webpackJsonp([1],{

/***/ "+AI7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+R1k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+jit":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Zto":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide($event)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0340":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Sfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1IHr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1L7y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1gH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1j/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2MTM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SEM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2YYa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2f7T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2yWH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3KoO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3i45":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6d97f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("6f65")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6f65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6qHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Gwn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ozb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7s0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "833x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8GKz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8h2B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "94ae":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Lkk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9S5I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9YqQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A9r3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ABtU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZK4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ayo6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B6gb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEdh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ban+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CubJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ddy5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E39w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E9z0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EHUm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPIE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ereq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fhl0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G9bI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HH82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HNfe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HjRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hr37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HybY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Im9W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JEav":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JiOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K2Sp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ko1+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LVM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LgKc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mckz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mxix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NDQp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("SldL");
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmHeader.vue
//
//
//
//

/* harmony default export */ var cmHeader = ({
  name: 'cmHeader',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmHeader.vue
//
//
//
//

/* harmony default export */ var components_cmHeader = ({
  name: 'cmHeader',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77977846","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmHeader.vue
var cmHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: cmHeader_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cmHeader = (esExports);
// CONCATENATED MODULE: ./src/components/cmHeader.vue
function injectStyle (ssrContext) {
  __webpack_require__("emCF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77977846"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cmHeader,
  selectortype_template_index_0_src_components_cmHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_cmHeader = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    cmHeader: src_components_cmHeader
  },
  provide: function provide() {
    return {
      // reload: this.reload
    };
  },
  data: function data() {
    return {
      // isRouterAlive: true
    };
  },

  methods: {
    // reload () {
    //   this.isRouterAlive = false
    //   this.$nextTick(function () {
    //     this.isRouterAlive = true
    //   })
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: {
    cmHeader: src_components_cmHeader
  },
  provide: function provide() {
    return {
      // reload: this.reload
    };
  },
  data: function data() {
    return {
      // isRouterAlive: true
    };
  },

  methods: {
    // reload () {
    //   this.isRouterAlive = false
    //   this.$nextTick(function () {
    //     this.isRouterAlive = true
    //   })
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7135c800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('cmHeader'),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("1L7y")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/customer/configs.js

var commonAssets = {
  homeBg: '/static/images/TOP_background@2x.png',
  blankImage: '/static/images/noData.png',
  scanIcon: '/static/images/scanCode.png'
};

var configs = {
  yizhuanjia: {
    key: 'yizhuanjia',
    brandId: 1,
    appId: 'wx1b71958fecb624cb',
    name: '衣专佳',
    loginTitle: '衣专佳',
    theme: 'yizhuanjia',
    home: 'yizhuanjia',
    enableRegionManager: false,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/yizhuanjia/logo.png',
      homeBg: '/static/brand/yizhuanjia/TOP_background@2x.png',
      scanIcon: '/static/brand/yizhuanjia/scanCode.png',
      blankImage: '/static/images/wudingdan.png',
      blankImageStyle: {
        width: '180px',
        height: 'auto'
      },
      icons: {
        createWashOrder: '/static/brand/yizhuanjia/icons/record_order.png',
        waybillWashOrder: '/static/brand/yizhuanjia/icons/worked.png',
        expressOrder: '/static/brand/yizhuanjia/icons/express.png',
        pickupOrder: '/static/brand/yizhuanjia/icons/pickup.png',
        queryExpress: '/static/brand/yizhuanjia/icons/send_back.png',
        searchOrder: '/static/brand/yizhuanjia/icons/searchOrder.png',
        createCollectWashOrder: '/static/brand/yizhuanjia/icons/yiwuhexiao.png',
        waitCollect: '/static/brand/yizhuanjia/icons/cikadaishou.png',
        douYinVerify: '/static/brand/yizhuanjia/icons/douyin.png',
        upClothe: '/static/brand/yizhuanjia/icons/yiwushangjia.png',
        pickClothe: '/static/brand/yizhuanjia/icons/gukeziqu.png'
      }
    })
  },
  yishe: {
    key: 'yishe',
    brandId: 1,
    appId: 'wx09b396844095c9af',
    name: '衣奢洗衣',
    loginTitle: '衣奢洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    apiBaseURL: 'https://yishe.uunbiot.com/',
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/yishe/logo.png'
    })
  },
  xiduoduo: {
    key: 'xiduoduo',
    brandId: 11,
    appId: 'wxaffe22a6adb7ffb0',
    name: '洗多多洗衣洗鞋',
    loginTitle: '洗多多洗衣洗鞋',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/xiduoduo/logo.png'
    })
  },
  yixiangzhixi: {
    key: 'yixiangzhixi',
    brandId: 4,
    appId: 'wx2dab0efdd64d3bfb',
    name: '易享智洗云值守',
    loginTitle: '易享智洗云值守',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/yixiangzhixi/logo.png'
    })
  },
  xingxi: {
    key: 'xingxi',
    brandId: 2,
    appId: 'wx109fd072a29dad94',
    name: '幸洗洗护',
    loginTitle: '幸洗洗护',
    loginButtonClass: 'cm-bg-yellow1',
    theme: 'xingxi',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/xingxi/logo.png',
      homeBg: '/static/brand/xingxi/TOP_background@2x.png'
    })
  },
  youjing: {
    key: 'youjing',
    brandId: 3,
    appId: 'wx46e375a0ea481002',
    name: '优净家清',
    loginTitle: '优净家清',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/youjing/logo.png'
    })
  },
  jiedixing: {
    key: 'jiedixing',
    brandId: 5,
    appId: 'wxeb21af47e2076eea',
    name: '洁涤星',
    loginTitle: '洁涤星',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/jiedixing/logo.png'
    })
  },
  uccxihu: {
    key: 'uccxihu',
    brandId: 6,
    appId: 'wx0587fdaedfc916db',
    name: '优CC洗护',
    loginTitle: '优CC洗护',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/uccxihu/logo.png'
    })
  },
  xiyuebiaoju: {
    key: 'xiyuebiaoju',
    brandId: 7,
    appId: 'wxd77baed2f979105d',
    name: '洗悦镖局',
    loginTitle: '洗悦镖局',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/xiyuebiaoju/logo.png'
    })
  },
  laijinao: {
    key: 'laijinao',
    brandId: 8,
    appId: 'wx2f41ce560693cda8',
    name: '莱金澳洗衣',
    loginTitle: '莱金澳洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/laijinao/logo.png'
    })
  },
  laixiguanjia: {
    key: 'laixiguanjia',
    brandId: 9,
    appId: 'wx67e0c4d5ce9f4a41',
    name: '来喜管家',
    loginTitle: '来喜管家',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/laixiguanjia/logo.png'
    })
  },
  yisiman: {
    key: 'yisiman',
    brandId: 10,
    appId: 'wx69580b25bf5b9b09',
    name: '伊斯曼洗衣',
    loginTitle: '伊斯曼洗衣',
    theme: 'default',
    home: 'default',
    enableRegionManager: true,
    assets: extends_default()({}, commonAssets, {
      logo: '/static/brand/yisiman/logo.png'
    })
  }
};

/* harmony default export */ var customer_configs = (configs);
// CONCATENATED MODULE: ./src/customer/index.js


var customerKey = "laixiguanjia";

if (!customerKey) {
  throw new Error('Missing CUSTOMER. Please run a customer build script, such as npm run build:xiyuebiaoju.');
}

if (!customer_configs[customerKey]) {
  throw new Error('Unknown CUSTOMER "' + customerKey + '". Please add it to src/customer/configs.js first.');
}

var customer_customer = customer_configs[customerKey];

/* harmony default export */ var src_customer = (customer_customer);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var json_stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(json_stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cmFooter = ({
  name: 'cmFooter',
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      nav: [{
        key: 0,
        title: '首页',
        path: '/',
        auth: 'home',
        img: '/static/images/home.png',
        imged: '/static/images/homeed.png'
      }, {
        key: 3,
        title: '物流',
        path: '/driver',
        auth: 'driver',
        img: '/static/images/driver.png',
        imged: '/static/images/drivered.png'
      }, {
        key: 4,
        title: '加工厂',
        path: '/factory',
        auth: 'factory',
        img: '/static/images/factory.png',
        imged: '/static/images/factoryed.png'
      },
      //   {
      //   key:6,
      //   title:'窗帘调度',
      //   path:'/curtain',
      //   auth:'curtain',
      //   img:'/static/images/curtain.png',
      //   imged:'/static/images/curtained.png',
      // },
      // {
      //   key:1,
      //   title:'工单',
      //   path:'/work',
      //   auth:'work',
      //   img:'/static/images/work.png',
      //   imged:'/static/images/worked.png',
      // },
      {
        key: 2,
        title: '我的',
        path: '/user',
        auth: 'user',
        img: '/static/images/me.png',
        imged: '/static/images/meed.png'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cmFooter = ({
  name: 'cmFooter',
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      nav: [{
        key: 0,
        title: '首页',
        path: '/',
        auth: 'home',
        img: '/static/images/home.png',
        imged: '/static/images/homeed.png'
      }, {
        key: 3,
        title: '物流',
        path: '/driver',
        auth: 'driver',
        img: '/static/images/driver.png',
        imged: '/static/images/drivered.png'
      }, {
        key: 4,
        title: '加工厂',
        path: '/factory',
        auth: 'factory',
        img: '/static/images/factory.png',
        imged: '/static/images/factoryed.png'
      },
      //   {
      //   key:6,
      //   title:'窗帘调度',
      //   path:'/curtain',
      //   auth:'curtain',
      //   img:'/static/images/curtain.png',
      //   imged:'/static/images/curtained.png',
      // },
      // {
      //   key:1,
      //   title:'工单',
      //   path:'/work',
      //   auth:'work',
      //   img:'/static/images/work.png',
      //   imged:'/static/images/worked.png',
      // },
      {
        key: 2,
        title: '我的',
        path: '/user',
        auth: 'user',
        img: '/static/images/me.png',
        imged: '/static/images/meed.png'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31eee5b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmFooter.vue
var cmFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-pf cm-w-100 cm-bg-white",staticStyle:{"bottom":"0","left":"0","height":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-h-100 cm-flex-around cm-flex-middle"},_vm._l((_vm.nav),function(item,key){return (_vm.$func.checkAuth(item.auth))?_c('div',{key:key,staticClass:"footer_ul"},[_c('router-link',{staticClass:"cm-text-center",staticStyle:{"line-height":"0"},attrs:{"to":item.path}},[_c('div',{staticClass:"cm-center"},[_c('img',{staticClass:"cm-margin cm-icon-22",attrs:{"src":_vm.active == item.key ? item.imged : item.img}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12"},[_vm._v(_vm._s(item.title))])])],1):_vm._e()}),0)])}
var cmFooter_staticRenderFns = []
var cmFooter_esExports = { render: cmFooter_render, staticRenderFns: cmFooter_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cmFooter = (cmFooter_esExports);
// CONCATENATED MODULE: ./src/components/cmFooter.vue
function cmFooter_injectStyle (ssrContext) {
  __webpack_require__("eZrW")
}
var cmFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cmFooter___vue_template_functional__ = false
/* styles */
var cmFooter___vue_styles__ = cmFooter_injectStyle
/* scopeId */
var cmFooter___vue_scopeId__ = "data-v-31eee5b9"
/* moduleIdentifier (server only) */
var cmFooter___vue_module_identifier__ = null
var cmFooter_Component = cmFooter_normalizeComponent(
  components_cmFooter,
  selectortype_template_index_0_src_components_cmFooter,
  cmFooter___vue_template_functional__,
  cmFooter___vue_styles__,
  cmFooter___vue_scopeId__,
  cmFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_cmFooter = (cmFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/homeDefault.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var homeDefault = ({
  name: 'home',
  components: {
    cmFooter: src_components_cmFooter
  },
  computed: {
    isYoujing: function isYoujing() {
      return this.$customer && this.$customer.key === 'youjing';
    }
  },
  data: function data() {
    return {
      type: 1,
      count: [],
      info: {},
      accessReady: false,
      nav: [{
        title: '洗衣',
        path: '/wash',
        auth: 'wash',
        img: '/static/images/washed.png'
      }, {
        title: '家政',
        path: '/clean',
        auth: 'clean',
        img: '/static/images/cleaned.png'
      }, {
        title: '商品',
        path: '/product',
        auth: 'product',
        img: '/static/images/producted.png'
      }, {
        title: '会员卡',
        path: '/card',
        auth: 'card',
        img: '/static/images/card.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.ensureAccess();
      this.getOrderCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    ensureAccess: function ensureAccess() {
      var _this = this;

      this.$api.getAccess({}).then(function (res) {
        if (res && res.data) {
          _this.$func.setLocal('node_v1', stringify_default()(res.data));
        }
        _this.accessReady = true;
      }).catch(function () {
        _this.accessReady = true;
      });
    },
    getOrderCount: function getOrderCount() {
      var _this2 = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this2.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this3.$router.push({ path: '/login' });
            return false;
          }
          _this3.info = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/homeDefault.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_homeDefault = ({
  name: 'home',
  components: {
    cmFooter: src_components_cmFooter
  },
  computed: {
    isYoujing: function isYoujing() {
      return this.$customer && this.$customer.key === 'youjing';
    }
  },
  data: function data() {
    return {
      type: 1,
      count: [],
      info: {},
      accessReady: false,
      nav: [{
        title: '洗衣',
        path: '/wash',
        auth: 'wash',
        img: '/static/images/washed.png'
      }, {
        title: '家政',
        path: '/clean',
        auth: 'clean',
        img: '/static/images/cleaned.png'
      }, {
        title: '商品',
        path: '/product',
        auth: 'product',
        img: '/static/images/producted.png'
      }, {
        title: '会员卡',
        path: '/card',
        auth: 'card',
        img: '/static/images/card.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.ensureAccess();
      this.getOrderCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    ensureAccess: function ensureAccess() {
      var _this = this;

      this.$api.getAccess({}).then(function (res) {
        if (res && res.data) {
          _this.$func.setLocal('node_v1', stringify_default()(res.data));
        }
        _this.accessReady = true;
      }).catch(function () {
        _this.accessReady = true;
      });
    },
    getOrderCount: function getOrderCount() {
      var _this2 = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this2.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this3.$router.push({ path: '/login' });
            return false;
          }
          _this3.info = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d0eaf9f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/homeDefault.vue
var homeDefault_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("门店端")])])]),_vm._v(" "),(_vm.accessReady)?_c('ul',{staticClass:"ul cm-m-lr-8 cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle  cm-flex-wrap"},[_vm._l((_vm.nav),function(item,index){return (_vm.$func.checkAuth(item.auth))?_c('router-link',{key:index,staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":item.path}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":item.img}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v(_vm._s(item.title))])])]):_vm._e()}),_vm._v(" "),(_vm.$func.checkAuth('recordOrder') && !_vm.isYoujing)?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":'/recordOrder'}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/record_order.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣录单")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('recordPhoneList') && !_vm.isYoujing)?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/recordPhoneList"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/pickuped.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("手机号查询")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('washHome'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/washHome"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/washHome.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("上门收衣")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('douYinVerify'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/douYinVerify"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/douyin.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("抖音核销")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('douYinVerify'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/douyinOrder"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/douyinOrder.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("抖音团购订单")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('device'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/device"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/device.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("门店设备")])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('userManage'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/miniUserManage"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/userManage.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("用户管理")])])]):_vm._e(),_vm._v(" "),(_vm.isYoujing && _vm.$func.checkAuth('upClothe'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/upClothe"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/store-visit-lined.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("本店衣物上挂")])])]):_vm._e(),_vm._v(" "),(_vm.isYoujing && _vm.$func.checkAuth('upClothe'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/upCustomClothe"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/upCustomClothe.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("其他衣物上挂")])])]):_vm._e(),_vm._v(" "),(_vm.isYoujing && _vm.$func.checkAuth('upClothe'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/upList"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/upList.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("上挂列表")])])]):_vm._e(),_vm._v(" "),(_vm.isYoujing && _vm.$func.checkAuth('pickClothe'))?_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/pickList"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":"/static/images/pickup.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("取衣记录")])])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('cmFooter')],1)}
var homeDefault_staticRenderFns = []
var homeDefault_esExports = { render: homeDefault_render, staticRenderFns: homeDefault_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_homeDefault = (homeDefault_esExports);
// CONCATENATED MODULE: ./src/pages/homeDefault.vue
function homeDefault_injectStyle (ssrContext) {
  __webpack_require__("tjPP")
}
var homeDefault_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homeDefault___vue_template_functional__ = false
/* styles */
var homeDefault___vue_styles__ = homeDefault_injectStyle
/* scopeId */
var homeDefault___vue_scopeId__ = "data-v-2d0eaf9f"
/* moduleIdentifier (server only) */
var homeDefault___vue_module_identifier__ = null
var homeDefault_Component = homeDefault_normalizeComponent(
  pages_homeDefault,
  selectortype_template_index_0_src_pages_homeDefault,
  homeDefault___vue_template_functional__,
  homeDefault___vue_styles__,
  homeDefault___vue_scopeId__,
  homeDefault___vue_module_identifier__
)

/* harmony default export */ var src_pages_homeDefault = (homeDefault_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/homeYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var homeYizhuanjia = ({
  name: 'home',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 1,
      count: [],
      info: {},
      nav: [{
        title: '小程序洗衣',
        path: '/wash',
        auth: 'wash',
        img: '/static/images/washed.png'
      },
      // {
      //   title:'家政',
      //   path:'/clean',
      //   auth:'clean',
      //   img:'/static/images/cleaned.png',
      // },
      // {
      //   title:'商品',
      //   path:'/product',
      //   auth:'product',
      //   img:'/static/images/producted.png',
      // },
      {
        title: '会员卡',
        path: '/card',
        auth: 'card',
        img: '/static/images/card.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getOrderCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    icon: function icon(name) {
      return this.$customer.assets.icons && this.$customer.assets.icons[name] || '/static/images/' + name + '.png';
    },
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this2.$router.push({ path: '/login' });
            return false;
          }
          _this2.info = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/homeYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_homeYizhuanjia = ({
  name: 'home',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 1,
      count: [],
      info: {},
      nav: [{
        title: '小程序洗衣',
        path: '/wash',
        auth: 'wash',
        img: '/static/images/washed.png'
      },
      // {
      //   title:'家政',
      //   path:'/clean',
      //   auth:'clean',
      //   img:'/static/images/cleaned.png',
      // },
      // {
      //   title:'商品',
      //   path:'/product',
      //   auth:'product',
      //   img:'/static/images/producted.png',
      // },
      {
        title: '会员卡',
        path: '/card',
        auth: 'card',
        img: '/static/images/card.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getOrderCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    icon: function icon(name) {
      return this.$customer.assets.icons && this.$customer.assets.icons[name] || '/static/images/' + name + '.png';
    },
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this2.$router.push({ path: '/login' });
            return false;
          }
          _this2.info = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056941d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/homeYizhuanjia.vue
var homeYizhuanjia_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"}),_vm._v(" "),_c('div',{staticClass:"ul2 cm-m-lr-8 cm-bg-white cm-border-radius-20 "},[_c('p',{staticClass:"cm-fn-16  cm-color-333 cm-p-tb-12 cm-p-lr-6 cm-m-l-12 cm-fn-500"},[_vm._v("衣物操作")]),_vm._v(" "),_c('ul',{staticClass:" cm-flex-start cm-flex-middle  cm-flex-wrap"},[_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":'/createWashOrder'}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('createWashOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物下单")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/waybillWashOrder"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('waybillWashOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("物流订单")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/expressOrder"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('expressOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("送洗订单")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/pickupOrder"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('pickupOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("送回订单")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/queryExpress"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('queryExpress')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("物流轨迹查询")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/searchOrder"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('searchOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("送洗订单查询")])])])],1)]),_vm._v(" "),(_vm.info.verify_status > 0)?_c('div',{staticClass:"cm-pr cm-m-t-16 cm-m-lr-8 cm-bg-white cm-border-radius-20 "},[_c('p',{staticClass:"cm-fn-16  cm-color-333 cm-p-tb-12 cm-p-lr-6 cm-m-l-12 cm-fn-500"},[_vm._v("核销工作台")]),_vm._v(" "),_c('ul',{staticClass:" cm-flex-start cm-flex-middle  cm-flex-wrap"},[_c('router-link',{staticClass:"cm-text-center cm-p-tb-16  cm-pr li",attrs:{"to":"/createCollectWashOrder"}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('createCollectWashOrder')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物核销")])]),_vm._v(" "),_c('router-link',{staticClass:"cm-text-center cm-p-tb-16  cm-pr li",attrs:{"to":"/yizhuanjia/waitCollect"}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('waitCollect')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物待核销")])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/douYinVerify"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('douYinVerify')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("抖音验券")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/yizhuanjia/upClothe"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('upClothe')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物上架")])])]),_vm._v(" "),_c('router-link',{staticClass:"cm-center cm-p-tb-24 li",attrs:{"to":"/yizhuanjia/pickClothe"}},[_c('div',{staticClass:"cm-text-center"},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":_vm.icon('pickClothe')}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("顾客取衣")])])])],1)]):_vm._e(),_vm._v(" "),_c('cmFooter')],1)}
var homeYizhuanjia_staticRenderFns = []
var homeYizhuanjia_esExports = { render: homeYizhuanjia_render, staticRenderFns: homeYizhuanjia_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_homeYizhuanjia = (homeYizhuanjia_esExports);
// CONCATENATED MODULE: ./src/pages/homeYizhuanjia.vue
function homeYizhuanjia_injectStyle (ssrContext) {
  __webpack_require__("ijf8")
}
var homeYizhuanjia_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var homeYizhuanjia___vue_template_functional__ = false
/* styles */
var homeYizhuanjia___vue_styles__ = homeYizhuanjia_injectStyle
/* scopeId */
var homeYizhuanjia___vue_scopeId__ = "data-v-056941d8"
/* moduleIdentifier (server only) */
var homeYizhuanjia___vue_module_identifier__ = null
var homeYizhuanjia_Component = homeYizhuanjia_normalizeComponent(
  pages_homeYizhuanjia,
  selectortype_template_index_0_src_pages_homeYizhuanjia,
  homeYizhuanjia___vue_template_functional__,
  homeYizhuanjia___vue_styles__,
  homeYizhuanjia___vue_scopeId__,
  homeYizhuanjia___vue_module_identifier__
)

/* harmony default export */ var src_pages_homeYizhuanjia = (homeYizhuanjia_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home.vue
//
//
//
//





/* harmony default export */ var home = ({
  name: 'home',
  components: {
    HomeDefault: src_pages_homeDefault,
    HomeYizhuanjia: src_pages_homeYizhuanjia
  },
  computed: {
    homeComponent: function homeComponent() {
      return src_customer.home === 'yizhuanjia' ? 'HomeYizhuanjia' : 'HomeDefault';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home.vue
//
//
//
//





/* harmony default export */ var pages_home = ({
  name: 'home',
  components: {
    HomeDefault: src_pages_homeDefault,
    HomeYizhuanjia: src_pages_homeYizhuanjia
  },
  computed: {
    homeComponent: function homeComponent() {
      return src_customer.home === 'yizhuanjia' ? 'HomeYizhuanjia' : 'HomeDefault';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d27fca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.homeComponent,{tag:"component"})}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_home = (home_esExports);
// CONCATENATED MODULE: ./src/pages/home.vue
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = null
/* scopeId */
var home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  pages_home,
  selectortype_template_index_0_src_pages_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var src_pages_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clean.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var clean = ({
  name: 'clean',
  components: {},
  data: function data() {
    return {
      type: 2,
      count: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getOrderCount();
  },

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clean.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_clean = ({
  name: 'clean',
  components: {},
  data: function data() {
    return {
      type: 2,
      count: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getOrderCount();
  },

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146ea77f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clean.vue
var clean_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("家政服务")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-around cm-flex-middle"},[(_vm.$func.checkAuth('order/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":'/order/'+_vm.type+'/2'}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待接单")]),_vm._v(" "),(_vm.count[2] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":'/order/'+_vm.type+'/'+3}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status5.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待分配")]),_vm._v(" "),(_vm.count[3] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-36 cm-p-lr-16 cm-bg-white cm-p-b-40"},[(_vm.$func.checkAuth('order/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[0] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[0]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待上门")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/5'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+5}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待服务")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[5] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[5]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+6}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[6] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[6]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/7'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+7}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待评价")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[7] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[7]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+9}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+10}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var clean_staticRenderFns = []
var clean_esExports = { render: clean_render, staticRenderFns: clean_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clean = (clean_esExports);
// CONCATENATED MODULE: ./src/pages/clean.vue
function clean_injectStyle (ssrContext) {
  __webpack_require__("LVM0")
}
var clean_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clean___vue_template_functional__ = false
/* styles */
var clean___vue_styles__ = clean_injectStyle
/* scopeId */
var clean___vue_scopeId__ = "data-v-146ea77f"
/* moduleIdentifier (server only) */
var clean___vue_module_identifier__ = null
var clean_Component = clean_normalizeComponent(
  pages_clean,
  selectortype_template_index_0_src_pages_clean,
  clean___vue_template_functional__,
  clean___vue_styles__,
  clean___vue_scopeId__,
  clean___vue_module_identifier__
)

/* harmony default export */ var src_pages_clean = (clean_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_login = ({
  name: 'login',
  data: function data() {
    return {
      account: '',
      password: '',
      checkLogin: false
    };
  },
  created: function created() {
    // this.$func.setLocal('token','');
    // this.$func.setLocal('node_v1','');
    // this.$func.setLocal('grade','');
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      // this.checkCid();
      this.checkCid();
    }
  },

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = src_customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.$func.setLocal('grade', res.data.grade);
            _this.$func.setLocal('node_v1', '');
            if (res.data.cid) {
              _this.$func.setLocal('cid', res.data.cid);
            }
            if (parseInt(res.data.cid) > 0) {
              _this.getAccess();
            } else {
              _this.checkLogin = true;
            }
          }
        }
      });
    },
    checkCid: function checkCid() {
      var _this2 = this;

      this.$api.checkCid({}).then(function (res) {
        if (res.code == 2) {
          if (src_customer.enableRegionManager && parseInt(_this2.$func.getLocal('grade')) === 2 && _this2.$func.getLocal('store_list')) {
            _this2.$router.replace({ path: '/selectStore' });
            return false;
          }
          _this2.checkLogin = true;
          // this.$func.showToast(res.msg);
          return false;
        } else {
          _this2.syncUserInfo(function () {
            _this2.getAccess();
          });
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!that.account) {
        that.$func.showToast('请输入账号');
        return false;
      }
      if (!that.password) {
        that.$func.showToast('请输入密码');
        return false;
      }
      that.$api.loginCommunity({
        account: that.account,
        password: that.password
      }).then(function (res) {
        if (res) {
          that.$func.setLocal('grade', res.data.grade);
          that.$func.setLocal('node_v1', '');
          if (src_customer.enableRegionManager && parseInt(res.data.need_store_select) === 1 && Array.isArray(res.data.store_list) && res.data.store_list.length) {
            that.$func.setLocal('store_list', stringify_default()(res.data.store_list));
            that.$func.setLocal('cid', '');
            that.$router.replace({ path: '/selectStore' });
            return;
          }
          if (res.data.cid) {
            that.$func.setLocal('cid', res.data.cid);
          }
          if (res.data.store_list) {
            that.$func.setLocal('store_list', stringify_default()(res.data.store_list));
          }
          that.getAccess();
        }
      });
    },
    syncUserInfo: function syncUserInfo(callback) {
      var _this3 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res && res.data) {
          if (res.data.token) {
            _this3.$func.setLocal('token', res.data.token);
          }
          if (res.data.grade) {
            _this3.$func.setLocal('grade', res.data.grade);
          }
          if (res.data.cid) {
            _this3.$func.setLocal('cid', res.data.cid);
          }
          if (res.data.store_list) {
            _this3.$func.setLocal('store_list', stringify_default()(res.data.store_list));
          }
        }
        callback ? callback() : '';
      }).catch(function () {
        callback ? callback() : '';
      });
    },
    getAccess: function getAccess() {
      var _this4 = this;

      // if(!this.$func.getLocal('node_v1')){
      this.$api.getAccess({}).then(function (res) {
        if (res.data) {
          _this4.$func.setLocal('node_v1', stringify_default()(res.data));
          var grade = parseInt(_this4.$func.getLocal('grade'));
          if ([3, 4, 5, 8, 13].includes(grade)) {
            window.location.href = "/#/home";
          } else if ([10, 11].includes(grade)) {
            window.location.href = "/#/factory";
          } else if (grade === 7) {
            window.location.href = "/#/driver";
          } else {
            window.location.href = "/#/user";
          }
        }
      });
      // }
    },
    out: function out() {
      var _this5 = this;

      // this.$func.confirm('确认退出账号？','温馨提示',()=>{
      this.$api.out({}).then(function (res) {
        _this5.$func.setLocal('node_v1', '');
        _this5.$func.setLocal('grade', '');
        _this5.$func.setLocal('cid', '');
        _this5.$router.push({ path: '/login' });
      });
      // })
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_login = ({
  name: 'login',
  data: function data() {
    return {
      account: '',
      password: '',
      checkLogin: false
    };
  },
  created: function created() {
    // this.$func.setLocal('token','');
    // this.$func.setLocal('node_v1','');
    // this.$func.setLocal('grade','');
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      // this.checkCid();
      this.checkCid();
    }
  },

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = src_customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.$func.setLocal('grade', res.data.grade);
            _this.$func.setLocal('node_v1', '');
            if (res.data.cid) {
              _this.$func.setLocal('cid', res.data.cid);
            }
            if (parseInt(res.data.cid) > 0) {
              _this.getAccess();
            } else {
              _this.checkLogin = true;
            }
          }
        }
      });
    },
    checkCid: function checkCid() {
      var _this2 = this;

      this.$api.checkCid({}).then(function (res) {
        if (res.code == 2) {
          if (src_customer.enableRegionManager && parseInt(_this2.$func.getLocal('grade')) === 2 && _this2.$func.getLocal('store_list')) {
            _this2.$router.replace({ path: '/selectStore' });
            return false;
          }
          _this2.checkLogin = true;
          // this.$func.showToast(res.msg);
          return false;
        } else {
          _this2.syncUserInfo(function () {
            _this2.getAccess();
          });
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!that.account) {
        that.$func.showToast('请输入账号');
        return false;
      }
      if (!that.password) {
        that.$func.showToast('请输入密码');
        return false;
      }
      that.$api.loginCommunity({
        account: that.account,
        password: that.password
      }).then(function (res) {
        if (res) {
          that.$func.setLocal('grade', res.data.grade);
          that.$func.setLocal('node_v1', '');
          if (src_customer.enableRegionManager && parseInt(res.data.need_store_select) === 1 && Array.isArray(res.data.store_list) && res.data.store_list.length) {
            that.$func.setLocal('store_list', stringify_default()(res.data.store_list));
            that.$func.setLocal('cid', '');
            that.$router.replace({ path: '/selectStore' });
            return;
          }
          if (res.data.cid) {
            that.$func.setLocal('cid', res.data.cid);
          }
          if (res.data.store_list) {
            that.$func.setLocal('store_list', stringify_default()(res.data.store_list));
          }
          that.getAccess();
        }
      });
    },
    syncUserInfo: function syncUserInfo(callback) {
      var _this3 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res && res.data) {
          if (res.data.token) {
            _this3.$func.setLocal('token', res.data.token);
          }
          if (res.data.grade) {
            _this3.$func.setLocal('grade', res.data.grade);
          }
          if (res.data.cid) {
            _this3.$func.setLocal('cid', res.data.cid);
          }
          if (res.data.store_list) {
            _this3.$func.setLocal('store_list', stringify_default()(res.data.store_list));
          }
        }
        callback ? callback() : '';
      }).catch(function () {
        callback ? callback() : '';
      });
    },
    getAccess: function getAccess() {
      var _this4 = this;

      // if(!this.$func.getLocal('node_v1')){
      this.$api.getAccess({}).then(function (res) {
        if (res.data) {
          _this4.$func.setLocal('node_v1', stringify_default()(res.data));
          var grade = parseInt(_this4.$func.getLocal('grade'));
          if ([3, 4, 5, 8, 13].includes(grade)) {
            window.location.href = "/#/home";
          } else if ([10, 11].includes(grade)) {
            window.location.href = "/#/factory";
          } else if (grade === 7) {
            window.location.href = "/#/driver";
          } else {
            window.location.href = "/#/user";
          }
        }
      });
      // }
    },
    out: function out() {
      var _this5 = this;

      // this.$func.confirm('确认退出账号？','温馨提示',()=>{
      this.$api.out({}).then(function (res) {
        _this5.$func.setLocal('node_v1', '');
        _this5.$func.setLocal('grade', '');
        _this5.$func.setLocal('cid', '');
        _this5.$router.push({ path: '/login' });
      });
      // })
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e841448a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[(_vm.checkLogin)?_c('div',{staticClass:"cm-pa cm-w-100",staticStyle:{"top":"10%","left":"0"}},[_c('div',{staticClass:"cm-p-tb-28 cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-main cm-m-l-8 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.loginTitle))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("服务平台")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-12"},[_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8  cm-m-t-8"},[_c('p',{staticClass:" cm-fn-16"},[_vm._v("账号：")]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account),expression:"account"}],staticClass:"cm-m-l-12 cm-fn-18 cm-w-100 cm-p-l-12 cm-border-radius-5",attrs:{"type":"text","placeholder":"请输入账号"},domProps:{"value":(_vm.account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.account=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8 cm-m-t-8"},[_c('p',{staticClass:" cm-fn-16"},[_vm._v("密码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"cm-m-l-12 cm-fn-18 cm-w-100 cm-border-radius-5 cm-p-l-12",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-m-t-40 cm-center"},[_c('button',{staticClass:"cm-p-tb-16 cm-p-lr-40 cm-border-radius-10 cm-color-white cm-fn-16 cm-w-100",class:_vm.$customer.loginButtonClass || 'cm-bg-blue',on:{"click":function($event){return _vm.submit()}}},[_vm._v("确定")])])])]):_vm._e()])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_login = (login_esExports);
// CONCATENATED MODULE: ./src/pages/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("ubv/")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-e841448a"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  selectortype_script_index_0_src_pages_login,
  selectortype_template_index_0_src_pages_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_pages_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/selectStore.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectStore = ({
  name: 'selectStore',
  data: function data() {
    return {
      storeList: [],
      currentStoreId: 0,
      selecting: false
    };
  },
  created: function created() {
    if (!src_customer.enableRegionManager) {
      this.$router.replace({ path: '/home' });
      return;
    }
    this.currentStoreId = Number(this.$func.getLocal('cid')) || 0;
    this.loadStoreList();
  },

  methods: {
    loadStoreList: function loadStoreList() {
      var _this = this;

      var cache = this.$func.getLocal('store_list');
      if (cache) {
        try {
          var list = JSON.parse(cache);
          this.storeList = Array.isArray(list) ? list : [];
        } catch (e) {
          this.storeList = [];
        }
      }
      if (!this.storeList.length && this.currentStoreId > 0) {
        this.$api.getInfo({}).then(function (res) {
          if (res && Array.isArray(res.data.store_list)) {
            _this.storeList = res.data.store_list;
            _this.$func.setLocal('store_list', stringify_default()(_this.storeList));
          }
        });
      }
    },
    formatAddress: function formatAddress(item) {
      return [item.province, item.city, item.district, item.address].filter(function (value) {
        return value;
      }).join('');
    },
    selectStore: function selectStore(item) {
      var _this2 = this;

      if (this.selecting) {
        return false;
      }
      var cid = Number(item.id);
      if (!cid) {
        this.$func.showToast('门店数据错误');
        return false;
      }
      this.selecting = true;
      this.$api.selectCommunityStore({ cid: cid }).then(function (res) {
        _this2.selecting = false;
        if (res) {
          _this2.currentStoreId = cid;
          _this2.$func.setLocal('cid', cid);
          _this2.$func.setLocal('current_store_name', item.name || '');
          _this2.$func.setLocal('node_v1', '');
          _this2.getAccess();
        }
      }).catch(function () {
        _this2.selecting = false;
      });
    },
    getAccess: function getAccess() {
      var _this3 = this;

      this.$api.getAccess({}).then(function (res) {
        if (res.data) {
          _this3.$func.setLocal('node_v1', stringify_default()(res.data));
          if (_this3.$route.query.from === 'user') {
            _this3.$router.replace({ path: '/user' });
            return;
          }
          var grade = parseInt(_this3.$func.getLocal('grade'));
          if ([3, 4, 5, 8, 13].includes(grade)) {
            _this3.$router.replace({ path: '/home' });
          } else if ([10, 11].includes(grade)) {
            _this3.$router.replace({ path: '/factory' });
          } else if (grade === 7) {
            _this3.$router.replace({ path: '/driver' });
          } else {
            _this3.$router.replace({ path: '/user' });
          }
        }
      });
    },
    backLogin: function backLogin() {
      this.$func.setLocal('cid', '');
      this.$func.setLocal('store_list', '');
      this.$router.replace({ path: '/login' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/selectStore.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_selectStore = ({
  name: 'selectStore',
  data: function data() {
    return {
      storeList: [],
      currentStoreId: 0,
      selecting: false
    };
  },
  created: function created() {
    if (!src_customer.enableRegionManager) {
      this.$router.replace({ path: '/home' });
      return;
    }
    this.currentStoreId = Number(this.$func.getLocal('cid')) || 0;
    this.loadStoreList();
  },

  methods: {
    loadStoreList: function loadStoreList() {
      var _this = this;

      var cache = this.$func.getLocal('store_list');
      if (cache) {
        try {
          var list = JSON.parse(cache);
          this.storeList = Array.isArray(list) ? list : [];
        } catch (e) {
          this.storeList = [];
        }
      }
      if (!this.storeList.length && this.currentStoreId > 0) {
        this.$api.getInfo({}).then(function (res) {
          if (res && Array.isArray(res.data.store_list)) {
            _this.storeList = res.data.store_list;
            _this.$func.setLocal('store_list', stringify_default()(_this.storeList));
          }
        });
      }
    },
    formatAddress: function formatAddress(item) {
      return [item.province, item.city, item.district, item.address].filter(function (value) {
        return value;
      }).join('');
    },
    selectStore: function selectStore(item) {
      var _this2 = this;

      if (this.selecting) {
        return false;
      }
      var cid = Number(item.id);
      if (!cid) {
        this.$func.showToast('门店数据错误');
        return false;
      }
      this.selecting = true;
      this.$api.selectCommunityStore({ cid: cid }).then(function (res) {
        _this2.selecting = false;
        if (res) {
          _this2.currentStoreId = cid;
          _this2.$func.setLocal('cid', cid);
          _this2.$func.setLocal('current_store_name', item.name || '');
          _this2.$func.setLocal('node_v1', '');
          _this2.getAccess();
        }
      }).catch(function () {
        _this2.selecting = false;
      });
    },
    getAccess: function getAccess() {
      var _this3 = this;

      this.$api.getAccess({}).then(function (res) {
        if (res.data) {
          _this3.$func.setLocal('node_v1', stringify_default()(res.data));
          if (_this3.$route.query.from === 'user') {
            _this3.$router.replace({ path: '/user' });
            return;
          }
          var grade = parseInt(_this3.$func.getLocal('grade'));
          if ([3, 4, 5, 8, 13].includes(grade)) {
            _this3.$router.replace({ path: '/home' });
          } else if ([10, 11].includes(grade)) {
            _this3.$router.replace({ path: '/factory' });
          } else if (grade === 7) {
            _this3.$router.replace({ path: '/driver' });
          } else {
            _this3.$router.replace({ path: '/user' });
          }
        }
      });
    },
    backLogin: function backLogin() {
      this.$func.setLocal('cid', '');
      this.$func.setLocal('store_list', '');
      this.$router.replace({ path: '/login' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffc06540","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/selectStore.vue
var selectStore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main select-store-page"},[_vm._m(0),_vm._v(" "),(_vm.storeList.length)?_c('div',{staticClass:"select-store-list"},_vm._l((_vm.storeList),function(item){return _c('div',{key:item.id,staticClass:"select-store-card",class:{active: Number(item.id) === _vm.currentStoreId},on:{"click":function($event){return _vm.selectStore(item)}}},[_c('div',{staticClass:"store-card-main"},[_c('p',{staticClass:"store-card-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"store-card-contact"},[_vm._v("联系人："+_vm._s(item.head_name || '-'))]),_vm._v(" "),_c('p',{staticClass:"store-card-contact"},[_vm._v("电话："+_vm._s(item.head_phone || '-'))]),_vm._v(" "),(_vm.formatAddress(item))?_c('p',{staticClass:"store-card-address"},[_vm._v(_vm._s(_vm.formatAddress(item)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"store-card-action"},[(Number(item.id) === _vm.currentStoreId)?_c('span',[_vm._v("当前")]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- iconfont"})])])}),0):_c('div',{staticClass:"select-store-empty"},[_c('p',[_vm._v("暂无可选择门店")]),_vm._v(" "),_c('button',{on:{"click":_vm.backLogin}},[_vm._v("重新登录")])])])}
var selectStore_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-store-header"},[_c('p',{staticClass:"select-store-title"},[_vm._v("选择登录门店")]),_vm._v(" "),_c('p',{staticClass:"select-store-subtitle"},[_vm._v("请选择本次要查看和操作的门店数据")])])}]
var selectStore_esExports = { render: selectStore_render, staticRenderFns: selectStore_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_selectStore = (selectStore_esExports);
// CONCATENATED MODULE: ./src/pages/selectStore.vue
function selectStore_injectStyle (ssrContext) {
  __webpack_require__("vXwO")
}
var selectStore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selectStore___vue_template_functional__ = false
/* styles */
var selectStore___vue_styles__ = selectStore_injectStyle
/* scopeId */
var selectStore___vue_scopeId__ = "data-v-ffc06540"
/* moduleIdentifier (server only) */
var selectStore___vue_module_identifier__ = null
var selectStore_Component = selectStore_normalizeComponent(
  pages_selectStore,
  selectortype_template_index_0_src_pages_selectStore,
  selectStore___vue_template_functional__,
  selectStore___vue_styles__,
  selectStore___vue_scopeId__,
  selectStore___vue_module_identifier__
)

/* harmony default export */ var src_pages_selectStore = (selectStore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmBlank.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cmBlank = ({
  props: {
    blankStyle: {
      type: String,
      default: '100vh'
    },
    text: {
      type: String,
      default: '什么都没有~'
    },
    text2: {
      type: String,
      default: ''
    },
    btn: {
      type: String,
      default: ''
    },
    btnShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    blankImage: function blankImage() {
      return src_customer.assets.blankImage || '/static/images/noData.png';
    },
    blankImageStyle: function blankImageStyle() {
      return src_customer.assets.blankImageStyle || {
        width: '110px',
        height: '110px'
      };
    }
  },
  components: {},
  created: function created() {},

  methods: {
    btnClick: function btnClick() {
      this.$emit('btnClick');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmBlank.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cmBlank = ({
  props: {
    blankStyle: {
      type: String,
      default: '100vh'
    },
    text: {
      type: String,
      default: '什么都没有~'
    },
    text2: {
      type: String,
      default: ''
    },
    btn: {
      type: String,
      default: ''
    },
    btnShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    blankImage: function blankImage() {
      return src_customer.assets.blankImage || '/static/images/noData.png';
    },
    blankImageStyle: function blankImageStyle() {
      return src_customer.assets.blankImageStyle || {
        width: '110px',
        height: '110px'
      };
    }
  },
  components: {},
  created: function created() {},

  methods: {
    btnClick: function btnClick() {
      this.$emit('btnClick');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7e2b6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmBlank.vue
var cmBlank_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-flex cm-center",style:({height:_vm.blankStyle})},[_c('div',{staticClass:"cm-flex-column cm-flex-middle"},[_c('img',{style:(_vm.blankImageStyle),attrs:{"src":_vm.blankImage,"mode":"aspectFit"}}),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-text-center"},[_c('div',{staticClass:"cm-p-tb-4 cm-color-999"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4"},[_vm._v(_vm._s(_vm.text2))])]),_vm._v(" "),(_vm.btnShow)?_c('div',{staticClass:"cm-label-main cm-border-radius-20 cm-p-tb-12 cm-p-lr-40 cm-fn-14",staticStyle:{"margin-top":"40px"},on:{"click":_vm.btnClick}},[_vm._v(_vm._s(_vm.btn))]):_vm._e()])])}
var cmBlank_staticRenderFns = []
var cmBlank_esExports = { render: cmBlank_render, staticRenderFns: cmBlank_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cmBlank = (cmBlank_esExports);
// CONCATENATED MODULE: ./src/components/cmBlank.vue
function cmBlank_injectStyle (ssrContext) {
  __webpack_require__("9YqQ")
}
var cmBlank_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cmBlank___vue_template_functional__ = false
/* styles */
var cmBlank___vue_styles__ = cmBlank_injectStyle
/* scopeId */
var cmBlank___vue_scopeId__ = "data-v-7d7e2b6c"
/* moduleIdentifier (server only) */
var cmBlank___vue_module_identifier__ = null
var cmBlank_Component = cmBlank_normalizeComponent(
  components_cmBlank,
  selectortype_template_index_0_src_components_cmBlank,
  cmBlank___vue_template_functional__,
  cmBlank___vue_styles__,
  cmBlank___vue_scopeId__,
  cmBlank___vue_module_identifier__
)

/* harmony default export */ var src_components_cmBlank = (cmBlank_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmLoadmore.vue
//
//
//
//
//
//
//

/* harmony default export */ var cmLoadmore = ({
  props: {
    text: {
      type: String,
      default: '正在加载。。。'
    }
  },
  data: function data() {
    return {};
  },

  components: {},
  created: function created() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cmLoadmore.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_cmLoadmore = ({
  props: {
    text: {
      type: String,
      default: '正在加载。。。'
    }
  },
  data: function data() {
    return {};
  },

  components: {},
  created: function created() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b367fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmLoadmore.vue
var cmLoadmore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-center cm-p-tb-12"},[_c('div',{staticClass:"weui-loading",style:({display: _vm.text == '正在加载。。。' ? 'block' : 'none'})}),_vm._v(" "),_c('div',{staticClass:"weui-loadmore__tips cm-m-l-8"},[_vm._v(_vm._s(_vm.text))])])}
var cmLoadmore_staticRenderFns = []
var cmLoadmore_esExports = { render: cmLoadmore_render, staticRenderFns: cmLoadmore_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cmLoadmore = (cmLoadmore_esExports);
// CONCATENATED MODULE: ./src/components/cmLoadmore.vue
function cmLoadmore_injectStyle (ssrContext) {
  __webpack_require__("2f7T")
}
var cmLoadmore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cmLoadmore___vue_template_functional__ = false
/* styles */
var cmLoadmore___vue_styles__ = cmLoadmore_injectStyle
/* scopeId */
var cmLoadmore___vue_scopeId__ = "data-v-59b367fc"
/* moduleIdentifier (server only) */
var cmLoadmore___vue_module_identifier__ = null
var cmLoadmore_Component = cmLoadmore_normalizeComponent(
  components_cmLoadmore,
  selectortype_template_index_0_src_components_cmLoadmore,
  cmLoadmore___vue_template_functional__,
  cmLoadmore___vue_styles__,
  cmLoadmore___vue_scopeId__,
  cmLoadmore___vue_module_identifier__
)

/* harmony default export */ var src_components_cmLoadmore = (cmLoadmore_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3077eb4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("T5Vs")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitCollect.vue





/* harmony default export */ var waitCollect = ({
  name: 'order',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      list: [],
      phone: '',
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 18,
      days: 30,
      editTimeIndex: ''
    };
  },

  computed: {
    isYizhuanjia: function isYizhuanjia() {
      return this.$customer && this.$customer.key == 'yizhuanjia';
    }
  },
  mounted: function mounted() {
    if (!this.$func.getLocal('token')) {
      window.location.href = "/";
      return false;
    }
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this = this;

      this.list[this.editTimeIndex].home_time = val;
      this.$api.editHomeTime({ id: this.list[this.editTimeIndex].id, home_time: val }).then(function (res) {
        if (res) {
          _this.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    editHomeTime: function editHomeTime(index) {
      this.editTimeIndex = index;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: 2 }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this3 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this3.blankShow) {
          _this3.busy = true;
          _this3.loadStatus = false;
          _this3.loadmoreText = '没有更多了。。。';
        } else {
          if (_this3.hasNext > 0) {
            _this3.loadStatus = false;
            _this3.busy = false;
          } else {
            _this3.busy = true;
            _this3.loadStatus = true;
            _this3.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitCollect.vue





/* harmony default export */ var pages_waitCollect = ({
  name: 'order',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      list: [],
      phone: '',
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 18,
      days: 30,
      editTimeIndex: ''
    };
  },

  computed: {
    isYizhuanjia: function isYizhuanjia() {
      return this.$customer && this.$customer.key == 'yizhuanjia';
    }
  },
  mounted: function mounted() {
    if (!this.$func.getLocal('token')) {
      window.location.href = "/";
      return false;
    }
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this = this;

      this.list[this.editTimeIndex].home_time = val;
      this.$api.editHomeTime({ id: this.list[this.editTimeIndex].id, home_time: val }).then(function (res) {
        if (res) {
          _this.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    editHomeTime: function editHomeTime(index) {
      this.editTimeIndex = index;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: 2 }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this3 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this3.blankShow) {
          _this3.busy = true;
          _this3.loadStatus = false;
          _this3.loadmoreText = '没有更多了。。。';
        } else {
          if (_this3.hasNext > 0) {
            _this3.loadStatus = false;
            _this3.busy = false;
          } else {
            _this3.busy = true;
            _this3.loadStatus = true;
            _this3.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3762e1e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waitCollect.vue
var waitCollect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"number","placeholder":"手机号或订单号后四位","oninput":"if(value.length > 4) value=value.slice(0,4)"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',{staticClass:"cm-p-tb-12 cm-text-left cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-color-red "},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12 cm-p-t-8 cm-text-left cm-border-bottom-1"},[(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(item.phone)+" "+_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num))]),_vm._v(" "),(_vm.$func.checkAuth('editHomeTime'))?_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("上门时间："+_vm._s(item.home_time)+" ")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222 cm-m-l-16",attrs:{"format":"YYYY-MM-DD HH:mm","end-date":_vm.endDate,"start-date":_vm.startDate,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus,"hour-list":['08','09', '10', '11', '12', '13', '14', '15', '16', '17', '18','19','20'],"minute-list":['00', '30']},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-fn-14 cm-color-222",on:{"click":function($event){return _vm.editHomeTime(index)}}},[_vm._v("修改")])])],1):_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("上门时间："+_vm._s(item.home_time))]),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('p',{staticClass:" title cm-fn-14"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-8 button"},[(!_vm.isYizhuanjia && _vm.$func.checkAuth('collect'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white"},[_c('router-link',{staticClass:"cm-w-100 cm-h-100 cm-center cm-color-white",attrs:{"to":'/collect/'+item.id}},[_vm._v("待送洗")])],1):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('contact') && item.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var waitCollect_staticRenderFns = []
var waitCollect_esExports = { render: waitCollect_render, staticRenderFns: waitCollect_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waitCollect = (waitCollect_esExports);
// CONCATENATED MODULE: ./src/pages/waitCollect.vue
function waitCollect_injectStyle (ssrContext) {
  __webpack_require__("HjRF")
}
var waitCollect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waitCollect___vue_template_functional__ = false
/* styles */
var waitCollect___vue_styles__ = waitCollect_injectStyle
/* scopeId */
var waitCollect___vue_scopeId__ = "data-v-3762e1e4"
/* moduleIdentifier (server only) */
var waitCollect___vue_module_identifier__ = null
var waitCollect_Component = waitCollect_normalizeComponent(
  pages_waitCollect,
  selectortype_template_index_0_src_pages_waitCollect,
  waitCollect___vue_template_functional__,
  waitCollect___vue_styles__,
  waitCollect___vue_scopeId__,
  waitCollect___vue_module_identifier__
)

/* harmony default export */ var src_pages_waitCollect = (waitCollect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitCollectYizhuanjia.vue





/* harmony default export */ var waitCollectYizhuanjia = ({
  name: 'order',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      list: [],
      phone: '',
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 18,
      days: 30,
      editTimeIndex: ''
    };
  },
  mounted: function mounted() {
    if (!this.$func.getLocal('token')) {
      window.location.href = "/";
      return false;
    }
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this = this;

      this.list[this.editTimeIndex].home_time = val;
      this.$api.editHomeTime({ id: this.list[this.editTimeIndex].id, home_time: val }).then(function (res) {
        if (res) {
          _this.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    editHomeTime: function editHomeTime(index) {
      this.editTimeIndex = index;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: 2 }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this3 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this3.blankShow) {
          _this3.busy = true;
          _this3.loadStatus = false;
          _this3.loadmoreText = '没有更多了。。。';
        } else {
          if (_this3.hasNext > 0) {
            _this3.loadStatus = false;
            _this3.busy = false;
          } else {
            _this3.busy = true;
            _this3.loadStatus = true;
            _this3.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitCollectYizhuanjia.vue





/* harmony default export */ var pages_waitCollectYizhuanjia = ({
  name: 'order',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      list: [],
      phone: '',
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 18,
      days: 30,
      editTimeIndex: ''
    };
  },
  mounted: function mounted() {
    if (!this.$func.getLocal('token')) {
      window.location.href = "/";
      return false;
    }
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this = this;

      this.list[this.editTimeIndex].home_time = val;
      this.$api.editHomeTime({ id: this.list[this.editTimeIndex].id, home_time: val }).then(function (res) {
        if (res) {
          _this.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    editHomeTime: function editHomeTime(index) {
      this.editTimeIndex = index;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: 2 }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this3 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this3.blankShow) {
          _this3.busy = true;
          _this3.loadStatus = false;
          _this3.loadmoreText = '没有更多了。。。';
        } else {
          if (_this3.hasNext > 0) {
            _this3.loadStatus = false;
            _this3.busy = false;
          } else {
            _this3.busy = true;
            _this3.loadStatus = true;
            _this3.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a0fe5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waitCollectYizhuanjia.vue
var waitCollectYizhuanjia_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"number","placeholder":"手机号或订单号后四位","oninput":"if(value.length > 4) value=value.slice(0,4)"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',{staticClass:"cm-p-tb-12 cm-text-left cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-color-red "},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12 cm-p-t-8 cm-text-left cm-border-bottom-1"},[(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(item.phone)+" "+_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num))]),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('p',{staticClass:" title cm-fn-14"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(_vm.$func.checkAuth('contact') && item.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var waitCollectYizhuanjia_staticRenderFns = []
var waitCollectYizhuanjia_esExports = { render: waitCollectYizhuanjia_render, staticRenderFns: waitCollectYizhuanjia_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waitCollectYizhuanjia = (waitCollectYizhuanjia_esExports);
// CONCATENATED MODULE: ./src/pages/waitCollectYizhuanjia.vue
function waitCollectYizhuanjia_injectStyle (ssrContext) {
  __webpack_require__("Hr37")
}
var waitCollectYizhuanjia_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waitCollectYizhuanjia___vue_template_functional__ = false
/* styles */
var waitCollectYizhuanjia___vue_styles__ = waitCollectYizhuanjia_injectStyle
/* scopeId */
var waitCollectYizhuanjia___vue_scopeId__ = "data-v-06a0fe5a"
/* moduleIdentifier (server only) */
var waitCollectYizhuanjia___vue_module_identifier__ = null
var waitCollectYizhuanjia_Component = waitCollectYizhuanjia_normalizeComponent(
  pages_waitCollectYizhuanjia,
  selectortype_template_index_0_src_pages_waitCollectYizhuanjia,
  waitCollectYizhuanjia___vue_template_functional__,
  waitCollectYizhuanjia___vue_styles__,
  waitCollectYizhuanjia___vue_scopeId__,
  waitCollectYizhuanjia___vue_module_identifier__
)

/* harmony default export */ var src_pages_waitCollectYizhuanjia = (waitCollectYizhuanjia_Component.exports);

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_collect = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      num: 1,
      pop: true,
      filePath: [],
      pics: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.id = Number(this.$route.params.id);
    // this.changePop();
    this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },

  methods: {
    changePop: function changePop() {
      this.pop = !this.pop;
    },
    scanQRCode: function scanQRCode() {
      // this.pop = false;
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode', 'qrCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.code = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              // that.pop = true;
            }, 1000);
          }
        });
      });
      // wx.error((res)=> {
      //   console.log(res)
      //   alert(res.errMsg);
      // })
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          // debug: true, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode', 'chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit: function submit() {
      var _this = this;

      if (!this.code) {
        return false;
      }
      if (!this.code) {
        this.$func.showToast('请先扫描送洗码');
        return false;
      }
      if (!this.num) {
        this.$func.showToast('请输入送洗总数量');
        return false;
      }
      this.$api.collect({ id: this.id, code: this.code, num: this.num, pics: this.pics }).then(function (res) {
        if (res) {
          _this.$func.showToast('收衣成功');
          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3";
            media.play();
          });
          setTimeout(function () {
            _this.$router.go(-1);
          }, 2000);
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'collect' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath // 需要预览的图片http链接列表
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collect.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_collect = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      num: 1,
      pop: true,
      filePath: [],
      pics: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.id = Number(this.$route.params.id);
    // this.changePop();
    this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },

  methods: {
    changePop: function changePop() {
      this.pop = !this.pop;
    },
    scanQRCode: function scanQRCode() {
      // this.pop = false;
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode', 'qrCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.code = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              // that.pop = true;
            }, 1000);
          }
        });
      });
      // wx.error((res)=> {
      //   console.log(res)
      //   alert(res.errMsg);
      // })
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          // debug: true, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode', 'chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit: function submit() {
      var _this = this;

      if (!this.code) {
        return false;
      }
      if (!this.code) {
        this.$func.showToast('请先扫描送洗码');
        return false;
      }
      if (!this.num) {
        this.$func.showToast('请输入送洗总数量');
        return false;
      }
      this.$api.collect({ id: this.id, code: this.code, num: this.num, pics: this.pics }).then(function (res) {
        if (res) {
          _this.$func.showToast('收衣成功');
          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3";
            media.play();
          });
          setTimeout(function () {
            _this.$router.go(-1);
          }, 2000);
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'collect' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath // 需要预览的图片http链接列表
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a00f5e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collect.vue
var collect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white"},[_c('div',{staticClass:"cm-text-left cm-p-tb-16 cm-p-lr-20"},[_c('p',{staticClass:"cm-fn-22"},[_vm._v("送洗码：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-28 cm-color-red cm-m-l-12 cm-bg-gray cm-m-t-12 cm-p-tb-4 cm-p-lr-8 cm-border-radius-10",attrs:{"type":"text","placeholder":"请输入送洗码或扫码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-p-tb-16 cm-p-lr-20"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("衣物图片")]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list",staticStyle:{"overflow-y":"auto"}},[_vm._l((_vm.filePath),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(index)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)])]),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"pop-bg"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请核对衣物总数后确认收衣")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_vm._v("共计"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.num),expression:"num"}],staticClass:"cm-fn-22 cm-bg-white cm-m-lr-4 cm-h-100 cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"50px","height":"40px"},attrs:{"type":"number","oninput":"if(value.length > 2)value=value.slice(0,2)"},domProps:{"value":(_vm.num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.num=$event.target.value}}}),_vm._v("件")])]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-w-100 cm-flex-around",staticStyle:{"height":"50px","left":"0","bottom":"10px"}},[_c('div',{staticClass:"cm-bg-blue cm-center cm-h-100 cm-p-lr-32",on:{"click":function($event){return _vm.scanQRCode()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("扫码")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center cm-h-100 cm-p-lr-32",style:({opacity: !_vm.code ? '0.6' : '1'}),on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("提交")])])])]):_vm._e(),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var collect_staticRenderFns = []
var collect_esExports = { render: collect_render, staticRenderFns: collect_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_collect = (collect_esExports);
// CONCATENATED MODULE: ./src/pages/collect.vue
function collect_injectStyle (ssrContext) {
  __webpack_require__("3i45")
}
var collect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var collect___vue_template_functional__ = false
/* styles */
var collect___vue_styles__ = collect_injectStyle
/* scopeId */
var collect___vue_scopeId__ = "data-v-3a00f5e4"
/* moduleIdentifier (server only) */
var collect___vue_module_identifier__ = null
var collect_Component = collect_normalizeComponent(
  selectortype_script_index_0_src_pages_collect,
  selectortype_template_index_0_src_pages_collect,
  collect___vue_template_functional__,
  collect___vue_styles__,
  collect___vue_scopeId__,
  collect___vue_module_identifier__
)

/* harmony default export */ var src_pages_collect = (collect_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2c7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("Q7uw")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("gsj7")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27223f69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("XZOv")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413ccea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("5jbP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9eff9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._t("wrap-after")],2)}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("xhby")
  __webpack_require__("z/9y")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("HH82")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order.vue












/* harmony default export */ var order = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  inject: ['reload'],
  data: function data() {
    return {
      title: '全部订单',
      grade: 0,
      isActive: 0,
      pop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 0,
      itemId: 0,
      list: [],
      storeScope: 0,
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.isActive = Number(this.$route.params.i);
    this.deliveryWay = Number(this.$route.params.deliveryWay);
    this.phone = this.$route.query.phone || '';
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.storeScope = this.$route.query.store_scope !== undefined ? Number(this.$route.query.store_scope) || 0 : this.grade === 2 ? 1 : 0;
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },
  amount: function amount() {},

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: this.isActive, deliveryWay: this.deliveryWay, store_scope: this.storeScope }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order.vue












/* harmony default export */ var pages_order = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  inject: ['reload'],
  data: function data() {
    return {
      title: '全部订单',
      grade: 0,
      isActive: 0,
      pop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 0,
      itemId: 0,
      list: [],
      storeScope: 0,
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.isActive = Number(this.$route.params.i);
    this.deliveryWay = Number(this.$route.params.deliveryWay);
    this.phone = this.$route.query.phone || '';
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.storeScope = this.$route.query.store_scope !== undefined ? Number(this.$route.query.store_scope) || 0 : this.grade === 2 ? 1 : 0;
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },
  amount: function amount() {},

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: this.isActive, deliveryWay: this.deliveryWay, store_scope: this.storeScope }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f8517c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order.vue
var order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"订单号后四位|手机号|姓名|昵称"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[(_vm.type == 2)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 7)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)),_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-fn-weight-default"},[_vm._v(_vm._s(item.user.nickname))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("订单金额："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.amount))])]),_vm._v(" "),(item.diff_price > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("补差价："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.diff_price))])]):_vm._e()])]),_vm._v(" "),(item.worker_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_c('a',{attrs:{"href":'tel:'+item.worker.phone}},[_vm._v(_vm._s(item.worker.phone))]),_vm._v(" "+_vm._s(item.worker.name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),0),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && _vm.$func.checkAuth('status/2'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,3)}}},[_vm._v("接单")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('status/3'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showOperater(item.id)}}},[_vm._v("分配")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('status/4'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('status/5'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[_vm._v("开始服务")]):_vm._e(),_vm._v(" "),(item.status == 5 && item.problem == 0 && _vm.$func.checkAuth('problem'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.problem(item.id)}}},[_vm._v("问题上报")]):_vm._e(),_vm._v(" "),(item.status == 6 && _vm.$func.checkAuth('status/6'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,7)}}},[_vm._v("服务完成")]):_vm._e(),_vm._v(" "),(item.status == 9 && _vm.$func.checkAuth('status/9'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center  cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id)}}},[_vm._v("查看评价")]):_vm._e(),_vm._v(" "),(item.status < 5 && _vm.$func.checkAuth('contact'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]):_vm._e()]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-m-t-16 cm-flex-middle"},[(item.status == 2 || item.status == 8)?_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 "},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-m-t-16  cm-flex-middle"},[(item.status == 8)?_c('div',{staticClass:"cm-fn-14  cm-fn-weight-default cm-color-white cm-p-tb-4 cm-p-lr-12 cm-bg-orange cm-border-radius-4",on:{"click":function($event){return _vm.changeStatus(item.id,9)}}},[_vm._v("确认取件")]):(item.out_time)?_c('div',{staticClass:"cm-fn-14  cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(item.out_time))]):_vm._e()])]),_vm._v(" "),(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)+" "),_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),(_vm.grade == 10 || _vm.grade == 2)?_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("社区："+_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(item.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("配送方式："+_vm._s(item.delivery_way_text))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.collect_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("收衣时间："+_vm._s(item.collect_time))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.special_title)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("会员卡特权："+_vm._s(item.special_title))]):_vm._e()]),_vm._v(" "),((item.status == 8 || item.status == 2) && item.uupt)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("跑男信息")]),_vm._v(" "),(item.uupt.driver_name)?_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-30",attrs:{"src":item.uupt.driver_photo,"lazy-load":true}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("跑男姓名："+_vm._s(item.uupt.driver_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("跑男电话："),_c('a',{staticClass:"cm-color-666",attrs:{"href":'tel:'+item.uupt.driver_mobile}},[_vm._v(_vm._s(item.uu_order.driver_mobile))])])])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-8"},[_vm._v("跑男抢单中。。。")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.status > 7 && item.sms_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("取件码：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.sms_code))])]):(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && item.delivery_way > 0 )?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_vm._v("已收衣")]):_vm._e(),_vm._v(" "),(item.status == 4)?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.record(item.order_no)}}},[_vm._v("衣物录单")]):_vm._e(),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]),_vm._v(" "),(item.status == 8 && item.channel == 1)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.uu_order.length <= 0)?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white",on:{"click":function($event){return _vm.uuptOrder(item.id)}}},[_vm._v("\n                          呼叫跑腿配送\n                          ")]):_vm._e(),_vm._v(" "),(item.uu_order.status > 0 && item.uu_order.status <= 3)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.cancelUuptOrder(item.id)}}},[_vm._v("\n                          取消跑腿配送\n                          ")]):_vm._e()]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择服务师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,4)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.worker,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,4)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCommentStatus),callback:function ($$v) {_vm.showCommentStatus=$$v},expression:"showCommentStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-tb-12"},_vm._l((_vm.comment.pics_path),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.src},on:{"click":function($event){return _vm.show(index)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14 cm-m-r-16"},[_vm._v("综合评分")]),_vm._v(" "),_vm._l((Number(_vm.comment.star)),function(k,k3){return _c('img',{key:k3+'a',staticClass:"cm-icon-22 cm-m-r-8",attrs:{"src":"/static/images/started@2x.png"}})}),_vm._v(" "),_vm._l((Number(_vm.comment.star1)),function(n,k4){return _c('img',{key:k4+'b',staticClass:"cm-icon-20 cm-m-r-8",attrs:{"src":"/static/images/start@2x.png"}})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-red cm-m-l-16"},[_vm._v(_vm._s(_vm.comment.star_text))])],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-border-bottom-1"},[_vm._v("\n                          "+_vm._s(_vm.comment.content)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-16  cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("评价时间")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(_vm.comment.create_time))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCommentStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),(_vm.showCommentStatus)?_c('previewer',{ref:"previewer",attrs:{"list":_vm.comment.pics_path,"options":_vm.options}}):_vm._e()],1)],1)])}
var order_staticRenderFns = []
var order_esExports = { render: order_render, staticRenderFns: order_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_order = (order_esExports);
// CONCATENATED MODULE: ./src/pages/order.vue
function order_injectStyle (ssrContext) {
  __webpack_require__("Mckz")
}
var order_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var order___vue_template_functional__ = false
/* styles */
var order___vue_styles__ = order_injectStyle
/* scopeId */
var order___vue_scopeId__ = "data-v-09f8517c"
/* moduleIdentifier (server only) */
var order___vue_module_identifier__ = null
var order_Component = order_normalizeComponent(
  pages_order,
  selectortype_template_index_0_src_pages_order,
  order___vue_template_functional__,
  order___vue_styles__,
  order___vue_scopeId__,
  order___vue_module_identifier__
)

/* harmony default export */ var src_pages_order = (order_Component.exports);

// EXTERNAL MODULE: ./node_modules/countup.js/dist/countUp.min.js
var countUp_min = __webpack_require__("EbL4");
var countUp_min_default = /*#__PURE__*/__webpack_require__.n(countUp_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/countup/index.vue



/* harmony default export */ var countup = ({
  name: 'countup',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._countup = new countUp_min_default.a(_this.$el, _this.startVal, _this.endVal, _this.decimals, _this.duration, _this.options);
      if (_this.start) {
        _this._countup.start();
      }
    });
  },

  props: {
    tag: {
      type: String,
      default: 'span'
    },
    start: {
      type: Boolean,
      default: true
    },
    startVal: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    // number of decimal places in number
    decimals: {
      type: Number,
      default: 0
    },
    // duration in seconds
    duration: {
      type: Number,
      default: 2
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render(h) {
    return h(this.tag, {}, [this.startVal]);
  },

  watch: {
    start: function start(val) {
      if (val) {
        this._countup.start();
      }
    },
    endVal: function endVal(val) {
      this._countup.update(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/countup/index.vue



/* harmony default export */ var components_countup = ({
  name: 'countup',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._countup = new countUp_min_default.a(_this.$el, _this.startVal, _this.endVal, _this.decimals, _this.duration, _this.options);
      if (_this.start) {
        _this._countup.start();
      }
    });
  },

  props: {
    tag: {
      type: String,
      default: 'span'
    },
    start: {
      type: Boolean,
      default: true
    },
    startVal: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    // number of decimal places in number
    decimals: {
      type: Number,
      default: 0
    },
    // duration in seconds
    duration: {
      type: Number,
      default: 2
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render(h) {
    return h(this.tag, {}, [this.startVal]);
  },

  watch: {
    start: function start(val) {
      if (val) {
        this._countup.start();
      }
    },
    endVal: function endVal(val) {
      this._countup.update(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/countup/index.vue
var countup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var countup___vue_template_functional__ = false
/* styles */
var countup___vue_styles__ = null
/* scopeId */
var countup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var countup___vue_module_identifier__ = null
var countup_Component = countup_normalizeComponent(
  components_countup,
  __vue_template__,
  countup___vue_template_functional__,
  countup___vue_styles__,
  countup___vue_scopeId__,
  countup___vue_module_identifier__
)

/* harmony default export */ var src_components_countup = (countup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/user.vue






/* harmony default export */ var user = ({
  name: 'user',
  components: {
    wx: weixin_js_sdk_default.a, cmFooter: src_components_cmFooter, Countup: src_components_countup
  },
  data: function data() {
    return {
      code: '',
      grade: 0,
      info: {
        nickname: '未登录',
        head: '/static/images/head.png',
        other_title: '',
        address: ''
      },
      order: {
        total_rebate: 0.00,
        month_rebate: 0.00,
        today_rebate: 0.00,
        last_month_rebate: 0.00,
        total_order: 0,
        month_order: 0,
        last_month_order: 0,
        today_order: 0,
        today_collect: 0,
        month_collect: 0,
        last_month_collect: 0,
        total_collect: 0,
        clean_today_order: 0,
        clean_month_order: 0,
        clean_last_month_order: 0,
        clean_total_order: 0,
        product_today_order: 0,
        product_month_order: 0,
        product_total_order: 0,
        product_last_month_order: 0,
        today_card: 0,
        total_card: 0,
        month_card: 0,
        last_month_card: 0,
        todayInFactory: 0,
        monthInFactory: 0,
        lastMonthInFactory: 0,
        totalInFactory: 0,
        todayOutFactory: 0,
        monthOutFactory: 0,
        lastMonthOutFactory: 0,
        totalOutFactory: 0
      },
      service: {},
      node: [],
      storeList: [],
      currentStoreId: 0,
      currentStoreName: '请选择'
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this2.$router.push({ path: '/login' });
            return false;
          }
          _this2.info = res.data;
          _this2.storeList = Array.isArray(res.data.store_list) ? res.data.store_list : [];
          _this2.currentStoreId = Number(res.data.cid);
          _this2.currentStoreName = res.data.other_title || '请选择';
          var currentStore = _this2.storeList.find(function (item) {
            return Number(item.id) === Number(res.data.cid);
          });
          if (currentStore && currentStore.name) {
            _this2.currentStoreName = currentStore.name;
          }
          if (_this2.storeList.length) {
            _this2.$func.setLocal('store_list', stringify_default()(_this2.storeList));
          }
          _this2.grade = res.data.grade;
          _this2.$func.setLocal('token', res.data.token);
          _this2.$func.setLocal('grade', res.data.grade);
          _this2.$func.setLocal('cid', res.data.cid);

          _this2.groupRebate();
        }
      });
    },
    edit: function edit() {
      this.$router.push({ path: '/editUser' });
    },
    groupRebate: function groupRebate() {
      var _this3 = this;

      this.$api.groupRebate({ store_scope: 1 }).then(function (res) {
        if (res) {
          _this3.order = res.data.order;
          _this3.service = res.data.service;
        }
      });
    },
    qrcode: function qrcode() {
      var _this = this;
      this.$api.qrcode({}).then(function (res) {
        if (res) {
          console.log(res);
          weixin_js_sdk_default.a.previewImage({
            current: res.data.path,
            urls: [res.data.path]
          });
        }
      });
    },
    switchStore: function switchStore() {
      this.$router.push({ path: '/selectStore', query: { from: 'user' } });
    },
    out: function out() {
      var _this4 = this;

      this.$func.confirm('确认退出账号？', '温馨提示', function () {
        _this4.$api.out({}).then(function (res) {
          _this4.$func.setLocal('node_v1', '');
          _this4.$func.setLocal('grade', '');
          _this4.$func.setLocal('cid', '');

          _this4.$func.setLocal('channel', '');

          _this4.$router.push({ path: '/login' });
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/user.vue






/* harmony default export */ var pages_user = ({
  name: 'user',
  components: {
    wx: weixin_js_sdk_default.a, cmFooter: src_components_cmFooter, Countup: src_components_countup
  },
  data: function data() {
    return {
      code: '',
      grade: 0,
      info: {
        nickname: '未登录',
        head: '/static/images/head.png',
        other_title: '',
        address: ''
      },
      order: {
        total_rebate: 0.00,
        month_rebate: 0.00,
        today_rebate: 0.00,
        last_month_rebate: 0.00,
        total_order: 0,
        month_order: 0,
        last_month_order: 0,
        today_order: 0,
        today_collect: 0,
        month_collect: 0,
        last_month_collect: 0,
        total_collect: 0,
        clean_today_order: 0,
        clean_month_order: 0,
        clean_last_month_order: 0,
        clean_total_order: 0,
        product_today_order: 0,
        product_month_order: 0,
        product_total_order: 0,
        product_last_month_order: 0,
        today_card: 0,
        total_card: 0,
        month_card: 0,
        last_month_card: 0,
        todayInFactory: 0,
        monthInFactory: 0,
        lastMonthInFactory: 0,
        totalInFactory: 0,
        todayOutFactory: 0,
        monthOutFactory: 0,
        lastMonthOutFactory: 0,
        totalOutFactory: 0
      },
      service: {},
      node: [],
      storeList: [],
      currentStoreId: 0,
      currentStoreName: '请选择'
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this2.$router.push({ path: '/login' });
            return false;
          }
          _this2.info = res.data;
          _this2.storeList = Array.isArray(res.data.store_list) ? res.data.store_list : [];
          _this2.currentStoreId = Number(res.data.cid);
          _this2.currentStoreName = res.data.other_title || '请选择';
          var currentStore = _this2.storeList.find(function (item) {
            return Number(item.id) === Number(res.data.cid);
          });
          if (currentStore && currentStore.name) {
            _this2.currentStoreName = currentStore.name;
          }
          if (_this2.storeList.length) {
            _this2.$func.setLocal('store_list', stringify_default()(_this2.storeList));
          }
          _this2.grade = res.data.grade;
          _this2.$func.setLocal('token', res.data.token);
          _this2.$func.setLocal('grade', res.data.grade);
          _this2.$func.setLocal('cid', res.data.cid);

          _this2.groupRebate();
        }
      });
    },
    edit: function edit() {
      this.$router.push({ path: '/editUser' });
    },
    groupRebate: function groupRebate() {
      var _this3 = this;

      this.$api.groupRebate({ store_scope: 1 }).then(function (res) {
        if (res) {
          _this3.order = res.data.order;
          _this3.service = res.data.service;
        }
      });
    },
    qrcode: function qrcode() {
      var _this = this;
      this.$api.qrcode({}).then(function (res) {
        if (res) {
          console.log(res);
          weixin_js_sdk_default.a.previewImage({
            current: res.data.path,
            urls: [res.data.path]
          });
        }
      });
    },
    switchStore: function switchStore() {
      this.$router.push({ path: '/selectStore', query: { from: 'user' } });
    },
    out: function out() {
      var _this4 = this;

      this.$func.confirm('确认退出账号？', '温馨提示', function () {
        _this4.$api.out({}).then(function (res) {
          _this4.$func.setLocal('node_v1', '');
          _this4.$func.setLocal('grade', '');
          _this4.$func.setLocal('cid', '');

          _this4.$func.setLocal('channel', '');

          _this4.$router.push({ path: '/login' });
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a3ef48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user.vue
var user_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"user-header cm-w-100"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-p-lr-20 cm-flex-start cm-flex-middle cm-p-t-24"},[_c('div',{staticClass:"cm-img-box head cm-border-radius",on:{"click":function($event){return _vm.edit()}}},[_c('img',{attrs:{"src":_vm.info.head}})]),_vm._v(" "),(_vm.info.token)?_c('div',{staticClass:"cm-m-l-8 cm-text-left"},[_c('p',{staticClass:"cm-fn-weight-max cm-fn-16"},[_vm._v(_vm._s(_vm.info.nickname))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-orange"},[_vm._v("UID："+_vm._s(_vm.info.user_id))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('img',{staticClass:"cm-icon-22 cm-m-r-20",attrs:{"src":"/static/images/set.png"},on:{"click":function($event){return _vm.edit()}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-12",attrs:{"src":"/static/images/out.png"},on:{"click":function($event){return _vm.out()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-p-lr-16 cm-text-left cm-m-t-8"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(_vm.info.grade_title)+" "+_vm._s(_vm.info.other_title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12"},[_vm._v(_vm._s(_vm.info.address))])]),_vm._v(" "),(_vm.$func.checkAuth('qrcode'))?_c('img',{staticClass:"cm-icon-24 cm-m-r-16",attrs:{"src":"/static/images/qrcode.png"},on:{"click":function($event){return _vm.qrcode()}}}):_vm._e()]),_vm._v(" "),(_vm.storeList.length > 1)?_c('div',{staticClass:"store-current"},[_c('div',{staticClass:"store-current-info"},[_c('p',{staticClass:"store-current-label"},[_vm._v("当前门店")]),_vm._v(" "),_c('p',{staticClass:"store-current-name"},[_vm._v(_vm._s(_vm.currentStoreName))])]),_vm._v(" "),_c('button',{staticClass:"store-current-btn",on:{"click":_vm.switchStore}},[_vm._v("切换门店")])]):_vm._e()]),_vm._v(" "),(_vm.$func.checkAuth('userData'))?_c('div',{staticClass:"table cm-p-t-12 cm-border-radius-4  shadow-gray cm-w-100 cm-bg-white"},[_vm._m(0),_vm._v(" "),(_vm.$func.checkAuth('rebate'))?_c('router-link',{attrs:{"to":"/rebate"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("收益")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.today_rebate))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.month_rebate))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.total_rebate))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_rebate))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('totalCollect'))?_c('router-link',{attrs:{"to":"/myData"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("收衣")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.today_collect))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.month_collect))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.total_collect))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_collect))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('washOrder'))?_c('router-link',{attrs:{"to":{path:'/order/1/0', query:{store_scope:1}}}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("洗衣订单")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.today_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.month_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.total_order))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_order))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('cleanOrder'))?_c('router-link',{attrs:{"to":{path:'/order/2/0', query:{store_scope:1}}}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16  cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("家政订单")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.clean_today_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.clean_month_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.clean_total_order))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.clean_last_month_order))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('inviteData'))?_c('router-link',{attrs:{"to":"/inviteUser"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',[_vm._v("推广用户")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.invite_today_user))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.invite_month_user))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.invite_total_user))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_user))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('inviteOrder'))?_c('router-link',{attrs:{"to":"/rebate"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',[_vm._v("推广订单")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.invite_today_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.invite_month_order))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.invite_total_order))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.invite_last_month_order))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('inviteCard'))?_c('router-link',{attrs:{"to":"/rebate"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',{staticStyle:{"width":"86px"}},[_vm._v("推广会员卡")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.invite_today_card))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.invite_month_card))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.invite_total_card))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.invite_last_month_card))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('pickupCount'))?_c('router-link',{attrs:{"to":"/pickuped"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',{staticStyle:{"width":"86px"}},[_vm._v("取件")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.today_pickup))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.month_pickup))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.total_pickup))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_pickup))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('arrivalCount'))?_c('router-link',{attrs:{"to":"/arrivaled"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',{staticStyle:{"width":"86px"}},[_vm._v("到站")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.today_arrival))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.month_arrival))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.total_arrival))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.last_month_arrival))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('userInFactory'))?_c('router-link',{attrs:{"to":"/factory"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',{staticStyle:{"width":"86px"}},[_vm._v("入厂")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.todayInFactory))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.monthInFactory))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.totalInFactory))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.lastMonthInFactory))])])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('userOutFactory'))?_c('router-link',{attrs:{"to":"/factory"}},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('li',{staticStyle:{"width":"86px"}},[_vm._v("出厂")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.todayOutFactory))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.order.monthOutFactory))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.totalOutFactory))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.order.lastMonthOutFactory))])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workData'))?_c('div',{staticClass:"table cm-p-t-12 cm-border-radius-4  shadow-gray cm-w-100 cm-bg-white"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.service),function(item,index){return _c('ul',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',{staticStyle:{"width":"25%"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"cm-color-orange",attrs:{"to":'/workorder/'+2}},[_vm._v(_vm._s(item.work_order ? item.work_order : 0))])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"cm-color-green",attrs:{"to":'/workorder/'+3}},[_vm._v(_vm._s(item.work_processe ? item.work_processe : 0))])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"cm-color-blue",attrs:{"to":'/workorder/'+4}},[_vm._v(_vm._s(item.work_finish ? item.work_finish : 0))])],1),_vm._v(" "),_c('li',{},[_c('router-link',{attrs:{"to":'/workorder/'+5}},[_vm._v(_vm._s(item.work_close ? item.work_close: 0))])],1)])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-bg-white cm-m-t-4",staticStyle:{"padding-bottom":"100px"}},[(_vm.$func.checkAuth('dataCount'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/dataCount"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("数据统计")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('secondCommunity'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/secondCommunity"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("下级团长")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('secondCommunityOrder'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/secondCommunityOrder"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("下级团长订单")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('rebate'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/rebate"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("收益记录")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('withdrawRecord') && (!_vm.info.floor_ids || _vm.info.floor_ids == '0'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/withdrawRecord"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("收益提现")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('balance'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/balance"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("平台账户")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('coupon'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/coupon/0"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("优惠券")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('coupon'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/coupon/1"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("配送券")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.info.print_bag && _vm.$func.checkAuth('washBagCode'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/washBagCode"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("洗衣码下载")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('password'))?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/password"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("修改密码")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e()],1),_vm._v(" "),_c('cmFooter',{attrs:{"active":2}})],1)}
var user_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1 cm-p-tb-12"},[_c('li',{staticClass:"cm-fn-14"},[_vm._v("项目")]),_vm._v(" "),_c('li',[_vm._v("今日")]),_vm._v(" "),_c('li',[_vm._v("当月")]),_vm._v(" "),_c('li',[_vm._v("累计")]),_vm._v(" "),_c('li',[_vm._v("上月")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1 cm-p-tb-12"},[_c('li',{staticClass:"cm-fn-14",staticStyle:{"width":"25%"}},[_vm._v("客服")]),_vm._v(" "),_c('li',[_vm._v("待接单")]),_vm._v(" "),_c('li',[_vm._v("处理中")]),_vm._v(" "),_c('li',[_vm._v("前段确认")]),_vm._v(" "),_c('li',[_vm._v("已完成")])])}]
var user_esExports = { render: user_render, staticRenderFns: user_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_user = (user_esExports);
// CONCATENATED MODULE: ./src/pages/user.vue
function user_injectStyle (ssrContext) {
  __webpack_require__("fJrc")
}
var user_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var user___vue_template_functional__ = false
/* styles */
var user___vue_styles__ = user_injectStyle
/* scopeId */
var user___vue_scopeId__ = "data-v-39a3ef48"
/* moduleIdentifier (server only) */
var user___vue_module_identifier__ = null
var user_Component = user_normalizeComponent(
  pages_user,
  selectortype_template_index_0_src_pages_user,
  user___vue_template_functional__,
  user___vue_styles__,
  user___vue_scopeId__,
  user___vue_module_identifier__
)

/* harmony default export */ var src_pages_user = (user_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdraw.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var withdraw = ({
    data: function data() {
        return {
            info: {
                wait_rebate: '0.00',
                hand_fee: '0.00',
                nickname: '',
                name: '',
                ids: ''
            },
            ids: '',
            type: 0,
            amount: 0,
            status: true
        };
    },
    mounted: function mounted() {
        this.ids = this.$route.query.ids;
        this.type = this.$route.query.type;
        this.withdrawMoney();
    },

    methods: {
        withdrawMoney: function withdrawMoney() {
            var _this = this;

            this.$api.withdrawMoney({ ids: this.ids, type: this.type }).then(function (res) {
                if (res) {
                    _this.info = res.data;
                    _this.amount = _this.info.wait_withdraw;
                }
            });
        },
        submitWithdraw: function submitWithdraw() {
            var _this2 = this;

            if (!this.status) {
                return false;
            }
            this.status = false;
            if (!this.info.name) {
                this.$func.showToast('请输入真实姓名');
                return false;
            }
            if (this.amount <= 0) {
                this.$func.showToast('提现金额不正确');
                return false;
            }
            if (this.amount > this.info.wait_withdraw) {
                this.$func.showToast('可提现金额不足');
                return false;
            }
            if (this.amount > 2000) {
                this.$func.showToast('单次提现限额2000元');
                return false;
            }
            this.$func.confirm('确认提交申请？', '提示', function () {
                _this2.checkWithdrawAuthorization();
            });
        },
        checkWithdrawAuthorization: function checkWithdrawAuthorization() {
            var _this3 = this;

            this.$api.withdrawAuthorization({}).then(function (res) {
                if (!res) {
                    _this3.status = true;
                    return false;
                }
                if (res.data.authorized) {
                    _this3.doSubmitWithdraw();
                    return;
                }
                _this3.openWithdrawAuthorization(res.data);
            });
        },
        openWithdrawAuthorization: function openWithdrawAuthorization(data) {
            var _this4 = this;

            if (!data.package_info) {
                this.status = true;
                this.$func.showToast('微信授权参数异常');
                return false;
            }
            var onBridgeReady = function onBridgeReady() {
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                    mchId: data.mch_id,
                    appId: data.app_id,
                    package: data.package_info
                }, function (res) {
                    if (res.err_msg == 'requestMerchantTransfer:ok') {
                        _this4.$api.bindWithdrawAuthorization({ out_authorization_no: data.out_authorization_no }).then(function (res) {
                            if (res) {
                                _this4.doSubmitWithdraw();
                            } else {
                                _this4.status = true;
                            }
                        });
                    } else {
                        _this4.status = true;
                        _this4.$func.showToast('未完成微信提现授权');
                    }
                });
            };
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            } else {
                onBridgeReady();
            }
        },
        doSubmitWithdraw: function doSubmitWithdraw() {
            var _this5 = this;

            this.$api.submitWithdraw({ name: this.info.name, ids: this.ids, type: this.type, amount: this.amount }).then(function (res) {
                _this5.status = true;
                if (res) {
                    setTimeout(function () {
                        _this5.$router.push({ path: '/withdrawComplete', query: { grade: res.data.grade } });
                    }, 300);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdraw.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_withdraw = ({
    data: function data() {
        return {
            info: {
                wait_rebate: '0.00',
                hand_fee: '0.00',
                nickname: '',
                name: '',
                ids: ''
            },
            ids: '',
            type: 0,
            amount: 0,
            status: true
        };
    },
    mounted: function mounted() {
        this.ids = this.$route.query.ids;
        this.type = this.$route.query.type;
        this.withdrawMoney();
    },

    methods: {
        withdrawMoney: function withdrawMoney() {
            var _this = this;

            this.$api.withdrawMoney({ ids: this.ids, type: this.type }).then(function (res) {
                if (res) {
                    _this.info = res.data;
                    _this.amount = _this.info.wait_withdraw;
                }
            });
        },
        submitWithdraw: function submitWithdraw() {
            var _this2 = this;

            if (!this.status) {
                return false;
            }
            this.status = false;
            if (!this.info.name) {
                this.$func.showToast('请输入真实姓名');
                return false;
            }
            if (this.amount <= 0) {
                this.$func.showToast('提现金额不正确');
                return false;
            }
            if (this.amount > this.info.wait_withdraw) {
                this.$func.showToast('可提现金额不足');
                return false;
            }
            if (this.amount > 2000) {
                this.$func.showToast('单次提现限额2000元');
                return false;
            }
            this.$func.confirm('确认提交申请？', '提示', function () {
                _this2.checkWithdrawAuthorization();
            });
        },
        checkWithdrawAuthorization: function checkWithdrawAuthorization() {
            var _this3 = this;

            this.$api.withdrawAuthorization({}).then(function (res) {
                if (!res) {
                    _this3.status = true;
                    return false;
                }
                if (res.data.authorized) {
                    _this3.doSubmitWithdraw();
                    return;
                }
                _this3.openWithdrawAuthorization(res.data);
            });
        },
        openWithdrawAuthorization: function openWithdrawAuthorization(data) {
            var _this4 = this;

            if (!data.package_info) {
                this.status = true;
                this.$func.showToast('微信授权参数异常');
                return false;
            }
            var onBridgeReady = function onBridgeReady() {
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                    mchId: data.mch_id,
                    appId: data.app_id,
                    package: data.package_info
                }, function (res) {
                    if (res.err_msg == 'requestMerchantTransfer:ok') {
                        _this4.$api.bindWithdrawAuthorization({ out_authorization_no: data.out_authorization_no }).then(function (res) {
                            if (res) {
                                _this4.doSubmitWithdraw();
                            } else {
                                _this4.status = true;
                            }
                        });
                    } else {
                        _this4.status = true;
                        _this4.$func.showToast('未完成微信提现授权');
                    }
                });
            };
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            } else {
                onBridgeReady();
            }
        },
        doSubmitWithdraw: function doSubmitWithdraw() {
            var _this5 = this;

            this.$api.submitWithdraw({ name: this.info.name, ids: this.ids, type: this.type, amount: this.amount }).then(function (res) {
                _this5.status = true;
                if (res) {
                    setTimeout(function () {
                        _this5.$router.push({ path: '/withdrawComplete', query: { grade: res.data.grade } });
                    }, 300);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25177a30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/withdraw.vue
var withdraw_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray cm-mh-100 "},[_c('div',{staticClass:"shadow-gray cm-p-lr-16 cm-m-lr-8 cm-p-tb-20 cm-flex-middle cm-bg-white cm-flex-between cm-m-t-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(_vm.info.nickname))])])]),_vm._v(" "),_c('div',{staticClass:"shadow-gray cm-p-lr-16 cm-m-lr-8 cm-bg-white cm-p-tb-20 cm-flex-middle cm-flex-between cm-m-t-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.name),expression:"info.name"}],staticClass:"border-b cm-fn-16 cm-text-right",attrs:{"type":"text"},domProps:{"value":(_vm.info.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.info, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"shadow-gray cm-p-lr-16 cm-p-t-36 cm-p-b-16  cm-m-lr-8 cm-bg-white cm-m-t-16 "},[_c('div',{staticClass:"cm-flex-middle cm-flex-between"},[(_vm.type > 0)?_c('div',{staticClass:"cm-flex-start cm-flex-middle",staticStyle:{"width":"50%"}},[_c('p',{staticClass:"cm-fn-20 cm-color-orange"},[_vm._v("￥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"cm-fn-28 cm-color-orange cm-fn-weight-default cm-border-bottom-1 cm-w-100",attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})]):_c('div',[_c('p',{staticClass:"cm-fn-28 cm-color-orange cm-fn-weight-default"},[_vm._v("￥"+_vm._s(_vm.amount))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"15%"}},[_c('p',{staticClass:"cm-fn-weight-min cm-fn-12  cm-color-txt3"},[_vm._v("手续费")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-min  cm-fn-12  cm-color-orange"},[_vm._v("￥"+_vm._s(_vm.info.hand_fee))])])]),_vm._v(" "),(_vm.type > 0)?_c('p',{staticClass:"cm-m-t-8 cm-fn-12"},[_vm._v("可提现金额"),_c('span',{staticClass:"cm-m-l-4 cm-fn-14 cm-fn-weight-default"},[_vm._v("￥"+_vm._s(_vm.info.wait_withdraw))])]):_vm._e()]),_vm._v(" "),(_vm.info.hand_fee > 0)?_c('div',{staticClass:"cm-m-t-36 cm-center"},[_c('p',{staticClass:"cm-fn-12 cm-color-txt2"},[_vm._v(_vm._s(_vm.info.head_fee_text))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-t-36 cm-center cm-w-100"},[_c('div',{staticClass:"cm-p-tb-8 cm-center  cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default cm-bg-red",staticStyle:{"width":"80%"},on:{"click":function($event){return _vm.submitWithdraw()}}},[_vm._v("提交申请")])])])}
var withdraw_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('div',{staticClass:"cm-img-box cm-icon-20"},[_c('img',{attrs:{"src":"/static/images/weixin-green.png"}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-min cm-m-l-8"},[_vm._v("到账微信昵称：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('div',{staticClass:"cm-img-box cm-icon-20"},[_c('img',{attrs:{"src":"/static/images/icon-tab-me-active.png"}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-min cm-m-l-8"},[_vm._v("请输入真实姓名：")])])}]
var withdraw_esExports = { render: withdraw_render, staticRenderFns: withdraw_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_withdraw = (withdraw_esExports);
// CONCATENATED MODULE: ./src/pages/withdraw.vue
function withdraw_injectStyle (ssrContext) {
  __webpack_require__("r36t")
}
var withdraw_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var withdraw___vue_template_functional__ = false
/* styles */
var withdraw___vue_styles__ = withdraw_injectStyle
/* scopeId */
var withdraw___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var withdraw___vue_module_identifier__ = null
var withdraw_Component = withdraw_normalizeComponent(
  pages_withdraw,
  selectortype_template_index_0_src_pages_withdraw,
  withdraw___vue_template_functional__,
  withdraw___vue_styles__,
  withdraw___vue_scopeId__,
  withdraw___vue_module_identifier__
)

/* harmony default export */ var src_pages_withdraw = (withdraw_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/rebate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var rebate = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            isActive: 0,
            uid: 0,
            otherId: 0,
            types: []
        };
    },
    mounted: function mounted() {
        this.uid = this.parseRouteId(this.$route.params.uid);
        this.otherId = this.parseRouteId(this.$route.params.otherId);
        this.grade = this.$func.getLocal('grade');
        this.grade = parseInt(this.grade);
        if (this.grade == 3 || this.grade == 5) {
            this.types = [{
                'key': 0,
                'text': '社区收益'
            }, {
                'key': 1,
                'text': '分销收益'
            }, {
                'key': 2,
                'text': '其他收益'
            }];
        }
    },

    methods: {
        parseRouteId: function parseRouteId(value) {
            var id = parseInt(value);
            return isNaN(id) ? 0 : id;
        },
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.orderRebate({ last_id: this.lastId, page_flag: this.pageFlag, type: this.isActive, uid: this.uid, otherId: this.otherId }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/rebate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_rebate = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            isActive: 0,
            uid: 0,
            otherId: 0,
            types: []
        };
    },
    mounted: function mounted() {
        this.uid = this.parseRouteId(this.$route.params.uid);
        this.otherId = this.parseRouteId(this.$route.params.otherId);
        this.grade = this.$func.getLocal('grade');
        this.grade = parseInt(this.grade);
        if (this.grade == 3 || this.grade == 5) {
            this.types = [{
                'key': 0,
                'text': '社区收益'
            }, {
                'key': 1,
                'text': '分销收益'
            }, {
                'key': 2,
                'text': '其他收益'
            }];
        }
    },

    methods: {
        parseRouteId: function parseRouteId(value) {
            var id = parseInt(value);
            return isNaN(id) ? 0 : id;
        },
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.orderRebate({ last_id: this.lastId, page_flag: this.pageFlag, type: this.isActive, uid: this.uid, otherId: this.otherId }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b56e9d2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rebate.vue
var rebate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[(_vm.types.length > 0)?_c('div',{staticClass:"nav cm-bg-white"},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 cm-w-50",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.select(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-bg",style:({ top: _vm.types.length > 0 ? '40px': '0px' })},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.community && item.community.name ? item.community.name : '未知门店'))]),_vm._v(" "),(item.order_id > 0)?_c('div',{staticClass:"cm-text-right cm-flex-end cm-flex-middle"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.order && item.order.name ? item.order.name : ''))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-m-l-4"},[_vm._v(_vm._s(item.order && item.order.phone ? item.order.phone : ''))])]):_vm._e()]),_vm._v(" "),(item.order_id > 0 && item.order)?_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.order.order_no)+" ")]),_vm._v(" "),(item.factory_wash_code)?_c('p',{staticClass:"cm-color-block cm-fn-12  cm-fn-weight-default"},[_vm._v(_vm._s(item.factory_wash_code))]):_vm._e()]),_vm._v(" "),(item.status == 1)?_c('p',{staticClass:"cm-color-green cm-center"},[_vm._v(_vm._s(item.order.status)+"，"+_vm._s(item.status_text))]):(item.status == 2)?_c('p',{staticClass:"cm-color-blue cm-center"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-color-red cm-center"},[_vm._v(_vm._s(item.order.status)+"，"+_vm._s(item.status_text))])]):_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-text-left"},[(item.factory_wash_code)?_c('p',{staticClass:"cm-color-block cm-fn-12  cm-fn-weight-default"},[_vm._v(_vm._s(item.factory_wash_code))]):_vm._e()]),_vm._v(" "),(item.status == 1)?_c('p',{staticClass:"cm-color-green cm-center"},[_vm._v(_vm._s(item.status_text))]):(item.status == 2)?_c('p',{staticClass:"cm-color-blue cm-center"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-color-red cm-center"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),(item.order_id > 0 && item.order && item.goods && item.goods.length)?_c('div',[(item.goods.length > 1)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-16 cm-p-lr-12"},_vm._l((item.goods),function(val,key){return (key < 4)?_c('div',{key:key,staticClass:"image cm-img-box  cm-m-l-8"},[_c('img',{attrs:{"src":val.goods && val.goods.pic ? val.goods.pic : ''}})]):_vm._e()}),0):_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.goods[0].goods && item.goods[0].goods.pic ? item.goods[0].goods.pic : ''}})]),_vm._v(" "),_c('div',{staticClass:"info cm-m-l-16"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.goods[0].goods && item.goods[0].goods.title ? item.goods[0].goods.title : ''))]),_vm._v(" "),_c('p',{staticClass:"cm-color-red"},[_vm._v("￥"+_vm._s(item.goods[0].price))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.goods[0].num))])])])]):_vm._e(),_vm._v(" "),(item.order_id > 0 && item.order)?_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-12 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('p',{staticClass:"cm-color-666 cm-m-l-4 cm-center cm-m-r-4"},[_vm._v("实付：￥"+_vm._s(item.order.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])]):_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-12 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var rebate_staticRenderFns = []
var rebate_esExports = { render: rebate_render, staticRenderFns: rebate_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_rebate = (rebate_esExports);
// CONCATENATED MODULE: ./src/pages/rebate.vue
function rebate_injectStyle (ssrContext) {
  __webpack_require__("yvPf")
}
var rebate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rebate___vue_template_functional__ = false
/* styles */
var rebate___vue_styles__ = rebate_injectStyle
/* scopeId */
var rebate___vue_scopeId__ = "data-v-b56e9d2e"
/* moduleIdentifier (server only) */
var rebate___vue_module_identifier__ = null
var rebate_Component = rebate_normalizeComponent(
  pages_rebate,
  selectortype_template_index_0_src_pages_rebate,
  rebate___vue_template_functional__,
  rebate___vue_styles__,
  rebate___vue_scopeId__,
  rebate___vue_module_identifier__
)

/* harmony default export */ var src_pages_rebate = (rebate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawComplete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var withdrawComplete = ({
    data: function data() {
        return {
            grade: 1
        };
    },
    created: function created() {
        this.grade = Number(this.$route.query.grade);
    },

    methods: {
        jump: function jump() {
            if (this.grade < 3) {
                this.$router.push({ path: '/group' });
            } else {
                this.$router.push({ path: '/user' });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawComplete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_withdrawComplete = ({
    data: function data() {
        return {
            grade: 1
        };
    },
    created: function created() {
        this.grade = Number(this.$route.query.grade);
    },

    methods: {
        jump: function jump() {
            if (this.grade < 3) {
                this.$router.push({ path: '/group' });
            } else {
                this.$router.push({ path: '/user' });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb4ee954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/withdrawComplete.vue
var withdrawComplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cm-m-t-40 cm-center cm-w-100"},[_c('div',{staticClass:"cm-p-tb-10 cm-center cm-bg-red cm-color-white cm-border-radius-8 cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"48%"},on:{"click":function($event){return _vm.jump()}}},[_vm._v("知道了")])])])}
var withdrawComplete_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40 cm-p-t-40"},[_c('div',{staticClass:"cm-auto-width cm-m-b-8",staticStyle:{"border-bottom":"6px solid #FFCD35"}},[_c('p',{staticClass:"cm-color-block cm-fn-16 cm-fn-weight-default cm-pr cm-fn-22",staticStyle:{"top":"9px"}},[_vm._v("申请已提交")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-w-100 cm-m-t-20 cm-text-center "},[_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v("提现申请已提交，审核通过后")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v("提现金额将转入微信钱包，")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v("请注意查收！")])])}]
var withdrawComplete_esExports = { render: withdrawComplete_render, staticRenderFns: withdrawComplete_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_withdrawComplete = (withdrawComplete_esExports);
// CONCATENATED MODULE: ./src/pages/withdrawComplete.vue
function withdrawComplete_injectStyle (ssrContext) {
  __webpack_require__("ksP8")
}
var withdrawComplete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var withdrawComplete___vue_template_functional__ = false
/* styles */
var withdrawComplete___vue_styles__ = withdrawComplete_injectStyle
/* scopeId */
var withdrawComplete___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var withdrawComplete___vue_module_identifier__ = null
var withdrawComplete_Component = withdrawComplete_normalizeComponent(
  pages_withdrawComplete,
  selectortype_template_index_0_src_pages_withdrawComplete,
  withdrawComplete___vue_template_functional__,
  withdrawComplete___vue_styles__,
  withdrawComplete___vue_scopeId__,
  withdrawComplete___vue_module_identifier__
)

/* harmony default export */ var src_pages_withdrawComplete = (withdrawComplete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_withdrawRecord = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            height: '100%',
            isActive: 1,
            checkAllStatus: 0,
            checkAllWithdraw: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            types: [{
                'key': 0,
                'text': '提现记录'
            }, {
                'key': 1,
                'text': '可提现订单'
            }],
            info: {
                wait_withdraw: 0.00,
                total_withdraw: 0.00
            },
            moneyMax: 5000
            // countMoney:0
        };
    },
    mounted: function mounted() {
        // this.getList();
        this.withdrawMoney();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.list = [];
            this.where = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.money = (Number(this.money) - Number(this.list[i].money)).toFixed(2);
                this.list[i].checked = 0;
            } else {
                if (Number(this.money) + Number(this.list[i].money) <= this.moneyMax) {
                    this.list[i].checked = 1;
                    this.money = (Number(this.money) + Number(this.list[i].money)).toFixed(2);
                } else {
                    this.$func.showToast('单笔最高可提现 ' + this.moneyMax + ' 元');
                    return false;
                }
            }
        },

        // countMoney(){
        //     let that = this;
        //     this.money = 0;
        //     if(this.checkAllStatus){
        //         this.money = this.info.wait_withdraw;
        //     }else{
        //         that.list.forEach((item,index)=>{
        //             if(item.checked && Number(item.status) == 1){
        //                 that.money = (Number(that.money) + Number(item.money)).toFixed(2);
        //             }
        //         })
        //     }
        // },
        checkAll: function checkAll() {
            var _this = this;

            this.checkAllStatus = !this.checkAllStatus;
            this.money = 0;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    if (Number(_this.money) + Number(item.money) <= _this.moneyMax) {
                        item.checked = 1;
                        _this.money = (Number(_this.money) + Number(item.money)).toFixed(2);
                    } else {
                        item.checked = 0;
                    }
                });
                // this.money = this.info.wait_withdraw;
                // this.money = money;
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
            }
            // this.countMoney();
        },
        getList: function getList() {
            var _this2 = this;

            var that = this;
            // this.loadmoreText = '正在加载。。。';
            switch (parseInt(that.isActive)) {
                case 1:
                    this.$api.withdrawList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                if (_this2.checkAllWithdraw) {
                                    item.checked = 1;
                                } else {
                                    if (_this2.checkAllStatus) {
                                        if (Number(_this2.money) + Number(item.money) <= _this2.moneyMax) {
                                            _this2.money = (Number(_this2.money) + Number(item.money)).toFixed(2);
                                            item.checked = 1;
                                        }
                                    }
                                }
                                _this2.list.push(item);
                            });
                            // this.checkAllStatus = false;
                        }
                    });
                    break;
                default:
                    this.$api.withdrawRecord({ last_id: this.lastId, page_flag: this.pageFlag, type: 0 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        withdrawMoney: function withdrawMoney() {
            var _this3 = this;

            this.$api.withdrawMoney({}).then(function (res) {
                if (res) {
                    _this3.info = res.data;
                }
            });
        },
        allWithdraw: function allWithdraw() {
            if (this.info.wait_withdraw <= this.moneyMax) {
                this.money = Number(this.info.wait_withdraw).toFixed(2);
                this.checkAllWithdraw = 1;
                this.checkAllStatus = 1;
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
            } else {
                this.$func.showToast('可提现金额大于单次提现限额，请手动选择提现订单');
            }
        },
        withdraw: function withdraw() {
            if (this.money <= 0) {
                this.$func.showToast('请选择提现订单');
                return false;
            }
            if (this.money > this.moneyMax) {
                this.$func.showToast('单次提现限额' + this.moneyMax + '元');
                return false;
            }
            var ids = '';
            if (Number(this.money) != Number(this.info.wait_withdraw)) {
                this.list.forEach(function (item, index) {
                    if (item.checked && Number(item.status) == 1) {
                        ids += item.id + ',';
                    }
                });
            }
            // if(!this.checkAllStatus){

            // }
            // if(!ids){
            //     this.$func.showToast('请选择提现订单');
            //     return false;
            // }
            this.$router.push({ path: '/withdraw', query: { ids: ids, type: 0 } });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_withdrawRecord = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            height: '100%',
            isActive: 1,
            checkAllStatus: 0,
            checkAllWithdraw: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            types: [{
                'key': 0,
                'text': '提现记录'
            }, {
                'key': 1,
                'text': '可提现订单'
            }],
            info: {
                wait_withdraw: 0.00,
                total_withdraw: 0.00
            },
            moneyMax: 5000
            // countMoney:0
        };
    },
    mounted: function mounted() {
        // this.getList();
        this.withdrawMoney();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.list = [];
            this.where = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.money = (Number(this.money) - Number(this.list[i].money)).toFixed(2);
                this.list[i].checked = 0;
            } else {
                if (Number(this.money) + Number(this.list[i].money) <= this.moneyMax) {
                    this.list[i].checked = 1;
                    this.money = (Number(this.money) + Number(this.list[i].money)).toFixed(2);
                } else {
                    this.$func.showToast('单笔最高可提现 ' + this.moneyMax + ' 元');
                    return false;
                }
            }
        },

        // countMoney(){
        //     let that = this;
        //     this.money = 0;
        //     if(this.checkAllStatus){
        //         this.money = this.info.wait_withdraw;
        //     }else{
        //         that.list.forEach((item,index)=>{
        //             if(item.checked && Number(item.status) == 1){
        //                 that.money = (Number(that.money) + Number(item.money)).toFixed(2);
        //             }
        //         })
        //     }
        // },
        checkAll: function checkAll() {
            var _this = this;

            this.checkAllStatus = !this.checkAllStatus;
            this.money = 0;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    if (Number(_this.money) + Number(item.money) <= _this.moneyMax) {
                        item.checked = 1;
                        _this.money = (Number(_this.money) + Number(item.money)).toFixed(2);
                    } else {
                        item.checked = 0;
                    }
                });
                // this.money = this.info.wait_withdraw;
                // this.money = money;
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
            }
            // this.countMoney();
        },
        getList: function getList() {
            var _this2 = this;

            var that = this;
            // this.loadmoreText = '正在加载。。。';
            switch (parseInt(that.isActive)) {
                case 1:
                    this.$api.withdrawList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                if (_this2.checkAllWithdraw) {
                                    item.checked = 1;
                                } else {
                                    if (_this2.checkAllStatus) {
                                        if (Number(_this2.money) + Number(item.money) <= _this2.moneyMax) {
                                            _this2.money = (Number(_this2.money) + Number(item.money)).toFixed(2);
                                            item.checked = 1;
                                        }
                                    }
                                }
                                _this2.list.push(item);
                            });
                            // this.checkAllStatus = false;
                        }
                    });
                    break;
                default:
                    this.$api.withdrawRecord({ last_id: this.lastId, page_flag: this.pageFlag, type: 0 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        withdrawMoney: function withdrawMoney() {
            var _this3 = this;

            this.$api.withdrawMoney({}).then(function (res) {
                if (res) {
                    _this3.info = res.data;
                }
            });
        },
        allWithdraw: function allWithdraw() {
            if (this.info.wait_withdraw <= this.moneyMax) {
                this.money = Number(this.info.wait_withdraw).toFixed(2);
                this.checkAllWithdraw = 1;
                this.checkAllStatus = 1;
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
            } else {
                this.$func.showToast('可提现金额大于单次提现限额，请手动选择提现订单');
            }
        },
        withdraw: function withdraw() {
            if (this.money <= 0) {
                this.$func.showToast('请选择提现订单');
                return false;
            }
            if (this.money > this.moneyMax) {
                this.$func.showToast('单次提现限额' + this.moneyMax + '元');
                return false;
            }
            var ids = '';
            if (Number(this.money) != Number(this.info.wait_withdraw)) {
                this.list.forEach(function (item, index) {
                    if (item.checked && Number(item.status) == 1) {
                        ids += item.id + ',';
                    }
                });
            }
            // if(!this.checkAllStatus){

            // }
            // if(!ids){
            //     this.$func.showToast('请选择提现订单');
            //     return false;
            // }
            this.$router.push({ path: '/withdraw', query: { ids: ids, type: 0 } });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c377e28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/withdrawRecord.vue
var withdrawRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-border-radius-6 cm-p-tb-16 cm-pf",staticStyle:{"height":"154px","top":"0","z-index":"100"}},[_c('div',{staticClass:" cm-flex-between cm-flex-middle cm-p-lr-16"},[_c('div',[_c('p',{staticClass:"cm-fn-12 cm-fn-weight-min cm-color-666"},[_vm._v("提现金额")]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-10 cm-fn-36 cm-color-red"},[_vm._v(_vm._s(_vm.money))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-yellow ",staticStyle:{"border-radius":"16px"},on:{"click":_vm.checkAll}},[_vm._v(_vm._s(_vm.checkAllStatus ? '全不选' : '全选'))]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-red cm-m-l-16",staticStyle:{"border-radius":"16px"},on:{"click":function($event){return _vm.withdraw()}}},[_vm._v("提现")])])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-middle cm-flex-between cm-p-lr-16"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("可提现")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-m-l-8"},[_vm._v("￥"+_vm._s(_vm.info.wait_withdraw))]),_vm._v(" "),(_vm.info.wait_withdraw <= _vm.moneyMax)?_c('p',{staticClass:"cm-color-blue cm-m-l-4",on:{"click":function($event){return _vm.allWithdraw()}}},[_vm._v("全部提现")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("累计提现")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-color-green cm-m-l-8"},[_vm._v("￥"+_vm._s(_vm.info.total_withdraw))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-p-lr-16"},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("单次提现限额 "),_c('span',{staticClass:"cm-fn-18 cm-color-red"},[_vm._v(_vm._s(_vm.moneyMax))]),_vm._v(" 元")])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-tb-8 cm-flex-middle cm-flex-around",staticStyle:{"border-bottom":"1px solid #eee","height":"27px"}},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-fn-16 cm-color-666",class:[_vm.isActive == index ? 'active' : ''],on:{"click":function($event){return _vm.select(index)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank',{staticClass:"cm-m-t-40",attrs:{"blankStyle":_vm.height}}):_vm._e(),_vm._v(" "),(!_vm.isActive)?_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"50"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-p-tb-8 cm-flex-middle cm-flex-between cm-bg-white cm-m-t-4 cm-p-lr-12"},[_c('div',[_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-fn-weight-min cm-fn-12 cm-color-txt2"},[_vm._v(" "+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-fn-20  cm-color-orange"},[_vm._v("￥"+_vm._s(item.money))])])}),0):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-8 cm-bg-white cm-flex-middle cm-flex-start",on:{"click":function($event){return _vm.check(index)}}},[_c('div',{staticClass:"cm-p-tb-16 cm-center",staticStyle:{"width":"8%"}},[_c('img',{staticClass:"cm-icon-22 cm-m-l-8",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"89%"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.order.order_no)+" ")]),_vm._v(" "),(item.factory_wash_code)?_c('p',{staticClass:"cm-color-block cm-fn-12  cm-fn-weight-default"},[_vm._v(_vm._s(item.factory_wash_code))]):_vm._e()]),_vm._v(" "),(item.order_type > 0)?_c('p',{staticClass:" cm-center cm-color-blue"},[_vm._v("社区订单")]):_c('p',{staticClass:" cm-center cm-color-green"},[_vm._v("菜鸟订单")])]),_vm._v(" "),(item.order_type > 0)?_c('div',[(item.goods.length > 1)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-16 cm-p-lr-12"},_vm._l((item.goods),function(val,key){return (key < 4)?_c('div',{key:key,staticClass:"image cm-img-box  cm-m-l-8"},[_c('img',{attrs:{"src":val.goods.pic}})]):_vm._e()}),0):_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.goods[0].goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"info cm-m-l-16"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.goods[0].goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-red"},[_vm._v("￥"+_vm._s(item.goods[0].price))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.goods[0].num))])])])]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.taocan))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.order.shuliang))])])])]),_vm._v(" "),(item.order_type > 0)?_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-12 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('p',{staticClass:"cm-color-666 cm-m-l-4 cm-center cm-m-r-12"},[_vm._v("实付：￥"+_vm._s(item.order.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])]):_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-4 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var withdrawRecord_staticRenderFns = []
var withdrawRecord_esExports = { render: withdrawRecord_render, staticRenderFns: withdrawRecord_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_withdrawRecord = (withdrawRecord_esExports);
// CONCATENATED MODULE: ./src/pages/withdrawRecord.vue
function withdrawRecord_injectStyle (ssrContext) {
  __webpack_require__("LgKc")
}
var withdrawRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var withdrawRecord___vue_template_functional__ = false
/* styles */
var withdrawRecord___vue_styles__ = withdrawRecord_injectStyle
/* scopeId */
var withdrawRecord___vue_scopeId__ = "data-v-7c377e28"
/* moduleIdentifier (server only) */
var withdrawRecord___vue_module_identifier__ = null
var withdrawRecord_Component = withdrawRecord_normalizeComponent(
  selectortype_script_index_0_src_pages_withdrawRecord,
  selectortype_template_index_0_src_pages_withdrawRecord,
  withdrawRecord___vue_template_functional__,
  withdrawRecord___vue_styles__,
  withdrawRecord___vue_scopeId__,
  withdrawRecord___vue_module_identifier__
)

/* harmony default export */ var src_pages_withdrawRecord = (withdrawRecord_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/wareHouse.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_wareHouse = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      order_no: '',
      order: {
        factory: [],
        goods_num: 0
      },
      num: 0,
      submitStatus: false,
      pop: false,
      inputCode: ''
    };
  },
  created: function created() {
    this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              // if(that.id <= 0){
              // that.$func.showToast(11);
              if (res.resultStr.indexOf(",") != -1) {
                that.order_no = res.resultStr.split(',')[1];
              } else {
                that.order_no = res.resultStr;
              }
              that.getOrder();
              // }else{
              //   // that.$func.showToast(22);
              //   let code = res.resultStr.split(',')[1];
              //   // that.$func.showToast(code);
              //   that.factoryHouse(code,1);
              // }
            }, 1000);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      this.order = {};
      this.submitStatus = false;
      if (!this.order_no || this.order_no.length != 23) {
        this.$func.showToast('订单号无效');
        return;
      }
      this.$api.getOrder({ order_no: this.order_no }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.num = res.data.num;
          _this.order = res.data;
          _this.submitStatus = true;

          // if(this.num >= this.order.goods_num){
          //   this.submitStatus = true;
          // }
        }
      });
    },
    factoryHouse: function factoryHouse(code, status) {
      var _this2 = this;

      var that = this;
      if (isNaN(code)) {
        that.$func.showToast('子订单码无效');
        return;
      }
      if (code.length != 12) {
        that.$func.showToast('子订单码无效');
        return;
      }
      this.$api.factoryHouse({ id: this.id, code: code, status: status }).then(function (res) {
        if (res) {
          _this2.pop = false;
          that.order.factory.forEach(function (item, index) {
            if (item.factory_wash_code == code) {
              if (item.status == 0) {
                item.status = 1;
                if (that.num < that.order.goods_num) {
                  that.num = Number(that.num) + 1;
                  if (that.num == that.order.goods_num) {
                    that.submitStatus = true;
                  }
                } else {
                  that.submitStatus = true;
                }
                that.$forceUpdate();
              }
              return;
            }
          });
        }
      });
    },
    changePop: function changePop() {
      this.pop = !this.pop;
    },
    eventInputCode: function eventInputCode() {
      this.factoryHouse(this.inputCode, 2);
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.id) {
        this.$func.showToast('订单号不存在，请扫码');
        return false;
      }
      this.$api.wareHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this3.$func.showToast('入库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this3.id = 0;
            _this3.order_no = '';
            _this3.num = 0;
            _this3.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/wareHouse.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_wareHouse = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      order_no: '',
      order: {
        factory: [],
        goods_num: 0
      },
      num: 0,
      submitStatus: false,
      pop: false,
      inputCode: ''
    };
  },
  created: function created() {
    this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              // if(that.id <= 0){
              // that.$func.showToast(11);
              if (res.resultStr.indexOf(",") != -1) {
                that.order_no = res.resultStr.split(',')[1];
              } else {
                that.order_no = res.resultStr;
              }
              that.getOrder();
              // }else{
              //   // that.$func.showToast(22);
              //   let code = res.resultStr.split(',')[1];
              //   // that.$func.showToast(code);
              //   that.factoryHouse(code,1);
              // }
            }, 1000);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      this.order = {};
      this.submitStatus = false;
      if (!this.order_no || this.order_no.length != 23) {
        this.$func.showToast('订单号无效');
        return;
      }
      this.$api.getOrder({ order_no: this.order_no }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.num = res.data.num;
          _this.order = res.data;
          _this.submitStatus = true;

          // if(this.num >= this.order.goods_num){
          //   this.submitStatus = true;
          // }
        }
      });
    },
    factoryHouse: function factoryHouse(code, status) {
      var _this2 = this;

      var that = this;
      if (isNaN(code)) {
        that.$func.showToast('子订单码无效');
        return;
      }
      if (code.length != 12) {
        that.$func.showToast('子订单码无效');
        return;
      }
      this.$api.factoryHouse({ id: this.id, code: code, status: status }).then(function (res) {
        if (res) {
          _this2.pop = false;
          that.order.factory.forEach(function (item, index) {
            if (item.factory_wash_code == code) {
              if (item.status == 0) {
                item.status = 1;
                if (that.num < that.order.goods_num) {
                  that.num = Number(that.num) + 1;
                  if (that.num == that.order.goods_num) {
                    that.submitStatus = true;
                  }
                } else {
                  that.submitStatus = true;
                }
                that.$forceUpdate();
              }
              return;
            }
          });
        }
      });
    },
    changePop: function changePop() {
      this.pop = !this.pop;
    },
    eventInputCode: function eventInputCode() {
      this.factoryHouse(this.inputCode, 2);
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.id) {
        this.$func.showToast('订单号不存在，请扫码');
        return false;
      }
      this.$api.wareHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this3.$func.showToast('入库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this3.id = 0;
            _this3.order_no = '';
            _this3.num = 0;
            _this3.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0635cf84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wareHouse.vue
var wareHouse_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white"},[_c('div',{staticClass:"cm-p-t-12 cm-p-lr-8 cm-flex-start cm-flex-middle cm-w-100"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单号：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_no),expression:"order_no"}],staticClass:"cm-fn-18 cm-color-red cm-m-l-4 cm-bg-gray cm-p-tb-2 cm-p-lr-4 cm-border-radius-4",staticStyle:{"width":"73%"},attrs:{"type":"text","placeholder":"输入订单号或扫码(订单列表可复制单号)"},domProps:{"value":(_vm.order_no)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.order_no=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-12"},[_c('p',{staticClass:"cm-p-t-4  cm-color-666"},[_vm._v("共"),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-m-l-4 cm-m-r-4"},[_vm._v(" "+_vm._s(_vm.order.goods_num)+" ")]),_vm._v("件")])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-lr-8 cm-p-t-12"},_vm._l((_vm.order.factory),function(item,index){return _c('li',{key:index,staticClass:"cm-pr"},[_c('div',{staticClass:"cm-img-box image cm-bg-gray"},[_c('img',{attrs:{"src":item.img}})]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-text-center"},[_vm._v(_vm._s(item.factory_wash_code))]),_vm._v(" "),_c('div',{staticClass:"cm-pa title-div",class:item.status > 0 ? 'cm-bg-blue' : 'cm-bg-block'}),_vm._v(" "),_c('div',{staticClass:"cm-pa title cm-text-center"},[_c('p',{staticClass:"cm-color-white overflow-line-1"},[_vm._v(_vm._s(item.status > 0 ? '已入库' : _vm.order.community.name))])])])}),0),_vm._v(" "),_c('div',{staticClass:"footer"},[(_vm.submitStatus)?_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_vm._v("\n          本订单"),_c('span',{staticClass:"cm-color-red cm-fn-14"},[_vm._v(" "+_vm._s(_vm.order.goods_num)+" ")]),_vm._v("件商品已收齐\n        ")]):_c('div',{staticClass:"cm-text-center cm-p-tb-12"}),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-flex-around cm-m-t-12 ",staticStyle:{"height":"50px"}},[_c('div',{staticClass:"cm-bg-blue cm-center cm-h-100 cm-p-lr-40 cm-border-radius-4",on:{"click":function($event){return _vm.scanQRCode()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("扫码")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center cm-h-100 cm-p-lr-40 cm-border-radius-4",style:({opacity: !_vm.submitStatus ? '0.5' : '1'}),on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("入库")])])])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}}),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"pop"}):_vm._e(),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"cm-border-radius-4",staticStyle:{"position":"absolute","width":"80%","height":"250px","margin-left":"10%","margin-top":"45%","background-color":"#FFF","z-index":"100"}},[_c('div',{staticClass:"cm-p-lr-12 cm-h-100"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-m-t-28"},[_c('p',{staticClass:"cm-p-tb-12 cm-fn-16"},[_vm._v("子订单码：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputCode),expression:"inputCode"}],staticClass:"cm-p-tb-2 cm-p-lr-12 cm-fn-18 cm-border-bottom-1",staticStyle:{"width":"55%"},attrs:{"type":"number","value":"","oninput":"if(value.length > 12)value=value.slice(0,12)"},domProps:{"value":(_vm.inputCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-around cm-flex-middle cm-p-tb-12 cm-m-t-24 buttom"},[_c('div',{staticClass:"cm-p-tb-12 cm-p-lr-40 cm-bg-orange cm-border-radius-4 cm-center cm-fn-16 cm-color-white",on:{"click":function($event){return _vm.eventInputCode()}}},[_vm._v("确定")])])]),_vm._v(" "),_c('img',{staticClass:"cm-icon-16 cm-pa",staticStyle:{"right":"5px","top":"15px"},attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.changePop()}}})]):_vm._e()])}
var wareHouse_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-center cm-p-tb-16"},[_c('p',{staticClass:"cm-fn-20"},[_vm._v("录入子订单码")])])}]
var wareHouse_esExports = { render: wareHouse_render, staticRenderFns: wareHouse_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_wareHouse = (wareHouse_esExports);
// CONCATENATED MODULE: ./src/pages/wareHouse.vue
function wareHouse_injectStyle (ssrContext) {
  __webpack_require__("Fhl0")
}
var wareHouse_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var wareHouse___vue_template_functional__ = false
/* styles */
var wareHouse___vue_styles__ = wareHouse_injectStyle
/* scopeId */
var wareHouse___vue_scopeId__ = "data-v-0635cf84"
/* moduleIdentifier (server only) */
var wareHouse___vue_module_identifier__ = null
var wareHouse_Component = wareHouse_normalizeComponent(
  selectortype_script_index_0_src_pages_wareHouse,
  selectortype_template_index_0_src_pages_wareHouse,
  wareHouse___vue_template_functional__,
  wareHouse___vue_styles__,
  wareHouse___vue_scopeId__,
  wareHouse___vue_module_identifier__
)

/* harmony default export */ var src_pages_wareHouse = (wareHouse_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outHouse.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_outHouse = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order_no: '',
      order: {},
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode', 'qrCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.order_no = res.resultStr.split(',')[1];
              } else {
                that.order_no = res.resultStr;
              }
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      if (!this.order_no) {
        this.$func.showToast('请输入手机号|取衣码|订单号');
        return;
      }
      this.$api.getOutOrder({ code: this.order_no }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.order = res.data;
          _this.submitStatus = true;
        }
      });
    },
    getOutOrder: function getOutOrder() {
      var _this2 = this;

      if (!this.code || this.code.length != 6) {
        this.$func.showToast('取衣码无效');
        return;
      }
      this.$api.getOutOrder({ code: this.code }).then(function (res) {
        if (res) {
          _this2.id = res.data.id;
          _this2.order = res.data;
          _this2.submitStatus = true;
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.id) {
        this.$func.showToast('出库订单不存在');
        return false;
      }
      this.$api.outHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this3.$func.showToast('出库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this3.id = 0;
            _this3.order = {};
            _this3.code = '';
            _this3.order_no = '';
            _this3.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outHouse.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_outHouse = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order_no: '',
      order: {},
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode', 'qrCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.order_no = res.resultStr.split(',')[1];
              } else {
                that.order_no = res.resultStr;
              }
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      if (!this.order_no) {
        this.$func.showToast('请输入手机号|取衣码|订单号');
        return;
      }
      this.$api.getOutOrder({ code: this.order_no }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.order = res.data;
          _this.submitStatus = true;
        }
      });
    },
    getOutOrder: function getOutOrder() {
      var _this2 = this;

      if (!this.code || this.code.length != 6) {
        this.$func.showToast('取衣码无效');
        return;
      }
      this.$api.getOutOrder({ code: this.code }).then(function (res) {
        if (res) {
          _this2.id = res.data.id;
          _this2.order = res.data;
          _this2.submitStatus = true;
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.id) {
        this.$func.showToast('出库订单不存在');
        return false;
      }
      this.$api.outHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this3.$func.showToast('出库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this3.id = 0;
            _this3.order = {};
            _this3.code = '';
            _this3.order_no = '';
            _this3.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e435951","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/outHouse.vue
var outHouse_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white"},[_c('div',{staticClass:"cm-p-t-8"},[_c('div',{staticClass:"cm-fn-14 cm-p-tb-12 cm-text-left cm-m-t-16 shadow-gray cm-m-lr-12 cm-p-lr-8"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default"},[_vm._v("衣物出库")]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-8 cm-w-100"},[_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_no),expression:"order_no"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 cm-w-100",attrs:{"type":"text","placeholder":"请输入手机号|取衣码|订单号"},domProps:{"value":(_vm.order_no)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.order_no=$event.target.value}}}),_vm._v(" "),(_vm.order_no)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.order_no = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-8 cm-flex-between cm-flex-middle cm-m-t-40"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-fn-20"},[_vm._v(_vm._s(_vm.order.phone)+" "+_vm._s(_vm.order.name))]),_vm._v(" "),_c('p',{staticClass:" cm-color-666"},[_vm._v("订单号："+_vm._s(_vm.order.order_no))])]),_vm._v(" "),_c('div',[_vm._v("\n          共"),_c('span',{staticClass:"cm-fn-20"},[_vm._v(" "+_vm._s(_vm.order.goods_num)+" ")]),_vm._v("件\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-lr-8 cm-p-t-12"},_vm._l((_vm.order.factory),function(item,index){return _c('li',{key:index,staticClass:"cm-pr"},[_c('div',{staticClass:"cm-img-box image cm-bg-gray"},[_c('img',{attrs:{"src":item.img}})]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-text-center"},[_vm._v(_vm._s(item.factory_wash_code))]),_vm._v(" "),_c('div',{staticClass:"cm-pa title-div cm-bg-block"}),_vm._v(" "),_c('div',{staticClass:"cm-pa title cm-text-center"},[_c('p',{staticClass:"cm-color-white overflow-line-1"},[_vm._v(_vm._s(_vm.order.community.name))])])])}),0),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"cm-w-100 cm-flex-around cm-m-t-12",staticStyle:{"height":"50px"}},[_c('div',{staticClass:"cm-bg-blue cm-center cm-h-100 cm-w-100",style:({opacity: !_vm.submitStatus ? '0.6' : '1'}),on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认出库")])])])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])])}
var outHouse_staticRenderFns = []
var outHouse_esExports = { render: outHouse_render, staticRenderFns: outHouse_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_outHouse = (outHouse_esExports);
// CONCATENATED MODULE: ./src/pages/outHouse.vue
function outHouse_injectStyle (ssrContext) {
  __webpack_require__("E39w")
}
var outHouse_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var outHouse___vue_template_functional__ = false
/* styles */
var outHouse___vue_styles__ = outHouse_injectStyle
/* scopeId */
var outHouse___vue_scopeId__ = "data-v-1e435951"
/* moduleIdentifier (server only) */
var outHouse___vue_module_identifier__ = null
var outHouse_Component = outHouse_normalizeComponent(
  selectortype_script_index_0_src_pages_outHouse,
  selectortype_template_index_0_src_pages_outHouse,
  outHouse___vue_template_functional__,
  outHouse___vue_styles__,
  outHouse___vue_scopeId__,
  outHouse___vue_module_identifier__
)

/* harmony default export */ var src_pages_outHouse = (outHouse_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_group = ({
  name: 'group',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      code: '',
      info: {
        nickname: '未登录',
        head: '/static/images/head.png',
        other_title: '',
        address: ''
      },
      order: {
        today_amount: 0.00,
        total_amount: 0.00,
        total_rebate: 0.00,
        today_rebate: 0.00,
        today_order: 0
      }
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    // getCode(){
    //   var local = window.location.href
    //   var appid = 'wx319f232455d7da71' 
    //   this.code = this.getUrlCode().code 
    //   if (this.code == null || this.code === '') {
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    //   } else {
    //     this.login();
    //   }
    // },
    // getUrlCode() {
    //   var url = location.search
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //       var str = url.substr(1)
    //       var strs = str.split("&")
    //       for(var i = 0; i < strs.length; i++) {
    //           theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
    //       }
    //   }
    //   return theRequest
    // },
    // login(){
    //     this.$api.login({code:this.code}).then((res)=>{
    //       if(res){
    //         console.log(res);
    //         this.$func.setLocal('token',res.data.token);
    //         this.getInfo();
    //       }
    //     })  
    // },
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this.$router.push({ path: '/login' });
            return false;
          }
          _this.info = res.data;
          _this.groupRebate();
        }
      });
    },
    groupRebate: function groupRebate() {
      var _this2 = this;

      this.$api.groupRebate({}).then(function (res) {
        if (res) {
          _this2.order = res.data;
        }
      });
    },
    out: function out() {
      var _this3 = this;

      this.$func.confirm('确认退出账号？', '温馨提示', function () {
        _this3.$api.out({}).then(function (res) {
          if (res) {
            // this.$func.setSession('token','');
            // this.$func.setLocal('token','');
            _this3.$router.push({ path: '/login' });
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_group = ({
  name: 'group',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      code: '',
      info: {
        nickname: '未登录',
        head: '/static/images/head.png',
        other_title: '',
        address: ''
      },
      order: {
        today_amount: 0.00,
        total_amount: 0.00,
        total_rebate: 0.00,
        today_rebate: 0.00,
        today_order: 0
      }
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    // getCode(){
    //   var local = window.location.href
    //   var appid = 'wx319f232455d7da71' 
    //   this.code = this.getUrlCode().code 
    //   if (this.code == null || this.code === '') {
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    //   } else {
    //     this.login();
    //   }
    // },
    // getUrlCode() {
    //   var url = location.search
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //       var str = url.substr(1)
    //       var strs = str.split("&")
    //       for(var i = 0; i < strs.length; i++) {
    //           theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
    //       }
    //   }
    //   return theRequest
    // },
    // login(){
    //     this.$api.login({code:this.code}).then((res)=>{
    //       if(res){
    //         console.log(res);
    //         this.$func.setLocal('token',res.data.token);
    //         this.getInfo();
    //       }
    //     })  
    // },
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this.$router.push({ path: '/login' });
            return false;
          }
          _this.info = res.data;
          _this.groupRebate();
        }
      });
    },
    groupRebate: function groupRebate() {
      var _this2 = this;

      this.$api.groupRebate({}).then(function (res) {
        if (res) {
          _this2.order = res.data;
        }
      });
    },
    out: function out() {
      var _this3 = this;

      this.$func.confirm('确认退出账号？', '温馨提示', function () {
        _this3.$api.out({}).then(function (res) {
          if (res) {
            // this.$func.setSession('token','');
            // this.$func.setLocal('token','');
            _this3.$router.push({ path: '/login' });
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4baed4d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/group.vue
var pages_group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-w-100",staticStyle:{"height":"155px","background":"#DAFEF0"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-p-lr-20 cm-flex-start cm-flex-middle cm-p-t-24"},[_c('div',{staticClass:"cm-img-box head cm-border-radius"},[_c('img',{attrs:{"src":_vm.info.head}})]),_vm._v(" "),(_vm.info.token)?_c('div',{staticClass:"cm-m-l-8 cm-text-left"},[_c('p',{staticClass:"cm-fn-weight-max cm-fn-16"},[_vm._v(_vm._s(_vm.info.nickname))]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-border-radius-12 cm-m-t-4",staticStyle:{"background":"#382C34","padding":"1px 8px"}},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/groupCenterIcon.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-m-l-4",staticStyle:{"color":"#D0C9CF"}},[_vm._v(_vm._s(_vm.info.grade_title))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('img',{staticClass:"cm-icon-22 cm-m-r-12",attrs:{"src":"/static/images/out.png"},on:{"click":function($event){return _vm.out()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-16 cm-text-left cm-m-t-8"},[_c('p',{staticClass:"cm-fn-14 cm-m-t-12"},[_vm._v(_vm._s(_vm.info.other_title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12"},[_vm._v(_vm._s(_vm.info.address))])])]),_vm._v(" "),(_vm.info.grade == 2)?_c('div',{staticClass:"cm-w-100 cm-pr",staticStyle:{"height":"117px"}},[_c('div',{staticClass:"cm-p-tb-12 cm-border-radius-10  shadow-gray",staticStyle:{"width":"100%","position":"absolute","top":"-20px","left":"0","background-color":"#fff"}},[_c('div',{staticClass:"cm-p-lr-16"},[_c('div',{staticClass:" cm-p-tb-16 cm-border-radius-6 cm-flex-middle cm-flex-around"},[_c('router-link',{staticClass:"cm-text-center",attrs:{"to":"/groupOrder"}},[_c('p',{staticClass:"cm-fn-12"},[_vm._v("今日营业额")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-22 cm-color-red cm-fn-bold"},[_vm._v(_vm._s(_vm.order.today_amount))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v("累计营业额 "),_c('span',{staticClass:"cm-color-red cm-fn-16"},[_vm._v(_vm._s(_vm.order.total_amount))]),_vm._v(" 元")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"1px","height":"36px","background-color":"#D4A823"}}),_vm._v(" "),_c('router-link',{staticClass:"cm-text-center",attrs:{"to":"/groupOrder"}},[_c('p',{staticClass:"cm-fn-12 "},[_vm._v("今日订单")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-22 cm-color-red cm-fn-bold"},[_vm._v(_vm._s(_vm.order.today_order))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v("查看全部订单 >")])])],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-t-12",staticStyle:{"padding-bottom":"100px"}},[_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/secondCommunity"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("下级团长")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]),_vm._v(" "),(_vm.info.grade == 2)?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/groupRebate"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("收益记录")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.info.grade == 2)?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/withdrawRecord"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("收益提现")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e(),_vm._v(" "),(_vm.info.grade == 1)?_c('router-link',{staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":"/groupOrder"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v("全部订单")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})]):_vm._e()],1)])}
var pages_group_staticRenderFns = []
var pages_group_esExports = { render: pages_group_render, staticRenderFns: pages_group_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_group = (pages_group_esExports);
// CONCATENATED MODULE: ./src/pages/group.vue
function pages_group_injectStyle (ssrContext) {
  __webpack_require__("Tl4D")
}
var pages_group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pages_group___vue_template_functional__ = false
/* styles */
var pages_group___vue_styles__ = pages_group_injectStyle
/* scopeId */
var pages_group___vue_scopeId__ = "data-v-4baed4d4"
/* moduleIdentifier (server only) */
var pages_group___vue_module_identifier__ = null
var pages_group_Component = pages_group_normalizeComponent(
  selectortype_script_index_0_src_pages_group,
  selectortype_template_index_0_src_pages_group,
  pages_group___vue_template_functional__,
  pages_group___vue_styles__,
  pages_group___vue_scopeId__,
  pages_group___vue_module_identifier__
)

/* harmony default export */ var src_pages_group = (pages_group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driver.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var driver = ({
  name: 'driver',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      info: {},
      nav: [{
        title: '取件',
        path: '/pickup',
        auth: 'pickup',
        img: '/static/images/pickup.png'
      }, {
        title: '出厂',
        path: '/outFactory',
        auth: 'outFactory',
        img: '/static/images/out_factory.png'
      }, {
        title: '到站',
        path: '/arrival',
        auth: 'arrival',
        img: '/static/images/arrival.png'
      }, {
        title: '待取件',
        path: '/waitPickup/0',
        auth: 'waitPickup',
        img: '/static/images/wait_pickup.png'
      }, {
        title: '已取件',
        path: '/pickuped',
        auth: 'pickuped',
        img: '/static/images/pickuped.png'
      }, {
        title: '已到站',
        path: '/arrivaled',
        auth: 'arrivaled',
        img: '/static/images/arrivaled.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '订单查询',
        path: '/searchOrder',
        auth: 'searchOrder',
        img: '/static/images/searchOrder.png'
      }, {
        title: '修改扎带码',
        path: '/editBag',
        auth: 'editBag',
        img: '/static/images/feedback.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.driverData({}).then(function (res) {
        _this.info = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driver.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_driver = ({
  name: 'driver',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      info: {},
      nav: [{
        title: '取件',
        path: '/pickup',
        auth: 'pickup',
        img: '/static/images/pickup.png'
      }, {
        title: '出厂',
        path: '/outFactory',
        auth: 'outFactory',
        img: '/static/images/out_factory.png'
      }, {
        title: '到站',
        path: '/arrival',
        auth: 'arrival',
        img: '/static/images/arrival.png'
      }, {
        title: '待取件',
        path: '/waitPickup/0',
        auth: 'waitPickup',
        img: '/static/images/wait_pickup.png'
      }, {
        title: '已取件',
        path: '/pickuped',
        auth: 'pickuped',
        img: '/static/images/pickuped.png'
      }, {
        title: '已到站',
        path: '/arrivaled',
        auth: 'arrivaled',
        img: '/static/images/arrivaled.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '订单查询',
        path: '/searchOrder',
        auth: 'searchOrder',
        img: '/static/images/searchOrder.png'
      }, {
        title: '修改扎带码',
        path: '/editBag',
        auth: 'editBag',
        img: '/static/images/feedback.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.driverData({}).then(function (res) {
        _this.info = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196142cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/driver.vue
var driver_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("物流端")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-around cm-flex-middle",staticStyle:{"margin-top":"45px"}},[(_vm.$func.checkAuth('waitPickup/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitPickup/0"}},[_c('p',{staticClass:"cm-fn-36 cm-color-orange"},[_vm._v(_vm._s(_vm.info.pick))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待取件 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('waitArrival'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitPickup/1"}},[_c('p',{staticClass:"cm-fn-36 cm-color-green"},[_vm._v(_vm._s(_vm.info.send))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待送衣物 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('waitArrival'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitPickup/1"}},[_c('p',{staticClass:"cm-fn-36 cm-color-green"},[_vm._v(_vm._s(_vm.info.sendGoods))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待送商品 >")])]):_vm._e()],1)]),_vm._v(" "),_c('ul',{staticClass:"ul2 cm-m-lr-8 cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle  cm-flex-wrap"},_vm._l((_vm.nav),function(item,index){return _c('router-link',{key:index,staticClass:"cm-text-center cm-p-tb-24 li",attrs:{"to":item.path}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":item.img}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v(_vm._s(item.title))])])}),1),_vm._v(" "),_c('cmFooter',{attrs:{"active":3}})],1)}
var driver_staticRenderFns = []
var driver_esExports = { render: driver_render, staticRenderFns: driver_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_driver = (driver_esExports);
// CONCATENATED MODULE: ./src/pages/driver.vue
function driver_injectStyle (ssrContext) {
  __webpack_require__("i8+u")
}
var driver_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var driver___vue_template_functional__ = false
/* styles */
var driver___vue_styles__ = driver_injectStyle
/* scopeId */
var driver___vue_scopeId__ = "data-v-196142cd"
/* moduleIdentifier (server only) */
var driver___vue_module_identifier__ = null
var driver_Component = driver_normalizeComponent(
  pages_driver,
  selectortype_template_index_0_src_pages_driver,
  driver___vue_template_functional__,
  driver___vue_styles__,
  driver___vue_scopeId__,
  driver___vue_module_identifier__
)

/* harmony default export */ var src_pages_driver = (driver_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupRebate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_groupRebate = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            isActive: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 0,
            lastId: 0
            // types:[
            //     {
            //         'key':0,
            //         'text':'社区收益',
            //     },
            //     {
            //         'key':1,
            //         'text':'分销收益',
            //     },
            // ],
        };
    },
    created: function created() {
        if (!this.$func.getLocal('token')) {
            window.location.href = "/#/group";
            return false;
        }
    },
    mounted: function mounted() {
        // this.getList();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.orderRebate({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupRebate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_groupRebate = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            isActive: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 0,
            lastId: 0
            // types:[
            //     {
            //         'key':0,
            //         'text':'社区收益',
            //     },
            //     {
            //         'key':1,
            //         'text':'分销收益',
            //     },
            // ],
        };
    },
    created: function created() {
        if (!this.$func.getLocal('token')) {
            window.location.href = "/#/group";
            return false;
        }
    },
    mounted: function mounted() {
        // this.getList();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.orderRebate({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d519569","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/groupRebate.vue
var groupRebate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray cm-p-b-16"},[_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.community.name))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.order_no))])]),_vm._v(" "),(item.status == 1)?_c('p',{staticClass:"cm-color-green cm-center"},[_vm._v(_vm._s(item.status_text))]):(item.status == 2)?_c('p',{staticClass:"cm-color-blue cm-center"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-color-red cm-center"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('div',[(item.goods.length > 1)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-16 cm-p-lr-12"},_vm._l((item.goods),function(val,key){return (key < 4)?_c('div',{key:key,staticClass:"image cm-img-box  cm-m-l-8"},[_c('img',{attrs:{"src":val.goods.pic}})]):_vm._e()}),0):_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.goods[0].goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"info cm-m-l-16"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.goods[0].goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-red"},[_vm._v("￥"+_vm._s(item.goods[0].price))]),_vm._v(" "),_c('p',{staticClass:"cm-color-999 cm-fn-12"},[_vm._v(_vm._s(item.goods[0].attr_title))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.goods[0].num))])])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-12 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('p',{staticClass:"cm-color-666 cm-m-l-12 cm-center cm-m-r-12"},[_vm._v("实付：￥"+_vm._s(item.order.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var groupRebate_staticRenderFns = []
var groupRebate_esExports = { render: groupRebate_render, staticRenderFns: groupRebate_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_groupRebate = (groupRebate_esExports);
// CONCATENATED MODULE: ./src/pages/groupRebate.vue
function groupRebate_injectStyle (ssrContext) {
  __webpack_require__("2SEM")
}
var groupRebate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var groupRebate___vue_template_functional__ = false
/* styles */
var groupRebate___vue_styles__ = groupRebate_injectStyle
/* scopeId */
var groupRebate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var groupRebate___vue_module_identifier__ = null
var groupRebate_Component = groupRebate_normalizeComponent(
  selectortype_script_index_0_src_pages_groupRebate,
  selectortype_template_index_0_src_pages_groupRebate,
  groupRebate___vue_template_functional__,
  groupRebate___vue_styles__,
  groupRebate___vue_scopeId__,
  groupRebate___vue_module_identifier__
)

/* harmony default export */ var src_pages_groupRebate = (groupRebate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var groupOrder = ({
    name: 'order',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            isActive: 0,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            name: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            statusArr: [{
                key: 0,
                text: '全部'
            }, {
                key: 2,
                text: '待收衣'
            }, {
                key: 3,
                text: '待司机取衣'
            }, {
                key: 6,
                text: '待送回'
            }, {
                key: 8,
                text: '待出库'
            }, {
                key: 9,
                text: '已完成'
            }]
        };
    },
    created: function created() {
        if (!this.$func.getLocal('token')) {
            window.location.href = "/";
            return false;
        }
        // this.isActive = Number(this.$route.params.i);
        // this.getCommunity();
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        selectStatus: function selectStatus(key) {
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, status: this.isActive, community_name: this.name, type: '1,2' }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        getCommunity: function getCommunity() {
            this.$api.getCommunity({}).then(function (res) {
                if (res) {}
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_groupOrder = ({
    name: 'order',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            isActive: 0,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            name: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            statusArr: [{
                key: 0,
                text: '全部'
            }, {
                key: 2,
                text: '待收衣'
            }, {
                key: 3,
                text: '待司机取衣'
            }, {
                key: 6,
                text: '待送回'
            }, {
                key: 8,
                text: '待出库'
            }, {
                key: 9,
                text: '已完成'
            }]
        };
    },
    created: function created() {
        if (!this.$func.getLocal('token')) {
            window.location.href = "/";
            return false;
        }
        // this.isActive = Number(this.$route.params.i);
        // this.getCommunity();
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        selectStatus: function selectStatus(key) {
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getOrderLists({ last_id: this.lastId, page_flag: this.pageFlag, status: this.isActive, community_name: this.name, type: '1,2' }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        getCommunity: function getCommunity() {
            this.$api.getCommunity({}).then(function (res) {
                if (res) {}
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf1637e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/groupOrder.vue
var groupOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"手机号/订单号/社区名称"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-b-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_vm._v(_vm._s(item.phone)+" "+_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-color-main cm-p-tb-2"},[_vm._v(_vm._s(item.community.name)+" "+_vm._s(item.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('p',{staticClass:" title cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-8 button"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-red cm-w-100 cm-center",attrs:{"href":'tel:'+item.community.head_phone}},[_vm._v("联系团长")])]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var groupOrder_staticRenderFns = []
var groupOrder_esExports = { render: groupOrder_render, staticRenderFns: groupOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_groupOrder = (groupOrder_esExports);
// CONCATENATED MODULE: ./src/pages/groupOrder.vue
function groupOrder_injectStyle (ssrContext) {
  __webpack_require__("z6pM")
}
var groupOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var groupOrder___vue_template_functional__ = false
/* styles */
var groupOrder___vue_styles__ = groupOrder_injectStyle
/* scopeId */
var groupOrder___vue_scopeId__ = "data-v-5cf1637e"
/* moduleIdentifier (server only) */
var groupOrder___vue_module_identifier__ = null
var groupOrder_Component = groupOrder_normalizeComponent(
  pages_groupOrder,
  selectortype_template_index_0_src_pages_groupOrder,
  groupOrder___vue_template_functional__,
  groupOrder___vue_styles__,
  groupOrder___vue_scopeId__,
  groupOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_groupOrder = (groupOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clearSession.vue
//
//
//
//
//
//

/* harmony default export */ var clearSession = ({
  name: 'clearSession',
  components: {},
  data: function data() {
    return {
      msg: ''
    };
  },
  created: function created() {
    this.$func.setLocal('token', '');
    this.$func.setLocal('node_v1', '');
    this.$func.setLocal('grade', '');
  },
  mounted: function mounted() {
    this.msg = '缓存清理成功';
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clearSession.vue
//
//
//
//
//
//

/* harmony default export */ var pages_clearSession = ({
  name: 'clearSession',
  components: {},
  data: function data() {
    return {
      msg: ''
    };
  },
  created: function created() {
    this.$func.setLocal('token', '');
    this.$func.setLocal('node_v1', '');
    this.$func.setLocal('grade', '');
  },
  mounted: function mounted() {
    this.msg = '缓存清理成功';
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548788c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clearSession.vue
var clearSession_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr cm-p-b-40"},[_c('p',[_vm._v(_vm._s(_vm.msg))])])}
var clearSession_staticRenderFns = []
var clearSession_esExports = { render: clearSession_render, staticRenderFns: clearSession_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clearSession = (clearSession_esExports);
// CONCATENATED MODULE: ./src/pages/clearSession.vue
function clearSession_injectStyle (ssrContext) {
  __webpack_require__("Im9W")
}
var clearSession_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clearSession___vue_template_functional__ = false
/* styles */
var clearSession___vue_styles__ = clearSession_injectStyle
/* scopeId */
var clearSession___vue_scopeId__ = "data-v-548788c2"
/* moduleIdentifier (server only) */
var clearSession___vue_module_identifier__ = null
var clearSession_Component = clearSession_normalizeComponent(
  pages_clearSession,
  selectortype_template_index_0_src_pages_clearSession,
  clearSession___vue_template_functional__,
  clearSession___vue_styles__,
  clearSession___vue_scopeId__,
  clearSession___vue_module_identifier__
)

/* harmony default export */ var src_pages_clearSession = (clearSession_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/storeApply.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_storeApply = ({
    components: {},
    data: function data() {
        return {
            fromData: {
                name: '',
                phone: '',
                store: '',
                address: ''
            }
        };
    },
    created: function created() {},

    methods: {
        submit: function submit() {
            var that = this;
            if (!this.fromData.name) {
                that.$func.showToast('请输入您的姓名');
                return false;
            }
            var reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
            if (!this.fromData.phone || !reg.test(this.fromData.phone)) {
                that.$func.showToast('请输入您的手机号');
                return false;
            }
            // if(!this.fromData.store){
            //     that.$func.showToast('请输入门店名称');
            //     return false;
            // }
            this.$api.storeApply(that.fromData).then(function (res) {
                if (res) {
                    that.$func.showToast('提交成功');
                    that.fromData.name = '';
                    that.fromData.phone = '';
                    that.fromData.store = '';
                    that.fromData.address = '';
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/storeApply.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_pages_storeApply = ({
    components: {},
    data: function data() {
        return {
            fromData: {
                name: '',
                phone: '',
                store: '',
                address: ''
            }
        };
    },
    created: function created() {},

    methods: {
        submit: function submit() {
            var that = this;
            if (!this.fromData.name) {
                that.$func.showToast('请输入您的姓名');
                return false;
            }
            var reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
            if (!this.fromData.phone || !reg.test(this.fromData.phone)) {
                that.$func.showToast('请输入您的手机号');
                return false;
            }
            // if(!this.fromData.store){
            //     that.$func.showToast('请输入门店名称');
            //     return false;
            // }
            this.$api.storeApply(that.fromData).then(function (res) {
                if (res) {
                    that.$func.showToast('提交成功');
                    that.fromData.name = '';
                    that.fromData.phone = '';
                    that.fromData.store = '';
                    that.fromData.address = '';
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323dce02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeApply.vue
var storeApply_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-white "},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"shadow-gray cm-m-lr-16 cm-p-lr-20 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 border-b cm-m-t-4"},[_c('p',{staticClass:"cm-fn-bold cm-color-666 cm-flex-middle cm-flex-end"},[_vm._v("联系人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromData.name),expression:"fromData.name"}],staticClass:" cm-m-l-12 cm-fn-16",attrs:{"type":"text","placeholder":"请输入您的姓名"},domProps:{"value":(_vm.fromData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fromData, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 border-b cm-m-t-4"},[_c('p',{staticClass:"cm-fn-bold cm-color-666 cm-flex-middle cm-flex-end"},[_vm._v("手机号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromData.phone),expression:"fromData.phone"}],staticClass:"cm-m-l-12 cm-fn-16",attrs:{"type":"number","placeholder":"请输入您的手机号"},domProps:{"value":(_vm.fromData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fromData, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 border-b cm-m-t-4"},[_c('p',{staticClass:"cm-fn-bold cm-color-666 cm-flex-middle cm-flex-end"},[_vm._v("门店名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromData.store),expression:"fromData.store"}],staticClass:" cm-m-l-12 cm-fn-16",attrs:{"type":"text","placeholder":"请输入门店名称"},domProps:{"value":(_vm.fromData.store)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fromData, "store", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 border-b cm-m-t-4"},[_c('p',{staticClass:"cm-fn-bold cm-color-666 cm-flex-middle cm-flex-end"},[_vm._v("门店地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromData.address),expression:"fromData.address"}],staticClass:"cm-m-l-12 cm-fn-16",attrs:{"type":"text","placeholder":"请输入门店地址"},domProps:{"value":(_vm.fromData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fromData, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-p-tb-16 cm-m-t-32",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"64%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-color-red cm-center cm-p-tb-16"},[_vm._v("共进！共享！共赢！让洗衣生意不再难做！")])])}
var storeApply_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" cm-p-tb-28 cm-center"},[_c('img',{staticStyle:{"width":"310px","height":"78px"},attrs:{"src":"/static/images/apply_logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-p-lr-20 cm-p-tb-12"},[_c('div',{staticClass:"cm-p-tb-12 cm-text-left"},[_c('p',{staticClass:"cm-fn-bold cm-color-333 cm-fn-16"},[_vm._v("合作条件:")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-left"},[_c('p',{staticClass:" cm-fn-16"},[_vm._v("1.正在经营洗衣店的从业者。")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-16 cm-p-t-4"},[_vm._v("2.有意在洗衣行业发展的投资人。")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-16 cm-p-t-4"},[_vm._v("3.合作区域:陕西省内。")])])])}]
var storeApply_esExports = { render: storeApply_render, staticRenderFns: storeApply_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_storeApply = (storeApply_esExports);
// CONCATENATED MODULE: ./src/pages/storeApply.vue
function storeApply_injectStyle (ssrContext) {
  __webpack_require__("833x")
}
var storeApply_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var storeApply___vue_template_functional__ = false
/* styles */
var storeApply___vue_styles__ = storeApply_injectStyle
/* scopeId */
var storeApply___vue_scopeId__ = "data-v-323dce02"
/* moduleIdentifier (server only) */
var storeApply___vue_module_identifier__ = null
var storeApply_Component = storeApply_normalizeComponent(
  selectortype_script_index_0_src_pages_storeApply,
  selectortype_template_index_0_src_pages_storeApply,
  storeApply___vue_template_functional__,
  storeApply___vue_styles__,
  storeApply___vue_scopeId__,
  storeApply___vue_module_identifier__
)

/* harmony default export */ var src_pages_storeApply = (storeApply_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var core_js_object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(core_js_object_assign);

// EXTERNAL MODULE: ./node_modules/@antv/f2/dist/f2.js
var f2 = __webpack_require__("1bPL");
var f2_default = /*#__PURE__*/__webpack_require__.n(f2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-chart.vue








//
//
//
//
//
//
//
//
//
//
//
//
//


// const shapeMap = {
//   point: ['circle', 'hollowCircle', 'rect'],
//   line: ['line', 'smooth', 'dash'],
//   area: ['area', 'smooth'],
//   interval: ['rect'],
//   polygon: ['polygon'],
//   schema: ['candle']
// }



/* harmony default export */ var v_chart = ({
  props: {
    width: Number,
    height: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    data: {
      type: Array
    },
    tooltip: {
      type: Object
    },
    shape: {
      type: String,
      default: 'line'
    },
    preventRender: {
      type: Boolean,
      default: false
    },
    preventDefault: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      xField: '',
      yField: '',
      hasPoint: false,
      pointStyle: {},

      guideTags: [],

      areaOptions: null,
      lineOptions: null,
      tooltipOptions: null,
      legendOptions: null,

      barOptions: null,

      pieOptions: null,

      guideOptions: null,

      pointOptions: null,

      xFieldOptions: {},
      yFieldOptions: {},

      guides: [],

      seriesField: '',

      xAxisOptions: null,
      yAxisOptions: null,

      autoAlignXAxis: undefined
    };
  },

  computed: {
    currentData: function currentData() {
      if (this.pieOptions) {
        return this.data.slice().map(function (item) {
          item.a = '1';
          return item;
        });
      }
      return this.data;
    },
    currentXFieldOptions: function currentXFieldOptions(val) {
      var defaultOptions = {
        tickCount: 5
      };
      if (!this.barOptions) {
        defaultOptions.range = [0, 1];
      } else {
        defaultOptions.tickCount = 0;
      }
      // auto detect if is timeCat
      if (!this.xFieldOptions) {
        if (/\d{4}-\d{2}-\d{2}/.test(this.data[0][this.xField])) {
          return assign_default()({}, defaultOptions, {
            type: 'timeCat',
            tickCount: 3
          });
        } else {
          return defaultOptions;
        }
      }

      return assign_default()({}, defaultOptions, this.xFieldOptions);
    },
    currentYFieldOptions: function currentYFieldOptions(val) {
      var defaultOptions = {
        tickCount: 5
      };
      if (!val) {
        return defaultOptions;
      }

      return assign_default()({}, defaultOptions, this.yFieldOptions);
    }
  },
  watch: {
    data: function data() {
      this.changeData(this.data);
    }
  },
  methods: {
    onTouchstart: function onTouchstart(e) {
      this.preventDefault && e.preventDefault();
    },
    set: function set(name, options) {
      this[name + 'Options'] = options;
    },
    changeData: function changeData(data) {
      this.chart && this.chart.changeData(data);
    },
    setField: function setField(axis, item) {
      this[axis + 'Field'] = item;
    },
    repaint: function repaint() {
      this.chart.repaint();
    },
    rerender: function rerender() {
      this.destroy();
      this.render();
    },
    destroy: function destroy() {
      this.chart && this.chart.destroy();
    },
    addGuide: function addGuide(options) {
      this.guides.push(options);
    },
    setScale: function setScale(options) {
      if (options.x) {
        this.xFieldOptions = options.x;
      }
      if (options.y) {
        this.yFieldOptions = options.y;
      }
    },
    setAxis: function setAxis(options) {
      if (options.x) {
        this.xAxisOptions = options;
        if (typeof options.autoAlign !== 'undefined') {
          this.autoAlignXAxis = options.autoAlign;
        }
      }
      if (options.y) {
        this.yAxisOptions = options;
      }
    },
    buildColor: function buildColor(c) {
      var color = c || '';
      if (Array.isArray(c) && Array.isArray(c[0])) {
        var ctx = this.$refs.chart.getContext('2d');
        color = ctx.createLinearGradient(0, 0, window.innerWidth, 0);
        c.forEach(function (c) {
          color.addColorStop(c[0], c[1]);
        });
      }
      return color;
    },
    setPie: function setPie() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.pieOptions = options;
    },
    setBar: function setBar() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.barOptions = options;
    },
    setLegend: function setLegend(options) {
      this.legendOptions = options;
    },
    setTooltip: function setTooltip(options) {
      this.tooltipOptions = options;
    },
    setArea: function setArea(options) {
      this.areaOptions = options;
    },
    setGuide: function setGuide(options) {
      this.guideOptions = options;
    },
    setLine: function setLine(options) {
      this.lineOptions = options;
    },
    setPoint: function setPoint(options) {
      this.pointOptions = options;
    },
    buildPosition: function buildPosition() {
      return this.xField + '*' + this.yField;
    },
    getFields: function getFields() {
      if (this.xField && this.yField) {
        return;
      }

      if (this.data && this.data.length) {
        var keys = keys_default()(this.data[0]);
        if (keys.length >= 2) {
          var indexes = [0, 1];
          var type1 = typeof_default()(this.data[0][keys[0]]);
          var type2 = typeof_default()(this.data[0][keys[1]]);
          if (type1 === 'number' && type2 !== 'number') {
            indexes = [1, 0];
          } else if (type1 === 'string' && type2 === 'string' && keys[2] === 'value') {
            indexes = [0, 2];
          }
          this.xField = keys[indexes[0]];
          this.yField = keys[indexes[1]];
        }
      }
    },
    render: function render() {
      var _this2 = this;

      var _this = this;
      var autoAlignXAxis = this.autoAlignXAxis;
      if (this.barOptions) {
        autoAlignXAxis = false;
      }
      if (typeof autoAlignXAxis === 'undefined') {
        autoAlignXAxis = true;
      }
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var chart = new f2_default.a.Chart(extends_default()({
        el: this.$refs.chart,
        width: this.width || windowWidth,
        height: this.height ? this.height : windowWidth > windowHeight ? windowHeight - 54 : windowWidth * 0.707,
        pixelRatio: this.$devicePixelRatio || window.devicePixelRatio
      }, this.$attrs));
      if (this.preventRender) {
        this.$emit('on-render', { chart: chart });
        return;
      }

      if (!this.data || !this.data.length) {
        return;
      }

      this.getFields();

      chart.source(this.currentData);

      chart.scale(this.xField, this.currentXFieldOptions);
      chart.scale(this.yField, this.currentYFieldOptions);

      if (this.legendOptions) {
        if (this.legendOptions.disabled) {
          chart.legend(false);
        } else {
          chart.legend(this.legendOptions);
        }
      }

      if (this.tooltipOptions) {
        if (this.barOptions) {
          this.tooltipOptions.showCrosshairs = false;
        }
        if (!this.tooltipOptions.disabled) {
          // handle show-value-in-legend
          if (this.tooltipOptions.showValueInLegend) {
            var customTooltip = {
              custom: true, // 自定义 tooltip 内容框
              onChange: function onChange(obj) {
                var legend = _this.chart.get('legendController').legends.top[0];
                var tooltipItems = obj.items;
                var legendItems = legend.items;
                var map = {};
                legendItems.map(function (item) {
                  map[item.name] = JSON.parse(stringify_default()(item));
                });
                tooltipItems.map(function (item) {
                  var name = item.name,
                      value = item.value;

                  if (map[name]) {
                    map[name].value = value;
                  }
                });
                legend.setItems(values_default()(map));
              },
              onHide: function onHide() {
                var VChart = _this.chart;
                var legend = VChart.get('legendController').legends.top[0];
                legend.setItems(VChart.getLegendItems().type);
              }
            };
            this.tooltipOptions = extends_default()({}, this.tooltipOptions, customTooltip);
          }
          chart.tooltip(this.tooltipOptions);
        } else {
          chart.tooltip(false);
        }
      } else {
        chart.tooltip({
          showCrosshairs: !this.barOption
        });
      }

      if (autoAlignXAxis) {
        chart.axis(this.xField, {
          label: function label(text, index, total) {
            var textCfg = {};
            if (index === 0) {
              textCfg.textAlign = 'left';
            }
            if (index === total - 1) {
              textCfg.textAlign = 'right';
            }
            return textCfg;
          }
        });
      }

      if (this.lineOptions) {
        var _lineOptions = this.lineOptions,
            shape = _lineOptions.shape,
            adjust = _lineOptions.adjust,
            size = _lineOptions.size;

        var seriesField = this.lineOptions.seriesField || '';
        var colors = this.buildColor(this.lineOptions.colors);
        var rs = chart.line().position(this.buildPosition()).shape(shape);

        if (size) {
          rs.size(size);
        }

        if (!seriesField && colors) {
          rs.color(colors);
        }
        if (seriesField) {
          if (colors && colors.length) {
            rs.color(seriesField, colors);
          } else {
            rs.color(seriesField);
          }
        }
        if (adjust) {
          rs.adjust(adjust);
        }
      }

      if (this.guides.length) {
        this.guides.forEach(function (guide) {
          chart.guide()[guide.type](guide.options);
        });
      }

      if (this.areaOptions) {
        var _areaOptions = this.areaOptions,
            _adjust = _areaOptions.adjust,
            _seriesField = _areaOptions.seriesField;

        var color = this.buildColor(this.areaOptions.colors);
        var _rs = chart.area().position(this.buildPosition()).shape(this.areaOptions.shape || '');
        if (!_seriesField && color) {
          _rs.color(color);
        } else {
          _rs.color(_seriesField || '', color);
        }

        if (_adjust) {
          _rs.adjust(_adjust);
        }
      }

      if (this.barOptions) {
        var _barOptions = this.barOptions,
            _adjust2 = _barOptions.adjust,
            _seriesField2 = _barOptions.seriesField;

        var _color = this.buildColor(this.barOptions.colors);
        var _rs2 = chart.interval().position(this.buildPosition());
        if (!_seriesField2 && _color) {
          _rs2.color(_color);
        } else {
          _rs2.color(_seriesField2 || '', _color);
        }

        if (_adjust2) {
          _rs2.adjust(_adjust2);
        }
      }

      ['x', 'y'].forEach(function (axis) {
        if (_this2[axis + 'AxisOptions']) {
          chart.axis(_this2[axis + 'Field'], _this2[axis + 'Field'].disabled ? false : _this2[axis + 'AxisOptions']);
        }
      });

      if (this.pieOptions) {
        chart.coord(this.pieOptions.coord, this.pieOptions);
        chart.axis(false);
        chart.interval().position('a*percent').color(this.pieOptions.seriesField, this.pieOptions.colors && this.pieOptions.colors.length ? this.pieOptions.colors : '').adjust('stack').style({
          lineWidth: 1,
          stroke: '#fff',
          lineJoin: 'round',
          lineCap: 'round'
        }).animate({
          appear: {
            duration: 1200,
            easing: 'bounceOut'
          }
        });
      }

      if (this.pointOptions) {
        var _pointOptions = this.pointOptions,
            _seriesField3 = _pointOptions.seriesField,
            styles = _pointOptions.styles,
            _shape = _pointOptions.shape,
            _size = _pointOptions.size,
            _colors = _pointOptions.colors;

        var _rs3 = chart.point().position(this.buildPosition()).style(styles).shape(_shape);

        var _color2 = this.buildColor(_colors);
        if (!_seriesField3 && _color2) {
          _rs3.color(_color2);
        } else {
          _rs3.color(_seriesField3 || '', _color2);
        }

        if (!_seriesField3 && _size) {
          _rs3.size(_size);
        } else {
          _rs3.size(_seriesField3 || '', _size);
        }
      }

      // 在渲染前执触发on-render使之可以做自定义设置
      this.$emit('on-render', { chart: chart });
      chart.render();
      this.chart = chart;
    }
  },
  mounted: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.render();
              window.addEventListener('resize', this.render);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.render);
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-chart.vue








//
//
//
//
//
//
//
//
//
//
//
//
//


// const shapeMap = {
//   point: ['circle', 'hollowCircle', 'rect'],
//   line: ['line', 'smooth', 'dash'],
//   area: ['area', 'smooth'],
//   interval: ['rect'],
//   polygon: ['polygon'],
//   schema: ['candle']
// }



/* harmony default export */ var v_chart_v_chart = ({
  props: {
    width: Number,
    height: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    data: {
      type: Array
    },
    tooltip: {
      type: Object
    },
    shape: {
      type: String,
      default: 'line'
    },
    preventRender: {
      type: Boolean,
      default: false
    },
    preventDefault: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      xField: '',
      yField: '',
      hasPoint: false,
      pointStyle: {},

      guideTags: [],

      areaOptions: null,
      lineOptions: null,
      tooltipOptions: null,
      legendOptions: null,

      barOptions: null,

      pieOptions: null,

      guideOptions: null,

      pointOptions: null,

      xFieldOptions: {},
      yFieldOptions: {},

      guides: [],

      seriesField: '',

      xAxisOptions: null,
      yAxisOptions: null,

      autoAlignXAxis: undefined
    };
  },

  computed: {
    currentData: function currentData() {
      if (this.pieOptions) {
        return this.data.slice().map(function (item) {
          item.a = '1';
          return item;
        });
      }
      return this.data;
    },
    currentXFieldOptions: function currentXFieldOptions(val) {
      var defaultOptions = {
        tickCount: 5
      };
      if (!this.barOptions) {
        defaultOptions.range = [0, 1];
      } else {
        defaultOptions.tickCount = 0;
      }
      // auto detect if is timeCat
      if (!this.xFieldOptions) {
        if (/\d{4}-\d{2}-\d{2}/.test(this.data[0][this.xField])) {
          return assign_default()({}, defaultOptions, {
            type: 'timeCat',
            tickCount: 3
          });
        } else {
          return defaultOptions;
        }
      }

      return assign_default()({}, defaultOptions, this.xFieldOptions);
    },
    currentYFieldOptions: function currentYFieldOptions(val) {
      var defaultOptions = {
        tickCount: 5
      };
      if (!val) {
        return defaultOptions;
      }

      return assign_default()({}, defaultOptions, this.yFieldOptions);
    }
  },
  watch: {
    data: function data() {
      this.changeData(this.data);
    }
  },
  methods: {
    onTouchstart: function onTouchstart(e) {
      this.preventDefault && e.preventDefault();
    },
    set: function set(name, options) {
      this[name + 'Options'] = options;
    },
    changeData: function changeData(data) {
      this.chart && this.chart.changeData(data);
    },
    setField: function setField(axis, item) {
      this[axis + 'Field'] = item;
    },
    repaint: function repaint() {
      this.chart.repaint();
    },
    rerender: function rerender() {
      this.destroy();
      this.render();
    },
    destroy: function destroy() {
      this.chart && this.chart.destroy();
    },
    addGuide: function addGuide(options) {
      this.guides.push(options);
    },
    setScale: function setScale(options) {
      if (options.x) {
        this.xFieldOptions = options.x;
      }
      if (options.y) {
        this.yFieldOptions = options.y;
      }
    },
    setAxis: function setAxis(options) {
      if (options.x) {
        this.xAxisOptions = options;
        if (typeof options.autoAlign !== 'undefined') {
          this.autoAlignXAxis = options.autoAlign;
        }
      }
      if (options.y) {
        this.yAxisOptions = options;
      }
    },
    buildColor: function buildColor(c) {
      var color = c || '';
      if (Array.isArray(c) && Array.isArray(c[0])) {
        var ctx = this.$refs.chart.getContext('2d');
        color = ctx.createLinearGradient(0, 0, window.innerWidth, 0);
        c.forEach(function (c) {
          color.addColorStop(c[0], c[1]);
        });
      }
      return color;
    },
    setPie: function setPie() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.pieOptions = options;
    },
    setBar: function setBar() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.barOptions = options;
    },
    setLegend: function setLegend(options) {
      this.legendOptions = options;
    },
    setTooltip: function setTooltip(options) {
      this.tooltipOptions = options;
    },
    setArea: function setArea(options) {
      this.areaOptions = options;
    },
    setGuide: function setGuide(options) {
      this.guideOptions = options;
    },
    setLine: function setLine(options) {
      this.lineOptions = options;
    },
    setPoint: function setPoint(options) {
      this.pointOptions = options;
    },
    buildPosition: function buildPosition() {
      return this.xField + '*' + this.yField;
    },
    getFields: function getFields() {
      if (this.xField && this.yField) {
        return;
      }

      if (this.data && this.data.length) {
        var keys = keys_default()(this.data[0]);
        if (keys.length >= 2) {
          var indexes = [0, 1];
          var type1 = typeof_default()(this.data[0][keys[0]]);
          var type2 = typeof_default()(this.data[0][keys[1]]);
          if (type1 === 'number' && type2 !== 'number') {
            indexes = [1, 0];
          } else if (type1 === 'string' && type2 === 'string' && keys[2] === 'value') {
            indexes = [0, 2];
          }
          this.xField = keys[indexes[0]];
          this.yField = keys[indexes[1]];
        }
      }
    },
    render: function render() {
      var _this2 = this;

      var _this = this;
      var autoAlignXAxis = this.autoAlignXAxis;
      if (this.barOptions) {
        autoAlignXAxis = false;
      }
      if (typeof autoAlignXAxis === 'undefined') {
        autoAlignXAxis = true;
      }
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var chart = new f2_default.a.Chart(extends_default()({
        el: this.$refs.chart,
        width: this.width || windowWidth,
        height: this.height ? this.height : windowWidth > windowHeight ? windowHeight - 54 : windowWidth * 0.707,
        pixelRatio: this.$devicePixelRatio || window.devicePixelRatio
      }, this.$attrs));
      if (this.preventRender) {
        this.$emit('on-render', { chart: chart });
        return;
      }

      if (!this.data || !this.data.length) {
        return;
      }

      this.getFields();

      chart.source(this.currentData);

      chart.scale(this.xField, this.currentXFieldOptions);
      chart.scale(this.yField, this.currentYFieldOptions);

      if (this.legendOptions) {
        if (this.legendOptions.disabled) {
          chart.legend(false);
        } else {
          chart.legend(this.legendOptions);
        }
      }

      if (this.tooltipOptions) {
        if (this.barOptions) {
          this.tooltipOptions.showCrosshairs = false;
        }
        if (!this.tooltipOptions.disabled) {
          // handle show-value-in-legend
          if (this.tooltipOptions.showValueInLegend) {
            var customTooltip = {
              custom: true, // 自定义 tooltip 内容框
              onChange: function onChange(obj) {
                var legend = _this.chart.get('legendController').legends.top[0];
                var tooltipItems = obj.items;
                var legendItems = legend.items;
                var map = {};
                legendItems.map(function (item) {
                  map[item.name] = JSON.parse(stringify_default()(item));
                });
                tooltipItems.map(function (item) {
                  var name = item.name,
                      value = item.value;

                  if (map[name]) {
                    map[name].value = value;
                  }
                });
                legend.setItems(values_default()(map));
              },
              onHide: function onHide() {
                var VChart = _this.chart;
                var legend = VChart.get('legendController').legends.top[0];
                legend.setItems(VChart.getLegendItems().type);
              }
            };
            this.tooltipOptions = extends_default()({}, this.tooltipOptions, customTooltip);
          }
          chart.tooltip(this.tooltipOptions);
        } else {
          chart.tooltip(false);
        }
      } else {
        chart.tooltip({
          showCrosshairs: !this.barOption
        });
      }

      if (autoAlignXAxis) {
        chart.axis(this.xField, {
          label: function label(text, index, total) {
            var textCfg = {};
            if (index === 0) {
              textCfg.textAlign = 'left';
            }
            if (index === total - 1) {
              textCfg.textAlign = 'right';
            }
            return textCfg;
          }
        });
      }

      if (this.lineOptions) {
        var _lineOptions = this.lineOptions,
            shape = _lineOptions.shape,
            adjust = _lineOptions.adjust,
            size = _lineOptions.size;

        var seriesField = this.lineOptions.seriesField || '';
        var colors = this.buildColor(this.lineOptions.colors);
        var rs = chart.line().position(this.buildPosition()).shape(shape);

        if (size) {
          rs.size(size);
        }

        if (!seriesField && colors) {
          rs.color(colors);
        }
        if (seriesField) {
          if (colors && colors.length) {
            rs.color(seriesField, colors);
          } else {
            rs.color(seriesField);
          }
        }
        if (adjust) {
          rs.adjust(adjust);
        }
      }

      if (this.guides.length) {
        this.guides.forEach(function (guide) {
          chart.guide()[guide.type](guide.options);
        });
      }

      if (this.areaOptions) {
        var _areaOptions = this.areaOptions,
            _adjust = _areaOptions.adjust,
            _seriesField = _areaOptions.seriesField;

        var color = this.buildColor(this.areaOptions.colors);
        var _rs = chart.area().position(this.buildPosition()).shape(this.areaOptions.shape || '');
        if (!_seriesField && color) {
          _rs.color(color);
        } else {
          _rs.color(_seriesField || '', color);
        }

        if (_adjust) {
          _rs.adjust(_adjust);
        }
      }

      if (this.barOptions) {
        var _barOptions = this.barOptions,
            _adjust2 = _barOptions.adjust,
            _seriesField2 = _barOptions.seriesField;

        var _color = this.buildColor(this.barOptions.colors);
        var _rs2 = chart.interval().position(this.buildPosition());
        if (!_seriesField2 && _color) {
          _rs2.color(_color);
        } else {
          _rs2.color(_seriesField2 || '', _color);
        }

        if (_adjust2) {
          _rs2.adjust(_adjust2);
        }
      }

      ['x', 'y'].forEach(function (axis) {
        if (_this2[axis + 'AxisOptions']) {
          chart.axis(_this2[axis + 'Field'], _this2[axis + 'Field'].disabled ? false : _this2[axis + 'AxisOptions']);
        }
      });

      if (this.pieOptions) {
        chart.coord(this.pieOptions.coord, this.pieOptions);
        chart.axis(false);
        chart.interval().position('a*percent').color(this.pieOptions.seriesField, this.pieOptions.colors && this.pieOptions.colors.length ? this.pieOptions.colors : '').adjust('stack').style({
          lineWidth: 1,
          stroke: '#fff',
          lineJoin: 'round',
          lineCap: 'round'
        }).animate({
          appear: {
            duration: 1200,
            easing: 'bounceOut'
          }
        });
      }

      if (this.pointOptions) {
        var _pointOptions = this.pointOptions,
            _seriesField3 = _pointOptions.seriesField,
            styles = _pointOptions.styles,
            _shape = _pointOptions.shape,
            _size = _pointOptions.size,
            _colors = _pointOptions.colors;

        var _rs3 = chart.point().position(this.buildPosition()).style(styles).shape(_shape);

        var _color2 = this.buildColor(_colors);
        if (!_seriesField3 && _color2) {
          _rs3.color(_color2);
        } else {
          _rs3.color(_seriesField3 || '', _color2);
        }

        if (!_seriesField3 && _size) {
          _rs3.size(_size);
        } else {
          _rs3.size(_seriesField3 || '', _size);
        }
      }

      // 在渲染前执触发on-render使之可以做自定义设置
      this.$emit('on-render', { chart: chart });
      chart.render();
      this.chart = chart;
    }
  },
  mounted: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.render();
              window.addEventListener('resize', this.render);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.render);
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2afeb0f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/v-chart/v-chart.vue
var v_chart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    backgroundColor: _vm.backgroundColor,
    width: _vm.width + 'px',
    height: _vm.height + 'px'
  }),on:{"touchstart":_vm.onTouchstart}},[_c('canvas',{ref:"chart",staticClass:"noselect",attrs:{"height":"260"}}),_vm._v(" "),_vm._t("default")],2)}
var v_chart_staticRenderFns = []
var v_chart_esExports = { render: v_chart_render, staticRenderFns: v_chart_staticRenderFns }
/* harmony default export */ var components_v_chart_v_chart = (v_chart_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/v-chart/v-chart.vue
function v_chart_injectStyle (ssrContext) {
  __webpack_require__("YqSk")
}
var v_chart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_chart___vue_template_functional__ = false
/* styles */
var v_chart___vue_styles__ = v_chart_injectStyle
/* scopeId */
var v_chart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_chart___vue_module_identifier__ = null
var v_chart_Component = v_chart_normalizeComponent(
  v_chart_v_chart,
  components_v_chart_v_chart,
  v_chart___vue_template_functional__,
  v_chart___vue_styles__,
  v_chart___vue_scopeId__,
  v_chart___vue_module_identifier__
)

/* harmony default export */ var src_components_v_chart_v_chart = (v_chart_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/v-chart/mixin.js
var mixin = __webpack_require__("QlYx");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-line.vue



/* harmony default export */ var v_line = ({
  mixins: [mixin["a" /* default */]],
  data: function data() {
    return {
      chartName: 'line'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-line.vue



/* harmony default export */ var v_chart_v_line = ({
  mixins: [mixin["a" /* default */]],
  data: function data() {
    return {
      chartName: 'line'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/v-chart/v-line.vue
var v_line_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var v_line___vue_template__ = null
/* template functional */
var v_line___vue_template_functional__ = false
/* styles */
var v_line___vue_styles__ = null
/* scopeId */
var v_line___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_line___vue_module_identifier__ = null
var v_line_Component = v_line_normalizeComponent(
  v_chart_v_line,
  v_line___vue_template__,
  v_line___vue_template_functional__,
  v_line___vue_styles__,
  v_line___vue_scopeId__,
  v_line___vue_module_identifier__
)

/* harmony default export */ var components_v_chart_v_line = (v_line_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/v-chart/util.js
var util = __webpack_require__("c8Kt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-axis.vue




/* harmony default export */ var v_axis = ({
  props: {
    x: Boolean,
    y: Boolean,
    field: String,
    disabled: Boolean,
    // only for x axis
    autoAlign: Boolean,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _options = extends_default()({}, this.$props, this.options, Object(util["a" /* camelAttrs */])(this.$attrs));
    this.$parent.setAxis(_options);
  },
  render: function render() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-axis.vue




/* harmony default export */ var v_chart_v_axis = ({
  props: {
    x: Boolean,
    y: Boolean,
    field: String,
    disabled: Boolean,
    // only for x axis
    autoAlign: Boolean,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _options = extends_default()({}, this.$props, this.options, Object(util["a" /* camelAttrs */])(this.$attrs));
    this.$parent.setAxis(_options);
  },
  render: function render() {}
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/v-chart/v-axis.vue
var v_axis_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var v_axis___vue_template__ = null
/* template functional */
var v_axis___vue_template_functional__ = false
/* styles */
var v_axis___vue_styles__ = null
/* scopeId */
var v_axis___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_axis___vue_module_identifier__ = null
var v_axis_Component = v_axis_normalizeComponent(
  v_chart_v_axis,
  v_axis___vue_template__,
  v_axis___vue_template_functional__,
  v_axis___vue_styles__,
  v_axis___vue_scopeId__,
  v_axis___vue_module_identifier__
)

/* harmony default export */ var components_v_chart_v_axis = (v_axis_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-tooltip.vue




/* harmony default export */ var v_tooltip = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    showCrosshairs: {
      type: Boolean,
      default: true
    },
    showItemMarker: {
      type: Boolean,
      default: true
    },
    showXValue: {
      type: Boolean,
      default: false
    },
    showValueInLegend: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render() {},
  created: function created() {
    var options = extends_default()({
      disabled: this.disabled,
      showCrosshairs: this.showCrosshairs,
      showItemMarker: this.showItemMarker,
      showValueInLegend: this.showValueInLegend
    }, Object(util["a" /* camelAttrs */])(this.options), Object(util["a" /* camelAttrs */])(this.$attrs));
    if (this.showXValue) {
      options.onShow = function (ev) {
        var items = ev.items;

        items[0].name = items[0].title;
      };
    }
    this.$parent.setTooltip(options);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-tooltip.vue




/* harmony default export */ var v_chart_v_tooltip = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    showCrosshairs: {
      type: Boolean,
      default: true
    },
    showItemMarker: {
      type: Boolean,
      default: true
    },
    showXValue: {
      type: Boolean,
      default: false
    },
    showValueInLegend: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render() {},
  created: function created() {
    var options = extends_default()({
      disabled: this.disabled,
      showCrosshairs: this.showCrosshairs,
      showItemMarker: this.showItemMarker,
      showValueInLegend: this.showValueInLegend
    }, Object(util["a" /* camelAttrs */])(this.options), Object(util["a" /* camelAttrs */])(this.$attrs));
    if (this.showXValue) {
      options.onShow = function (ev) {
        var items = ev.items;

        items[0].name = items[0].title;
      };
    }
    this.$parent.setTooltip(options);
  }
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/v-chart/v-tooltip.vue
var v_tooltip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var v_tooltip___vue_template__ = null
/* template functional */
var v_tooltip___vue_template_functional__ = false
/* styles */
var v_tooltip___vue_styles__ = null
/* scopeId */
var v_tooltip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_tooltip___vue_module_identifier__ = null
var v_tooltip_Component = v_tooltip_normalizeComponent(
  v_chart_v_tooltip,
  v_tooltip___vue_template__,
  v_tooltip___vue_template_functional__,
  v_tooltip___vue_styles__,
  v_tooltip___vue_scopeId__,
  v_tooltip___vue_module_identifier__
)

/* harmony default export */ var components_v_chart_v_tooltip = (v_tooltip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-scale.vue





/* harmony default export */ var v_scale = ({
  props: {
    x: Boolean,
    y: Boolean,
    field: String
  },
  render: function render() {},
  created: function created() {
    this.emitSetting();
  },

  methods: {
    emitSetting: function emitSetting() {
      var _this = this;

      ['x', 'y'].forEach(function (item) {
        if (_this[item]) {
          _this.$parent.setScale(defineProperty_default()({}, item, extends_default()({}, Object(util["a" /* camelAttrs */])(_this.$attrs))));
          if (_this.field) {
            _this.$parent.setField(item, _this.field);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/v-chart/v-scale.vue





/* harmony default export */ var v_chart_v_scale = ({
  props: {
    x: Boolean,
    y: Boolean,
    field: String
  },
  render: function render() {},
  created: function created() {
    this.emitSetting();
  },

  methods: {
    emitSetting: function emitSetting() {
      var _this = this;

      ['x', 'y'].forEach(function (item) {
        if (_this[item]) {
          _this.$parent.setScale(defineProperty_default()({}, item, extends_default()({}, Object(util["a" /* camelAttrs */])(_this.$attrs))));
          if (_this.field) {
            _this.$parent.setField(item, _this.field);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/v-chart/v-scale.vue
var v_scale_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var v_scale___vue_template__ = null
/* template functional */
var v_scale___vue_template_functional__ = false
/* styles */
var v_scale___vue_styles__ = null
/* scopeId */
var v_scale___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_scale___vue_module_identifier__ = null
var v_scale_Component = v_scale_normalizeComponent(
  v_chart_v_scale,
  v_scale___vue_template__,
  v_scale___vue_template_functional__,
  v_scale___vue_styles__,
  v_scale___vue_scopeId__,
  v_scale___vue_module_identifier__
)

/* harmony default export */ var components_v_chart_v_scale = (v_scale_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collectData.vue












/* harmony default export */ var collectData = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      operater1: '',
      operater: '请选择',
      operater_id: 0,
      operaterArr: [],
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.communityOperater();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    communityOperater: function communityOperater() {
      var _this = this;

      this.$api.communityOperater({}).then(function (res) {
        if (res) {
          _this.operaterArr = res.data;
          _this.operater = _this.operaterArr[0].name;
          _this.operater_id = _this.operaterArr[0].value;
          _this.getData();
        }
      });
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.operater_id = value[0];
      this.operater = this.operater1;
    },
    schange: function schange(value, name) {
      this.operater1 = name[0];
    },
    getData: function getData() {
      var _this2 = this;

      this.$api.communityData({ id: this.operater_id, startDate: this.startDate, endDate: this.endDate, type: 2 }).then(function (res) {
        if (res) {
          _this2.data = res.data.list;
          _this2.collectCount = res.data.collectCount;
          _this2.orderCount = res.data.orderCount;
          _this2.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collectData.vue












/* harmony default export */ var pages_collectData = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      operater1: '',
      operater: '请选择',
      operater_id: 0,
      operaterArr: [],
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.communityOperater();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    communityOperater: function communityOperater() {
      var _this = this;

      this.$api.communityOperater({}).then(function (res) {
        if (res) {
          _this.operaterArr = res.data;
          _this.operater = _this.operaterArr[0].name;
          _this.operater_id = _this.operaterArr[0].value;
          _this.getData();
        }
      });
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.operater_id = value[0];
      this.operater = this.operater1;
    },
    schange: function schange(value, name) {
      this.operater1 = name[0];
    },
    getData: function getData() {
      var _this2 = this;

      this.$api.communityData({ id: this.operater_id, startDate: this.startDate, endDate: this.endDate, type: 2 }).then(function (res) {
        if (res) {
          _this2.data = res.data.list;
          _this2.collectCount = res.data.collectCount;
          _this2.orderCount = res.data.orderCount;
          _this2.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b50b578","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collectData.vue
var collectData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开始日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("结束日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12  cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("操作员")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":_vm.showOperater}},[_vm._v(_vm._s(_vm.operater))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-m-tb-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getData}},[_c('p',{staticClass:"cm-w-100 cm-h-100 cm-center cm-color-white"},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-32 cm-flex-middle cm-flex-between cm-bg-white"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("下单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.orderCount,"duration":1.2}}),_vm._v("件")],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("录单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.collectCount,"duration":1.2}}),_vm._v("件")],1)]),_vm._v(" "),_c('v-chart',{ref:"echart",attrs:{"data":_vm.data}},[_c('v-scale',{attrs:{"x":"","type":"timeCat","mask":"MM.DD","tick-count":9,"field":"date"}}),_vm._v(" "),_c('v-scale',{attrs:{"y":"","tick-count":5,"field":"value"}}),_vm._v(" "),_c('v-tooltip',{attrs:{"show-x-value":true}}),_vm._v(" "),_c('v-line',{attrs:{"series-field":"type","shape":"smooth"}})],1),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}}),_vm._v(" "),_c('popup-picker',{attrs:{"data":_vm.operaterArr,"show":_vm.pickerStatus,"show-name":"","columns":1},on:{"update:show":function($event){_vm.pickerStatus=$event},"on-change":_vm.onChange,"on-shadow-change":_vm.schange}})],1)}
var collectData_staticRenderFns = []
var collectData_esExports = { render: collectData_render, staticRenderFns: collectData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_collectData = (collectData_esExports);
// CONCATENATED MODULE: ./src/pages/collectData.vue
function collectData_injectStyle (ssrContext) {
  __webpack_require__("QGo0")
}
var collectData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var collectData___vue_template_functional__ = false
/* styles */
var collectData___vue_styles__ = collectData_injectStyle
/* scopeId */
var collectData___vue_scopeId__ = "data-v-3b50b578"
/* moduleIdentifier (server only) */
var collectData___vue_module_identifier__ = null
var collectData_Component = collectData_normalizeComponent(
  pages_collectData,
  selectortype_template_index_0_src_pages_collectData,
  collectData___vue_template_functional__,
  collectData___vue_styles__,
  collectData___vue_scopeId__,
  collectData___vue_module_identifier__
)

/* harmony default export */ var src_pages_collectData = (collectData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/communityData.vue











/* harmony default export */ var pages_communityData = ({
  components: {
    Datetime: vux_src_components_datetime,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getData: function getData() {
      var _this = this;

      this.$api.communityData({ startDate: this.startDate, endDate: this.endDate, type: 0 }).then(function (res) {
        if (res) {
          _this.data = res.data.list;
          _this.collectCount = res.data.collectCount;
          _this.orderCount = res.data.orderCount;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/communityData.vue











/* harmony default export */ var selectortype_script_index_0_src_pages_communityData = ({
  components: {
    Datetime: vux_src_components_datetime,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getData: function getData() {
      var _this = this;

      this.$api.communityData({ startDate: this.startDate, endDate: this.endDate, type: 0 }).then(function (res) {
        if (res) {
          _this.data = res.data.list;
          _this.collectCount = res.data.collectCount;
          _this.orderCount = res.data.orderCount;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f79dea76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/communityData.vue
var communityData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开始日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("结束日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-m-tb-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getData}},[_c('p',{staticClass:"cm-w-100 cm-h-100 cm-center cm-color-white"},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-32 cm-flex-middle cm-flex-between cm-bg-white"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("下单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.orderCount,"duration":1.2}}),_vm._v("件")],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("录单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.collectCount,"duration":1.2}}),_vm._v("件")],1)]),_vm._v(" "),_c('v-chart',{ref:"echart",attrs:{"data":_vm.data}},[_c('v-scale',{attrs:{"x":"","type":"timeCat","mask":"MM.DD","tick-count":9,"field":"date"}}),_vm._v(" "),_c('v-scale',{attrs:{"y":"","tick-count":5,"field":"value"}}),_vm._v(" "),_c('v-tooltip',{attrs:{"show-x-value":true}}),_vm._v(" "),_c('v-line',{attrs:{"series-field":"type","shape":"smooth"}})],1),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var communityData_staticRenderFns = []
var communityData_esExports = { render: communityData_render, staticRenderFns: communityData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_communityData = (communityData_esExports);
// CONCATENATED MODULE: ./src/pages/communityData.vue
function communityData_injectStyle (ssrContext) {
  __webpack_require__("izsC")
}
var communityData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var communityData___vue_template_functional__ = false
/* styles */
var communityData___vue_styles__ = communityData_injectStyle
/* scopeId */
var communityData___vue_scopeId__ = "data-v-f79dea76"
/* moduleIdentifier (server only) */
var communityData___vue_module_identifier__ = null
var communityData_Component = communityData_normalizeComponent(
  selectortype_script_index_0_src_pages_communityData,
  selectortype_template_index_0_src_pages_communityData,
  communityData___vue_template_functional__,
  communityData___vue_styles__,
  communityData___vue_scopeId__,
  communityData___vue_module_identifier__
)

/* harmony default export */ var src_pages_communityData = (communityData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myData.vue











/* harmony default export */ var myData = ({
  components: {
    Datetime: vux_src_components_datetime,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getData: function getData() {
      var _this = this;

      this.$api.communityData({ startDate: this.startDate, endDate: this.endDate, type: 1 }).then(function (res) {
        if (res) {
          _this.data = res.data.list;
          _this.collectCount = res.data.collectCount;
          _this.orderCount = res.data.orderCount;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myData.vue











/* harmony default export */ var pages_myData = ({
  components: {
    Datetime: vux_src_components_datetime,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    var _ref;

    return {
      dateStatus: false,
      index: 0,
      orderCount: 0,
      collectCount: 0,
      startDate: '',
      endDate: '',
      data: [(_ref = {
        date: '2021-04-15', value: 0, 'type': '下单'
      }, defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '下单'), defineProperty_default()(_ref, 'date', '2021-04-15'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-16'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-17'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), defineProperty_default()(_ref, 'date', '2021-04-18'), defineProperty_default()(_ref, 'value', 0), defineProperty_default()(_ref, 'type', '收衣'), _ref)]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getData: function getData() {
      var _this = this;

      this.$api.communityData({ startDate: this.startDate, endDate: this.endDate, type: 1 }).then(function (res) {
        if (res) {
          _this.data = res.data.list;
          _this.collectCount = res.data.collectCount;
          _this.orderCount = res.data.orderCount;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ac2ef0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/myData.vue
var myData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开始日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("结束日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-m-tb-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getData}},[_c('p',{staticClass:"cm-w-100 cm-h-100 cm-center cm-color-white"},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-32 cm-flex-middle cm-flex-between cm-bg-white"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("下单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.orderCount,"duration":1.2}}),_vm._v("件")],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("录单 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.collectCount,"duration":1.2}}),_vm._v("件")],1)]),_vm._v(" "),_c('v-chart',{ref:"echart",attrs:{"data":_vm.data}},[_c('v-scale',{attrs:{"x":"","type":"timeCat","mask":"MM.DD","tick-count":9,"field":"date"}}),_vm._v(" "),_c('v-scale',{attrs:{"y":"","tick-count":5,"field":"value","alias":"下单"}}),_vm._v(" "),_c('v-tooltip',{attrs:{"show-x-value":true}}),_vm._v(" "),_c('v-line',{attrs:{"series-field":"type","shape":"smooth"}})],1),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var myData_staticRenderFns = []
var myData_esExports = { render: myData_render, staticRenderFns: myData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_myData = (myData_esExports);
// CONCATENATED MODULE: ./src/pages/myData.vue
function myData_injectStyle (ssrContext) {
  __webpack_require__("2yWH")
}
var myData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myData___vue_template_functional__ = false
/* styles */
var myData___vue_styles__ = myData_injectStyle
/* scopeId */
var myData___vue_scopeId__ = "data-v-33ac2ef0"
/* moduleIdentifier (server only) */
var myData___vue_module_identifier__ = null
var myData_Component = myData_normalizeComponent(
  pages_myData,
  selectortype_template_index_0_src_pages_myData,
  myData___vue_template_functional__,
  myData___vue_styles__,
  myData___vue_scopeId__,
  myData___vue_module_identifier__
)

/* harmony default export */ var src_pages_myData = (myData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/password.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_password = ({
  name: 'login',
  data: function data() {
    return {
      info: {},
      password: '',
      password1: '',
      password2: ''
    };
  },
  created: function created() {
    this.account();
  },

  methods: {
    account: function account() {
      var _this = this;

      this.$api.account({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!that.info.account) {
        that.$func.showToast('账号不存在');
        return false;
      }
      if (!this.password) {
        that.$func.showToast('请输入原密码');
        return false;
      }
      if (that.info.password != this.password) {
        that.$func.showToast('原密码不正确');
        return false;
      }
      if (!this.password1) {
        that.$func.showToast('请输入新密码');
        return false;
      }
      if (this.password1 != this.password2) {
        that.$func.showToast('两次输入密码不一致');
        return false;
      }
      this.$func.confirm('确认修改？', '提示', function () {
        that.$api.password({ password: that.password, password1: that.password1, password2: that.password2 }).then(function (res) {
          if (res) {
            that.$func.alert('您的新密码为 "' + that.password1 + '" 请以后使用新密码登录', '操作成功');
            that.account();
            that.password = '';
            that.password1 = '';
            that.password2 = '';
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/password.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_pages_password = ({
  name: 'login',
  data: function data() {
    return {
      info: {},
      password: '',
      password1: '',
      password2: ''
    };
  },
  created: function created() {
    this.account();
  },

  methods: {
    account: function account() {
      var _this = this;

      this.$api.account({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!that.info.account) {
        that.$func.showToast('账号不存在');
        return false;
      }
      if (!this.password) {
        that.$func.showToast('请输入原密码');
        return false;
      }
      if (that.info.password != this.password) {
        that.$func.showToast('原密码不正确');
        return false;
      }
      if (!this.password1) {
        that.$func.showToast('请输入新密码');
        return false;
      }
      if (this.password1 != this.password2) {
        that.$func.showToast('两次输入密码不一致');
        return false;
      }
      this.$func.confirm('确认修改？', '提示', function () {
        that.$api.password({ password: that.password, password1: that.password1, password2: that.password2 }).then(function (res) {
          if (res) {
            that.$func.alert('您的新密码为 "' + that.password1 + '" 请以后使用新密码登录', '操作成功');
            that.account();
            that.password = '';
            that.password1 = '';
            that.password2 = '';
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e7cd85","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/password.vue
var password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white cm-md-100"},[_c('div',{staticClass:"cm-m-lr-12  cm-p-t-36"},[_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16 left"},[_vm._v("登录账号：")]),_vm._v(" "),_c('div',{staticClass:" right"},[_c('p',{staticClass:"cm-m-l-12 cm-fn-18 cm-w-100"},[_vm._v(_vm._s(_vm.info.account))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8 cm-m-t-8"},[_c('p',{staticClass:"cm-fn-16 left"},[_vm._v("原密码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"cm-m-l-12 cm-fn-18 ",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8 cm-m-t-8"},[_c('p',{staticClass:"cm-fn-16 left"},[_vm._v("新密码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password1),expression:"password1"}],staticClass:"cm-m-l-12 cm-fn-18 ",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8 cm-m-t-8"},[_c('p',{staticClass:"cm-fn-16 left"},[_vm._v("确认密码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password2),expression:"password2"}],staticClass:"cm-m-l-12 cm-fn-18 ",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password2=$event.target.value}}})])]),_vm._v(" "),_c('p',{staticClass:"cm-p-tb-4 cm-m-t-8 cm-color-666"},[_vm._v("注：新密码建议8个字符以上，其中包括大小写字母和数字")]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-m-t-40 cm-center"},[_c('button',{staticClass:"cm-bg-red cm-p-tb-12 cm-p-lr-40 cm-border-radius-10 cm-color-white cm-fn-16 cm-w-100",on:{"click":function($event){return _vm.submit()}}},[_vm._v("确定")])])])])}
var password_staticRenderFns = []
var password_esExports = { render: password_render, staticRenderFns: password_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_password = (password_esExports);
// CONCATENATED MODULE: ./src/pages/password.vue
function password_injectStyle (ssrContext) {
  __webpack_require__("tYDS")
}
var password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var password___vue_template_functional__ = false
/* styles */
var password___vue_styles__ = password_injectStyle
/* scopeId */
var password___vue_scopeId__ = "data-v-58e7cd85"
/* moduleIdentifier (server only) */
var password___vue_module_identifier__ = null
var password_Component = password_normalizeComponent(
  selectortype_script_index_0_src_pages_password,
  selectortype_template_index_0_src_pages_password,
  password___vue_template_functional__,
  password___vue_styles__,
  password___vue_scopeId__,
  password___vue_module_identifier__
)

/* harmony default export */ var src_pages_password = (password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/problem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_problem = ({
    name: 'problem',
    components: {
        wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            filePath: [],
            formData: {
                order_id: 0,
                content: '',
                pics: []
            }
        };
    },
    created: function created() {
        this.formData.order_id = Number(this.$route.params.id);
        this.config();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            if (!this.formData.pics.length) {
                this.$func.showToast('请输入上传照片');
                return false;
            }
            if (!this.formData.content) {
                this.$func.showToast('请输入问题描述');
                return false;
            }
            this.$api.problem(this.formData).then(function (res) {
                _this.$func.showToast('提交成功');
                setTimeout(function () {
                    _this.$router.go(-1);
                }, 1000);
            });
        },
        config: function config() {
            // var url= '';
            // var u = navigator.userAgent;
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isIOS) {
            //     url=window.entryUrl
            // }else{
            //     url = window.location.href;
            // }
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false, //调试阶段建议开启
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["chooseImage", "uploadImage"]
                    });
                }
            });
        },
        uploadFile: function uploadFile() {
            var that = this;
            weixin_js_sdk_default.a.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'],
                sourceType: ['album', 'camera'],
                success: function success(res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
        uploadImg: function uploadImg(localIds) {
            var localId = localIds.pop();
            var that = this;
            weixin_js_sdk_default.a.uploadImage({
                localId: localId,
                success: function success(res) {
                    that.$api.uploadsImg({ serverId: res.serverId }).then(function (res) {
                        if (res) {
                            that.filePath.push(res.data.url);
                            that.formData.pics.push(res.data.path);
                            if (localIds.length > 0) {
                                that.uploadImg(localIds);
                            }
                        }
                    });
                }
            });
        },
        showPic: function showPic(index) {
            weixin_js_sdk_default.a.previewImage({
                current: this.filePath[index], // 当前显示图片的http链接
                urls: this.filePath // 需要预览的图片http链接列表
            });
        },
        delImg: function delImg(index) {
            this.filePath.splice(index, 1);
            this.formData.pics.splice(index, 1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/problem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_problem = ({
    name: 'problem',
    components: {
        wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            filePath: [],
            formData: {
                order_id: 0,
                content: '',
                pics: []
            }
        };
    },
    created: function created() {
        this.formData.order_id = Number(this.$route.params.id);
        this.config();
    },

    methods: {
        submit: function submit() {
            var _this = this;

            if (!this.formData.pics.length) {
                this.$func.showToast('请输入上传照片');
                return false;
            }
            if (!this.formData.content) {
                this.$func.showToast('请输入问题描述');
                return false;
            }
            this.$api.problem(this.formData).then(function (res) {
                _this.$func.showToast('提交成功');
                setTimeout(function () {
                    _this.$router.go(-1);
                }, 1000);
            });
        },
        config: function config() {
            // var url= '';
            // var u = navigator.userAgent;
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isIOS) {
            //     url=window.entryUrl
            // }else{
            //     url = window.location.href;
            // }
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false, //调试阶段建议开启
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["chooseImage", "uploadImage"]
                    });
                }
            });
        },
        uploadFile: function uploadFile() {
            var that = this;
            weixin_js_sdk_default.a.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'],
                sourceType: ['album', 'camera'],
                success: function success(res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
        uploadImg: function uploadImg(localIds) {
            var localId = localIds.pop();
            var that = this;
            weixin_js_sdk_default.a.uploadImage({
                localId: localId,
                success: function success(res) {
                    that.$api.uploadsImg({ serverId: res.serverId }).then(function (res) {
                        if (res) {
                            that.filePath.push(res.data.url);
                            that.formData.pics.push(res.data.path);
                            if (localIds.length > 0) {
                                that.uploadImg(localIds);
                            }
                        }
                    });
                }
            });
        },
        showPic: function showPic(index) {
            weixin_js_sdk_default.a.previewImage({
                current: this.filePath[index], // 当前显示图片的http链接
                urls: this.filePath // 需要预览的图片http链接列表
            });
        },
        delImg: function delImg(index) {
            this.filePath.splice(index, 1);
            this.formData.pics.splice(index, 1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-276315e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/problem.vue
var problem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("照片上传")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-b-16 "},[_vm._l((_vm.filePath),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(index)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2),_vm._v(" "),_c('div',{staticClass:" cm-m-t-16 div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-tb-12"},[_vm._v("问题描述")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.content),expression:"formData.content"}],staticClass:" cm-p-tb-4 cm-w-100 cm-p-lr-4 cm-border cm-border-radius-4 cm-fn-16",staticStyle:{"height":"150px"},attrs:{"placeholder":"150字以内"},domProps:{"value":(_vm.formData.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var problem_staticRenderFns = []
var problem_esExports = { render: problem_render, staticRenderFns: problem_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_problem = (problem_esExports);
// CONCATENATED MODULE: ./src/pages/problem.vue
function problem_injectStyle (ssrContext) {
  __webpack_require__("UUfS")
}
var problem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var problem___vue_template_functional__ = false
/* styles */
var problem___vue_styles__ = problem_injectStyle
/* scopeId */
var problem___vue_scopeId__ = "data-v-276315e8"
/* moduleIdentifier (server only) */
var problem___vue_module_identifier__ = null
var problem_Component = problem_normalizeComponent(
  selectortype_script_index_0_src_pages_problem,
  selectortype_template_index_0_src_pages_problem,
  problem___vue_template_functional__,
  problem___vue_styles__,
  problem___vue_scopeId__,
  problem___vue_module_identifier__
)

/* harmony default export */ var src_pages_problem = (problem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/orderDetail.vue










/* harmony default export */ var orderDetail = ({
  name: 'orderDetail',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      id: 0,
      deliveryStatus: false,
      info: {},
      filePath: [],
      formData: {
        id: 0,
        pics: []
      },
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 21,
      days: 30
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.formData.id = this.id;
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      this.getInfo();
    }
    this.config();
    this.setDate();
  },
  amount: function amount() {},

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = src_customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.getInfo();
          }
        }
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.orderDetial({ id: this.id }).then(function (res) {
        if (res) {
          _this2.info = res.data;
        }
      });
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this3 = this;

      this.info.home_time = val;
      this.$api.editHomeTime({ id: this.id, home_time: val }).then(function (res) {
        if (res) {
          _this3.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.info.problem.pics_path[index], // 当前显示图片的http链接
        urls: this.info.problem.pics_path
      });
    },
    showPic1: function showPic1(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delivery: function delivery() {
      this.deliveryStatus = true;
    },
    closeDelivery: function closeDelivery() {
      this.deliveryStatus = false;
      this.filePath = [];
      this.formData.pics = [];
    },
    changeStatus: function changeStatus(id, status) {
      var that = this;
      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      that.$func.confirm('确认操作？', '提示', function () {
        that.$api.changeStatus({ id: id, status: status, type: that.info.type }).then(function (res) {
          if (res) {
            setTimeout(function () {
              that.getInfo();
            }, 300);
          }
        });
      });
    },
    submitDelivery: function submitDelivery() {
      var that = this;
      that.$func.confirm('确认已配送？', '提示', function () {
        that.$api.submitDelivery(that.formData).then(function (res) {
          if (res) {
            that.deliveryStatus = false;
            that.filePath = [];
            that.formData.pics = [];
            that.getInfo();
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'delivery' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/orderDetail.vue










/* harmony default export */ var pages_orderDetail = ({
  name: 'orderDetail',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      id: 0,
      deliveryStatus: false,
      info: {},
      filePath: [],
      formData: {
        id: 0,
        pics: []
      },
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 8,
      maxHour: 21,
      days: 30
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.formData.id = this.id;
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      this.getInfo();
    }
    this.config();
    this.setDate();
  },
  amount: function amount() {},

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = src_customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.getInfo();
          }
        }
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.orderDetial({ id: this.id }).then(function (res) {
        if (res) {
          _this2.info = res.data;
        }
      });
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    datetimeShow: function datetimeShow() {
      this.datetimeStatus = true;
    },
    datetimeChange: function datetimeChange(val) {
      var _this3 = this;

      this.info.home_time = val;
      this.$api.editHomeTime({ id: this.id, home_time: val }).then(function (res) {
        if (res) {
          _this3.$func.showToast('已修改');
        }
      });
      this.datetimeStatus = false;
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.info.problem.pics_path[index], // 当前显示图片的http链接
        urls: this.info.problem.pics_path
      });
    },
    showPic1: function showPic1(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delivery: function delivery() {
      this.deliveryStatus = true;
    },
    closeDelivery: function closeDelivery() {
      this.deliveryStatus = false;
      this.filePath = [];
      this.formData.pics = [];
    },
    changeStatus: function changeStatus(id, status) {
      var that = this;
      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      that.$func.confirm('确认操作？', '提示', function () {
        that.$api.changeStatus({ id: id, status: status, type: that.info.type }).then(function (res) {
          if (res) {
            setTimeout(function () {
              that.getInfo();
            }, 300);
          }
        });
      });
    },
    submitDelivery: function submitDelivery() {
      var that = this;
      that.$func.confirm('确认已配送？', '提示', function () {
        that.$api.submitDelivery(that.formData).then(function (res) {
          if (res) {
            that.deliveryStatus = false;
            that.filePath = [];
            that.formData.pics = [];
            that.getInfo();
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'delivery' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6dbc6e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderDetail.vue
var orderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"list-bg"},[_c('ul',[_c('li',{staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[(_vm.info.type == 2)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(_vm.info.status < 7)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(_vm.info.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(_vm.info.status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+_vm.info.phone}},[_vm._v(_vm._s(_vm.info.phone))]),_vm._v(" "+_vm._s(_vm.info.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(_vm.info.address.address)+" "+_vm._s(_vm.info.address.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(_vm.info.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.info.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(_vm.info.create_time))]),_vm._v(" "),(_vm.info.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："+_vm._s(_vm.info.home_time))]):_vm._e(),_vm._v(" "),(_vm.info.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(_vm.info.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("订单金额："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.info.amount))])]),_vm._v(" "),(_vm.info.diff_price > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("补差价："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.info.diff_price))])]):_vm._e()])]),_vm._v(" "),(_vm.info.worker_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_c('a',{attrs:{"href":'tel:'+_vm.info.worker.phone}},[_vm._v(_vm._s(_vm.info.worker.phone))]),_vm._v(" "+_vm._s(_vm.info.worker.name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},_vm._l((_vm.info.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),0)]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(_vm.info.status < 9)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-orange"},[_vm._v(_vm._s(_vm.info.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(_vm.info.status_text))]),_vm._v(" "),(_vm.info.sms_code)?_c('div',{staticClass:"cm-p-tb-2 cm-m-t-16 cm-p-lr-8 cm-bg-666 cm-color-yellow cm-fn-18"},[_vm._v(_vm._s(_vm.info.sms_code))]):(_vm.info.out_time)?_c('div',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(_vm.info.out_time))]):_c('div')]),_vm._v(" "),(_vm.info.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+_vm.info.phone}},[_vm._v(_vm._s(_vm.info.phone))]),_vm._v(" "+_vm._s(_vm.info.name))]):_vm._e(),_vm._v(" "),(_vm.info.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(_vm.info.house_number))]):_vm._e(),_vm._v(" "),(_vm.info.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(_vm.info.address.address)+" "+_vm._s(_vm.info.address.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(_vm.info.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.info.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(_vm.info.create_time))]),_vm._v(" "),(_vm.info.type == 1)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(_vm.info.goods_num)+"件")]):_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("商品数量："+_vm._s(_vm.info.goods_num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("配送方式："+_vm._s(_vm.info.delivery_way_text))]),_vm._v(" "),(_vm.$func.checkAuth('editHomeTime'))?_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.info.home_time))])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222 cm-m-l-16",attrs:{"format":"YYYY-MM-DD HH:mm","end-date":_vm.endDate,"start-date":_vm.startDate,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus,"hour-list":['08','09', '10', '11', '12', '13', '14', '15', '16', '17', '18','19','20','21'],"minute-list":['00', '30']},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-fn-14 cm-color-main"},[_vm._v("修改")])])],1):_vm._e(),_vm._v(" "),(_vm.info.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(_vm.info.remark))]):_vm._e(),_vm._v(" "),(_vm.info.type == 1 && _vm.info.collect_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("收衣时间："+_vm._s(_vm.info.collect_time))]):_vm._e(),_vm._v(" "),(_vm.info.special_title)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("会员卡特权："+_vm._s(_vm.info.special_title))]):_vm._e()]),_vm._v(" "),((_vm.info.status == 8 || _vm.info.status == 2) && _vm.info.uupt)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("跑男信息")]),_vm._v(" "),(_vm.info.uupt.driver_name)?_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-30",attrs:{"src":_vm.info.uupt.driver_photo,"lazy-load":true}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("跑男姓名："+_vm._s(_vm.info.uupt.driver_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("跑男电话："),_c('a',{staticClass:"cm-color-666",attrs:{"href":'tel:'+_vm.info.uupt.driver_mobile}},[_vm._v(_vm._s(_vm.info.uu_order.driver_mobile))])])])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-8"},[_vm._v("跑男抢单中。。。")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(_vm.info.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(_vm.info.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.info.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(_vm.info.num)+"件衣物 洗涤费用￥"+_vm._s(_vm.info.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(_vm.info.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+_vm.info.phone}},[_vm._v("联系客户")])]):_vm._e()])])])]),_vm._v(" "),(_vm.info.problem)?_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16 problem"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("问题上报信息")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-b-16 "},_vm._l((_vm.info.problem.pics_path),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(index)}}})])}),0),_vm._v(" "),_c('div',{staticClass:" cm-m-t-16 div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-tb-12"},[_vm._v("问题描述")]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-w-100 cm-p-lr-4 cm-fn-16 cm-text-left"},[_vm._v(_vm._s(_vm.info.problem.content))])])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticClass:"delivery",attrs:{"position":"bottom"},model:{value:(_vm.deliveryStatus),callback:function ($$v) {_vm.deliveryStatus=$$v},expression:"deliveryStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16 cm-mh-100"},[_c('div',{staticClass:"cm-p-b-12 cm-text-left"},[_vm._v("请拍照记录")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list",staticStyle:{"height":"350px","overflow-y":"scroll"}},[_vm._l((_vm.filePath),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic1(index)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-32 cm-p-tb-16 button border-t"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-p-tb-12 cm-center cm-p-lr-32",on:{"click":_vm.closeDelivery}},[_vm._v("关闭")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-m-l-16 cm-p-tb-12 cm-center cm-p-lr-32 cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.submitDelivery()}}},[_vm._v("提交")])])])])],1)])}
var orderDetail_staticRenderFns = []
var orderDetail_esExports = { render: orderDetail_render, staticRenderFns: orderDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_orderDetail = (orderDetail_esExports);
// CONCATENATED MODULE: ./src/pages/orderDetail.vue
function orderDetail_injectStyle (ssrContext) {
  __webpack_require__("HNfe")
}
var orderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderDetail___vue_template_functional__ = false
/* styles */
var orderDetail___vue_styles__ = orderDetail_injectStyle
/* scopeId */
var orderDetail___vue_scopeId__ = "data-v-c6dbc6e4"
/* moduleIdentifier (server only) */
var orderDetail___vue_module_identifier__ = null
var orderDetail_Component = orderDetail_normalizeComponent(
  pages_orderDetail,
  selectortype_template_index_0_src_pages_orderDetail,
  orderDetail___vue_template_functional__,
  orderDetail___vue_styles__,
  orderDetail___vue_scopeId__,
  orderDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_orderDetail = (orderDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myInvite.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_myInvite = ({
  name: 'myInvite',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      order: 'total_amount',
      active: 0,
      nav: [{
        key: 'total_amount',
        title: '累计营业额'
      }, {
        key: 'total_reward',
        title: '累计返佣'
      }, {
        key: 'month_amount',
        title: '当月营业额'
      }, {
        key: 'month_reward',
        title: '当月返佣'
      }],
      list: []
    };
  },
  created: function created() {
    this.getList();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    orderSort: function orderSort(index) {
      this.active = index;
      this.order = this.nav[index].key;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.myInvite({ last_id: this.lastId, page_flag: this.pageFlag, order: this.order }).then(function (res) {
        if (res) {
          // console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          _this.list = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myInvite.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_myInvite = ({
  name: 'myInvite',
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      order: 'total_amount',
      active: 0,
      nav: [{
        key: 'total_amount',
        title: '累计营业额'
      }, {
        key: 'total_reward',
        title: '累计返佣'
      }, {
        key: 'month_amount',
        title: '当月营业额'
      }, {
        key: 'month_reward',
        title: '当月返佣'
      }],
      list: []
    };
  },
  created: function created() {
    this.getList();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    orderSort: function orderSort(index) {
      this.active = index;
      this.order = this.nav[index].key;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.myInvite({ last_id: this.lastId, page_flag: this.pageFlag, order: this.order }).then(function (res) {
        if (res) {
          // console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          _this.list = res.data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1809194","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/myInvite.vue
var myInvite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"nav cm-bg-white cm-pf cm-w-100"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12"},_vm._l((_vm.nav),function(item,index){return _c('div',{key:index,staticClass:"cm-center",on:{"click":function($event){return _vm.orderSort(index)}}},[_c('p',{class:_vm.active == index ? 'cm-color-block' : 'cm-color-666'},[_vm._v(_vm._s(item.title))]),_c('img',{staticClass:"cm-icon-12 cm-m-l-2",attrs:{"src":_vm.active == index ? '/static/images/down-arrow.png' : '/static/images/closePoster.png'}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg cm-p-b-16"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-tb-8 cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-fn-weight-default cm-color-red cm-fn-16"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-t-8 numbers"},[_c('div',[_vm._v(_vm._s(item.total_amount))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.total_reward))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.month_amount))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.month_reward))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8"},[_c('router-link',{staticClass:"cm-p-tb-2 cm-p-lr-12 cm-border-radius-5 cm-m-r-12 cm-center cm-bg-red cm-color-white",attrs:{"to":'/addVisit/'+item.id+'/'+item.name}},[_vm._v("新增拜访记录")]),_vm._v(" "),_c('router-link',{staticClass:"cm-border cm-p-tb-2 cm-p-lr-12 cm-border-radius-5 cm-center cm-bg-white cm-color-block",attrs:{"to":'/visit/'+item.id+'/'+item.name}},[_vm._v("拜访记录")])],1)])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var myInvite_staticRenderFns = []
var myInvite_esExports = { render: myInvite_render, staticRenderFns: myInvite_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_myInvite = (myInvite_esExports);
// CONCATENATED MODULE: ./src/pages/myInvite.vue
function myInvite_injectStyle (ssrContext) {
  __webpack_require__("R1fz")
}
var myInvite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myInvite___vue_template_functional__ = false
/* styles */
var myInvite___vue_styles__ = myInvite_injectStyle
/* scopeId */
var myInvite___vue_scopeId__ = "data-v-b1809194"
/* moduleIdentifier (server only) */
var myInvite___vue_module_identifier__ = null
var myInvite_Component = myInvite_normalizeComponent(
  selectortype_script_index_0_src_pages_myInvite,
  selectortype_template_index_0_src_pages_myInvite,
  myInvite___vue_template_functional__,
  myInvite___vue_styles__,
  myInvite___vue_scopeId__,
  myInvite___vue_module_identifier__
)

/* harmony default export */ var src_pages_myInvite = (myInvite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/addVisit.vue



/* harmony default export */ var addVisit = ({
  name: 'addVisit',
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        cid: 0,
        labels: '',
        content: '',
        visit_time: ''
      },
      title: '',
      labels: [],
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 6,
      maxHour: 24,
      days: 7
    };
  },
  created: function created() {
    this.formData.cid = Number(this.$route.params.cid);
    this.formData.id = Number(this.$route.params.id);
    this.title = this.$route.params.title;
    this.setDate();
    this.visitLabels();
  },
  mounted: function mounted() {
    if (this.formData.id > 0) {
      this.getInfo();
    }
  },
  activated: function activated() {},

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate() - 7,
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      if (!this.formData.id) {
        this.formData.visit_time = this.endDate;
      }
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.visit_time = val;
      this.datetimeStatus = false;
    },
    addLabel: function addLabel(title) {
      if (title) {
        this.formData.labels += '#' + title;
      } else {
        this.formData.labels += '#';
      }
      this.$refs.textarea.focus();
    },
    getInfo: function getInfo() {
      var _this = this;

      this.$api.visit({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data[0];
        }
      });
    },
    visitLabels: function visitLabels() {
      var _this2 = this;

      this.$api.visitLabels({}).then(function (res) {
        if (res) {
          _this2.labels = res.data;
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.cid) {
        this.$func.showToast('社区id不存在');
        return false;
      }
      if (!this.formData.labels) {
        this.$func.showToast('请添加拜访标签');
        return false;
      }
      if (!this.formData.visit_time) {
        this.$func.showToast('请选择拜访时间');
        return false;
      }
      this.$api.submitVisit(this.formData).then(function (res) {
        if (res) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 1000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/addVisit.vue



/* harmony default export */ var pages_addVisit = ({
  name: 'addVisit',
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        cid: 0,
        labels: '',
        content: '',
        visit_time: ''
      },
      title: '',
      labels: [],
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 6,
      maxHour: 24,
      days: 7
    };
  },
  created: function created() {
    this.formData.cid = Number(this.$route.params.cid);
    this.formData.id = Number(this.$route.params.id);
    this.title = this.$route.params.title;
    this.setDate();
    this.visitLabels();
  },
  mounted: function mounted() {
    if (this.formData.id > 0) {
      this.getInfo();
    }
  },
  activated: function activated() {},

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate() - 7,
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      this.minHour = date.hour + 1;
      if (nowDate.getHours() >= this.maxHour - 1) {
        var date = new Date(this.startDate);
        date.setDate(date.getDate() + 1);
        var date1 = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
        this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      }
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      if (!this.formData.id) {
        this.formData.visit_time = this.endDate;
      }
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.visit_time = val;
      this.datetimeStatus = false;
    },
    addLabel: function addLabel(title) {
      if (title) {
        this.formData.labels += '#' + title;
      } else {
        this.formData.labels += '#';
      }
      this.$refs.textarea.focus();
    },
    getInfo: function getInfo() {
      var _this = this;

      this.$api.visit({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data[0];
        }
      });
    },
    visitLabels: function visitLabels() {
      var _this2 = this;

      this.$api.visitLabels({}).then(function (res) {
        if (res) {
          _this2.labels = res.data;
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.cid) {
        this.$func.showToast('社区id不存在');
        return false;
      }
      if (!this.formData.labels) {
        this.$func.showToast('请添加拜访标签');
        return false;
      }
      if (!this.formData.visit_time) {
        this.$func.showToast('请选择拜访时间');
        return false;
      }
      this.$api.submitVisit(this.formData).then(function (res) {
        if (res) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 1000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615252f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/addVisit.vue
var addVisit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-p-tb-16 cm-p-lr-12 cm-bg-white "},[_c('div',{staticClass:"cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("拜访社区")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:" cm-p-tb-8 cm-w-100 cm-fn-16 cm-border-bottom-1",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("拜访标签")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.labels),expression:"formData.labels"}],ref:"textarea",staticClass:" cm-p-tb-4 cm-w-100 cm-p-lr-4 ",staticStyle:{"height":"80px","border":"unset"},attrs:{"placeholder":"请使用#号隔开"},domProps:{"value":(_vm.formData.labels)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "labels", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},[_c('div',{staticClass:"cm-border-radius-10 cm-bg-block cm-color-white cm-border cm-p-lr-4 cm-p-tb-2 cm-m-t-4 cm-center cm-m-r-4",staticStyle:{"width":"50px"},on:{"click":function($event){return _vm.addLabel()}}},[_vm._v("#标签")]),_vm._v(" "),_vm._l((_vm.labels),function(val,i){return _c('div',{key:i,staticClass:"cm-p-tb-2 cm-p-lr-4 cm-bg-red cm-border-radius-6 cm-m-t-4 cm-m-r-4 cm-color-white",on:{"click":function($event){return _vm.addLabel(val.title)}}},[_vm._v("#"+_vm._s(val.title))])})],2)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("拜访备注")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.content),expression:"formData.content"}],staticClass:" cm-p-tb-4 cm-w-100 cm-p-lr-4 ",staticStyle:{"height":"100px","border":"unset"},attrs:{"placeholder":"150字以内(非必填)"},domProps:{"value":(_vm.formData.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("拜访时间")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222",attrs:{"format":"YYYY-MM-DD","end-date":_vm.endDate,"start-date":_vm.startDate,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222"},[_vm._v(_vm._s(_vm.formData.visit_time))])])],1),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var addVisit_staticRenderFns = []
var addVisit_esExports = { render: addVisit_render, staticRenderFns: addVisit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_addVisit = (addVisit_esExports);
// CONCATENATED MODULE: ./src/pages/addVisit.vue
function addVisit_injectStyle (ssrContext) {
  __webpack_require__("1IHr")
}
var addVisit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addVisit___vue_template_functional__ = false
/* styles */
var addVisit___vue_styles__ = addVisit_injectStyle
/* scopeId */
var addVisit___vue_scopeId__ = "data-v-615252f4"
/* moduleIdentifier (server only) */
var addVisit___vue_module_identifier__ = null
var addVisit_Component = addVisit_normalizeComponent(
  pages_addVisit,
  selectortype_template_index_0_src_pages_addVisit,
  addVisit___vue_template_functional__,
  addVisit___vue_styles__,
  addVisit___vue_scopeId__,
  addVisit___vue_module_identifier__
)

/* harmony default export */ var src_pages_addVisit = (addVisit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/visit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_visit = ({
    name: 'visit',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            cid: 0,
            title: ''
        };
    },
    mounted: function mounted() {
        this.cid = Number(this.$route.params.cid);
        this.title = this.$route.params.title;
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.$api.visit({ last_id: this.lastId, page_flag: this.pageFlag, cid: this.cid }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        detail: function detail(id) {
            this.$router.push({ name: 'addVisit', params: { cid: this.cid, title: this.title, id: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/visit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_visit = ({
    name: 'visit',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            cid: 0,
            title: ''
        };
    },
    mounted: function mounted() {
        this.cid = Number(this.$route.params.cid);
        this.title = this.$route.params.title;
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.$api.visit({ last_id: this.lastId, page_flag: this.pageFlag, cid: this.cid }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        detail: function detail(id) {
            this.$router.push({ name: 'addVisit', params: { cid: this.cid, title: this.title, id: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed00fa14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/visit.vue
var visit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:" cm-p-tb-12 cm-pf cm-bg-white",staticStyle:{"z-index":"100","top":"0","left":"0"}},[_c('div',{staticClass:"cm-p-lr-16 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-red cm-fn-16"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('router-link',{staticClass:"cm-p-tb-2 cm-p-lr-12 cm-border-radius-5 cm-m-r-12 cm-center cm-bg-red cm-color-white",attrs:{"to":'/addVisit/'+_vm.cid+'/'+_vm.title}},[_vm._v("新增拜访记录")])],1)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12  cm-p-tb-12 cm-bg-white cm-p-lr-12 ",on:{"click":function($event){return _vm.detail(item.id)}}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((item.label),function(val,i){return _c('div',{key:i,staticClass:"cm-p-tb-2 cm-p-lr-4 cm-bg-red cm-border-radius-6 cm-m-t-4 cm-m-r-4 cm-color-white"},[_vm._v(_vm._s(val))])}),0),_vm._v(" "),_c('div',{staticClass:" cm-p-tb-12 cm-border-bottom-1"},[_vm._v("\n                "+_vm._s(item.content)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-m-t-8"},[_vm._v("拜访时间："+_vm._s(item.visit_time))])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var visit_staticRenderFns = []
var visit_esExports = { render: visit_render, staticRenderFns: visit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_visit = (visit_esExports);
// CONCATENATED MODULE: ./src/pages/visit.vue
function visit_injectStyle (ssrContext) {
  __webpack_require__("YSb3")
}
var visit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var visit___vue_template_functional__ = false
/* styles */
var visit___vue_styles__ = visit_injectStyle
/* scopeId */
var visit___vue_scopeId__ = "data-v-ed00fa14"
/* moduleIdentifier (server only) */
var visit___vue_module_identifier__ = null
var visit_Component = visit_normalizeComponent(
  selectortype_script_index_0_src_pages_visit,
  selectortype_template_index_0_src_pages_visit,
  visit___vue_template_functional__,
  visit___vue_styles__,
  visit___vue_scopeId__,
  visit___vue_module_identifier__
)

/* harmony default export */ var src_pages_visit = (visit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/countReward.vue











/* harmony default export */ var pages_countReward = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      total: 0,
      money1: 0,
      money2: 0,
      startDate: '',
      endDate: '',
      operater1: '',
      operater: '请选择',
      operater_id: 0,
      operaterArr: [],
      list: [{ "date": "2010-01-10", "type": "总计", "value": 0 }, { "date": "2010-01-10", "type": "社区", "value": 0 }, { "date": "2010-01-10", "type": "进出", "value": 0 }]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    getData: function getData() {
      var _this = this;

      this.$api.countReward({ startDate: this.startDate, endDate: this.endDate }).then(function (res) {
        if (res) {
          _this.list = res.data.list;
          _this.total = res.data.total;
          _this.money1 = res.data.money1;
          _this.money2 = res.data.money2;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/countReward.vue











/* harmony default export */ var selectortype_script_index_0_src_pages_countReward = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    VChart: src_components_v_chart_v_chart,
    VAxis: components_v_chart_v_axis,
    VLine: components_v_chart_v_line,
    VScale: components_v_chart_v_scale,
    VTooltip: components_v_chart_v_tooltip
  },
  data: function data() {
    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      total: 0,
      money1: 0,
      money2: 0,
      startDate: '',
      endDate: '',
      operater1: '',
      operater: '请选择',
      operater_id: 0,
      operaterArr: [],
      list: [{ "date": "2010-01-10", "type": "总计", "value": 0 }, { "date": "2010-01-10", "type": "社区", "value": 0 }, { "date": "2010-01-10", "type": "进出", "value": 0 }]
    };
  },
  created: function created() {
    this.setDate();
    this.getData();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    getData: function getData() {
      var _this = this;

      this.$api.countReward({ startDate: this.startDate, endDate: this.endDate }).then(function (res) {
        if (res) {
          _this.list = res.data.list;
          _this.total = res.data.total;
          _this.money1 = res.data.money1;
          _this.money2 = res.data.money2;
          _this.$refs.echart.rerender();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c444981","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/countReward.vue
var countReward_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开始日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("结束日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-m-tb-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getData}},[_c('p',{staticClass:"cm-w-100 cm-h-100 cm-center cm-color-white"},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-32 cm-flex-middle cm-flex-between cm-bg-white"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("总计 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.total,"duration":1.2,"decimals":1}},[_vm._v("元")])],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("社区 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.money1,"duration":1.2,"decimals":1}},[_vm._v("元")])],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("进出 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min",attrs:{"start-val":0,"end-val":_vm.money2,"duration":1.2,"decimals":1}},[_vm._v("元")])],1)]),_vm._v(" "),_c('v-chart',{ref:"echart",attrs:{"data":_vm.list}},[_c('v-line',{attrs:{"series-field":"type"}})],1),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var countReward_staticRenderFns = []
var countReward_esExports = { render: countReward_render, staticRenderFns: countReward_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_countReward = (countReward_esExports);
// CONCATENATED MODULE: ./src/pages/countReward.vue
function countReward_injectStyle (ssrContext) {
  __webpack_require__("kznd")
}
var countReward_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var countReward___vue_template_functional__ = false
/* styles */
var countReward___vue_styles__ = countReward_injectStyle
/* scopeId */
var countReward___vue_scopeId__ = "data-v-1c444981"
/* moduleIdentifier (server only) */
var countReward___vue_module_identifier__ = null
var countReward_Component = countReward_normalizeComponent(
  selectortype_script_index_0_src_pages_countReward,
  selectortype_template_index_0_src_pages_countReward,
  countReward___vue_template_functional__,
  countReward___vue_styles__,
  countReward___vue_scopeId__,
  countReward___vue_module_identifier__
)

/* harmony default export */ var src_pages_countReward = (countReward_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outTimeOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_outTimeOrder = ({
    name: 'outTimeOrder',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    inject: ['reload'],
    data: function data() {
        return {
            title: '超时订单',
            grade: 0,
            isActive: 3,
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            type: 0,
            itemId: 0,
            list: [],
            days: [{
                key: 3,
                text: '三天以上'
            }, {
                key: 4,
                text: '四天以上'
            }, {
                key: 5,
                text: '五天以上'
            }, {
                key: 10,
                text: '十天以上'
            }]
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.grade = parseInt(this.$func.getLocal('grade'));
        // if(this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8){
        //     this.getWorker();
        // }
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectDays: function selectDays(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.outTimeOrder({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, day: this.isActive }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outTimeOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_outTimeOrder = ({
    name: 'outTimeOrder',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    inject: ['reload'],
    data: function data() {
        return {
            title: '超时订单',
            grade: 0,
            isActive: 3,
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            type: 0,
            itemId: 0,
            list: [],
            days: [{
                key: 3,
                text: '三天以上'
            }, {
                key: 4,
                text: '四天以上'
            }, {
                key: 5,
                text: '五天以上'
            }, {
                key: 10,
                text: '十天以上'
            }]
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.grade = parseInt(this.$func.getLocal('grade'));
        // if(this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8){
        //     this.getWorker();
        // }
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectDays: function selectDays(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.outTimeOrder({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, day: this.isActive }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3231ae74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/outTimeOrder.vue
var outTimeOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"number","placeholder":"手机号或订单号后四位"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"nav cm-bg-white shadow-gray",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.days),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 ",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectDays(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(item.out_time))])]),_vm._v(" "),(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name))]):_vm._e(),_vm._v(" "),(_vm.grade == 10)?_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("社区："+_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666 cm-fn-weight-default"},[_vm._v("收衣时间："+_vm._s(item.collect_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])])]):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var outTimeOrder_staticRenderFns = []
var outTimeOrder_esExports = { render: outTimeOrder_render, staticRenderFns: outTimeOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_outTimeOrder = (outTimeOrder_esExports);
// CONCATENATED MODULE: ./src/pages/outTimeOrder.vue
function outTimeOrder_injectStyle (ssrContext) {
  __webpack_require__("E9z0")
}
var outTimeOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var outTimeOrder___vue_template_functional__ = false
/* styles */
var outTimeOrder___vue_styles__ = outTimeOrder_injectStyle
/* scopeId */
var outTimeOrder___vue_scopeId__ = "data-v-3231ae74"
/* moduleIdentifier (server only) */
var outTimeOrder___vue_module_identifier__ = null
var outTimeOrder_Component = outTimeOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_outTimeOrder,
  selectortype_template_index_0_src_pages_outTimeOrder,
  outTimeOrder___vue_template_functional__,
  outTimeOrder___vue_styles__,
  outTimeOrder___vue_scopeId__,
  outTimeOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_outTimeOrder = (outTimeOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/product.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var product = ({
  name: 'product',
  components: {},
  data: function data() {
    return {
      type: 3,
      count: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getOrderCount();
  },

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/product.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_product = ({
  name: 'product',
  components: {},
  data: function data() {
    return {
      type: 3,
      count: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getOrderCount();
  },

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23acc33a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/product.vue
var product_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("商品服务")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-around cm-flex-middle"},[(_vm.$func.checkAuth('order/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":'/order/'+_vm.type+'/4'}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待核销")]),_vm._v(" "),(_vm.count[4] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('productVerify'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/productVerify"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status6.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("订单核销")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-36 cm-p-lr-16 cm-bg-white cm-p-b-40"},[(_vm.$func.checkAuth('order/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+2}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待配送")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[2] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+3}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("配送中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待核销")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+9}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+10}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var product_staticRenderFns = []
var product_esExports = { render: product_render, staticRenderFns: product_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_product = (product_esExports);
// CONCATENATED MODULE: ./src/pages/product.vue
function product_injectStyle (ssrContext) {
  __webpack_require__("S5Ll")
}
var product_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var product___vue_template_functional__ = false
/* styles */
var product___vue_styles__ = product_injectStyle
/* scopeId */
var product___vue_scopeId__ = "data-v-23acc33a"
/* moduleIdentifier (server only) */
var product___vue_module_identifier__ = null
var product_Component = product_normalizeComponent(
  pages_product,
  selectortype_template_index_0_src_pages_product,
  product___vue_template_functional__,
  product___vue_styles__,
  product___vue_scopeId__,
  product___vue_module_identifier__
)

/* harmony default export */ var src_pages_product = (product_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myProduct.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var myProduct = ({
    name: 'myProduct',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        var _ref;

        return _ref = {
            title: '本店商品',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false
        }, defineProperty_default()(_ref, 'title', ''), defineProperty_default()(_ref, 'pageFlag', 2), defineProperty_default()(_ref, 'hasNext', 0), defineProperty_default()(_ref, 'lastId', 0), defineProperty_default()(_ref, 'list', []), _ref;
    },
    created: function created() {},
    amount: function amount() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.productList({ last_id: this.lastId, page_flag: this.pageFlag, title: this.title }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        showPic: function showPic(item, index) {
            weixin_js_sdk_default.a.previewImage({
                current: item[index], // 当前显示图片的http链接
                urls: item // 需要预览的图片http链接列表
            });
        },
        edit: function edit(id) {
            this.$router.push({ name: 'addProduct', params: { id: id } });
        },
        del: function del(id) {
            var _this2 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this2.$api.changeProductStatus({ id: id }).then(function (res) {
                    if (res) {
                        setTimeout(function () {
                            _this2.list = [];
                            _this2.lastId = 0;
                            _this2.hasNext = 0;
                            _this2.loadmore();
                        }, 300);
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/myProduct.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_myProduct = ({
    name: 'myProduct',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        var _ref;

        return _ref = {
            title: '本店商品',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false
        }, defineProperty_default()(_ref, 'title', ''), defineProperty_default()(_ref, 'pageFlag', 2), defineProperty_default()(_ref, 'hasNext', 0), defineProperty_default()(_ref, 'lastId', 0), defineProperty_default()(_ref, 'list', []), _ref;
    },
    created: function created() {},
    amount: function amount() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.productList({ last_id: this.lastId, page_flag: this.pageFlag, title: this.title }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        showPic: function showPic(item, index) {
            weixin_js_sdk_default.a.previewImage({
                current: item[index], // 当前显示图片的http链接
                urls: item // 需要预览的图片http链接列表
            });
        },
        edit: function edit(id) {
            this.$router.push({ name: 'addProduct', params: { id: id } });
        },
        del: function del(id) {
            var _this2 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this2.$api.changeProductStatus({ id: id }).then(function (res) {
                    if (res) {
                        setTimeout(function () {
                            _this2.list = [];
                            _this2.lastId = 0;
                            _this2.hasNext = 0;
                            _this2.loadmore();
                        }, 300);
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e837467c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/myProduct.vue
var myProduct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"商品名称"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.edit(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-p-lr-12 cm-bg-white cm-p-tb-12 cm-m-t-4"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-b-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(item.title)),_c('span',{staticClass:"cm-color-666 cm-fn-14 cm-m-l-8 cm-fn-weight-default"},[_vm._v(_vm._s(item.attr))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-green"},[_vm._v(_vm._s(item.category.name))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-12"},_vm._l((item.pics_path),function(img,i){return _c('div',{key:i,staticClass:"cm-img-box image cm-m-r-12",on:{"click":function($event){return _vm.showPic(item.pics_path,i)}}},[_c('img',{attrs:{"src":img}})])}),0),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12  cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v("单价:￥"+_vm._s(item.price))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-12"},[_c('div',{staticClass:"cm-border cm-p-tb-4 cm-border-radius-5 cm-center cm-p-lr-12 cm-m-r-24",on:{"click":function($event){return _vm.edit(item.id)}}},[_vm._v("编辑")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-4 cm-border-radius-5 cm-center cm-p-lr-12 cm-bg-red cm-color-white",on:{"click":function($event){return _vm.del(item.id)}}},[_vm._v("删除")])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var myProduct_staticRenderFns = []
var myProduct_esExports = { render: myProduct_render, staticRenderFns: myProduct_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_myProduct = (myProduct_esExports);
// CONCATENATED MODULE: ./src/pages/myProduct.vue
function myProduct_injectStyle (ssrContext) {
  __webpack_require__("A9r3")
}
var myProduct_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myProduct___vue_template_functional__ = false
/* styles */
var myProduct___vue_styles__ = myProduct_injectStyle
/* scopeId */
var myProduct___vue_scopeId__ = "data-v-e837467c"
/* moduleIdentifier (server only) */
var myProduct___vue_module_identifier__ = null
var myProduct_Component = myProduct_normalizeComponent(
  pages_myProduct,
  selectortype_template_index_0_src_pages_myProduct,
  myProduct___vue_template_functional__,
  myProduct___vue_styles__,
  myProduct___vue_scopeId__,
  myProduct___vue_module_identifier__
)

/* harmony default export */ var src_pages_myProduct = (myProduct_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dacecb72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("sVG7")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7667bbe5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("Mxix")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/addProduct.vue







/* harmony default export */ var addProduct = ({
  name: 'addProduct',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      pop: false,
      filePath: [],
      formData: {
        id: 0,
        title: '',
        pics: [],
        cate_id: 0,
        attr: '',
        price: '',

        content: ''
      },
      category: [],
      cateName: '请选择分类',
      pickerStatus: false,

      product: [],
      productList: []
    };
  },
  created: function created() {
    this.getCategory();
    this.getProduct();
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.productDetial();
    }
  },

  computed: {},
  methods: {
    handleInput: function handleInput() {
      var _this = this;

      var reg = new RegExp(this.formData.title, 'g');
      var replaceString = '<span class="cm-color-red">' + this.formData.title + '</span>';
      this.productList = this.product.filter(function (item) {
        if (item.title.indexOf(_this.formData.title) > -1) {
          return item.title.replace(_this.formData.title, replaceString);
        }
      });

      this.pop = this.productList.length > 0 ? true : false;
    },
    selectProduct: function selectProduct(item) {
      this.formData.pid = item.id;
      this.formData.title = item.title;
      this.formData.cate_id = item.cate_id;
      this.cateName = item.category.name;
      this.filePath = item.pics_path;
      this.formData.pics = item.pics;
      this.pop = false;
    },
    productDetial: function productDetial() {
      var _this2 = this;

      this.$api.productDetial({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = res.data;
          _this2.cateName = res.data.category.name;
          _this2.filePath = res.data.pics_path;
        }
      });
    },
    getProduct: function getProduct() {
      var _this3 = this;

      this.$api.searchProduct({ title: this.formData.title }).then(function (res) {
        if (res) {
          _this3.product = res.data;
        }
      });
    },
    getCategory: function getCategory() {
      var _this4 = this;

      this.$api.category({}).then(function (res) {
        if (res) {
          _this4.category = res.data;
        }
      });
    },
    cate: function cate(value) {
      this.formData.cate_id = value;
    },
    submit: function submit() {
      var _this5 = this;

      console.log(this.formData);
      if (!this.formData.title) {
        this.$func.showToast('请输入商品名称');
        return false;
      }
      if (!this.formData.cate_id) {
        this.$func.showToast('请选择分类');
        return false;
      }
      if (!this.formData.attr) {
        this.$func.showToast('请输入商品规格');
        return false;
      }
      if (!this.formData.price) {
        this.$func.showToast('请输入商品价格');
        return false;
      }
      if (!this.formData.pics.length) {
        this.$func.showToast('请输入上传照片');
        return false;
      }

      this.$api.submitProduct(this.formData).then(function (res) {
        _this5.$func.showToast('提交成功');
        setTimeout(function () {
          _this5.$router.go(-1);
        }, 300);
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/addProduct.vue







/* harmony default export */ var pages_addProduct = ({
  name: 'addProduct',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      pop: false,
      filePath: [],
      formData: {
        id: 0,
        title: '',
        pics: [],
        cate_id: 0,
        attr: '',
        price: '',

        content: ''
      },
      category: [],
      cateName: '请选择分类',
      pickerStatus: false,

      product: [],
      productList: []
    };
  },
  created: function created() {
    this.getCategory();
    this.getProduct();
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.productDetial();
    }
  },

  computed: {},
  methods: {
    handleInput: function handleInput() {
      var _this = this;

      var reg = new RegExp(this.formData.title, 'g');
      var replaceString = '<span class="cm-color-red">' + this.formData.title + '</span>';
      this.productList = this.product.filter(function (item) {
        if (item.title.indexOf(_this.formData.title) > -1) {
          return item.title.replace(_this.formData.title, replaceString);
        }
      });

      this.pop = this.productList.length > 0 ? true : false;
    },
    selectProduct: function selectProduct(item) {
      this.formData.pid = item.id;
      this.formData.title = item.title;
      this.formData.cate_id = item.cate_id;
      this.cateName = item.category.name;
      this.filePath = item.pics_path;
      this.formData.pics = item.pics;
      this.pop = false;
    },
    productDetial: function productDetial() {
      var _this2 = this;

      this.$api.productDetial({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = res.data;
          _this2.cateName = res.data.category.name;
          _this2.filePath = res.data.pics_path;
        }
      });
    },
    getProduct: function getProduct() {
      var _this3 = this;

      this.$api.searchProduct({ title: this.formData.title }).then(function (res) {
        if (res) {
          _this3.product = res.data;
        }
      });
    },
    getCategory: function getCategory() {
      var _this4 = this;

      this.$api.category({}).then(function (res) {
        if (res) {
          _this4.category = res.data;
        }
      });
    },
    cate: function cate(value) {
      this.formData.cate_id = value;
    },
    submit: function submit() {
      var _this5 = this;

      console.log(this.formData);
      if (!this.formData.title) {
        this.$func.showToast('请输入商品名称');
        return false;
      }
      if (!this.formData.cate_id) {
        this.$func.showToast('请选择分类');
        return false;
      }
      if (!this.formData.attr) {
        this.$func.showToast('请输入商品规格');
        return false;
      }
      if (!this.formData.price) {
        this.$func.showToast('请输入商品价格');
        return false;
      }
      if (!this.formData.pics.length) {
        this.$func.showToast('请输入上传照片');
        return false;
      }

      this.$api.submitProduct(this.formData).then(function (res) {
        _this5.$func.showToast('提交成功');
        setTimeout(function () {
          _this5.$router.go(-1);
        }, 300);
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30322b8d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/addProduct.vue
var addProduct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("商品名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.title),expression:"formData.title"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入商品名称"},domProps:{"value":(_vm.formData.title)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "title", $event.target.value)},_vm.handleInput]}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12  border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("选择分类")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-wrap"},_vm._l((_vm.category),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2",class:item.value == _vm.formData.cate_id ? 'cm-bg-red cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.cate(item.value)}}},[_vm._v(_vm._s(item.name))])}),0)]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("照片上传")]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((_vm.filePath),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(index)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2),_vm._v(" "),_c('p',{staticClass:"cm-p-tb-12 cm-color-666"},[_vm._v("第一张为主图")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("规格")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.attr),expression:"formData.attr"}],staticClass:"cm-fn-16",attrs:{"type":"text","placeholder":"例：30ml"},domProps:{"value":(_vm.formData.attr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "attr", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("价格(￥)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.price),expression:"formData.price"}],staticClass:"cm-fn-16",attrs:{"type":"number","placeholder":"单位（元）","min":"0"},domProps:{"value":(_vm.formData.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("商品描述")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":"150字以内（选填）","height":120},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])]),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"cm-bg",on:{"click":function($event){_vm.pop = false}}}):_vm._e(),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"cm-bg-white cm-w-100 cm-bg-body"},_vm._l((_vm.productList),function(item,index){return _c('div',{key:index,staticClass:"border-b cm-p-tb-8 cm-p-lr-16",on:{"click":function($event){return _vm.selectProduct(item)}}},[_c('p',{},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.category.name))])])}),0):_vm._e()])])}
var addProduct_staticRenderFns = []
var addProduct_esExports = { render: addProduct_render, staticRenderFns: addProduct_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_addProduct = (addProduct_esExports);
// CONCATENATED MODULE: ./src/pages/addProduct.vue
function addProduct_injectStyle (ssrContext) {
  __webpack_require__("aIO9")
}
var addProduct_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addProduct___vue_template_functional__ = false
/* styles */
var addProduct___vue_styles__ = addProduct_injectStyle
/* scopeId */
var addProduct___vue_scopeId__ = "data-v-30322b8d"
/* moduleIdentifier (server only) */
var addProduct___vue_module_identifier__ = null
var addProduct_Component = addProduct_normalizeComponent(
  pages_addProduct,
  selectortype_template_index_0_src_pages_addProduct,
  addProduct___vue_template_functional__,
  addProduct___vue_styles__,
  addProduct___vue_scopeId__,
  addProduct___vue_module_identifier__
)

/* harmony default export */ var src_pages_addProduct = (addProduct_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/editUser.vue




/* harmony default export */ var editUser = ({
  name: 'editUser',
  components: {
    wx: weixin_js_sdk_default.a, CheckIcon: vux_src_components_check_icon
  },
  data: function data() {
    return {
      filePath: '',
      title: '',
      formData: {
        title: '',
        voice_status: false,
        voice_phone: '',
        head_name: '',
        head_phone: '',
        pic: '',
        content: ''
      },
      voiceStatus: false,
      voiceStatusText: '',
      info: {}
    };
  },
  created: function created() {
    this.config();
    this.getInfo();
  },

  computed: {},
  watch: {
    voiceStatus: function voiceStatus(key) {
      this.voiceStatusText = key ? '开启' : '关闭';
      this.formData.voice_status = key;
    }
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.title = res.data.title;
          _this.filePath = res.data.pic_path;
          _this.formData.voice_status = res.data.voice_status ? true : false;
          _this.voiceStatus = res.data.voice_status ? true : false;
          _this.voiceStatusText = res.data.voice_status ? '开启' : '关闭';
          _this.formData.voice_phone = res.data.voice_phone;
          _this.formData.title = res.data.title;
          _this.formData.head_name = res.data.head_name;
          _this.formData.head_phone = res.data.head_phone;
          _this.formData.pic = res.data.pic;
          _this.formData.content = res.data.content;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.head_name) {
        this.$func.showToast('请输入团长姓名');
        return false;
      }
      if (!this.formData.head_phone) {
        this.$func.showToast('请输入团长电话');
        return false;
      }
      if (this.formData.voice_status && !this.formData.voice_phone) {
        this.$func.showToast('请输入语音电话号码');
        return false;
      }
      this.$api.submitCommunity(this.formData).then(function (res) {
        _this2.$func.showToast('提交成功');
        _this2.getInfo();
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath = res.data.url;
              that.formData.pic = res.data.path;
            }
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/editUser.vue




/* harmony default export */ var pages_editUser = ({
  name: 'editUser',
  components: {
    wx: weixin_js_sdk_default.a, CheckIcon: vux_src_components_check_icon
  },
  data: function data() {
    return {
      filePath: '',
      title: '',
      formData: {
        title: '',
        voice_status: false,
        voice_phone: '',
        head_name: '',
        head_phone: '',
        pic: '',
        content: ''
      },
      voiceStatus: false,
      voiceStatusText: '',
      info: {}
    };
  },
  created: function created() {
    this.config();
    this.getInfo();
  },

  computed: {},
  watch: {
    voiceStatus: function voiceStatus(key) {
      this.voiceStatusText = key ? '开启' : '关闭';
      this.formData.voice_status = key;
    }
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.title = res.data.title;
          _this.filePath = res.data.pic_path;
          _this.formData.voice_status = res.data.voice_status ? true : false;
          _this.voiceStatus = res.data.voice_status ? true : false;
          _this.voiceStatusText = res.data.voice_status ? '开启' : '关闭';
          _this.formData.voice_phone = res.data.voice_phone;
          _this.formData.title = res.data.title;
          _this.formData.head_name = res.data.head_name;
          _this.formData.head_phone = res.data.head_phone;
          _this.formData.pic = res.data.pic;
          _this.formData.content = res.data.content;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.head_name) {
        this.$func.showToast('请输入团长姓名');
        return false;
      }
      if (!this.formData.head_phone) {
        this.$func.showToast('请输入团长电话');
        return false;
      }
      if (this.formData.voice_status && !this.formData.voice_phone) {
        this.$func.showToast('请输入语音电话号码');
        return false;
      }
      this.$api.submitCommunity(this.formData).then(function (res) {
        _this2.$func.showToast('提交成功');
        _this2.getInfo();
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath = res.data.url;
              that.formData.pic = res.data.path;
            }
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b7284a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/editUser.vue
var editUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("店名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","disabled":"","placeholder":"请输入店名"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("门面图")]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[(_vm.filePath)?_c('div',{staticClass:"cm-img-box cm-m-l-4 cm-w-100",staticStyle:{"height":"200px"}},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":_vm.filePath},on:{"click":function($event){return _vm.uploadFile()}}})]):_c('div',{staticClass:"cm-m-l-4 cm-w-100 cm-p-tb-32 cm-center",staticStyle:{"height":"140px"}},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":"/static/images/pic_btn_add@2x.png"},on:{"click":function($event){return _vm.uploadFile()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("团长名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.head_name),expression:"formData.head_name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入团长名称"},domProps:{"value":(_vm.formData.head_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "head_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("团长电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.head_phone),expression:"formData.head_phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入团长电话"},domProps:{"value":(_vm.formData.head_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "head_phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b cm-flex-middle cm-flex-between "},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开锁后语音电话提醒")]),_vm._v(" "),_c('check-icon',{attrs:{"value":_vm.voiceStatus},on:{"update:value":function($event){_vm.voiceStatus=$event}}},[_vm._v(" "+_vm._s(_vm.voiceStatusText))])],1),_vm._v(" "),(_vm.voiceStatus)?_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("语音电话号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.voice_phone),expression:"formData.voice_phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入电话"},domProps:{"value":(_vm.formData.voice_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "voice_phone", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("描述")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.content),expression:"formData.content"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"例：社区团购，各种蔬菜果蔬等"},domProps:{"value":(_vm.formData.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var editUser_staticRenderFns = []
var editUser_esExports = { render: editUser_render, staticRenderFns: editUser_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_editUser = (editUser_esExports);
// CONCATENATED MODULE: ./src/pages/editUser.vue
function editUser_injectStyle (ssrContext) {
  __webpack_require__("atlD")
}
var editUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editUser___vue_template_functional__ = false
/* styles */
var editUser___vue_styles__ = editUser_injectStyle
/* scopeId */
var editUser___vue_scopeId__ = "data-v-35b7284a"
/* moduleIdentifier (server only) */
var editUser___vue_module_identifier__ = null
var editUser_Component = editUser_normalizeComponent(
  pages_editUser,
  selectortype_template_index_0_src_pages_editUser,
  editUser___vue_template_functional__,
  editUser___vue_styles__,
  editUser___vue_scopeId__,
  editUser___vue_module_identifier__
)

/* harmony default export */ var src_pages_editUser = (editUser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/wash.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var wash = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/wash.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_wash = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc86dd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wash.vue
var wash_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("洗衣服务")])]),_vm._v(" "),(_vm.$func.checkAuth('wash'))?_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle cm-flex-wrap"},[(_vm.$func.checkAuth('waitCollect'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16  cm-pr",staticStyle:{"width":"30%"},attrs:{"to":"/waitCollect"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待送洗")]),_vm._v(" "),(_vm.count[2] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('wareHouse'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/wareHouse"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status5.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣入库")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('outHouse'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/outHouse"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status6.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣出库")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('backStore'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/backStore"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images//store-visit-lined.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("回店记录")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('clothesConfirm'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-pr row-div",staticStyle:{"width":"30%"},attrs:{"to":"/clothesConfirm"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物确认")]),_vm._v(" "),(_vm.count[11] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[11]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('barOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/barOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/bar.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("条码查询")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('searchOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",staticStyle:{"width":"30%"},attrs:{"to":"/searchOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/searchOrder.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("订单查询")])]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" cm-p-lr-16 cm-bg-white cm-p-b-40",staticStyle:{"margin-top":"140px"}},[(_vm.$func.checkAuth('order/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[0] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[0]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('outTimeOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":"/outTimeOrder"}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("超时订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[10] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[10]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('collectOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+2}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待收衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[2] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+3}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待司机取衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送工厂")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/5'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+5}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("洗涤中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[5] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[5]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+6}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送回")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[6] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[6]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/7'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+7}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待入库")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[7] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[7]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/8'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+8}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待出库")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[8] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[8]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+9}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+10}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var wash_staticRenderFns = []
var wash_esExports = { render: wash_render, staticRenderFns: wash_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_wash = (wash_esExports);
// CONCATENATED MODULE: ./src/pages/wash.vue
function wash_injectStyle (ssrContext) {
  __webpack_require__("RDzS")
}
var wash_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var wash___vue_template_functional__ = false
/* styles */
var wash___vue_styles__ = wash_injectStyle
/* scopeId */
var wash___vue_scopeId__ = "data-v-4bc86dd2"
/* moduleIdentifier (server only) */
var wash___vue_module_identifier__ = null
var wash_Component = wash_normalizeComponent(
  pages_wash,
  selectortype_template_index_0_src_pages_wash,
  wash___vue_template_functional__,
  wash___vue_styles__,
  wash___vue_scopeId__,
  wash___vue_module_identifier__
)

/* harmony default export */ var src_pages_wash = (wash_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/work.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var work = ({
  name: 'work',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 0,
      grade: 0,
      count: [],
      service: {}
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  mounted: function mounted() {
    this.workCount();
  },

  methods: {
    workCount: function workCount() {
      var _this = this;

      this.$api.workCount({}).then(function (res) {
        _this.count = res.data;
        _this.service = res.data.service;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/work.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_work = ({
  name: 'work',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 0,
      grade: 0,
      count: [],
      service: {}
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  mounted: function mounted() {
    this.workCount();
  },

  methods: {
    workCount: function workCount() {
      var _this = this;

      this.$api.workCount({}).then(function (res) {
        _this.count = res.data;
        _this.service = res.data.service;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd278052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work.vue
var work_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-red cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("工单服务")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle cm-flex-wrap"},[(_vm.$func.checkAuth('clotheStatus'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/clotheStatus"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/notstatus.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物状态")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('submitWork'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/submitWork"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/submit.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("发起工单")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('wbarOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",attrs:{"to":"/barOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/bar.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("条码查询")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('wsearchOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",attrs:{"to":"/searchOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/searchOrder.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("订单查询")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('clothesConfirm'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16",attrs:{"to":"/clothesConfirm"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("衣物确认")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:" cm-p-lr-16 cm-bg-white cm-p-b-40",staticStyle:{"margin-top":"140px"}},[(_vm.$func.checkAuth('workorder/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+0}},[_c('p',{staticClass:"cm-fn-16 cm-flex-start cm-flex-middle"},[_vm._v("全部")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/1'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+1}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待分配")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[1] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[1]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+2}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待接单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[2] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+3}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("处理中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待前端确认")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/5'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+5}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('workorder/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/workorder/'+6}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已撤销")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1),_vm._v(" "),_c('cmFooter',{attrs:{"active":1}})],1)}
var work_staticRenderFns = []
var work_esExports = { render: work_render, staticRenderFns: work_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_work = (work_esExports);
// CONCATENATED MODULE: ./src/pages/work.vue
function work_injectStyle (ssrContext) {
  __webpack_require__("hon+")
}
var work_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var work___vue_template_functional__ = false
/* styles */
var work___vue_styles__ = work_injectStyle
/* scopeId */
var work___vue_scopeId__ = "data-v-bd278052"
/* moduleIdentifier (server only) */
var work___vue_module_identifier__ = null
var work_Component = work_normalizeComponent(
  pages_work,
  selectortype_template_index_0_src_pages_work,
  work___vue_template_functional__,
  work___vue_styles__,
  work___vue_scopeId__,
  work___vue_module_identifier__
)

/* harmony default export */ var src_pages_work = (work_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/submitWork.vue











/* harmony default export */ var pages_submitWork = ({
  name: 'submitWork',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      filePath: [],
      conf: [],
      confId: 0,
      cateId: 0,
      formData: {},
      category: [],
      pics: [],
      grade: 0,
      store_id: 0,
      stores: [],
      pickerStatus: false,
      status: true,
      store_name: '请选择',
      code: ''
    };
  },
  created: function created() {
    this.getCategory();
    this.config();
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 13) {
      this.getStore();
    }
  },

  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$api.workCategory({}).then(function (res) {
        if (res) {
          _this.category = res.data;
          _this.cateId = res.data[0].id;
          _this.conf = res.data[0].conf;
        }
      });
    },
    cate: function cate(index, value) {
      this.cateId = value;
      this.conf = this.category[index].conf;
      this.formData = {};
      this.code = '';
      this.pics = [];
      this.filePath = [];
      this.confId = 0;
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.status) {
        return false;
      }
      this.status = false;
      this.formData.code = this.code;
      this.formData.cate_id = this.cateId;
      this.formData.store_id = this.store_id;
      this.formData.pics = stringify_default()(this.pics);
      this.$api.submitWork(this.formData).then(function (res) {
        if (res) {
          _this2.formData = {};
          _this2.code = '';
          _this2.pics = [];
          _this2.filePath = [];
          _this2.confId = 0;
          _this2.cateId = _this2.category[0].id;
          _this2.$func.showToast('提交成功');
          _this2.status = true;
        }
      });
    },
    onStore: function onStore(value) {
      this.store_id = value;
    },
    confirmStore: function confirmStore() {
      var that = this;
      this.stores.forEach(function (item, index) {
        if (item.key == that.store_id) {
          that.store_name = item.value;
        }
      });
      this.pickerStatus = false;
    },
    getStore: function getStore() {
      var _this3 = this;

      this.$api.store({}).then(function (res) {
        if (res) {
          _this3.stores = res.data;
        }
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(value) {
      var that = this;
      this.confId = value;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'work' }).then(function (res) {
            if (res) {
              that.filePath.push({ key: that.confId, value: res.data.url });
              that.pics.push({ key: that.confId, value: res.data.path });
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index].value, // 当前显示图片的http链接
        urls: [this.filePath[index].value]
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/submitWork.vue











/* harmony default export */ var selectortype_script_index_0_src_pages_submitWork = ({
  name: 'submitWork',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      filePath: [],
      conf: [],
      confId: 0,
      cateId: 0,
      formData: {},
      category: [],
      pics: [],
      grade: 0,
      store_id: 0,
      stores: [],
      pickerStatus: false,
      status: true,
      store_name: '请选择',
      code: ''
    };
  },
  created: function created() {
    this.getCategory();
    this.config();
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 13) {
      this.getStore();
    }
  },

  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$api.workCategory({}).then(function (res) {
        if (res) {
          _this.category = res.data;
          _this.cateId = res.data[0].id;
          _this.conf = res.data[0].conf;
        }
      });
    },
    cate: function cate(index, value) {
      this.cateId = value;
      this.conf = this.category[index].conf;
      this.formData = {};
      this.code = '';
      this.pics = [];
      this.filePath = [];
      this.confId = 0;
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.status) {
        return false;
      }
      this.status = false;
      this.formData.code = this.code;
      this.formData.cate_id = this.cateId;
      this.formData.store_id = this.store_id;
      this.formData.pics = stringify_default()(this.pics);
      this.$api.submitWork(this.formData).then(function (res) {
        if (res) {
          _this2.formData = {};
          _this2.code = '';
          _this2.pics = [];
          _this2.filePath = [];
          _this2.confId = 0;
          _this2.cateId = _this2.category[0].id;
          _this2.$func.showToast('提交成功');
          _this2.status = true;
        }
      });
    },
    onStore: function onStore(value) {
      this.store_id = value;
    },
    confirmStore: function confirmStore() {
      var that = this;
      this.stores.forEach(function (item, index) {
        if (item.key == that.store_id) {
          that.store_name = item.value;
        }
      });
      this.pickerStatus = false;
    },
    getStore: function getStore() {
      var _this3 = this;

      this.$api.store({}).then(function (res) {
        if (res) {
          _this3.stores = res.data;
        }
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(value) {
      var that = this;
      this.confId = value;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'work' }).then(function (res) {
            if (res) {
              that.filePath.push({ key: that.confId, value: res.data.url });
              that.pics.push({ key: that.confId, value: res.data.path });
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index].value, // 当前显示图片的http链接
        urls: [this.filePath[index].value]
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf600fb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/submitWork.vue
var submitWork_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12  border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("选择分类")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-wrap cm-p-tb-12",staticStyle:{"height":"250px","overflow-y":"auto"}},_vm._l((_vm.category),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:item.id == _vm.cateId ? 'cm-bg-red cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.cate(index,item.id)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_vm._l((_vm.conf),function(item,index){return _c('div',{key:index},[(item.format == 1)?_c('div',[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":'请输入'+item.title+' 150字以内'+(item.required > 0 ? '（必填）' : '（选填）'),"height":120},model:{value:(_vm.formData[item.id]),callback:function ($$v) {_vm.$set(_vm.formData, item.id, $$v)},expression:"formData[item.id]"}})],1)],1)]):(item.format == 2)?_c('div',[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v(_vm._s(item.title)+_vm._s(item.required > 0 ? '（必填）' : '（选填）'))]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((_vm.filePath),function(val,i){return (item.id == val.key)?_c('li',{key:i,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val.value},on:{"click":function($event){return _vm.showPic(i)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(i)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile(item.id)}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)])]):_c('div',[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.title == '条码')?_c('div',{staticClass:"border-b cm-p-b-12 cm-flex-middle cm-flex-between"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16",attrs:{"type":"text","placeholder":'请输入'+item.title+(item.required > 0 ? '（必填）' : '（选填）')},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]):_c('div',{staticClass:"border-b cm-p-b-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData[item.id]),expression:"formData[item.id]"}],staticClass:"cm-fn-16",attrs:{"type":"text","placeholder":'请输入'+item.title+(item.required > 0 ? '（必填）' : '（选填）')},domProps:{"value":(_vm.formData[item.id])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, item.id, $event.target.value)}}})])])])}),_vm._v(" "),(_vm.grade == 13)?_c('div',{staticClass:"cm-p-tb-12 cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('div',{staticClass:"cm-fn-16"},[_vm._v("选择门店")]),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-color-red",on:{"click":function($event){_vm.pickerStatus = true}}},[_vm._v(_vm._s(_vm.store_name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:" cm-border-radius-8 cm-center",class:_vm.status ? 'cm-bg-red' : 'cm-bg-gray',staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"70%","hide-on-blur":false},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"选择门店","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.confirmStore()}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.stores,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onStore}})],1)],1)],1)])}
var submitWork_staticRenderFns = []
var submitWork_esExports = { render: submitWork_render, staticRenderFns: submitWork_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_submitWork = (submitWork_esExports);
// CONCATENATED MODULE: ./src/pages/submitWork.vue
function submitWork_injectStyle (ssrContext) {
  __webpack_require__("+R1k")
}
var submitWork_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var submitWork___vue_template_functional__ = false
/* styles */
var submitWork___vue_styles__ = submitWork_injectStyle
/* scopeId */
var submitWork___vue_scopeId__ = "data-v-cf600fb8"
/* moduleIdentifier (server only) */
var submitWork___vue_module_identifier__ = null
var submitWork_Component = submitWork_normalizeComponent(
  selectortype_script_index_0_src_pages_submitWork,
  selectortype_template_index_0_src_pages_submitWork,
  submitWork___vue_template_functional__,
  submitWork___vue_styles__,
  submitWork___vue_scopeId__,
  submitWork___vue_module_identifier__
)

/* harmony default export */ var src_pages_submitWork = (submitWork_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workorder.vue











/* harmony default export */ var workorder = ({
  name: 'workorder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      title: '工单列表',
      status: 0,
      keyword: '',
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      category: [],
      labels: [],
      searchPop: false,
      community: '',
      cateId: 0,
      labelsId: 0,
      labelTitle: '',
      services: [],
      itemId: 0,
      serviceId: 0,
      pickerStatus: false,
      orders: [{
        key: 'id',
        title: '发起时间'
      }, {
        key: 'deadline',
        title: '处理截止时间'
      }],
      orderItem: 0,
      orderType: 0

    };
  },
  created: function created() {
    this.status = Number(this.$route.params.i);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'workOrderInfo') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  mounted: function mounted() {
    this.getCategory();
    this.getService();
    this.getLabels();
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    sort: function sort(i) {
      this.orderItem = i;
      this.search();
    },
    order: function order(i) {
      this.orderType = i;
      this.search();
    },
    getList: function getList() {
      var _this = this;

      var params = {
        last_id: this.lastId, page_flag: this.pageFlag, status: this.status,
        keyword: this.keyword, cate_id: this.cateId, community: this.community,
        label: this.labelTitle, orderItem: this.orders[this.orderItem].key, orderType: this.orderType
      };
      this.$api.workOrder(params).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    getCategory: function getCategory() {
      var _this2 = this;

      this.$api.workCategory({ status: this.status, type: 1 }).then(function (res) {
        if (res) {
          _this2.category = res.data;
        }
      });
    },
    getLabels: function getLabels() {
      var _this3 = this;

      this.$api.workLabels({ status: this.status }).then(function (res) {
        if (res) {
          _this3.labels = res.data;
        }
      });
    },
    detail: function detail(id) {
      this.$router.push({ name: 'workOrderInfo', params: { id: id } });
    },
    cate: function cate(id) {
      this.cateId = id;
    },
    label: function label(id, title) {
      this.labelsId = id;
      this.labelTitle = title;
    },
    showPic: function showPic(pics, index) {
      weixin_js_sdk_default.a.previewImage({
        current: pics[index], // 当前显示图片的http链接
        urls: pics
      });
    },
    resetSearch: function resetSearch() {
      this.community = '';
      this.cateId = 0;
      this.labelTitle = '';
      this.keyword = '';
      this.orderItem = 0;
      this.orderType = 0;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    getService: function getService() {
      var _this4 = this;

      this.$api.getService({}).then(function (res) {
        if (res) {
          _this4.services = res.data;
        }
      });
    },
    assignService: function assignService(id) {
      this.itrmId = id;
      this.pickerStatus = true;
    },
    onSercice: function onSercice(value) {
      this.serviceId = value;
    },
    confirmService: function confirmService() {
      var _this5 = this;

      var that = this;
      if (!this.serviceId) {
        this.$func.showToast('请选择客服');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this5.$api.assignService({ id: _this5.itrmId, serviceId: _this5.serviceId }).then(function (res) {
          if (res) {
            that.pickerStatus = false;
            that.search();
          }
        });
      });
    },
    loadmore: function loadmore() {
      var _this6 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this6.blankShow) {
          _this6.busy = true;
          _this6.loadStatus = false;
          _this6.loadmoreText = '没有更多了。。。';
        } else {
          if (_this6.hasNext > 0) {
            _this6.loadStatus = false;
            _this6.busy = false;
          } else {
            _this6.busy = true;
            _this6.loadStatus = true;
            _this6.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workorder.vue











/* harmony default export */ var pages_workorder = ({
  name: 'workorder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      title: '工单列表',
      status: 0,
      keyword: '',
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      category: [],
      labels: [],
      searchPop: false,
      community: '',
      cateId: 0,
      labelsId: 0,
      labelTitle: '',
      services: [],
      itemId: 0,
      serviceId: 0,
      pickerStatus: false,
      orders: [{
        key: 'id',
        title: '发起时间'
      }, {
        key: 'deadline',
        title: '处理截止时间'
      }],
      orderItem: 0,
      orderType: 0

    };
  },
  created: function created() {
    this.status = Number(this.$route.params.i);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'workOrderInfo') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  mounted: function mounted() {
    this.getCategory();
    this.getService();
    this.getLabels();
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    sort: function sort(i) {
      this.orderItem = i;
      this.search();
    },
    order: function order(i) {
      this.orderType = i;
      this.search();
    },
    getList: function getList() {
      var _this = this;

      var params = {
        last_id: this.lastId, page_flag: this.pageFlag, status: this.status,
        keyword: this.keyword, cate_id: this.cateId, community: this.community,
        label: this.labelTitle, orderItem: this.orders[this.orderItem].key, orderType: this.orderType
      };
      this.$api.workOrder(params).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    getCategory: function getCategory() {
      var _this2 = this;

      this.$api.workCategory({ status: this.status, type: 1 }).then(function (res) {
        if (res) {
          _this2.category = res.data;
        }
      });
    },
    getLabels: function getLabels() {
      var _this3 = this;

      this.$api.workLabels({ status: this.status }).then(function (res) {
        if (res) {
          _this3.labels = res.data;
        }
      });
    },
    detail: function detail(id) {
      this.$router.push({ name: 'workOrderInfo', params: { id: id } });
    },
    cate: function cate(id) {
      this.cateId = id;
    },
    label: function label(id, title) {
      this.labelsId = id;
      this.labelTitle = title;
    },
    showPic: function showPic(pics, index) {
      weixin_js_sdk_default.a.previewImage({
        current: pics[index], // 当前显示图片的http链接
        urls: pics
      });
    },
    resetSearch: function resetSearch() {
      this.community = '';
      this.cateId = 0;
      this.labelTitle = '';
      this.keyword = '';
      this.orderItem = 0;
      this.orderType = 0;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    getService: function getService() {
      var _this4 = this;

      this.$api.getService({}).then(function (res) {
        if (res) {
          _this4.services = res.data;
        }
      });
    },
    assignService: function assignService(id) {
      this.itrmId = id;
      this.pickerStatus = true;
    },
    onSercice: function onSercice(value) {
      this.serviceId = value;
    },
    confirmService: function confirmService() {
      var _this5 = this;

      var that = this;
      if (!this.serviceId) {
        this.$func.showToast('请选择客服');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this5.$api.assignService({ id: _this5.itrmId, serviceId: _this5.serviceId }).then(function (res) {
          if (res) {
            that.pickerStatus = false;
            that.search();
          }
        });
      });
    },
    loadmore: function loadmore() {
      var _this6 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this6.blankShow) {
          _this6.busy = true;
          _this6.loadStatus = false;
          _this6.loadmoreText = '没有更多了。。。';
        } else {
          if (_this6.hasNext > 0) {
            _this6.loadStatus = false;
            _this6.busy = false;
          } else {
            _this6.busy = true;
            _this6.loadStatus = true;
            _this6.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f859d1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/workorder.vue
var workorder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"72%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"工单号|条码|描述关键字查询"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-text-center cm-m-r-12  cm-p-lr-8 cm-p-tb-2"},[_c('img',{staticClass:"cm-icon-24 cm-margin ",attrs:{"src":"/static/images/filter.png"},on:{"click":function($event){_vm.searchPop = true}}}),_vm._v(" "),_c('p',{staticClass:"cm-color-block cm-fn-10"},[_vm._v("筛选")])])])]),_vm._v(" "),(_vm.status == 3)?_c('div',{staticClass:"order cm-w-100 cm-bg-white cm-p-tb-4"},[_c('ul',{staticClass:"cm-flex-around cm-flex-middle cm-p-lr-16"},_vm._l((_vm.orders),function(item,index){return _c('li',{key:index,staticClass:"cm-center",on:{"click":function($event){return _vm.sort(index)}}},[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),(index == _vm.orderItem && _vm.orderType == 0)?_c('img',{staticClass:"cm-icon-18",attrs:{"src":"/static/images/sort_down.png"},on:{"click":function($event){return _vm.order(1)}}}):_vm._e(),_vm._v(" "),(index == _vm.orderItem && _vm.orderType > 0)?_c('img',{staticClass:"cm-icon-18",attrs:{"src":"/static/images/sort_up.png"},on:{"click":function($event){return _vm.order(0)}}}):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-bg",style:({ top: _vm.status == 3 ? '78px' : '50px'})},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-p-b-12"},[_c('div',{on:{"click":function($event){return _vm.detail(item.id)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 "},[_vm._v("工单号："+_vm._s(item.work_no))]),_vm._v(" "),(item.status < 2)?_c('p',{staticClass:"cm-fn-weight-default cm-color-blue"},[_vm._v(_vm._s(item.status_text))]):(item.status > 1 || item.status < 5)?_c('p',{staticClass:"cm-fn-weight-default cm-color-orange"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-weight-default cm-color-green"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-4 cm-p-t-8 cm-flex-between cm-flex-middle"},[_c('div',[_c('span',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.grade_title))]),_vm._v("："),_c('span',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.cate_title))])]),_vm._v(" "),_vm._l((item.content),function(value,i){return _c('div',{key:i,staticClass:"cm-m-t-4"},[(value.conf_format != 2)?_c('div',{},[_c('span',{staticClass:"cm-color-666"},[_vm._v(_vm._s(value.conf_title))]),_vm._v("："),_c('span',{class:!isNaN(value.content) ? 'cm-color-red' : ''},[_vm._v(_vm._s(value.content))])]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"cm-m-t-4"},[_c('span',{staticClass:"cm-color-666"},[_vm._v("时间")]),_vm._v("："),_c('span',{},[_vm._v(_vm._s(item.create_time))])])],2),_vm._v(" "),_vm._l((item.content),function(value,i){return _c('div',{key:i,staticClass:"cm-m-t-4"},[(value.conf_format == 2)?_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},_vm._l((value.content),function(val,j){return (j<3)?_c('li',{key:j,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(value.content,j)}}})]):_vm._e()}),0):_vm._e()])})],2),_vm._v(" "),(item.reply != null)?_c('div',{staticClass:"cm-p-tb-12 cm-border-top-1"},[_c('p',{staticClass:"cm-fn-14 cm-color-blue"},[_vm._v("最新回复")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-4"},[(item.reply.format == 2)?_c('div',{staticClass:"cm-img-box cm-bg-gray cm-p-tb-4 cm-p-lr-4 reply-img"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.reply.content},on:{"click":function($event){return _vm.showPic([item.reply.content],0)}}})]):_c('div',{staticClass:"cm-fn-14 cm-color-666 ",staticStyle:{"word-break":"break-all"},on:{"click":function($event){return _vm.detail(item.id)}}},[_c('span',[_vm._v(_vm._s(item.reply.name))]),_vm._v(" "),_c('span',{staticClass:"cm-color-666 cm-m-l-8",domProps:{"innerHTML":_vm._s(item.reply.content)}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-m-t-4"},[_vm._v(_vm._s(item.reply.create_time))])])]):_vm._e(),_vm._v(" "),(item.out_time)?_c('div',{staticClass:"cm-p-b-12 cm-color-orange"},[_vm._v(_vm._s(item.out_time))]):_vm._e(),_vm._v(" "),(item.status == 1 && _vm.$func.checkAuth('assignService'))?_c('div',{staticClass:"cm-p-tb-12 cm-border-top-1 cm-flex-end cm-flex-middle"},[_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-p-lr-16 cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.assignService(item.id)}}},[_vm._v("分配客服")])]):_vm._e(),_vm._v(" "),(item.status > 1 && item.status < 4 && _vm.$func.checkAuth('assignService'))?_c('div',{staticClass:"cm-p-tb-12 cm-border-top-1 cm-flex-end cm-flex-middle"},[_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-p-lr-16 cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.assignService(item.id)}}},[_vm._v("重新分配客服")])]):_vm._e(),_vm._v(" "),(item.status > 1 && item.status < 5 && _vm.$func.checkAuth('moveServer'))?_c('div',{staticClass:"cm-p-tb-12 cm-border-top-1 cm-flex-end cm-flex-middle"},[_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-p-lr-16 cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.assignService(item.id)}}},[_vm._v("转工单")])]):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"right","width":"80%"},model:{value:(_vm.searchPop),callback:function ($$v) {_vm.searchPop=$$v},expression:"searchPop"}},[_c('div',{staticClass:"cm-p-lr-16"},[_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("门店：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.community),expression:"community"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"门店|社区关键字查询"},domProps:{"value":(_vm.community)},on:{"input":function($event){if($event.target.composing){ return; }_vm.community=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("分类：")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-wrap"},_vm._l((_vm.category),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:item.id == _vm.cateId ? 'cm-bg-red cm-color-white' :'cm-bg-white',on:{"click":function($event){return _vm.cate(item.id)}}},[_vm._v(_vm._s(item.title)+" "),_c('span',{staticClass:"cm-m-l-4",class:item.id == _vm.cateId ? 'cm-color-white' : 'cm-color-orange'},[_vm._v(_vm._s(item.num))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("处理办法：")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-wrap"},_vm._l((_vm.labels),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:item.id == _vm.labelsId ? 'cm-bg-red cm-color-white' :'cm-bg-white',on:{"click":function($event){return _vm.label(item.id,item.title)}}},[_vm._v(_vm._s(item.title)+" "),_c('span',{staticClass:"cm-m-l-4",class:item.id == _vm.labelsId ? 'cm-color-white' : 'cm-color-orange'},[_vm._v(_vm._s(item.num))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-pa cm-center cm-border-top-1",staticStyle:{"bottom":"0","left":"0"}},[_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18 cm-bg-white cm-center",on:{"click":_vm.resetSearch}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18  cm-color-white cm-bg-green cm-center",on:{"click":_vm.searchSubmit}},[_vm._v("确定")])])])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"70%","hide-on-blur":false},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"选择客服","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.confirmService()}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.services,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onSercice}})],1)],1)],1)])}
var workorder_staticRenderFns = []
var workorder_esExports = { render: workorder_render, staticRenderFns: workorder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_workorder = (workorder_esExports);
// CONCATENATED MODULE: ./src/pages/workorder.vue
function workorder_injectStyle (ssrContext) {
  __webpack_require__("K2Sp")
}
var workorder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var workorder___vue_template_functional__ = false
/* styles */
var workorder___vue_styles__ = workorder_injectStyle
/* scopeId */
var workorder___vue_scopeId__ = "data-v-4f859d1a"
/* moduleIdentifier (server only) */
var workorder___vue_module_identifier__ = null
var workorder_Component = workorder_normalizeComponent(
  pages_workorder,
  selectortype_template_index_0_src_pages_workorder,
  workorder___vue_template_functional__,
  workorder___vue_styles__,
  workorder___vue_scopeId__,
  workorder___vue_module_identifier__
)

/* harmony default export */ var src_pages_workorder = (workorder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workOrderInfo.vue










/* harmony default export */ var pages_workOrderInfo = ({
  name: 'workOrderInfo',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      title: '工单详情',
      id: 0,
      info: {
        community: {}
      },
      reply: [],
      content: '',
      format: 0,
      grade: 0,
      pickerStatus: false,
      quickReplys: [],
      quickReplyId: 0,
      services: [],
      serviceId: 0,
      pickerStatus1: false,
      status: true

    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.config();
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      this.workOrderInfo();
      this.grade = parseInt(this.$func.getLocal('grade'));
    }
  },
  mounted: function mounted() {
    if (this.$func.getLocal('token')) {
      this.getService();
    }
  },

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = this.$customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.$func.setLocal('grade', res.data.grade);
            _this.grade = parseInt(_this.$func.getLocal('grade'));
            _this.workOrderInfo();
            _this.getService();
          }
        }
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    workOrderInfo: function workOrderInfo() {
      var _this2 = this;

      this.$api.workOrderInfo({ id: this.id }).then(function (res) {
        if (res) {
          console.log(res);
          _this2.info = res.data;

          _this2.quickReply();

          _this2.workOrderReply();
        }
      });
    },
    workOrderReply: function workOrderReply() {
      var _this3 = this;

      this.$api.workOrderReply({ id: this.id }).then(function (res) {
        if (res) {
          _this3.reply = res.data;
        }
      });
    },
    submitReply: function submitReply(content, format) {
      var _this4 = this;

      if (!this.status) {
        return false;
      }
      this.status = false;
      var content1 = content ? content : this.content;
      if (!content1) {
        this.$func.showToast('请输入回复内容');
        return false;
      }
      this.$api.submitWorkReply({ id: this.id, cid: this.info.cid, content: content1, format: format ? format : this.format }).then(function (res) {
        if (res) {
          _this4.content = '';
          _this4.workOrderReply();
          _this4.status = true;
          _this4.$func.endLoading();
        }
      });
    },
    quickReply: function quickReply() {
      var _this5 = this;

      this.$api.quickReply({}).then(function (res) {
        if (res) {
          _this5.quickReplys = res.data;
        }
      });
    },
    onQuickReplyChange: function onQuickReplyChange(value) {
      this.quickReplyId = value;
    },
    changeStatus: function changeStatus(value) {
      var _this6 = this;

      switch (parseInt(value)) {
        case 3:
          if (this.info.status == 2) {
            if (!this.quickReplyId) {
              this.$func.showToast('请选择快捷回复');
              return false;
            }
            this.quickReplys.forEach(function (item, index) {
              if (item.key == _this6.quickReplyId) {
                _this6.content = item.value;
              }
            });
          } else {
            this.content = '没解决';
          }
          break;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$api.changeWorkStatus({ id: _this6.id, status: value, content: _this6.content }).then(function (res) {
          if (res) {
            _this6.pickerStatus = false;
            _this6.content = '';
            _this6.workOrderInfo();
          }
        });
      });
    },
    showPic: function showPic(pics, index) {
      weixin_js_sdk_default.a.previewImage({
        current: pics[index], // 当前显示图片的http链接
        urls: pics
      });
    },
    getService: function getService() {
      var _this7 = this;

      this.$api.getService({}).then(function (res) {
        if (res) {
          _this7.services = res.data;
        }
      });
    },
    onSercice: function onSercice(value) {
      this.serviceId = value;
    },
    confirmService: function confirmService() {
      var _this8 = this;

      var that = this;
      if (!this.serviceId) {
        this.$func.showToast('请选择客服');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this8.$api.assignService({ id: _this8.id, serviceId: _this8.serviceId }).then(function (res) {
          if (res) {
            that.pickerStatus1 = false;
            that.workOrderInfo();
          }
        });
      });
    },
    workOrderSolution: function workOrderSolution() {
      this.$router.push({ name: 'workOrderSolution', params: { id: this.id } });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      this.$func.startLoading();
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'work' }).then(function (res) {
            if (res) {
              that.submitReply(res.data.path, 2);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    hide1: function hide1(e) {
      console.log(this.option1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workOrderInfo.vue










/* harmony default export */ var selectortype_script_index_0_src_pages_workOrderInfo = ({
  name: 'workOrderInfo',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      title: '工单详情',
      id: 0,
      info: {
        community: {}
      },
      reply: [],
      content: '',
      format: 0,
      grade: 0,
      pickerStatus: false,
      quickReplys: [],
      quickReplyId: 0,
      services: [],
      serviceId: 0,
      pickerStatus1: false,
      status: true

    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.config();
    if (!this.$func.getLocal('token')) {
      this.getCode();
    } else {
      this.workOrderInfo();
      this.grade = parseInt(this.$func.getLocal('grade'));
    }
  },
  mounted: function mounted() {
    if (this.$func.getLocal('token')) {
      this.getService();
    }
  },

  methods: {
    getCode: function getCode() {
      var local = window.location.href;
      this.code = this.getUrlCode().code;
      var appid = this.$customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        this.login();
      }
    },
    getUrlCode: function getUrlCode() {
      var url = window.location.href;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var urls = url.split("?");
        var strs = urls[1].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      var code = theRequest.code;
      if (code == 'undefined' || code == null || code === '') {
        this.$func.setLocal('channel', parseInt(theRequest.channel));
      }
      return theRequest;
    },
    login: function login() {
      var _this = this;

      this.$api.login({ code: this.code, channel: this.$func.getLocal('channel') }).then(function (res) {
        if (res) {
          if (res.data.token) {
            _this.$func.setLocal('token', res.data.token);
            _this.$func.setLocal('grade', res.data.grade);
            _this.grade = parseInt(_this.$func.getLocal('grade'));
            _this.workOrderInfo();
            _this.getService();
          }
        }
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    workOrderInfo: function workOrderInfo() {
      var _this2 = this;

      this.$api.workOrderInfo({ id: this.id }).then(function (res) {
        if (res) {
          console.log(res);
          _this2.info = res.data;

          _this2.quickReply();

          _this2.workOrderReply();
        }
      });
    },
    workOrderReply: function workOrderReply() {
      var _this3 = this;

      this.$api.workOrderReply({ id: this.id }).then(function (res) {
        if (res) {
          _this3.reply = res.data;
        }
      });
    },
    submitReply: function submitReply(content, format) {
      var _this4 = this;

      if (!this.status) {
        return false;
      }
      this.status = false;
      var content1 = content ? content : this.content;
      if (!content1) {
        this.$func.showToast('请输入回复内容');
        return false;
      }
      this.$api.submitWorkReply({ id: this.id, cid: this.info.cid, content: content1, format: format ? format : this.format }).then(function (res) {
        if (res) {
          _this4.content = '';
          _this4.workOrderReply();
          _this4.status = true;
          _this4.$func.endLoading();
        }
      });
    },
    quickReply: function quickReply() {
      var _this5 = this;

      this.$api.quickReply({}).then(function (res) {
        if (res) {
          _this5.quickReplys = res.data;
        }
      });
    },
    onQuickReplyChange: function onQuickReplyChange(value) {
      this.quickReplyId = value;
    },
    changeStatus: function changeStatus(value) {
      var _this6 = this;

      switch (parseInt(value)) {
        case 3:
          if (this.info.status == 2) {
            if (!this.quickReplyId) {
              this.$func.showToast('请选择快捷回复');
              return false;
            }
            this.quickReplys.forEach(function (item, index) {
              if (item.key == _this6.quickReplyId) {
                _this6.content = item.value;
              }
            });
          } else {
            this.content = '没解决';
          }
          break;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$api.changeWorkStatus({ id: _this6.id, status: value, content: _this6.content }).then(function (res) {
          if (res) {
            _this6.pickerStatus = false;
            _this6.content = '';
            _this6.workOrderInfo();
          }
        });
      });
    },
    showPic: function showPic(pics, index) {
      weixin_js_sdk_default.a.previewImage({
        current: pics[index], // 当前显示图片的http链接
        urls: pics
      });
    },
    getService: function getService() {
      var _this7 = this;

      this.$api.getService({}).then(function (res) {
        if (res) {
          _this7.services = res.data;
        }
      });
    },
    onSercice: function onSercice(value) {
      this.serviceId = value;
    },
    confirmService: function confirmService() {
      var _this8 = this;

      var that = this;
      if (!this.serviceId) {
        this.$func.showToast('请选择客服');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this8.$api.assignService({ id: _this8.id, serviceId: _this8.serviceId }).then(function (res) {
          if (res) {
            that.pickerStatus1 = false;
            that.workOrderInfo();
          }
        });
      });
    },
    workOrderSolution: function workOrderSolution() {
      this.$router.push({ name: 'workOrderSolution', params: { id: this.id } });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      this.$func.startLoading();
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'work' }).then(function (res) {
            if (res) {
              that.submitReply(res.data.path, 2);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    hide1: function hide1(e) {
      console.log(this.option1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8d474e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/workOrderInfo.vue
var workOrderInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:" cm-bg-white cm-p-b-12  "},[_c('div',{staticClass:"cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 "},[_vm._v("工单号："+_vm._s(_vm.info.work_no))]),_vm._v(" "),(_vm.info.status < 2)?_c('p',{staticClass:"cm-fn-weight-default cm-color-blue"},[_vm._v(_vm._s(_vm.info.status_text))]):(_vm.info.status > 1 || _vm.info.status < 5)?_c('p',{staticClass:"cm-fn-weight-default cm-color-orange"},[_vm._v(_vm._s(_vm.info.status_text))]):_c('p',{staticClass:"cm-fn-weight-default cm-color-green"},[_vm._v(_vm._s(_vm.info.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-4 cm-p-t-8 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-fn-14 cm-color-666"},[_c('span',{staticClass:"cm-color-222"},[_vm._v(_vm._s(_vm.info.grade_title))]),_vm._v("："),_c('span',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.info.community_name))]),_vm._v(" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+_vm.info.community_phone}},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/phone.png"}})])]),_vm._v(" "),_c('div',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.info.cate_title))])]),_vm._v(" "),_vm._l((_vm.info.content),function(value,ii){return _c('div',{key:ii,staticClass:"cm-m-t-4"},[(value.conf_format != 2)?_c('div',{},[_c('span',{staticClass:"cm-color-666"},[_vm._v(_vm._s(value.conf_title))]),_vm._v("："),_c('span',{class:!isNaN(value.content) ? 'cm-color-red' : ''},[_vm._v(_vm._s(value.content))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(value.content)}}},[_vm._v("复制")])]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-4"},[_c('div',{},[_c('span',{staticClass:"cm-color-666"},[_vm._v("时间")]),_vm._v("："),_c('span',{},[_vm._v(_vm._s(_vm.info.create_time))])]),_vm._v(" "),(_vm.info.status == 3 && _vm.info.orders == 1)?_c('div',{staticClass:"cm-bg-orange cm-p-tb-4 cm-p-lr-12 cm-m-t-4 cm-border-radius-4",on:{"click":function($event){return _vm.changeStatus(4)}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("处理完成")])]):_vm._e(),_vm._v(" "),(_vm.info.status < 4 && _vm.info.close == 1)?_c('div',{staticClass:"cm-bg-orange cm-p-tb-4 cm-p-lr-12 cm-m-t-4 cm-border-radius-4",on:{"click":function($event){return _vm.changeStatus(6)}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("撤销")])]):_vm._e(),_vm._v(" "),(_vm.info.status == 1 && _vm.$func.checkAuth('assignService'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-4 cm-p-lr-12 cm-m-t-4 cm-border-radius-4",on:{"click":function($event){_vm.pickerStatus1 = true}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("分配客服")])]):_vm._e()]),_vm._v(" "),(_vm.info.out_time)?_c('div',{staticClass:"cm-p-tb-4 cm-color-orange cm-flex-end"},[_vm._v(_vm._s(_vm.info.out_time))]):_vm._e(),_vm._v(" "),_vm._l((_vm.info.content),function(item,jj){return _c('div',{key:jj,staticClass:"cm-m-t-4"},[(item.conf_format == 2)?_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},_vm._l((item.content),function(val,kk){return _c('li',{key:kk,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(item.content,kk)}}})])}),0):_vm._e()])})],2)]),_vm._v(" "),(_vm.reply.length > 0)?_c('div',{staticClass:"cm-bg-white  reply cm-w-100 cm-m-t-12 "},[_c('div',{staticClass:" cm-p-lr-12"},_vm._l((_vm.reply),function(item,index){return _c('div',{key:index,staticClass:"cm-p-t-12"},[(item.is_me > 0)?_c('div',{staticClass:"cm-flex-between"},[_c('div',{staticStyle:{"width":"30%"}}),_vm._v(" "),_c('div',{staticClass:"cm-bg-gray cm-p-tb-8 cm-p-lr-8 cm-border-radius-6",staticStyle:{"width":"70%"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-36 cm-border-radius-4",attrs:{"src":item.head}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-12 "},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.grade_name))])]),_vm._v(" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+item.phone}},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/phone.png"}})])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-8"},[(item.format  == 2)?_c('div',{staticClass:"cm-img-box cm-bg-gray cm-p-tb-4 cm-p-lr-4"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.content},on:{"click":function($event){return _vm.showPic([item.content],0)}}})]):_c('div',{staticClass:"cm-fn-14 cm-color-222 cm-bg-gray cm-p-tb-4 cm-p-lr-4",staticStyle:{"word-break":"break-all"}},[_c('div',{domProps:{"innerHTML":_vm._s(item.content)}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-fn-12 "},[_vm._v(_vm._s(item.create_time))])])])])]):_c('div',{staticClass:"cm-flex-between"},[_c('div',{staticClass:"cm-bg-gray cm-p-tb-8 cm-p-lr-8 cm-border-radius-6",staticStyle:{"width":"70%"}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-36 cm-border-radius-4",attrs:{"src":item.head}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-12 "},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.grade_name))])]),_vm._v(" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+item.phone}},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/phone.png"}})])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-8"},[(item.format  == 2)?_c('div',{staticClass:"cm-img-box cm-bg-gray cm-p-tb-4 cm-p-lr-4"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.content},on:{"click":function($event){return _vm.showPic([item.content],0)}}})]):_c('div',{staticClass:"cm-fn-14 cm-color-222 cm-bg-gray cm-p-tb-4 cm-p-lr-4",staticStyle:{"word-break":"break-all"}},[_c('div',{domProps:{"innerHTML":_vm._s(item.content)}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-4"},[_c('p',{staticClass:"cm-fn-12 "},[_vm._v(_vm._s(item.create_time))])])])]),_vm._v(" "),_c('div')])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-w-100 cm-bg-gray shadow-gray cm-p-b-20 cm-p-t-8"},[(_vm.info.status == 2 && _vm.$func.checkAuth('confirmWorkOrder') && _vm.info.orders == 1)?_c('div',{staticClass:"cm-m-lr-16 cm-center buttom"},[_c('div',{staticClass:"cm-bg-blue cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){_vm.pickerStatus = true}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("确认接单")])])]):(_vm.info.status == 4 && _vm.$func.checkAuth('closeWorkOrder') && _vm.info.close == 1)?_c('div',{staticClass:"cm-flex-around cm-flex-middle"},[_c('div',{staticClass:"cm-text-center cm-p-lr-40 cm-bg-blue buttom cm-border-radius-8",on:{"click":function($event){return _vm.changeStatus(5)}}},[_c('p',{staticClass:"cm-color-white cm-m-t-4 cm-fn-16"},[_vm._v("已解决")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-10 cm-color-ccc"},[_vm._v("完成工单")])]),_vm._v(" "),_c('div',{staticClass:"cm-text-center  cm-p-lr-40 cm-bg-orange buttom cm-center cm-border-radius-8",on:{"click":function($event){return _vm.changeStatus(3)}}},[_c('p',{staticClass:"cm-color-white  cm-fn-16"},[_vm._v("没解决")])])]):(_vm.info.status < 5)?_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle",staticStyle:{"width":"70%"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],staticClass:"cm-border cm-fn-14 cm-p-tb-4 cm-p-lr-8 cm-w-100 cm-h-100",staticStyle:{"height":"auto","min-height":"30px","max-height":"80px"},attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('div',{staticClass:"cm-border-radius cm-bg-white cm-center cm-m-r-8",staticStyle:{"width":"30px","height":"30px","border":"1px solid #666"},on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{staticClass:"cm-icon-18",attrs:{"src":"/static/images/num_plus.png"}})]),_vm._v(" "),_c('div',{staticClass:" cm-center cm-p-tb-8 cm-p-lr-12 cm-color-white cm-border-radius-4",class:_vm.status ? 'cm-bg-blue' : 'cm-bg-gray',on:{"click":function($event){return _vm.submitReply('',0)}}},[_vm._v("\n                      发送\n                  ")])])]):_vm._e()]),_vm._v(" "),(_vm.info.status == 3 && _vm.info.orders == 1 && !_vm.info.labels)?_c('div',{staticClass:"cm-border-radius cm-bg-blue cm-text-center cm-p-tb-2 cm-p-lr-2",staticStyle:{"position":"fixed","width":"50px","height":"50px","bottom":"125px","right":"10px"},on:{"click":_vm.workOrderSolution}},[_c('p',{staticClass:"cm-m-t-4 cm-color-white cm-fn-bold cm-fn-12"},[_vm._v("处理")]),_vm._v(" "),_c('p',{staticClass:"cm-color-white cm-fn-bold  cm-fn-12"},[_vm._v("办法")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"70%","hide-on-blur":false},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"快捷回复","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.changeStatus(3)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.quickReplys,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onQuickReplyChange}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"70%","hide-on-blur":false},model:{value:(_vm.pickerStatus1),callback:function ($$v) {_vm.pickerStatus1=$$v},expression:"pickerStatus1"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"选择客服","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus1 = false},"on-click-right":function($event){return _vm.confirmService()}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.services,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onSercice}})],1)],1)],1)])}
var workOrderInfo_staticRenderFns = []
var workOrderInfo_esExports = { render: workOrderInfo_render, staticRenderFns: workOrderInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_workOrderInfo = (workOrderInfo_esExports);
// CONCATENATED MODULE: ./src/pages/workOrderInfo.vue
function workOrderInfo_injectStyle (ssrContext) {
  __webpack_require__("jnan")
}
var workOrderInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var workOrderInfo___vue_template_functional__ = false
/* styles */
var workOrderInfo___vue_styles__ = workOrderInfo_injectStyle
/* scopeId */
var workOrderInfo___vue_scopeId__ = "data-v-7c8d474e"
/* moduleIdentifier (server only) */
var workOrderInfo___vue_module_identifier__ = null
var workOrderInfo_Component = workOrderInfo_normalizeComponent(
  selectortype_script_index_0_src_pages_workOrderInfo,
  selectortype_template_index_0_src_pages_workOrderInfo,
  workOrderInfo___vue_template_functional__,
  workOrderInfo___vue_styles__,
  workOrderInfo___vue_scopeId__,
  workOrderInfo___vue_module_identifier__
)

/* harmony default export */ var src_pages_workOrderInfo = (workOrderInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workOrderSolution.vue



/* harmony default export */ var workOrderSolution = ({
  name: 'workOrderSolution',
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        labels: '',
        content: '',
        deadline: ''
      },
      labels: [],
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 6,
      maxHour: 24,
      days: 30
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.setDate();
    this.visitLabels();
  },
  mounted: function mounted() {},
  activated: function activated() {},

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      this.formData.deadline = this.startDate;
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.deadline = val;
      this.datetimeStatus = false;
    },
    addLabel: function addLabel(title) {
      if (title) {
        this.formData.labels += '#' + title;
      } else {
        this.formData.labels += '#';
      }
      this.$refs.textarea.focus();
    },
    visitLabels: function visitLabels() {
      var _this = this;

      this.$api.visitLabels({ type: 1 }).then(function (res) {
        if (res) {
          _this.labels = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.id) {
        this.$func.showToast('系统错误，请稍后再试');
        return false;
      }
      if (!this.formData.labels) {
        this.$func.showToast('请输入处理办法');
        return false;
      }
      if (!this.formData.deadline) {
        this.$func.showToast('请选择截止时间');
        return false;
      }
      this.$api.submitSolution(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 1000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/workOrderSolution.vue



/* harmony default export */ var pages_workOrderSolution = ({
  name: 'workOrderSolution',
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        labels: '',
        content: '',
        deadline: ''
      },
      labels: [],
      datetimeStatus: false,
      startDate: '',
      endDate: '',
      minHour: 6,
      maxHour: 24,
      days: 30
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.setDate();
    this.visitLabels();
  },
  mounted: function mounted() {},
  activated: function activated() {},

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
        hour: nowDate.getHours()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.startDate);
      date.setDate(date.getDate() + this.days);
      var date1 = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
      this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
      this.formData.deadline = this.startDate;
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.deadline = val;
      this.datetimeStatus = false;
    },
    addLabel: function addLabel(title) {
      if (title) {
        this.formData.labels += '#' + title;
      } else {
        this.formData.labels += '#';
      }
      this.$refs.textarea.focus();
    },
    visitLabels: function visitLabels() {
      var _this = this;

      this.$api.visitLabels({ type: 1 }).then(function (res) {
        if (res) {
          _this.labels = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.id) {
        this.$func.showToast('系统错误，请稍后再试');
        return false;
      }
      if (!this.formData.labels) {
        this.$func.showToast('请输入处理办法');
        return false;
      }
      if (!this.formData.deadline) {
        this.$func.showToast('请选择截止时间');
        return false;
      }
      this.$api.submitSolution(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 1000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13691118","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/workOrderSolution.vue
var workOrderSolution_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-p-tb-16 cm-p-lr-12 cm-bg-white "},[_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("处理办法")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.labels),expression:"formData.labels"}],ref:"textarea",staticClass:" cm-p-tb-4 cm-p-lr-8 cm-fn-16 cm-border",staticStyle:{"height":"80px","width":"96%"},attrs:{"placeholder":"请使用#号隔开"},domProps:{"value":(_vm.formData.labels)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "labels", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap cm-p-tb-12",staticStyle:{"height":"300px","overflow-y":"auto"}},[_c('div',{staticClass:"cm-border-radius-10  cm-color-orange cm-border cm-p-lr-4 cm-p-tb-2 cm-m-t-4 cm-center cm-m-r-4",staticStyle:{"width":"50px"},on:{"click":function($event){return _vm.addLabel()}}},[_vm._v("#标签")]),_vm._v(" "),_vm._l((_vm.labels),function(val,i){return _c('div',{key:i,staticClass:"cm-p-tb-2 cm-p-lr-4 cm-border cm-border-radius-6 cm-color-666 cm-m-t-4 cm-m-r-4 ",on:{"click":function($event){return _vm.addLabel(val.title)}}},[_vm._v("#"+_vm._s(val.title))])})],2)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("备注")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.content),expression:"formData.content"}],staticClass:" cm-p-tb-4 cm-w-100 cm-p-lr-4 ",staticStyle:{"height":"100px","border":"unset"},attrs:{"placeholder":"150字以内(非必填)"},domProps:{"value":(_vm.formData.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("截止时间")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222",attrs:{"format":"YYYY-MM-DD","end-date":_vm.endDate,"start-date":_vm.startDate,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222"},[_vm._v(_vm._s(_vm.formData.deadline))])])],1),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var workOrderSolution_staticRenderFns = []
var workOrderSolution_esExports = { render: workOrderSolution_render, staticRenderFns: workOrderSolution_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_workOrderSolution = (workOrderSolution_esExports);
// CONCATENATED MODULE: ./src/pages/workOrderSolution.vue
function workOrderSolution_injectStyle (ssrContext) {
  __webpack_require__("lm63")
}
var workOrderSolution_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var workOrderSolution___vue_template_functional__ = false
/* styles */
var workOrderSolution___vue_styles__ = workOrderSolution_injectStyle
/* scopeId */
var workOrderSolution___vue_scopeId__ = "data-v-13691118"
/* moduleIdentifier (server only) */
var workOrderSolution___vue_module_identifier__ = null
var workOrderSolution_Component = workOrderSolution_normalizeComponent(
  pages_workOrderSolution,
  selectortype_template_index_0_src_pages_workOrderSolution,
  workOrderSolution___vue_template_functional__,
  workOrderSolution___vue_styles__,
  workOrderSolution___vue_scopeId__,
  workOrderSolution___vue_module_identifier__
)

/* harmony default export */ var src_pages_workOrderSolution = (workOrderSolution_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/inviteUser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_inviteUser = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        getList: function getList() {
            var _this = this;

            this.$api.inviteUser({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        rebate: function rebate(uid) {
            this.$router.push({ name: 'rebate', params: { uid: uid } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/inviteUser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_inviteUser = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        getList: function getList() {
            var _this = this;

            this.$api.inviteUser({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        rebate: function rebate(uid) {
            this.$router.push({ name: 'rebate', params: { uid: uid } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605b3d6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inviteUser.vue
var inviteUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white",on:{"click":function($event){return _vm.rebate(item.uid)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.community.name))]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(item.bd_invite_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start  cm-p-tb-8 cm-p-lr-12"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.head}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-16 cm-text-left"},[_c('p',{},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.phone))])])]),_vm._v(" "),_c('div',{staticClass:"cm-text-right cm-p-tb-8 cm-p-lr-12"},[(item.order > 0)?_c('p',{staticClass:"cm-color-blue"},[_vm._v("已下19元单")]):_vm._e(),_vm._v(" "),(item.card > 0)?_c('p',{staticClass:"cm-color-orange"},[_vm._v("已成为会员")]):_vm._e()])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var inviteUser_staticRenderFns = []
var inviteUser_esExports = { render: inviteUser_render, staticRenderFns: inviteUser_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_inviteUser = (inviteUser_esExports);
// CONCATENATED MODULE: ./src/pages/inviteUser.vue
function inviteUser_injectStyle (ssrContext) {
  __webpack_require__("c9F2")
}
var inviteUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inviteUser___vue_template_functional__ = false
/* styles */
var inviteUser___vue_styles__ = inviteUser_injectStyle
/* scopeId */
var inviteUser___vue_scopeId__ = "data-v-605b3d6e"
/* moduleIdentifier (server only) */
var inviteUser___vue_module_identifier__ = null
var inviteUser_Component = inviteUser_normalizeComponent(
  selectortype_script_index_0_src_pages_inviteUser,
  selectortype_template_index_0_src_pages_inviteUser,
  inviteUser___vue_template_functional__,
  inviteUser___vue_styles__,
  inviteUser___vue_scopeId__,
  inviteUser___vue_module_identifier__
)

/* harmony default export */ var src_pages_inviteUser = (inviteUser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clotheStatus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_clotheStatus = ({
  name: 'clotheStatus',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      code: '',
      info: {}
    };
  },
  created: function created() {
    this.sign();
  },
  mounted: function mounted() {},

  methods: {
    clotheStatus: function clotheStatus() {
      var _this = this;

      if (!this.code || this.code.length != 12) {
        this.$func.showToast('条码无效');
        return;
      }
      this.$api.clotheStatus({ code: this.code }).then(function (res) {
        if (res) {
          if (res.data) {
            _this.info = res.data;
          } else {
            _this.$func.showToast('无信息');
          }
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.code = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: false, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clotheStatus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_clotheStatus = ({
  name: 'clotheStatus',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      code: '',
      info: {}
    };
  },
  created: function created() {
    this.sign();
  },
  mounted: function mounted() {},

  methods: {
    clotheStatus: function clotheStatus() {
      var _this = this;

      if (!this.code || this.code.length != 12) {
        this.$func.showToast('条码无效');
        return;
      }
      this.$api.clotheStatus({ code: this.code }).then(function (res) {
        if (res) {
          if (res.data) {
            _this.info = res.data;
          } else {
            _this.$func.showToast('无信息');
          }
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.code = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: false, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc95c3aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clotheStatus.vue
var clotheStatus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white"},[_c('div',{staticClass:" cm-p-b-8 cm-p-lr-8 cm-p-t-20"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-18",staticStyle:{"width":"40px"}},[_vm._v("条码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-border-bottom-1 cm-fn-22 cm-m-l-12 cm-p-tb-4",attrs:{"type":"number","oninput":"if(value.length > 12)value=value.slice(0,12)"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-16 cm-bg-blue cm-border-radius-5 cm-p-tb-12 cm-center cm-color-white cm-m-t-8",on:{"click":function($event){return _vm.clotheStatus()}}},[_vm._v("查询")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-24 cm-p-lr-16"},[_c('div',{staticClass:"cm-p-lr-12 shadow-gray cm-p-tb-12"},[_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("条码：")]),_vm._v(" "),_c('p',{staticClass:"cm-text-left cm-color-blue cm-fn-18"},[_vm._v(_vm._s(_vm.info.tiaoma))])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("衣物：")]),_vm._v(" "),(_vm.info.yfmc)?_c('p',{staticClass:"cm-text-left cm-fn-18"},[_vm._v(_vm._s(_vm.info.yfmc)+"（"+_vm._s(_vm.info.yanse)+"）")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("状态：")]),_vm._v(" "),_c('p',{staticClass:"cm-text-left cm-color-red cm-fn-18"},[_vm._v(_vm._s(_vm.info.stat))])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("门店：")]),_vm._v(" "),_c('p',{staticClass:"cm-text-left cm-fn-18"},[_vm._v(_vm._s(_vm.info.dwname))])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("订单：")]),_vm._v(" "),_c('p',{staticClass:"cm-text-left cm-fn-18"},[_vm._v(_vm._s(_vm.info.order_id))])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-4"},[_c('p',{staticClass:"cm-text-left cm-fn-16"},[_vm._v("进厂：")]),_vm._v(" "),_c('p',{staticClass:"cm-text-left cm-fn-18"},[_vm._v(_vm._s(_vm.info.jctime))])])])])])}
var clotheStatus_staticRenderFns = []
var clotheStatus_esExports = { render: clotheStatus_render, staticRenderFns: clotheStatus_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clotheStatus = (clotheStatus_esExports);
// CONCATENATED MODULE: ./src/pages/clotheStatus.vue
function clotheStatus_injectStyle (ssrContext) {
  __webpack_require__("0340")
}
var clotheStatus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clotheStatus___vue_template_functional__ = false
/* styles */
var clotheStatus___vue_styles__ = clotheStatus_injectStyle
/* scopeId */
var clotheStatus___vue_scopeId__ = "data-v-dc95c3aa"
/* moduleIdentifier (server only) */
var clotheStatus___vue_module_identifier__ = null
var clotheStatus_Component = clotheStatus_normalizeComponent(
  selectortype_script_index_0_src_pages_clotheStatus,
  selectortype_template_index_0_src_pages_clotheStatus,
  clotheStatus___vue_template_functional__,
  clotheStatus___vue_styles__,
  clotheStatus___vue_scopeId__,
  clotheStatus___vue_module_identifier__
)

/* harmony default export */ var src_pages_clotheStatus = (clotheStatus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupInvite.vue



/* harmony default export */ var pages_groupInvite = ({
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: [],
      order: 0
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);

      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    getList: function getList() {
      var _this = this;

      this.$api.groupInvite({ startDate: this.startDate, endDate: this.endDate, order: this.order }).then(function (res) {
        if (res) {
          _this.list = res.data;
        }
      });
    },
    sort: function sort(value) {
      this.order = value;
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/groupInvite.vue



/* harmony default export */ var selectortype_script_index_0_src_pages_groupInvite = ({
  components: {
    Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: [],
      order: 0
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);

      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showOperater: function showOperater() {
      this.pickerStatus = true;
    },
    getList: function getList() {
      var _this = this;

      this.$api.groupInvite({ startDate: this.startDate, endDate: this.endDate, order: this.order }).then(function (res) {
        if (res) {
          _this.list = res.data;
        }
      });
    },
    sort: function sort(value) {
      this.order = value;
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6c0f9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/groupInvite.vue
var groupInvite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-4 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-8"},[_c('p',{staticClass:"cm-bg-gray cm-p-lr-16 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-12"},[_vm._v("--")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-lr-16  cm-p-tb-4",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-bg-green cm-p-lr-16  cm-center",on:{"click":_vm.getList}},[_c('p',{staticClass:" cm-color-white"},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-12 cm-p-lr-16 cm-bg-white"},[_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-border-bottom-1 cm-p-tb-12"},[_c('li',{staticClass:"cm-fn-weight-default "},[_vm._v("姓名")]),_vm._v(" "),_c('li',{staticClass:"cm-fn-weight-default cm-center",on:{"click":function($event){return _vm.sort(1)}}},[_vm._v("用户 "),(_vm.order == 1)?_c('img',{staticClass:"cm-icon-10 cm-m-t-4",attrs:{"src":"/static/images/arrow-d-3@2x.png"}}):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"cm-fn-weight-default  cm-center",on:{"click":function($event){return _vm.sort(2)}}},[_vm._v("订单 "),(_vm.order == 2)?_c('img',{staticClass:"cm-icon-10 cm-m-t-4",attrs:{"src":"/static/images/arrow-d-3@2x.png"}}):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"cm-fn-weight-default  cm-center",on:{"click":function($event){return _vm.sort(3)}}},[_vm._v("会员卡"),(_vm.order == 3)?_c('img',{staticClass:"cm-icon-10 cm-m-t-4",attrs:{"src":"/static/images/arrow-d-3@2x.png"}}):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"cm-fn-weight-default  cm-center",on:{"click":function($event){return _vm.sort(0)}}},[_vm._v("分润"),(_vm.order == 0)?_c('img',{staticClass:"cm-icon-10 cm-m-t-4",attrs:{"src":"/static/images/arrow-d-3@2x.png"}}):_vm._e()])]),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('ul',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.user))]),_vm._v(" "),_c('li',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.order ? item.order : 0))]),_vm._v(" "),_c('li',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.card ? item.card : 0))]),_vm._v(" "),_c('li',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.money ? item.money : 0))])])})],2),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var groupInvite_staticRenderFns = []
var groupInvite_esExports = { render: groupInvite_render, staticRenderFns: groupInvite_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_groupInvite = (groupInvite_esExports);
// CONCATENATED MODULE: ./src/pages/groupInvite.vue
function groupInvite_injectStyle (ssrContext) {
  __webpack_require__("8GKz")
}
var groupInvite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var groupInvite___vue_template_functional__ = false
/* styles */
var groupInvite___vue_styles__ = groupInvite_injectStyle
/* scopeId */
var groupInvite___vue_scopeId__ = "data-v-4f6c0f9a"
/* moduleIdentifier (server only) */
var groupInvite___vue_module_identifier__ = null
var groupInvite_Component = groupInvite_normalizeComponent(
  selectortype_script_index_0_src_pages_groupInvite,
  selectortype_template_index_0_src_pages_groupInvite,
  groupInvite___vue_template_functional__,
  groupInvite___vue_styles__,
  groupInvite___vue_scopeId__,
  groupInvite___vue_module_identifier__
)

/* harmony default export */ var src_pages_groupInvite = (groupInvite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondBd.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var secondBd = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getSecondBd({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'secondBdEdit', params: { id: id } });
        },
        rebate: function rebate(id) {
            this.$router.push({ name: 'rebate', params: { uid: 0, otherId: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondBd.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_secondBd = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getSecondBd({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'secondBdEdit', params: { id: id } });
        },
        rebate: function rebate(id) {
            this.$router.push({ name: 'rebate', params: { uid: 0, otherId: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9e34fd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondBd.vue
var secondBd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"账号/姓名/手机号关键字查询"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.info(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-block"},[_vm._v("账号："),_c('span',{staticClass:"cm-color-red cm-fn-16"},[_vm._v(_vm._s(item.account))])]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle "},[_c('div',{staticClass:"cm-flex-start  cm-p-tb-8 cm-p-lr-12"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.user ? item.user.head : '/static/images/default.png'}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-16 cm-text-left"},[_c('p',{},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.phone))])])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-p-tb-8 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-orange"},[_vm._v("日常："+_vm._s(item.reward)+"%")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v("活动："+_vm._s(item.active_reward)+"%")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v("会员卡："+_vm._s(item.card_reward)+"%")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-p-tb-12"},[_c('div',{staticClass:"cm-bg-orange cm-color-white cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.rebate(item.id)}}},[_vm._v("收益记录")]),_vm._v(" "),_c('div',{staticClass:"cm-border  cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4 ",on:{"click":function($event){return _vm.info(item.id)}}},[_vm._v("修改")])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var secondBd_staticRenderFns = []
var secondBd_esExports = { render: secondBd_render, staticRenderFns: secondBd_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondBd = (secondBd_esExports);
// CONCATENATED MODULE: ./src/pages/secondBd.vue
function secondBd_injectStyle (ssrContext) {
  __webpack_require__("WGM4")
}
var secondBd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondBd___vue_template_functional__ = false
/* styles */
var secondBd___vue_styles__ = secondBd_injectStyle
/* scopeId */
var secondBd___vue_scopeId__ = "data-v-a9e34fd8"
/* moduleIdentifier (server only) */
var secondBd___vue_module_identifier__ = null
var secondBd_Component = secondBd_normalizeComponent(
  pages_secondBd,
  selectortype_template_index_0_src_pages_secondBd,
  secondBd___vue_template_functional__,
  secondBd___vue_styles__,
  secondBd___vue_scopeId__,
  secondBd___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondBd = (secondBd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondBdEdit.vue




/* harmony default export */ var secondBdEdit = ({
  name: 'secondBdEdit',
  components: {
    XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        name: '',
        phone: '',
        account: '',
        password: '',
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    console.log(this.formData);
    if (this.formData.id > 0) {
      this.getSecondBd();
    }
  },

  computed: {},
  methods: {
    getSecondBd: function getSecondBd() {
      var _this = this;

      this.$api.getSecondBd({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入姓名或名称');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入手机号');
        return false;
      }
      if (!this.formData.account) {
        this.$func.showToast('请输入登录账号');
        return false;
      }
      if (!this.formData.password) {
        this.$func.showToast('请输入登录密码');
        return false;
      }
      this.$api.submitSecondBd(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondBdEdit.vue




/* harmony default export */ var pages_secondBdEdit = ({
  name: 'secondBdEdit',
  components: {
    XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        name: '',
        phone: '',
        account: '',
        password: '',
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    console.log(this.formData);
    if (this.formData.id > 0) {
      this.getSecondBd();
    }
  },

  computed: {},
  methods: {
    getSecondBd: function getSecondBd() {
      var _this = this;

      this.$api.getSecondBd({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入姓名或名称');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入手机号');
        return false;
      }
      if (!this.formData.account) {
        this.$func.showToast('请输入登录账号');
        return false;
      }
      if (!this.formData.password) {
        this.$func.showToast('请输入登录密码');
        return false;
      }
      this.$api.submitSecondBd(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b54f9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondBdEdit.vue
var secondBdEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入姓名或名称"},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("手机号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入手机号","oninput":"if(value.length > 11)value=value.slice(0,11)"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("账号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.account),expression:"formData.account"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入登录账号"},domProps:{"value":(_vm.formData.account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "account", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"password","placeholder":"请输入登录密码"},domProps:{"value":(_vm.formData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("日常洗衣分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.reward),expression:"formData.reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("活动商品分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.active_reward),expression:"formData.active_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.active_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "active_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("会员卡分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.card_reward),expression:"formData.card_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.card_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "card_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("备注")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":80,"placeholder":"80字以内（选填）","height":80},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var secondBdEdit_staticRenderFns = []
var secondBdEdit_esExports = { render: secondBdEdit_render, staticRenderFns: secondBdEdit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondBdEdit = (secondBdEdit_esExports);
// CONCATENATED MODULE: ./src/pages/secondBdEdit.vue
function secondBdEdit_injectStyle (ssrContext) {
  __webpack_require__("1j/V")
}
var secondBdEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondBdEdit___vue_template_functional__ = false
/* styles */
var secondBdEdit___vue_styles__ = secondBdEdit_injectStyle
/* scopeId */
var secondBdEdit___vue_scopeId__ = "data-v-24b54f9d"
/* moduleIdentifier (server only) */
var secondBdEdit___vue_module_identifier__ = null
var secondBdEdit_Component = secondBdEdit_normalizeComponent(
  pages_secondBdEdit,
  selectortype_template_index_0_src_pages_secondBdEdit,
  secondBdEdit___vue_template_functional__,
  secondBdEdit___vue_styles__,
  secondBdEdit___vue_scopeId__,
  secondBdEdit___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondBdEdit = (secondBdEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunity.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var secondCommunity = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            isActive: 0,
            grade: 0,
            types: [{
                'key': 0,
                'text': '门店列表'
            }, {
                'key': 1,
                'text': '门店收益'
            }]
        };
    },
    mounted: function mounted() {
        this.grade = this.$func.getLocal('grade');
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            if (this.isActive) {
                this.$api.secondCommunityReward({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                    if (res) {
                        if (!_this.lastId) {
                            _this.blankShow = res.data.length > 0 ? false : true;
                        }
                        _this.hasNext = res.hasNext;
                        _this.lastId = res.lastId;
                        res.data.forEach(function (item) {
                            _this.list.push(item);
                        });
                    }
                });
            } else {
                this.$api.getSecondCommunity({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                    if (res) {
                        if (!_this.lastId) {
                            _this.blankShow = res.data.length > 0 ? false : true;
                        }
                        _this.hasNext = res.hasNext;
                        _this.lastId = res.lastId;
                        res.data.forEach(function (item) {
                            _this.list.push(item);
                        });
                    }
                });
            }
        },
        info: function info(id) {
            this.$router.push({ name: 'secondCommunityEdit', params: { id: id } });
        },
        rebate: function rebate(id) {
            this.$router.push({ name: 'rebate', params: { uid: 0, otherId: id } });
        },
        factory: function factory(id) {
            this.$router.push({ name: 'secondCommunityFactoryPrice', params: { cid: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunity.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_secondCommunity = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            isActive: 0,
            grade: 0,
            types: [{
                'key': 0,
                'text': '门店列表'
            }, {
                'key': 1,
                'text': '门店收益'
            }]
        };
    },
    mounted: function mounted() {
        this.grade = this.$func.getLocal('grade');
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            if (this.isActive) {
                this.$api.secondCommunityReward({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                    if (res) {
                        if (!_this.lastId) {
                            _this.blankShow = res.data.length > 0 ? false : true;
                        }
                        _this.hasNext = res.hasNext;
                        _this.lastId = res.lastId;
                        res.data.forEach(function (item) {
                            _this.list.push(item);
                        });
                    }
                });
            } else {
                this.$api.getSecondCommunity({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                    if (res) {
                        if (!_this.lastId) {
                            _this.blankShow = res.data.length > 0 ? false : true;
                        }
                        _this.hasNext = res.hasNext;
                        _this.lastId = res.lastId;
                        res.data.forEach(function (item) {
                            _this.list.push(item);
                        });
                    }
                });
            }
        },
        info: function info(id) {
            this.$router.push({ name: 'secondCommunityEdit', params: { id: id } });
        },
        rebate: function rebate(id) {
            this.$router.push({ name: 'rebate', params: { uid: 0, otherId: id } });
        },
        factory: function factory(id) {
            this.$router.push({ name: 'secondCommunityFactoryPrice', params: { cid: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60698728","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondCommunity.vue
var secondCommunity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"nav cm-bg-white"},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 cm-w-50",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.select(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"社区名称/姓名/手机号关键字查询"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.info(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[(_vm.isActive)?_c('div',{staticClass:"table"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-orange cm-fn-18"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.name))])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("收益")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(item.today.total_reward))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.month.total_reward))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.total.total_reward))])]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("收衣")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(item.today.goods_num))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.month.goods_num))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.total.goods_num))])]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1  cm-p-tb-12"},[_c('li',[_vm._v("订单")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(item.today.order_num))]),_vm._v(" "),_c('li',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.month.order_num))]),_vm._v(" "),_c('li',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.total.order_num))])])]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-orange cm-fn-16 overflow-line-1"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.name))]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-12  cm-p-tb-8"},[_c('div',{staticClass:"cm-text-left cm-flex-start cm-flex-middle"},[_c('p',{},[_vm._v(_vm._s(item.head_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default cm-m-l-12"},[_vm._v(_vm._s(item.head_phone))])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left"})]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-12 cm-p-b-12"},[_c('p',[_vm._v("地址："+_vm._s(item.address))])]),_vm._v(" "),(_vm.grade == 5)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-p-tb-12"},[_c('div',{staticClass:"cm-bg-orange cm-color-white cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.rebate(item.id)}}},[_vm._v("收益记录")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.factory(item.id)}}},[_vm._v("加工价格")]),_vm._v(" "),_c('div',{staticClass:"cm-border  cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4 ",on:{"click":function($event){return _vm.info(item.id)}}},[_vm._v("修改")])]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var secondCommunity_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-border-bottom-1 cm-p-tb-12"},[_c('li',{staticClass:"cm-fn-14"},[_vm._v("项目")]),_vm._v(" "),_c('li',[_vm._v("今日")]),_vm._v(" "),_c('li',[_vm._v("当月")]),_vm._v(" "),_c('li',[_vm._v("累计")])])}]
var secondCommunity_esExports = { render: secondCommunity_render, staticRenderFns: secondCommunity_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondCommunity = (secondCommunity_esExports);
// CONCATENATED MODULE: ./src/pages/secondCommunity.vue
function secondCommunity_injectStyle (ssrContext) {
  __webpack_require__("WJ6T")
}
var secondCommunity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondCommunity___vue_template_functional__ = false
/* styles */
var secondCommunity___vue_styles__ = secondCommunity_injectStyle
/* scopeId */
var secondCommunity___vue_scopeId__ = "data-v-60698728"
/* moduleIdentifier (server only) */
var secondCommunity___vue_module_identifier__ = null
var secondCommunity_Component = secondCommunity_normalizeComponent(
  pages_secondCommunity,
  selectortype_template_index_0_src_pages_secondCommunity,
  secondCommunity___vue_template_functional__,
  secondCommunity___vue_styles__,
  secondCommunity___vue_scopeId__,
  secondCommunity___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondCommunity = (secondCommunity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityEdit.vue






/* harmony default export */ var secondCommunityEdit = ({
  name: 'secondCommunityEdit',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        title: '',
        name: '',
        phone: '',
        reward: '',
        clean_reward: '',
        card_reward: '',
        goods_reward: '',
        content: '',
        address: '请在地图上标注社区所在位置',
        lat: '',
        lng: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.config();
    console.log(this.formData);
    if (this.formData.id > 0) {
      this.getSecondCommunity();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'maps') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  activated: function activated() {
    if (this.$func.getSession('address')) {
      var address = JSON.parse(this.$func.getSession('address'));
      this.formData.address = address.poiaddress;
      this.formData.lat = address.latlng.lat;
      this.formData.lng = address.latlng.lng;
      this.$func.setSession('address', '');
    }
  },

  methods: {
    getSecondCommunity: function getSecondCommunity() {
      var _this = this;

      this.$api.getSecondCommunity({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入社区名称');
        return false;
      }
      if (!this.formData.head_name) {
        this.$func.showToast('请输入团长姓名');
        return false;
      }
      if (!this.formData.head_phone) {
        this.$func.showToast('请输入团长电话');
        return false;
      }
      if (!this.formData.reward) {
        this.$func.showToast('请输入洗衣分润');
        return false;
      }
      if (!this.formData.card_reward) {
        this.$func.showToast('请输入会员卡分润');
        return false;
      }
      if (!this.formData.clean_reward) {
        this.$func.showToast('请输入家政分润');
        return false;
      }
      if (!this.formData.goods_reward) {
        this.$func.showToast('请输入商品分润');
        return false;
      }
      if (!this.formData.lat || !this.formData.lng) {
        this.$func.showToast('请在地图上标注社区所在位置');
        return false;
      }
      this.$api.submitSecondCommunity(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 300);
        }
      });
    },
    position: function position() {
      var that = this;
      weixin_js_sdk_default.a.getLocation({
        type: 'gcj02',
        success: function success(res) {
          that.$router.push({ name: 'maps', params: { latitude: res.latitude, longitude: res.longitude } });
        }
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["getLocation"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityEdit.vue






/* harmony default export */ var pages_secondCommunityEdit = ({
  name: 'secondCommunityEdit',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        title: '',
        name: '',
        phone: '',
        reward: '',
        clean_reward: '',
        card_reward: '',
        goods_reward: '',
        content: '',
        address: '请在地图上标注社区所在位置',
        lat: '',
        lng: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.config();
    console.log(this.formData);
    if (this.formData.id > 0) {
      this.getSecondCommunity();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'maps') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  activated: function activated() {
    if (this.$func.getSession('address')) {
      var address = JSON.parse(this.$func.getSession('address'));
      this.formData.address = address.poiaddress;
      this.formData.lat = address.latlng.lat;
      this.formData.lng = address.latlng.lng;
      this.$func.setSession('address', '');
    }
  },

  methods: {
    getSecondCommunity: function getSecondCommunity() {
      var _this = this;

      this.$api.getSecondCommunity({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入社区名称');
        return false;
      }
      if (!this.formData.head_name) {
        this.$func.showToast('请输入团长姓名');
        return false;
      }
      if (!this.formData.head_phone) {
        this.$func.showToast('请输入团长电话');
        return false;
      }
      if (!this.formData.reward) {
        this.$func.showToast('请输入洗衣分润');
        return false;
      }
      if (!this.formData.card_reward) {
        this.$func.showToast('请输入会员卡分润');
        return false;
      }
      if (!this.formData.clean_reward) {
        this.$func.showToast('请输入家政分润');
        return false;
      }
      if (!this.formData.goods_reward) {
        this.$func.showToast('请输入商品分润');
        return false;
      }
      if (!this.formData.lat || !this.formData.lng) {
        this.$func.showToast('请在地图上标注社区所在位置');
        return false;
      }
      this.$api.submitSecondCommunity(this.formData).then(function (res) {
        if (res) {
          _this2.$func.showToast('提交成功');
          setTimeout(function () {
            _this2.$router.go(-1);
          }, 300);
        }
      });
    },
    position: function position() {
      var that = this;
      weixin_js_sdk_default.a.getLocation({
        type: 'gcj02',
        success: function success(res) {
          that.$router.push({ name: 'maps', params: { latitude: res.latitude, longitude: res.longitude } });
        }
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["getLocation"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a726686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondCommunityEdit.vue
var secondCommunityEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("社区名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入社区名称"},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("所在位置")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-border-bottom-1 cm-w-100 cm-m-t-8 cm-p-tb-8",on:{"click":function($event){return _vm.position()}}},[_c('p',{staticClass:"cm-fn-16 ",class:_vm.formData.address == '请在地图上标注社区所在位置' ? 'cm-color-999' : 'cm-color-block'},[_vm._v(_vm._s(_vm.formData.address))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("团长姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.head_name),expression:"formData.head_name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入团长姓名"},domProps:{"value":(_vm.formData.head_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "head_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("团长电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.head_phone),expression:"formData.head_phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入团长电话"},domProps:{"value":(_vm.formData.head_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "head_phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("洗衣分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.reward),expression:"formData.reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("家政分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.clean_reward),expression:"formData.clean_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.clean_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "clean_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("会员卡分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.card_reward),expression:"formData.card_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.card_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "card_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("商品分润（%）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.goods_reward),expression:"formData.goods_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"所得利润百分比"},domProps:{"value":(_vm.formData.goods_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "goods_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("团长描述")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":80,"placeholder":"80字以内（选填）","height":80},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var secondCommunityEdit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-text-left cm-p-tb-4"},[_c('p',{staticClass:"cm-fn-14 cm-color-orange"},[_vm._v("注：团长平台登录账号为“团长电话”；默认密码：123456")])])}]
var secondCommunityEdit_esExports = { render: secondCommunityEdit_render, staticRenderFns: secondCommunityEdit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondCommunityEdit = (secondCommunityEdit_esExports);
// CONCATENATED MODULE: ./src/pages/secondCommunityEdit.vue
function secondCommunityEdit_injectStyle (ssrContext) {
  __webpack_require__("ZYdI")
}
var secondCommunityEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondCommunityEdit___vue_template_functional__ = false
/* styles */
var secondCommunityEdit___vue_styles__ = secondCommunityEdit_injectStyle
/* scopeId */
var secondCommunityEdit___vue_scopeId__ = "data-v-2a726686"
/* moduleIdentifier (server only) */
var secondCommunityEdit___vue_module_identifier__ = null
var secondCommunityEdit_Component = secondCommunityEdit_normalizeComponent(
  pages_secondCommunityEdit,
  selectortype_template_index_0_src_pages_secondCommunityEdit,
  secondCommunityEdit___vue_template_functional__,
  secondCommunityEdit___vue_styles__,
  secondCommunityEdit___vue_scopeId__,
  secondCommunityEdit___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondCommunityEdit = (secondCommunityEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityFactoryPrice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var secondCommunityFactoryPrice = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            cid: 0,
            title: '',
            list: [],
            where: [],
            price: []
        };
    },
    mounted: function mounted() {
        this.cid = parseInt(this.$route.params.cid);
        this.getList();
    },

    methods: {
        reset: function reset() {
            this.title = '';
            this.list = [];
            this.getList();
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.storeGoodsPrice({ cid: this.cid, title: this.title }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                }
            });
        },
        submit: function submit(i) {
            var _this2 = this;

            console.log(i, this.price[i]);
            var price = Number(this.price[i]);
            var miPrice = Number(this.list[i].mi_wash_price);
            if (miPrice != price) {
                // if(miPrice < price){
                //     this.$func.showToast('下级加工价格不能小于平台加工价格');
                //     return false;
                // }
                this.$api.submitStoreGoodsPrice({ cid: this.cid, gid: this.list[i].id, price: price }).then(function (res) {
                    if (res) {
                        // this.search();
                        _this2.list[i].wash_price = price;
                        _this2.$func.showToast('提交成功');
                    }
                });
            }
            // this.$api.storeGoodsPrice({title:this.title}).then((res)=>{
            //     if(res){
            //         this.list = res.data;
            //     }
            // })  
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityFactoryPrice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_secondCommunityFactoryPrice = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            cid: 0,
            title: '',
            list: [],
            where: [],
            price: []
        };
    },
    mounted: function mounted() {
        this.cid = parseInt(this.$route.params.cid);
        this.getList();
    },

    methods: {
        reset: function reset() {
            this.title = '';
            this.list = [];
            this.getList();
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.storeGoodsPrice({ cid: this.cid, title: this.title }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                }
            });
        },
        submit: function submit(i) {
            var _this2 = this;

            console.log(i, this.price[i]);
            var price = Number(this.price[i]);
            var miPrice = Number(this.list[i].mi_wash_price);
            if (miPrice != price) {
                // if(miPrice < price){
                //     this.$func.showToast('下级加工价格不能小于平台加工价格');
                //     return false;
                // }
                this.$api.submitStoreGoodsPrice({ cid: this.cid, gid: this.list[i].id, price: price }).then(function (res) {
                    if (res) {
                        // this.search();
                        _this2.list[i].wash_price = price;
                        _this2.$func.showToast('提交成功');
                    }
                });
            }
            // this.$api.storeGoodsPrice({title:this.title}).then((res)=>{
            //     if(res){
            //         this.list = res.data;
            //     }
            // })  
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496cc500","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondCommunityFactoryPrice.vue
var secondCommunityFactoryPrice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8 cm-w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"cm-fn-16  cm-color-red  cm-p-tb-4 ",attrs:{"type":"text","placeholder":"商品名称"},domProps:{"value":(_vm.title)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),(_vm.title)?_c('img',{staticClass:"cm-icon-20 cm-m-r-12",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.reset}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[_c('ul',{staticClass:"cm-m-lr-8"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle",staticStyle:{"width":"58%"}},[_c('p',{staticClass:"cm-color-orange cm-fn-14 overflow-line-1",staticStyle:{"max-width":"80%"}},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.title))]),_vm._v(" "),_c('img',{staticClass:"cm-icon-24 cm-m-l-12",attrs:{"src":item.pic}})]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12"},[_vm._v("门店加工价格："),_c('span',{staticClass:"cm-color-orange cm-fn-14"},[_vm._v("￥"+_vm._s(item.mi_wash_price))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-12  cm-p-tb-6"},[_c('p',[_vm._v("下级加工价格："),_c('span',{staticClass:"cm-color-green"},[_vm._v("￥"+_vm._s(item.wash_price))])]),_vm._v(" "),_c('span',{staticClass:"cm-color-orange"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.price[index]),expression:"price[index]"}],staticClass:"cm-p-tb-4 cm-fn-16 cm-border cm-p-lr-4 cm-color-red",attrs:{"type":"number","placeholder":"设置加工价格","min":item.mi_wash_price},domProps:{"value":(_vm.price[index])},on:{"blur":function($event){return _vm.submit(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.price, index, $event.target.value)}}})])])}),0)])])}
var secondCommunityFactoryPrice_staticRenderFns = []
var secondCommunityFactoryPrice_esExports = { render: secondCommunityFactoryPrice_render, staticRenderFns: secondCommunityFactoryPrice_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondCommunityFactoryPrice = (secondCommunityFactoryPrice_esExports);
// CONCATENATED MODULE: ./src/pages/secondCommunityFactoryPrice.vue
function secondCommunityFactoryPrice_injectStyle (ssrContext) {
  __webpack_require__("CubJ")
}
var secondCommunityFactoryPrice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondCommunityFactoryPrice___vue_template_functional__ = false
/* styles */
var secondCommunityFactoryPrice___vue_styles__ = secondCommunityFactoryPrice_injectStyle
/* scopeId */
var secondCommunityFactoryPrice___vue_scopeId__ = "data-v-496cc500"
/* moduleIdentifier (server only) */
var secondCommunityFactoryPrice___vue_module_identifier__ = null
var secondCommunityFactoryPrice_Component = secondCommunityFactoryPrice_normalizeComponent(
  pages_secondCommunityFactoryPrice,
  selectortype_template_index_0_src_pages_secondCommunityFactoryPrice,
  secondCommunityFactoryPrice___vue_template_functional__,
  secondCommunityFactoryPrice___vue_styles__,
  secondCommunityFactoryPrice___vue_scopeId__,
  secondCommunityFactoryPrice___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondCommunityFactoryPrice = (secondCommunityFactoryPrice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/balance.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var balance = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            pop: false,
            popUp: false,
            height: '100%',
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            amount: '',
            info: {
                community_balance: 0
            },
            moneyMax: 5000,
            isActive: 1,
            types: [{
                'key': 0,
                'text': '充值记录'
            }, {
                'key': 1,
                'text': '消费记录'
            }]
        };
    },
    mounted: function mounted() {
        this.getInfo();
    },

    methods: {
        getInfo: function getInfo() {
            var _this = this;

            this.$api.getInfo({}).then(function (res) {
                if (res) {
                    _this.info = res.data;
                }
            });
        },
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this2 = this;

            switch (parseInt(this.isActive)) {
                case 1:
                    this.$api.balanceList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
                default:
                    this.$api.balanceList({ last_id: this.lastId, page_flag: this.pageFlag, type: 1 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        openPop: function openPop() {
            this.pop = true;
            this.popUp = true;
        },
        closePop: function closePop() {
            this.pop = false;
            this.popUp = false;
        },
        recharge: function recharge() {
            if (this.amount <= 0) {
                this.$func.showToast('请输入充值金额');
                return false;
            }
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            } else {
                this.onBridgeReady();
            }
        },
        onBridgeReady: function onBridgeReady() {
            var that = this;
            this.$api.recharge({ money: this.amount }).then(function (res) {
                if (res) {
                    WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            that.$func.showToast('支付成功');
                            setTimeout(function () {
                                that.$router.push({ name: 'balance' });
                            }, 300);
                        } else {
                            that.$func.showToast('已取消支付');
                        }
                        that.closePop();
                    });
                }
            });
        },
        withdraw: function withdraw() {
            if (this.info.withdraw <= 0) {
                this.$func.showToast('无可提现金额');
                return false;
            }
            this.$router.push({ path: '/withdraw', query: { ids: '', type: 1 } });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/balance.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_balance = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            pop: false,
            popUp: false,
            height: '100%',
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            amount: '',
            info: {
                community_balance: 0
            },
            moneyMax: 5000,
            isActive: 1,
            types: [{
                'key': 0,
                'text': '充值记录'
            }, {
                'key': 1,
                'text': '消费记录'
            }]
        };
    },
    mounted: function mounted() {
        this.getInfo();
    },

    methods: {
        getInfo: function getInfo() {
            var _this = this;

            this.$api.getInfo({}).then(function (res) {
                if (res) {
                    _this.info = res.data;
                }
            });
        },
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this2 = this;

            switch (parseInt(this.isActive)) {
                case 1:
                    this.$api.balanceList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
                default:
                    this.$api.balanceList({ last_id: this.lastId, page_flag: this.pageFlag, type: 1 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        openPop: function openPop() {
            this.pop = true;
            this.popUp = true;
        },
        closePop: function closePop() {
            this.pop = false;
            this.popUp = false;
        },
        recharge: function recharge() {
            if (this.amount <= 0) {
                this.$func.showToast('请输入充值金额');
                return false;
            }
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            } else {
                this.onBridgeReady();
            }
        },
        onBridgeReady: function onBridgeReady() {
            var that = this;
            this.$api.recharge({ money: this.amount }).then(function (res) {
                if (res) {
                    WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            that.$func.showToast('支付成功');
                            setTimeout(function () {
                                that.$router.push({ name: 'balance' });
                            }, 300);
                        } else {
                            that.$func.showToast('已取消支付');
                        }
                        that.closePop();
                    });
                }
            });
        },
        withdraw: function withdraw() {
            if (this.info.withdraw <= 0) {
                this.$func.showToast('无可提现金额');
                return false;
            }
            this.$router.push({ path: '/withdraw', query: { ids: '', type: 1 } });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc2726d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/balance.vue
var balance_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-border-radius-6 cm-p-tb-16 cm-pf",staticStyle:{"height":"126px","top":"0","z-index":"100"}},[_c('div',{staticClass:" cm-flex-between cm-flex-middle cm-p-lr-16"},[_c('div',[_c('p',{staticClass:"cm-fn-12 cm-fn-weight-min cm-color-666"},[_vm._v("余额")]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-10 cm-fn-36 cm-color-red"},[_vm._v(_vm._s(_vm.info.community_balance))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-green cm-m-l-16",staticStyle:{"border-radius":"16px"},on:{"click":function($event){return _vm.openPop()}}},[_vm._v("充值")])])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-tb-12 cm-flex-middle cm-flex-around"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-fn-16 cm-color-666",class:[_vm.isActive == index ? 'active' : ''],on:{"click":function($event){return _vm.select(index)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank',{staticClass:"cm-m-t-40",attrs:{"blankStyle":_vm.height}}):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"50"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-p-t-8 cm-p-lr-12 cm-bg-white cm-m-t-2 cm-p-b-4"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between"},[_c('div',[_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-fn-weight-min cm-fn-12 cm-color-txt2"},[_vm._v(" "+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-text-right"},[(item.add > 0)?_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-green"},[_vm._v(_vm._s(item.money))]):_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-red"},[_vm._v("-"+_vm._s(item.money))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v(_vm._s(item.content))])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"pop-bg cm-p-tb-24"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入充值金额")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('p',{staticClass:"cm-color-orange cm-fn-22"},[_vm._v("￥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"cm-fn-22 cm-m-lr-4 cm-h-100 cm-color-orange cm-bg-gray cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"80px","height":"40px"},attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.recharge()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认支付")])])])]):_vm._e()])}
var balance_staticRenderFns = []
var balance_esExports = { render: balance_render, staticRenderFns: balance_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_balance = (balance_esExports);
// CONCATENATED MODULE: ./src/pages/balance.vue
function balance_injectStyle (ssrContext) {
  __webpack_require__("p9i6")
}
var balance_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var balance___vue_template_functional__ = false
/* styles */
var balance___vue_styles__ = balance_injectStyle
/* scopeId */
var balance___vue_scopeId__ = "data-v-4dc2726d"
/* moduleIdentifier (server only) */
var balance___vue_module_identifier__ = null
var balance_Component = balance_normalizeComponent(
  pages_balance,
  selectortype_template_index_0_src_pages_balance,
  balance___vue_template_functional__,
  balance___vue_styles__,
  balance___vue_scopeId__,
  balance___vue_module_identifier__
)

/* harmony default export */ var src_pages_balance = (balance_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/maps.vue

//
//
//
//
//
//
//
//

/* harmony default export */ var maps = ({
  name: 'maps',
  components: {},
  data: function data() {
    return {
      lat: '',
      lng: '',
      address: '',
      confirmStatus: false,
      src: ''
    };
  },
  created: function created() {
    this.lat = this.$route.params.latitude;
    this.lng = this.$route.params.longitude;
    this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    console.log(this.src);
  },

  // beforeRouteLeave(to, from, next) {
  //   to.meta.keepAlive = true; 
  //   next();
  // },
  mounted: function mounted() {
    var that = this;
    this.$func.setSession('address', '');
    window.addEventListener('message', function (event) {
      //  console.log(event);

      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {
        that.$func.setSession('address', stringify_default()(loc));
      }
    }, false);
  },

  methods: {
    confirm: function confirm() {
      if (!this.$func.getSession('address')) {
        this.$func.showToast('请选择位置信息');
        return false;
      }
      this.$router.back(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/maps.vue

//
//
//
//
//
//
//
//

/* harmony default export */ var pages_maps = ({
  name: 'maps',
  components: {},
  data: function data() {
    return {
      lat: '',
      lng: '',
      address: '',
      confirmStatus: false,
      src: ''
    };
  },
  created: function created() {
    this.lat = this.$route.params.latitude;
    this.lng = this.$route.params.longitude;
    this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM&referer=fengchao';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    // this.src = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&coord='+this.lat+','+this.lng+'&key=3RXBZ-XDHC4-76FUE-X3T6K-7VOJK-KEFFP&referer=washcollect';
    console.log(this.src);
  },

  // beforeRouteLeave(to, from, next) {
  //   to.meta.keepAlive = true; 
  //   next();
  // },
  mounted: function mounted() {
    var that = this;
    this.$func.setSession('address', '');
    window.addEventListener('message', function (event) {
      //  console.log(event);

      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {
        that.$func.setSession('address', stringify_default()(loc));
      }
    }, false);
  },

  methods: {
    confirm: function confirm() {
      if (!this.$func.getSession('address')) {
        this.$func.showToast('请选择位置信息');
        return false;
      }
      this.$router.back(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-653010aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/maps.vue
var maps_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-w-100 cm-h-100"},[_c('div',{staticClass:"cm-pa cm-bg-green cm-color-white cm-p-lr-4 cm-p-tb-4 cm-center cm-border-radius-2",staticStyle:{"top":"330px","right":"5px","width":"50px"},on:{"click":function($event){return _vm.confirm()}}},[_vm._v("确认")]),_vm._v(" "),(_vm.src)?_c('iframe',{attrs:{"id":"mapPage","width":"100%","height":"100%","frameborder":"0","src":_vm.src}}):_vm._e()])}
var maps_staticRenderFns = []
var maps_esExports = { render: maps_render, staticRenderFns: maps_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_maps = (maps_esExports);
// CONCATENATED MODULE: ./src/pages/maps.vue
function maps_injectStyle (ssrContext) {
  __webpack_require__("fB+7")
}
var maps_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maps___vue_template_functional__ = false
/* styles */
var maps___vue_styles__ = maps_injectStyle
/* scopeId */
var maps___vue_scopeId__ = "data-v-653010aa"
/* moduleIdentifier (server only) */
var maps___vue_module_identifier__ = null
var maps_Component = maps_normalizeComponent(
  pages_maps,
  selectortype_template_index_0_src_pages_maps,
  maps___vue_template_functional__,
  maps___vue_styles__,
  maps___vue_scopeId__,
  maps___vue_module_identifier__
)

/* harmony default export */ var src_pages_maps = (maps_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driverList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_driverList = ({
    name: 'driverList',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {
        //   this.getList()
    },

    // beforeRouteLeave(to, from, next) {
    //     if(to.name == 'driverEdit'){
    //         from.meta.keepAlive = true; 
    //     }else{
    //     var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
    //     var cache = this.$vnode.parent.componentInstance.cache
    //     var keys = this.$vnode.parent.componentInstance.keys
    //     console.log(key,cache,keys);
    //         if (cache[key]) {
    //             if (keys.length) {
    //                 var index = keys.indexOf(key)
    //                 if (index > -1) {
    //                     keys.splice(index, 1) 
    //                 }
    //             }
    //             delete cache[key]
    //         }
    //     }
    //     next();
    // },
    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.driverList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'driverEdit', params: { id: id } });
        },

        // rebate(id){
        //     this.$router.push({name:'rebate',params:{uid:0,otherId:id}})
        // },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driverList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_driverList = ({
    name: 'driverList',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {
        //   this.getList()
    },

    // beforeRouteLeave(to, from, next) {
    //     if(to.name == 'driverEdit'){
    //         from.meta.keepAlive = true; 
    //     }else{
    //     var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
    //     var cache = this.$vnode.parent.componentInstance.cache
    //     var keys = this.$vnode.parent.componentInstance.keys
    //     console.log(key,cache,keys);
    //         if (cache[key]) {
    //             if (keys.length) {
    //                 var index = keys.indexOf(key)
    //                 if (index > -1) {
    //                     keys.splice(index, 1) 
    //                 }
    //             }
    //             delete cache[key]
    //         }
    //     }
    //     next();
    // },
    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.driverList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'driverEdit', params: { id: id } });
        },

        // rebate(id){
        //     this.$router.push({name:'rebate',params:{uid:0,otherId:id}})
        // },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26bcee7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/driverList.vue
var driverList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"姓名/手机号查询"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.info(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-p-tb-8 cm-bg-white",on:{"click":function($event){return _vm.info(item.id)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-12  cm-p-tb-12"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.phone))])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-orange"},[_vm._v("取衣："+_vm._s(item.take_reward)+"元/件")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v("送衣："+_vm._s(item.send_reward)+"元/件")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-p-b-12 cm-p-lr-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var driverList_staticRenderFns = []
var driverList_esExports = { render: driverList_render, staticRenderFns: driverList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_driverList = (driverList_esExports);
// CONCATENATED MODULE: ./src/pages/driverList.vue
function driverList_injectStyle (ssrContext) {
  __webpack_require__("HybY")
}
var driverList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var driverList___vue_template_functional__ = false
/* styles */
var driverList___vue_styles__ = driverList_injectStyle
/* scopeId */
var driverList___vue_scopeId__ = "data-v-26bcee7e"
/* moduleIdentifier (server only) */
var driverList___vue_module_identifier__ = null
var driverList_Component = driverList_normalizeComponent(
  selectortype_script_index_0_src_pages_driverList,
  selectortype_template_index_0_src_pages_driverList,
  driverList___vue_template_functional__,
  driverList___vue_styles__,
  driverList___vue_scopeId__,
  driverList___vue_module_identifier__
)

/* harmony default export */ var src_pages_driverList = (driverList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driverEdit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var driverEdit = ({
    name: 'driverEdit',
    data: function data() {
        return {
            formData: {
                id: 0,
                title: '',
                phone: '',
                take_reward: '',
                send_reward: ''
            }
        };
    },
    created: function created() {
        this.formData.id = Number(this.$route.params.id);
        if (this.formData.id > 0) {
            this.driverInfo();
        }
    },


    methods: {
        driverInfo: function driverInfo() {
            var _this = this;

            this.$api.driverList({ id: this.formData.id }).then(function (res) {
                if (res) {
                    _this.formData = res.data;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            if (!this.formData.title) {
                this.$func.showToast('请输入姓名');
                return false;
            }
            if (!this.formData.phone) {
                this.$func.showToast('请输入手机号');
                return false;
            }
            if (!this.formData.take_reward) {
                this.$func.showToast('请输入取衣提成');
                return false;
            }
            if (!this.formData.send_reward) {
                this.$func.showToast('请输入送衣提成');
                return false;
            }
            this.$api.submitDriver(this.formData).then(function (res) {
                if (res) {
                    _this2.$func.showToast('提交成功');
                    setTimeout(function () {
                        _this2.$router.go(-1);
                    }, 300);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/driverEdit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_driverEdit = ({
    name: 'driverEdit',
    data: function data() {
        return {
            formData: {
                id: 0,
                title: '',
                phone: '',
                take_reward: '',
                send_reward: ''
            }
        };
    },
    created: function created() {
        this.formData.id = Number(this.$route.params.id);
        if (this.formData.id > 0) {
            this.driverInfo();
        }
    },


    methods: {
        driverInfo: function driverInfo() {
            var _this = this;

            this.$api.driverList({ id: this.formData.id }).then(function (res) {
                if (res) {
                    _this.formData = res.data;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            if (!this.formData.title) {
                this.$func.showToast('请输入姓名');
                return false;
            }
            if (!this.formData.phone) {
                this.$func.showToast('请输入手机号');
                return false;
            }
            if (!this.formData.take_reward) {
                this.$func.showToast('请输入取衣提成');
                return false;
            }
            if (!this.formData.send_reward) {
                this.$func.showToast('请输入送衣提成');
                return false;
            }
            this.$api.submitDriver(this.formData).then(function (res) {
                if (res) {
                    _this2.$func.showToast('提交成功');
                    setTimeout(function () {
                        _this2.$router.go(-1);
                    }, 300);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8280cfe4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/driverEdit.vue
var driverEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.title),expression:"formData.title"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入姓名"},domProps:{"value":(_vm.formData.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("手机号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入手机号"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("取衣提成（元/件）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.take_reward),expression:"formData.take_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"请输入"},domProps:{"value":(_vm.formData.take_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "take_reward", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("送衣提成（元/件）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.send_reward),expression:"formData.send_reward"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","placeholder":"请输入"},domProps:{"value":(_vm.formData.send_reward)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "send_reward", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var driverEdit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-text-left cm-p-tb-4"},[_c('p',{staticClass:"cm-fn-14 cm-color-orange"},[_vm._v("注：团长平台登录账号为“手机号”；默认密码：123456")])])}]
var driverEdit_esExports = { render: driverEdit_render, staticRenderFns: driverEdit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_driverEdit = (driverEdit_esExports);
// CONCATENATED MODULE: ./src/pages/driverEdit.vue
function driverEdit_injectStyle (ssrContext) {
  __webpack_require__("TxjS")
}
var driverEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var driverEdit___vue_template_functional__ = false
/* styles */
var driverEdit___vue_styles__ = driverEdit_injectStyle
/* scopeId */
var driverEdit___vue_scopeId__ = "data-v-8280cfe4"
/* moduleIdentifier (server only) */
var driverEdit___vue_module_identifier__ = null
var driverEdit_Component = driverEdit_normalizeComponent(
  pages_driverEdit,
  selectortype_template_index_0_src_pages_driverEdit,
  driverEdit___vue_template_functional__,
  driverEdit___vue_styles__,
  driverEdit___vue_scopeId__,
  driverEdit___vue_module_identifier__
)

/* harmony default export */ var src_pages_driverEdit = (driverEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitPickup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_waitPickup = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            types: [],
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            isActive: 0

        };
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
        if (this.i > 0) {
            this.$route.meta.title = '待送回';
            document.title = this.$route.meta.title;
            this.types = [{
                'key': 0,
                'text': '衣物配送'
            }, {
                'key': 1,
                'text': '商品配送'
            }];
        } else {
            this.$route.meta.title = '待取件';
            document.title = this.$route.meta.title;
        }
        this.config();
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.hasNext = 0;
            this.loadmore();
        },
        openMap: function openMap(cid) {
            this.$router.push({ name: 'openMap', params: { id: cid } });
        },
        waitPickupInfo: function waitPickupInfo(cid, type) {
            this.$router.push({ name: 'waitPickupInfo', params: { cid: cid, i: this.i, type: type } });
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPickup({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, i: this.i, type: this.isActive }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["openLocation"]
                    });
                }
            });
        },
        getInfo: function getInfo(id) {
            this.$api.getCommunity({ id: id }).then(function (res) {
                if (res) {
                    // this.info = res.data;
                    weixin_js_sdk_default.a.openLocation({
                        latitude: Number(res.data.lat), // 纬度，浮点数，范围为90 ~ -90
                        longitude: Number(res.data.lng), // 经度，浮点数，范围为180 ~ -180。
                        name: res.data.name, // 位置名
                        address: res.data.province + ' ' + res.data.city + ' ' + res.data.district + ' ' + res.data.address, // 地址详情说明
                        scale: 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
                        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitPickup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var selectortype_script_index_0_src_pages_waitPickup = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            types: [],
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            isActive: 0

        };
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
        if (this.i > 0) {
            this.$route.meta.title = '待送回';
            document.title = this.$route.meta.title;
            this.types = [{
                'key': 0,
                'text': '衣物配送'
            }, {
                'key': 1,
                'text': '商品配送'
            }];
        } else {
            this.$route.meta.title = '待取件';
            document.title = this.$route.meta.title;
        }
        this.config();
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.hasNext = 0;
            this.loadmore();
        },
        openMap: function openMap(cid) {
            this.$router.push({ name: 'openMap', params: { id: cid } });
        },
        waitPickupInfo: function waitPickupInfo(cid, type) {
            this.$router.push({ name: 'waitPickupInfo', params: { cid: cid, i: this.i, type: type } });
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPickup({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, i: this.i, type: this.isActive }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["openLocation"]
                    });
                }
            });
        },
        getInfo: function getInfo(id) {
            this.$api.getCommunity({ id: id }).then(function (res) {
                if (res) {
                    // this.info = res.data;
                    weixin_js_sdk_default.a.openLocation({
                        latitude: Number(res.data.lat), // 纬度，浮点数，范围为90 ~ -90
                        longitude: Number(res.data.lng), // 经度，浮点数，范围为180 ~ -180。
                        name: res.data.name, // 位置名
                        address: res.data.province + ' ' + res.data.city + ' ' + res.data.district + ' ' + res.data.address, // 地址详情说明
                        scale: 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
                        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e0d4e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waitPickup.vue
var waitPickup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[(_vm.types.length > 0)?_c('div',{staticClass:"nav cm-bg-white"},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 cm-w-50",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.select(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-bg",style:({ top: _vm.types.length > 0 ? '40px': '0px' })},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-flex-between cm-flex-middle cm-p-lr-12 cm-p-tb-12 cm-text-left"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle ",staticStyle:{"width":"85%","overflow":"hidden"},on:{"click":function($event){return _vm.waitPickupInfo(item.cid,item.type)}}},[_c('div',{staticClass:"cm-center"},[_c('p',{staticClass:"cm-fn-weight-max"},[_vm._v(_vm._s(index+1)+"、")])]),_vm._v(" "),(item.type == 1)?_c('div',[_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("社区名称："),_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物数量："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.count))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("最早封签时间："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.date))])])]):_c('div',[_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("社区名称："),_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("商品数量："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.count))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("最早下单时间："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.date))])])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle",on:{"click":function($event){return _vm.getInfo(item.cid)}}},[_c('img',{staticClass:"cm-icon-30",attrs:{"src":"/static/images/daohang.png"}})])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var waitPickup_staticRenderFns = []
var waitPickup_esExports = { render: waitPickup_render, staticRenderFns: waitPickup_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waitPickup = (waitPickup_esExports);
// CONCATENATED MODULE: ./src/pages/waitPickup.vue
function waitPickup_injectStyle (ssrContext) {
  __webpack_require__("aE5D")
}
var waitPickup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waitPickup___vue_template_functional__ = false
/* styles */
var waitPickup___vue_styles__ = waitPickup_injectStyle
/* scopeId */
var waitPickup___vue_scopeId__ = "data-v-48e0d4e6"
/* moduleIdentifier (server only) */
var waitPickup___vue_module_identifier__ = null
var waitPickup_Component = waitPickup_normalizeComponent(
  selectortype_script_index_0_src_pages_waitPickup,
  selectortype_template_index_0_src_pages_waitPickup,
  waitPickup___vue_template_functional__,
  waitPickup___vue_styles__,
  waitPickup___vue_scopeId__,
  waitPickup___vue_module_identifier__
)

/* harmony default export */ var src_pages_waitPickup = (waitPickup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_pickup = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        community: {}
      },
      info: {
        day: 0,
        month: 0
      }
    };
  },
  created: function created() {
    this.getCount();
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.driverData2({}).then(function (res) {
        _this.info = res.data;
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      //  this.$func.showToast(this.code);
      // return;
      var that = this;
      if (!this.code) {
        that.$func.showToast('扎带码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.pickup({ code: this.code }).then(function (res) {
        if (res) {
          that.$func.endLoading();
          that.order = res.data;
          that.info.day = Number(parseInt(that.info.day) + parseInt(that.order.goods_num));
          that.info.month = Number(parseInt(that.info.month) + parseInt(that.order.goods_num));
          that.$func.showToast('取件成功');
          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/pick.mp3";
            media.play();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_pickup = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        community: {}
      },
      info: {
        day: 0,
        month: 0
      }
    };
  },
  created: function created() {
    this.getCount();
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.driverData2({}).then(function (res) {
        _this.info = res.data;
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      //  this.$func.showToast(this.code);
      // return;
      var that = this;
      if (!this.code) {
        that.$func.showToast('扎带码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.pickup({ code: this.code }).then(function (res) {
        if (res) {
          that.$func.endLoading();
          that.order = res.data;
          that.info.day = Number(parseInt(that.info.day) + parseInt(that.order.goods_num));
          that.info.month = Number(parseInt(that.info.month) + parseInt(that.order.goods_num));
          that.$func.showToast('取件成功');
          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/pick.mp3";
            media.play();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bf29988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickup.vue
var pickup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"70px"}},[_vm._v("扎带码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"60%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"输入扎带码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white  cm-flex-around cm-flex-middle cm-m-t-8"},[_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/pickuped"}},[_c('p',{staticClass:"cm-fn-36 cm-color-yellow"},[_vm._v(_vm._s(_vm.info.day)),_c('span',{staticClass:"cm-fn-12 cm-m-t-8 cm-m-l-8"},[_vm._v("件")])]),_vm._v(" "),_c('p',{staticClass:" cm-m-t-4"},[_vm._v("今日已收 >")])]),_vm._v(" "),_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/pickuped"}},[_c('p',{staticClass:"cm-fn-36 cm-color-green"},[_vm._v(_vm._s(_vm.info.month)),_c('span',{staticClass:"cm-fn-12 cm-m-t-8 cm-m-l-8"},[_vm._v("件")])]),_vm._v(" "),_c('p',{staticClass:" cm-m-t-4"},[_vm._v("当月已收 >")])])],1),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物数量："),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.goods_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("社区/驿站："+_vm._s(_vm.order.community.name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.status_text))])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100 cm-m-t-32"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.scanQRCode()}}},[_vm._v("扫码")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var pickup_staticRenderFns = []
var pickup_esExports = { render: pickup_render, staticRenderFns: pickup_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickup = (pickup_esExports);
// CONCATENATED MODULE: ./src/pages/pickup.vue
function pickup_injectStyle (ssrContext) {
  __webpack_require__("9Lkk")
}
var pickup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickup___vue_template_functional__ = false
/* styles */
var pickup___vue_styles__ = pickup_injectStyle
/* scopeId */
var pickup___vue_scopeId__ = "data-v-3bf29988"
/* moduleIdentifier (server only) */
var pickup___vue_module_identifier__ = null
var pickup_Component = pickup_normalizeComponent(
  selectortype_script_index_0_src_pages_pickup,
  selectortype_template_index_0_src_pages_pickup,
  pickup___vue_template_functional__,
  pickup___vue_styles__,
  pickup___vue_scopeId__,
  pickup___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickup = (pickup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var outFactory = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getFactoryOrder({ order_no: this.code, status: 5 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitFactory: function submitFactory() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitFactory({ order_no: this.order.order_no, status: 6 }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('出厂成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {}
          };
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_outFactory = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getFactoryOrder({ order_no: this.code, status: 5 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitFactory: function submitFactory() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitFactory({ order_no: this.order.order_no, status: 6 }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('出厂成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {}
          };
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a850e28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/outFactory.vue
var outFactory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-14 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入订单号或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物+附件："),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.count))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("社区/驿站："+_vm._s(_vm.order.community.name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.status_text))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("衣物信息")]),_vm._v(" "),_vm._l((_vm.order.factory),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："+_vm._s(item.factory_wash_code)),(item.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物编码："+_vm._s(item.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物数量："+_vm._s(item.item_num))])])])})],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100 cm-m-t-40",staticStyle:{"margin-top":"50px"}},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},style:({opacity: !_vm.submitStatus ? '0.5' : '1'}),on:{"click":function($event){return _vm.submitFactory()}}},[_vm._v("确认出厂")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.scanQRCode()}}},[_vm._v("扫码")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var outFactory_staticRenderFns = []
var outFactory_esExports = { render: outFactory_render, staticRenderFns: outFactory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_outFactory = (outFactory_esExports);
// CONCATENATED MODULE: ./src/pages/outFactory.vue
function outFactory_injectStyle (ssrContext) {
  __webpack_require__("x0oP")
}
var outFactory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var outFactory___vue_template_functional__ = false
/* styles */
var outFactory___vue_styles__ = outFactory_injectStyle
/* scopeId */
var outFactory___vue_scopeId__ = "data-v-7a850e28"
/* moduleIdentifier (server only) */
var outFactory___vue_module_identifier__ = null
var outFactory_Component = outFactory_normalizeComponent(
  pages_outFactory,
  selectortype_template_index_0_src_pages_outFactory,
  outFactory___vue_template_functional__,
  outFactory___vue_styles__,
  outFactory___vue_scopeId__,
  outFactory___vue_module_identifier__
)

/* harmony default export */ var src_pages_outFactory = (outFactory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/arrival.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var arrival = ({
  name: 'arrival',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getFactoryOrder({ order_no: this.code, status: 6 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitFactory: function submitFactory() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitFactory({ order_no: this.order.order_no, status: 7 }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('到站成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {}
          };

          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/arrival.mp3";
            media.play();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/arrival.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_arrival = ({
  name: 'arrival',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getFactoryOrder({ order_no: this.code, status: 6 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitFactory: function submitFactory() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitFactory({ order_no: this.order.order_no, status: 7 }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('到站成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {}
          };

          weixin_js_sdk_default.a.ready(function () {
            var media = document.getElementById("musicBox");
            media.src = "https://fcwash.uunbiot.com/uploads/default/arrival.mp3";
            media.play();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fab072b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/arrival.vue
var arrival_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-14 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入订单号或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物+附件："),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.count))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("社区/驿站："+_vm._s(_vm.order.community.name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.status_text))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("衣物信息")]),_vm._v(" "),_vm._l((_vm.order.factory),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："+_vm._s(item.factory_wash_code)),(item.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物编码："+_vm._s(item.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物数量："+_vm._s(item.item_num))])])])})],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},style:({opacity: !_vm.submitStatus ? '0.5' : '1'}),on:{"click":function($event){return _vm.submitFactory()}}},[_vm._v("确认到站")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100 cm-m-t-32"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.scanQRCode()}}},[_vm._v("扫码")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var arrival_staticRenderFns = []
var arrival_esExports = { render: arrival_render, staticRenderFns: arrival_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_arrival = (arrival_esExports);
// CONCATENATED MODULE: ./src/pages/arrival.vue
function arrival_injectStyle (ssrContext) {
  __webpack_require__("s3fz")
}
var arrival_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var arrival___vue_template_functional__ = false
/* styles */
var arrival___vue_styles__ = arrival_injectStyle
/* scopeId */
var arrival___vue_scopeId__ = "data-v-5fab072b"
/* moduleIdentifier (server only) */
var arrival___vue_module_identifier__ = null
var arrival_Component = arrival_normalizeComponent(
  pages_arrival,
  selectortype_template_index_0_src_pages_arrival,
  arrival___vue_template_functional__,
  arrival___vue_styles__,
  arrival___vue_scopeId__,
  arrival___vue_module_identifier__
)

/* harmony default export */ var src_pages_arrival = (arrival_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/searchOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_searchOrder = ({
  name: 'searchOrder',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      }
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.changePop();
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.searchOrder({ order_no: this.code, status: 6 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/searchOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_searchOrder = ({
  name: 'searchOrder',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      }
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.changePop();
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.searchOrder({ order_no: this.code, status: 6 }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8802cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/searchOrder.vue
var searchOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-16 cm-bg-white cm-p-lr-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单号/扎带码：")]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-16 cm-w-100"},[_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 cm-w-100",attrs:{"type":"text","placeholder":"通过订单号或扎带码查询"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(_vm.order.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(_vm.order.community.name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")]),(_vm.order.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物数量："),_c('span',{},[_vm._v(_vm._s(_vm.order.goods_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("扎  带  码："),_c('span',{},[_vm._v(_vm._s(_vm.order.bag_code))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(_vm.order.order_type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("订单流程")]),_vm._v(" "),_vm._l((_vm.order.logs),function(val,i){return _c('div',{key:i,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14"},[_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(val.status_text))]),_vm._v(" "),_c('span',{staticClass:"cm-m-l-12"},[_vm._v(_vm._s(val.operate))]),_vm._v(" "),_c('span',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(val.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-p-lr-8 cm-fn-12"},[_vm._v(_vm._s(val.remark)+" "),(val.img_path.length > 0)?_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(val.img_path)}}},[_vm._v("查看收衣图片")]):_vm._e()])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("衣物信息")]),_vm._v(" "),_vm._l((_vm.order.factory),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12  "},[_c('div',{staticClass:" cm-p-b-8 cm-p-lr-12"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("品类编码："+_vm._s(item.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单图片："),_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(item.img_path)}}},[_vm._v("点击查看")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(item.color)+"|"+_vm._s(item.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),(item.up_num > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.up_num))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("送洗流程")]),_vm._v(" "),_vm._l((item.process),function(val,i){return _c('div',{key:i,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('div',{staticClass:"cm-flex-between"},[_c('p',{staticClass:"cm-color-orange cm-fn-16",staticStyle:{"width":"25%"}},[_vm._v(_vm._s(val.status_text))]),_vm._v(" "),_c('p',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(val.operate))]),_vm._v(" "),_c('p',{staticClass:"cm-flex-end",staticStyle:{"width":"40%"}},[_vm._v(_vm._s(val.operate_time))])]),_vm._v(" "),(val.remark)?_c('p',{staticClass:" cm-color-666 cm-m-l-16"},[_vm._v("备注："+_vm._s(val.remark))]):_vm._e()])])})],2)])})],2)])}
var searchOrder_staticRenderFns = []
var searchOrder_esExports = { render: searchOrder_render, staticRenderFns: searchOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_searchOrder = (searchOrder_esExports);
// CONCATENATED MODULE: ./src/pages/searchOrder.vue
function searchOrder_injectStyle (ssrContext) {
  __webpack_require__("r+28")
}
var searchOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var searchOrder___vue_template_functional__ = false
/* styles */
var searchOrder___vue_styles__ = searchOrder_injectStyle
/* scopeId */
var searchOrder___vue_scopeId__ = "data-v-6b8802cc"
/* moduleIdentifier (server only) */
var searchOrder___vue_module_identifier__ = null
var searchOrder_Component = searchOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_searchOrder,
  selectortype_template_index_0_src_pages_searchOrder,
  searchOrder___vue_template_functional__,
  searchOrder___vue_styles__,
  searchOrder___vue_scopeId__,
  searchOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_searchOrder = (searchOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickuped.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_pickuped = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.pickuped({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickuped.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_pickuped = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.pickuped({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c242dc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickuped.vue
var pickuped_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"95%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"订单号|社区名称检索"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-p-lr-12 cm-text-left  cm-p-tb-4"},[_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("订  单  号："+_vm._s(item.order_no)),(item.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("社区/驿站："+_vm._s(item.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物数量："+_vm._s(item.goods_num))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("下单时间："+_vm._s(item.order_time))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("取件时间："+_vm._s(item.create_time))])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var pickuped_staticRenderFns = []
var pickuped_esExports = { render: pickuped_render, staticRenderFns: pickuped_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickuped = (pickuped_esExports);
// CONCATENATED MODULE: ./src/pages/pickuped.vue
function pickuped_injectStyle (ssrContext) {
  __webpack_require__("mkCq")
}
var pickuped_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickuped___vue_template_functional__ = false
/* styles */
var pickuped___vue_styles__ = pickuped_injectStyle
/* scopeId */
var pickuped___vue_scopeId__ = "data-v-5c242dc9"
/* moduleIdentifier (server only) */
var pickuped___vue_module_identifier__ = null
var pickuped_Component = pickuped_normalizeComponent(
  selectortype_script_index_0_src_pages_pickuped,
  selectortype_template_index_0_src_pages_pickuped,
  pickuped___vue_template_functional__,
  pickuped___vue_styles__,
  pickuped___vue_scopeId__,
  pickuped___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickuped = (pickuped_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/openMap.vue
//
//
//
//
//
//



/* harmony default export */ var openMap = ({
  name: 'openMap',
  components: {},
  data: function data() {
    return {
      id: 0,
      info: {}
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    console.log(this.id);
    this.config();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/openMap.vue
//
//
//
//
//
//



/* harmony default export */ var pages_openMap = ({
  name: 'openMap',
  components: {},
  data: function data() {
    return {
      id: 0,
      info: {}
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    console.log(this.id);
    this.config();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c8f817","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/openMap.vue
var openMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-w-100 cm-h-100"})}
var openMap_staticRenderFns = []
var openMap_esExports = { render: openMap_render, staticRenderFns: openMap_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_openMap = (openMap_esExports);
// CONCATENATED MODULE: ./src/pages/openMap.vue
function openMap_injectStyle (ssrContext) {
  __webpack_require__("sFso")
}
var openMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var openMap___vue_template_functional__ = false
/* styles */
var openMap___vue_styles__ = openMap_injectStyle
/* scopeId */
var openMap___vue_scopeId__ = "data-v-45c8f817"
/* moduleIdentifier (server only) */
var openMap___vue_module_identifier__ = null
var openMap_Component = openMap_normalizeComponent(
  pages_openMap,
  selectortype_template_index_0_src_pages_openMap,
  openMap___vue_template_functional__,
  openMap___vue_styles__,
  openMap___vue_scopeId__,
  openMap___vue_module_identifier__
)

/* harmony default export */ var src_pages_openMap = (openMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/arrivaled.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_arrivaled = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.arrivaled({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/arrivaled.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_arrivaled = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.arrivaled({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 3000);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fee28770","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/arrivaled.vue
var arrivaled_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"95%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"订单号|社区名称检索"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-p-lr-12 cm-text-left  cm-p-tb-4"},[_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("订  单  号："+_vm._s(item.order_no)),(item.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("社区/驿站："+_vm._s(item.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物数量："+_vm._s(item.goods_num))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("下单时间："+_vm._s(item.order_time))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("到站时间："+_vm._s(item.create_time))])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var arrivaled_staticRenderFns = []
var arrivaled_esExports = { render: arrivaled_render, staticRenderFns: arrivaled_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_arrivaled = (arrivaled_esExports);
// CONCATENATED MODULE: ./src/pages/arrivaled.vue
function arrivaled_injectStyle (ssrContext) {
  __webpack_require__("Ban+")
}
var arrivaled_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var arrivaled___vue_template_functional__ = false
/* styles */
var arrivaled___vue_styles__ = arrivaled_injectStyle
/* scopeId */
var arrivaled___vue_scopeId__ = "data-v-fee28770"
/* moduleIdentifier (server only) */
var arrivaled___vue_module_identifier__ = null
var arrivaled_Component = arrivaled_normalizeComponent(
  selectortype_script_index_0_src_pages_arrivaled,
  selectortype_template_index_0_src_pages_arrivaled,
  arrivaled___vue_template_functional__,
  arrivaled___vue_styles__,
  arrivaled___vue_scopeId__,
  arrivaled___vue_module_identifier__
)

/* harmony default export */ var src_pages_arrivaled = (arrivaled_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitPickupInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_waitPickupInfo = ({
    components: {},
    data: function data() {
        return {
            i: 0,
            cid: 0,
            type: 0,
            list: [],
            where: []
        };
    },
    mounted: function mounted() {
        this.cid = Number(this.$route.params.cid);
        this.i = Number(this.$route.params.i);
        this.type = Number(this.$route.params.type);
        if (this.i > 0) {
            this.$route.meta.title = '待送详情';
            document.title = this.$route.meta.title;
        } else {
            this.$route.meta.title = '待取详情';
            document.title = this.$route.meta.title;
        }
        this.getList();
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPickupInfo({ cid: this.cid, i: this.i, type: this.type }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitPickupInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_pages_waitPickupInfo = ({
    components: {},
    data: function data() {
        return {
            i: 0,
            cid: 0,
            type: 0,
            list: [],
            where: []
        };
    },
    mounted: function mounted() {
        this.cid = Number(this.$route.params.cid);
        this.i = Number(this.$route.params.i);
        this.type = Number(this.$route.params.type);
        if (this.i > 0) {
            this.$route.meta.title = '待送详情';
            document.title = this.$route.meta.title;
        } else {
            this.$route.meta.title = '待取详情';
            document.title = this.$route.meta.title;
        }
        this.getList();
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPickupInfo({ cid: this.cid, i: this.i, type: this.type }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e68353ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waitPickupInfo.vue
var waitPickupInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"list-bg"},[_c('ul',{staticClass:"cm-m-lr-8"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-p-lr-12 cm-text-left"},[(item.type == 1)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-8"},[_c('div',{staticClass:"cm-center"},[_c('p',{staticClass:"cm-fn-weight-max"},[_vm._v(_vm._s(index+1)+"、")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"cm-p-b-4"},[_vm._v("订单编号："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.order_no))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("社区名称："),_c('router-link',{staticClass:"cm-color-red",attrs:{"to":'/openMap/'+item.cid}},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物数量："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.goods_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("封签时间："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.date))])])])]):_c('div',[_c('router-link',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-8",attrs:{"to":'/orderDetail/'+item.id}},[_c('div',{staticClass:"cm-center"},[_c('p',{staticClass:"cm-fn-weight-max"},[_vm._v(_vm._s(index+1)+"、")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"cm-p-b-4"},[_vm._v("订单编号："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.order_no))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-tb-4"},[_vm._v("社区名称："+_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("商品数量："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.goods_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("下单时间："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.date))])])])])],1)])}),0)])])}
var waitPickupInfo_staticRenderFns = []
var waitPickupInfo_esExports = { render: waitPickupInfo_render, staticRenderFns: waitPickupInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waitPickupInfo = (waitPickupInfo_esExports);
// CONCATENATED MODULE: ./src/pages/waitPickupInfo.vue
function waitPickupInfo_injectStyle (ssrContext) {
  __webpack_require__("B6gb")
}
var waitPickupInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waitPickupInfo___vue_template_functional__ = false
/* styles */
var waitPickupInfo___vue_styles__ = waitPickupInfo_injectStyle
/* scopeId */
var waitPickupInfo___vue_scopeId__ = "data-v-e68353ca"
/* moduleIdentifier (server only) */
var waitPickupInfo___vue_module_identifier__ = null
var waitPickupInfo_Component = waitPickupInfo_normalizeComponent(
  selectortype_script_index_0_src_pages_waitPickupInfo,
  selectortype_template_index_0_src_pages_waitPickupInfo,
  waitPickupInfo___vue_template_functional__,
  waitPickupInfo___vue_styles__,
  waitPickupInfo___vue_scopeId__,
  waitPickupInfo___vue_module_identifier__
)

/* harmony default export */ var src_pages_waitPickupInfo = (waitPickupInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/factory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var factory = ({
  name: 'factory',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      info: {},
      nav: [{
        title: '入厂',
        path: '/inFactory/0',
        auth: 'inFactory',
        img: '/static/images/inFactory.png'
      }, {
        title: '打包',
        path: '/inFactory/1',
        auth: 'pack',
        img: '/static/images/pack.png'
      }, {
        title: '出厂',
        path: '/inFactory/2',
        auth: 'outMaxFactory',
        img: '/static/images/outMaxFactory.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '订单查询',
        path: '/searchOrder',
        auth: 'searchOrder',
        img: '/static/images/searchOrder.png'
      }, {
        title: '不洗退回',
        path: '/factoryBack',
        auth: 'factoryBack',
        img: '/static/images/factoryBack.png'
      }, {
        title: '异常报备',
        path: '/abnormal',
        auth: 'abnormal',
        img: '/static/images/abnormal.png'
      }, {
        title: '物流订单',
        path: '/waybillOrder',
        auth: 'waybillOrder',
        img: '/static/images/express.png'
      }, {
        title: '衣物发货',
        path: '/waybillClotheOrder',
        auth: 'waybillClotheOrder',
        img: '/static/images/topic-online2.png'
      }, {
        title: '物流轨迹',
        path: '/queryExpress',
        auth: 'queryExpress',
        img: '/static/images/send_back.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.factoryData({}).then(function (res) {
        _this.info = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/factory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_factory = ({
  name: 'factory',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      info: {},
      nav: [{
        title: '入厂',
        path: '/inFactory/0',
        auth: 'inFactory',
        img: '/static/images/inFactory.png'
      }, {
        title: '打包',
        path: '/inFactory/1',
        auth: 'pack',
        img: '/static/images/pack.png'
      }, {
        title: '出厂',
        path: '/inFactory/2',
        auth: 'outMaxFactory',
        img: '/static/images/outMaxFactory.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '订单查询',
        path: '/searchOrder',
        auth: 'searchOrder',
        img: '/static/images/searchOrder.png'
      }, {
        title: '不洗退回',
        path: '/factoryBack',
        auth: 'factoryBack',
        img: '/static/images/factoryBack.png'
      }, {
        title: '异常报备',
        path: '/abnormal',
        auth: 'abnormal',
        img: '/static/images/abnormal.png'
      }, {
        title: '物流订单',
        path: '/waybillOrder',
        auth: 'waybillOrder',
        img: '/static/images/express.png'
      }, {
        title: '衣物发货',
        path: '/waybillClotheOrder',
        auth: 'waybillClotheOrder',
        img: '/static/images/topic-online2.png'
      }, {
        title: '物流轨迹',
        path: '/queryExpress',
        auth: 'queryExpress',
        img: '/static/images/send_back.png'
      }]
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getCount();
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {},

  methods: {
    getCount: function getCount() {
      var _this = this;

      this.$api.factoryData({}).then(function (res) {
        _this.info = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c14a41a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/factory.vue
var factory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-white cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("工厂端")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-flex-wrap cm-border-radius-10 cm-flex-around cm-flex-middle",staticStyle:{"margin-top":"45px"}},[(_vm.$func.checkAuth('waitInFactory'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitInFactory/0/1"}},[_c('p',{staticClass:"cm-fn-36 cm-color-orange"},[_vm._v(_vm._s(_vm.info.yesterdayIn))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("昨日待入厂 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('waitPack'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitInFactory/1/0"}},[_c('p',{staticClass:"cm-fn-36 cm-color-blue"},[_vm._v(_vm._s(_vm.info.pack))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待打包 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('waitOutFactory'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitInFactory/2/0"}},[_c('p',{staticClass:"cm-fn-36 cm-color-green"},[_vm._v(_vm._s(_vm.info.out))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待出厂 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('waitInFactory'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/waitInFactory/0/0"}},[_c('p',{staticClass:"cm-fn-36 cm-color-orange"},[_vm._v(_vm._s(_vm.info.in))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("全部待入厂 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('backwash'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/backwash/1"}},[_c('p',{staticClass:"cm-fn-36 cm-color-blue"},[_vm._v(_vm._s(_vm.info.yesterdayBackwash))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("昨日回进厂 >")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('backwash'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/backwash/0"}},[_c('p',{staticClass:"cm-fn-36 cm-color-green"},[_vm._v(_vm._s(_vm.info.backwash))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("全部回进厂 >")])]):_vm._e()],1)]),_vm._v(" "),_c('ul',{staticClass:"ul2 cm-m-lr-8 cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle  cm-flex-wrap"},_vm._l((_vm.nav),function(item,index){return _c('router-link',{key:index,staticClass:"cm-text-center cm-p-tb-24 li",attrs:{"to":item.path}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":item.img}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v(_vm._s(item.title))])])}),1),_vm._v(" "),_c('cmFooter',{attrs:{"active":4}})],1)}
var factory_staticRenderFns = []
var factory_esExports = { render: factory_render, staticRenderFns: factory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_factory = (factory_esExports);
// CONCATENATED MODULE: ./src/pages/factory.vue
function factory_injectStyle (ssrContext) {
  __webpack_require__("Nz4j")
}
var factory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var factory___vue_template_functional__ = false
/* styles */
var factory___vue_styles__ = factory_injectStyle
/* scopeId */
var factory___vue_scopeId__ = "data-v-6c14a41a"
/* moduleIdentifier (server only) */
var factory___vue_module_identifier__ = null
var factory_Component = factory_normalizeComponent(
  pages_factory,
  selectortype_template_index_0_src_pages_factory,
  factory___vue_template_functional__,
  factory___vue_styles__,
  factory___vue_scopeId__,
  factory___vue_module_identifier__
)

/* harmony default export */ var src_pages_factory = (factory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitInFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var pages_waitInFactory = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            number: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            type: 0,
            code: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.i = Number(this.$route.params.i);
        this.type = Number(this.$route.params.type);
        this.$api.factoryData({ type: this.type }).then(function (res) {
            switch (parseInt(_this.i)) {
                case 1:
                    _this.$route.meta.title = '待打包(' + res.data.pack + ')';
                    break;
                case 2:
                    _this.$route.meta.title = '待出厂(' + res.data.out + ')';
                    break;
                default:
                    _this.$route.meta.title = '待入厂(' + (_this.type > 0 ? res.data.yesterdayIn : res.data.in) + ')';
                    _this.number = _this.type > 0 ? res.data.yesterdayIn : res.data.in;
                    break;
            }
            document.title = _this.$route.meta.title;
        });
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        getList: function getList() {
            var _this2 = this;

            this.$api.waitInFactory({ last_id: this.lastId, page_flag: this.pageFlag, i: this.i, type: this.type, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this2.lastId) {
                        _this2.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this2.hasNext = res.hasNext;
                    _this2.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this2.list.push(item);
                    });
                }
            });
        },
        allInFactory: function allInFactory() {
            var _this3 = this;

            var that = this;
            that.$func.confirm('确认 ' + this.number + ' 件已入厂？', '提示', function () {
                that.$func.startLoading();
                that.$api.alliInFactory({ type: _this3.type, i: _this3.i }).then(function (res) {
                    if (res) {
                        that.$func.endLoading();
                        that.search();
                        that.$func.showToast('操作成功');
                        weixin_js_sdk_default.a.ready(function () {
                            var media = document.getElementById("musicBox");
                            media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                            media.play();
                        });
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waitInFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var selectortype_script_index_0_src_pages_waitInFactory = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            number: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            type: 0,
            code: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.i = Number(this.$route.params.i);
        this.type = Number(this.$route.params.type);
        this.$api.factoryData({ type: this.type }).then(function (res) {
            switch (parseInt(_this.i)) {
                case 1:
                    _this.$route.meta.title = '待打包(' + res.data.pack + ')';
                    break;
                case 2:
                    _this.$route.meta.title = '待出厂(' + res.data.out + ')';
                    break;
                default:
                    _this.$route.meta.title = '待入厂(' + (_this.type > 0 ? res.data.yesterdayIn : res.data.in) + ')';
                    _this.number = _this.type > 0 ? res.data.yesterdayIn : res.data.in;
                    break;
            }
            document.title = _this.$route.meta.title;
        });
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        getList: function getList() {
            var _this2 = this;

            this.$api.waitInFactory({ last_id: this.lastId, page_flag: this.pageFlag, i: this.i, type: this.type, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this2.lastId) {
                        _this2.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this2.hasNext = res.hasNext;
                    _this2.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this2.list.push(item);
                    });
                }
            });
        },
        allInFactory: function allInFactory() {
            var _this3 = this;

            var that = this;
            that.$func.confirm('确认 ' + this.number + ' 件已入厂？', '提示', function () {
                that.$func.startLoading();
                that.$api.alliInFactory({ type: _this3.type, i: _this3.i }).then(function (res) {
                    if (res) {
                        that.$func.endLoading();
                        that.search();
                        that.$func.showToast('操作成功');
                        weixin_js_sdk_default.a.ready(function () {
                            var media = document.getElementById("musicBox");
                            media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                            media.play();
                        });
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e250d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waitInFactory.vue
var waitInFactory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"衣物条码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-flex-between cm-flex-middle cm-p-lr-12 cm-p-tb-12 cm-text-left"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle ",staticStyle:{"overflow":"hidden"}},[_c('div',[_c('p',{staticClass:"cm-p-tb-4 "},[_vm._v("\n                           订  单  号："+_vm._s(item.order_no)+"\n                            "),(item.order_no)?_c('span',{staticClass:"cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(item.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(item.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(item.color)+"|"+_vm._s(item.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(item.send_wash_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(item.order_type))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(item.remark ? item.remark : '无'))])])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),(_vm.i == 0 && _vm.number > 0 && _vm.$func.checkAuth('allInFactory'))?_c('div',{staticClass:"cm-pf cm-border-radius cm-bg-orange cm-text-center",staticStyle:{"width":"50px","height":"50px","right":"5px","bottom":"80px"},on:{"click":_vm.allInFactory}},[_c('p',{staticClass:"cm-color-white cm-fn-12 cm-m-t-8"},[_vm._v("全部")]),_c('p',{staticClass:"cm-color-white cm-fn-12"},[_vm._v("入厂")])]):_vm._e(),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var waitInFactory_staticRenderFns = []
var waitInFactory_esExports = { render: waitInFactory_render, staticRenderFns: waitInFactory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waitInFactory = (waitInFactory_esExports);
// CONCATENATED MODULE: ./src/pages/waitInFactory.vue
function waitInFactory_injectStyle (ssrContext) {
  __webpack_require__("km7Z")
}
var waitInFactory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waitInFactory___vue_template_functional__ = false
/* styles */
var waitInFactory___vue_styles__ = waitInFactory_injectStyle
/* scopeId */
var waitInFactory___vue_scopeId__ = "data-v-38e250d4"
/* moduleIdentifier (server only) */
var waitInFactory___vue_module_identifier__ = null
var waitInFactory_Component = waitInFactory_normalizeComponent(
  selectortype_script_index_0_src_pages_waitInFactory,
  selectortype_template_index_0_src_pages_waitInFactory,
  waitInFactory___vue_template_functional__,
  waitInFactory___vue_styles__,
  waitInFactory___vue_scopeId__,
  waitInFactory___vue_module_identifier__
)

/* harmony default export */ var src_pages_waitInFactory = (waitInFactory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/inFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_inFactory = ({
    name: 'pickup',
    components: {},
    data: function data() {
        return {
            id: 0,
            i: 0,
            code: '',
            order: {}
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
        switch (this.i) {
            case 1:
                this.$route.meta.title = '打包';
                break;
            case 2:
                this.$route.meta.title = '出厂';
                break;
            default:
                this.$route.meta.title = '入厂';
                break;
        }
        document.title = this.$route.meta.title;
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            // that.formData[id] = res.resultStr.split(',')[1];
                            that.code = res.resultStr.split(',')[1];
                            that.getOrder();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        getOrder: function getOrder() {
            //  this.$func.showToast(this.code);
            // return;
            var that = this;
            if (!this.code) {
                that.$func.showToast('衣物条码无效');
                return;
            }
            // if(code.length != 12){
            //   that.$func.showToast('子订单码无效');
            //   return ;
            // }
            that.$func.startLoading();
            console.log(this.code);
            this.$api.inFactory({ code: this.code, i: this.i }).then(function (res) {
                if (res) {
                    that.$func.endLoading();
                    that.order = res.data;
                    that.$func.showToast('操作成功');
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/inFactory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_inFactory = ({
    name: 'pickup',
    components: {},
    data: function data() {
        return {
            id: 0,
            i: 0,
            code: '',
            order: {}
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
        switch (this.i) {
            case 1:
                this.$route.meta.title = '打包';
                break;
            case 2:
                this.$route.meta.title = '出厂';
                break;
            default:
                this.$route.meta.title = '入厂';
                break;
        }
        document.title = this.$route.meta.title;
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            // that.formData[id] = res.resultStr.split(',')[1];
                            that.code = res.resultStr.split(',')[1];
                            that.getOrder();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        getOrder: function getOrder() {
            //  this.$func.showToast(this.code);
            // return;
            var that = this;
            if (!this.code) {
                that.$func.showToast('衣物条码无效');
                return;
            }
            // if(code.length != 12){
            //   that.$func.showToast('子订单码无效');
            //   return ;
            // }
            that.$func.startLoading();
            console.log(this.code);
            this.$api.inFactory({ code: this.code, i: this.i }).then(function (res) {
                if (res) {
                    that.$func.endLoading();
                    that.order = res.data;
                    that.$func.showToast('操作成功');
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f448228","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inFactory.vue
var inFactory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"70px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"60%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"请输入衣物条码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-red cm-fn-16 "},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-color-orange cm-fn-16 "},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："+_vm._s(_vm.order.store_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："+_vm._s(_vm.order.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："+_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var inFactory_staticRenderFns = []
var inFactory_esExports = { render: inFactory_render, staticRenderFns: inFactory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_inFactory = (inFactory_esExports);
// CONCATENATED MODULE: ./src/pages/inFactory.vue
function inFactory_injectStyle (ssrContext) {
  __webpack_require__("yIJl")
}
var inFactory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inFactory___vue_template_functional__ = false
/* styles */
var inFactory___vue_styles__ = inFactory_injectStyle
/* scopeId */
var inFactory___vue_scopeId__ = "data-v-5f448228"
/* moduleIdentifier (server only) */
var inFactory___vue_module_identifier__ = null
var inFactory_Component = inFactory_normalizeComponent(
  selectortype_script_index_0_src_pages_inFactory,
  selectortype_template_index_0_src_pages_inFactory,
  inFactory___vue_template_functional__,
  inFactory___vue_styles__,
  inFactory___vue_scopeId__,
  inFactory___vue_module_identifier__
)

/* harmony default export */ var src_pages_inFactory = (inFactory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/barOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_barOrder = ({
  name: 'barOrder',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      number: '',
      strip_code: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (key > 0) {
                that.strip_code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.up({ code: this.order.factory_wash_code, number: that.number, strip_code: this.strip_code }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this.$func.showToast('已点亮5秒');
        }
        _this.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/barOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_barOrder = ({
  name: 'barOrder',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      number: '',
      strip_code: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (key > 0) {
                that.strip_code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.up({ code: this.order.factory_wash_code, number: that.number, strip_code: this.strip_code }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this.$func.showToast('已点亮5秒');
        }
        _this.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623811de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/barOrder.vue
var barOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物条码或扫条码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16 "},[_vm._v("订单号："),_c('span',{staticClass:"cm-color-blue cm-fn-14"},[_vm._v(_vm._s(_vm.order.order_no))]),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e(),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(_vm.order.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(_vm.order.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(_vm.order.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("品类编码："+_vm._s(_vm.order.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),(_vm.order.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")]):_vm._e(),(_vm.order.factory_wash_code && _vm.order.up_num <= 0 && _vm.$func.checkAuth('up'))?_c('span',{staticClass:"cm-p-lr-4 cm-p-tb-2 cm-color-white cm-m-l-12 cm-border-radius-2 cm-bg-orange cm-fn-10",on:{"click":function($event){_vm.popUp = true}}},[_vm._v("上挂")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单图片："),_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(_vm.order.img_path)}}},[_vm._v("点击查看")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(_vm.order.color)+"|"+_vm._s(_vm.order.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")]),(_vm.order.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(_vm.order.order_type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.state_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗工厂："),_c('span',{},[_vm._v(_vm._s(_vm.order.factory_title))])]),_vm._v(" "),(_vm.order.up_num > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.up_num))])]):_vm._e(),_vm._v(" "),(_vm.order.strip_code)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("灯条编码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.strip_code))])]):_vm._e(),_vm._v(" "),(_vm.order.history_strip_code && !_vm.order.strip_code)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("历史灯条编码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.history_strip_code))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("送洗流程")]),_vm._v(" "),_vm._l((_vm.order.process),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8 "},[_c('div',{staticClass:"cm-flex-between"},[_c('p',{staticClass:"cm-color-orange cm-fn-16",staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.operate))]),_vm._v(" "),_c('p',{staticClass:"cm-flex-end",staticStyle:{"width":"40%"}},[_vm._v(_vm._s(item.operate_time))])]),_vm._v(" "),(item.remark)?_c('p',{staticClass:" cm-color-666 cm-m-l-16"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e()])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"popup cm-bg-white cm-border-radius-10 cm-p-tb-24"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"up-form-row"},[_c('p',{staticClass:"up-label cm-fn-16"},[_vm._v("输入挂点：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"up-input cm-fn-14 cm-border cm-border-radius-8",attrs:{"type":"number","placeholder":"请输入挂点"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"up-form-row"},[_c('p',{staticClass:"up-label cm-fn-16"},[_vm._v("灯条编码：")]),_vm._v(" "),_c('div',{staticClass:"strip-input-wrap cm-border cm-flex-between cm-flex-middle cm-border-radius-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strip_code),expression:"strip_code"}],staticClass:"cm-fn-14 ",attrs:{"type":"text","placeholder":"请输入灯条编码"},domProps:{"value":(_vm.strip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.strip_code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}})])]),_vm._v(" "),_c('button',{staticClass:"submit-btn cm-bg-red cm-p-tb-16 cm-color-white cm-border-radius-8 cm-m-t-24",attrs:{"lang":"zh_CN"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("同订单挂点："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.up_nums))])]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("当前手机号已上挂："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.phone_up_count || 0))]),_vm._v("件")]),_vm._v(" "),(_vm.order.phone_up_list && _vm.order.phone_up_list.length)?_c('div',{staticClass:"same-user-list"},[_c('p',{staticClass:"same-user-title"},[_vm._v("同用户已上挂衣物")]),_vm._v(" "),_vm._l((_vm.order.phone_up_list),function(item,index){return _c('div',{key:index,staticClass:"same-user-item"},[_c('div',{staticClass:"same-user-info"},[_c('p',{staticClass:"cm-fn-13 cm-color-333"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("衣物："+_vm._s(item.factory_wash_code || item.washing_code)+"　挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.up_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("灯条："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.strip_code || '无'))])])]),_vm._v(" "),(item.strip_code)?_c('button',{staticClass:"light-btn cm-border-radius-4",on:{"click":function($event){return _vm.lightUpStrip(item)}}},[_vm._v("寻找衣物")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-20 cm-pa close-btn",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.popUp = false}}})])])])}
var barOrder_staticRenderFns = []
var barOrder_esExports = { render: barOrder_render, staticRenderFns: barOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_barOrder = (barOrder_esExports);
// CONCATENATED MODULE: ./src/pages/barOrder.vue
function barOrder_injectStyle (ssrContext) {
  __webpack_require__("PdTF")
}
var barOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var barOrder___vue_template_functional__ = false
/* styles */
var barOrder___vue_styles__ = barOrder_injectStyle
/* scopeId */
var barOrder___vue_scopeId__ = "data-v-623811de"
/* moduleIdentifier (server only) */
var barOrder___vue_module_identifier__ = null
var barOrder_Component = barOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_barOrder,
  selectortype_template_index_0_src_pages_barOrder,
  barOrder___vue_template_functional__,
  barOrder___vue_styles__,
  barOrder___vue_scopeId__,
  barOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_barOrder = (barOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/backwash.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_backwash = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            code: ''
        };
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.backwash({ last_id: this.lastId, page_flag: this.pageFlag, i: this.i, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/backwash.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_backwash = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            i: 0,
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            code: ''
        };
    },
    mounted: function mounted() {
        this.i = Number(this.$route.params.i);
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.isActive = 0;
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.backwash({ last_id: this.lastId, page_flag: this.pageFlag, i: this.i, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be4788e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backwash.vue
var backwash_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"衣物条码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white cm-flex-between cm-flex-middle cm-p-lr-12 cm-p-tb-12 cm-text-left"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle ",staticStyle:{"overflow":"hidden"}},[_c('div',[_c('p',{staticClass:"cm-p-tb-4 "},[_vm._v("\n                           订  单  号："+_vm._s(item.order_no)+"\n                            "),(item.order_no)?_c('span',{staticClass:"cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(item.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(item.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(item.color)+"|"+_vm._s(item.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(item.send_wash_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(item.order_type))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(item.remark ? item.remark : '无'))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("反洗时间："),_c('span',{},[_vm._v(_vm._s(item.backwash_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("反洗原因："),_c('span',{},[_vm._v(_vm._s(item.backwash_reason))])]),_vm._v(" "),_c('p',{staticClass:"cm-p-b-4"},[_vm._v("当前状态："),_c('span',{},[_vm._v(_vm._s(item.state_text))])])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var backwash_staticRenderFns = []
var backwash_esExports = { render: backwash_render, staticRenderFns: backwash_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_backwash = (backwash_esExports);
// CONCATENATED MODULE: ./src/pages/backwash.vue
function backwash_injectStyle (ssrContext) {
  __webpack_require__("gf3k")
}
var backwash_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var backwash___vue_template_functional__ = false
/* styles */
var backwash___vue_styles__ = backwash_injectStyle
/* scopeId */
var backwash___vue_scopeId__ = "data-v-0be4788e"
/* moduleIdentifier (server only) */
var backwash___vue_module_identifier__ = null
var backwash_Component = backwash_normalizeComponent(
  selectortype_script_index_0_src_pages_backwash,
  selectortype_template_index_0_src_pages_backwash,
  backwash___vue_template_functional__,
  backwash___vue_styles__,
  backwash___vue_scopeId__,
  backwash___vue_module_identifier__
)

/* harmony default export */ var src_pages_backwash = (backwash_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var secondCommunityOrder = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getSubOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/secondCommunityOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_secondCommunityOrder = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getSubOrderCount({ type: this.type }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e59e931c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/secondCommunityOrder.vue
var secondCommunityOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main ",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:" cm-p-lr-16 cm-bg-white cm-p-b-40",staticStyle:{"margin-top":"10px"}},[(_vm.$func.checkAuth('suborder/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suboutTimeOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":"/suboutTimeOrder"}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("超时订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[10] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[10]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+2}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待收衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[2] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+3}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待司机取衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送工厂")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/5'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+5}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("洗涤中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[5] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[5]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+6}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送回")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[6] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[6]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/7'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+7}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待入库")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[7] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[7]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/8'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+8}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待出库")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[8] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[8]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+9}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('suborder/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/suborder/'+_vm.type+'/'+10}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var secondCommunityOrder_staticRenderFns = []
var secondCommunityOrder_esExports = { render: secondCommunityOrder_render, staticRenderFns: secondCommunityOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_secondCommunityOrder = (secondCommunityOrder_esExports);
// CONCATENATED MODULE: ./src/pages/secondCommunityOrder.vue
function secondCommunityOrder_injectStyle (ssrContext) {
  __webpack_require__("NcMn")
}
var secondCommunityOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var secondCommunityOrder___vue_template_functional__ = false
/* styles */
var secondCommunityOrder___vue_styles__ = secondCommunityOrder_injectStyle
/* scopeId */
var secondCommunityOrder___vue_scopeId__ = "data-v-e59e931c"
/* moduleIdentifier (server only) */
var secondCommunityOrder___vue_module_identifier__ = null
var secondCommunityOrder_Component = secondCommunityOrder_normalizeComponent(
  pages_secondCommunityOrder,
  selectortype_template_index_0_src_pages_secondCommunityOrder,
  secondCommunityOrder___vue_template_functional__,
  secondCommunityOrder___vue_styles__,
  secondCommunityOrder___vue_scopeId__,
  secondCommunityOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_secondCommunityOrder = (secondCommunityOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/suborder.vue












/* harmony default export */ var suborder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  inject: ['reload'],
  data: function data() {
    return {
      title: '全部订单',
      grade: 0,
      isActive: 0,
      pop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.isActive = Number(this.$route.params.i);
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getSubOrderLists({ type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: this.isActive }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/suborder.vue












/* harmony default export */ var pages_suborder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  inject: ['reload'],
  data: function data() {
    return {
      title: '全部订单',
      grade: 0,
      isActive: 0,
      pop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.isActive = Number(this.$route.params.i);
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getSubOrderLists({ type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, status: this.isActive }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8f0a0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/suborder.vue
var suborder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"下级社区名称|订单号后四位|手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[(_vm.type == 2)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 7)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)),_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-fn-weight-default"},[_vm._v(_vm._s(item.user.nickname))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("订单金额："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.amount))])]),_vm._v(" "),(item.diff_price > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("补差价："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.diff_price))])]):_vm._e()])]),_vm._v(" "),(item.worker_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_c('a',{attrs:{"href":'tel:'+item.worker.phone}},[_vm._v(_vm._s(item.worker.phone))]),_vm._v(" "+_vm._s(item.worker.name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),0),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && _vm.$func.checkAuth('status/2'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,3)}}},[_vm._v("接单")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('status/3'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showOperater(item.id)}}},[_vm._v("分配")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('status/4'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('status/5'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[_vm._v("开始服务")]):_vm._e(),_vm._v(" "),(item.status == 5 && item.problem == 0 && _vm.$func.checkAuth('problem'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.problem(item.id)}}},[_vm._v("问题上报")]):_vm._e(),_vm._v(" "),(item.status == 6 && _vm.$func.checkAuth('status/6'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,7)}}},[_vm._v("服务完成")]):_vm._e(),_vm._v(" "),(item.status == 9 && _vm.$func.checkAuth('status/9'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center  cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id)}}},[_vm._v("查看评价")]):_vm._e(),_vm._v(" "),(item.status < 5 && _vm.$func.checkAuth('contact'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]):_vm._e()]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-m-t-16 cm-flex-middle"},[(item.status == 2 || item.status == 8)?_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 "},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-m-t-16  cm-flex-middle"},[(item.status == 8)?_c('div',{staticClass:"cm-fn-14  cm-fn-weight-default cm-color-white cm-p-tb-4 cm-p-lr-12 cm-bg-orange cm-border-radius-4",on:{"click":function($event){return _vm.changeStatus(item.id,9)}}},[_vm._v("确认取件")]):(item.out_time)?_c('div',{staticClass:"cm-fn-14  cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(item.out_time))]):_vm._e()])]),_vm._v(" "),(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)+" "),_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("社区："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))])]),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.collect_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("收衣时间："+_vm._s(item.collect_time))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.special_title)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("会员卡特权："+_vm._s(item.special_title))]):_vm._e()]),_vm._v(" "),((item.status == 8 || item.status == 2) && item.uupt)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("跑男信息")]),_vm._v(" "),(item.uupt.driver_name)?_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-30",attrs:{"src":item.uupt.driver_photo,"lazy-load":true}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("跑男姓名："+_vm._s(item.uupt.driver_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("跑男电话："),_c('a',{staticClass:"cm-color-666",attrs:{"href":'tel:'+item.uupt.driver_mobile}},[_vm._v(_vm._s(item.uu_order.driver_mobile))])])])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-8"},[_vm._v("跑男抢单中。。。")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.status > 7 && item.sms_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("取件码：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.sms_code))])]):(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])])]):_vm._e(),_vm._v(" "),(item.status == 8 && item.channel > 0)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.uu_order.length <= 0)?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white",on:{"click":function($event){return _vm.uuptOrder(item.id)}}},[_vm._v("\n                          呼叫跑腿配送\n                          ")]):_vm._e(),_vm._v(" "),(item.uu_order.status > 0 && item.uu_order.status <= 3)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.cancelUuptOrder(item.id)}}},[_vm._v("\n                          取消跑腿配送\n                          ")]):_vm._e()]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var suborder_staticRenderFns = []
var suborder_esExports = { render: suborder_render, staticRenderFns: suborder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_suborder = (suborder_esExports);
// CONCATENATED MODULE: ./src/pages/suborder.vue
function suborder_injectStyle (ssrContext) {
  __webpack_require__("Ko1+")
}
var suborder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var suborder___vue_template_functional__ = false
/* styles */
var suborder___vue_styles__ = suborder_injectStyle
/* scopeId */
var suborder___vue_scopeId__ = "data-v-1f8f0a0e"
/* moduleIdentifier (server only) */
var suborder___vue_module_identifier__ = null
var suborder_Component = suborder_normalizeComponent(
  pages_suborder,
  selectortype_template_index_0_src_pages_suborder,
  suborder___vue_template_functional__,
  suborder___vue_styles__,
  suborder___vue_scopeId__,
  suborder___vue_module_identifier__
)

/* harmony default export */ var src_pages_suborder = (suborder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/suboutTimeOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_suboutTimeOrder = ({
    name: 'outTimeOrder',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    inject: ['reload'],
    data: function data() {
        return {
            title: '超时订单',
            grade: 0,
            isActive: 3,
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            type: 0,
            itemId: 0,
            list: [],
            days: [{
                key: 3,
                text: '三天以上'
            }, {
                key: 4,
                text: '四天以上'
            }, {
                key: 5,
                text: '五天以上'
            }, {
                key: 10,
                text: '十天以上'
            }]
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.grade = parseInt(this.$func.getLocal('grade'));
        // if(this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8){
        //     this.getWorker();
        // }
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectDays: function selectDays(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.suboutTimeOrder({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, day: this.isActive }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/suboutTimeOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_suboutTimeOrder = ({
    name: 'outTimeOrder',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    inject: ['reload'],
    data: function data() {
        return {
            title: '超时订单',
            grade: 0,
            isActive: 3,
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            type: 0,
            itemId: 0,
            list: [],
            days: [{
                key: 3,
                text: '三天以上'
            }, {
                key: 4,
                text: '四天以上'
            }, {
                key: 5,
                text: '五天以上'
            }, {
                key: 10,
                text: '十天以上'
            }]
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.grade = parseInt(this.$func.getLocal('grade'));
        // if(this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8){
        //     this.getWorker();
        // }
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectDays: function selectDays(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.suboutTimeOrder({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, day: this.isActive }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70010022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/suboutTimeOrder.vue
var suboutTimeOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"number","placeholder":"下级社区名称|订单号后四位|手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"nav cm-bg-white shadow-gray",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.days),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 ",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectDays(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(item.out_time))])]),_vm._v(" "),(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("社区："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))])]),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666 cm-fn-weight-default"},[_vm._v("收衣时间："+_vm._s(item.collect_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])])]):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var suboutTimeOrder_staticRenderFns = []
var suboutTimeOrder_esExports = { render: suboutTimeOrder_render, staticRenderFns: suboutTimeOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_suboutTimeOrder = (suboutTimeOrder_esExports);
// CONCATENATED MODULE: ./src/pages/suboutTimeOrder.vue
function suboutTimeOrder_injectStyle (ssrContext) {
  __webpack_require__("jsML")
}
var suboutTimeOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var suboutTimeOrder___vue_template_functional__ = false
/* styles */
var suboutTimeOrder___vue_styles__ = suboutTimeOrder_injectStyle
/* scopeId */
var suboutTimeOrder___vue_scopeId__ = "data-v-70010022"
/* moduleIdentifier (server only) */
var suboutTimeOrder___vue_module_identifier__ = null
var suboutTimeOrder_Component = suboutTimeOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_suboutTimeOrder,
  selectortype_template_index_0_src_pages_suboutTimeOrder,
  suboutTimeOrder___vue_template_functional__,
  suboutTimeOrder___vue_styles__,
  suboutTimeOrder___vue_scopeId__,
  suboutTimeOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_suboutTimeOrder = (suboutTimeOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/editBag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_editBag = ({
    name: 'editBag',
    components: {},
    data: function data() {
        return {
            id: 0,
            order_no: '',
            code: '',
            submitStatus: false
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        // this.id = Number(this.$route.params.id);
        // this.changePop();

    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['qrCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.order_no = res.resultStr;
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        scanBrCode: function scanBrCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        submit: function submit() {
            var that = this;
            if (!this.order_no) {
                that.$func.showToast('订单号无效');
                return;
            }
            if (!this.code) {
                that.$func.showToast('扎带码无效');
                return;
            }
            this.$api.editBag({ order_no: this.order_no, code: this.code }).then(function (res) {
                if (res) {
                    that.$func.showToast('修改成功');
                    that.code = '';
                    that.order_no = '';
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/editBag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_editBag = ({
    name: 'editBag',
    components: {},
    data: function data() {
        return {
            id: 0,
            order_no: '',
            code: '',
            submitStatus: false
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        // this.id = Number(this.$route.params.id);
        // this.changePop();

    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['qrCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.order_no = res.resultStr;
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        scanBrCode: function scanBrCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        submit: function submit() {
            var that = this;
            if (!this.order_no) {
                that.$func.showToast('订单号无效');
                return;
            }
            if (!this.code) {
                that.$func.showToast('扎带码无效');
                return;
            }
            this.$api.editBag({ order_no: this.order_no, code: this.code }).then(function (res) {
                if (res) {
                    that.$func.showToast('修改成功');
                    that.code = '';
                    that.order_no = '';
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145feac0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/editBag.vue
var editBag_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"shadow-gray cm-m-lr-8 cm-m-t-20 cm-bg-white"},[_c('div',{staticClass:" cm-p-tb-16   cm-p-lr-12 cm-flex-start cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_no),expression:"order_no"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-8 cm-fn-weight-default ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入订单号或扫码"},domProps:{"value":(_vm.order_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.order_no=$event.target.value}}}),_vm._v(" "),(_vm.order_no)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.order_no = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:" cm-p-tb-16 cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("扎带码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-blue  cm-p-tb-8 cm-fn-weight-default",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入扎带码或扫码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanBrCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100 cm-m-t-40"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var editBag_staticRenderFns = []
var editBag_esExports = { render: editBag_render, staticRenderFns: editBag_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_editBag = (editBag_esExports);
// CONCATENATED MODULE: ./src/pages/editBag.vue
function editBag_injectStyle (ssrContext) {
  __webpack_require__("dEb7")
}
var editBag_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editBag___vue_template_functional__ = false
/* styles */
var editBag___vue_styles__ = editBag_injectStyle
/* scopeId */
var editBag___vue_scopeId__ = "data-v-145feac0"
/* moduleIdentifier (server only) */
var editBag___vue_module_identifier__ = null
var editBag_Component = editBag_normalizeComponent(
  selectortype_script_index_0_src_pages_editBag,
  selectortype_template_index_0_src_pages_editBag,
  editBag___vue_template_functional__,
  editBag___vue_styles__,
  editBag___vue_scopeId__,
  editBag___vue_module_identifier__
)

/* harmony default export */ var src_pages_editBag = (editBag_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/express.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var express = ({
  name: 'express',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {},
        address: {},
        store: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getExpressOrder({ order_no: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitOrder: function submitOrder() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitExpress({ order_no: this.order.order_no }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('下单成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {},
            address: {},
            store: {}
          };
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/express.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_express = ({
  name: 'express',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {
        factory: [],
        community: {},
        address: {},
        store: {}
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getExpressOrder({ order_no: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submitOrder: function submitOrder() {
      var that = this;
      if (!this.order.order_no) {
        that.$func.showToast('订单号无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitExpress({ order_no: this.order.order_no }).then(function (res) {
        if (res) {
          that.submitStatus = false;
          that.$func.showToast('下单成功');
          that.code = '';
          that.order = {
            factory: [],
            community: {},
            address: {},
            store: {}
          };
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86869b24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/express.vue
var express_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-14 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入订单号或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物+附件："),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.count))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("社区/驿站："+_vm._s(_vm.order.community.name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.status_text))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("衣物信息")]),_vm._v(" "),_vm._l((_vm.order.factory),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："+_vm._s(item.factory_wash_code)),(item.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.factory_wash_code)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物编码："+_vm._s(item.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物数量："+_vm._s(item.item_num))])])])})],2),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("收货地址")]),_vm._v(" "),_c('div',{staticClass:"cm-text-left  cm-p-lr-12"},[_c('p',{staticClass:"cm-m-t-8 cm-p-lr-8 cm-fn-16"},[_vm._v(_vm._s(_vm.order.address.name)+" "+_vm._s(_vm.order.address.phone)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.address.phone)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-8 cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(_vm.order.address.address)+" "+_vm._s(_vm.order.address.house_number))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("发货地址")]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-p-lr-12"},[_c('p',{staticClass:"cm-m-t-8 cm-p-lr-8 cm-fn-16"},[_vm._v(_vm._s(_vm.order.store.name)+" "+_vm._s(_vm.order.store.phone)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.address.phone)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-8 cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(_vm.order.store.address))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-flex-between cm-flex-middle cm-p-r-16 cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("快递类型")]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(_vm.order.delivery_way_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-24 cm-center cm-w-100 cm-m-t-8",staticStyle:{"margin-top":"50px"}},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},style:({opacity: !_vm.submitStatus ? '0.5' : '1'}),on:{"click":function($event){return _vm.submitOrder()}}},[_vm._v("确认下单")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-24 cm-center cm-w-100"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.scanQRCode()}}},[_vm._v("扫码")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var express_staticRenderFns = []
var express_esExports = { render: express_render, staticRenderFns: express_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_express = (express_esExports);
// CONCATENATED MODULE: ./src/pages/express.vue
function express_injectStyle (ssrContext) {
  __webpack_require__("v9cA")
}
var express_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var express___vue_template_functional__ = false
/* styles */
var express___vue_styles__ = express_injectStyle
/* scopeId */
var express___vue_scopeId__ = "data-v-86869b24"
/* moduleIdentifier (server only) */
var express___vue_module_identifier__ = null
var express_Component = express_normalizeComponent(
  pages_express,
  selectortype_template_index_0_src_pages_express,
  express___vue_template_functional__,
  express___vue_styles__,
  express___vue_scopeId__,
  express___vue_module_identifier__
)

/* harmony default export */ var src_pages_express = (express_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/productVerify.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var productVerify = ({
  name: 'productVerify',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      info: {
        goods: []
      }
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('核销码无效');
        return;
      }
      that.$func.startLoading();
      this.$api.getProductOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.$func.endLoading();
          that.info = res.data;
        }
      });
    },
    submitQrcode: function submitQrcode() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('核销码无效');
        return;
      }
      that.$func.confirm('确认核销？', '温馨提示', function () {
        that.$func.startLoading();
        that.$api.submitProductQrcode({ id: that.info.id }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            that.$func.showToast('核销成功');
            that.info = {
              oil: {},
              station: {},
              city: {}
            };
            weixin_js_sdk_default.a.ready(function () {
              var media = document.getElementById("musicBox");
              media.src = "https://www.yinliwei.com.cn/uploads/default/qrcode.mp3";
              media.play();
            });
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/productVerify.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_productVerify = ({
  name: 'productVerify',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      info: {
        goods: []
      }
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr;
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('核销码无效');
        return;
      }
      that.$func.startLoading();
      this.$api.getProductOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.$func.endLoading();
          that.info = res.data;
        }
      });
    },
    submitQrcode: function submitQrcode() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('核销码无效');
        return;
      }
      that.$func.confirm('确认核销？', '温馨提示', function () {
        that.$func.startLoading();
        that.$api.submitProductQrcode({ id: that.info.id }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            that.$func.showToast('核销成功');
            that.info = {
              oil: {},
              station: {},
              city: {}
            };
            weixin_js_sdk_default.a.ready(function () {
              var media = document.getElementById("musicBox");
              media.src = "https://www.yinliwei.com.cn/uploads/default/qrcode.mp3";
              media.play();
            });
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35921318","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productVerify.vue
var productVerify_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"70px"}},[_vm._v("核销码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"60%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"输入核销码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/search_ico_delete@2x.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),(_vm.info.goods)?_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-p-lr-12 cm-m-t-12"},_vm._l((_vm.info.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-middle cm-bg-white cm-p-lr-12  cm-flex-start cm-p-tb-12 cm-border-radius-10 border-t"},[_c('div',{staticClass:"image cm-img-box"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"info cm-m-l-12"},[_c('p',{staticClass:"cm-color-333 cm-fn-14 cm-fn-400 overflow-line-2"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-w-100 cm-m-t-8"},[_c('p',{staticClass:"cm-color-333 cm-fn-16"},[_vm._v("￥"+_vm._s(val.price)+"/件")]),_vm._v(" "),_c('p',{staticClass:"cm-color-red cn-fn-500 cm-fn-16"},[_vm._v("×"+_vm._s(val.num))])])])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-p-lr-12 cm-m-t-12"},[_c('div',{staticClass:"cm-p-tb-12 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("订单编号")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(_vm.info.order_no))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("下单时间")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(_vm.info.create_time))])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-w-100 cm-m-t-32"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default cm-margin",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.submitQrcode()}}},[_vm._v("核销")]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default cm-margin cm-m-t-24",staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.scanQRCode()}}},[_vm._v("扫码")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var productVerify_staticRenderFns = []
var productVerify_esExports = { render: productVerify_render, staticRenderFns: productVerify_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_productVerify = (productVerify_esExports);
// CONCATENATED MODULE: ./src/pages/productVerify.vue
function productVerify_injectStyle (ssrContext) {
  __webpack_require__("S+BX")
}
var productVerify_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var productVerify___vue_template_functional__ = false
/* styles */
var productVerify___vue_styles__ = productVerify_injectStyle
/* scopeId */
var productVerify___vue_scopeId__ = "data-v-35921318"
/* moduleIdentifier (server only) */
var productVerify___vue_module_identifier__ = null
var productVerify_Component = productVerify_normalizeComponent(
  pages_productVerify,
  selectortype_template_index_0_src_pages_productVerify,
  productVerify___vue_template_functional__,
  productVerify___vue_styles__,
  productVerify___vue_scopeId__,
  productVerify___vue_module_identifier__
)

/* harmony default export */ var src_pages_productVerify = (productVerify_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/active.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var active = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      utoken: '',
      active: 1,
      user: {
        uid: 0,
        nickname: '',
        phone: ''
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    actived: function actived(e) {
      this.active = e;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.utoken = res.resultStr;
              that.getUser();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getUser: function getUser() {
      var that = this;
      if (!this.utoken) {
        that.$func.showToast('用户token无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getUser({ utoken: this.utoken }).then(function (res) {
        if (res) {
          that.user = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      if (!this.user.uid) {
        that.$func.showToast('用户信息不存在');
        return;
      }
      if (!this.active) {
        that.$func.showToast('请选择赠送数量');
        return;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$api.submitActive({ uid: _this.user.uid, active: _this.active }).then(function (res) {
          if (res) {
            that.submitStatus = false;
            that.$func.showToast('操作成功，请用户前往小程序首页下拉刷新查看免洗商品');
            that.utoken = '';
            that.active = 0;
            that.user = {
              uid: 0,
              nickname: '',
              phone: ''
            };
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/active.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_active = ({
  name: 'pickup',
  components: {},
  data: function data() {
    return {
      id: 0,
      utoken: '',
      active: 1,
      user: {
        uid: 0,
        nickname: '',
        phone: ''
      },
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    actived: function actived(e) {
      this.active = e;
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.utoken = res.resultStr;
              that.getUser();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getUser: function getUser() {
      var that = this;
      if (!this.utoken) {
        that.$func.showToast('用户token无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getUser({ utoken: this.utoken }).then(function (res) {
        if (res) {
          that.user = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      if (!this.user.uid) {
        that.$func.showToast('用户信息不存在');
        return;
      }
      if (!this.active) {
        that.$func.showToast('请选择赠送数量');
        return;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$api.submitActive({ uid: _this.user.uid, active: _this.active }).then(function (res) {
          if (res) {
            that.submitStatus = false;
            that.$func.showToast('操作成功，请用户前往小程序首页下拉刷新查看免洗商品');
            that.utoken = '';
            that.active = 0;
            that.user = {
              uid: 0,
              nickname: '',
              phone: ''
            };
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8b2b72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/active.vue
var active_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-12 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("token：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.utoken),expression:"utoken"}],staticClass:"cm-fn-14 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"请扫描用户个人中心二维码"},domProps:{"value":(_vm.utoken)},on:{"change":_vm.getUser,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.utoken=$event.target.value}}}),_vm._v(" "),(_vm.utoken)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.utoken = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-12 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("用户昵称："),_c('span',{staticClass:"cm-color-red  cm-fn-16"},[_vm._v(_vm._s(_vm.user.nickname))])]),_vm._v(" "),_c('p',{staticClass:" cm-p-lr-8 cm-fn-16"},[_vm._v("手  机  号："),_c('span',{staticClass:"cm-color-red cm-fn-16"},[_vm._v(_vm._s(_vm.user.phone))])])]),_vm._v(" "),_c('div',{staticClass:"cm-text-center cm-p-tb-12 cm-p-lr-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("赠送数量")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-around cm-flex-middle cm-m-t-16"},[_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center cm-p-lr-24 shadow-gray",class:_vm.active == 1 ? 'cm-bg-red' : '',on:{"click":function($event){return _vm.actived(1)}}},[_c('span',{staticClass:"cm-color-blue cm-fn-18",class:_vm.active == 1 ? 'cm-color-white' : ''},[_vm._v("1件")])]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center cm-p-lr-24 shadow-gray",class:_vm.active == 2 ? 'cm-bg-red' : '',on:{"click":function($event){return _vm.actived(2)}}},[_c('span',{staticClass:"cm-color-blue cm-fn-18",class:_vm.active == 2 ? 'cm-color-white' : ''},[_vm._v("2件")])]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center  cm-p-lr-24 shadow-gray ",class:_vm.active == 3 ? 'cm-bg-red' : '',on:{"click":function($event){return _vm.actived(3)}}},[_c('span',{staticClass:"cm-color-blue cm-fn-18",class:_vm.active == 3 ? 'cm-color-white' : ''},[_vm._v("3件")])])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-center cm-w-100 cm-m-t-40",staticStyle:{"margin-top":"50px"}},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-fn-weight-default",staticStyle:{"width":"90%"},style:({opacity: !_vm.submitStatus ? '0.5' : '1'}),on:{"click":function($event){return _vm.submit()}}},[_vm._v("确认赠送")])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var active_staticRenderFns = []
var active_esExports = { render: active_render, staticRenderFns: active_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_active = (active_esExports);
// CONCATENATED MODULE: ./src/pages/active.vue
function active_injectStyle (ssrContext) {
  __webpack_require__("3KoO")
}
var active_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var active___vue_template_functional__ = false
/* styles */
var active___vue_styles__ = active_injectStyle
/* scopeId */
var active___vue_scopeId__ = "data-v-0a8b2b72"
/* moduleIdentifier (server only) */
var active___vue_module_identifier__ = null
var active_Component = active_normalizeComponent(
  pages_active,
  selectortype_template_index_0_src_pages_active,
  active___vue_template_functional__,
  active___vue_styles__,
  active___vue_scopeId__,
  active___vue_module_identifier__
)

/* harmony default export */ var src_pages_active = (active_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outHouseCode.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var outHouseCode = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {},
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              that.getOutOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOutOrder: function getOutOrder() {
      var _this = this;

      if (!this.code) {
        this.$func.showToast('订单号无效');
        return;
      }
      this.$api.getOutOrder({ code: this.code }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.order = res.data;
          _this.submitStatus = true;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.code) {
        this.$func.showToast('订单号无效');
        return false;
      }
      this.$api.outHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this2.$func.showToast('出库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this2.id = 0;
            _this2.order = {};
            _this2.code = '';
            _this2.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/outHouseCode.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_outHouseCode = ({
  name: 'collect',
  components: {},
  data: function data() {
    return {
      id: 0,
      code: '',
      order: {},
      submitStatus: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (res.resultStr.indexOf(",") != -1) {
                that.code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr;
              }
              that.getOutOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOutOrder: function getOutOrder() {
      var _this = this;

      if (!this.code) {
        this.$func.showToast('订单号无效');
        return;
      }
      this.$api.getOutOrder({ code: this.code }).then(function (res) {
        if (res) {
          _this.id = res.data.id;
          _this.order = res.data;
          _this.submitStatus = true;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.submitStatus) {
        return false;
      }
      if (!this.code) {
        this.$func.showToast('订单号无效');
        return false;
      }
      this.$api.outHouse({ id: this.id }).then(function (res) {
        if (res) {
          _this2.$func.showToast('出库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(function () {
            _this2.id = 0;
            _this2.order = {};
            _this2.code = '';
            _this2.submitStatus = false;
          }, 300);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60147cb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/outHouseCode.vue
var outHouseCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-16 cm-bg-white cm-p-lr-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle cm-m-t-16 cm-w-100"},[_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 cm-w-100",attrs:{"type":"text","placeholder":"请扫描二维码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOutOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOutOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-8 cm-flex-between cm-flex-middle cm-m-t-40"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-fn-20"},[_vm._v(_vm._s(_vm.order.phone)+" "+_vm._s(_vm.order.name))]),_vm._v(" "),_c('p',{staticClass:" cm-color-666"},[_vm._v("订单号："+_vm._s(_vm.order.order_no))])]),_vm._v(" "),_c('div',[_vm._v("\n        共"),_c('span',{staticClass:"cm-fn-20"},[_vm._v(" "+_vm._s(_vm.order.goods_num)+" ")]),_vm._v("件\n      ")])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-lr-8 cm-p-t-12"},_vm._l((_vm.order.factory),function(item,index){return _c('li',{key:index,staticClass:"cm-pr"},[_c('div',{staticClass:"cm-img-box image cm-bg-gray"},[_c('img',{attrs:{"src":item.img}})]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-text-center"},[_vm._v(_vm._s(item.factory_wash_code))]),_vm._v(" "),_c('div',{staticClass:"cm-pa title-div cm-bg-block"}),_vm._v(" "),_c('div',{staticClass:"cm-pa title cm-text-center"},[_c('p',{staticClass:"cm-color-white overflow-line-1"},[_vm._v(_vm._s(_vm.order.community.name))])])])}),0),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"cm-w-100 cm-flex-around cm-m-t-12",staticStyle:{"height":"50px"}},[_c('div',{staticClass:"cm-bg-blue cm-center cm-h-100 cm-w-100",style:({opacity: !_vm.submitStatus ? '0.6' : '1'}),on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认出库")])])])]),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var outHouseCode_staticRenderFns = []
var outHouseCode_esExports = { render: outHouseCode_render, staticRenderFns: outHouseCode_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_outHouseCode = (outHouseCode_esExports);
// CONCATENATED MODULE: ./src/pages/outHouseCode.vue
function outHouseCode_injectStyle (ssrContext) {
  __webpack_require__("2YYa")
}
var outHouseCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var outHouseCode___vue_template_functional__ = false
/* styles */
var outHouseCode___vue_styles__ = outHouseCode_injectStyle
/* scopeId */
var outHouseCode___vue_scopeId__ = "data-v-60147cb6"
/* moduleIdentifier (server only) */
var outHouseCode___vue_module_identifier__ = null
var outHouseCode_Component = outHouseCode_normalizeComponent(
  pages_outHouseCode,
  selectortype_template_index_0_src_pages_outHouseCode,
  outHouseCode___vue_template_functional__,
  outHouseCode___vue_styles__,
  outHouseCode___vue_scopeId__,
  outHouseCode___vue_module_identifier__
)

/* harmony default export */ var src_pages_outHouseCode = (outHouseCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/backStore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_backStore = ({
    name: 'backStore',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            backPop: false,
            popBg: false,
            code: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            isActive: 0,
            type: 0,
            itemId: 0,
            list: [],
            types: [{
                key: 0,
                text: '昨日出厂'
            }, {
                key: 1,
                text: '已出厂未到店'
            }, {
                key: 2,
                text: '已回店'
            }]
        };
    },
    created: function created() {
        this.config();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectType: function selectType(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            switch (parseInt(this.isActive)) {
                case 1:
                    this.$api.outFactoryList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                        }
                    });
                    break;
                case 2:
                    this.$api.historyBackStore({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            // if(!this.lastId){
                            //     this.blankShow = res.data.length > 0 ? false : true;
                            // }
                            // this.hasNext = res.hasNext;
                            // this.lastId = res.lastId;
                            // res.data.forEach((item)=>{
                            //     this.list.push(item);
                            // });
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                            console.log(_this.lastId, _this.hasNext);
                        }
                    });
                    break;
                default:
                    this.$api.yesterdayOutFactory({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        barCode: function barCode(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        scanQRCode: function scanQRCode(e) {
            var that = this;
            this.type = e;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            // that.formData[id] = res.resultStr.split(',')[1];
                            that.code = res.resultStr.split(',')[1];
                            that.backStore();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        closePop: function closePop() {
            this.selectType(0);
            this.popBg = false;
            this.backPop = false;
            this.type = 0;
        },
        openPop: function openPop() {
            this.popBg = true;
            this.backPop = true;
        },
        backStore: function backStore() {
            //  this.$func.showToast(this.code);
            // return;
            var that = this;
            if (!this.code) {
                that.$func.showToast('衣物条码无效');
                return;
            }
            // if(code.length != 12){
            //   that.$func.showToast('子订单码无效');
            //   return ;
            // }
            that.$func.startLoading();
            this.$api.backStore({ code: this.code }).then(function (res) {
                if (res) {
                    that.$func.endLoading();
                    that.$func.showToast('已回店');
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                    //   that.selectType(0);
                    if (that.type > 0) {
                        setTimeout(function () {
                            that.scanQRCode(that.type);
                        }, 300);
                    }
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            console.log(111, this.lastId, this.hasNext);
            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            console.log(this.lastId);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/backStore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var selectortype_script_index_0_src_pages_backStore = ({
    name: 'backStore',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            backPop: false,
            popBg: false,
            code: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            isActive: 0,
            type: 0,
            itemId: 0,
            list: [],
            types: [{
                key: 0,
                text: '昨日出厂'
            }, {
                key: 1,
                text: '已出厂未到店'
            }, {
                key: 2,
                text: '已回店'
            }]
        };
    },
    created: function created() {
        this.config();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        selectType: function selectType(key) {
            this.loadStatus = false;
            this.isActive = key;
            this.lastId = 0;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            switch (parseInt(this.isActive)) {
                case 1:
                    this.$api.outFactoryList({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                        }
                    });
                    break;
                case 2:
                    this.$api.historyBackStore({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            // if(!this.lastId){
                            //     this.blankShow = res.data.length > 0 ? false : true;
                            // }
                            // this.hasNext = res.hasNext;
                            // this.lastId = res.lastId;
                            // res.data.forEach((item)=>{
                            //     this.list.push(item);
                            // });
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                            console.log(_this.lastId, _this.hasNext);
                        }
                    });
                    break;
                default:
                    this.$api.yesterdayOutFactory({ last_id: this.lastId, page_flag: this.pageFlag }).then(function (res) {
                        if (res) {
                            console.log(res);
                            if (!_this.lastId) {
                                _this.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this.hasNext = res.hasNext;
                            _this.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        barCode: function barCode(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        scanQRCode: function scanQRCode(e) {
            var that = this;
            this.type = e;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            // that.formData[id] = res.resultStr.split(',')[1];
                            that.code = res.resultStr.split(',')[1];
                            that.backStore();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        closePop: function closePop() {
            this.selectType(0);
            this.popBg = false;
            this.backPop = false;
            this.type = 0;
        },
        openPop: function openPop() {
            this.popBg = true;
            this.backPop = true;
        },
        backStore: function backStore() {
            //  this.$func.showToast(this.code);
            // return;
            var that = this;
            if (!this.code) {
                that.$func.showToast('衣物条码无效');
                return;
            }
            // if(code.length != 12){
            //   that.$func.showToast('子订单码无效');
            //   return ;
            // }
            that.$func.startLoading();
            this.$api.backStore({ code: this.code }).then(function (res) {
                if (res) {
                    that.$func.endLoading();
                    that.$func.showToast('已回店');
                    weixin_js_sdk_default.a.ready(function () {
                        var media = document.getElementById("musicBox");
                        media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3";
                        media.play();
                    });
                    //   that.selectType(0);
                    if (that.type > 0) {
                        setTimeout(function () {
                            that.scanQRCode(that.type);
                        }, 300);
                    }
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            console.log(111, this.lastId, this.hasNext);
            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            console.log(this.lastId);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-993b0626","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backStore.vue
var backStore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"nav cm-bg-white shadow-gray",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 ",class:[_vm.isActive == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectType(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barCode(item.code)}}},[_vm._v(_vm._s(item.code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.code)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.clothe_title)+"("+_vm._s(item.clothe_color)+")")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.openPop()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("扫回店")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.backPop)?_c('div',{staticClass:"pop-bg1 cm-border-radius-10 cm-p-tb-16"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-12 shadow-gray cm-m-t-12 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"52%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物条码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-8 cm-border cm-p-tb-6 cm-p-lr-8 cm-border-radius-8 ",on:{"click":_vm.backStore}},[_vm._v("确定")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-24 cm-flex-middle cm-flex-around cm-w-100 cm-m-t-32"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.scanQRCode(0)}}},[_vm._v("扫一次")]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-green cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.scanQRCode(1)}}},[_vm._v("连续扫")])])]):_vm._e(),_vm._v(" "),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":"false"}})])}
var backStore_staticRenderFns = []
var backStore_esExports = { render: backStore_render, staticRenderFns: backStore_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_backStore = (backStore_esExports);
// CONCATENATED MODULE: ./src/pages/backStore.vue
function backStore_injectStyle (ssrContext) {
  __webpack_require__("RS7C")
}
var backStore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var backStore___vue_template_functional__ = false
/* styles */
var backStore___vue_styles__ = backStore_injectStyle
/* scopeId */
var backStore___vue_scopeId__ = "data-v-993b0626"
/* moduleIdentifier (server only) */
var backStore___vue_module_identifier__ = null
var backStore_Component = backStore_normalizeComponent(
  selectortype_script_index_0_src_pages_backStore,
  selectortype_template_index_0_src_pages_backStore,
  backStore___vue_template_functional__,
  backStore___vue_styles__,
  backStore___vue_scopeId__,
  backStore___vue_module_identifier__
)

/* harmony default export */ var src_pages_backStore = (backStore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/factoryBack.vue









/* harmony default export */ var pages_factoryBack = ({
  name: 'factoryBack',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      id: 0,
      code: '',
      content: '',
      order: {}
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }

      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      if (!this.content) {
        that.$func.showToast('请输入退洗原因');
        return;
      }
      this.$func.confirm('确认提交退洗？', '提示', function () {
        _this.$api.factoryBack({ code: _this.code, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('操作成功');
            _this.code = '';
            _this.content = '';
            _this.order = {};
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/factoryBack.vue









/* harmony default export */ var selectortype_script_index_0_src_pages_factoryBack = ({
  name: 'factoryBack',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      id: 0,
      code: '',
      content: '',
      order: {}
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }

      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      if (!this.content) {
        that.$func.showToast('请输入退洗原因');
        return;
      }
      this.$func.confirm('确认提交退洗？', '提示', function () {
        _this.$api.factoryBack({ code: _this.code, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('操作成功');
            _this.code = '';
            _this.content = '';
            _this.order = {};
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2002aa5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/factoryBack.vue
var factoryBack_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"70px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"60%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"请输入衣物条码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-red cm-fn-16 "},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-color-orange cm-fn-16 "},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："+_vm._s(_vm.order.store_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："+_vm._s(_vm.order.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："+_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12 cm-p-lr-12 cm-m-t-12 shadow-gray"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("退洗原因")]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12"},[_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":'请输入退洗原因 150字以内（必填）',"height":120},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16",staticStyle:{"height":"44px"}},[_c('div',{staticClass:" cm-border-radius-8 cm-center cm-bg-red",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var factoryBack_staticRenderFns = []
var factoryBack_esExports = { render: factoryBack_render, staticRenderFns: factoryBack_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_factoryBack = (factoryBack_esExports);
// CONCATENATED MODULE: ./src/pages/factoryBack.vue
function factoryBack_injectStyle (ssrContext) {
  __webpack_require__("gMNk")
}
var factoryBack_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var factoryBack___vue_template_functional__ = false
/* styles */
var factoryBack___vue_styles__ = factoryBack_injectStyle
/* scopeId */
var factoryBack___vue_scopeId__ = "data-v-2002aa5b"
/* moduleIdentifier (server only) */
var factoryBack___vue_module_identifier__ = null
var factoryBack_Component = factoryBack_normalizeComponent(
  selectortype_script_index_0_src_pages_factoryBack,
  selectortype_template_index_0_src_pages_factoryBack,
  factoryBack___vue_template_functional__,
  factoryBack___vue_styles__,
  factoryBack___vue_scopeId__,
  factoryBack___vue_module_identifier__
)

/* harmony default export */ var src_pages_factoryBack = (factoryBack_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var recordOrder = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      count: {
        'xidi': 0,
        'time_out': 0
      },
      nav: [{
        title: '扎带码录单',
        path: '/bagCodeRecord/1',
        auth: 'bagCodeRecord',
        img: '/static/images/status1.png'
      }, {
        title: '手机号录单',
        path: '/bagCodeRecord/3',
        auth: 'phoneRecord',
        img: '/static/images/status5.png'
      }, {
        title: '衣物上挂',
        path: '/upClothe',
        auth: 'upClothe',
        img: '/static/images/store-visit-lined.png'
      }, {
        title: '自有衣物上挂',
        path: '/upCustomClothe',
        auth: 'upCustomClothe',
        img: '/static/images/upCustomClothe.png'
      }, {
        title: '顾客取衣',
        path: '/pickClothe',
        auth: 'pickClothe',
        img: '/static/images/pickup.png'
      }, {
        title: '附件补录',
        path: '/annex',
        auth: 'annex',
        img: '/static/images/bar.png'
      }, {
        title: '撤单',
        path: '/cancelRecord',
        auth: 'cancelRecord',
        img: '/static/images/submit.png'
      }, {
        title: '回店记录',
        path: '/backStore',
        auth: 'backStore',
        img: '/static/images/store-visit-lined.png'
      }],
      nav1: [{
        title: '今日送洗',
        path: '/todayRecordList',
        auth: 'todayRecordList',
        img: '/static/images/drivered.png'
      }, {
        title: '手机号查询',
        path: '/recordPhoneList',
        auth: 'recordPhoneList',
        img: '/static/images/pickuped.png'
      }, {
        title: '洗涤中',
        path: '/clotheWash',
        auth: 'clotheWash',
        img: '/static/images/arrivaled.png',
        key: 'xidi'
      }, {
        title: '上挂列表',
        path: '/upList',
        auth: 'upList',
        img: '/static/images/upList.png'
      }, {
        title: '取衣记录',
        path: '/pickList',
        auth: 'pickClothe',
        img: '/static/images/pickup.png'
      }, {
        title: '超时衣物',
        path: '/timeOutClotheWash',
        auth: 'timeOutClotheWash',
        img: '/static/images/timeout.png',
        key: 'time_out'
      }, {
        title: '衣物图片',
        path: '/clothePhoto',
        auth: 'clothePhoto',
        img: '/static/images/photo.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '综合查询',
        path: '/recordList',
        auth: 'recordList',
        img: '/static/images/status6.png'
      }]
    };
  },
  created: function created() {
    this.getClotheCount();
  },
  mounted: function mounted() {},

  methods: {
    isNavVisible: function isNavVisible(item) {
      if (!item.customers) {
        return true;
      }
      return this.$customer && item.customers.indexOf(this.$customer.key) > -1;
    },
    hasAuth: function hasAuth(list) {
      var _this = this;

      return list.some(function (item) {
        return _this.isNavVisible(item) && _this.$func.checkAuth(item.auth);
      });
    },
    getClotheCount: function getClotheCount() {
      var _this2 = this;

      this.$api.getClotheCount({}).then(function (res) {
        _this2.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_recordOrder = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      count: {
        'xidi': 0,
        'time_out': 0
      },
      nav: [{
        title: '扎带码录单',
        path: '/bagCodeRecord/1',
        auth: 'bagCodeRecord',
        img: '/static/images/status1.png'
      }, {
        title: '手机号录单',
        path: '/bagCodeRecord/3',
        auth: 'phoneRecord',
        img: '/static/images/status5.png'
      }, {
        title: '衣物上挂',
        path: '/upClothe',
        auth: 'upClothe',
        img: '/static/images/store-visit-lined.png'
      }, {
        title: '自有衣物上挂',
        path: '/upCustomClothe',
        auth: 'upCustomClothe',
        img: '/static/images/upCustomClothe.png'
      }, {
        title: '顾客取衣',
        path: '/pickClothe',
        auth: 'pickClothe',
        img: '/static/images/pickup.png'
      }, {
        title: '附件补录',
        path: '/annex',
        auth: 'annex',
        img: '/static/images/bar.png'
      }, {
        title: '撤单',
        path: '/cancelRecord',
        auth: 'cancelRecord',
        img: '/static/images/submit.png'
      }, {
        title: '回店记录',
        path: '/backStore',
        auth: 'backStore',
        img: '/static/images/store-visit-lined.png'
      }],
      nav1: [{
        title: '今日送洗',
        path: '/todayRecordList',
        auth: 'todayRecordList',
        img: '/static/images/drivered.png'
      }, {
        title: '手机号查询',
        path: '/recordPhoneList',
        auth: 'recordPhoneList',
        img: '/static/images/pickuped.png'
      }, {
        title: '洗涤中',
        path: '/clotheWash',
        auth: 'clotheWash',
        img: '/static/images/arrivaled.png',
        key: 'xidi'
      }, {
        title: '上挂列表',
        path: '/upList',
        auth: 'upList',
        img: '/static/images/upList.png'
      }, {
        title: '取衣记录',
        path: '/pickList',
        auth: 'pickClothe',
        img: '/static/images/pickup.png'
      }, {
        title: '超时衣物',
        path: '/timeOutClotheWash',
        auth: 'timeOutClotheWash',
        img: '/static/images/timeout.png',
        key: 'time_out'
      }, {
        title: '衣物图片',
        path: '/clothePhoto',
        auth: 'clothePhoto',
        img: '/static/images/photo.png'
      }, {
        title: '条码查询',
        path: '/barOrder',
        auth: 'barOrder',
        img: '/static/images/bar.png'
      }, {
        title: '综合查询',
        path: '/recordList',
        auth: 'recordList',
        img: '/static/images/status6.png'
      }]
    };
  },
  created: function created() {
    this.getClotheCount();
  },
  mounted: function mounted() {},

  methods: {
    isNavVisible: function isNavVisible(item) {
      if (!item.customers) {
        return true;
      }
      return this.$customer && item.customers.indexOf(this.$customer.key) > -1;
    },
    hasAuth: function hasAuth(list) {
      var _this = this;

      return list.some(function (item) {
        return _this.isNavVisible(item) && _this.$func.checkAuth(item.auth);
      });
    },
    getClotheCount: function getClotheCount() {
      var _this2 = this;

      this.$api.getClotheCount({}).then(function (res) {
        _this2.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38eb7118","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recordOrder.vue
var recordOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-red cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("洗衣服务")])]),_vm._v(" "),(_vm.$func.checkAuth('recordOrder') && _vm.hasAuth(_vm.nav))?_c('div',{staticClass:"ul2 cm-m-lr-8 cm-bg-white cm-border-radius-10"},[_c('p',{staticClass:"cm-fn-16 cm-color-blue cm-p-tb-12 cm-p-lr-6 cm-m-l-12 cm-fn-500"},[_vm._v("操作")]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((_vm.nav),function(item,index){return (_vm.isNavVisible(item) && _vm.$func.checkAuth(item.auth))?_c('router-link',{key:index,staticClass:"cm-text-center cm-p-tb-24 li cm-pr",attrs:{"to":item.path}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":item.img}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v(_vm._s(item.title))])]):_vm._e()}),1)]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('recordOrder') && _vm.hasAuth(_vm.nav1))?_c('div',{staticClass:"cm-pr cm-m-t-16 cm-m-lr-8 cm-bg-white cm-border-radius-10"},[_c('p',{staticClass:"cm-fn-16 cm-color-blue cm-p-tb-12 cm-p-lr-6 cm-m-l-12 cm-fn-500"},[_vm._v("查询")]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((_vm.nav1),function(item,index){return (_vm.isNavVisible(item) && _vm.$func.checkAuth(item.auth))?_c('router-link',{key:index,staticClass:"cm-text-center cm-p-tb-24 li cm-pr",attrs:{"to":item.path}},[_c('img',{staticClass:"cm-icon-36 cm-margin",attrs:{"src":item.img}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.key && _vm.count[item.key] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[item.key]))]):_vm._e()]):_vm._e()}),1)]):_vm._e()])])}
var recordOrder_staticRenderFns = []
var recordOrder_esExports = { render: recordOrder_render, staticRenderFns: recordOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_recordOrder = (recordOrder_esExports);
// CONCATENATED MODULE: ./src/pages/recordOrder.vue
function recordOrder_injectStyle (ssrContext) {
  __webpack_require__("XsBE")
}
var recordOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recordOrder___vue_template_functional__ = false
/* styles */
var recordOrder___vue_styles__ = recordOrder_injectStyle
/* scopeId */
var recordOrder___vue_scopeId__ = "data-v-38eb7118"
/* moduleIdentifier (server only) */
var recordOrder___vue_module_identifier__ = null
var recordOrder_Component = recordOrder_normalizeComponent(
  pages_recordOrder,
  selectortype_template_index_0_src_pages_recordOrder,
  recordOrder___vue_template_functional__,
  recordOrder___vue_styles__,
  recordOrder___vue_scopeId__,
  recordOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_recordOrder = (recordOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bagCodeRecord.vue






/* harmony default export */ var bagCodeRecord = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      rechargePop: false,
      orderShow: false,
      clotheShow: false,
      colorShow: false,
      flawShow: false,
      bagCode: '',
      amount: '',
      order_no: '',
      type: 0,
      order: {
        community: {
          name: ''
        }
      },
      name: '',
      phone: '',
      froms: [{
        code: '',
        clothe_id: 0,
        color_id: 0,
        flaw_id: [],
        clothe: '选择衣物',
        flaw: '选择瑕疵',
        color: '选择颜色',
        filePath: [],
        pics: [],
        remark: ''
      }],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      info: {}
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.order_no = this.$route.params.order_no;
    if (this.order_no || this.type > 1) {
      this.getOrder();
    }
    this.config();
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    addModules: function addModules() {
      this.froms.push({
        code: '',
        clothe_id: 0,
        color_id: 0,
        flaw_id: [],
        clothe: '选择衣物',
        flaw: '选择瑕疵',
        color: '选择颜色',
        filePath: [],
        pics: [],
        remark: ''
      });
    },
    removeModules: function removeModules(index) {
      this.froms.splice(index, 1);
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              if (key > 0) {
                that.froms[index].code = res.resultStr.split(',')[1];
              } else {
                that.bagCode = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      this.$api.getRecordOrder({ code: this.bagCode, order_no: this.order_no, type: this.type }).then(function (res) {
        if (res) {
          _this2.clothes = res.data.goods;
          _this2.colors = res.data.colors;
          _this2.flaws = res.data.flaw;
          if (_this2.type <= 1) {
            _this2.order = res.data.order;
            _this2.popUp = true;
            _this2.orderShow = true;
          }
        }
      });
    },
    getLastUserInfo: function getLastUserInfo() {
      var _this3 = this;

      this.$api.getLastUserInfo({}).then(function (res) {
        if (res) {
          _this3.name = res.data.name;
          _this3.phone = res.data.phone;
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
    },
    openClotheColor: function openClotheColor(index) {
      this.colorIndex = index;
      this.popUp = true;
      this.colorShow = true;
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.orderShow = false;
      this.clotheShow = false;
      this.colorShow = false;
      this.flawShow = false;
      this.clotheIndex = 0;
      this.colorIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    clotheSelect: function clotheSelect(id, title) {
      this.froms[this.clotheIndex].clothe_id = id;
      this.froms[this.clotheIndex].clothe = title;
      this.closePop();
    },
    colorSelect: function colorSelect(id, title) {
      this.froms[this.colorIndex].color_id = id;
      this.froms[this.colorIndex].color = title;
      this.closePop();
    },
    flawSelect: function flawSelect(i, title) {
      var _this4 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this4.froms[_this4.flawIndex].flaw += index == flaw.length - 1 ? _this4.flaws[item].title : _this4.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    submit: function submit() {
      var _this5 = this;

      if (!this.subStatus) {
        return false;
      }
      this.subStatus = false;
      this.$func.startLoading('提交中...');
      this.$api.submitRecord({ order_id: this.order.id, cid: this.order.cid, name: this.name, phone: this.phone, record_type: this.type, clothe: stringify_default()(this.froms) }).then(function (res) {
        _this5.$func.endLoading();
        if (res) {
          _this5.$func.showToast('提交成功');
          _this5.order_no = '';
          setTimeout(function () {
            window.location.reload();
          }, 300);
        } else {
          _this5.subStatus = true;
        }
      }).catch(function () {
        _this5.$func.endLoading();
        _this5.subStatus = true;
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      if (!localIds || !localIds.length) {
        return false;
      }
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    },
    openRecharge: function openRecharge() {
      this.rechargePop = true;
      this.popUp = true;
    },
    recharge: function recharge() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入充值金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.recharge({ money: this.amount }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.getInfo();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.closePop();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bagCodeRecord.vue






/* harmony default export */ var pages_bagCodeRecord = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      rechargePop: false,
      orderShow: false,
      clotheShow: false,
      colorShow: false,
      flawShow: false,
      bagCode: '',
      amount: '',
      order_no: '',
      type: 0,
      order: {
        community: {
          name: ''
        }
      },
      name: '',
      phone: '',
      froms: [{
        code: '',
        clothe_id: 0,
        color_id: 0,
        flaw_id: [],
        clothe: '选择衣物',
        flaw: '选择瑕疵',
        color: '选择颜色',
        filePath: [],
        pics: [],
        remark: ''
      }],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      info: {}
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.order_no = this.$route.params.order_no;
    if (this.order_no || this.type > 1) {
      this.getOrder();
    }
    this.config();
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    addModules: function addModules() {
      this.froms.push({
        code: '',
        clothe_id: 0,
        color_id: 0,
        flaw_id: [],
        clothe: '选择衣物',
        flaw: '选择瑕疵',
        color: '选择颜色',
        filePath: [],
        pics: [],
        remark: ''
      });
    },
    removeModules: function removeModules(index) {
      this.froms.splice(index, 1);
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              if (key > 0) {
                that.froms[index].code = res.resultStr.split(',')[1];
              } else {
                that.bagCode = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      this.$api.getRecordOrder({ code: this.bagCode, order_no: this.order_no, type: this.type }).then(function (res) {
        if (res) {
          _this2.clothes = res.data.goods;
          _this2.colors = res.data.colors;
          _this2.flaws = res.data.flaw;
          if (_this2.type <= 1) {
            _this2.order = res.data.order;
            _this2.popUp = true;
            _this2.orderShow = true;
          }
        }
      });
    },
    getLastUserInfo: function getLastUserInfo() {
      var _this3 = this;

      this.$api.getLastUserInfo({}).then(function (res) {
        if (res) {
          _this3.name = res.data.name;
          _this3.phone = res.data.phone;
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
    },
    openClotheColor: function openClotheColor(index) {
      this.colorIndex = index;
      this.popUp = true;
      this.colorShow = true;
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.orderShow = false;
      this.clotheShow = false;
      this.colorShow = false;
      this.flawShow = false;
      this.clotheIndex = 0;
      this.colorIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    clotheSelect: function clotheSelect(id, title) {
      this.froms[this.clotheIndex].clothe_id = id;
      this.froms[this.clotheIndex].clothe = title;
      this.closePop();
    },
    colorSelect: function colorSelect(id, title) {
      this.froms[this.colorIndex].color_id = id;
      this.froms[this.colorIndex].color = title;
      this.closePop();
    },
    flawSelect: function flawSelect(i, title) {
      var _this4 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this4.froms[_this4.flawIndex].flaw += index == flaw.length - 1 ? _this4.flaws[item].title : _this4.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    submit: function submit() {
      var _this5 = this;

      if (!this.subStatus) {
        return false;
      }
      this.subStatus = false;
      this.$func.startLoading('提交中...');
      this.$api.submitRecord({ order_id: this.order.id, cid: this.order.cid, name: this.name, phone: this.phone, record_type: this.type, clothe: stringify_default()(this.froms) }).then(function (res) {
        _this5.$func.endLoading();
        if (res) {
          _this5.$func.showToast('提交成功');
          _this5.order_no = '';
          setTimeout(function () {
            window.location.reload();
          }, 300);
        } else {
          _this5.subStatus = true;
        }
      }).catch(function () {
        _this5.$func.endLoading();
        _this5.subStatus = true;
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      if (!localIds || !localIds.length) {
        return false;
      }
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    },
    openRecharge: function openRecharge() {
      this.rechargePop = true;
      this.popUp = true;
    },
    recharge: function recharge() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入充值金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.recharge({ money: this.amount }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.getInfo();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.closePop();
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c40b79a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bagCodeRecord.vue
var bagCodeRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-t-12 "},[_c('div',{staticClass:" cm-flex-between cm-flex-middle cm-p-lr-16 shadow-gray"},[_c('div',[_c('p',{staticClass:"cm-fn-12 cm-fn-weight-min cm-color-666"},[_vm._v("余额")]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-10 cm-fn-36 cm-color-red"},[_vm._v(_vm._s(_vm.info.community_balance))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-green cm-m-l-16",staticStyle:{"border-radius":"16px"},on:{"click":function($event){return _vm.openRecharge()}}},[_vm._v("充值")])])]),_vm._v(" "),(_vm.type > 1)?_c('div',{staticClass:"shadow-gray cm-bg-white cm-m-lr-8 cm-p-tb-16 cm-m-t-12 cm-p-lr-8 "},[_c('div',{staticClass:" cm-flex-start cm-flex-middle border-b cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("姓名：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8  ",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red cm-w-100 cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入姓名"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.name)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.name = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-start cm-flex-middle  cm-m-t-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("电话：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 ",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入电话"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.phone = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-12 "},[_c('div'),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-12 cm-bg-blue cm-color-white cm-w-auto cm-border-radius-4",on:{"click":_vm.getLastUserInfo}},[_vm._v("获取上一单用户信息")])])]):_c('div',{staticClass:"shadow-gray cm-bg-white cm-m-lr-8 cm-p-tb-16 cm-m-t-12  cm-p-lr-8 "},[(_vm.order_no)?_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order_no),expression:"order_no"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 cm-w-100",attrs:{"type":"text","placeholder":"请输入订单号"},domProps:{"value":(_vm.order_no)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.order_no=$event.target.value}}}),_vm._v(" "),(_vm.order_no)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.order_no = ''}}}):_vm._e()])]):_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("扎带码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bagCode),expression:"bagCode"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入扎带码或扫码"},domProps:{"value":(_vm.bagCode)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.bagCode=$event.target.value}}}),_vm._v(" "),(_vm.bagCode)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.bagCode = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-8"},_vm._l((_vm.froms),function(item,index){return _c('div',{key:index,staticClass:" cm-p-lr-8 cm-m-t-8 shadow-gray"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12"},[_c('p',{staticClass:"cm-color-blue  cm-text-left cm-fn-16"},[_vm._v("衣物"+_vm._s(index+1))]),_vm._v(" "),(index > 0)?_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-8 cm-bg-orange cm-color-white",on:{"click":function($event){return _vm.removeModules(index)}}},[_vm._v("移除")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物编码")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.code),expression:"item.code"}],staticClass:"cm-fn-16 cm-color-red ",attrs:{"type":"text","placeholder":"请输入衣物编码或扫码"},domProps:{"value":(item.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "code", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1,index)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("录单衣物")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheShow(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.clothe))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物颜色")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheColor(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.color))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物瑕疵")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheFlaw(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.flaw))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('p',{staticClass:"cm-fn-15 cm-m-t-12"},[_vm._v("衣物图片")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((item.filePath),function(val,i){return _c('li',{key:i,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(index,i)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index,i)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile(index)}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-12"},[_vm._v("备注")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":100,"placeholder":"100字以内（选填）","height":50},model:{value:(item.remark),callback:function ($$v) {_vm.$set(item, "remark", $$v)},expression:"item.remark"}})],1)],1)])}),0),_vm._v(" "),_c('div',{staticClass:"cm-w-100  cm-m-t-40"},[_c('div',{staticClass:"cm-border-radius-8 cm-center cm-m-t-24 cm-m-lr-16 cm-p-tb-12",class:_vm.subStatus ? 'cm-bg-red' : 'cm-bg-gray',staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v(_vm._s(_vm.subStatus ? '提交' : '提交中...'))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",on:{"click":_vm.closePop}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderShow),expression:"orderShow"}],staticClass:"popup cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16 "},[_vm._v("订单号："),_c('span',{staticClass:"cm-color-blue cm-fn-16"},[_vm._v(_vm._s(_vm.order.order_no))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(_vm.order.community.name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单数量："),_vm._l((_vm.order.goods),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item.goods.title)+"×"+_vm._s(item.num)+"；")])})],2),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单数量："),_c('span',{},[_vm._v(_vm._s(_vm.order.goods_num)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-m-t-12"},[_c('button',{staticClass:" cm-bg-green cm-p-tb-12 cm-color-white cm-border-radius-8 cm-fn-16  cm-p-lr-28",on:{"click":_vm.closePop}},[_vm._v("确认")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clotheShow),expression:"clotheShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},_vm._l((_vm.clothes),function(item,index){return _c('div',{key:index,staticClass:"cm-p-tb-12  border-b"},[_c('div',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.clotheSelect(val.id,item.title+'-'+val.title)}}},[_vm._v(_vm._s(val.title))])}),0)])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.colorShow),expression:"colorShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap"},_vm._l((_vm.colors),function(item,index){return _c('div',{key:index,staticClass:"cm-text-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:item.id == _vm.froms[_vm.colorIndex].color_id ? 'cm-bg-orange' :'cm-bg-gray',on:{"click":function($event){return _vm.colorSelect(item.id,item.title)}}},[_c('div',{staticClass:"cm-p-tb-12 cm-p-lr-24",style:({backgroundColor:item.code})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-m-t-2",class:item.id == _vm.froms[_vm.colorIndex].color_id ? 'cm-color-white' :''},[_vm._v(_vm._s(item.title))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flawShow),expression:"flawShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.flaws),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:_vm.froms[_vm.flawIndex].flaw_id.indexOf(index) > -1 ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.flawSelect(index,item.title)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-text-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.addModules()}}},[_c('p',{staticClass:"cm-fn-12 cm-m-t-8 cm-color-white"},[_vm._v("添加")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-white"},[_vm._v("衣物")])]),_vm._v(" "),(_vm.rechargePop)?_c('div',{staticClass:"pop-bg cm-p-tb-24"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入充值金额")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('p',{staticClass:"cm-color-orange cm-fn-22"},[_vm._v("￥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"cm-fn-22 cm-m-lr-4 cm-h-100 cm-color-orange cm-bg-gray cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"80px","height":"40px"},attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.recharge()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认支付")])])])]):_vm._e()])}
var bagCodeRecord_staticRenderFns = []
var bagCodeRecord_esExports = { render: bagCodeRecord_render, staticRenderFns: bagCodeRecord_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_bagCodeRecord = (bagCodeRecord_esExports);
// CONCATENATED MODULE: ./src/pages/bagCodeRecord.vue
function bagCodeRecord_injectStyle (ssrContext) {
  __webpack_require__("hWTM")
}
var bagCodeRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bagCodeRecord___vue_template_functional__ = false
/* styles */
var bagCodeRecord___vue_styles__ = bagCodeRecord_injectStyle
/* scopeId */
var bagCodeRecord___vue_scopeId__ = "data-v-c40b79a8"
/* moduleIdentifier (server only) */
var bagCodeRecord___vue_module_identifier__ = null
var bagCodeRecord_Component = bagCodeRecord_normalizeComponent(
  pages_bagCodeRecord,
  selectortype_template_index_0_src_pages_bagCodeRecord,
  bagCodeRecord___vue_template_functional__,
  bagCodeRecord___vue_styles__,
  bagCodeRecord___vue_scopeId__,
  bagCodeRecord___vue_module_identifier__
)

/* harmony default export */ var src_pages_bagCodeRecord = (bagCodeRecord_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/todayRecordList.vue











/* harmony default export */ var todayRecordList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      pickerStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      wash_code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      checkAllStatus: false,
      allText: '全选',
      ids: '',
      factorys: [],
      factory_id: 0
    };
  },
  created: function created() {
    this.config();
    this.search();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.wash_code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    check: function check(i) {
      if (this.list[i].checked > 0) {
        this.list[i].checked = 0;
      } else {
        this.list[i].checked = 1;
      }
    },
    checkAll: function checkAll() {
      this.checkAllStatus = !this.checkAllStatus;
      if (this.checkAllStatus) {
        this.list.forEach(function (item, index) {
          item.checked = 1;
        });
        this.allText = '全不选';
      } else {
        this.list.forEach(function (item, index) {
          item.checked = 0;
        });
        this.allText = '全选';
      }
    },
    getList: function getList() {
      var _this = this;

      var isDate = new Date();
      var start = isDate.getFullYear() + '-' + (isDate.getMonth() + 1) + '-' + isDate.getDate();
      this.$api.washCode({ wash_code: this.wash_code, type: 1, start: start, end: start }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWash: function sendWash() {
      var _this2 = this;

      this.ids = '';
      this.list.forEach(function (item, index) {
        if (item.checked) {
          _this2.ids += item.id + ',';
        }
      });
      this.$api.getFactory({}).then(function (res) {
        if (res) {
          _this2.factorys = res.data.factorys;
          console.log(res);
          _this2.pickerStatus = true;
        }
      });
    },
    onChange: function onChange(value) {
      this.factory_id = value;
    },
    submitSendWash: function submitSendWash() {
      var _this3 = this;

      if (!this.factory_id) {
        this.$func.showToast('请选择送洗加工厂');
        return false;
      }
      this.$func.startLoading();
      this.$api.sendFactory({ checkIds: this.ids, factory_id: this.factory_id }).then(function (res) {
        if (res) {
          _this3.reset();
          _this3.pickerStatus = false;
          _this3.$func.endLoading();
        }
      });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/todayRecordList.vue











/* harmony default export */ var pages_todayRecordList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      pickerStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      wash_code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      checkAllStatus: false,
      allText: '全选',
      ids: '',
      factorys: [],
      factory_id: 0
    };
  },
  created: function created() {
    this.config();
    this.search();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.wash_code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    check: function check(i) {
      if (this.list[i].checked > 0) {
        this.list[i].checked = 0;
      } else {
        this.list[i].checked = 1;
      }
    },
    checkAll: function checkAll() {
      this.checkAllStatus = !this.checkAllStatus;
      if (this.checkAllStatus) {
        this.list.forEach(function (item, index) {
          item.checked = 1;
        });
        this.allText = '全不选';
      } else {
        this.list.forEach(function (item, index) {
          item.checked = 0;
        });
        this.allText = '全选';
      }
    },
    getList: function getList() {
      var _this = this;

      var isDate = new Date();
      var start = isDate.getFullYear() + '-' + (isDate.getMonth() + 1) + '-' + isDate.getDate();
      this.$api.washCode({ wash_code: this.wash_code, type: 1, start: start, end: start }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWash: function sendWash() {
      var _this2 = this;

      this.ids = '';
      this.list.forEach(function (item, index) {
        if (item.checked) {
          _this2.ids += item.id + ',';
        }
      });
      this.$api.getFactory({}).then(function (res) {
        if (res) {
          _this2.factorys = res.data.factorys;
          console.log(res);
          _this2.pickerStatus = true;
        }
      });
    },
    onChange: function onChange(value) {
      this.factory_id = value;
    },
    submitSendWash: function submitSendWash() {
      var _this3 = this;

      if (!this.factory_id) {
        this.$func.showToast('请选择送洗加工厂');
        return false;
      }
      this.$func.startLoading();
      this.$api.sendFactory({ checkIds: this.ids, factory_id: this.factory_id }).then(function (res) {
        if (res) {
          _this3.reset();
          _this3.pickerStatus = false;
          _this3.$func.endLoading();
        }
      });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7b4b3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/todayRecordList.vue
var todayRecordList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:" cm-bg-white  cm-p-tb-16  cm-p-lr-8 "},[_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14",staticStyle:{"width":"50px"}},[_vm._v("编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-flex-between cm-flex-middle",staticStyle:{"width":"68%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wash_code),expression:"wash_code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物编码或扫码"},domProps:{"value":(_vm.wash_code)},on:{"change":_vm.search,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.wash_code=$event.target.value}}}),_vm._v(" "),(_vm.wash_code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.reset}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-flex-middle cm-flex-start cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-center cm-p-lr-4",staticStyle:{"width":"8%"},on:{"click":function($event){return _vm.check(index)}}},[_c('img',{staticClass:"cm-icon-22 ",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-8",staticStyle:{"width":"82%"},on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.washing_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("加工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_c('span',{staticClass:"cm-color-orange"},[_vm._v("未送洗")])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择送洗加工厂","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.submitSendWash()}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.factorys,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitSendWash()}}},[_vm._v(" 确认 ")])],1)],1)],1),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"155px","right":"15px"},on:{"click":function($event){return _vm.checkAll()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v(_vm._s(_vm.allText))])]):_vm._e(),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.sendWash()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("送洗")])]):_vm._e()])}
var todayRecordList_staticRenderFns = []
var todayRecordList_esExports = { render: todayRecordList_render, staticRenderFns: todayRecordList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_todayRecordList = (todayRecordList_esExports);
// CONCATENATED MODULE: ./src/pages/todayRecordList.vue
function todayRecordList_injectStyle (ssrContext) {
  __webpack_require__("8h2B")
}
var todayRecordList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var todayRecordList___vue_template_functional__ = false
/* styles */
var todayRecordList___vue_styles__ = todayRecordList_injectStyle
/* scopeId */
var todayRecordList___vue_scopeId__ = "data-v-8d7b4b3c"
/* moduleIdentifier (server only) */
var todayRecordList___vue_module_identifier__ = null
var todayRecordList_Component = todayRecordList_normalizeComponent(
  pages_todayRecordList,
  selectortype_template_index_0_src_pages_todayRecordList,
  todayRecordList___vue_template_functional__,
  todayRecordList___vue_styles__,
  todayRecordList___vue_scopeId__,
  todayRecordList___vue_module_identifier__
)

/* harmony default export */ var src_pages_todayRecordList = (todayRecordList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordList.vue













/* harmony default export */ var recordList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: '',
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      outDays: [{
        key: 3,
        text: '三天以上'
      }, {
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, type: 2, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone, outDay: outDay }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordList.vue













/* harmony default export */ var pages_recordList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: '',
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      outDays: [{
        key: 3,
        text: '三天以上'
      }, {
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, type: 2, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone, outDay: outDay }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dbc3a7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recordList.vue
var recordList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wash_code),expression:"wash_code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码"},domProps:{"value":(_vm.wash_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.wash_code=$event.target.value}}}),_vm._v(" "),(_vm.wash_code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("加工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_c('span',{staticClass:"cm-color-orange"},[_vm._v("未送洗")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){_vm.searchPop = true}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("更多")])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}}),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus1},on:{"on-change":_vm.dateChange1,"update:show":function($event){_vm.dateStatus1=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"left","width":"80%"},model:{value:(_vm.searchPop),callback:function ($$v) {_vm.searchPop=$$v},expression:"searchPop"}},[_c('div',{staticClass:"cm-p-lr-16"},[_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("手机号")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("录单时间")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-p-tb-4 cm-flex-between cm-flex-middle cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.startDate)?_c('p',{staticClass:"cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v("请选择")])]),_vm._v(" "),_c('p',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.endDate)?_c('p',{staticClass:" cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v("请选择")])])])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("进厂时间")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-p-tb-4 cm-flex-between cm-flex-middle cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.startDate1)?_c('p',{staticClass:"cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate1(0)}}},[_vm._v(_vm._s(_vm.startDate1))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate1(0)}}},[_vm._v("请选择")])]),_vm._v(" "),_c('p',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.endDate1)?_c('p',{staticClass:" cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate1(1)}}},[_vm._v(_vm._s(_vm.endDate1))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate1(1)}}},[_vm._v("请选择")])])])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("超时时长")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-p-tb-8 cm-flex-start cm-flex-wrap cm-p-lr-12 cm-bg-white"},_vm._l((_vm.outDays),function(item,index){return _c('div',{key:index,staticClass:"cm-border cm-p-tb-4 cm-p-lr-8 cm-m-r-12 cm-m-b-8 cm-fn-12 cm-border-radius-2",class:_vm.outIndex === index ? 'cm-bg-gray cm-color-orange' : '',on:{"click":function($event){return _vm.outTime(index)}}},[_vm._v(_vm._s(item.text))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-pa cm-center cm-border-top-1",staticStyle:{"bottom":"0","left":"0"}},[_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18 cm-bg-white cm-center",on:{"click":_vm.resetSearch}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18  cm-color-white cm-bg-green cm-center",on:{"click":_vm.searchSubmit}},[_vm._v("确定")])])])],1)],1)}
var recordList_staticRenderFns = []
var recordList_esExports = { render: recordList_render, staticRenderFns: recordList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_recordList = (recordList_esExports);
// CONCATENATED MODULE: ./src/pages/recordList.vue
function recordList_injectStyle (ssrContext) {
  __webpack_require__("7s0s")
}
var recordList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recordList___vue_template_functional__ = false
/* styles */
var recordList___vue_styles__ = recordList_injectStyle
/* scopeId */
var recordList___vue_scopeId__ = "data-v-6dbc3a7b"
/* moduleIdentifier (server only) */
var recordList___vue_module_identifier__ = null
var recordList_Component = recordList_normalizeComponent(
  pages_recordList,
  selectortype_template_index_0_src_pages_recordList,
  recordList___vue_template_functional__,
  recordList___vue_styles__,
  recordList___vue_scopeId__,
  recordList___vue_module_identifier__
)

/* harmony default export */ var src_pages_recordList = (recordList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upClothe.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var upClothe = ({
  name: 'barOrder',
  components: {},
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      number: '',
      strip_code: '',
      store: {}
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    //this.getInfo();
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (key > 0) {
                that.strip_code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.up({ code: this.order.factory_wash_code, number: that.number, strip_code: this.strip_code }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this.$func.showToast('已点亮5秒');
        }
        _this.$func.endLoading();
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.store = res.data;
          _this2.$func.setLocal('token', res.data.token);
          _this2.$func.setLocal('grade', res.data.grade);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upClothe.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_upClothe = ({
  name: 'barOrder',
  components: {},
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      number: '',
      strip_code: '',
      store: {}
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    //this.getInfo();
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              if (key > 0) {
                that.strip_code = res.resultStr.split(',')[1];
              } else {
                that.code = res.resultStr.split(',')[1];
                that.getOrder();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.up({ code: this.order.factory_wash_code, number: that.number, strip_code: this.strip_code }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this.$func.showToast('已点亮5秒');
        }
        _this.$func.endLoading();
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.store = res.data;
          _this2.$func.setLocal('token', res.data.token);
          _this2.$func.setLocal('grade', res.data.grade);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b68869e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/upClothe.vue
var upClothe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物条码或扫条码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16 "},[_vm._v("订单号："),_c('span',{staticClass:"cm-color-blue cm-fn-14"},[_vm._v(_vm._s(_vm.order.order_no))]),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e(),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(_vm.order.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(_vm.order.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(_vm.order.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("品类编码："+_vm._s(_vm.order.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),(_vm.order.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")]):_vm._e(),(_vm.order.factory_wash_code && _vm.order.up_num <= 0 && _vm.$func.checkAuth('up'))?_c('span',{staticClass:"cm-p-lr-6 cm-p-tb-4 cm-color-white cm-m-l-12 cm-border-radius-2 cm-bg-orange cm-fn-10",on:{"click":function($event){_vm.popUp = true}}},[_vm._v("上挂")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单图片："),_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(_vm.order.img_path)}}},[_vm._v("点击查看")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(_vm.order.color)+"|"+_vm._s(_vm.order.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")]),(_vm.order.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(_vm.order.order_type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.state_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗工厂："),_c('span',{},[_vm._v(_vm._s(_vm.order.factory_title))])]),_vm._v(" "),(_vm.order.up_num > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.up_num))])]):_vm._e(),_vm._v(" "),(_vm.order.strip_code)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("灯条编码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.strip_code))])]):_vm._e(),_vm._v(" "),(_vm.order.history_strip_code && !_vm.order.strip_code)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("历史灯条编码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.history_strip_code))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("送洗流程")]),_vm._v(" "),_vm._l((_vm.order.process),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8 cm-flex-between"},[_c('p',{staticClass:"cm-color-orange cm-fn-16",staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.operate))]),_vm._v(" "),_c('p',{staticClass:"cm-flex-end",staticStyle:{"width":"40%"}},[_vm._v(_vm._s(item.operate_time))])])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"popup cm-bg-white cm-border-radius-10 cm-p-tb-24"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"up-form-row"},[_c('p',{staticClass:"up-label cm-fn-16"},[_vm._v("输入挂点：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"up-input cm-fn-14 cm-border cm-border-radius-8",attrs:{"type":"number","placeholder":"请输入挂点"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"up-form-row"},[_c('p',{staticClass:"up-label cm-fn-16"},[_vm._v("灯条编码：")]),_vm._v(" "),_c('div',{staticClass:"strip-input-wrap cm-border cm-flex-between cm-flex-middle cm-border-radius-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strip_code),expression:"strip_code"}],staticClass:"cm-fn-14 ",attrs:{"type":"text","placeholder":"请输入灯条编码"},domProps:{"value":(_vm.strip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.strip_code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}})])]),_vm._v(" "),_c('button',{staticClass:"submit-btn cm-bg-red cm-p-tb-16 cm-color-white cm-border-radius-8 cm-m-t-24",attrs:{"lang":"zh_CN"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("同订单挂点："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.up_nums))])]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("当前手机号已上挂："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.phone_up_count || 0))]),_vm._v("件")]),_vm._v(" "),(_vm.order.phone_up_list && _vm.order.phone_up_list.length)?_c('div',{staticClass:"same-user-list"},[_c('p',{staticClass:"same-user-title"},[_vm._v("同用户已上挂衣物")]),_vm._v(" "),_vm._l((_vm.order.phone_up_list),function(item,index){return _c('div',{key:index,staticClass:"same-user-item"},[_c('div',{staticClass:"same-user-info"},[_c('p',{staticClass:"cm-fn-13 cm-color-333"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("衣物："+_vm._s(item.factory_wash_code || item.washing_code)+"　挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.up_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("灯条："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.strip_code || '无'))])])]),_vm._v(" "),(item.strip_code)?_c('button',{staticClass:"light-btn cm-border-radius-4",on:{"click":function($event){return _vm.lightUpStrip(item)}}},[_vm._v("寻找衣物")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-20 cm-pa close-btn",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.popUp = false}}})])])])}
var upClothe_staticRenderFns = []
var upClothe_esExports = { render: upClothe_render, staticRenderFns: upClothe_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_upClothe = (upClothe_esExports);
// CONCATENATED MODULE: ./src/pages/upClothe.vue
function upClothe_injectStyle (ssrContext) {
  __webpack_require__("AZK4")
}
var upClothe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upClothe___vue_template_functional__ = false
/* styles */
var upClothe___vue_styles__ = upClothe_injectStyle
/* scopeId */
var upClothe___vue_scopeId__ = "data-v-8b68869e"
/* moduleIdentifier (server only) */
var upClothe___vue_module_identifier__ = null
var upClothe_Component = upClothe_normalizeComponent(
  pages_upClothe,
  selectortype_template_index_0_src_pages_upClothe,
  upClothe___vue_template_functional__,
  upClothe___vue_styles__,
  upClothe___vue_scopeId__,
  upClothe___vue_module_identifier__
)

/* harmony default export */ var src_pages_upClothe = (upClothe_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upCustomClothe.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_upCustomClothe = ({
  name: 'upCustomClothe',
  components: {},
  data: function data() {
    return {
      code: '',
      number: '',
      strip_code: '',
      name: '',
      phone: '',
      userPop: false,
      userList: [],
      selectedUser: null,
      searchLoading: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    clearPhone: function clearPhone() {
      this.phone = '';
      this.userList = [];
      this.selectedUser = null;
    },
    clearName: function clearName() {
      this.name = '';
    },
    searchUser: function searchUser() {
      var _this = this;

      var phone = (this.phone || '').trim();
      if (!/^\d{4}$|^\d{11}$/.test(phone)) {
        this.$func.showToast('请输入手机号全号或后四位');
        return;
      }
      if (this.searchLoading) {
        return;
      }
      this.searchLoading = true;
      this.$func.startLoading('查询中...');
      this.$api.searchFactoryUsers({ phone: phone }).then(function (res) {
        _this.searchLoading = false;
        _this.$func.endLoading();
        if (res) {
          _this.userList = res.data || [];
          if (!_this.userList.length) {
            _this.$func.showToast('未查询到用户');
            return;
          }
          _this.selectedUser = _this.userList[0];
          _this.userPop = true;
        }
      }).catch(function () {
        _this.searchLoading = false;
        _this.$func.endLoading();
      });
    },
    closeUserPop: function closeUserPop() {
      this.userPop = false;
    },
    confirmUser: function confirmUser() {
      if (!this.selectedUser) {
        this.$func.showToast('请选择用户');
        return;
      }
      this.name = this.selectedUser.name || '';
      this.phone = this.selectedUser.phone || '';
      this.closeUserPop();
    },
    sysUser: function sysUser() {
      var user = this.$func.getLocal('upCustomClotheUserInfo');
      if (user) {
        this.name = JSON.parse(user).name;
        this.phone = JSON.parse(user).phone;
      }
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode', 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              var result = res.resultStr;
              if (result.indexOf(",") != -1) {
                result = result.split(',')[1];
              }
              if (key > 0) {
                that.strip_code = result;
              } else {
                that.code = result;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      if (!this.phone) {
        that.$func.showToast('请输入用户电话');
        return;
      }
      this.$api.upCustomClothe({ code: this.code, number: that.number, strip_code: this.strip_code, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          that.$func.setLocal('upCustomClotheUserInfo', stringify_default()({ 'name': that.name, 'phone': that.phone }));
          that.code = '';
          that.strip_code = '';
          that.number = '';
          that.name = '';
          that.phone = '';
          that.$func.showToast('已上挂');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upCustomClothe.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_upCustomClothe = ({
  name: 'upCustomClothe',
  components: {},
  data: function data() {
    return {
      code: '',
      number: '',
      strip_code: '',
      name: '',
      phone: '',
      userPop: false,
      userList: [],
      selectedUser: null,
      searchLoading: false
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {},

  methods: {
    clearPhone: function clearPhone() {
      this.phone = '';
      this.userList = [];
      this.selectedUser = null;
    },
    clearName: function clearName() {
      this.name = '';
    },
    searchUser: function searchUser() {
      var _this = this;

      var phone = (this.phone || '').trim();
      if (!/^\d{4}$|^\d{11}$/.test(phone)) {
        this.$func.showToast('请输入手机号全号或后四位');
        return;
      }
      if (this.searchLoading) {
        return;
      }
      this.searchLoading = true;
      this.$func.startLoading('查询中...');
      this.$api.searchFactoryUsers({ phone: phone }).then(function (res) {
        _this.searchLoading = false;
        _this.$func.endLoading();
        if (res) {
          _this.userList = res.data || [];
          if (!_this.userList.length) {
            _this.$func.showToast('未查询到用户');
            return;
          }
          _this.selectedUser = _this.userList[0];
          _this.userPop = true;
        }
      }).catch(function () {
        _this.searchLoading = false;
        _this.$func.endLoading();
      });
    },
    closeUserPop: function closeUserPop() {
      this.userPop = false;
    },
    confirmUser: function confirmUser() {
      if (!this.selectedUser) {
        this.$func.showToast('请选择用户');
        return;
      }
      this.name = this.selectedUser.name || '';
      this.phone = this.selectedUser.phone || '';
      this.closeUserPop();
    },
    sysUser: function sysUser() {
      var user = this.$func.getLocal('upCustomClotheUserInfo');
      if (user) {
        this.name = JSON.parse(user).name;
        this.phone = JSON.parse(user).phone;
      }
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode', 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              var result = res.resultStr;
              if (result.indexOf(",") != -1) {
                result = result.split(',')[1];
              }
              if (key > 0) {
                that.strip_code = result;
              } else {
                that.code = result;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number && !this.strip_code) {
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return;
      }
      if (!this.code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      if (!this.phone) {
        that.$func.showToast('请输入用户电话');
        return;
      }
      this.$api.upCustomClothe({ code: this.code, number: that.number, strip_code: this.strip_code, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          that.$func.setLocal('upCustomClotheUserInfo', stringify_default()({ 'name': that.name, 'phone': that.phone }));
          that.code = '';
          that.strip_code = '';
          that.number = '';
          that.name = '';
          that.phone = '';
          that.$func.showToast('已上挂');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cab08774","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/upCustomClothe.vue
var upCustomClothe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main  cm-bg-white"},[_c('div',{staticClass:" cm-p-tb-24  cm-p-lr-16"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle   "},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("衣物条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:" cm-fn-16",attrs:{"type":"text","placeholder":"输入衣物条码或扫码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("衣物挂点：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"cm-fn-16 ",attrs:{"type":"number","placeholder":"请输入挂点"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16 "},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("灯条编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strip_code),expression:"strip_code"}],staticClass:"cm-fn-16 ",attrs:{"type":"text","placeholder":"请输入灯条编码"},domProps:{"value":(_vm.strip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.strip_code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("用户电话：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8",staticStyle:{"width":"55%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入全号或后四位查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('span',{staticClass:"clear-btn",on:{"click":function($event){return _vm.clearPhone()}}},[_vm._v("×")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-text-center cm-border-radius-5 cm-p-lr-4 cm-p-tb-2 cm-m-l-8",on:{"click":function($event){return _vm.searchUser()}}},[_c('p',{staticClass:"cm-color-white cm-p-tb-4 cm-p-lr-8"},[_vm._v("查询")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("用户姓名：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8",staticStyle:{"width":"50%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入用户姓名"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.name)?_c('span',{staticClass:"clear-btn",on:{"click":function($event){return _vm.clearName()}}},[_vm._v("×")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-text-center cm-border-radius-5 cm-p-lr-4 cm-p-tb-2 cm-m-l-8",on:{"click":function($event){return _vm.sysUser()}}},[_c('p',{staticClass:"cm-color-white cm-fn-12"},[_vm._v("获取上一件")]),_vm._v(" "),_c('p',{staticClass:"cm-color-white cm-fn-12"},[_vm._v("衣物信息")])])]),_vm._v(" "),_c('button',{staticClass:" cm-bg-red cm-p-tb-16 cm-color-white cm-border-radius-8 cm-m-t-24",staticStyle:{"width":"90%"},attrs:{"lang":"zh_CN"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userPop),expression:"userPop"}],staticClass:"pop",on:{"click":function($event){return _vm.closeUserPop()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userPop),expression:"userPop"}],staticClass:"user-popup cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-bold"},[_vm._v("选择用户")]),_vm._v(" "),_c('p',{staticClass:"cm-color-gray cm-fn-18",on:{"click":function($event){return _vm.closeUserPop()}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"user-list"},_vm._l((_vm.userList),function(item){return _c('div',{key:item.phone,staticClass:"user-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",class:{'user-item-active': _vm.selectedUser && _vm.selectedUser.phone == item.phone},on:{"click":function($event){_vm.selectedUser = item}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(item.name || '未填写姓名'))]),_vm._v(" "),_c('p',{staticClass:"cm-color-blue cm-fn-16"},[_vm._v(_vm._s(item.phone))])]),_vm._v(" "),(item.create_time)?_c('p',{staticClass:"cm-color-gray cm-fn-12 cm-m-t-4"},[_vm._v("最近衣物："+_vm._s(item.create_time))]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12"},[_c('button',{staticClass:"cm-border cm-bg-white cm-color-gray cm-border-radius-5 cm-p-tb-8",staticStyle:{"width":"42%"},on:{"click":function($event){return _vm.closeUserPop()}}},[_vm._v("取消")]),_vm._v(" "),_c('button',{staticClass:"cm-bg-blue cm-color-white cm-border-radius-5 cm-p-tb-8",staticStyle:{"width":"52%"},on:{"click":function($event){return _vm.confirmUser()}}},[_vm._v("确认选择")])])])])}
var upCustomClothe_staticRenderFns = []
var upCustomClothe_esExports = { render: upCustomClothe_render, staticRenderFns: upCustomClothe_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_upCustomClothe = (upCustomClothe_esExports);
// CONCATENATED MODULE: ./src/pages/upCustomClothe.vue
function upCustomClothe_injectStyle (ssrContext) {
  __webpack_require__("vTcT")
}
var upCustomClothe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upCustomClothe___vue_template_functional__ = false
/* styles */
var upCustomClothe___vue_styles__ = upCustomClothe_injectStyle
/* scopeId */
var upCustomClothe___vue_scopeId__ = "data-v-cab08774"
/* moduleIdentifier (server only) */
var upCustomClothe___vue_module_identifier__ = null
var upCustomClothe_Component = upCustomClothe_normalizeComponent(
  selectortype_script_index_0_src_pages_upCustomClothe,
  selectortype_template_index_0_src_pages_upCustomClothe,
  upCustomClothe___vue_template_functional__,
  upCustomClothe___vue_styles__,
  upCustomClothe___vue_scopeId__,
  upCustomClothe___vue_module_identifier__
)

/* harmony default export */ var src_pages_upCustomClothe = (upCustomClothe_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickClothe.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_pickClothe = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            code: '',
            //   strip_code:'',
            //   phone:'',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            checkAllStatus: false,
            allText: '全选',
            ids: ''
        };
    },
    created: function created() {
        this.config();
        this.search();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        reset: function reset() {
            this.code = '';
            this.list = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        getList: function getList() {
            var _this = this;

            if (!this.code) {
                this.$func.showToast('请输入手机号|衣物编码|灯条编码查询');
                return;
            }
            this.$api.waitPick({ code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        pick: function pick() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.id + ',';
                }
            });
            this.$func.confirm('确认已取衣？', '提示', function () {
                _this2.$func.startLoading();
                _this2.$api.pickClothe({ ids: _this2.ids }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        setTimeout(function () {
                            _this2.reset();
                        }, 300);
                    }
                });
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                            that.search();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickClothe.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_pickClothe = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            code: '',
            //   strip_code:'',
            //   phone:'',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            checkAllStatus: false,
            allText: '全选',
            ids: ''
        };
    },
    created: function created() {
        this.config();
        this.search();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        reset: function reset() {
            this.code = '';
            this.list = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        getList: function getList() {
            var _this = this;

            if (!this.code) {
                this.$func.showToast('请输入手机号|衣物编码|灯条编码查询');
                return;
            }
            this.$api.waitPick({ code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        pick: function pick() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.id + ',';
                }
            });
            this.$func.confirm('确认已取衣？', '提示', function () {
                _this2.$func.startLoading();
                _this2.$api.pickClothe({ ids: _this2.ids }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        setTimeout(function () {
                            _this2.reset();
                        }, 300);
                    }
                });
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                            that.search();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705e70d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickClothe.vue
var pickClothe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-p-tb-16 shadow-gray  cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('div',{staticClass:"cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"请输入手机号|衣物编码|灯条编码查询"},domProps:{"value":(_vm.code)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20 cm-m-l-8",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-12",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-flex-middle cm-flex-start cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-center cm-p-lr-4",staticStyle:{"width":"8%"},on:{"click":function($event){return _vm.check(index)}}},[_c('img',{staticClass:"cm-icon-22 ",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-le-8",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(index+1)+"、")]),_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.up_num))])]),_vm._v(" "),(item.strip_code)?_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("灯条编码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.strip_code))])]):_vm._e()])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"155px","right":"15px"},on:{"click":function($event){return _vm.checkAll()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v(_vm._s(_vm.allText))])]):_vm._e(),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.pick()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("已取衣")])]):_vm._e()])}
var pickClothe_staticRenderFns = []
var pickClothe_esExports = { render: pickClothe_render, staticRenderFns: pickClothe_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickClothe = (pickClothe_esExports);
// CONCATENATED MODULE: ./src/pages/pickClothe.vue
function pickClothe_injectStyle (ssrContext) {
  __webpack_require__("R4rr")
}
var pickClothe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickClothe___vue_template_functional__ = false
/* styles */
var pickClothe___vue_styles__ = pickClothe_injectStyle
/* scopeId */
var pickClothe___vue_scopeId__ = "data-v-705e70d3"
/* moduleIdentifier (server only) */
var pickClothe___vue_module_identifier__ = null
var pickClothe_Component = pickClothe_normalizeComponent(
  selectortype_script_index_0_src_pages_pickClothe,
  selectortype_template_index_0_src_pages_pickClothe,
  pickClothe___vue_template_functional__,
  pickClothe___vue_styles__,
  pickClothe___vue_scopeId__,
  pickClothe___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickClothe = (pickClothe_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upClotheYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var upClotheYizhuanjia = ({
  name: 'barOrder',
  components: {
    cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      id: 0,
      blankShow: true,
      popUp: false,
      code: '',
      order: {
        factory_wash_code: '',
        log: [],
        factory: [],
        community: {}
      },
      number: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.resetScrollTop();
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },
  activated: function activated() {
    this.resetScrollTop();
  },

  methods: {
    resetScrollTop: function resetScrollTop() {
      this.$nextTick(function () {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        setTimeout(function () {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 100);
      });
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          _this.blankShow = false;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number) {
        that.$func.showToast('请输入挂点');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.communityUp({ code: this.order.factory_wash_code, number: that.number }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this2 = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this2.$func.showToast('已点亮5秒');
        }
        _this2.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upClotheYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_upClotheYizhuanjia = ({
  name: 'barOrder',
  components: {
    cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      id: 0,
      blankShow: true,
      popUp: false,
      code: '',
      order: {
        factory_wash_code: '',
        log: [],
        factory: [],
        community: {}
      },
      number: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.resetScrollTop();
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },
  activated: function activated() {
    this.resetScrollTop();
  },

  methods: {
    resetScrollTop: function resetScrollTop() {
      this.$nextTick(function () {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        setTimeout(function () {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 100);
      });
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          _this.blankShow = false;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit() {
      var that = this;
      if (!this.number) {
        that.$func.showToast('请输入挂点');
        return;
      }
      if (!this.order.factory_wash_code) {
        that.$func.showToast('输入衣物条码或扫条码');
        return;
      }
      this.$api.communityUp({ code: this.order.factory_wash_code, number: that.number }).then(function (res) {
        if (res) {
          that.$func.showToast('已上挂');
          that.popUp = false;
        }
      });
    },
    lightUpStrip: function lightUpStrip(item) {
      var _this2 = this;

      if (!item.strip_code) {
        this.$func.showToast('灯条编码为空');
        return;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({ strip_code: item.strip_code }).then(function (res) {
        if (res) {
          _this2.$func.showToast('已点亮5秒');
        }
        _this2.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e29e1d82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/upClotheYizhuanjia.vue
var upClotheYizhuanjia_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物条码或扫条码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),(_vm.order.factory_wash_code)?_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16 "},[_vm._v("订单号："),_c('span',{staticClass:"cm-color-blue cm-fn-14"},[_vm._v(_vm._s(_vm.order.order_no))]),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e(),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(_vm.order.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(_vm.order.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："),_c('span',{},[_vm._v(_vm._s(_vm.order.community_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("品类编码："+_vm._s(_vm.order.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),(_vm.order.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-6 cm-p-tb-8 cm-fn-14 cm-color-666 cm-border cm-m-l-12 cm-border-radius-6",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")]):_vm._e(),(_vm.order.factory_wash_code && _vm.order.up_num <= 0)?_c('span',{staticClass:"cm-p-lr-12 cm-p-tb-8 cm-color-white cm-m-l-12 cm-fn-14 cm-border-radius-6 cm-bg-orange cm-fn-10",on:{"click":function($event){_vm.popUp = true}}},[_vm._v("上挂")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单图片："),_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(_vm.order.img_path)}}},[_vm._v("点击查看")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(_vm.order.color)+"|"+_vm._s(_vm.order.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")]),(_vm.order.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单类型："),_c('span',{},[_vm._v(_vm._s(_vm.order.order_type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.state_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗工厂："),_c('span',{},[_vm._v(_vm._s(_vm.order.factory_title))])]),_vm._v(" "),(_vm.order.up_num > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.up_num))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.order.factory_wash_code)?_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("送洗流程")]),_vm._v(" "),_vm._l((_vm.order.process),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8 cm-flex-between"},[_c('p',{staticClass:"cm-color-orange cm-fn-16",staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.operate))]),_vm._v(" "),_c('p',{staticClass:"cm-flex-end",staticStyle:{"width":"40%"}},[_vm._v(_vm._s(item.operate_time))])])])})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"popup cm-bg-white cm-border-radius-10 cm-p-tb-24"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"up-form-row"},[_c('p',{staticClass:"up-label cm-fn-16"},[_vm._v("输入挂点：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"up-input cm-fn-14 cm-border cm-border-radius-8",attrs:{"type":"number","placeholder":"请输入挂点"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"submit-btn cm-bg-red cm-p-tb-16 cm-color-white cm-border-radius-8 cm-m-t-24",attrs:{"lang":"zh_CN"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("同订单挂点："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.up_nums))])]),_vm._v(" "),_c('p',{staticClass:"cm-center cm-p-tb-4"},[_vm._v("当前手机号已上挂："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(_vm.order.phone_up_count || 0))]),_vm._v("件")]),_vm._v(" "),(_vm.order.phone_up_list && _vm.order.phone_up_list.length)?_c('div',{staticClass:"same-user-list"},[_c('p',{staticClass:"same-user-title"},[_vm._v("同用户已上挂衣物")]),_vm._v(" "),_vm._l((_vm.order.phone_up_list),function(item,index){return _c('div',{key:index,staticClass:"same-user-item"},[_c('div',{staticClass:"same-user-info"},[_c('p',{staticClass:"cm-fn-13 cm-color-333"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("衣物："+_vm._s(item.factory_wash_code || item.washing_code)+"　挂点："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.up_num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("灯条："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.strip_code || '无'))])])]),_vm._v(" "),(item.strip_code)?_c('button',{staticClass:"light-btn cm-border-radius-4",on:{"click":function($event){return _vm.lightUpStrip(item)}}},[_vm._v("寻找衣物")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-20 cm-pa close-btn",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.popUp = false}}})])])],1)}
var upClotheYizhuanjia_staticRenderFns = []
var upClotheYizhuanjia_esExports = { render: upClotheYizhuanjia_render, staticRenderFns: upClotheYizhuanjia_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_upClotheYizhuanjia = (upClotheYizhuanjia_esExports);
// CONCATENATED MODULE: ./src/pages/upClotheYizhuanjia.vue
function upClotheYizhuanjia_injectStyle (ssrContext) {
  __webpack_require__("JiOg")
}
var upClotheYizhuanjia_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upClotheYizhuanjia___vue_template_functional__ = false
/* styles */
var upClotheYizhuanjia___vue_styles__ = upClotheYizhuanjia_injectStyle
/* scopeId */
var upClotheYizhuanjia___vue_scopeId__ = "data-v-e29e1d82"
/* moduleIdentifier (server only) */
var upClotheYizhuanjia___vue_module_identifier__ = null
var upClotheYizhuanjia_Component = upClotheYizhuanjia_normalizeComponent(
  pages_upClotheYizhuanjia,
  selectortype_template_index_0_src_pages_upClotheYizhuanjia,
  upClotheYizhuanjia___vue_template_functional__,
  upClotheYizhuanjia___vue_styles__,
  upClotheYizhuanjia___vue_scopeId__,
  upClotheYizhuanjia___vue_module_identifier__
)

/* harmony default export */ var src_pages_upClotheYizhuanjia = (upClotheYizhuanjia_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickClotheYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pickClotheYizhuanjia = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: true,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            wash_code: '',
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            checkAllStatus: false,
            allText: '全选',
            ids: ''
        };
    },
    created: function created() {
        this.getList();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        reset: function reset() {
            this.phone = '';
            this.wash_code = '';
            this.list = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPick({ code: this.wash_code, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        pick: function pick() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.id + ',';
                }
            });
            this.$func.confirm('确认已取衣？', '提示', function () {
                _this2.$func.startLoading();
                _this2.$api.pickClothe({ ids: _this2.ids }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        setTimeout(function () {
                            _this2.reset();
                        }, 300);
                    }
                });
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickClotheYizhuanjia.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_pickClotheYizhuanjia = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: true,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            wash_code: '',
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            checkAllStatus: false,
            allText: '全选',
            ids: ''
        };
    },
    created: function created() {
        this.getList();
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        reset: function reset() {
            this.phone = '';
            this.wash_code = '';
            this.list = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        getList: function getList() {
            var _this = this;

            this.$api.waitPick({ code: this.wash_code, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        pick: function pick() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.id + ',';
                }
            });
            this.$func.confirm('确认已取衣？', '提示', function () {
                _this2.$func.startLoading();
                _this2.$api.pickClothe({ ids: _this2.ids }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        setTimeout(function () {
                            _this2.reset();
                        }, 300);
                    }
                });
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32339f9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickClotheYizhuanjia.vue
var pickClotheYizhuanjia_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"请输入顾客手机号查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.reset()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-flex-middle cm-flex-start cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-center cm-p-lr-4",staticStyle:{"width":"8%"},on:{"click":function($event){return _vm.check(index)}}},[_c('img',{staticClass:"cm-icon-22 ",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-le-8",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(index+1)+"、")]),_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("挂点："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.up_num))])])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"155px","right":"15px"},on:{"click":function($event){return _vm.checkAll()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v(_vm._s(_vm.allText))])]):_vm._e(),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.pick()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("已取衣")])]):_vm._e()])}
var pickClotheYizhuanjia_staticRenderFns = []
var pickClotheYizhuanjia_esExports = { render: pickClotheYizhuanjia_render, staticRenderFns: pickClotheYizhuanjia_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickClotheYizhuanjia = (pickClotheYizhuanjia_esExports);
// CONCATENATED MODULE: ./src/pages/pickClotheYizhuanjia.vue
function pickClotheYizhuanjia_injectStyle (ssrContext) {
  __webpack_require__("Q/l8")
}
var pickClotheYizhuanjia_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickClotheYizhuanjia___vue_template_functional__ = false
/* styles */
var pickClotheYizhuanjia___vue_styles__ = pickClotheYizhuanjia_injectStyle
/* scopeId */
var pickClotheYizhuanjia___vue_scopeId__ = "data-v-32339f9e"
/* moduleIdentifier (server only) */
var pickClotheYizhuanjia___vue_module_identifier__ = null
var pickClotheYizhuanjia_Component = pickClotheYizhuanjia_normalizeComponent(
  pages_pickClotheYizhuanjia,
  selectortype_template_index_0_src_pages_pickClotheYizhuanjia,
  pickClotheYizhuanjia___vue_template_functional__,
  pickClotheYizhuanjia___vue_styles__,
  pickClotheYizhuanjia___vue_scopeId__,
  pickClotheYizhuanjia___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickClotheYizhuanjia = (pickClotheYizhuanjia_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/annex.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var annex = ({
    components: {
        wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            subStatus: true,
            popUp: false,
            orderShow: false,
            clotheShow: false,
            colorShow: false,
            flawShow: false,
            bagCode: '',
            type: 0,
            name: '',
            phone: '',
            froms: [{
                code: '',
                clothe_id: 0,
                color_id: 0,
                flaw_id: [],
                clothe: '选择附件',
                flaw: '选择瑕疵',
                color: '选择颜色',
                filePath: [],
                pics: []
            }],
            clotheIndex: 0,
            colorIndex: 0,
            flawIndex: 0,
            picIndex: 0,
            clothes: [],
            colors: [],
            flaws: []
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.getAnnex();
        this.config();
    },


    methods: {
        addModules: function addModules() {
            this.froms.push({
                code: '',
                clothe_id: 0,
                color_id: 0,
                flaw_id: [],
                clothe: '选择附件',
                flaw: '选择瑕疵',
                color: '选择颜色',
                filePath: [],
                pics: []
            });
        },
        removeModules: function removeModules(index) {
            this.froms.splice(index, 1);
        },
        scanQRCode: function scanQRCode(key, index) {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            if (key > 0) {
                                that.froms[index].code = res.resultStr.split(',')[1];
                            } else {
                                that.bagCode = res.resultStr.split(',')[1];
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        getAnnex: function getAnnex() {
            var _this = this;

            this.$api.getAnnex({}).then(function (res) {
                if (res) {
                    _this.clothes = res.data.goods;
                    _this.colors = res.data.colors;
                    _this.flaws = res.data.flaw;
                    if (_this.type <= 1) {
                        _this.order = res.data.order;
                        _this.popUp = true;
                        _this.orderShow = true;
                    }

                    console.log(res);
                }
            });
        },
        openClotheShow: function openClotheShow(index) {
            this.clotheIndex = index;
            this.popUp = true;
            this.clotheShow = true;
        },
        openClotheColor: function openClotheColor(index) {
            this.colorIndex = index;
            this.popUp = true;
            this.colorShow = true;
        },
        openClotheFlaw: function openClotheFlaw(index) {
            this.flawIndex = index;
            this.popUp = true;
            this.flawShow = true;
        },
        closePop: function closePop() {
            this.popUp = false;
            this.orderShow = false;
            this.clotheShow = false;
            this.colorShow = false;
            this.flawShow = false;
            this.clotheIndex = 0;
            this.colorIndex = 0;
            this.flawIndex = 0;
        },
        clotheSelect: function clotheSelect(id, title) {
            this.froms[this.clotheIndex].clothe_id = id;
            this.froms[this.clotheIndex].clothe = title;
            this.closePop();
        },
        colorSelect: function colorSelect(id, title) {
            this.froms[this.colorIndex].color_id = id;
            this.froms[this.colorIndex].color = title;
            this.closePop();
        },
        flawSelect: function flawSelect(i, title) {
            var _this2 = this;

            var flawId = this.froms[this.flawIndex].flaw_id;
            if (flawId) {
                if (flawId.indexOf(i) > -1) {
                    flawId.splice(flawId.indexOf(i), 1);
                    this.froms[this.flawIndex].flaw_id = flawId;
                } else {
                    this.froms[this.flawIndex].flaw_id.push(i);
                }
            } else {
                this.froms[this.flawIndex].flaw_id.push(i);
            }
            var flaw = this.froms[this.flawIndex].flaw_id;
            this.froms[this.flawIndex].flaw = '';
            flaw.forEach(function (item, index) {
                _this2.froms[_this2.flawIndex].flaw += index == flaw.length - 1 ? _this2.flaws[item].title : _this2.flaws[item].title + ',';
            });
            if (this.froms[this.flawIndex].flaw_id.length < 1) {
                this.froms[this.flawIndex].flaw = '选择瑕疵';
            }
        },
        submit: function submit() {
            var _this3 = this;

            if (!this.subStatus) {
                return false;
            }
            console.log(this.froms);
            this.$api.submitAnnex({ code: this.bagCode, record_type: this.type, clothe: stringify_default()(this.froms) }).then(function (res) {
                if (res) {
                    _this3.$func.showToast('提交成功');
                    _this3.subStatus = true;
                    setTimeout(function () {
                        window.location.reload();
                    }, 300);
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
                    });
                }
            });
        },
        uploadFile: function uploadFile(index) {
            var that = this;
            this.picIndex = index;
            weixin_js_sdk_default.a.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'],
                sourceType: ['album', 'camera'],
                success: function success(res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
        uploadImg: function uploadImg(localIds) {
            var that = this;
            var localId = localIds.pop();
            weixin_js_sdk_default.a.uploadImage({
                localId: localId,
                success: function success(res) {
                    var path = 'record';
                    that.$api.uploadsImgOss({ serverId: res.serverId, path: path }).then(function (res) {
                        if (res) {
                            that.froms[that.picIndex].filePath.push(res.data.pathName);
                            that.froms[that.picIndex].pics.push(res.data.saveName);
                            if (localIds.length > 0) {
                                that.uploadImg(localIds);
                            }
                        }
                    });
                }
            });
        },
        showPic: function showPic(i, index) {
            weixin_js_sdk_default.a.previewImage({
                current: this.froms[i].filePath[index],
                urls: [this.froms[i].filePath[index]]
            });
        },
        delImg: function delImg(i, index) {
            this.froms[i].filePath.splice(index, 1);
            this.froms[i].pics.splice(index, 1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/annex.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_annex = ({
    components: {
        wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            subStatus: true,
            popUp: false,
            orderShow: false,
            clotheShow: false,
            colorShow: false,
            flawShow: false,
            bagCode: '',
            type: 0,
            name: '',
            phone: '',
            froms: [{
                code: '',
                clothe_id: 0,
                color_id: 0,
                flaw_id: [],
                clothe: '选择附件',
                flaw: '选择瑕疵',
                color: '选择颜色',
                filePath: [],
                pics: []
            }],
            clotheIndex: 0,
            colorIndex: 0,
            flawIndex: 0,
            picIndex: 0,
            clothes: [],
            colors: [],
            flaws: []
        };
    },
    created: function created() {
        this.type = Number(this.$route.params.type);
        this.getAnnex();
        this.config();
    },


    methods: {
        addModules: function addModules() {
            this.froms.push({
                code: '',
                clothe_id: 0,
                color_id: 0,
                flaw_id: [],
                clothe: '选择附件',
                flaw: '选择瑕疵',
                color: '选择颜色',
                filePath: [],
                pics: []
            });
        },
        removeModules: function removeModules(index) {
            this.froms.splice(index, 1);
        },
        scanQRCode: function scanQRCode(key, index) {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            if (key > 0) {
                                that.froms[index].code = res.resultStr.split(',')[1];
                            } else {
                                that.bagCode = res.resultStr.split(',')[1];
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        getAnnex: function getAnnex() {
            var _this = this;

            this.$api.getAnnex({}).then(function (res) {
                if (res) {
                    _this.clothes = res.data.goods;
                    _this.colors = res.data.colors;
                    _this.flaws = res.data.flaw;
                    if (_this.type <= 1) {
                        _this.order = res.data.order;
                        _this.popUp = true;
                        _this.orderShow = true;
                    }

                    console.log(res);
                }
            });
        },
        openClotheShow: function openClotheShow(index) {
            this.clotheIndex = index;
            this.popUp = true;
            this.clotheShow = true;
        },
        openClotheColor: function openClotheColor(index) {
            this.colorIndex = index;
            this.popUp = true;
            this.colorShow = true;
        },
        openClotheFlaw: function openClotheFlaw(index) {
            this.flawIndex = index;
            this.popUp = true;
            this.flawShow = true;
        },
        closePop: function closePop() {
            this.popUp = false;
            this.orderShow = false;
            this.clotheShow = false;
            this.colorShow = false;
            this.flawShow = false;
            this.clotheIndex = 0;
            this.colorIndex = 0;
            this.flawIndex = 0;
        },
        clotheSelect: function clotheSelect(id, title) {
            this.froms[this.clotheIndex].clothe_id = id;
            this.froms[this.clotheIndex].clothe = title;
            this.closePop();
        },
        colorSelect: function colorSelect(id, title) {
            this.froms[this.colorIndex].color_id = id;
            this.froms[this.colorIndex].color = title;
            this.closePop();
        },
        flawSelect: function flawSelect(i, title) {
            var _this2 = this;

            var flawId = this.froms[this.flawIndex].flaw_id;
            if (flawId) {
                if (flawId.indexOf(i) > -1) {
                    flawId.splice(flawId.indexOf(i), 1);
                    this.froms[this.flawIndex].flaw_id = flawId;
                } else {
                    this.froms[this.flawIndex].flaw_id.push(i);
                }
            } else {
                this.froms[this.flawIndex].flaw_id.push(i);
            }
            var flaw = this.froms[this.flawIndex].flaw_id;
            this.froms[this.flawIndex].flaw = '';
            flaw.forEach(function (item, index) {
                _this2.froms[_this2.flawIndex].flaw += index == flaw.length - 1 ? _this2.flaws[item].title : _this2.flaws[item].title + ',';
            });
            if (this.froms[this.flawIndex].flaw_id.length < 1) {
                this.froms[this.flawIndex].flaw = '选择瑕疵';
            }
        },
        submit: function submit() {
            var _this3 = this;

            if (!this.subStatus) {
                return false;
            }
            console.log(this.froms);
            this.$api.submitAnnex({ code: this.bagCode, record_type: this.type, clothe: stringify_default()(this.froms) }).then(function (res) {
                if (res) {
                    _this3.$func.showToast('提交成功');
                    _this3.subStatus = true;
                    setTimeout(function () {
                        window.location.reload();
                    }, 300);
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
                    });
                }
            });
        },
        uploadFile: function uploadFile(index) {
            var that = this;
            this.picIndex = index;
            weixin_js_sdk_default.a.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'],
                sourceType: ['album', 'camera'],
                success: function success(res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
        uploadImg: function uploadImg(localIds) {
            var that = this;
            var localId = localIds.pop();
            weixin_js_sdk_default.a.uploadImage({
                localId: localId,
                success: function success(res) {
                    var path = 'record';
                    that.$api.uploadsImgOss({ serverId: res.serverId, path: path }).then(function (res) {
                        if (res) {
                            that.froms[that.picIndex].filePath.push(res.data.pathName);
                            that.froms[that.picIndex].pics.push(res.data.saveName);
                            if (localIds.length > 0) {
                                that.uploadImg(localIds);
                            }
                        }
                    });
                }
            });
        },
        showPic: function showPic(i, index) {
            weixin_js_sdk_default.a.previewImage({
                current: this.froms[i].filePath[index],
                urls: [this.froms[i].filePath[index]]
            });
        },
        delImg: function delImg(i, index) {
            this.froms[i].filePath.splice(index, 1);
            this.froms[i].pics.splice(index, 1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ac76dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/annex.vue
var annex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-t-12"},[_c('div',{staticClass:"shadow-gray cm-bg-white cm-m-lr-8 cm-p-tb-16  cm-p-lr-8 "},[_c('div',{},[_c('p',{staticClass:"cm-fn-16 cm-text-left"},[_vm._v("主件衣物编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start  cm-flex-middle cm-m-t-12"},[_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bagCode),expression:"bagCode"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入主件衣物编码或扫码"},domProps:{"value":(_vm.bagCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bagCode=$event.target.value}}}),_vm._v(" "),(_vm.bagCode)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.bagCode = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-8"},_vm._l((_vm.froms),function(item,index){return _c('div',{key:index,staticClass:" cm-p-lr-8 cm-m-t-8 shadow-gray"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12"},[_c('p',{staticClass:"cm-color-blue  cm-text-left cm-fn-16"},[_vm._v("附件"+_vm._s(index+1))]),_vm._v(" "),(index > 0)?_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-8 cm-bg-orange cm-color-white",on:{"click":function($event){return _vm.removeModules(index)}}},[_vm._v("移除")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物编码")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.code),expression:"item.code"}],staticClass:"cm-fn-16 cm-color-red ",attrs:{"type":"text","placeholder":"请输入衣物编码或扫码"},domProps:{"value":(item.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "code", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1,index)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("附件类型")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheShow(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.clothe))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物颜色")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheColor(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.color))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物瑕疵")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheFlaw(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.flaw))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('p',{staticClass:"cm-fn-15 cm-m-t-12"},[_vm._v("衣物图片")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((item.filePath),function(val,i){return _c('li',{key:i,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(index,i)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index,i)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile(index)}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)])])}),0),_vm._v(" "),_c('div',{staticClass:"cm-w-100  cm-m-t-40"},[_c('div',{staticClass:"cm-border-radius-8 cm-center cm-m-t-24 cm-m-lr-16 cm-p-tb-12",class:_vm.subStatus ? 'cm-bg-red' : 'cm-bg-gray',staticStyle:{"width":"90%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",on:{"click":_vm.closePop}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clotheShow),expression:"clotheShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.clothes),function(val,i){return _c('div',{key:i,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.clotheSelect(val.id,val.title)}}},[_vm._v(_vm._s(val.title))])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.colorShow),expression:"colorShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap"},_vm._l((_vm.colors),function(item,index){return _c('div',{key:index,staticClass:"cm-text-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:item.id == _vm.froms[_vm.colorIndex].color_id ? 'cm-bg-orange' :'cm-bg-gray',on:{"click":function($event){return _vm.colorSelect(item.id,item.title)}}},[_c('div',{staticClass:"cm-p-tb-12 cm-p-lr-24",style:({backgroundColor:item.code})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-m-t-2",class:item.id == _vm.froms[_vm.colorIndex].color_id ? 'cm-color-white' :''},[_vm._v(_vm._s(item.title))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flawShow),expression:"flawShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.flaws),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:_vm.froms[_vm.flawIndex].flaw_id.indexOf(index) > -1 ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.flawSelect(index,item.title)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-text-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.addModules()}}},[_c('p',{staticClass:"cm-fn-12 cm-m-t-8 cm-color-white"},[_vm._v("添加")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-white"},[_vm._v("附件")])])])}
var annex_staticRenderFns = []
var annex_esExports = { render: annex_render, staticRenderFns: annex_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_annex = (annex_esExports);
// CONCATENATED MODULE: ./src/pages/annex.vue
function annex_injectStyle (ssrContext) {
  __webpack_require__("by66")
}
var annex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var annex___vue_template_functional__ = false
/* styles */
var annex___vue_styles__ = annex_injectStyle
/* scopeId */
var annex___vue_scopeId__ = "data-v-69ac76dd"
/* moduleIdentifier (server only) */
var annex___vue_module_identifier__ = null
var annex_Component = annex_normalizeComponent(
  pages_annex,
  selectortype_template_index_0_src_pages_annex,
  annex___vue_template_functional__,
  annex___vue_styles__,
  annex___vue_scopeId__,
  annex___vue_module_identifier__
)

/* harmony default export */ var src_pages_annex = (annex_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cancelRecord.vue











/* harmony default export */ var pages_cancelRecord = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      pickerStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      wash_code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      checkAllStatus: false,
      allText: '全选',
      ids: '',
      factorys: [],
      factory_id: 0
    };
  },
  created: function created() {
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.wash_code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getWashCode({ code: this.wash_code }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    cancel: function cancel() {
      var _this2 = this;

      this.$func.confirm('确认提交撤单？', '提示', function () {
        _this2.$func.startLoading();
        _this2.$api.cancelRecord({ code: _this2.wash_code }).then(function (res) {
          if (res) {
            _this2.reset();
            _this2.$func.endLoading();
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cancelRecord.vue











/* harmony default export */ var selectortype_script_index_0_src_pages_cancelRecord = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      pickerStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      wash_code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      checkAllStatus: false,
      allText: '全选',
      ids: '',
      factorys: [],
      factory_id: 0
    };
  },
  created: function created() {
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.wash_code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getWashCode({ code: this.wash_code }).then(function (res) {
        if (res) {
          console.log(res);
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    cancel: function cancel() {
      var _this2 = this;

      this.$func.confirm('确认提交撤单？', '提示', function () {
        _this2.$func.startLoading();
        _this2.$api.cancelRecord({ code: _this2.wash_code }).then(function (res) {
          if (res) {
            _this2.reset();
            _this2.$func.endLoading();
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369db6dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cancelRecord.vue
var cancelRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:" cm-bg-white  cm-p-tb-16  cm-p-lr-8 "},[_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"50px"}},[_vm._v("编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-flex-between cm-flex-middle",staticStyle:{"width":"68%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wash_code),expression:"wash_code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物编码或扫码"},domProps:{"value":(_vm.wash_code)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.wash_code=$event.target.value}}}),_vm._v(" "),(_vm.wash_code)?_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.reset}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8  cm-bg-white cm-p-tb-8 cm-p-lr-8"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(index+1)+"、")]),_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])])])}),0)],1),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.cancel()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("撤单")])]):_vm._e()])}
var cancelRecord_staticRenderFns = []
var cancelRecord_esExports = { render: cancelRecord_render, staticRenderFns: cancelRecord_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_cancelRecord = (cancelRecord_esExports);
// CONCATENATED MODULE: ./src/pages/cancelRecord.vue
function cancelRecord_injectStyle (ssrContext) {
  __webpack_require__("0Sfn")
}
var cancelRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cancelRecord___vue_template_functional__ = false
/* styles */
var cancelRecord___vue_styles__ = cancelRecord_injectStyle
/* scopeId */
var cancelRecord___vue_scopeId__ = "data-v-369db6dc"
/* moduleIdentifier (server only) */
var cancelRecord___vue_module_identifier__ = null
var cancelRecord_Component = cancelRecord_normalizeComponent(
  selectortype_script_index_0_src_pages_cancelRecord,
  selectortype_template_index_0_src_pages_cancelRecord,
  cancelRecord___vue_template_functional__,
  cancelRecord___vue_styles__,
  cancelRecord___vue_scopeId__,
  cancelRecord___vue_module_identifier__
)

/* harmony default export */ var src_pages_cancelRecord = (cancelRecord_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/countInOutFactory.vue











/* harmony default export */ var countInOutFactory = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      datas: {
        clothe_in: 0,
        clothe_out: 0,
        count_in: 0,
        count_out: 0,
        shoe_in: 0,
        shoe_out: 0
      },
      startDate: '',
      endDate: '',
      store_title: '请选择',
      community: []
    };
  },
  created: function created() {
    this.getCommunity();
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);

      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    reset: function reset() {
      var _this = this;

      this.store_code = '';
      this.store_title = '请选择';
      this.setDate();
      setTimeout(function () {
        _this.getData();
      }, 300);
    },
    onChange: function onChange(value) {
      console.log(value);
      var that = this;
      this.community.forEach(function (item, index) {
        if (item.key == value) {
          that.store_title = item.value + '(' + item.warehouse_number + ')';
          that.store_code = item.id;
          return;
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.getInOutFactoryData({ start: this.startDate, end: this.endDate, code: this.store_code }).then(function (res) {
        if (res) {
          _this2.datas = res.data;
          _this2.pickerStatus = false;
          _this2.$func.endLoading();
        }
      });
    },
    getCommunity: function getCommunity() {
      var _this3 = this;

      this.$api.getInOutFactoryCommunity({}).then(function (res) {
        if (res) {
          _this3.community = res.data.community;
          _this3.store_title = _this3.community[0].value + '(' + _this3.community[0].warehouse_number + ')';
          _this3.store_code = _this3.community[0].id;
          _this3.getData();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/countInOutFactory.vue











/* harmony default export */ var pages_countInOutFactory = ({
  components: {
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Countup: src_components_countup,
    Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      pickerStatus: false,
      dateStatus: false,
      index: 0,
      datas: {
        clothe_in: 0,
        clothe_out: 0,
        count_in: 0,
        count_out: 0,
        shoe_in: 0,
        shoe_out: 0
      },
      startDate: '',
      endDate: '',
      store_title: '请选择',
      community: []
    };
  },
  created: function created() {
    this.getCommunity();
    this.setDate();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);

      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    reset: function reset() {
      var _this = this;

      this.store_code = '';
      this.store_title = '请选择';
      this.setDate();
      setTimeout(function () {
        _this.getData();
      }, 300);
    },
    onChange: function onChange(value) {
      console.log(value);
      var that = this;
      this.community.forEach(function (item, index) {
        if (item.key == value) {
          that.store_title = item.value + '(' + item.warehouse_number + ')';
          that.store_code = item.id;
          return;
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.getInOutFactoryData({ start: this.startDate, end: this.endDate, code: this.store_code }).then(function (res) {
        if (res) {
          _this2.datas = res.data;
          _this2.pickerStatus = false;
          _this2.$func.endLoading();
        }
      });
    },
    getCommunity: function getCommunity() {
      var _this3 = this;

      this.$api.getInOutFactoryCommunity({}).then(function (res) {
        if (res) {
          _this3.community = res.data.community;
          _this3.store_title = _this3.community[0].value + '(' + _this3.community[0].warehouse_number + ')';
          _this3.store_code = _this3.community[0].id;
          _this3.getData();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf7b761c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/countInOutFactory.vue
var countInOutFactory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-p-lr-16 cm-bg-white cm-p-b-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开始日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("结束日期")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("录单门店")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){_vm.pickerStatus = true}}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(_vm.store_title))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-m-tb-16 cm-flex-around cm-flex-middle"},[_c('div',{staticClass:" cm-p-tb-12  cm-center cm-bg-gray cm-border-radius-12",staticStyle:{"width":"40%"},on:{"click":_vm.reset}},[_c('p',{staticClass:" "},[_vm._v("重置")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-green cm-border-radius-12",staticStyle:{"width":"40%"},on:{"click":_vm.getData}},[_c('p',{staticClass:"cm-color-white"},[_vm._v("确认")])])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-12 cm-bg-white"},[_c('p',{staticClass:"cm-text-left cm-fn-16 cm-color-blue"},[_vm._v("进厂统计")]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-32 cm-m-t-12 cm-flex-middle cm-flex-between "},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("总计 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.count_in,"duration":1.2}})],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v(" 衣服"),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.clothe_in,"duration":1.2}},[_vm._v("元")])],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("鞋 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.shoe_in,"duration":1.2}},[_vm._v("元")])],1)])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12 cm-p-tb-16 cm-p-lr-12 cm-bg-white"},[_c('p',{staticClass:"cm-text-left cm-fn-16 cm-color-blue"},[_vm._v("出厂统计")]),_vm._v(" "),_c('div',{staticClass:"cm-p-lr-32 cm-m-t-12 cm-flex-middle cm-flex-between "},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("总计 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.count_out,"duration":1.2}})],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v(" 衣服"),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.clothe_out,"duration":1.2}},[_vm._v("元")])],1),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("鞋 "),_c('countup',{staticClass:"cm-fn-22 cm-color-red cm-fn-weight-min cm-m-l-8",attrs:{"start-val":0,"end-val":_vm.datas.shoe_out,"duration":1.2}},[_vm._v("元")])],1)])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择录单门店","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.getData()}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.community,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.getData()}}},[_vm._v(" 确认 ")])],1)],1)],1)],1)}
var countInOutFactory_staticRenderFns = []
var countInOutFactory_esExports = { render: countInOutFactory_render, staticRenderFns: countInOutFactory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_countInOutFactory = (countInOutFactory_esExports);
// CONCATENATED MODULE: ./src/pages/countInOutFactory.vue
function countInOutFactory_injectStyle (ssrContext) {
  __webpack_require__("gIZc")
}
var countInOutFactory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var countInOutFactory___vue_template_functional__ = false
/* styles */
var countInOutFactory___vue_styles__ = countInOutFactory_injectStyle
/* scopeId */
var countInOutFactory___vue_scopeId__ = "data-v-bf7b761c"
/* moduleIdentifier (server only) */
var countInOutFactory___vue_module_identifier__ = null
var countInOutFactory_Component = countInOutFactory_normalizeComponent(
  pages_countInOutFactory,
  selectortype_template_index_0_src_pages_countInOutFactory,
  countInOutFactory___vue_template_functional__,
  countInOutFactory___vue_styles__,
  countInOutFactory___vue_scopeId__,
  countInOutFactory___vue_module_identifier__
)

/* harmony default export */ var src_pages_countInOutFactory = (countInOutFactory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/abnormal.vue










/* harmony default export */ var pages_abnormal = ({
  name: 'factoryBack',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      pickerStatus: false,
      abnormal_title: '请选择',
      code: '',
      abnormals: [],
      content: '',
      abnormal_id: 0,
      order: {}
    };
  },
  created: function created() {
    this.config();
    this.abnormal();
  },
  mounted: function mounted() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }

      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    abnormal: function abnormal() {
      var that = this;
      this.$api.abnormal({}).then(function (res) {
        if (res) {
          that.abnormals = res.data;
        }
      });
    },
    onChange: function onChange(value) {
      var _this = this;

      var that = this;
      this.abnormal_id = value;
      this.abnormals.forEach(function (item) {
        if (item.key == _this.abnormal_id) {
          that.abnormal_title = item.value;
          return;
        }
      });
      console.log(value);
    },
    submit: function submit() {
      var _this2 = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      if (!this.abnormal_id) {
        that.$func.showToast('请选择异常类型');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        _this2.$api.submitAbnormal({ code: _this2.code, abnormal_title: _this2.abnormal_title, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/abnormal.vue










/* harmony default export */ var selectortype_script_index_0_src_pages_abnormal = ({
  name: 'factoryBack',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Popup: node_modules_vux_src_components_popup, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      pickerStatus: false,
      abnormal_title: '请选择',
      code: '',
      abnormals: [],
      content: '',
      abnormal_id: 0,
      order: {}
    };
  },
  created: function created() {
    this.config();
    this.abnormal();
  },
  mounted: function mounted() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }

      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          that.$func.endLoading();
        }
      });
    },
    abnormal: function abnormal() {
      var that = this;
      this.$api.abnormal({}).then(function (res) {
        if (res) {
          that.abnormals = res.data;
        }
      });
    },
    onChange: function onChange(value) {
      var _this = this;

      var that = this;
      this.abnormal_id = value;
      this.abnormals.forEach(function (item) {
        if (item.key == _this.abnormal_id) {
          that.abnormal_title = item.value;
          return;
        }
      });
      console.log(value);
    },
    submit: function submit() {
      var _this2 = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      if (!this.abnormal_id) {
        that.$func.showToast('请选择异常类型');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        _this2.$api.submitAbnormal({ code: _this2.code, abnormal_title: _this2.abnormal_title, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2386f998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/abnormal.vue
var abnormal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"70px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"60%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"88%"},attrs:{"type":"text","placeholder":"请输入衣物条码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-text-left cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("订  单  号："+_vm._s(_vm.order.order_no)),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-red cm-fn-16 "},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-color-orange cm-fn-16 "},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："+_vm._s(_vm.order.store_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("下单社区："+_vm._s(_vm.order.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："+_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12 cm-p-lr-12 cm-m-t-12 shadow-gray"},[_c('div',{staticClass:"cm-p-tb-12 cm-bg-white cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('div',{staticClass:"cm-fn-16"},[_vm._v("异常类型")]),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-color-red",on:{"click":function($event){_vm.pickerStatus = true}}},[_vm._v(_vm._s(_vm.abnormal_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("备注说明")]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12"},[_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":'请输入异常原因 150字以内（必填）',"height":120},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16",staticStyle:{"height":"44px"}},[_c('div',{staticClass:" cm-border-radius-8 cm-center cm-bg-red",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择异常类型","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){_vm.pickerStatus = false}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.abnormals,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1)],1)],1)])}
var abnormal_staticRenderFns = []
var abnormal_esExports = { render: abnormal_render, staticRenderFns: abnormal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_abnormal = (abnormal_esExports);
// CONCATENATED MODULE: ./src/pages/abnormal.vue
function abnormal_injectStyle (ssrContext) {
  __webpack_require__("Q44f")
}
var abnormal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var abnormal___vue_template_functional__ = false
/* styles */
var abnormal___vue_styles__ = abnormal_injectStyle
/* scopeId */
var abnormal___vue_scopeId__ = "data-v-2386f998"
/* moduleIdentifier (server only) */
var abnormal___vue_module_identifier__ = null
var abnormal_Component = abnormal_normalizeComponent(
  selectortype_script_index_0_src_pages_abnormal,
  selectortype_template_index_0_src_pages_abnormal,
  abnormal___vue_template_functional__,
  abnormal___vue_styles__,
  abnormal___vue_scopeId__,
  abnormal___vue_module_identifier__
)

/* harmony default export */ var src_pages_abnormal = (abnormal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/coupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var coupon = ({
  name: 'coupon',
  components: {
    cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      list: [],
      type: 0
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.communityCoupon();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    communityCoupon: function communityCoupon() {
      var _this = this;

      this.$api.communityCoupon({ type: this.type }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.list = res.data;
        }
      });
    },
    give: function give(id) {
      this.$router.push({ name: 'giveCoupon', params: { id: id } });
    },
    qrCoupon: function qrCoupon(id) {
      this.$router.push({ name: 'qrCoupon', params: { id: id } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/coupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_coupon = ({
  name: 'coupon',
  components: {
    cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      list: [],
      type: 0
    };
  },
  created: function created() {
    this.type = Number(this.$route.params.type);
    this.communityCoupon();
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    communityCoupon: function communityCoupon() {
      var _this = this;

      this.$api.communityCoupon({ type: this.type }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.list = res.data;
        }
      });
    },
    give: function give(id) {
      this.$router.push({ name: 'giveCoupon', params: { id: id } });
    },
    qrCoupon: function qrCoupon(id) {
      this.$router.push({ name: 'qrCoupon', params: { id: id } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b735fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coupon.vue
var coupon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"cm-m-lr-2"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-pr"},[_c('img',{attrs:{"src":"/static/images/coupon_bg.png"}}),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-flex-between cm-flex-middle",staticStyle:{"top":"0","left":"5%","width":"90%","height":"100%"}},[_c('div',{staticClass:" cm-m-l-16 cm-text-left",staticStyle:{"width":"55%"}},[_c('p',{staticClass:"cm-color-white cm-fn-18"},[_vm._v(_vm._s(item.coupon.title))]),_vm._v(" "),(item.type > 0)?_c('div',[_c('div',{staticClass:"cm-p-tb-2 cm-p-lr-8 cm-border-radius-2 cm-bg-red12 cm-fn-12 cm-auto-width cm-m-t-12"},[_vm._v(_vm._s(item.delivery_type_text))])]):_c('div',[(item.coupon.full > 0)?_c('div',{staticClass:"cm-p-tb-2 cm-p-lr-8 cm-border-radius-2 cm-bg-red12 cm-fn-12 cm-auto-width cm-m-t-12"},[_vm._v("单件满"+_vm._s(item.coupon.full)+"减"+_vm._s(item.coupon.cut))]):_c('div',{staticClass:"cm-p-tb-2 cm-p-lr-8 cm-border-radius-2 cm-bg-red12 cm-fn-12 cm-auto-width cm-m-t-12"},[_vm._v("无使用门槛")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-10 cm-color-white"},[_vm._v("共计"),_c('span',{staticClass:"cn-fn-16 cm-color-white"},[_vm._v(_vm._s(item.total))]),_vm._v("张")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-10 cm-color-white"},[_vm._v("已赠送 "),_c('span',{staticClass:"cn-fn-16 cm-color-white"},[_vm._v(_vm._s(item.num))]),_vm._v("张")])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-fn-10 cm-color-white"},[_vm._v("剩余"),_c('span',{staticClass:"cn-fn-16 cm-color-yellow"},[_vm._v(_vm._s(item.remain))]),_vm._v("张")])])])]),_vm._v(" "),_c('div',{staticClass:" cm-p-tb-4",staticStyle:{"width":"36%"}},[(item.type > 0)?_c('div',{staticClass:"cm-text-center"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("配送券")])]):_c('div',{staticClass:"cm-text-center"},[_c('p',{staticClass:"cm-fn-36 cm-color-red"},[_c('span',{staticClass:"cm-fn-12 cm-color-red"},[_vm._v("￥")]),_vm._v(_vm._s(item.coupon.cut))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("优惠券")])]),_vm._v(" "),(item.remain > 0)?_c('div',{staticClass:"cm-flex-around cm-flex-middle cm-m-t-8"},[_c('div',{staticClass:"cm-bg-yellow cm-color-white cm-p-tb-2 cm-p-lr-8 cm-fn-12 cm-border-radius-2",on:{"click":function($event){return _vm.qrCoupon(item.id)}}},[_vm._v(" 领取码")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-color-white cm-p-tb-2 cm-p-lr-8 cm-fn-12 cm-border-radius-2",on:{"click":function($event){return _vm.give(item.id)}}},[_vm._v("赠送")])]):_c('div',{staticClass:"cm-flex-around cm-flex-middle cm-m-t-8"},[_c('p',{staticClass:"cm-color-orange cm-fn-10"},[_vm._v("数量不足")])])])])])}),0)],1)])}
var coupon_staticRenderFns = []
var coupon_esExports = { render: coupon_render, staticRenderFns: coupon_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_coupon = (coupon_esExports);
// CONCATENATED MODULE: ./src/pages/coupon.vue
function coupon_injectStyle (ssrContext) {
  __webpack_require__("RUse")
}
var coupon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var coupon___vue_template_functional__ = false
/* styles */
var coupon___vue_styles__ = coupon_injectStyle
/* scopeId */
var coupon___vue_scopeId__ = "data-v-72b735fe"
/* moduleIdentifier (server only) */
var coupon___vue_module_identifier__ = null
var coupon_Component = coupon_normalizeComponent(
  pages_coupon,
  selectortype_template_index_0_src_pages_coupon,
  coupon___vue_template_functional__,
  coupon___vue_styles__,
  coupon___vue_scopeId__,
  coupon___vue_module_identifier__
)

/* harmony default export */ var src_pages_coupon = (coupon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/giveCoupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_giveCoupon = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            couponId: 0,
            checkAllStatus: false,
            allText: '全选',
            ids: '',
            days: '',
            number: '',
            phone: ''
        };
    },
    created: function created() {
        this.couponId = Number(this.$route.params.id);
    },
    mounted: function mounted() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getCommunityUser({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        showPop: function showPop() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.uid + ',';
                }
            });
            if (!this.ids) {
                this.$func.showToast('请选择用户');
                return false;
            }
            this.pop = true;
        },
        give: function give() {
            var _this3 = this;

            if (this.number <= 0) {
                this.$func.showToast('请输入赠送数量');
                return false;
            }
            console.log({ coupon_id: this.couponId, ids: this.ids });
            this.$func.confirm('确认赠送？', '提示', function () {
                _this3.$api.giveCoupon({ coupon_id: _this3.couponId, ids: _this3.ids, number: _this3.number, days: _this3.days }).then(function (res) {
                    if (res) {
                        _this3.$func.showToast('提交成功');
                        _this3.pop = false;
                        _this3.phone = '';
                        _this3.search();
                    }
                });
            });
        },
        closePop: function closePop() {
            this.pop = false;
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/giveCoupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_giveCoupon = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            pop: false,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            couponId: 0,
            checkAllStatus: false,
            allText: '全选',
            ids: '',
            days: '',
            number: '',
            phone: ''
        };
    },
    created: function created() {
        this.couponId = Number(this.$route.params.id);
    },
    mounted: function mounted() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getCommunityUser({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.list[i].checked = 0;
            } else {
                this.list[i].checked = 1;
            }
        },
        checkAll: function checkAll() {
            this.checkAllStatus = !this.checkAllStatus;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
                this.allText = '全不选';
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
                this.allText = '全选';
            }
        },
        showPop: function showPop() {
            var _this2 = this;

            this.ids = '';
            this.list.forEach(function (item, index) {
                if (item.checked) {
                    _this2.ids += item.uid + ',';
                }
            });
            if (!this.ids) {
                this.$func.showToast('请选择用户');
                return false;
            }
            this.pop = true;
        },
        give: function give() {
            var _this3 = this;

            if (this.number <= 0) {
                this.$func.showToast('请输入赠送数量');
                return false;
            }
            console.log({ coupon_id: this.couponId, ids: this.ids });
            this.$func.confirm('确认赠送？', '提示', function () {
                _this3.$api.giveCoupon({ coupon_id: _this3.couponId, ids: _this3.ids, number: _this3.number, days: _this3.days }).then(function (res) {
                    if (res) {
                        _this3.$func.showToast('提交成功');
                        _this3.pop = false;
                        _this3.phone = '';
                        _this3.search();
                    }
                });
            });
        },
        closePop: function closePop() {
            this.pop = false;
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bf1593a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/giveCoupon.vue
var giveCoupon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray",class:[_vm.pop ? 'noscroll' : '' ]},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"UID|手机号|姓名"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank',{staticClass:"cm-m-t-40"}):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-8 cm-bg-white cm-flex-middle cm-flex-start",on:{"click":function($event){return _vm.check(index)}}},[_c('div',{staticClass:"cm-p-tb-16 cm-center",staticStyle:{"width":"8%"}},[_c('img',{staticClass:"cm-icon-22 cm-m-l-8",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-12",staticStyle:{"width":"89%"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-4  "},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-color-orange"},[_vm._v("NO."+_vm._s(item.uid))]),_vm._v(" "),_c('p',{staticClass:"cm-color-block cm-m-l-12"},[_vm._v(_vm._s(item.nickname)+" ")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-4 cm-border-top-1"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.name)+" ")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange cm-m-l-12"},[_vm._v(_vm._s(item.phone))])]):_vm._e(),_vm._v(" "),(item.card_title)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-4 cm-border-top-1"},[_c('p',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.card_title)+" ")])]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"155px","right":"15px","z-index":"101"},on:{"click":function($event){return _vm.checkAll()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v(_vm._s(_vm.allText))])]):_vm._e(),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-orange cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px","z-index":"101"},on:{"click":function($event){return _vm.showPop()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("赠送")])]):_vm._e(),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"pop"}):_vm._e(),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"pop-bg cm-p-t-20 cm-p-b-36"},[_c('div',{staticClass:"cm-w-100"},[_c('div',{staticClass:"cm-m-lr-16 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-block cm-fn-16 cm-fn-weight-default cm-pr"}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.closePop()}}},[_c('i',{staticClass:"cm-fn-32 iconfont icon-shanchu cm-fn-weight-default",staticStyle:{"color":"#000"}})])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-4 cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("领取数量(张)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"cm-fn-16 ",attrs:{"type":"number","placeholder":"每个用户可领取数量(张)"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("使用期限(天)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.days),expression:"days"}],staticClass:"cm-fn-16 ",attrs:{"type":"days","placeholder":"领取后几天有效(天)默认1年"},domProps:{"value":(_vm.days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.days=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.give()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])]):_vm._e()])}
var giveCoupon_staticRenderFns = []
var giveCoupon_esExports = { render: giveCoupon_render, staticRenderFns: giveCoupon_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_giveCoupon = (giveCoupon_esExports);
// CONCATENATED MODULE: ./src/pages/giveCoupon.vue
function giveCoupon_injectStyle (ssrContext) {
  __webpack_require__("Ur7f")
}
var giveCoupon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var giveCoupon___vue_template_functional__ = false
/* styles */
var giveCoupon___vue_styles__ = giveCoupon_injectStyle
/* scopeId */
var giveCoupon___vue_scopeId__ = "data-v-3bf1593a"
/* moduleIdentifier (server only) */
var giveCoupon___vue_module_identifier__ = null
var giveCoupon_Component = giveCoupon_normalizeComponent(
  selectortype_script_index_0_src_pages_giveCoupon,
  selectortype_template_index_0_src_pages_giveCoupon,
  giveCoupon___vue_template_functional__,
  giveCoupon___vue_styles__,
  giveCoupon___vue_scopeId__,
  giveCoupon___vue_module_identifier__
)

/* harmony default export */ var src_pages_giveCoupon = (giveCoupon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/qrCoupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var qrCoupon = ({
  name: 'qrCoupon',
  components: {},
  data: function data() {
    return {
      popUp: false,
      dateStatus: false,
      size: 250,
      days: '',
      qrcode: '',
      endDate: '',
      number: '',
      id: 0,
      info: {
        coupon: {}
      }
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.communityCoupon();
  },

  methods: {
    communityCoupon: function communityCoupon() {
      var _this = this;

      this.$api.communityCoupon({ id: this.id }).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (this.number <= 0) {
        this.$func.showToast('请输入领取数量');
        return false;
      }
      this.$api.subQrCoupon({ id: this.id, number: this.number, days: this.days }).then(function (res) {
        if (res) {
          _this2.qrcode = res.data.path;
          console.log('qrcode', res.data.path);
          _this2.popUp = true;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/qrCoupon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_qrCoupon = ({
  name: 'qrCoupon',
  components: {},
  data: function data() {
    return {
      popUp: false,
      dateStatus: false,
      size: 250,
      days: '',
      qrcode: '',
      endDate: '',
      number: '',
      id: 0,
      info: {
        coupon: {}
      }
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.communityCoupon();
  },

  methods: {
    communityCoupon: function communityCoupon() {
      var _this = this;

      this.$api.communityCoupon({ id: this.id }).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (this.number <= 0) {
        this.$func.showToast('请输入领取数量');
        return false;
      }
      this.$api.subQrCoupon({ id: this.id, number: this.number, days: this.days }).then(function (res) {
        if (res) {
          _this2.qrcode = res.data.path;
          console.log('qrcode', res.data.path);
          _this2.popUp = true;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b7fe10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/qrCoupon.vue
var qrCoupon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-p-tb-16 cm-p-lr-12 cm-bg-white "},[_c('div',{staticClass:"cm-p-tb-12 cm-flex-start cm-flex-middle  cm-border-bottom-1"},[_c('p',[_c('span',{staticClass:"cm-color-red cm-fn-22 cm-p-lr-4"},[_vm._v(_vm._s(_vm.info.coupon.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-l-12"},[_vm._v("剩余"),_c('span',{staticClass:"cm-color-red cm-fn-22 cm-p-lr-4"},[_vm._v(_vm._s(_vm.info.remain))]),_vm._v("张")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 shadow-gray cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-4 cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("领取数量(张)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"cm-fn-16 ",attrs:{"type":"number","placeholder":"每个用户可领取数量(张)"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-flex-between cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("使用期限(天)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.days),expression:"days"}],staticClass:"cm-fn-16 ",attrs:{"type":"days","placeholder":"领取后几天有效(天)默认1年"},domProps:{"value":(_vm.days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.days=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",on:{"click":function($event){_vm.popUp = false}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"popup cm-bg-white cm-border-radius-10 cm-center cm-p-tb-32 cm-img-box",staticStyle:{"height":"340px"}},[_c('img',{attrs:{"src":_vm.qrcode}})])])}
var qrCoupon_staticRenderFns = []
var qrCoupon_esExports = { render: qrCoupon_render, staticRenderFns: qrCoupon_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_qrCoupon = (qrCoupon_esExports);
// CONCATENATED MODULE: ./src/pages/qrCoupon.vue
function qrCoupon_injectStyle (ssrContext) {
  __webpack_require__("kN7D")
}
var qrCoupon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrCoupon___vue_template_functional__ = false
/* styles */
var qrCoupon___vue_styles__ = qrCoupon_injectStyle
/* scopeId */
var qrCoupon___vue_scopeId__ = "data-v-11b7fe10"
/* moduleIdentifier (server only) */
var qrCoupon___vue_module_identifier__ = null
var qrCoupon_Component = qrCoupon_normalizeComponent(
  pages_qrCoupon,
  selectortype_template_index_0_src_pages_qrCoupon,
  qrCoupon___vue_template_functional__,
  qrCoupon___vue_styles__,
  qrCoupon___vue_scopeId__,
  qrCoupon___vue_module_identifier__
)

/* harmony default export */ var src_pages_qrCoupon = (qrCoupon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsCount.vue





/* harmony default export */ var pages_goodsCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();

        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsCount.vue





/* harmony default export */ var selectortype_script_index_0_src_pages_goodsCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();

        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afe4b1d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goodsCount.vue
var goodsCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16"},[_c('div',{staticClass:" cm-pf cm-bg-white",staticStyle:{"top":"0","left":"0","z-index":"100"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-8"},[_vm._v("至")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-p-lr-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getList}},[_c('p',{staticClass:"cm-color-white"},[_vm._v("确认")])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table cm-pa cm-p-t-12 cm-border-radius-4  shadow-gray cm-w-100 cm-bg-white",staticStyle:{"top":"105px","left":"0","z-index":"90"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.member_price))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.price))]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange",staticStyle:{"width":"11%"}},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('p',{staticStyle:{"width":"16.5%"}},[_vm._v(_vm._s(item.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange",staticStyle:{"width":"16.5%"}},[_vm._v(_vm._s(item.profit))])])}),_vm._v(" "),(_vm.blankShow)?_c('cmBlank'):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-blue cm-center cm-border-radius",staticStyle:{"z-index":"110","width":"56px","height":"56px","bottom":"65px","right":"15px"},on:{"click":function($event){return _vm.download()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("下载")])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var goodsCount_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table cm-pf cm-bg-white",staticStyle:{"left":"0","top":"60px","z-index":"99"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("名称")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v("会员价")]),_vm._v(" "),_c('p',[_vm._v("市场价")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange",staticStyle:{"width":"11%"}},[_vm._v("数量")]),_vm._v(" "),_c('p',{staticStyle:{"width":"16.5%"}},[_vm._v("营业额")]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange",staticStyle:{"width":"16.5%"}},[_vm._v("收益")])])])}]
var goodsCount_esExports = { render: goodsCount_render, staticRenderFns: goodsCount_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_goodsCount = (goodsCount_esExports);
// CONCATENATED MODULE: ./src/pages/goodsCount.vue
function goodsCount_injectStyle (ssrContext) {
  __webpack_require__("iYUD")
}
var goodsCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var goodsCount___vue_template_functional__ = false
/* styles */
var goodsCount___vue_styles__ = goodsCount_injectStyle
/* scopeId */
var goodsCount___vue_scopeId__ = "data-v-6afe4b1d"
/* moduleIdentifier (server only) */
var goodsCount___vue_module_identifier__ = null
var goodsCount_Component = goodsCount_normalizeComponent(
  selectortype_script_index_0_src_pages_goodsCount,
  selectortype_template_index_0_src_pages_goodsCount,
  goodsCount___vue_template_functional__,
  goodsCount___vue_styles__,
  goodsCount___vue_scopeId__,
  goodsCount___vue_module_identifier__
)

/* harmony default export */ var src_pages_goodsCount = (goodsCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dataCount.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dataCount = ({
  name: 'dataCount',
  components: {},
  data: function data() {
    return {
      list: [{
        title: '洗衣店普通商品统计',
        path: '/goodsCount'
      }, {
        title: '洗衣店团购商品统计',
        path: '/goodsGroupCount'
      }, {
        title: '洗衣店各项收入统计',
        path: '/goodsAmountCount'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dataCount.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_dataCount = ({
  name: 'dataCount',
  components: {},
  data: function data() {
    return {
      list: [{
        title: '洗衣店普通商品统计',
        path: '/goodsCount'
      }, {
        title: '洗衣店团购商品统计',
        path: '/goodsGroupCount'
      }, {
        title: '洗衣店各项收入统计',
        path: '/goodsAmountCount'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdb60e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dataCount.vue
var dataCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-m-t-4 list-bg"},_vm._l((_vm.list),function(item,index){return _c('router-link',{key:index,staticClass:"cm-p-tb-16 cm-p-lr-16 cm-border-bottom-1 cm-flex-between cm-flex-middle",attrs:{"to":item.path}},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-color-666"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])}),1)])}
var dataCount_staticRenderFns = []
var dataCount_esExports = { render: dataCount_render, staticRenderFns: dataCount_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_dataCount = (dataCount_esExports);
// CONCATENATED MODULE: ./src/pages/dataCount.vue
function dataCount_injectStyle (ssrContext) {
  __webpack_require__("/Zto")
}
var dataCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dataCount___vue_template_functional__ = false
/* styles */
var dataCount___vue_styles__ = dataCount_injectStyle
/* scopeId */
var dataCount___vue_scopeId__ = "data-v-1cdb60e4"
/* moduleIdentifier (server only) */
var dataCount___vue_module_identifier__ = null
var dataCount_Component = dataCount_normalizeComponent(
  pages_dataCount,
  selectortype_template_index_0_src_pages_dataCount,
  dataCount___vue_template_functional__,
  dataCount___vue_styles__,
  dataCount___vue_scopeId__,
  dataCount___vue_module_identifier__
)

/* harmony default export */ var src_pages_dataCount = (dataCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsAmountCount.vue





/* harmony default export */ var pages_goodsAmountCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsAmountCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsAmountCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();
        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsAmountCount.vue





/* harmony default export */ var selectortype_script_index_0_src_pages_goodsAmountCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsAmountCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsAmountCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();
        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f14600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goodsAmountCount.vue
var goodsAmountCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16"},[_c('div',{staticClass:" cm-pf cm-bg-white",staticStyle:{"top":"0","left":"0","z-index":"100"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-8"},[_vm._v("至")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-p-lr-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getList}},[_c('p',{staticClass:"cm-color-white"},[_vm._v("确认")])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table cm-pa cm-p-t-12 cm-border-radius-4  shadow-gray cm-w-100 cm-bg-white",staticStyle:{"top":"105px","left":"0","z-index":"90"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.profit))])])}),_vm._v(" "),(_vm.blankShow)?_c('cmBlank'):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-blue cm-center cm-border-radius",staticStyle:{"z-index":"110","width":"56px","height":"56px","bottom":"65px","right":"15px"},on:{"click":function($event){return _vm.download()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("下载")])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var goodsAmountCount_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table cm-pf cm-bg-white",staticStyle:{"left":"0","top":"60px","z-index":"99"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("类别")]),_vm._v(" "),_c('p',[_vm._v("数量")]),_vm._v(" "),_c('p',[_vm._v("营业额")]),_vm._v(" "),_c('p',[_vm._v("收益")])])])}]
var goodsAmountCount_esExports = { render: goodsAmountCount_render, staticRenderFns: goodsAmountCount_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_goodsAmountCount = (goodsAmountCount_esExports);
// CONCATENATED MODULE: ./src/pages/goodsAmountCount.vue
function goodsAmountCount_injectStyle (ssrContext) {
  __webpack_require__("Uvid")
}
var goodsAmountCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var goodsAmountCount___vue_template_functional__ = false
/* styles */
var goodsAmountCount___vue_styles__ = goodsAmountCount_injectStyle
/* scopeId */
var goodsAmountCount___vue_scopeId__ = "data-v-92f14600"
/* moduleIdentifier (server only) */
var goodsAmountCount___vue_module_identifier__ = null
var goodsAmountCount_Component = goodsAmountCount_normalizeComponent(
  selectortype_script_index_0_src_pages_goodsAmountCount,
  selectortype_template_index_0_src_pages_goodsAmountCount,
  goodsAmountCount___vue_template_functional__,
  goodsAmountCount___vue_styles__,
  goodsAmountCount___vue_scopeId__,
  goodsAmountCount___vue_module_identifier__
)

/* harmony default export */ var src_pages_goodsAmountCount = (goodsAmountCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsGroupCount.vue





/* harmony default export */ var pages_goodsGroupCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      console.log('dateChange', e);
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    dateChange1: function dateChange1(e) {
      console.log('dateChange1', e);
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsGroupCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsGroupCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();
        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/goodsGroupCount.vue





/* harmony default export */ var selectortype_script_index_0_src_pages_goodsGroupCount = ({
  components: {
    Datetime: vux_src_components_datetime, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      blankShow: false,
      index: 0,
      dateStatus: false,
      startDate: '',
      endDate: '',
      list: []
    };
  },
  created: function created() {
    this.setDate();
    this.getList();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth() - 1);
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      console.log('dateChange', e);
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    dateChange1: function dateChange1(e) {
      console.log('dateChange1', e);
    },
    getList: function getList() {
      var _this = this;

      this.$func.startLoading();
      this.$api.goodsGroupCount({ end: this.endDate, start: this.startDate }).then(function (res) {
        if (res) {
          _this.$func.endLoading();
          _this.list = res.data;
          _this.blankShow = res.data.length > 0 ? false : true;
        }
      });
    },
    download: function download() {
      var _this2 = this;

      this.$func.startLoading();
      this.$api.goodsGroupCountExport({ end: this.endDate, start: this.startDate }).then(function (res) {
        _this2.$func.endLoading();
        window.open(res.data.path, '__self');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-890f431c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goodsGroupCount.vue
var goodsGroupCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16"},[_c('div',{staticClass:" cm-pf cm-bg-white",staticStyle:{"top":"0","left":"0","z-index":"100"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-8"},[_vm._v("至")]),_vm._v(" "),_c('p',{staticClass:"cm-bg-gray cm-p-tb-4 cm-p-lr-12",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-p-lr-32 cm-bg-green cm-border-radius-12",on:{"click":_vm.getList}},[_c('p',{staticClass:"cm-color-white"},[_vm._v("确认")])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table cm-pa cm-p-t-12 cm-border-radius-4  shadow-gray cm-w-100 cm-bg-white",staticStyle:{"top":"105px","left":"0","z-index":"90"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.profit))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.count))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.used))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v(_vm._s(item.unused))])])}),_vm._v(" "),(_vm.blankShow)?_c('cmBlank'):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-blue cm-center cm-border-radius",staticStyle:{"z-index":"110","width":"56px","height":"56px","bottom":"65px","right":"15px"},on:{"click":function($event){return _vm.download()}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("下载")])]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-confirm":_vm.dateChange1,"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}})],1)}
var goodsGroupCount_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table cm-pf cm-bg-white",staticStyle:{"left":"0","top":"60px","z-index":"99"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-8 cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("名称")]),_vm._v(" "),_c('p',[_vm._v("成交量")]),_vm._v(" "),_c('p',[_vm._v("营业额")]),_vm._v(" "),_c('p',[_vm._v("收益")]),_vm._v(" "),_c('p',[_vm._v("衣物数量")]),_vm._v(" "),_c('p',[_vm._v("已核销量")]),_vm._v(" "),_c('p',[_vm._v("未核销量")])])])}]
var goodsGroupCount_esExports = { render: goodsGroupCount_render, staticRenderFns: goodsGroupCount_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_goodsGroupCount = (goodsGroupCount_esExports);
// CONCATENATED MODULE: ./src/pages/goodsGroupCount.vue
function goodsGroupCount_injectStyle (ssrContext) {
  __webpack_require__("vOuF")
}
var goodsGroupCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var goodsGroupCount___vue_template_functional__ = false
/* styles */
var goodsGroupCount___vue_styles__ = goodsGroupCount_injectStyle
/* scopeId */
var goodsGroupCount___vue_scopeId__ = "data-v-890f431c"
/* moduleIdentifier (server only) */
var goodsGroupCount___vue_module_identifier__ = null
var goodsGroupCount_Component = goodsGroupCount_normalizeComponent(
  selectortype_script_index_0_src_pages_goodsGroupCount,
  selectortype_template_index_0_src_pages_goodsGroupCount,
  goodsGroupCount___vue_template_functional__,
  goodsGroupCount___vue_styles__,
  goodsGroupCount___vue_scopeId__,
  goodsGroupCount___vue_module_identifier__
)

/* harmony default export */ var src_pages_goodsGroupCount = (goodsGroupCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawCleanRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var withdrawCleanRecord = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            height: '100%',
            isActive: 1,
            checkAllStatus: 0,
            checkAllWithdraw: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            types: [{
                'key': 0,
                'text': '提现记录'
            }, {
                'key': 1,
                'text': '可提现订单'
            }],
            info: {
                wait_withdraw: 0.00,
                total_withdraw: 0.00
            },
            moneyMax: 5000
            // countMoney:0
        };
    },
    mounted: function mounted() {
        // this.getList();
        this.withdrawMoney();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.list = [];
            this.where = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.money = (Number(this.money) - Number(this.list[i].money)).toFixed(2);
                this.list[i].checked = 0;
            } else {
                if (Number(this.money) + Number(this.list[i].money) <= this.moneyMax) {
                    this.list[i].checked = 1;
                    this.money = (Number(this.money) + Number(this.list[i].money)).toFixed(2);
                } else {
                    this.$func.showToast('单笔最高可提现 ' + this.moneyMax + ' 元');
                    return false;
                }
            }
        },

        // countMoney(){
        //     let that = this;
        //     this.money = 0;
        //     if(this.checkAllStatus){
        //         this.money = this.info.wait_withdraw;
        //     }else{
        //         that.list.forEach((item,index)=>{
        //             if(item.checked && Number(item.status) == 1){
        //                 that.money = (Number(that.money) + Number(item.money)).toFixed(2);
        //             }
        //         })
        //     }
        // },
        checkAll: function checkAll() {
            var _this = this;

            this.checkAllStatus = !this.checkAllStatus;
            this.money = 0;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    if (Number(_this.money) + Number(item.money) <= _this.moneyMax) {
                        item.checked = 1;
                        _this.money = (Number(_this.money) + Number(item.money)).toFixed(2);
                    } else {
                        item.checked = 0;
                    }
                });
                // this.money = this.info.wait_withdraw;
                // this.money = money;
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
            }
            // this.countMoney();
        },
        getList: function getList() {
            var _this2 = this;

            var that = this;
            // this.loadmoreText = '正在加载。。。';
            switch (parseInt(that.isActive)) {
                case 1:
                    this.$api.withdrawList({ last_id: this.lastId, page_flag: this.pageFlag, type: 2 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                if (_this2.checkAllWithdraw) {
                                    item.checked = 1;
                                } else {
                                    if (_this2.checkAllStatus) {
                                        if (Number(_this2.money) + Number(item.money) <= _this2.moneyMax) {
                                            _this2.money = (Number(_this2.money) + Number(item.money)).toFixed(2);
                                            item.checked = 1;
                                        }
                                    }
                                }
                                _this2.list.push(item);
                            });
                            // this.checkAllStatus = false;
                        }
                    });
                    break;
                default:
                    this.$api.withdrawRecord({ last_id: this.lastId, page_flag: this.pageFlag, type: 2 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        withdrawMoney: function withdrawMoney() {
            var _this3 = this;

            this.$api.withdrawMoney({ type: 2 }).then(function (res) {
                if (res) {
                    _this3.info = res.data;
                }
            });
        },
        allWithdraw: function allWithdraw() {
            if (this.info.wait_withdraw <= this.moneyMax) {
                this.money = this.info.wait_withdraw;
                this.checkAllWithdraw = 1;
                this.checkAllStatus = 1;
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
            } else {
                this.$func.showToast('可提现金额大于单次提现限额，请手动选择提现订单');
            }
        },
        withdraw: function withdraw() {
            if (this.money <= 0) {
                this.$func.showToast('请选择提现订单');
                return false;
            }
            if (this.money > this.moneyMax) {
                this.$func.showToast('单次提现限额' + this.moneyMax + '元');
                return false;
            }
            var ids = '';
            if (this.money != this.info.wait_withdraw) {
                this.list.forEach(function (item, index) {
                    if (item.checked && Number(item.status) == 1) {
                        ids += item.id + ',';
                    }
                });
            }
            // if(!this.checkAllStatus){

            // }
            // if(!ids){
            //     this.$func.showToast('请选择提现订单');
            //     return false;
            // }
            this.$router.push({ path: '/withdraw', query: { ids: ids, type: 2 } });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/withdrawCleanRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_withdrawCleanRecord = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            blankShow: false,
            height: '100%',
            isActive: 1,
            checkAllStatus: 0,
            checkAllWithdraw: 0,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            grade: 0,
            money: 0,
            types: [{
                'key': 0,
                'text': '提现记录'
            }, {
                'key': 1,
                'text': '可提现订单'
            }],
            info: {
                wait_withdraw: 0.00,
                total_withdraw: 0.00
            },
            moneyMax: 5000
            // countMoney:0
        };
    },
    mounted: function mounted() {
        // this.getList();
        this.withdrawMoney();
    },

    methods: {
        select: function select(i) {
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.list = [];
            this.where = [];
            this.getList();
        },
        check: function check(i) {
            if (this.list[i].checked > 0) {
                this.money = (Number(this.money) - Number(this.list[i].money)).toFixed(2);
                this.list[i].checked = 0;
            } else {
                if (Number(this.money) + Number(this.list[i].money) <= this.moneyMax) {
                    this.list[i].checked = 1;
                    this.money = (Number(this.money) + Number(this.list[i].money)).toFixed(2);
                } else {
                    this.$func.showToast('单笔最高可提现 ' + this.moneyMax + ' 元');
                    return false;
                }
            }
        },

        // countMoney(){
        //     let that = this;
        //     this.money = 0;
        //     if(this.checkAllStatus){
        //         this.money = this.info.wait_withdraw;
        //     }else{
        //         that.list.forEach((item,index)=>{
        //             if(item.checked && Number(item.status) == 1){
        //                 that.money = (Number(that.money) + Number(item.money)).toFixed(2);
        //             }
        //         })
        //     }
        // },
        checkAll: function checkAll() {
            var _this = this;

            this.checkAllStatus = !this.checkAllStatus;
            this.money = 0;
            if (this.checkAllStatus) {
                this.list.forEach(function (item, index) {
                    if (Number(_this.money) + Number(item.money) <= _this.moneyMax) {
                        item.checked = 1;
                        _this.money = (Number(_this.money) + Number(item.money)).toFixed(2);
                    } else {
                        item.checked = 0;
                    }
                });
                // this.money = this.info.wait_withdraw;
                // this.money = money;
            } else {
                this.list.forEach(function (item, index) {
                    item.checked = 0;
                });
            }
            // this.countMoney();
        },
        getList: function getList() {
            var _this2 = this;

            var that = this;
            // this.loadmoreText = '正在加载。。。';
            switch (parseInt(that.isActive)) {
                case 1:
                    this.$api.withdrawList({ last_id: this.lastId, page_flag: this.pageFlag, type: 2 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                if (_this2.checkAllWithdraw) {
                                    item.checked = 1;
                                } else {
                                    if (_this2.checkAllStatus) {
                                        if (Number(_this2.money) + Number(item.money) <= _this2.moneyMax) {
                                            _this2.money = (Number(_this2.money) + Number(item.money)).toFixed(2);
                                            item.checked = 1;
                                        }
                                    }
                                }
                                _this2.list.push(item);
                            });
                            // this.checkAllStatus = false;
                        }
                    });
                    break;
                default:
                    this.$api.withdrawRecord({ last_id: this.lastId, page_flag: this.pageFlag, type: 2 }).then(function (res) {
                        if (res) {
                            if (!_this2.lastId) {
                                _this2.blankShow = res.data.length > 0 ? false : true;
                            }
                            _this2.hasNext = res.hasNext;
                            _this2.lastId = res.lastId;
                            res.data.forEach(function (item) {
                                _this2.list.push(item);
                            });
                        }
                    });
                    break;
            }
        },
        withdrawMoney: function withdrawMoney() {
            var _this3 = this;

            this.$api.withdrawMoney({ type: 2 }).then(function (res) {
                if (res) {
                    _this3.info = res.data;
                }
            });
        },
        allWithdraw: function allWithdraw() {
            if (this.info.wait_withdraw <= this.moneyMax) {
                this.money = this.info.wait_withdraw;
                this.checkAllWithdraw = 1;
                this.checkAllStatus = 1;
                this.list.forEach(function (item, index) {
                    item.checked = 1;
                });
            } else {
                this.$func.showToast('可提现金额大于单次提现限额，请手动选择提现订单');
            }
        },
        withdraw: function withdraw() {
            if (this.money <= 0) {
                this.$func.showToast('请选择提现订单');
                return false;
            }
            if (this.money > this.moneyMax) {
                this.$func.showToast('单次提现限额' + this.moneyMax + '元');
                return false;
            }
            var ids = '';
            if (this.money != this.info.wait_withdraw) {
                this.list.forEach(function (item, index) {
                    if (item.checked && Number(item.status) == 1) {
                        ids += item.id + ',';
                    }
                });
            }
            // if(!this.checkAllStatus){

            // }
            // if(!ids){
            //     this.$func.showToast('请选择提现订单');
            //     return false;
            // }
            this.$router.push({ path: '/withdraw', query: { ids: ids, type: 2 } });
        },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41731b0d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/withdrawCleanRecord.vue
var withdrawCleanRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"cm-bg-white cm-border-radius-6 cm-p-tb-16 cm-pf",staticStyle:{"height":"154px","top":"0","z-index":"100"}},[_c('div',{staticClass:" cm-flex-between cm-flex-middle cm-p-lr-16"},[_c('div',[_c('p',{staticClass:"cm-fn-12 cm-fn-weight-min cm-color-666"},[_vm._v("提现金额")]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-10 cm-fn-36 cm-color-red"},[_vm._v(_vm._s(_vm.money))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-yellow ",staticStyle:{"border-radius":"16px"},on:{"click":_vm.checkAll}},[_vm._v(_vm._s(_vm.checkAllStatus ? '全不选' : '全选'))]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-6 cm-p-lr-20 cm-color-white cm-bg-red cm-m-l-16",staticStyle:{"border-radius":"16px"},on:{"click":function($event){return _vm.withdraw()}}},[_vm._v("提现")])])]),_vm._v(" "),_c('div',{staticClass:" cm-flex-middle cm-flex-between cm-p-lr-16"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("可提现")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-m-l-8"},[_vm._v("￥"+_vm._s(_vm.info.wait_withdraw))]),_vm._v(" "),(_vm.info.wait_withdraw <= _vm.moneyMax)?_c('p',{staticClass:"cm-color-blue cm-m-l-4",on:{"click":function($event){return _vm.allWithdraw()}}},[_vm._v("全部提现")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("累计提现")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-color-green cm-m-l-8"},[_vm._v("￥"+_vm._s(_vm.info.total_withdraw))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-p-lr-16"},[_c('p',{staticClass:"cm-fn-14 cm-fn-weight-min cm-color-666"},[_vm._v("单次提现限额 "),_c('span',{staticClass:"cm-fn-18 cm-color-red"},[_vm._v(_vm._s(_vm.moneyMax))]),_vm._v(" 元")])]),_vm._v(" "),_c('ul',{staticClass:"cm-p-tb-8 cm-flex-middle cm-flex-around",staticStyle:{"border-bottom":"1px solid #eee","height":"27px"}},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-fn-16 cm-color-666",class:[_vm.isActive == index ? 'active' : ''],on:{"click":function($event){return _vm.select(index)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank',{staticClass:"cm-m-t-40",attrs:{"blankStyle":_vm.height}}):_vm._e(),_vm._v(" "),(!_vm.isActive)?_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"50"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-p-tb-8 cm-flex-middle cm-flex-between cm-bg-white cm-m-t-4 cm-p-lr-12"},[_c('div',[_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-fn-weight-min cm-fn-12 cm-color-txt2"},[_vm._v(" "+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-fn-20  cm-color-orange"},[_vm._v("￥"+_vm._s(item.money))])])}),0):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-8 cm-bg-white cm-flex-middle cm-flex-start",on:{"click":function($event){return _vm.check(index)}}},[_c('div',{staticClass:"cm-p-tb-16 cm-center",staticStyle:{"width":"8%"}},[_c('img',{staticClass:"cm-icon-22 cm-m-l-8",attrs:{"src":item.checked ? '/static/images/checkbox-checked.png' : '/static/images/checkbox-disabled.png'}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"89%"}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1 cm-p-lr-12"},[_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-block"},[_vm._v(_vm._s(item.order.order_no)+" ")]),_vm._v(" "),(item.factory_wash_code)?_c('p',{staticClass:"cm-color-block cm-fn-12  cm-fn-weight-default"},[_vm._v(_vm._s(item.factory_wash_code))]):_vm._e()]),_vm._v(" "),(item.order_type > 0)?_c('p',{staticClass:" cm-center cm-color-blue"},[_vm._v("社区订单")]):_c('p',{staticClass:" cm-center cm-color-green"},[_vm._v("菜鸟订单")])]),_vm._v(" "),(item.order_type > 0)?_c('div',[(item.goods.length > 1)?_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-16 cm-p-lr-12"},_vm._l((item.goods),function(val,key){return (key < 4)?_c('div',{key:key,staticClass:"image cm-img-box  cm-m-l-8"},[_c('img',{attrs:{"src":val.goods.pic}})]):_vm._e()}),0):_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('div',{staticClass:"image cm-img-box cm-center"},[_c('img',{attrs:{"src":item.goods[0].goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"info cm-m-l-16"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.goods[0].goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-red"},[_vm._v("￥"+_vm._s(item.goods[0].price))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.goods[0].num))])])])]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-flex-start"},[_c('p',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.taocan))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("×"+_vm._s(item.order.shuliang))])])])]),_vm._v(" "),(item.order_type > 0)?_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-12 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('p',{staticClass:"cm-color-666 cm-m-l-4 cm-center cm-m-r-12"},[_vm._v("实付：￥"+_vm._s(item.order.amount))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])]):_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-12 cm-p-lr-4 cm-border-top-1"},[_c('p',{staticClass:"cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-p-lr-2 cm-color-red cm-border-radius-2",staticStyle:{"border":"1px solid #FE5448"}},[_vm._v(_vm._s(item.reward_title)+"："+_vm._s(item.money))])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var withdrawCleanRecord_staticRenderFns = []
var withdrawCleanRecord_esExports = { render: withdrawCleanRecord_render, staticRenderFns: withdrawCleanRecord_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_withdrawCleanRecord = (withdrawCleanRecord_esExports);
// CONCATENATED MODULE: ./src/pages/withdrawCleanRecord.vue
function withdrawCleanRecord_injectStyle (ssrContext) {
  __webpack_require__("y15j")
}
var withdrawCleanRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var withdrawCleanRecord___vue_template_functional__ = false
/* styles */
var withdrawCleanRecord___vue_styles__ = withdrawCleanRecord_injectStyle
/* scopeId */
var withdrawCleanRecord___vue_scopeId__ = "data-v-41731b0d"
/* moduleIdentifier (server only) */
var withdrawCleanRecord___vue_module_identifier__ = null
var withdrawCleanRecord_Component = withdrawCleanRecord_normalizeComponent(
  pages_withdrawCleanRecord,
  selectortype_template_index_0_src_pages_withdrawCleanRecord,
  withdrawCleanRecord___vue_template_functional__,
  withdrawCleanRecord___vue_styles__,
  withdrawCleanRecord___vue_scopeId__,
  withdrawCleanRecord___vue_module_identifier__
)

/* harmony default export */ var src_pages_withdrawCleanRecord = (withdrawCleanRecord_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordPhoneList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var recordPhoneList = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },

    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: []
        };
    },
    created: function created() {
        this.phone = this.$route.query.phone || '';
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchOrder: function searchOrder(orderNo) {
            this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
        },
        resetSearch: function resetSearch() {
            this.phone = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
            this.searchPop = false;
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
            this.searchPop = false;
        },
        getList: function getList() {
            var _this = this;

            if (!this.phone) {
                return false;
            }
            this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, type: 2, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recordPhoneList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_recordPhoneList = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },

    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: []
        };
    },
    created: function created() {
        this.phone = this.$route.query.phone || '';
    },
    amount: function amount() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchOrder: function searchOrder(orderNo) {
            this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
        },
        resetSearch: function resetSearch() {
            this.phone = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
            this.searchPop = false;
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
            this.searchPop = false;
        },
        getList: function getList() {
            var _this = this;

            if (!this.phone) {
                return false;
            }
            this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, type: 2, phone: this.phone }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169c76f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recordPhoneList.vue
var recordPhoneList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-12 cm-bg-white cm-m-tb-8 cm-m-lr-12 cm-w-100"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"请输入手机号或姓名查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.washing_code)}}},[_vm._v("复制")])]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left"},[_c('p',{staticClass:"cm-color-666 cm-fn-14"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:" cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),(item.up_num > 0)?_c('p',{staticClass:"cm-color-green "},[_vm._v("挂点："+_vm._s(item.up_num))]):_vm._e()]),_vm._v(" "),(item.order_no)?_c('p',{staticClass:"cm-color-666 "},[_vm._v(_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(item.order_no)}}},[_vm._v("查询")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var recordPhoneList_staticRenderFns = []
var recordPhoneList_esExports = { render: recordPhoneList_render, staticRenderFns: recordPhoneList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_recordPhoneList = (recordPhoneList_esExports);
// CONCATENATED MODULE: ./src/pages/recordPhoneList.vue
function recordPhoneList_injectStyle (ssrContext) {
  __webpack_require__("TdPp")
}
var recordPhoneList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recordPhoneList___vue_template_functional__ = false
/* styles */
var recordPhoneList___vue_styles__ = recordPhoneList_injectStyle
/* scopeId */
var recordPhoneList___vue_scopeId__ = "data-v-169c76f6"
/* moduleIdentifier (server only) */
var recordPhoneList___vue_module_identifier__ = null
var recordPhoneList_Component = recordPhoneList_normalizeComponent(
  pages_recordPhoneList,
  selectortype_template_index_0_src_pages_recordPhoneList,
  recordPhoneList___vue_template_functional__,
  recordPhoneList___vue_styles__,
  recordPhoneList___vue_scopeId__,
  recordPhoneList___vue_module_identifier__
)

/* harmony default export */ var src_pages_recordPhoneList = (recordPhoneList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var card = ({
  name: 'clean',
  components: {},
  data: function data() {
    return {
      type: 10,
      count: {
        all: 0,
        member: 0,
        wait: 0,
        expired: 0
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCountMember();
  },

  methods: {
    getCountMember: function getCountMember() {
      var _this = this;

      this.$api.getCountMember({}).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_card = ({
  name: 'clean',
  components: {},
  data: function data() {
    return {
      type: 10,
      count: {
        all: 0,
        member: 0,
        wait: 0,
        expired: 0
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCountMember();
  },

  methods: {
    getCountMember: function getCountMember() {
      var _this = this;

      this.$api.getCountMember({}).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b32f25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/card.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-red cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("会员服务")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-around cm-flex-middle"},[(_vm.$func.checkAuth('cardMember'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":"/cardMember/0"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("全部会员")]),_vm._v(" "),(_vm.count.all > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count.all))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('cardMember'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":"/cardMember/1"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("正常会员")]),_vm._v(" "),(_vm.count.member > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count.member))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('cardMember'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":"/cardMember/2"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status5.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("即将过期")]),_vm._v(" "),(_vm.count.wait)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count.wait))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-color-red cm-pa",staticStyle:{"font-size":"9px","bottom":"10px"}},[_vm._v("剩余一个月到期")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('cardMember'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20 cm-p-lr-12 cm-pr",staticStyle:{"width":"30%"},attrs:{"to":"/cardMember/3"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status5.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("已过期")]),_vm._v(" "),(_vm.count.expired)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count.expired))]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-36 cm-p-lr-16 cm-bg-white cm-p-b-40"},[(_vm.$func.checkAuth('order/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+9}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+10}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_card = (card_esExports);
// CONCATENATED MODULE: ./src/pages/card.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("JEav")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = "data-v-62b32f25"
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  pages_card,
  selectortype_template_index_0_src_pages_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var src_pages_card = (card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cardMember.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_cardMember = ({
    name: 'cardMember',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            title: '全部订单',
            isActive: 0,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            uid: '',
            pageFlag: 2,
            i: 0,
            hasNext: 0,
            lastId: 0,
            itemId: 0,
            list: []
        };
    },
    created: function created() {
        this.i = Number(this.$route.params.i);
        switch (this.i) {
            case 1:
                this.title = '即将过期';
                break;
            case 2:
                this.title = '已过期会员';
                break;
            default:
                this.title = '会员用户';
                break;
        }
    },
    amount: function amount() {},

    methods: {
        reset: function reset() {
            this.list = [];
            this.phone = '';
            this.uid = '';
            this.pageFlag = 2;
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        getList: function getList() {
            var _this = this;

            this.$api.cardMember({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, i: this.i, uid: this.uid }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cardMember.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_cardMember = ({
    name: 'cardMember',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            title: '全部订单',
            isActive: 0,
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            phone: '',
            uid: '',
            pageFlag: 2,
            i: 0,
            hasNext: 0,
            lastId: 0,
            itemId: 0,
            list: []
        };
    },
    created: function created() {
        this.i = Number(this.$route.params.i);
        switch (this.i) {
            case 1:
                this.title = '即将过期';
                break;
            case 2:
                this.title = '已过期会员';
                break;
            default:
                this.title = '会员用户';
                break;
        }
    },
    amount: function amount() {},

    methods: {
        reset: function reset() {
            this.list = [];
            this.phone = '';
            this.uid = '';
            this.pageFlag = 2;
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        getList: function getList() {
            var _this = this;

            this.$api.cardMember({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, i: this.i, uid: this.uid }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7f3fc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cardMember.vue
var cardMember_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"number","placeholder":"手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"cm-fn-18 cm-h-100  cm-color-gray cm-p-lr-4"},[_vm._v("|")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uid),expression:"uid"}],staticClass:"cm-fn-18 cm-h-100 cm-m-l-4",attrs:{"type":"number","placeholder":"用户UID"},domProps:{"value":(_vm.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('img',{staticClass:"cm-icon-20 cm-m-r-12",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.reset()}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-tb-12"},[_c('div',[_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default"},[_c('a',{attrs:{"href":'tel:'+item.user.phone}},[_vm._v(_vm._s(item.user.phone))]),_vm._v(" "+_vm._s(item.user.name)+" "),_c('span',{staticClass:"cm-icon-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（ID:"+_vm._s(item.uid)+"）")])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(item.card.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(item.card.price))])])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("过期时间："),_c('span',{staticClass:"cm-fn-14  cm-fn-weight-default cm-color-orange"},[_vm._v(_vm._s(item.deadline))])]),_vm._v(" "),(item.status_text)?_c('div',{staticClass:"cm-fn-14  cm-color-red cm-fn-weight-default"},[_vm._v(_vm._s(item.status_text))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.user.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.user.phone}},[_vm._v("联系客户")])]):_vm._e()])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var cardMember_staticRenderFns = []
var cardMember_esExports = { render: cardMember_render, staticRenderFns: cardMember_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_cardMember = (cardMember_esExports);
// CONCATENATED MODULE: ./src/pages/cardMember.vue
function cardMember_injectStyle (ssrContext) {
  __webpack_require__("S5Li")
}
var cardMember_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cardMember___vue_template_functional__ = false
/* styles */
var cardMember___vue_styles__ = cardMember_injectStyle
/* scopeId */
var cardMember___vue_scopeId__ = "data-v-7e7f3fc2"
/* moduleIdentifier (server only) */
var cardMember___vue_module_identifier__ = null
var cardMember_Component = cardMember_normalizeComponent(
  selectortype_script_index_0_src_pages_cardMember,
  selectortype_template_index_0_src_pages_cardMember,
  cardMember___vue_template_functional__,
  cardMember___vue_styles__,
  cardMember___vue_scopeId__,
  cardMember___vue_module_identifier__
)

/* harmony default export */ var src_pages_cardMember = (cardMember_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothesConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var clothesConfirm = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            code: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            type: 0,
            types: [{
                'key': 0,
                'text': '洗前通知'
            }, {
                'key': 1,
                'text': '风险确认'
            }],
            status: 0,
            statusArr: []
        };
    },
    mounted: function mounted() {
        this.config();
        var grade = this.$func.getLocal('grade');
        if (grade == 13 || grade == 9) {
            this.status = 1;
            this.statusArr = [{
                'key': 1,
                'text': '待审核'
            }, {
                'key': 2,
                'text': '待通知'
            }, {
                'key': 3,
                'text': '待确认'
            }, {
                'key': 4,
                'text': '已确认'
            }];
        } else {
            this.status = 3;
            this.statusArr = [{
                'key': 3,
                'text': '待确认'
            }, {
                'key': 4,
                'text': '已确认'
            }];
        }
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            // this.type = i;
            this.status = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        reset: function reset() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        getList: function getList() {
            var _this = this;

            this.$api.clothesConfirmList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code, type: this.type, status: this.status }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'clothesConfirmInfo', params: { id: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                            that.getList();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothesConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_clothesConfirm = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            code: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0,
            type: 0,
            types: [{
                'key': 0,
                'text': '洗前通知'
            }, {
                'key': 1,
                'text': '风险确认'
            }],
            status: 0,
            statusArr: []
        };
    },
    mounted: function mounted() {
        this.config();
        var grade = this.$func.getLocal('grade');
        if (grade == 13 || grade == 9) {
            this.status = 1;
            this.statusArr = [{
                'key': 1,
                'text': '待审核'
            }, {
                'key': 2,
                'text': '待通知'
            }, {
                'key': 3,
                'text': '待确认'
            }, {
                'key': 4,
                'text': '已确认'
            }];
        } else {
            this.status = 3;
            this.statusArr = [{
                'key': 3,
                'text': '待确认'
            }, {
                'key': 4,
                'text': '已确认'
            }];
        }
    },

    methods: {
        select: function select(i) {
            // this.where = [];
            // this.type = i;
            this.status = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        reset: function reset() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        barOrder: function barOrder(code) {
            this.$router.push({ name: 'barOrder', params: { code: code } });
        },
        getList: function getList() {
            var _this = this;

            this.$api.clothesConfirmList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code, type: this.type, status: this.status }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'clothesConfirmInfo', params: { id: id } });
        },
        loadmore: function loadmore() {
            var _this2 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this2.blankShow) {
                    _this2.busy = true;
                    _this2.loadStatus = false;
                    _this2.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this2.hasNext > 0) {
                        _this2.loadStatus = false;
                        _this2.busy = false;
                    } else {
                        _this2.busy = true;
                        _this2.loadStatus = true;
                        _this2.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.code = res.resultStr.split(',')[1];
                            that.getList();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a88a4b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clothesConfirm.vue
var clothesConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-bg-white  cm-p-tb-16  cm-p-lr-8 "},[_c('div',{staticClass:" cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"50px"}},[_vm._v("编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-flex-between cm-flex-middle",staticStyle:{"width":"68%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-16 cm-bg-gray cm-color-red  cm-p-tb-4 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物编码或扫码"},domProps:{"value":(_vm.code)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.reset}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('div',{staticClass:"nav cm-bg-white"},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.statusArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 cm-w-50",class:[_vm.status == item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.select(item.key)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.code)}}},[_vm._v(_vm._s(item.code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.info(item.id)}}},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型： "+_vm._s(item.cate_title)+_vm._s(item.clothe_title))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("加工工厂："+_vm._s(item.factory_title))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认内容："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知类型："),_c('span',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(item.type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知状态："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),(item.type > 0 && item.status == 4)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认结果："),(item.confirm_result > 1)?_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(item.confirm_result_text)+" ")]):_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.confirm_result_text))]),_c('span',{staticClass:"cm-fn-14 cm-m-l-14"},[_vm._v("（"+_vm._s(item.confirm_time)+")")])]):_vm._e()])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var clothesConfirm_staticRenderFns = []
var clothesConfirm_esExports = { render: clothesConfirm_render, staticRenderFns: clothesConfirm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clothesConfirm = (clothesConfirm_esExports);
// CONCATENATED MODULE: ./src/pages/clothesConfirm.vue
function clothesConfirm_injectStyle (ssrContext) {
  __webpack_require__("qMU2")
}
var clothesConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clothesConfirm___vue_template_functional__ = false
/* styles */
var clothesConfirm___vue_styles__ = clothesConfirm_injectStyle
/* scopeId */
var clothesConfirm___vue_scopeId__ = "data-v-2a88a4b7"
/* moduleIdentifier (server only) */
var clothesConfirm___vue_module_identifier__ = null
var clothesConfirm_Component = clothesConfirm_normalizeComponent(
  pages_clothesConfirm,
  selectortype_template_index_0_src_pages_clothesConfirm,
  clothesConfirm___vue_template_functional__,
  clothesConfirm___vue_styles__,
  clothesConfirm___vue_scopeId__,
  clothesConfirm___vue_module_identifier__
)

/* harmony default export */ var src_pages_clothesConfirm = (clothesConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothesConfirmInfo.vue





/* harmony default export */ var pages_clothesConfirmInfo = ({
  name: 'clothesConfirmInfo',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      id: 0,
      popBg: false,
      popContent: false,
      content: '',
      grade: 0,
      info: {
        pics_path: [],
        img_path: [],
        audios: []
      },
      currentIndex: 0,
      videoShow: false,
      srcAudio: '',
      srcAudioText: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.getOrder();
    }
  },

  methods: {
    editContent: function editContent() {
      this.content = this.info.content;
      this.popBg = true;
      this.popContent = true;
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      that.$func.startLoading();
      this.$api.clothesConfirmInfo({ id: this.id }).then(function (res) {
        if (res) {
          that.info = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit(e) {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        that.$api.submitClothesConfirm({ id: that.id, result: e }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.getOrder();
          }
        });
      });
    },
    submitPush: function submitPush() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认通知门店？', '提示', function () {
        that.$api.submitClothesConfirmPush({ id: that.id }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.getOrder();
          }
        });
      });
    },
    submitContent: function submitContent() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        that.$api.submitClothesConfirmContent({ id: that.id, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.closePop();
            that.getOrder();
          }
        });
      });
    },
    startPlaying: function startPlaying(i) {
      this.currentIndex = i;
      this.popBg = true;
      this.videoShow = true;
      this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
      this.srcAudioText = this.currentIndex + 1 + '、' + this.srcAudio.substr(this.srcAudio.lastIndexOf('/') + 1, 20);
      this.playAudio();
    },
    playAudio: function playAudio() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        var media = document.getElementById("musicBox");
        media.src = that.srcAudio;
        media.play();
      });
    },
    playNextAudio: function playNextAudio() {
      this.currentIndex++;
      if (this.currentIndex < this.info.audios_path.length) {
        this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
        this.srcAudioText = this.currentIndex + 1 + '、' + this.srcAudio.substr(this.srcAudio.lastIndexOf('/') + 1, 20);

        this.playAudio();
      } else {

        this.srcAudioText = '';
        this.closePop();
        console.log('All audios finished playing');
      }
    },
    closePop: function closePop() {
      this.videoShow = false;
      this.popBg = false;
      this.popContent = false;
      weixin_js_sdk_default.a.ready(function () {
        var media = document.getElementById("musicBox");
        media.pause();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothesConfirmInfo.vue





/* harmony default export */ var selectortype_script_index_0_src_pages_clothesConfirmInfo = ({
  name: 'clothesConfirmInfo',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      id: 0,
      popBg: false,
      popContent: false,
      content: '',
      grade: 0,
      info: {
        pics_path: [],
        img_path: [],
        audios: []
      },
      currentIndex: 0,
      videoShow: false,
      srcAudio: '',
      srcAudioText: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.getOrder();
    }
  },

  methods: {
    editContent: function editContent() {
      this.content = this.info.content;
      this.popBg = true;
      this.popContent = true;
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls
      });
    },
    getOrder: function getOrder() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      that.$func.startLoading();
      this.$api.clothesConfirmInfo({ id: this.id }).then(function (res) {
        if (res) {
          that.info = res.data;
          that.$func.endLoading();
        }
      });
    },
    submit: function submit(e) {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        that.$api.submitClothesConfirm({ id: that.id, result: e }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.getOrder();
          }
        });
      });
    },
    submitPush: function submitPush() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认通知门店？', '提示', function () {
        that.$api.submitClothesConfirmPush({ id: that.id }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.getOrder();
          }
        });
      });
    },
    submitContent: function submitContent() {
      var that = this;
      if (!this.id) {
        that.$func.showToast('数据错误，请确认后再试');
        return;
      }
      this.$func.confirm('确认提交？', '提示', function () {
        that.$api.submitClothesConfirmContent({ id: that.id, content: that.content }).then(function (res) {
          if (res) {
            that.$func.showToast('已提交');
            that.closePop();
            that.getOrder();
          }
        });
      });
    },
    startPlaying: function startPlaying(i) {
      this.currentIndex = i;
      this.popBg = true;
      this.videoShow = true;
      this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
      this.srcAudioText = this.currentIndex + 1 + '、' + this.srcAudio.substr(this.srcAudio.lastIndexOf('/') + 1, 20);
      this.playAudio();
    },
    playAudio: function playAudio() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        var media = document.getElementById("musicBox");
        media.src = that.srcAudio;
        media.play();
      });
    },
    playNextAudio: function playNextAudio() {
      this.currentIndex++;
      if (this.currentIndex < this.info.audios_path.length) {
        this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
        this.srcAudioText = this.currentIndex + 1 + '、' + this.srcAudio.substr(this.srcAudio.lastIndexOf('/') + 1, 20);

        this.playAudio();
      } else {

        this.srcAudioText = '';
        this.closePop();
        console.log('All audios finished playing');
      }
    },
    closePop: function closePop() {
      this.videoShow = false;
      this.popBg = false;
      this.popContent = false;
      weixin_js_sdk_default.a.ready(function () {
        var media = document.getElementById("musicBox");
        media.pause();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dce6bd76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clothesConfirmInfo.vue
var clothesConfirmInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(_vm.info.code)}}},[_vm._v(_vm._s(_vm.info.code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.info.code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型： "+_vm._s(_vm.info.cate_title)+_vm._s(_vm.info.clothe_title))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(_vm.info.color)+"|"+_vm._s(_vm.info.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单图片："),_c('span',{staticClass:"cm-color-blue",on:{"click":function($event){return _vm.showPic(_vm.info.img_path)}}},[_vm._v("点击查看")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("送洗时间："),_c('span',{},[_vm._v(_vm._s(_vm.info.record_create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("当前状态："),_c('span',{staticClass:"cm-color-yellow cm-fn-weight-default"},[_vm._v(_vm._s(_vm.info.state_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.info.name)+" "+_vm._s(_vm.info.phone)+" ")]),(_vm.info.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.info.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("订单编号："),_c('span',{staticClass:"cm-color-blue cm-fn-14",on:{"click":function($event){return _vm.searchOrder(_vm.info.order_no)}}},[_vm._v(_vm._s(_vm.info.order_no))]),(_vm.info.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.info.order_no)}}},[_vm._v("复制")]):_vm._e(),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(_vm.info.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("加工工厂："+_vm._s(_vm.info.factory_title))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认名称："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.info.title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("备注内容："+_vm._s(_vm.info.content)),(_vm.$func.checkAuth('clothes_confirm_edit_content') && _vm.info.status < 4)?_c('img',{staticClass:"cm-icon-20 cm-m-l-16",attrs:{"src":"/static/images/edit@2x.png"},on:{"click":function($event){return _vm.editContent()}}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知类型："),_c('span',{staticClass:"cm-color-blue"},[_vm._v(_vm._s(_vm.info.type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知时间："+_vm._s(_vm.info.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("通知状态："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.info.status_text))])]),_vm._v(" "),(_vm.info.type > 0 && _vm.info.status == 4)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认结果："),(_vm.info.confirm_result > 1)?_c('span',{staticClass:"cm-color-red"},[_vm._v(_vm._s(_vm.info.confirm_result_text))]):_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(_vm.info.confirm_result_text))])]):_vm._e(),_vm._v(" "),(_vm.info.confirm_result > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认时间："+_vm._s(_vm.info.confirm_time))]):_vm._e(),_vm._v(" "),(_vm.info.confirm_result > 0)?_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("确认账号："+_vm._s(_vm.info.store_account))]):_vm._e()]),_vm._v(" "),(_vm.$func.checkAuth('community_push') && _vm.info.status == 1)?_c('div',{staticClass:"cm-p-tb-24 cm-flex-middle cm-flex-around cm-w-100"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.submitPush()}}},[_vm._v("通知门店")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('submit_clothes_confirm') && _vm.info.type > 0 && _vm.info.status < 4)?_c('div',{staticClass:"cm-p-tb-24 cm-flex-middle cm-flex-around cm-w-100"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-red cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.submit(2)}}},[_vm._v("不洗退回")]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.submit(1)}}},[_vm._v("正常洗")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("录音文件")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-8 cm-p-lr-8 cm-bg-white"},_vm._l((_vm.info.audios),function(item,index){return _c('div',{key:index,staticClass:"cm-p-tb-8 border-b cm-flex-between cm-flex-middle"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item))]),_vm._v(" "),_c('p',{staticClass:"cm-color-blue  cm-m-l-4",on:{"click":function($event){return _vm.startPlaying(index)}}},[_vm._v("播放")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("确认图")]),_vm._v(" "),_vm._l((_vm.info.pics_path),function(item,index){return _c('div',{key:index,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:"cm-img-box",on:{"click":function($event){return _vm.showPic(_vm.info.pics_path,item)}}},[_c('img',{attrs:{"src":item}})])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.popContent)?_c('div',{staticClass:"pop-bg1 cm-border-radius-10 cm-p-tb-16"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-12  cm-bg-white cm-center"},[_c('x-textarea',{staticClass:"cm-border cm-fn-16 cm-w-100",attrs:{"max":500,"placeholder":'请输入退洗原因 500字以内（选填）',"height":120},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-16 cm-flex-middle cm-flex-around cm-w-100 "},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-ccc cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){_vm.popBg = false}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-16 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.submitContent()}}},[_vm._v("提交")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoShow),expression:"videoShow"}],staticClass:"cm-bg-white shadow-gray cm-pa cm-text-center",staticStyle:{"width":"90%","height":"150px","top":"25%","left":"5%","z-index":"102"}},[_c('div',{staticClass:"cm-center cm-m-t-16",staticStyle:{"height":"70%"}},[_c('audio',{attrs:{"id":"musicBox","preload":"metadata","controls":"","autoplay":false},on:{"ended":_vm.playNextAudio}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-12px"}},[_vm._v("当前播放: "+_vm._s(_vm.srcAudioText))])])])}
var clothesConfirmInfo_staticRenderFns = []
var clothesConfirmInfo_esExports = { render: clothesConfirmInfo_render, staticRenderFns: clothesConfirmInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clothesConfirmInfo = (clothesConfirmInfo_esExports);
// CONCATENATED MODULE: ./src/pages/clothesConfirmInfo.vue
function clothesConfirmInfo_injectStyle (ssrContext) {
  __webpack_require__("rZq6")
}
var clothesConfirmInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clothesConfirmInfo___vue_template_functional__ = false
/* styles */
var clothesConfirmInfo___vue_styles__ = clothesConfirmInfo_injectStyle
/* scopeId */
var clothesConfirmInfo___vue_scopeId__ = "data-v-dce6bd76"
/* moduleIdentifier (server only) */
var clothesConfirmInfo___vue_module_identifier__ = null
var clothesConfirmInfo_Component = clothesConfirmInfo_normalizeComponent(
  selectortype_script_index_0_src_pages_clothesConfirmInfo,
  selectortype_template_index_0_src_pages_clothesConfirmInfo,
  clothesConfirmInfo___vue_template_functional__,
  clothesConfirmInfo___vue_styles__,
  clothesConfirmInfo___vue_scopeId__,
  clothesConfirmInfo___vue_module_identifier__
)

/* harmony default export */ var src_pages_clothesConfirmInfo = (clothesConfirmInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/douYinVerify.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_douYinVerify = ({
  name: 'douYinVerify',
  components: {},
  data: function data() {
    return {
      // shortUrl:'https://v.douyin.com/i5xgngo9/',
      shortUrl: '',
      code: '',
      name: '',
      phone: '',
      status: false,
      order: { goods: [] },
      storeId: 0,
      storeList: []
    };
  },
  created: function created() {
    this.sign();
    //  this.getOrder();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              if (res.resultStr.indexOf(",") != -1) {
                that.shortUrl = res.resultStr.split(',')[1];
              } else {
                that.shortUrl = res.resultStr;
              }
              that.getOrder();
            }, 500);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      var that = this;
      if (!this.code && !that.shortUrl) {
        that.$func.showToast('请输入核销码或扫码');
        return;
      }
      this.$func.startLoading();
      this.$api.getDouYinOrderNew({ code: this.code, shortUrl: this.shortUrl }).then(function (res) {
        if (res) {
          _this.order = res.data;
          _this.storeList = res.data.store_list || [];
          _this.storeId = res.data.store_id || (_this.storeList[0] ? _this.storeList[0].id : 0);
          _this.status = true;
          _this.$func.endLoading();
          console.log(_this.order);
        }
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit: function submit() {
      var that = this;
      if (this.order.goods.length <= 0) {
        that.$func.showToast('请输入核销码或扫码');
        return false;
      }
      if (!this.name || !this.phone) {
        that.$func.showToast('请输入用户姓名和电话');
        return false;
      }
      that.$func.confirm('确认核销？', '提示', function () {
        that.$func.startLoading();
        that.$api.douYinVerifyNew({ goods: stringify_default()(that.order.goods), name: that.name, phone: that.phone, cid: that.storeId || 0 }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            setTimeout(function () {
              that.code = '';
              that.shortUrl = '';
              that.name = '';
              that.phone = '';
              that.order = { goods: [] };
              that.storeId = 0;
              that.storeList = [];
              that.status = false;
              that.$func.showToast('核销成功');
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/douYinVerify.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_pages_douYinVerify = ({
  name: 'douYinVerify',
  components: {},
  data: function data() {
    return {
      // shortUrl:'https://v.douyin.com/i5xgngo9/',
      shortUrl: '',
      code: '',
      name: '',
      phone: '',
      status: false,
      order: { goods: [] },
      storeId: 0,
      storeList: []
    };
  },
  created: function created() {
    this.sign();
    //  this.getOrder();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted: function mounted() {
    // this.id = Number(this.$route.params.id);
    // this.changePop();

  },

  methods: {
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"],
          success: function success(res) {
            setTimeout(function () {
              if (res.resultStr.indexOf(",") != -1) {
                that.shortUrl = res.resultStr.split(',')[1];
              } else {
                that.shortUrl = res.resultStr;
              }
              that.getOrder();
            }, 500);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    getOrder: function getOrder() {
      var _this = this;

      var that = this;
      if (!this.code && !that.shortUrl) {
        that.$func.showToast('请输入核销码或扫码');
        return;
      }
      this.$func.startLoading();
      this.$api.getDouYinOrderNew({ code: this.code, shortUrl: this.shortUrl }).then(function (res) {
        if (res) {
          _this.order = res.data;
          _this.storeList = res.data.store_list || [];
          _this.storeId = res.data.store_id || (_this.storeList[0] ? _this.storeList[0].id : 0);
          _this.status = true;
          _this.$func.endLoading();
          console.log(_this.order);
        }
      });
    },
    sign: function sign() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        weixin_js_sdk_default.a.config({
          debug: res.data.debug, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit: function submit() {
      var that = this;
      if (this.order.goods.length <= 0) {
        that.$func.showToast('请输入核销码或扫码');
        return false;
      }
      if (!this.name || !this.phone) {
        that.$func.showToast('请输入用户姓名和电话');
        return false;
      }
      that.$func.confirm('确认核销？', '提示', function () {
        that.$func.startLoading();
        that.$api.douYinVerifyNew({ goods: stringify_default()(that.order.goods), name: that.name, phone: that.phone, cid: that.storeId || 0 }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            setTimeout(function () {
              that.code = '';
              that.shortUrl = '';
              that.name = '';
              that.phone = '';
              that.order = { goods: [] };
              that.storeId = 0;
              that.storeList = [];
              that.status = false;
              that.$func.showToast('核销成功');
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca94f0b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/douYinVerify.vue
var douYinVerify_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-white cm-p-t-16"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray  cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("核销码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"请输入核销码或扫码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1 cm-p-lr-16 cm-m-t-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("商品信息")]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("共"),_c('span',{staticClass:"cm-color-red cm-fn-20 cm-m-l-4 cm-m-r-4"},[_vm._v(" "+_vm._s(_vm.order.number)+" ")]),_vm._v("件")])]),_vm._v(" "),_vm._l((_vm.order.goods),function(item,index){return _c('div',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(item.title)+" ")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("×"+_vm._s(item.num))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(item.amount))])])})],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8  cm-p-lr-16 cm-m-t-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入用户姓名"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入用户手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),(_vm.storeList.length > 1)?_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("核销门店")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.storeId),expression:"storeId"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100 store-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.storeId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.storeList),function(item){return _c('option',{key:item.id,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-12",staticStyle:{"height":"50px"}},[_c('div',{staticClass:"cm-w-100 cm-h-100 cm-center cm-m-t-16"},[_c('div',{staticClass:" cm-border-radius-8 cm-center ",class:_vm.status ? 'cm-bg-red' : 'cm-bg-gray',staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default ",class:_vm.status ? 'cm-color-white' : 'cm-color-666'},[_vm._v("提交核销")])])])])])}
var douYinVerify_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('div',{staticClass:"cm-fn-16 cm-fn-bold"},[_vm._v("用户信息")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"cm-fn-16"},[_vm._v("姓名"),_c('span',{staticClass:"cm-color-red cm-fn-16"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"cm-fn-16"},[_vm._v("手机号"),_c('span',{staticClass:"cm-color-red cm-fn-16"},[_vm._v("*")])])}]
var douYinVerify_esExports = { render: douYinVerify_render, staticRenderFns: douYinVerify_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_douYinVerify = (douYinVerify_esExports);
// CONCATENATED MODULE: ./src/pages/douYinVerify.vue
function douYinVerify_injectStyle (ssrContext) {
  __webpack_require__("j9Kl")
}
var douYinVerify_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var douYinVerify___vue_template_functional__ = false
/* styles */
var douYinVerify___vue_styles__ = douYinVerify_injectStyle
/* scopeId */
var douYinVerify___vue_scopeId__ = "data-v-ca94f0b8"
/* moduleIdentifier (server only) */
var douYinVerify___vue_module_identifier__ = null
var douYinVerify_Component = douYinVerify_normalizeComponent(
  selectortype_script_index_0_src_pages_douYinVerify,
  selectortype_template_index_0_src_pages_douYinVerify,
  douYinVerify___vue_template_functional__,
  douYinVerify___vue_styles__,
  douYinVerify___vue_scopeId__,
  douYinVerify___vue_module_identifier__
)

/* harmony default export */ var src_pages_douYinVerify = (douYinVerify_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/washBagCode.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var washBagCode = ({
  name: 'qrCoupon',
  components: {},
  data: function data() {
    return {
      popUp: false,
      popUp1: false,
      popUp2: false,
      qrcode: '',
      code: '',
      codeOld: '',
      washCode: '',
      qrText: '',
      part: '',
      list: [],
      number: '',
      info: {}
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },

  methods: {
    generateQRCode: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(text) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$func.createQrCode(text, this.$refs.qrcodeCanvas);

              case 2:
                this.qrText = text;
                this.popUp = true;
                this.popUp1 = true;
                console.log('二维码生成完成');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateQRCode(_x) {
        return _ref.apply(this, arguments);
      }

      return generateQRCode;
    }(),
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this.$router.push({ path: '/login' });
            return false;
          }
          _this.info = res.data;
          _this.code = _this.info.bag_code;
        }
      });
    },
    submit: function submit() {
      this.codeOld = this.code;
      var str = this.code.substr(0, 1);
      var part = this.code.substr(1, 10);
      var len = part.length;
      var i = 0;
      var bagCode = '';
      this.list = [];
      while (i <= this.number) {
        bagCode = (Number(part) + i).toString();
        bagCode = str + '' + bagCode.padStart(len, '0');
        if (i < this.number) {
          this.list.push(bagCode);
        }
        i++;
      }
      this.code = bagCode;
      this.washCode = bagCode;
      this.editWashCode();
      console.log('list', this.list);
    },
    export1: function export1() {
      var _this2 = this;

      if (this.number <= 0) {
        this.$func.showToast('请输入生成数量');
        return false;
      }
      this.$func.startLoading('导出中...');
      this.$api.exportWashCode({ code: this.codeOld, number: this.number }).then(function (res) {
        if (res) {
          _this2.$func.endLoading();
          var path = res.data.path;
          _this2.$func.downloadFile(path, res.data.fileName);
          _this2.$func.showToast('导出成功');
        }
      });
    },
    editWashCode: function editWashCode() {
      var _this3 = this;

      if (!this.washCode) {
        this.$func.showToast('请输入洗衣码');
        return false;
      }
      var str = this.washCode.substr(0, 1);
      var code = str != this.part ? this.part + '' + this.washCode : this.washCode;
      this.$api.editWashCode({ code: code }).then(function (res) {
        if (res) {
          _this3.code = code;
          // this.$func.showToast('修改成功');
          _this3.closePop();
        }
      });
    },
    closePop: function closePop() {
      this.popUp = false;
      this.popUp1 = false;
      this.popUp2 = false;
    },
    editBag: function editBag() {
      this.part = this.code.substr(0, 1);
      this.washCode = this.code.substr(1, 10);
      this.popUp = true;
      this.popUp2 = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/washBagCode.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_washBagCode = ({
  name: 'qrCoupon',
  components: {},
  data: function data() {
    return {
      popUp: false,
      popUp1: false,
      popUp2: false,
      qrcode: '',
      code: '',
      codeOld: '',
      washCode: '',
      qrText: '',
      part: '',
      list: [],
      number: '',
      info: {}
    };
  },
  created: function created() {
    if (this.$func.getLocal('token')) {
      this.getInfo();
    } else {
      this.$router.push({ path: '/login' });
    }
  },

  methods: {
    generateQRCode: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(text) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$func.createQrCode(text, this.$refs.qrcodeCanvas);

              case 2:
                this.qrText = text;
                this.popUp = true;
                this.popUp1 = true;
                console.log('二维码生成完成');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateQRCode(_x) {
        return _ref.apply(this, arguments);
      }

      return generateQRCode;
    }(),
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          if (!Number(res.data.cid)) {
            _this.$router.push({ path: '/login' });
            return false;
          }
          _this.info = res.data;
          _this.code = _this.info.bag_code;
        }
      });
    },
    submit: function submit() {
      this.codeOld = this.code;
      var str = this.code.substr(0, 1);
      var part = this.code.substr(1, 10);
      var len = part.length;
      var i = 0;
      var bagCode = '';
      this.list = [];
      while (i <= this.number) {
        bagCode = (Number(part) + i).toString();
        bagCode = str + '' + bagCode.padStart(len, '0');
        if (i < this.number) {
          this.list.push(bagCode);
        }
        i++;
      }
      this.code = bagCode;
      this.washCode = bagCode;
      this.editWashCode();
      console.log('list', this.list);
    },
    export1: function export1() {
      var _this2 = this;

      if (this.number <= 0) {
        this.$func.showToast('请输入生成数量');
        return false;
      }
      this.$func.startLoading('导出中...');
      this.$api.exportWashCode({ code: this.codeOld, number: this.number }).then(function (res) {
        if (res) {
          _this2.$func.endLoading();
          var path = res.data.path;
          _this2.$func.downloadFile(path, res.data.fileName);
          _this2.$func.showToast('导出成功');
        }
      });
    },
    editWashCode: function editWashCode() {
      var _this3 = this;

      if (!this.washCode) {
        this.$func.showToast('请输入洗衣码');
        return false;
      }
      var str = this.washCode.substr(0, 1);
      var code = str != this.part ? this.part + '' + this.washCode : this.washCode;
      this.$api.editWashCode({ code: code }).then(function (res) {
        if (res) {
          _this3.code = code;
          // this.$func.showToast('修改成功');
          _this3.closePop();
        }
      });
    },
    closePop: function closePop() {
      this.popUp = false;
      this.popUp1 = false;
      this.popUp2 = false;
    },
    editBag: function editBag() {
      this.part = this.code.substr(0, 1);
      this.washCode = this.code.substr(1, 10);
      this.popUp = true;
      this.popUp2 = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80ccaa0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/washBagCode.vue
var washBagCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-p-tb-16 cm-p-lr-12 cm-bg-white "},[_c('div',{staticClass:"cm-p-tb-12 shadow-gray cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-4 cm-flex-start cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("当前送洗码")]),_vm._v(" "),_c('p',{staticClass:"cm-m-l-12"},[_c('span',{staticClass:"cm-color-red cm-fn-22 cm-p-lr-4"},[_vm._v(_vm._s(_vm.code))])]),_vm._v(" "),_c('img',{staticClass:"cm-icon-24 cm-m-l-8",attrs:{"src":"/static/images/edit@2x.png"},on:{"click":function($event){return _vm.editBag()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-flex-start cm-flex-middle cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("生成数量")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"cm-fn-16 cm-m-l-12 cm-color-orange",staticStyle:{"width":"60%"},attrs:{"type":"number","placeholder":"请输入(最多100个)","maxlength":"3","max":"100","min":"1"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-flex-middle cm-flex-between cm-m-t-16",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-blue cm-border-radius-8 cm-center",staticStyle:{"width":"48%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("开始生成")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-border-radius-8 cm-center",staticStyle:{"width":"48%","height":"100%"},on:{"click":function($event){return _vm.export1()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("导出")])])])]),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"cm-p-lr-16 cm-m-t-12"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"cm-p-tb-12 cm-flex-between cm-flex-middle cm-border-bottom-1",on:{"click":function($event){return _vm.generateQRCode(item)}}},[_c('div',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(item))]),_vm._v(" "),_c('div',{staticClass:"cm-color-blue"},[_vm._v("二维码")])])}),0):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",style:({opacity: !_vm.popUp1 ? '0.5' : '1'}),on:{"click":_vm.closePop}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp1),expression:"popUp1"}],staticClass:"popup cm-bg-white cm-border-radius-10 cm-text-center cm-p-tb-32 cm-img-box"},[_c('canvas',{ref:"qrcodeCanvas"}),_vm._v(" "),(_vm.qrText)?_c('p',{staticClass:"cm-fn-24 cm-color-333 cm-m-t-16"},[_vm._v(" "+_vm._s(_vm.qrText))]):_vm._e()]),_vm._v(" "),(_vm.popUp2)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("修改当前送洗码")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('p',{staticClass:"cm-color-orange cm-fn-22"},[_vm._v(_vm._s(_vm.part))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.washCode),expression:"washCode"}],staticClass:"cm-fn-22 cm-m-lr-4 cm-p-tb-4 cm-h-100 cm-color-orange cm-bg-gray cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"150px","height":"40px"},attrs:{"type":"text","maxlength":"10","minlength":"6"},domProps:{"value":(_vm.washCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.washCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-flex-around cm-flex-middle cm-m-t-16"},[_c('div',{staticClass:"cm-bg-blue cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.editWashCode()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("提交")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])])])]):_vm._e()])}
var washBagCode_staticRenderFns = []
var washBagCode_esExports = { render: washBagCode_render, staticRenderFns: washBagCode_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_washBagCode = (washBagCode_esExports);
// CONCATENATED MODULE: ./src/pages/washBagCode.vue
function washBagCode_injectStyle (ssrContext) {
  __webpack_require__("l76H")
}
var washBagCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var washBagCode___vue_template_functional__ = false
/* styles */
var washBagCode___vue_styles__ = washBagCode_injectStyle
/* scopeId */
var washBagCode___vue_scopeId__ = "data-v-80ccaa0c"
/* moduleIdentifier (server only) */
var washBagCode___vue_module_identifier__ = null
var washBagCode_Component = washBagCode_normalizeComponent(
  pages_washBagCode,
  selectortype_template_index_0_src_pages_washBagCode,
  washBagCode___vue_template_functional__,
  washBagCode___vue_styles__,
  washBagCode___vue_scopeId__,
  washBagCode___vue_module_identifier__
)

/* harmony default export */ var src_pages_washBagCode = (washBagCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/washHome.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var washHome = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, deliveryWay: 1, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/washHome.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_washHome = ({
  name: 'wash',
  components: {},
  data: function data() {
    return {
      type: 1,
      count: []
    };
  },
  created: function created() {
    this.getOrderCount();
  },
  mounted: function mounted() {},

  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$api.getOrderCount({ type: this.type, deliveryWay: 1, store_scope: 1 }).then(function (res) {
        _this.count = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25cadd78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/washHome.vue
var washHome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-red cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("上门收衣服务")])]),_vm._v(" "),(_vm.$func.checkAuth('wash'))?_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle cm-flex-wrap"},[(_vm.$func.checkAuth('order/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16  cm-pr row-div",attrs:{"to":'/order/'+_vm.type+'/'+2+'/1'}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status1.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("待上门收衣")]),_vm._v(" "),(_vm.count[2] > 0)?_c('div',{staticClass:"badge",staticStyle:{"right":"26px"}},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('wareHouse'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 row-div",attrs:{"to":"/wareHouse"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status5.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣入库")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('outHouse'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 row-div",attrs:{"to":"/outHouse"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/status6.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣出库")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('barOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 row-div",attrs:{"to":"/barOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/bar.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("条码查询")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('searchOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 row-div",attrs:{"to":"/searchOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/searchOrder.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("订单查询")])]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" cm-p-lr-16 cm-bg-white cm-p-b-40",staticStyle:{"margin-top":"140px"}},[(_vm.$func.checkAuth('order/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+0+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("全部订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[0] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[0]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+3+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待司机取衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+4+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送工厂")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/5'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+5+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("洗涤中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[5] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[5]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+6+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待送回")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[6] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[6]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/7'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+7+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待入库")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[7] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[7]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/8'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+8+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待上门送衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[8] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[8]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/9'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+9+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已完成")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('order/10'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/order/'+_vm.type+'/'+10+'/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已取消")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1)])}
var washHome_staticRenderFns = []
var washHome_esExports = { render: washHome_render, staticRenderFns: washHome_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_washHome = (washHome_esExports);
// CONCATENATED MODULE: ./src/pages/washHome.vue
function washHome_injectStyle (ssrContext) {
  __webpack_require__("OOHY")
}
var washHome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var washHome___vue_template_functional__ = false
/* styles */
var washHome___vue_styles__ = washHome_injectStyle
/* scopeId */
var washHome___vue_scopeId__ = "data-v-25cadd78"
/* moduleIdentifier (server only) */
var washHome___vue_module_identifier__ = null
var washHome_Component = washHome_normalizeComponent(
  pages_washHome,
  selectortype_template_index_0_src_pages_washHome,
  washHome___vue_template_functional__,
  washHome___vue_styles__,
  washHome___vue_scopeId__,
  washHome___vue_module_identifier__
)

/* harmony default export */ var src_pages_washHome = (washHome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/boxList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var boxList = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            code: '',
            qrcode: '',
            qrcodeCode: '',
            qrcodeShow: false
        };
    },
    created: function created() {
        this.config();
    },
    amount: function amount() {
        this.code = '';
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getBoxList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        scanQRCode: function scanQRCode(key) {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['qrCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            var m = (res.resultStr || '').match(/(\d+)(?!.*\d)/);
                            var code = m ? m[1] : '';
                            if (key > 0) {
                                that.bindBox(code);
                            } else {
                                that.code = code;
                                that.search();
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        bindBox: function bindBox(code) {
            var _this2 = this;

            this.$api.bindBox({ code: code }).then(function (res) {
                if (res) {
                    _this2.resetSearch();
                }
            });
        },
        unbindBox: function unbindBox(id) {
            var _this3 = this;

            this.$func.confirm('确认解绑？', '提示', function () {
                _this3.$api.unbindBox({ id: id }).then(function (res) {
                    if (res) {
                        _this3.resetSearch();
                    }
                });
            });
        },
        qrcodeBox: function qrcodeBox(code) {
            var _this4 = this;

            this.$api.qrcodeBox({ code: code }).then(function (res) {
                if (res) {
                    _this4.qrcode = res.data.qrcode;
                    _this4.qrcodeCode = res.data.code;
                    _this4.qrcodeShow = true;
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this5 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this5.blankShow) {
                    _this5.busy = true;
                    _this5.loadStatus = false;
                    _this5.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this5.hasNext > 0) {
                        _this5.loadStatus = false;
                        _this5.busy = false;
                    } else {
                        _this5.busy = true;
                        _this5.loadStatus = true;
                        _this5.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/boxList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_boxList = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            code: '',
            qrcode: '',
            qrcodeCode: '',
            qrcodeShow: false
        };
    },
    created: function created() {
        this.config();
    },
    amount: function amount() {
        this.code = '';
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getBoxList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        scanQRCode: function scanQRCode(key) {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['qrCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            var m = (res.resultStr || '').match(/(\d+)(?!.*\d)/);
                            var code = m ? m[1] : '';
                            if (key > 0) {
                                that.bindBox(code);
                            } else {
                                that.code = code;
                                that.search();
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        bindBox: function bindBox(code) {
            var _this2 = this;

            this.$api.bindBox({ code: code }).then(function (res) {
                if (res) {
                    _this2.resetSearch();
                }
            });
        },
        unbindBox: function unbindBox(id) {
            var _this3 = this;

            this.$func.confirm('确认解绑？', '提示', function () {
                _this3.$api.unbindBox({ id: id }).then(function (res) {
                    if (res) {
                        _this3.resetSearch();
                    }
                });
            });
        },
        qrcodeBox: function qrcodeBox(code) {
            var _this4 = this;

            this.$api.qrcodeBox({ code: code }).then(function (res) {
                if (res) {
                    _this4.qrcode = res.data.qrcode;
                    _this4.qrcodeCode = res.data.code;
                    _this4.qrcodeShow = true;
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this5 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this5.blankShow) {
                    _this5.busy = true;
                    _this5.loadStatus = false;
                    _this5.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this5.hasNext > 0) {
                        _this5.loadStatus = false;
                        _this5.busy = false;
                    } else {
                        _this5.busy = true;
                        _this5.loadStatus = true;
                        _this5.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0421b96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/boxList.vue
var boxList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.box_code)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.box_code)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8"},[_c('div',{staticClass:"cm-border cm-bg-orange cm-m-r-12 cm-color-white cm-p-lr-16 cm-p-tb-8 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.unbindBox(item.id)}}},[_vm._v("\n                        解绑\n                      ")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.qrcodeBox(item.box_code)}}},[_vm._v("\n                        去小程序解锁\n                      ")])])])}),0),_vm._v(" "),(_vm.qrcodeShow)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('span',[_vm._v("小程序码")]),_vm._v(" "),_c('span',{staticClass:"modal-close",on:{"click":function($event){_vm.qrcodeShow = false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.qrcode)?_c('div',{staticClass:"modal-image"},[_c('img',{attrs:{"src":_vm.qrcode,"alt":""}})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-m-t-8 cm-color-333 cm-center"},[_vm._v(_vm._s(_vm.qrcodeCode))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-m-t-8 cm-color-red cm-center"},[_vm._v("长按识别小程序码跳转至小程序")])])])])]):_vm._e(),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-text-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){return _vm.scanQRCode(1)}}},[_c('p',{staticClass:"cm-fn-12 cm-m-t-8 cm-color-white"},[_vm._v("添加")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-white"},[_vm._v("魔盒")])])])}
var boxList_staticRenderFns = []
var boxList_esExports = { render: boxList_render, staticRenderFns: boxList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_boxList = (boxList_esExports);
// CONCATENATED MODULE: ./src/pages/boxList.vue
function boxList_injectStyle (ssrContext) {
  __webpack_require__("S5PC")
}
var boxList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var boxList___vue_template_functional__ = false
/* styles */
var boxList___vue_styles__ = boxList_injectStyle
/* scopeId */
var boxList___vue_scopeId__ = "data-v-d0421b96"
/* moduleIdentifier (server only) */
var boxList___vue_module_identifier__ = null
var boxList_Component = boxList_normalizeComponent(
  pages_boxList,
  selectortype_template_index_0_src_pages_boxList,
  boxList___vue_template_functional__,
  boxList___vue_styles__,
  boxList___vue_scopeId__,
  boxList___vue_module_identifier__
)

/* harmony default export */ var src_pages_boxList = (boxList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/douyinOrder.vue












/* harmony default export */ var douyinOrder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  data: function data() {
    return {
      title: '全部订单',
      diffPop: false,
      popBg: false,
      grade: 0,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 1,
      amount: '',
      id: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {

    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ uid: 2325, type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    openDiffPop: function openDiffPop(id) {
      this.diffPop = true;
      this.popBg = true;
      this.id = id;
    },
    closePop: function closePop() {
      this.diffPop = false;
      this.popBg = false;
    },
    diffPay: function diffPay() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入补差价金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.diffPrice({ amount: this.amount, id: this.id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.id = 0;
            that.closePop();
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/douyinOrder.vue












/* harmony default export */ var pages_douyinOrder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  data: function data() {
    return {
      title: '全部订单',
      diffPop: false,
      popBg: false,
      grade: 0,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: 1,
      amount: '',
      id: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {

    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ uid: 2325, type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    openDiffPop: function openDiffPop(id) {
      this.diffPop = true;
      this.popBg = true;
      this.id = id;
    },
    closePop: function closePop() {
      this.diffPop = false;
      this.popBg = false;
    },
    diffPay: function diffPay() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入补差价金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.diffPrice({ amount: this.amount, id: this.id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.id = 0;
            that.closePop();
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c215fa3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/douyinOrder.vue
var douyinOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main",class:[_vm.popBg ? 'noscroll' : '' ]},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"订单号后四位|手机号|姓名|昵称"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[(_vm.type == 2)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 7)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)),_c('span',{staticClass:"cm-fn-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("订单金额："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.amount))])]),_vm._v(" "),(item.diff_price > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("补差价："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.diff_price))])]):_vm._e()])]),_vm._v(" "),(item.worker_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_c('a',{attrs:{"href":'tel:'+item.worker.phone}},[_vm._v(_vm._s(item.worker.phone))]),_vm._v(" "+_vm._s(item.worker.name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),0),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && _vm.$func.checkAuth('status/2'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,3)}}},[_vm._v("接单")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('status/3'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showOperater(item.id)}}},[_vm._v("分配")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('status/4'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('status/5'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[_vm._v("开始服务")]):_vm._e(),_vm._v(" "),(item.status == 5 && item.problem == 0 && _vm.$func.checkAuth('problem'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.problem(item.id)}}},[_vm._v("问题上报")]):_vm._e(),_vm._v(" "),(item.status == 6 && _vm.$func.checkAuth('status/6'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,7)}}},[_vm._v("服务完成")]):_vm._e(),_vm._v(" "),(item.status == 9 && _vm.$func.checkAuth('status/9'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center  cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id)}}},[_vm._v("查看评价")]):_vm._e(),_vm._v(" "),(item.status < 5 && _vm.$func.checkAuth('contact'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]):_vm._e()]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-m-t-16 cm-flex-middle"},[(item.status == 2 || item.status == 8)?_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 "},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-m-t-16  cm-flex-middle "},[(item.status == 8)?_c('div',{staticClass:"cm-fn-14  cm-fn-weight-default cm-color-white cm-p-tb-4 cm-p-lr-12 cm-bg-orange cm-border-radius-4",on:{"click":function($event){return _vm.changeStatus(item.id,9)}}},[_vm._v("确认取件")]):(item.out_time)?_c('div',{staticClass:"cm-fn-14  cm-color-red cm-fn-weight-default"},[_vm._v("超时："+_vm._s(item.out_time))]):_vm._e()])]),_vm._v(" "),(item.phone)?_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)+" "),_c('span',{staticClass:"cm-fn-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('span',{staticClass:"cm-fn-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),(_vm.grade == 10 || _vm.grade == 2)?_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("站点信息："+_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(item.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("配送方式："+_vm._s(item.delivery_way_text))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.collect_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("收衣时间："+_vm._s(item.collect_time))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.special_title)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("会员卡特权："+_vm._s(item.special_title))]):_vm._e()]),_vm._v(" "),((item.status == 8 || item.status == 2) && item.uupt)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("跑男信息")]),_vm._v(" "),(item.uupt.driver_name)?_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('img',{staticClass:"cm-icon-30",attrs:{"src":item.uupt.driver_photo,"lazy-load":true}}),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-l-12"},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("跑男姓名："+_vm._s(item.uupt.driver_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("跑男电话："),_c('a',{staticClass:"cm-color-666",attrs:{"href":'tel:'+item.uupt.driver_mobile}},[_vm._v(_vm._s(item.uu_order.driver_mobile))])])])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-8"},[_vm._v("跑男抢单中。。。")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[(item.status > 7 && item.sms_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("取件码：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.sms_code))])]):(item.bag_code)?_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]):_vm._e(),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && item.delivery_way > 0 )?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_vm._v("已收衣")]):_vm._e(),_vm._v(" "),(item.status == 4 && item.mobile_record > 0 )?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.record(item.order_no)}}},[_vm._v("衣物录单")]):_vm._e(),_vm._v(" "),(item.status > 1 && item.status < 9)?_c('div',{staticClass:"cm-bg-orange  cm-border cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.openDiffPop(item.id)}}},[_vm._v("补差价")]):_vm._e(),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]),_vm._v(" "),(item.status == 8 && item.channel == 1)?_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-8 button"},[(item.uu_order.length <= 0)?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white",on:{"click":function($event){return _vm.uuptOrder(item.id)}}},[_vm._v("\n                          呼叫跑腿配送\n                          ")]):_vm._e(),_vm._v(" "),(item.uu_order.status > 0 && item.uu_order.status <= 3)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.cancelUuptOrder(item.id)}}},[_vm._v("\n                          取消跑腿配送\n                          ")]):_vm._e()]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择服务师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,4)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.worker,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,4)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCommentStatus),callback:function ($$v) {_vm.showCommentStatus=$$v},expression:"showCommentStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-tb-12"},_vm._l((_vm.comment.pics_path),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.src},on:{"click":function($event){return _vm.show(index)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14 cm-m-r-16"},[_vm._v("综合评分")]),_vm._v(" "),_vm._l((Number(_vm.comment.star)),function(k,k3){return _c('img',{key:k3+'a',staticClass:"cm-icon-22 cm-m-r-8",attrs:{"src":"/static/images/started@2x.png"}})}),_vm._v(" "),_vm._l((Number(_vm.comment.star1)),function(n,k4){return _c('img',{key:k4+'b',staticClass:"cm-icon-20 cm-m-r-8",attrs:{"src":"/static/images/start@2x.png"}})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-red cm-m-l-16"},[_vm._v(_vm._s(_vm.comment.star_text))])],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-border-bottom-1"},[_vm._v("\n                          "+_vm._s(_vm.comment.content)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-16  cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("评价时间")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(_vm.comment.create_time))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCommentStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),(_vm.showCommentStatus)?_c('previewer',{ref:"previewer",attrs:{"list":_vm.comment.pics_path,"options":_vm.options}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.diffPop)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入补差价金额")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('p',{staticClass:"cm-color-orange cm-fn-22"},[_vm._v("￥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"cm-fn-22 cm-m-lr-4 cm-p-tb-4 cm-h-100 cm-color-orange cm-bg-gray cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"100px","height":"40px"},attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.diffPay()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认支付")])])])]):_vm._e()])}
var douyinOrder_staticRenderFns = []
var douyinOrder_esExports = { render: douyinOrder_render, staticRenderFns: douyinOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_douyinOrder = (douyinOrder_esExports);
// CONCATENATED MODULE: ./src/pages/douyinOrder.vue
function douyinOrder_injectStyle (ssrContext) {
  __webpack_require__("Ayo6")
}
var douyinOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var douyinOrder___vue_template_functional__ = false
/* styles */
var douyinOrder___vue_styles__ = douyinOrder_injectStyle
/* scopeId */
var douyinOrder___vue_scopeId__ = "data-v-3c215fa3"
/* moduleIdentifier (server only) */
var douyinOrder___vue_module_identifier__ = null
var douyinOrder_Component = douyinOrder_normalizeComponent(
  pages_douyinOrder,
  selectortype_template_index_0_src_pages_douyinOrder,
  douyinOrder___vue_template_functional__,
  douyinOrder___vue_styles__,
  douyinOrder___vue_scopeId__,
  douyinOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_douyinOrder = (douyinOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickList.vue













/* harmony default export */ var pages_pickList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      loading: false,
      endDate: '',
      startDate: '',
      dateKey: 0,
      keyword: '',
      name: '',
      phone: '',
      strip_code: '',
      index: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: []
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    resetPage: function resetPage() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.pageFlag = 2;
      this.blankShow = false;
      this.busy = false;
      this.loading = false;
      this.loadStatus = false;
    },
    appendList: function appendList(rows) {
      var _this = this;

      var idMap = {};
      this.list.forEach(function (item) {
        idMap[item.id] = true;
      });
      rows.forEach(function (item) {
        if (!idMap[item.id]) {
          _this.list.push(item);
          idMap[item.id] = true;
        }
      });
    },
    search: function search() {
      this.resetPage();
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.strip_code = '';
      this.keyword = '';
      this.startDate = '';
      this.endDate = '';
      this.dateStatus = false;
      this.dateKey++;
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
      this.dateKey++;
    },
    getList: function getList() {
      var _this2 = this;

      var params = { last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, start: this.startDate, end: this.endDate, name: this.name, phone: this.phone, strip_code: this.strip_code };
      if (/^2\d{9}$/.test(this.keyword)) {
        params.strip_code = this.keyword;
        params.keyword = '';
      }
      this.$api.pickList(params).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          _this2.appendList(res.data);
        }
      }).finally(function () {
        _this2.loading = false;
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      });
    },
    barOrder: function barOrder(item) {
      var code = item.factory_wash_code || item.washing_code;
      if (!code) {
        this.$func.showToast('衣物条码无效');
        return;
      }
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.keyword = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      if (this.loading) {
        return;
      }
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loading = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickList.vue













/* harmony default export */ var selectortype_script_index_0_src_pages_pickList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      loading: false,
      endDate: '',
      startDate: '',
      dateKey: 0,
      keyword: '',
      name: '',
      phone: '',
      strip_code: '',
      index: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: []
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    resetPage: function resetPage() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.pageFlag = 2;
      this.blankShow = false;
      this.busy = false;
      this.loading = false;
      this.loadStatus = false;
    },
    appendList: function appendList(rows) {
      var _this = this;

      var idMap = {};
      this.list.forEach(function (item) {
        idMap[item.id] = true;
      });
      rows.forEach(function (item) {
        if (!idMap[item.id]) {
          _this.list.push(item);
          idMap[item.id] = true;
        }
      });
    },
    search: function search() {
      this.resetPage();
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.strip_code = '';
      this.keyword = '';
      this.startDate = '';
      this.endDate = '';
      this.dateStatus = false;
      this.dateKey++;
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
      this.dateKey++;
    },
    getList: function getList() {
      var _this2 = this;

      var params = { last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, start: this.startDate, end: this.endDate, name: this.name, phone: this.phone, strip_code: this.strip_code };
      if (/^2\d{9}$/.test(this.keyword)) {
        params.strip_code = this.keyword;
        params.keyword = '';
      }
      this.$api.pickList(params).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          _this2.appendList(res.data);
        }
      }).finally(function () {
        _this2.loading = false;
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      });
    },
    barOrder: function barOrder(item) {
      var code = item.factory_wash_code || item.washing_code;
      if (!code) {
        this.$func.showToast('衣物条码无效');
        return;
      }
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.keyword = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      if (this.loading) {
        return;
      }
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loading = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158ea09b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickList.vue
var pickList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码|手机号|姓名|灯条编码"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),(_vm.keyword)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:item.id || index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_vm._v("复制")])]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("录单时间："+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("送洗工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_vm._e(),_vm._v(" "),(item.clothe_title)?_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("上挂时间："),_c('span',{staticClass:"cm-fn-333 cm-fn-12"},[_vm._v(_vm._s(item.up_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("取衣时间："),_c('span',{staticClass:"cm-fn-333 cm-fn-12"},[_vm._v(_vm._s(item.pick_time))])])]),_vm._v(" "),(item.history_strip_code || item.pick_strip_code || item.strip_code)?_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("历史灯条编码："),_c('span',{staticClass:"cm-color-green cm-fn-500"},[_vm._v(_vm._s(item.history_strip_code || item.pick_strip_code || item.strip_code))])])]):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){_vm.searchPop = true}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("查询")])]),_vm._v(" "),_c('datetime',{key:'date-' + _vm.dateKey,staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"left","width":"80%"},model:{value:(_vm.searchPop),callback:function ($$v) {_vm.searchPop=$$v},expression:"searchPop"}},[_c('div',{staticClass:"cm-p-lr-16"},[_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("手机号")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("历史灯条编码")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strip_code),expression:"strip_code"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"请输入历史灯条编码"},domProps:{"value":(_vm.strip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.strip_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("取衣时间")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-p-tb-4 cm-flex-between cm-flex-middle cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.startDate)?_c('p',{staticClass:"cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v("请选择")])]),_vm._v(" "),_c('p',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.endDate)?_c('p',{staticClass:" cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v("请选择")])])])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-pa cm-center cm-border-top-1",staticStyle:{"bottom":"0","left":"0"}},[_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18 cm-bg-white cm-center",on:{"click":_vm.resetSearch}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18  cm-color-white cm-bg-green cm-center",on:{"click":_vm.searchSubmit}},[_vm._v("确定")])])])],1)],1)}
var pickList_staticRenderFns = []
var pickList_esExports = { render: pickList_render, staticRenderFns: pickList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickList = (pickList_esExports);
// CONCATENATED MODULE: ./src/pages/pickList.vue
function pickList_injectStyle (ssrContext) {
  __webpack_require__("6qHd")
}
var pickList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickList___vue_template_functional__ = false
/* styles */
var pickList___vue_styles__ = pickList_injectStyle
/* scopeId */
var pickList___vue_scopeId__ = "data-v-158ea09b"
/* moduleIdentifier (server only) */
var pickList___vue_module_identifier__ = null
var pickList_Component = pickList_normalizeComponent(
  selectortype_script_index_0_src_pages_pickList,
  selectortype_template_index_0_src_pages_pickList,
  pickList___vue_template_functional__,
  pickList___vue_styles__,
  pickList___vue_scopeId__,
  pickList___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickList = (pickList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upList.vue













/* harmony default export */ var pages_upList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      loading: false,
      endDate: '',
      startDate: '',
      dateKey: 0,
      keyword: '',
      name: '',
      phone: '',
      index: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: []
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    resetPage: function resetPage() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.pageFlag = 2;
      this.blankShow = false;
      this.busy = false;
      this.loading = false;
      this.loadStatus = false;
    },
    appendList: function appendList(rows) {
      var _this = this;

      var idMap = {};
      this.list.forEach(function (item) {
        idMap[item.id] = true;
      });
      rows.forEach(function (item) {
        if (!idMap[item.id]) {
          _this.list.push(item);
          idMap[item.id] = true;
        }
      });
    },
    search: function search() {
      this.resetPage();
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.keyword = '';
      this.startDate = '';
      this.endDate = '';
      this.dateStatus = false;
      this.dateKey++;
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
      this.dateKey++;
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.upList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, up_start: this.startDate, up_end: this.endDate, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          _this2.appendList(res.data);
        }
      }).finally(function () {
        _this2.loading = false;
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      });
    },
    barOrder: function barOrder(item) {
      var code = item.factory_wash_code || item.washing_code;
      if (!code) {
        this.$func.showToast('衣物条码无效');
        return;
      }
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.keyword = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      if (this.loading) {
        return;
      }
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loading = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/upList.vue













/* harmony default export */ var selectortype_script_index_0_src_pages_upList = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      loading: false,
      endDate: '',
      startDate: '',
      dateKey: 0,
      keyword: '',
      name: '',
      phone: '',
      index: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: []
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    resetPage: function resetPage() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.pageFlag = 2;
      this.blankShow = false;
      this.busy = false;
      this.loading = false;
      this.loadStatus = false;
    },
    appendList: function appendList(rows) {
      var _this = this;

      var idMap = {};
      this.list.forEach(function (item) {
        idMap[item.id] = true;
      });
      rows.forEach(function (item) {
        if (!idMap[item.id]) {
          _this.list.push(item);
          idMap[item.id] = true;
        }
      });
    },
    search: function search() {
      this.resetPage();
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.keyword = '';
      this.startDate = '';
      this.endDate = '';
      this.dateStatus = false;
      this.dateKey++;
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.resetPage();
      this.loadmore();
      this.searchPop = false;
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
      this.dateKey++;
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.upList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, up_start: this.startDate, up_end: this.endDate, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          _this2.appendList(res.data);
        }
      }).finally(function () {
        _this2.loading = false;
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      });
    },
    barOrder: function barOrder(item) {
      var code = item.factory_wash_code || item.washing_code;
      if (!code) {
        this.$func.showToast('衣物条码无效');
        return;
      }
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.keyword = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      if (this.loading) {
        return;
      }
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loading = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55de8794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/upList.vue
var upList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码|手机号|姓名"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),(_vm.keyword)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:item.id || index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_vm._v("复制")])]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("录单时间："+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("送洗工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_vm._e(),_vm._v(" "),(item.clothe_title)?_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("挂点："+_vm._s(item.up_num))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("灯条编码："),_c('span',{staticClass:"cm-color-green cm-fn-500"},[_vm._v(_vm._s(item.strip_code))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("上挂时间："+_vm._s(item.up_time))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-bg-green cm-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px"},on:{"click":function($event){_vm.searchPop = true}}},[_c('p',{staticClass:"cm-fn-14 cm-color-white"},[_vm._v("查询")])]),_vm._v(" "),_c('datetime',{key:'date-' + _vm.dateKey,staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateStatus},on:{"on-change":_vm.dateChange,"update:show":function($event){_vm.dateStatus=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"left","width":"80%"},model:{value:(_vm.searchPop),callback:function ($$v) {_vm.searchPop=$$v},expression:"searchPop"}},[_c('div',{staticClass:"cm-p-lr-16"},[_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("手机号")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4  cm-w-100 cm-bg-white"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-p-tb-4 cm-p-lr-8 cm-fn-16",staticStyle:{"width":"90%"},attrs:{"type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-20"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v("上挂时间")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-m-t-4 cm-p-tb-4 cm-flex-between cm-flex-middle cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.startDate)?_c('p',{staticClass:"cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v(_vm._s(_vm.startDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(0)}}},[_vm._v("请选择")])]),_vm._v(" "),_c('p',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.endDate)?_c('p',{staticClass:" cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v(_vm._s(_vm.endDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4",on:{"click":function($event){return _vm.showDate(1)}}},[_vm._v("请选择")])])])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-pa cm-center cm-border-top-1",staticStyle:{"bottom":"0","left":"0"}},[_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18 cm-bg-white cm-center",on:{"click":_vm.resetSearch}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"cm-w-50 cm-p-tb-16 cm-fn-18  cm-color-white cm-bg-green cm-center",on:{"click":_vm.searchSubmit}},[_vm._v("确定")])])])],1)],1)}
var upList_staticRenderFns = []
var upList_esExports = { render: upList_render, staticRenderFns: upList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_upList = (upList_esExports);
// CONCATENATED MODULE: ./src/pages/upList.vue
function upList_injectStyle (ssrContext) {
  __webpack_require__("PT8N")
}
var upList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upList___vue_template_functional__ = false
/* styles */
var upList___vue_styles__ = upList_injectStyle
/* scopeId */
var upList___vue_scopeId__ = "data-v-55de8794"
/* moduleIdentifier (server only) */
var upList___vue_module_identifier__ = null
var upList_Component = upList_normalizeComponent(
  selectortype_script_index_0_src_pages_upList,
  selectortype_template_index_0_src_pages_upList,
  upList___vue_template_functional__,
  upList___vue_styles__,
  upList___vue_scopeId__,
  upList___vue_module_identifier__
)

/* harmony default export */ var src_pages_upList = (upList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clotheWash.vue













/* harmony default export */ var clotheWash = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: '',
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      stateStr: '-2,0,1,2',
      outDays: [{
        key: 3,
        text: '三天以上'
      }, {
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, type: 2, state: this.stateStr, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clotheWash.vue













/* harmony default export */ var pages_clotheWash = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: '',
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      stateStr: '-2,0,1,2',
      outDays: [{
        key: 3,
        text: '三天以上'
      }, {
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, type: 2, state: this.stateStr, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0391cd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clotheWash.vue
var clotheWash_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wash_code),expression:"wash_code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码"},domProps:{"value":(_vm.wash_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.wash_code=$event.target.value}}}),_vm._v(" "),(_vm.wash_code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("加工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_c('span',{staticClass:"cm-color-orange"},[_vm._v("未送洗")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var clotheWash_staticRenderFns = []
var clotheWash_esExports = { render: clotheWash_render, staticRenderFns: clotheWash_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clotheWash = (clotheWash_esExports);
// CONCATENATED MODULE: ./src/pages/clotheWash.vue
function clotheWash_injectStyle (ssrContext) {
  __webpack_require__("z1dc")
}
var clotheWash_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clotheWash___vue_template_functional__ = false
/* styles */
var clotheWash___vue_styles__ = clotheWash_injectStyle
/* scopeId */
var clotheWash___vue_scopeId__ = "data-v-d0391cd6"
/* moduleIdentifier (server only) */
var clotheWash___vue_module_identifier__ = null
var clotheWash_Component = clotheWash_normalizeComponent(
  pages_clotheWash,
  selectortype_template_index_0_src_pages_clotheWash,
  clotheWash___vue_template_functional__,
  clotheWash___vue_styles__,
  clotheWash___vue_scopeId__,
  clotheWash___vue_module_identifier__
)

/* harmony default export */ var src_pages_clotheWash = (clotheWash_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/timeOutClotheWash.vue













/* harmony default export */ var timeOutClotheWash = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: 0,
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      outDays: [{
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 8,
        text: '八天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, outDay: outDay, type: 2, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/timeOutClotheWash.vue













/* harmony default export */ var pages_timeOutClotheWash = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      dateStatus: false,
      dateStatus1: false,
      searchPop: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      endDate: '',
      startDate: '',
      endDate1: '',
      startDate1: '',
      outIndex: 0,
      wash_code: '',
      name: '',
      phone: '',
      index: 0,
      index1: 0,
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      outDays: [{
        key: 4,
        text: '四天以上'
      }, {
        key: 5,
        text: '五天以上'
      }, {
        key: 8,
        text: '八天以上'
      }, {
        key: 10,
        text: '十天以上'
      }]
    };
  },
  created: function created() {
    this.startDate = '';
    this.endDate = '';
    this.name = '';
    this.phone = '';
    this.config();
  },
  amount: function amount() {},

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.name = '';
      this.phone = '';
      this.wash_code = '';
      this.startDate = '';
      this.startDate1 = '';
      this.endDate = '';
      this.endDate1 = '';
      this.outIndex = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.searchPop = false;
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    setDate1: function setDate1() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.endDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
      var date = new Date(this.endDate);
      console.log(date);
      nowDate.setMonth(nowDate.getMonth());
      var date1 = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate1 = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
    },
    showDate: function showDate(e) {
      this.index = e;
      this.dateStatus = true;
    },
    dateChange: function dateChange(e) {
      if (this.index > 0) {
        this.endDate = e;
      } else {
        this.startDate = e;
      }
    },
    showDate1: function showDate1(e) {
      this.index1 = e;
      this.dateStatus1 = true;
    },
    dateChange1: function dateChange1(e) {
      if (this.index1 > 0) {
        this.endDate1 = e;
      } else {
        this.startDate1 = e;
      }
    },
    outTime: function outTime(index) {
      this.outIndex = this.outIndex === index ? '' : index;
    },
    getList: function getList() {
      var _this = this;

      var outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
      this.$api.washCode({ last_id: this.lastId, page_flag: this.pageFlag, wash_code: this.wash_code, outDay: outDay, type: 2, start: this.startDate, end: this.endDate, start1: this.startDate1, end1: this.endDate1, name: this.name, phone: this.phone }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.wash_code = res.resultStr.split(',')[1];
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd89e0f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/timeOutClotheWash.vue
var timeOutClotheWash_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-l-8",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wash_code),expression:"wash_code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"衣物编码"},domProps:{"value":(_vm.wash_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.wash_code=$event.target.value}}}),_vm._v(" "),(_vm.wash_code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('img',{staticClass:"cm-icon-36 cm-m-l-8 cm-m-r-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(0)}}})]),_vm._v(" "),_c('div',{staticClass:"nav cm-bg-white shadow-gray",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-16 cm-flex-middle cm-flex-between"},_vm._l((_vm.outDays),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-p-tb-8 ",class:[_vm.outIndex == index ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.outTime(index)}}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),(item.state < 6)?_c('p',{staticClass:"cm-fn-12 cm-color-blue"},[_vm._v(_vm._s(item.state_text))]):_c('p',{staticClass:"cm-fn-12 cm-color-green"},[_vm._v(_vm._s(item.state_text))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.factory_id > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("加工厂："),_c('span',{staticClass:"cm-color-333"},[_vm._v(_vm._s(item.factory_title))])]):_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_c('span',{staticClass:"cm-color-orange"},[_vm._v("未送洗")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange cm-m-t-4"},[_vm._v("超时："+_vm._s(item.out_day))])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var timeOutClotheWash_staticRenderFns = []
var timeOutClotheWash_esExports = { render: timeOutClotheWash_render, staticRenderFns: timeOutClotheWash_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_timeOutClotheWash = (timeOutClotheWash_esExports);
// CONCATENATED MODULE: ./src/pages/timeOutClotheWash.vue
function timeOutClotheWash_injectStyle (ssrContext) {
  __webpack_require__("P+90")
}
var timeOutClotheWash_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var timeOutClotheWash___vue_template_functional__ = false
/* styles */
var timeOutClotheWash___vue_styles__ = timeOutClotheWash_injectStyle
/* scopeId */
var timeOutClotheWash___vue_scopeId__ = "data-v-6bd89e0f"
/* moduleIdentifier (server only) */
var timeOutClotheWash___vue_module_identifier__ = null
var timeOutClotheWash_Component = timeOutClotheWash_normalizeComponent(
  pages_timeOutClotheWash,
  selectortype_template_index_0_src_pages_timeOutClotheWash,
  timeOutClotheWash___vue_template_functional__,
  timeOutClotheWash___vue_styles__,
  timeOutClotheWash___vue_scopeId__,
  timeOutClotheWash___vue_module_identifier__
)

/* harmony default export */ var src_pages_timeOutClotheWash = (timeOutClotheWash_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothePhoto.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var clothePhoto = ({
  name: 'barOrder',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      pics: [],
      picPath: [],
      number: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode", "chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          var path = 'record';
          that.$api.uploadsImgOss({ serverId: res.serverId, path: path }).then(function (res) {
            if (res) {
              that.picPath.unshift(res.data.pathName);
              that.pics.unshift(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              } else {
                that.addImg();
              }
            }
          });
        }
      });
    },
    addImg: function addImg() {
      var that = this;
      that.$func.startLoading();
      var picsStr = that.pics.join(',');
      that.$api.operatePhoto({ code: this.code, imgs: picsStr }).then(function (res) {
        if (res) {
          // that.$func.endLoading();
          that.$func.showToast('添加成功');
        }
      });
      that.$func.endLoading();
    },
    delImg: function delImg(index) {
      var _this = this;

      var that = this;
      this.$func.confirm('确定删除吗？', '提示', function () {
        that.$func.startLoading();
        that.pics.splice(index, 1);
        var picsStr = that.pics.join(',');
        that.$api.operatePhoto({ code: _this.code, imgs: picsStr }).then(function (res) {
          if (res) {
            that.picPath.splice(index, 1);
            that.$func.endLoading();
          }
        });
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          _this2.picPath = res.data.img_path;
          _this2.pics = res.data.item_imgs;
          that.$func.endLoading();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/clothePhoto.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pages_clothePhoto = ({
  name: 'barOrder',
  components: {
    wx: weixin_js_sdk_default.a
  },
  data: function data() {
    return {
      id: 0,
      popUp: false,
      code: '',
      order: {
        log: [],
        factory: [],
        community: {}
      },
      pics: [],
      picPath: [],
      number: ''
    };
  },
  created: function created() {
    this.config();
  },
  mounted: function mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ["barCode"],
          success: function success(res) {
            setTimeout(function () {
              // that.formData[id] = res.resultStr.split(',')[1];
              that.code = res.resultStr.split(',')[1];
              that.getOrder();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
        // alert(res.errMsg);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode", "chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          var path = 'record';
          that.$api.uploadsImgOss({ serverId: res.serverId, path: path }).then(function (res) {
            if (res) {
              that.picPath.unshift(res.data.pathName);
              that.pics.unshift(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              } else {
                that.addImg();
              }
            }
          });
        }
      });
    },
    addImg: function addImg() {
      var that = this;
      that.$func.startLoading();
      var picsStr = that.pics.join(',');
      that.$api.operatePhoto({ code: this.code, imgs: picsStr }).then(function (res) {
        if (res) {
          // that.$func.endLoading();
          that.$func.showToast('添加成功');
        }
      });
      that.$func.endLoading();
    },
    delImg: function delImg(index) {
      var _this = this;

      var that = this;
      this.$func.confirm('确定删除吗？', '提示', function () {
        that.$func.startLoading();
        that.pics.splice(index, 1);
        var picsStr = that.pics.join(',');
        that.$api.operatePhoto({ code: _this.code, imgs: picsStr }).then(function (res) {
          if (res) {
            that.picPath.splice(index, 1);
            that.$func.endLoading();
          }
        });
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      var that = this;
      if (!this.code) {
        that.$func.showToast('衣物条码无效');
        return;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({ code: this.code }).then(function (res) {
        if (res) {
          that.order = res.data;
          _this2.picPath = res.data.img_path;
          _this2.pics = res.data.item_imgs;
          that.$func.endLoading();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15bcbe48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clothePhoto.vue
var clothePhoto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-m-lr-8 cm-p-tb-16 shadow-gray cm-m-t-20 cm-bg-white cm-p-lr-12 cm-flex-start cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16",staticStyle:{"width":"65px"}},[_vm._v("条码：")]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-4 cm-bg-gray cm-p-lr-8 cm-border-radius-4 cm-flex-between cm-flex-middle",staticStyle:{"width":"64%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-15 cm-bg-gray cm-color-red  cm-p-tb-6 ",staticStyle:{"width":"90%"},attrs:{"type":"text","placeholder":"输入衣物条码或扫条码"},domProps:{"value":(_vm.code)},on:{"change":_vm.getOrder,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.code = ''}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:" cm-p-lr-8 cm-fn-16 "},[_vm._v("订单号："),_c('span',{staticClass:"cm-color-blue cm-fn-14"},[_vm._v(_vm._s(_vm.order.order_no))]),(_vm.order.order_no)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.order_no)}}},[_vm._v("复制")]):_vm._e(),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(_vm.order.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物类型："),_c('span',{staticClass:"cm-fn-500"},[_vm._v(_vm._s(_vm.order.cate_title)+"-"+_vm._s(_vm.order.clothe_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单门店："),_c('span',{},[_vm._v(_vm._s(_vm.order.store_name))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("品类编码："+_vm._s(_vm.order.item_code))]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("衣物条码："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.order.factory_wash_code))]),(_vm.order.factory_wash_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.factory_wash_code)}}},[_vm._v("复制")]):_vm._e(),(_vm.order.factory_wash_code && _vm.order.up_num <= 0 && _vm.$func.checkAuth('up'))?_c('span',{staticClass:"cm-p-lr-4 cm-p-tb-2 cm-color-white cm-m-l-12 cm-border-radius-2 cm-bg-orange cm-fn-10",on:{"click":function($event){_vm.popUp = true}}},[_vm._v("上挂")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("颜色瑕疵："),_c('span',{},[_vm._v(_vm._s(_vm.order.color)+"|"+_vm._s(_vm.order.flaw))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("用户信息："),_c('span',{},[_vm._v(_vm._s(_vm.order.name)+" "+_vm._s(_vm.order.phone)+" ")]),(_vm.order.phone)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(_vm.order.phone)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("录单时间："),_c('span',{staticClass:"cm-color-yellow"},[_vm._v(_vm._s(_vm.order.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-16"},[_vm._v("顾客备注："),_c('span',{},[_vm._v(_vm._s(_vm.order.remark ? _vm.order.remark : '无'))])])]),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8  cm-bg-white cm-p-tb-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-blue cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("衣物图片")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-8 cm-border-radius-4 cm-p-tb-8 cm-p-lr-16 cm-fn-14",on:{"click":_vm.uploadFile}},[_vm._v("添加图片")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap cm-p-lr-8 cm-m-t-8"},_vm._l((_vm.picPath),function(item,index){return _c('div',{key:index,staticClass:"cm-img-box cm-pr cm-p-tb-4 cm-border-radius-8 cm-p-lr-4 shadow-gray"},[_c('img',{attrs:{"src":item},on:{"click":function($event){return _vm.showPic(_vm.picPath,item)}}}),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-bg-block cm-img-box",staticStyle:{"width":"22px","height":"22px","top":"0","right":"0","border-radius":"50%","z-index":"100"}},[_c('img',{attrs:{"src":"/static/images/remove.png"},on:{"click":function($event){return _vm.delImg(index)}}})])])}),0)])])}
var clothePhoto_staticRenderFns = []
var clothePhoto_esExports = { render: clothePhoto_render, staticRenderFns: clothePhoto_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_clothePhoto = (clothePhoto_esExports);
// CONCATENATED MODULE: ./src/pages/clothePhoto.vue
function clothePhoto_injectStyle (ssrContext) {
  __webpack_require__("94ae")
}
var clothePhoto_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clothePhoto___vue_template_functional__ = false
/* styles */
var clothePhoto___vue_styles__ = clothePhoto_injectStyle
/* scopeId */
var clothePhoto___vue_scopeId__ = "data-v-15bcbe48"
/* moduleIdentifier (server only) */
var clothePhoto___vue_module_identifier__ = null
var clothePhoto_Component = clothePhoto_normalizeComponent(
  pages_clothePhoto,
  selectortype_template_index_0_src_pages_clothePhoto,
  clothePhoto___vue_template_functional__,
  clothePhoto___vue_styles__,
  clothePhoto___vue_scopeId__,
  clothePhoto___vue_module_identifier__
)

/* harmony default export */ var src_pages_clothePhoto = (clothePhoto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var curtain = ({
  name: 'work',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 0,
      grade: 0,
      count: [],
      info: {}
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 23 || this.grade == 24) {
      this.getInfo();
    }
  },
  mounted: function mounted() {
    this.getCurtainOrderCount();
  },

  methods: {
    getCurtainOrderCount: function getCurtainOrderCount() {
      var _this = this;

      this.$api.getCurtainOrderCount({}).then(function (res) {
        _this.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.info = res.data;
          console.log(res.data);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_curtain = ({
  name: 'work',
  components: {
    cmFooter: src_components_cmFooter
  },
  data: function data() {
    return {
      type: 0,
      grade: 0,
      count: [],
      info: {}
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 23 || this.grade == 24) {
      this.getInfo();
    }
  },
  mounted: function mounted() {
    this.getCurtainOrderCount();
  },

  methods: {
    getCurtainOrderCount: function getCurtainOrderCount() {
      var _this = this;

      this.$api.getCurtainOrderCount({}).then(function (res) {
        _this.count = res.data;
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.info = res.data;
          console.log(res.data);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c83901e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtain.vue
var curtain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-pr",staticStyle:{"padding-bottom":"60px"}},[_c('div',{staticClass:"cm-w-100 cm-img-box",staticStyle:{"height":"170px"}},[_c('img',{attrs:{"src":_vm.$customer.assets.homeBg}})]),_vm._v(" "),_c('div',{staticClass:"body cm-w-100"},[_c('div',{staticClass:"cm-center cm-w-100"},[_c('img',{staticClass:"cm-icon-34",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-24 cm-color-red cm-m-l-8  cm-fn-weight-default"},[_vm._v(_vm._s(_vm.$customer.name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4 cm-color-block cm-m-l-4"},[_vm._v("窗帘调度服务")])]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-32 cm-m-lr-8 shadow-gray cm-bg-white cm-border-radius-10 cm-flex-start cm-flex-middle cm-flex-wrap"},[(_vm.$func.checkAuth('curtainGoods'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/curtainGoods"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/worked.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("产品管理")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('createCurtainOrder'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/createCurtainOrder"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/submit.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("创建上门订单")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('recordOrder') && _vm.info.account_cid > 0)?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":'/recordOrder'}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/record_order.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("洗衣录单")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainAddWorker'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/curtainAddWorker"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/submit.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("添加组员")])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainWorker'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-20",attrs:{"to":"/curtainWorker"}},[_c('img',{staticClass:"img",attrs:{"src":"/static/images/worked.png"}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-4"},[_vm._v("组员管理")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:" cm-p-lr-16 cm-bg-white cm-p-b-40",staticStyle:{"margin-top":"40px"}},[(_vm.$func.checkAuth('curtainOrder/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+0}},[_c('p',{staticClass:"cm-fn-16 cm-flex-start cm-flex-middle"},[_vm._v("全部订单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[0] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[0]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/1'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+1}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待分配")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[1] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[1]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/2'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+2}},[(_vm.grade == 23)?_c('p',{staticClass:"cm-fn-16"},[_vm._v("待分配")]):_c('p',{staticClass:"cm-fn-16"},[_vm._v("待抢单")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[2] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[2]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/3'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+3}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待上门")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[3] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[3]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+4}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("拆卸中/收取中")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[4] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[4]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/4'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+5}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待安装/待送回")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[5] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[5]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/6'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+6}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务完成")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[6] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[6]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/7'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/'+7}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已撤销")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[7] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[7]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/6/0'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/6/0'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("待回访")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[(_vm.count[10] > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count[10]))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})])]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainOrder/6/1'))?_c('router-link',{staticClass:"cm-text-center cm-p-tb-16 cm-flex-between cm-flex-middle cm-pr cm-border-bottom-1",attrs:{"to":'/curtainOrder/6/1'}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("已回访")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-youjiantou-"})]):_vm._e()],1),_vm._v(" "),_c('cmFooter',{attrs:{"active":6}})],1)}
var curtain_staticRenderFns = []
var curtain_esExports = { render: curtain_render, staticRenderFns: curtain_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtain = (curtain_esExports);
// CONCATENATED MODULE: ./src/pages/curtain.vue
function curtain_injectStyle (ssrContext) {
  __webpack_require__("7Gwn")
}
var curtain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtain___vue_template_functional__ = false
/* styles */
var curtain___vue_styles__ = curtain_injectStyle
/* scopeId */
var curtain___vue_scopeId__ = "data-v-3c83901e"
/* moduleIdentifier (server only) */
var curtain___vue_module_identifier__ = null
var curtain_Component = curtain_normalizeComponent(
  pages_curtain,
  selectortype_template_index_0_src_pages_curtain,
  curtain___vue_template_functional__,
  curtain___vue_styles__,
  curtain___vue_scopeId__,
  curtain___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtain = (curtain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainGoods.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var curtainGoods = ({
    name: 'myProduct',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        var _ref;

        return _ref = {
            title: '产品管理',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false
        }, defineProperty_default()(_ref, 'title', ''), defineProperty_default()(_ref, 'pageFlag', 2), defineProperty_default()(_ref, 'hasNext', 0), defineProperty_default()(_ref, 'lastId', 0), defineProperty_default()(_ref, 'list', []), _ref;
    },
    created: function created() {},
    amount: function amount() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getCurtainGoods({ last_id: this.lastId, page_flag: this.pageFlag, title: this.title }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        showPic: function showPic(item, index) {
            weixin_js_sdk_default.a.previewImage({
                current: item[index], // 当前显示图片的http链接
                urls: item // 需要预览的图片http链接列表
            });
        },
        edit: function edit(id) {
            this.$router.push({ name: 'curtainAddGoods', params: { id: id } });
        },
        del: function del(id) {
            var _this2 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this2.$api.changeCurtainGoodsStatus({ id: id, status: '-1' }).then(function (res) {
                    if (res) {
                        setTimeout(function () {
                            _this2.list = [];
                            _this2.lastId = 0;
                            _this2.hasNext = 0;
                            _this2.loadmore();
                        }, 300);
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainGoods.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_curtainGoods = ({
    name: 'myProduct',
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        var _ref;

        return _ref = {
            title: '产品管理',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false
        }, defineProperty_default()(_ref, 'title', ''), defineProperty_default()(_ref, 'pageFlag', 2), defineProperty_default()(_ref, 'hasNext', 0), defineProperty_default()(_ref, 'lastId', 0), defineProperty_default()(_ref, 'list', []), _ref;
    },
    created: function created() {},
    amount: function amount() {},

    methods: {
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getCurtainGoods({ last_id: this.lastId, page_flag: this.pageFlag, title: this.title }).then(function (res) {
                if (res) {
                    // console.log(res);
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        showPic: function showPic(item, index) {
            weixin_js_sdk_default.a.previewImage({
                current: item[index], // 当前显示图片的http链接
                urls: item // 需要预览的图片http链接列表
            });
        },
        edit: function edit(id) {
            this.$router.push({ name: 'curtainAddGoods', params: { id: id } });
        },
        del: function del(id) {
            var _this2 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this2.$api.changeCurtainGoodsStatus({ id: id, status: '-1' }).then(function (res) {
                    if (res) {
                        setTimeout(function () {
                            _this2.list = [];
                            _this2.lastId = 0;
                            _this2.hasNext = 0;
                            _this2.loadmore();
                        }, 300);
                    }
                });
            });
        },
        loadmore: function loadmore() {
            var _this3 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(function () {
                if (_this3.blankShow) {
                    _this3.busy = true;
                    _this3.loadStatus = false;
                    _this3.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this3.hasNext > 0) {
                        _this3.loadStatus = false;
                        _this3.busy = false;
                    } else {
                        _this3.busy = true;
                        _this3.loadStatus = true;
                        _this3.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7498e85f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainGoods.vue
var curtainGoods_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"商品名称"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.edit(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-p-lr-12 cm-bg-white cm-p-tb-12 cm-m-b-4"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-8 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 "},[_vm._v("服务时长："),_c('span',{staticClass:"cm-color-green"},[_vm._v(_vm._s(item.service_hours)+"小时")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('div',{staticClass:"cm-border cm-p-tb-4 cm-border-radius-5 cm-center cm-p-lr-12 cm-m-r-24",on:{"click":function($event){return _vm.edit(item.id)}}},[_vm._v("编辑")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-4 cm-border-radius-5 cm-center cm-p-lr-12 cm-bg-red cm-color-white",on:{"click":function($event){return _vm.del(item.id)}}},[_vm._v("删除")])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var curtainGoods_staticRenderFns = []
var curtainGoods_esExports = { render: curtainGoods_render, staticRenderFns: curtainGoods_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainGoods = (curtainGoods_esExports);
// CONCATENATED MODULE: ./src/pages/curtainGoods.vue
function curtainGoods_injectStyle (ssrContext) {
  __webpack_require__("sR1l")
}
var curtainGoods_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainGoods___vue_template_functional__ = false
/* styles */
var curtainGoods___vue_styles__ = curtainGoods_injectStyle
/* scopeId */
var curtainGoods___vue_scopeId__ = "data-v-7498e85f"
/* moduleIdentifier (server only) */
var curtainGoods___vue_module_identifier__ = null
var curtainGoods_Component = curtainGoods_normalizeComponent(
  pages_curtainGoods,
  selectortype_template_index_0_src_pages_curtainGoods,
  curtainGoods___vue_template_functional__,
  curtainGoods___vue_styles__,
  curtainGoods___vue_scopeId__,
  curtainGoods___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainGoods = (curtainGoods_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainAddGoods.vue







/* harmony default export */ var curtainAddGoods = ({
  name: 'curtainAddGoods',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      pop: false,
      filePath: [],
      formData: {
        id: 0,
        title: '',
        service_hours: '',
        status: 1,
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getCurtainGoods();
    }
    this.config();
  },

  computed: {},
  methods: {
    getCurtainGoods: function getCurtainGoods() {
      var _this = this;

      this.$api.getCurtainGoods({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.title) {
        this.$func.showToast('请输入产品名称');
        return false;
      }
      this.$api.submitCurtainGoods(this.formData).then(function (res) {
        _this2.$func.showToast('提交成功');
        setTimeout(function () {
          _this2.$router.go(-1);
        }, 300);
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainAddGoods.vue







/* harmony default export */ var pages_curtainAddGoods = ({
  name: 'curtainAddGoods',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      pop: false,
      filePath: [],
      formData: {
        id: 0,
        title: '',
        service_hours: '',
        status: 1,
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getCurtainGoods();
    }
    this.config();
  },

  computed: {},
  methods: {
    getCurtainGoods: function getCurtainGoods() {
      var _this = this;

      this.$api.getCurtainGoods({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.title) {
        this.$func.showToast('请输入产品名称');
        return false;
      }
      this.$api.submitCurtainGoods(this.formData).then(function (res) {
        _this2.$func.showToast('提交成功');
        setTimeout(function () {
          _this2.$router.go(-1);
        }, 300);
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
        }
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImg({ serverId: res.serverId, path: 'product' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.url);
              that.formData.pics.push(res.data.path);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.filePath[index], // 当前显示图片的http链接
        urls: this.filePath
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.formData.pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ce9ac0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainAddGoods.vue
var curtainAddGoods_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("产品名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.title),expression:"formData.title"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入产品名称"},domProps:{"value":(_vm.formData.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务时长")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.service_hours),expression:"formData.service_hours"}],staticClass:"cm-fn-16",attrs:{"type":"number","placeholder":"请输入服务时长"},domProps:{"value":(_vm.formData.service_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "service_hours", $event.target.value)}}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-l-4"},[_vm._v("小时")])])]),_vm._v(" "),_c('div',{staticClass:" div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("产品描述")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":"150字以内（选填）","height":120},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var curtainAddGoods_staticRenderFns = []
var curtainAddGoods_esExports = { render: curtainAddGoods_render, staticRenderFns: curtainAddGoods_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainAddGoods = (curtainAddGoods_esExports);
// CONCATENATED MODULE: ./src/pages/curtainAddGoods.vue
function curtainAddGoods_injectStyle (ssrContext) {
  __webpack_require__("BEdh")
}
var curtainAddGoods_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainAddGoods___vue_template_functional__ = false
/* styles */
var curtainAddGoods___vue_styles__ = curtainAddGoods_injectStyle
/* scopeId */
var curtainAddGoods___vue_scopeId__ = "data-v-e2ce9ac0"
/* moduleIdentifier (server only) */
var curtainAddGoods___vue_module_identifier__ = null
var curtainAddGoods_Component = curtainAddGoods_normalizeComponent(
  pages_curtainAddGoods,
  selectortype_template_index_0_src_pages_curtainAddGoods,
  curtainAddGoods___vue_template_functional__,
  curtainAddGoods___vue_styles__,
  curtainAddGoods___vue_scopeId__,
  curtainAddGoods___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainAddGoods = (curtainAddGoods_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createCurtainOrder.vue








/* harmony default export */ var createCurtainOrder = ({
  name: 'curtainAddGoods',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      datetimeStatus: false,
      startDate: '',
      minHour: 6,
      maxHour: 24,
      minuteList: ['00', '30'],
      address: '',
      goods: [],
      fromIndex: 1,
      froms: [{
        key: 1,
        title: '小程序'
      }, {
        key: 2,
        title: '抖音'
      }, {
        key: 3,
        title: '其他'
      }],
      typeIndex: 0,
      types: [{
        key: 1,
        title: '当日拆当日装'
      }, {
        key: 2,
        title: '只清洗不拆装'
      }, {
        key: 3,
        title: '当日拆次日装'
      }],
      formData: {
        id: 0,
        goods_id: 0,
        goods_title: '',
        order_no: '',
        name: '',
        phone: '',
        province: '陕西省',
        city: '西安市',
        district: '',
        address: '',
        lat: '',
        lng: '',
        source: 2,
        type: 1,
        pay_status: 0,
        home_time: '请选择',
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getCurtainOrder();
    }
    this.getCurtainGoods();
    this.config();
    this.setDate();
  },

  computed: {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'maps') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  activated: function activated() {
    if (this.$func.getSession('address')) {
      var address = JSON.parse(this.$func.getSession('address'));
      this.formData.address = address.poiaddress;

      this.formData.lat = address.latlng.lat;
      this.formData.lng = address.latlng.lng;
      this.$func.setSession('address', '');
    }
  },

  methods: {
    getCurtainOrder: function getCurtainOrder() {
      var _this = this;

      this.$api.getCurtainOrderInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
          _this.fromIndex = _this.formData.source - 1;
          _this.typeIndex = _this.formData.type - 1;
          _this.goodsIndex = _this.formData.goods_id - 1;
        }
      });
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()

      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.home_time = val;
      this.datetimeStatus = false;
    },
    recognizeAddress: function recognizeAddress() {
      var info = this.parseAddress(this.address);
      this.formData.name = info.name || '';
      this.formData.phone = info.phone || '';
      this.formData.address = info.address || '';
      this.formData.province = info.province || '';
      this.formData.city = info.city || '';
      this.formData.district = info.district || '';
    },
    parseAddress: function parseAddress(text) {
      var src = (text || '').trim();
      if (!src) {
        return { name: '', phone: '', address: '', province: '', city: '', district: '' };
      }

      src = src.replace(/[\t\r\n]+/g, ' ').replace(/[，,；;]+/g, ' ').replace(/\s{2,}/g, ' ').trim();

      var phone = '';
      var mobileMatch = src.match(/(1[3-9]\d{9})/);
      if (mobileMatch) {
        phone = mobileMatch[1];
      } else {
        var landlineMatch = src.match(/((?:0\d{2,3}-?)\d{7,8})/);
        if (landlineMatch) {
          phone = landlineMatch[1];
        }
      }

      var name = '';
      var nameByKey = src.match(/(?:收件人|联系人|姓名)[：:\s]*([\u4e00-\u9fa5·]{2,15})/);
      if (nameByKey) {
        name = nameByKey[1];
      } else if (phone) {
        var beforePhone = src.split(phone)[0];
        var nearName = beforePhone.match(/([\u4e00-\u9fa5·]{2,15})\s*$/);
        if (nearName) {
          name = nearName[1];
        } else {
          var startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
          if (startName) {
            name = startName[1];
          }
        }
      } else {
        var _startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
        if (_startName) {
          name = _startName[1];
        }
      }

      var address = src;
      if (phone) {
        address = address.replace(phone, '');
      }
      if (name) {
        address = address.replace(name, '');
      }
      address = address.replace(/(收件人|联系人|姓名|地址|详细地址|上门地址)[：:\s]*/g, '').replace(/\s{2,}/g, ' ').trim();

      var province = '';
      var city = '';
      var district = '';

      var provRegex = /([\u4e00-\u9fa5]+?(?:省|自治区|特别行政区)|(?:北京|上海|天津|重庆)市|香港特别行政区|澳门特别行政区)/;
      var provMatch = address.match(provRegex);
      if (provMatch) {
        province = provMatch[1];
        address = address.replace(province, '').trim();
      }

      var cityRegex = /([\u4e00-\u9fa5]+?(?:市|地区|盟))/;
      var cityMatch = address.match(cityRegex);
      if (cityMatch) {
        city = cityMatch[1];
        address = address.replace(city, '').trim();
      } else if (!province) {

        var muniStart = address.match(/^(北京|上海|天津|重庆)/);
        if (muniStart) {
          city = muniStart[1] + '市';
          address = address.replace(muniStart[1], '').trim();
        }
      }

      var distRegex = /([\u4e00-\u9fa5]+?(?:区|县|旗|市))/;
      var distMatch = address.match(distRegex);
      if (distMatch) {
        district = distMatch[1];
        address = address.replace(district, '').trim();
      }

      return { name: name, phone: phone, address: address, province: province, city: city, district: district };
    },
    getCurtainGoods: function getCurtainGoods() {
      var _this2 = this;

      this.$api.getCurtainGoods({}).then(function (res) {
        if (res) {
          _this2.goods = res.data;
          if (!_this2.formData.id) {
            _this2.formData.goods_id = _this2.goods[0].id;
            _this2.formData.goods_title = _this2.goods[0].title;
          }
        }
      });
    },
    cateGoods: function cateGoods(index) {
      this.formData.goods_id = this.goods[index].id;
      this.formData.goods_title = this.goods[index].title;
    },
    cateFrom: function cateFrom(index) {
      this.fromIndex = index;
      this.formData.source = this.froms[index].key;
    },
    cateType: function cateType(index) {
      this.typeIndex = index;
      this.formData.type = this.types[index].key;
    },
    position: function position() {
      var that = this;
      weixin_js_sdk_default.a.getLocation({
        type: 'gcj02',
        success: function success(res) {
          console.log('getLocation', res);
          that.$router.push({ name: 'maps', params: { latitude: res.latitude, longitude: res.longitude } });
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.goods_id) {
        this.$func.showToast('请选择产品');
        return false;
      }
      if (!this.formData.name) {
        this.$func.showToast('请输入联系人');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入联系人手机号');
        return false;
      }
      if (!this.formData.address) {
        this.$func.showToast('请输入上门地址');
        return false;
      }

      if (this.formData.home_time == '请选择') {
        this.formData.home_time = '';
      }
      this.$func.confirm('确认提交订单？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.submitCurtainOrder(_this3.formData).then(function (res) {
          _this3.$func.endLoading();
          _this3.$func.showToast('提交成功');
          if (_this3.formData.id > 0) {
            setTimeout(function () {
              _this3.$router.go(-1);
            }, 300);
          } else {
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["getLocation"]
          });
        }
      });
    }
  },
  watch: {
    address: function address(newVal) {
      var _this4 = this;

      clearTimeout(this._addrTimer);
      this._addrTimer = setTimeout(function () {
        _this4.recognizeAddress();
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createCurtainOrder.vue








/* harmony default export */ var pages_createCurtainOrder = ({
  name: 'curtainAddGoods',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      datetimeStatus: false,
      startDate: '',
      minHour: 6,
      maxHour: 24,
      minuteList: ['00', '30'],
      address: '',
      goods: [],
      fromIndex: 1,
      froms: [{
        key: 1,
        title: '小程序'
      }, {
        key: 2,
        title: '抖音'
      }, {
        key: 3,
        title: '其他'
      }],
      typeIndex: 0,
      types: [{
        key: 1,
        title: '当日拆当日装'
      }, {
        key: 2,
        title: '只清洗不拆装'
      }, {
        key: 3,
        title: '当日拆次日装'
      }],
      formData: {
        id: 0,
        goods_id: 0,
        goods_title: '',
        order_no: '',
        name: '',
        phone: '',
        province: '陕西省',
        city: '西安市',
        district: '',
        address: '',
        lat: '',
        lng: '',
        source: 2,
        type: 1,
        pay_status: 0,
        home_time: '请选择',
        content: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getCurtainOrder();
    }
    this.getCurtainGoods();
    this.config();
    this.setDate();
  },

  computed: {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'maps') {
      from.meta.keepAlive = true;
    } else {
      var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? '::' + this.$vnode.componentOptions.tag : '') : this.$vnode.key;
      var cache = this.$vnode.parent.componentInstance.cache;
      var keys = this.$vnode.parent.componentInstance.keys;
      console.log(key, cache, keys);
      if (cache[key]) {
        if (keys.length) {
          var index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        delete cache[key];
      }
    }
    next();
  },
  activated: function activated() {
    if (this.$func.getSession('address')) {
      var address = JSON.parse(this.$func.getSession('address'));
      this.formData.address = address.poiaddress;

      this.formData.lat = address.latlng.lat;
      this.formData.lng = address.latlng.lng;
      this.$func.setSession('address', '');
    }
  },

  methods: {
    getCurtainOrder: function getCurtainOrder() {
      var _this = this;

      this.$api.getCurtainOrderInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
          _this.fromIndex = _this.formData.source - 1;
          _this.typeIndex = _this.formData.type - 1;
          _this.goodsIndex = _this.formData.goods_id - 1;
        }
      });
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()

      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.home_time = val;
      this.datetimeStatus = false;
    },
    recognizeAddress: function recognizeAddress() {
      var info = this.parseAddress(this.address);
      this.formData.name = info.name || '';
      this.formData.phone = info.phone || '';
      this.formData.address = info.address || '';
      this.formData.province = info.province || '';
      this.formData.city = info.city || '';
      this.formData.district = info.district || '';
    },
    parseAddress: function parseAddress(text) {
      var src = (text || '').trim();
      if (!src) {
        return { name: '', phone: '', address: '', province: '', city: '', district: '' };
      }

      src = src.replace(/[\t\r\n]+/g, ' ').replace(/[，,；;]+/g, ' ').replace(/\s{2,}/g, ' ').trim();

      var phone = '';
      var mobileMatch = src.match(/(1[3-9]\d{9})/);
      if (mobileMatch) {
        phone = mobileMatch[1];
      } else {
        var landlineMatch = src.match(/((?:0\d{2,3}-?)\d{7,8})/);
        if (landlineMatch) {
          phone = landlineMatch[1];
        }
      }

      var name = '';
      var nameByKey = src.match(/(?:收件人|联系人|姓名)[：:\s]*([\u4e00-\u9fa5·]{2,15})/);
      if (nameByKey) {
        name = nameByKey[1];
      } else if (phone) {
        var beforePhone = src.split(phone)[0];
        var nearName = beforePhone.match(/([\u4e00-\u9fa5·]{2,15})\s*$/);
        if (nearName) {
          name = nearName[1];
        } else {
          var startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
          if (startName) {
            name = startName[1];
          }
        }
      } else {
        var _startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
        if (_startName) {
          name = _startName[1];
        }
      }

      var address = src;
      if (phone) {
        address = address.replace(phone, '');
      }
      if (name) {
        address = address.replace(name, '');
      }
      address = address.replace(/(收件人|联系人|姓名|地址|详细地址|上门地址)[：:\s]*/g, '').replace(/\s{2,}/g, ' ').trim();

      var province = '';
      var city = '';
      var district = '';

      var provRegex = /([\u4e00-\u9fa5]+?(?:省|自治区|特别行政区)|(?:北京|上海|天津|重庆)市|香港特别行政区|澳门特别行政区)/;
      var provMatch = address.match(provRegex);
      if (provMatch) {
        province = provMatch[1];
        address = address.replace(province, '').trim();
      }

      var cityRegex = /([\u4e00-\u9fa5]+?(?:市|地区|盟))/;
      var cityMatch = address.match(cityRegex);
      if (cityMatch) {
        city = cityMatch[1];
        address = address.replace(city, '').trim();
      } else if (!province) {

        var muniStart = address.match(/^(北京|上海|天津|重庆)/);
        if (muniStart) {
          city = muniStart[1] + '市';
          address = address.replace(muniStart[1], '').trim();
        }
      }

      var distRegex = /([\u4e00-\u9fa5]+?(?:区|县|旗|市))/;
      var distMatch = address.match(distRegex);
      if (distMatch) {
        district = distMatch[1];
        address = address.replace(district, '').trim();
      }

      return { name: name, phone: phone, address: address, province: province, city: city, district: district };
    },
    getCurtainGoods: function getCurtainGoods() {
      var _this2 = this;

      this.$api.getCurtainGoods({}).then(function (res) {
        if (res) {
          _this2.goods = res.data;
          if (!_this2.formData.id) {
            _this2.formData.goods_id = _this2.goods[0].id;
            _this2.formData.goods_title = _this2.goods[0].title;
          }
        }
      });
    },
    cateGoods: function cateGoods(index) {
      this.formData.goods_id = this.goods[index].id;
      this.formData.goods_title = this.goods[index].title;
    },
    cateFrom: function cateFrom(index) {
      this.fromIndex = index;
      this.formData.source = this.froms[index].key;
    },
    cateType: function cateType(index) {
      this.typeIndex = index;
      this.formData.type = this.types[index].key;
    },
    position: function position() {
      var that = this;
      weixin_js_sdk_default.a.getLocation({
        type: 'gcj02',
        success: function success(res) {
          console.log('getLocation', res);
          that.$router.push({ name: 'maps', params: { latitude: res.latitude, longitude: res.longitude } });
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.goods_id) {
        this.$func.showToast('请选择产品');
        return false;
      }
      if (!this.formData.name) {
        this.$func.showToast('请输入联系人');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入联系人手机号');
        return false;
      }
      if (!this.formData.address) {
        this.$func.showToast('请输入上门地址');
        return false;
      }

      if (this.formData.home_time == '请选择') {
        this.formData.home_time = '';
      }
      this.$func.confirm('确认提交订单？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.submitCurtainOrder(_this3.formData).then(function (res) {
          _this3.$func.endLoading();
          _this3.$func.showToast('提交成功');
          if (_this3.formData.id > 0) {
            setTimeout(function () {
              _this3.$router.go(-1);
            }, 300);
          } else {
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["getLocation"]
          });
        }
      });
    }
  },
  watch: {
    address: function address(newVal) {
      var _this4 = this;

      clearTimeout(this._addrTimer);
      this._addrTimer = setTimeout(function () {
        _this4.recognizeAddress();
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6891620e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/createCurtainOrder.vue
var createCurtainOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:" div-show cm-p-b-12"},[_c('div',[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("用户上门地址")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":"粘贴含姓名/电话/地址的文本，自动识别","height":60},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('div',{staticClass:" cm-m-t-8"},[_c('p',{staticClass:"cm-fn-12 cm-color-666"},[_vm._v("示例：张三 13800001111 陕西省西安市莲湖区××路××号")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-around cm-flex-middle"},[_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-12 cm-p-tb-8 cm-m-t-8  cm-border-radius-6",on:{"click":_vm.recognizeAddress}},[_vm._v("自动识别")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-color-white cm-p-lr-12 cm-p-tb-8 cm-m-t-8  cm-border-radius-6",on:{"click":_vm.position}},[_vm._v("地图查找")])])])],1),_vm._v(" "),_c('div',{staticClass:"cm-m-t-8"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-8"},[_c('div',{staticClass:"border-b cm-fn-16 cm-p-lr-8",staticStyle:{"height":"36px","width":"40%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"cm-w-100 cm-h-100",attrs:{"type":"text","placeholder":"姓名"},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"border-b cm-fn-16 cm-p-lr-8",staticStyle:{"height":"36px","width":"50%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"cm-w-100 cm-h-100",attrs:{"type":"text","placeholder":"电话"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-tb-12 border-b cm-fn-16 cm-p-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.province),expression:"formData.province"}],staticStyle:{"width":"20%"},attrs:{"type":"text","placeholder":"省"},domProps:{"value":(_vm.formData.province)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "province", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.city),expression:"formData.city"}],staticStyle:{"width":"30%"},attrs:{"type":"text","placeholder":"市"},domProps:{"value":(_vm.formData.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.district),expression:"formData.district"}],staticStyle:{"width":"50%"},attrs:{"type":"text","placeholder":"区"},domProps:{"value":(_vm.formData.district)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "district", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" div-show"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("详细地址")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":300,"placeholder":"详细地址","height":50},model:{value:(_vm.formData.address),callback:function ($$v) {_vm.$set(_vm.formData, "address", $$v)},expression:"formData.address"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12  border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("选择产品")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((_vm.goods),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-m-r-12 cm-p-lr-8 cm-m-t-12 cm-border-radius-2",class:item.id == _vm.formData.goods_id ? 'cm-bg-red cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.cateGoods(index)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-16 cm-p-tb-8"},[_vm._v("上门时间")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222",attrs:{"format":"YYYY-MM-DD HH:mm","start-date":_vm.startDate,"minute-list":_vm.minuteList,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222 cm-fn-16"},[_vm._v(_vm._s(_vm.formData.home_time))])])],1),_vm._v(" "),_c('div',{staticClass:" div-show cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("备注")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":300,"placeholder":"选填","height":60},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12  border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单类型")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((_vm.types),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-m-r-12 cm-p-lr-8 cm-m-t-12 cm-border-radius-2",class:index == _vm.typeIndex ? 'cm-bg-blue cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.cateType(index)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12  border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单来源")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-flex-wrap"},_vm._l((_vm.froms),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-m-r-12 cm-p-lr-8 cm-m-t-12 cm-border-radius-2",class:index == _vm.fromIndex ? 'cm-bg-blue cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.cateFrom(index)}}},[_vm._v(_vm._s(item.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var createCurtainOrder_staticRenderFns = []
var createCurtainOrder_esExports = { render: createCurtainOrder_render, staticRenderFns: createCurtainOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_createCurtainOrder = (createCurtainOrder_esExports);
// CONCATENATED MODULE: ./src/pages/createCurtainOrder.vue
function createCurtainOrder_injectStyle (ssrContext) {
  __webpack_require__("NDQp")
}
var createCurtainOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var createCurtainOrder___vue_template_functional__ = false
/* styles */
var createCurtainOrder___vue_styles__ = createCurtainOrder_injectStyle
/* scopeId */
var createCurtainOrder___vue_scopeId__ = "data-v-6891620e"
/* moduleIdentifier (server only) */
var createCurtainOrder___vue_module_identifier__ = null
var createCurtainOrder_Component = createCurtainOrder_normalizeComponent(
  pages_createCurtainOrder,
  selectortype_template_index_0_src_pages_createCurtainOrder,
  createCurtainOrder___vue_template_functional__,
  createCurtainOrder___vue_styles__,
  createCurtainOrder___vue_scopeId__,
  createCurtainOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_createCurtainOrder = (createCurtainOrder_Component.exports);

// EXTERNAL MODULE: ./node_modules/blueimp-md5/js/md5.js
var md5 = __webpack_require__("AJcs");
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// CONCATENATED MODULE: ./src/utils/index.js


 // 小程序里也可以用 CryptoJS 或自定义 md5 库


function formatNumber(n) {
  var str = n.toString();
  return str[1] ? str : '0' + str;
}
function generateSign(params) {
  var keys = keys_default()(params).sort();
  var str = '';
  keys.forEach(function (key) {
    if (params[key] !== undefined && params[key] !== '') {
      str += key + '=' + params[key] + '&';
    }
  });
  str += 'key=WliCeBHTez2H5WjfMiWwx2XDYkpBYIbv'; // 加上约定好的密钥
  return md5_default()(str).toUpperCase();
}
function generateSHA256Sign(params) {
  var keys = keys_default()(params).sort();
  var str = '';
  keys.forEach(function (key) {
    if (params[key] !== undefined && params[key] !== '') {
      str += key + '=' + params[key] + '&';
    }
  });
  str += 'key=WliCeBHTez2H5WjfMiWwx2XDYkpBYIbv';
  console.log(str);
  return crypto_js_default.a.SHA256(str).toString(crypto_js_default.a.enc.Hex).toUpperCase();
}
function generateNonce() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var nonce = '';
  for (var i = 0; i < length; i++) {
    nonce += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return nonce;
}

function formatTime(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  var t1 = [year, month, day].map(formatNumber).join('/');
  var t2 = [hour, minute, second].map(formatNumber).join(':');

  return t1 + ' ' + t2;
}
function uniquesArr(obj) {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
    var keys = keys_default()(obj[i]);
    keys.sort(function (a, b) {
      return Number(a) - Number(b);
    });
    var str = '';
    for (var j = 0; j < keys.length; j++) {
      str += stringify_default()(keys[j]);
      str += stringify_default()(obj[i][keys[j]]);
    }
    if (!stringify.hasOwnProperty(str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  uniques = uniques;
  return uniques;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2282ea60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("cu/V")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a680c1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("2MTM")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainOrder.vue




















/* harmony default export */ var curtainOrder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Checklist: vux_src_components_checklist, XTextarea: vux_src_components_x_textarea, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title: '全部订单',
      startDate: '',
      minHour: 6,
      maxHour: 20,
      minuteList: ['00', '30'],
      popBg: false,
      timePop: false,
      datetimeStatus: false,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      showCommentStatus: false,
      showResetStatus: false,
      showCancelStatus: false,
      showVerifyOrder: false,
      showQuery: false,
      sortStatus: false,
      rewardStatus: false,
      pickerSelectWorkerStatus: false,
      selectWorkerId: 0,
      selectWorkerTitle: '请选择',
      sortSelectType: '',
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      id: 0,
      itemIndex: 0,
      itemId: 0,
      list: [],
      pickerGroupStatus: false,
      pickerWorkerStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      group: [],
      groupId: 0,
      rewardAmount: '',
      worker: [],
      workerId: [],
      grade: 0,
      pay_status: '',
      scope: 0,
      content: '',
      commented: '',
      verifyOrder: '',
      verifyAmount: '',
      type: '',
      sortNum: 0,
      isAssign: 0,
      waitPay: 0,
      isTransferOrder: false,
      payStatusArr: [{
        key: '',
        value: '全部'
      }, {
        key: 0,
        value: '未支付'
      }, {
        key: 1,
        value: '已支付'
      }],
      commentedArr: [{
        key: '',
        value: '全部'
      }, {
        key: 1,
        value: '已回访'
      }, {
        key: 0,
        value: '未回访'
      }],
      orderScope: [{
        key: 0,
        value: '全部'
      }, {
        key: 1,
        value: '本人订单'
      }, {
        key: 2,
        value: '组员订单'
      }],
      types: [{
        key: 1,
        title: '当日拆当日装'
      }, {
        key: 2,
        title: '只清洗不拆装'
      }, {
        key: 3,
        title: '当日拆次日装'
      }],
      orderStatusArr: ['全部订单', '待分配', '待抢单', '待上门', '拆卸中', '待安装', '服务完成', '已撤销'],

      dateList: [],
      dateStr: '',
      home_time: '',
      old_home_time: '',
      dateIndex: 0,
      dateHomeStatus: false,
      startHomeDate: '',
      endHomeDate: ''
    };
  },
  created: function created() {
    this.isActive = Number(this.$route.params.i);
    this.commented = this.$route.params.commented;
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.setDate();
    this.loadmore();
    this.$route.meta.title = this.orderStatusArr[this.isActive];
    document.title = this.$route.meta.title;
  },
  mounted: function mounted() {
    this.buildDateList();
    if (this.grade == 23 || this.grade == 24) {
      if (this.grade == 23) {
        this.getWorker();
      }
    } else {
      this.getCurtainGroup();
    }
    this.config();
  },

  methods: {
    buildDateList: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var weekMap, list, mkDate, i, d, yyyy, mm, dd, value, label, display, num;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                list = [];
                _context.next = 4;
                return this.getCurtainOrderDateCount();

              case 4:
                mkDate = _context.sent;

                if (this.grade == 23 || this.grade == 24) {
                  list.push({ value: '', label: '全部', display: '', num: mkDate.all });
                } else {
                  list.push({ value: '', label: '全部', display: '', num: mkDate.all });
                  if (this.isActive < 2 && this.startHomeDate == '') {
                    list.push({ value: 'wait', label: '未设置', display: '', num: mkDate.wait });
                  }
                }
                for (i = 0; i < 15; i++) {
                  d = new Date();

                  d.setDate(d.getDate() + i);
                  yyyy = d.getFullYear();
                  mm = String(d.getMonth() + 1).padStart(2, '0');
                  dd = String(d.getDate()).padStart(2, '0');
                  value = yyyy + '-' + mm + '-' + dd;
                  label = '';
                  display = '';
                  num = 0;

                  if (i === 0) {
                    label = '今天';
                    display = mm + '-' + dd;
                  } else if (i === 1) {
                    label = '明天';
                    display = mm + '-' + dd;
                  } else if (i === 2) {
                    label = '后天';
                    display = mm + '-' + dd;
                  } else {

                    label = mm + '-' + dd;

                    display = weekMap[d.getDay()];
                  }
                  num = mkDate[value] || 0;
                  list.push({ value: value, label: label, display: display, num: num });
                }
                this.dateList = list;
                console.log(this.dateList);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildDateList() {
        return _ref.apply(this, arguments);
      }

      return buildDateList;
    }(),
    getCurtainOrderDateCount: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var where, res;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                where = {
                  phone: this.phone,
                  pay_status: this.pay_status,
                  status: this.isActive,
                  commented: this.commented,
                  scope: this.scope,
                  type: this.type,
                  home_date: this.dateStr,
                  start_home_date: this.startHomeDate,
                  end_home_date: this.endHomeDate,
                  worker_id: this.selectWorkerId
                };
                _context2.next = 4;
                return this.$api.getCurtainOrderDateCount(where);

              case 4:
                res = _context2.sent;
                return _context2.abrupt('return', res ? res.data : {});

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error('getCurtainOrderDateCount error', _context2.t0);
                return _context2.abrupt('return', {});

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getCurtainOrderDateCount() {
        return _ref2.apply(this, arguments);
      }

      return getCurtainOrderDateCount;
    }(),
    getCurtainOrderPayCount: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$api.getCurtainOrderPayCount({ status: this.isActive });

              case 3:
                res = _context3.sent;

                this.waitPay = res.data || 0;
                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('getCurtainOrderDateCount error', _context3.t0);
                return _context3.abrupt('return', {});

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getCurtainOrderPayCount() {
        return _ref3.apply(this, arguments);
      }

      return getCurtainOrderPayCount;
    }(),
    showHomeDate: function showHomeDate(e) {
      this.dateIndex = e;
      this.dateHomeStatus = true;
    },
    dateHomeChange: function dateHomeChange(e) {
      if (this.dateIndex > 0) {
        this.endHomeDate = e;
      } else {
        this.startHomeDate = e;
      }
    },
    onChangeSelectWorker: function onChangeSelectWorker(value) {
      console.log(value);
      this.selectWorkerId = value;
      this.selectWorkerTitle = value ? this.worker.find(function (item) {
        return item.key == value;
      }).value : '请选择';
    },
    selectDate: function selectDate(val) {
      this.loadStatus = false;
      this.dateStr = val;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.home_time = val;
    },
    editHomeTime: function editHomeTime(id, index) {
      this.itemId = id;
      this.home_time = this.list[index].home_time;
      this.old_home_time = this.list[index].home_time;
      this.popBg = true;
      this.timePop = true;
    },
    submitEditHomeTime: function submitEditHomeTime() {
      var _this = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.home_time) {
        this.$func.showToast('请选择上门时间');
        return false;
      }
      if (this.home_time == this.old_home_time) {
        if (this.isAssign > 0) {
          this.datetimeStatus = false;
          this.popBg = false;
          this.timePop = false;
          this.pickerWorkerStatus = true;
          return;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$func.startLoading('请求中。。。');
        _this.$api.curtainEditHomeTime({ id: _this.itemId, home_time: _this.home_time }).then(function (res) {
          if (res) {
            _this.$func.endLoading();
            if (_this.isAssign > 0) {
              _this.datetimeStatus = false;
              _this.popBg = false;
              _this.timePop = false;
              _this.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                _this.datetimeStatus = false;
                _this.popBg = false;
                _this.timePop = false;
                _this.list = [];
                _this.lastId = 0;
                _this.hasNext = 0;
                _this.itemId = 0;
                _this.loadmore();
              }, 300);
            }
          }
        });
      });
    },
    clearHomeTime: function clearHomeTime() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.curtainEditHomeTime({ id: _this2.itemId, home_time: 0 }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            if (_this2.isAssign > 0) {
              _this2.datetimeStatus = false;
              _this2.popBg = false;
              _this2.timePop = false;
              _this2.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                _this2.datetimeStatus = false;
                _this2.popBg = false;
                _this2.timePop = false;
                _this2.list = [];
                _this2.lastId = 0;
                _this2.hasNext = 0;
                _this2.itemId = 0;
                _this2.loadmore();
              }, 300);
            }
          }
        });
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.loadStatus = false;
      this.showQuery = false;
      this.phone = '';
      this.pay_status = '';
      this.startHomeDate = '';
      this.endHomeDate = '';
      this.selectWorkerTitle = '请选择';
      this.selectWorkerId = 0;
      this.scope = 0;
      this.type = 0;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.buildDateList();
    },
    search: function search() {
      this.loadStatus = false;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.buildDateList();
    },
    selectPayStatus: function selectPayStatus(key) {
      this.pay_status = key;
    },
    selectScope: function selectScope(key) {
      this.scope = key;
    },
    selectType: function selectType(key) {
      this.type = key == this.type ? 0 : key;
    },
    selectCommented: function selectCommented(key) {
      this.commented = key;
    },
    curtainSort: function curtainSort(id) {
      this.itemId = id;
      this.popBg = true;
      this.sortStatus = true;
    },
    setReward: function setReward(id, index) {
      this.itemId = id;
      this.rewardAmount = 0;
      this.itemIndex = index;
      this.popBg = true;
      this.rewardStatus = true;
      console.log(this.itemIndex);
    },
    sortSelect: function sortSelect(type) {
      this.sortSelectType = type;
    },
    getList: function getList() {
      var _this3 = this;

      var where = {
        last_id: this.lastId,
        page_flag: this.pageFlag,
        phone: this.phone,
        pay_status: this.pay_status,
        status: this.isActive,
        commented: this.commented,
        scope: this.scope,
        type: this.type,
        home_date: this.dateStr,
        worker_id: this.selectWorkerId,
        start_home_date: this.startHomeDate,
        end_home_date: this.endHomeDate
      };
      this.$api.getCurtainOrder(where).then(function (res) {
        if (res) {
          if (!_this3.lastId) {
            _this3.blankShow = res.data.length > 0 ? false : true;
          }
          _this3.hasNext = res.hasNext;
          _this3.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this3.list.push(item);
          });
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (status == 2 && !this.groupId) {
        this.$func.showToast('请选择拆装组');
        return false;
      }
      if (status == 3 && !this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$func.startLoading('请求中。。。');
        _this4.$api.changeCurtainStatus({ id: id, status: status, groupId: _this4.groupId, workerId: _this4.workerId, isTransferOrder: _this4.isTransferOrder ? 1 : 0 }).then(function (res) {
          if (res) {
            _this4.$func.endLoading();
            _this4.$func.showToast('操作成功');
            setTimeout(function () {
              _this4.pickerGroupStatus = false;
              _this4.pickerWorkerStatus = false;
              _this4.isTransferOrder = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.itemId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    submitSort: function submitSort() {
      var _this5 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.sortSelectType) {
        this.$func.showToast('请选择排序方式');
        return false;
      }
      if (this.sortSelectType == 'number' && !this.sortNum) {
        this.$func.showToast('请输入排名');
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.curtainSort({ id: this.itemId, type: this.sortSelectType, num: this.sortNum }).then(function (res) {
        if (res) {
          _this5.$func.endLoading();
          setTimeout(function () {
            _this5.popBg = false;
            _this5.sortStatus = false;
            _this5.sortSelectType = '';
            _this5.sortNum = 0;
            _this5.itemId = 0;
            _this5.list = [];
            _this5.lastId = 0;
            _this5.hasNext = 0;

            _this5.loadmore();
          }, 300);
        }
      });
    },
    submitReward: function submitReward() {
      var _this6 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.rewardAmount <= 0) {
        this.$func.showToast('请输入佣金金额');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$func.startLoading('请求中。。。');
        _this6.$api.curtainReward({ id: _this6.itemId, amount: _this6.rewardAmount }).then(function (res) {
          if (res) {
            _this6.$func.endLoading();
            setTimeout(function () {
              _this6.popBg = false;
              _this6.rewardStatus = false;
              _this6.list[_this6.itemIndex].amount = _this6.rewardAmount;
              _this6.rewardAmount = 0;
              _this6.itemIndex = 0;
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this7 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this7.$func.startLoading('请求中。。。');
        _this7.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this7.$func.endLoading();
            _this7.$func.showToast('操作成功');
            setTimeout(function () {
              _this7.list = [];
              _this7.lastId = 0;
              _this7.hasNext = 0;

              _this7.loadmore();
            }, 300);
          }
        });
      });
    },
    curtainOrderEdit: function curtainOrderEdit(id) {
      this.$router.push({ name: 'createCurtainOrder', params: { id: id } });
    },
    detail: function detail(id) {
      this.$router.push({ name: 'curtainOrderInfo', params: { id: id } });
    },
    curtainMapOrder: function curtainMapOrder(id) {
      this.$router.push({ name: 'curtainMapOrder', params: { status: this.isActive, dateStr: this.dateStr } });
    },
    assignGroup: function assignGroup(id) {
      this.itemId = id;
      this.pickerGroupStatus = true;
    },
    onGroupChange: function onGroupChange(value) {
      this.groupId = value;
    },
    assignWorker: function assignWorker(id, index) {
      this.itemId = id;
      this.isAssign = 1;
      this.editHomeTime(id, index);
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    transferOrder: function transferOrder(id) {
      this.itemId = id;
      this.isTransferOrder = true;
      this.getWorker();
      this.popBg = true;
      this.pickerWorkerStatus = true;
    },
    getCurtainGroup: function getCurtainGroup() {
      var _this8 = this;

      this.$api.getCurtainGroup({}).then(function (res) {
        if (res) {
          _this8.group = res.data;
        }
      });
    },
    getWorker: function getWorker() {
      var _this9 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this9.worker = res.data;
        }
      });
    },
    closePop: function closePop() {
      this.popBg = false;
      this.timePop = false;
      this.sortStatus = false;
      this.rewardStatus = false;
      this.showVerifyOrder = false;
      this.sortSelectType = '';
      this.sortNum = 0;
      this.itemId = 0;
      this.itemIndex = 0;
      this.rewardAmount = 0;
    },
    showComment: function showComment(id, index) {
      this.itemId = id;
      this.itemIndex = index;
      this.content = '';
      this.showCommentStatus = true;
    },
    submitComment: function submitComment() {
      var _this10 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入回访结果');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this10.$func.startLoading('请求中。。。');
        _this10.$api.curtainComment({ id: _this10.itemId, content: _this10.content }).then(function (res) {
          if (res) {
            _this10.$func.endLoading();
            _this10.$func.showToast('操作成功');
            setTimeout(function () {
              _this10.showCommentStatus = false;

              _this10.list[_this10.itemIndex].commented = 1;
            }, 300);
          }
        });
      });
    },
    resetCurtainOrderStatus: function resetCurtainOrderStatus(id) {
      this.itemId = id;
      this.content = '';
      this.showResetStatus = true;
    },
    submitReset: function submitReset() {
      var _this11 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单重置原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this11.$func.startLoading('请求中。。。');
        _this11.$api.resetCurtainOrder({ id: _this11.itemId, content: _this11.content }).then(function (res) {
          if (res) {
            _this11.$func.endLoading();
            _this11.$func.showToast('操作成功');
            setTimeout(function () {
              _this11.showResetStatus = false;
              _this11.list = [];
              _this11.lastId = 0;
              _this11.hasNext = 0;

              _this11.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelCurtainOrder: function cancelCurtainOrder(id) {
      this.itemId = id;
      this.content = '';
      this.showCancelStatus = true;
    },
    submitCancel: function submitCancel() {
      var _this12 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单撤销原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this12.$func.startLoading('请求中。。。');
        _this12.$api.cancelCurtainOrder({ id: _this12.itemId, content: _this12.content }).then(function (res) {
          if (res) {
            _this12.$func.endLoading();
            _this12.$func.showToast('操作成功');
            setTimeout(function () {
              _this12.showCancelStatus = false;
              _this12.list = [];
              _this12.lastId = 0;
              _this12.hasNext = 0;

              _this12.loadmore();
            }, 300);
          }
        });
      });
    },
    payStatus: function payStatus(id, index) {
      this.itemId = id;
      this.itemIndex = index;
      this.verifyOrder = '';
      this.verifyAmount = '';
      this.popBg = true;
      this.showVerifyOrder = true;
    },
    submitVerifyOrder: function submitVerifyOrder() {
      var _this13 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      var source = this.list[this.itemIndex].source;
      if (source < 3) {
        if (!this.verifyOrder) {
          this.$func.showToast('请输入核销订单号');
          return false;
        }
      } else {
        if (this.verifyAmount <= 0) {
          this.$func.showToast('请输入核销金额');
          return false;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this13.$func.startLoading('请求中。。。');
        _this13.$api.curtainPayStatus({ id: _this13.itemId, source: source, verifyOrder: _this13.verifyOrder, amount: _this13.verifyAmount }).then(function (res) {
          if (res) {
            _this13.$func.endLoading();
            _this13.$func.showToast('操作成功');
            setTimeout(function () {
              _this13.popBg = false;
              _this13.showVerifyOrder = false;
              if (source < 3) {
                _this13.list = [];
                _this13.lastId = 0;
                _this13.itemIndex = 0;
                _this13.hasNext = 0;

                _this13.loadmore();
              } else {
                _this13.list[_this13.itemIndex].pay_status = 1;
                _this13.list[_this13.itemIndex].order_amount = _this13.verifyAmount;
                _this13.list[_this13.itemIndex].verify_time = formatTime(new Date());
              }
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["openLocation"]
          });
        }
      });
    },
    openLocation: function openLocation(info) {
      weixin_js_sdk_default.a.openLocation({
        latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
        longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
        name: info.address, // 位置名
        address: info.address, // 地址详情说明
        scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: ''
      });
    },
    loadmore: function loadmore() {
      var _this14 = this;

      console.log(this.lastId, this.hasNext);
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      setTimeout(function () {
        _this14.getList();
      }, 300);
      setTimeout(function () {
        if (_this14.blankShow) {
          _this14.busy = true;
          _this14.loadStatus = false;
          _this14.loadmoreText = '没有更多了。。。';
        } else {
          if (_this14.hasNext > 0) {
            _this14.loadStatus = false;
            _this14.busy = false;
          } else {
            _this14.busy = true;
            _this14.loadStatus = true;
            _this14.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainOrder.vue




















/* harmony default export */ var pages_curtainOrder = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Checklist: vux_src_components_checklist, XTextarea: vux_src_components_x_textarea, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title: '全部订单',
      startDate: '',
      minHour: 6,
      maxHour: 20,
      minuteList: ['00', '30'],
      popBg: false,
      timePop: false,
      datetimeStatus: false,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      showCommentStatus: false,
      showResetStatus: false,
      showCancelStatus: false,
      showVerifyOrder: false,
      showQuery: false,
      sortStatus: false,
      rewardStatus: false,
      pickerSelectWorkerStatus: false,
      selectWorkerId: 0,
      selectWorkerTitle: '请选择',
      sortSelectType: '',
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      id: 0,
      itemIndex: 0,
      itemId: 0,
      list: [],
      pickerGroupStatus: false,
      pickerWorkerStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      group: [],
      groupId: 0,
      rewardAmount: '',
      worker: [],
      workerId: [],
      grade: 0,
      pay_status: '',
      scope: 0,
      content: '',
      commented: '',
      verifyOrder: '',
      verifyAmount: '',
      type: '',
      sortNum: 0,
      isAssign: 0,
      waitPay: 0,
      isTransferOrder: false,
      payStatusArr: [{
        key: '',
        value: '全部'
      }, {
        key: 0,
        value: '未支付'
      }, {
        key: 1,
        value: '已支付'
      }],
      commentedArr: [{
        key: '',
        value: '全部'
      }, {
        key: 1,
        value: '已回访'
      }, {
        key: 0,
        value: '未回访'
      }],
      orderScope: [{
        key: 0,
        value: '全部'
      }, {
        key: 1,
        value: '本人订单'
      }, {
        key: 2,
        value: '组员订单'
      }],
      types: [{
        key: 1,
        title: '当日拆当日装'
      }, {
        key: 2,
        title: '只清洗不拆装'
      }, {
        key: 3,
        title: '当日拆次日装'
      }],
      orderStatusArr: ['全部订单', '待分配', '待抢单', '待上门', '拆卸中', '待安装', '服务完成', '已撤销'],

      dateList: [],
      dateStr: '',
      home_time: '',
      old_home_time: '',
      dateIndex: 0,
      dateHomeStatus: false,
      startHomeDate: '',
      endHomeDate: ''
    };
  },
  created: function created() {
    this.isActive = Number(this.$route.params.i);
    this.commented = this.$route.params.commented;
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.setDate();
    this.loadmore();
    this.$route.meta.title = this.orderStatusArr[this.isActive];
    document.title = this.$route.meta.title;
  },
  mounted: function mounted() {
    this.buildDateList();
    if (this.grade == 23 || this.grade == 24) {
      if (this.grade == 23) {
        this.getWorker();
      }
    } else {
      this.getCurtainGroup();
    }
    this.config();
  },

  methods: {
    buildDateList: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var weekMap, list, mkDate, i, d, yyyy, mm, dd, value, label, display, num;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                list = [];
                _context.next = 4;
                return this.getCurtainOrderDateCount();

              case 4:
                mkDate = _context.sent;

                if (this.grade == 23 || this.grade == 24) {
                  list.push({ value: '', label: '全部', display: '', num: mkDate.all });
                } else {
                  list.push({ value: '', label: '全部', display: '', num: mkDate.all });
                  if (this.isActive < 2 && this.startHomeDate == '') {
                    list.push({ value: 'wait', label: '未设置', display: '', num: mkDate.wait });
                  }
                }
                for (i = 0; i < 15; i++) {
                  d = new Date();

                  d.setDate(d.getDate() + i);
                  yyyy = d.getFullYear();
                  mm = String(d.getMonth() + 1).padStart(2, '0');
                  dd = String(d.getDate()).padStart(2, '0');
                  value = yyyy + '-' + mm + '-' + dd;
                  label = '';
                  display = '';
                  num = 0;

                  if (i === 0) {
                    label = '今天';
                    display = mm + '-' + dd;
                  } else if (i === 1) {
                    label = '明天';
                    display = mm + '-' + dd;
                  } else if (i === 2) {
                    label = '后天';
                    display = mm + '-' + dd;
                  } else {

                    label = mm + '-' + dd;

                    display = weekMap[d.getDay()];
                  }
                  num = mkDate[value] || 0;
                  list.push({ value: value, label: label, display: display, num: num });
                }
                this.dateList = list;
                console.log(this.dateList);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildDateList() {
        return _ref.apply(this, arguments);
      }

      return buildDateList;
    }(),
    getCurtainOrderDateCount: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var where, res;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                where = {
                  phone: this.phone,
                  pay_status: this.pay_status,
                  status: this.isActive,
                  commented: this.commented,
                  scope: this.scope,
                  type: this.type,
                  home_date: this.dateStr,
                  start_home_date: this.startHomeDate,
                  end_home_date: this.endHomeDate,
                  worker_id: this.selectWorkerId
                };
                _context2.next = 4;
                return this.$api.getCurtainOrderDateCount(where);

              case 4:
                res = _context2.sent;
                return _context2.abrupt('return', res ? res.data : {});

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error('getCurtainOrderDateCount error', _context2.t0);
                return _context2.abrupt('return', {});

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getCurtainOrderDateCount() {
        return _ref2.apply(this, arguments);
      }

      return getCurtainOrderDateCount;
    }(),
    getCurtainOrderPayCount: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$api.getCurtainOrderPayCount({ status: this.isActive });

              case 3:
                res = _context3.sent;

                this.waitPay = res.data || 0;
                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('getCurtainOrderDateCount error', _context3.t0);
                return _context3.abrupt('return', {});

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getCurtainOrderPayCount() {
        return _ref3.apply(this, arguments);
      }

      return getCurtainOrderPayCount;
    }(),
    showHomeDate: function showHomeDate(e) {
      this.dateIndex = e;
      this.dateHomeStatus = true;
    },
    dateHomeChange: function dateHomeChange(e) {
      if (this.dateIndex > 0) {
        this.endHomeDate = e;
      } else {
        this.startHomeDate = e;
      }
    },
    onChangeSelectWorker: function onChangeSelectWorker(value) {
      console.log(value);
      this.selectWorkerId = value;
      this.selectWorkerTitle = value ? this.worker.find(function (item) {
        return item.key == value;
      }).value : '请选择';
    },
    selectDate: function selectDate(val) {
      this.loadStatus = false;
      this.dateStr = val;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()
      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.home_time = val;
    },
    editHomeTime: function editHomeTime(id, index) {
      this.itemId = id;
      this.home_time = this.list[index].home_time;
      this.old_home_time = this.list[index].home_time;
      this.popBg = true;
      this.timePop = true;
    },
    submitEditHomeTime: function submitEditHomeTime() {
      var _this = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.home_time) {
        this.$func.showToast('请选择上门时间');
        return false;
      }
      if (this.home_time == this.old_home_time) {
        if (this.isAssign > 0) {
          this.datetimeStatus = false;
          this.popBg = false;
          this.timePop = false;
          this.pickerWorkerStatus = true;
          return;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$func.startLoading('请求中。。。');
        _this.$api.curtainEditHomeTime({ id: _this.itemId, home_time: _this.home_time }).then(function (res) {
          if (res) {
            _this.$func.endLoading();
            if (_this.isAssign > 0) {
              _this.datetimeStatus = false;
              _this.popBg = false;
              _this.timePop = false;
              _this.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                _this.datetimeStatus = false;
                _this.popBg = false;
                _this.timePop = false;
                _this.list = [];
                _this.lastId = 0;
                _this.hasNext = 0;
                _this.itemId = 0;
                _this.loadmore();
              }, 300);
            }
          }
        });
      });
    },
    clearHomeTime: function clearHomeTime() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.curtainEditHomeTime({ id: _this2.itemId, home_time: 0 }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            if (_this2.isAssign > 0) {
              _this2.datetimeStatus = false;
              _this2.popBg = false;
              _this2.timePop = false;
              _this2.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                _this2.datetimeStatus = false;
                _this2.popBg = false;
                _this2.timePop = false;
                _this2.list = [];
                _this2.lastId = 0;
                _this2.hasNext = 0;
                _this2.itemId = 0;
                _this2.loadmore();
              }, 300);
            }
          }
        });
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.loadStatus = false;
      this.showQuery = false;
      this.phone = '';
      this.pay_status = '';
      this.startHomeDate = '';
      this.endHomeDate = '';
      this.selectWorkerTitle = '请选择';
      this.selectWorkerId = 0;
      this.scope = 0;
      this.type = 0;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.buildDateList();
    },
    search: function search() {
      this.loadStatus = false;
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
      this.buildDateList();
    },
    selectPayStatus: function selectPayStatus(key) {
      this.pay_status = key;
    },
    selectScope: function selectScope(key) {
      this.scope = key;
    },
    selectType: function selectType(key) {
      this.type = key == this.type ? 0 : key;
    },
    selectCommented: function selectCommented(key) {
      this.commented = key;
    },
    curtainSort: function curtainSort(id) {
      this.itemId = id;
      this.popBg = true;
      this.sortStatus = true;
    },
    setReward: function setReward(id, index) {
      this.itemId = id;
      this.rewardAmount = 0;
      this.itemIndex = index;
      this.popBg = true;
      this.rewardStatus = true;
      console.log(this.itemIndex);
    },
    sortSelect: function sortSelect(type) {
      this.sortSelectType = type;
    },
    getList: function getList() {
      var _this3 = this;

      var where = {
        last_id: this.lastId,
        page_flag: this.pageFlag,
        phone: this.phone,
        pay_status: this.pay_status,
        status: this.isActive,
        commented: this.commented,
        scope: this.scope,
        type: this.type,
        home_date: this.dateStr,
        worker_id: this.selectWorkerId,
        start_home_date: this.startHomeDate,
        end_home_date: this.endHomeDate
      };
      this.$api.getCurtainOrder(where).then(function (res) {
        if (res) {
          if (!_this3.lastId) {
            _this3.blankShow = res.data.length > 0 ? false : true;
          }
          _this3.hasNext = res.hasNext;
          _this3.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this3.list.push(item);
          });
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (status == 2 && !this.groupId) {
        this.$func.showToast('请选择拆装组');
        return false;
      }
      if (status == 3 && !this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$func.startLoading('请求中。。。');
        _this4.$api.changeCurtainStatus({ id: id, status: status, groupId: _this4.groupId, workerId: _this4.workerId, isTransferOrder: _this4.isTransferOrder ? 1 : 0 }).then(function (res) {
          if (res) {
            _this4.$func.endLoading();
            _this4.$func.showToast('操作成功');
            setTimeout(function () {
              _this4.pickerGroupStatus = false;
              _this4.pickerWorkerStatus = false;
              _this4.isTransferOrder = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.itemId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    submitSort: function submitSort() {
      var _this5 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.sortSelectType) {
        this.$func.showToast('请选择排序方式');
        return false;
      }
      if (this.sortSelectType == 'number' && !this.sortNum) {
        this.$func.showToast('请输入排名');
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.curtainSort({ id: this.itemId, type: this.sortSelectType, num: this.sortNum }).then(function (res) {
        if (res) {
          _this5.$func.endLoading();
          setTimeout(function () {
            _this5.popBg = false;
            _this5.sortStatus = false;
            _this5.sortSelectType = '';
            _this5.sortNum = 0;
            _this5.itemId = 0;
            _this5.list = [];
            _this5.lastId = 0;
            _this5.hasNext = 0;

            _this5.loadmore();
          }, 300);
        }
      });
    },
    submitReward: function submitReward() {
      var _this6 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.rewardAmount <= 0) {
        this.$func.showToast('请输入佣金金额');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$func.startLoading('请求中。。。');
        _this6.$api.curtainReward({ id: _this6.itemId, amount: _this6.rewardAmount }).then(function (res) {
          if (res) {
            _this6.$func.endLoading();
            setTimeout(function () {
              _this6.popBg = false;
              _this6.rewardStatus = false;
              _this6.list[_this6.itemIndex].amount = _this6.rewardAmount;
              _this6.rewardAmount = 0;
              _this6.itemIndex = 0;
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this7 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this7.$func.startLoading('请求中。。。');
        _this7.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this7.$func.endLoading();
            _this7.$func.showToast('操作成功');
            setTimeout(function () {
              _this7.list = [];
              _this7.lastId = 0;
              _this7.hasNext = 0;

              _this7.loadmore();
            }, 300);
          }
        });
      });
    },
    curtainOrderEdit: function curtainOrderEdit(id) {
      this.$router.push({ name: 'createCurtainOrder', params: { id: id } });
    },
    detail: function detail(id) {
      this.$router.push({ name: 'curtainOrderInfo', params: { id: id } });
    },
    curtainMapOrder: function curtainMapOrder(id) {
      this.$router.push({ name: 'curtainMapOrder', params: { status: this.isActive, dateStr: this.dateStr } });
    },
    assignGroup: function assignGroup(id) {
      this.itemId = id;
      this.pickerGroupStatus = true;
    },
    onGroupChange: function onGroupChange(value) {
      this.groupId = value;
    },
    assignWorker: function assignWorker(id, index) {
      this.itemId = id;
      this.isAssign = 1;
      this.editHomeTime(id, index);
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    transferOrder: function transferOrder(id) {
      this.itemId = id;
      this.isTransferOrder = true;
      this.getWorker();
      this.popBg = true;
      this.pickerWorkerStatus = true;
    },
    getCurtainGroup: function getCurtainGroup() {
      var _this8 = this;

      this.$api.getCurtainGroup({}).then(function (res) {
        if (res) {
          _this8.group = res.data;
        }
      });
    },
    getWorker: function getWorker() {
      var _this9 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this9.worker = res.data;
        }
      });
    },
    closePop: function closePop() {
      this.popBg = false;
      this.timePop = false;
      this.sortStatus = false;
      this.rewardStatus = false;
      this.showVerifyOrder = false;
      this.sortSelectType = '';
      this.sortNum = 0;
      this.itemId = 0;
      this.itemIndex = 0;
      this.rewardAmount = 0;
    },
    showComment: function showComment(id, index) {
      this.itemId = id;
      this.itemIndex = index;
      this.content = '';
      this.showCommentStatus = true;
    },
    submitComment: function submitComment() {
      var _this10 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入回访结果');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this10.$func.startLoading('请求中。。。');
        _this10.$api.curtainComment({ id: _this10.itemId, content: _this10.content }).then(function (res) {
          if (res) {
            _this10.$func.endLoading();
            _this10.$func.showToast('操作成功');
            setTimeout(function () {
              _this10.showCommentStatus = false;

              _this10.list[_this10.itemIndex].commented = 1;
            }, 300);
          }
        });
      });
    },
    resetCurtainOrderStatus: function resetCurtainOrderStatus(id) {
      this.itemId = id;
      this.content = '';
      this.showResetStatus = true;
    },
    submitReset: function submitReset() {
      var _this11 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单重置原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this11.$func.startLoading('请求中。。。');
        _this11.$api.resetCurtainOrder({ id: _this11.itemId, content: _this11.content }).then(function (res) {
          if (res) {
            _this11.$func.endLoading();
            _this11.$func.showToast('操作成功');
            setTimeout(function () {
              _this11.showResetStatus = false;
              _this11.list = [];
              _this11.lastId = 0;
              _this11.hasNext = 0;

              _this11.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelCurtainOrder: function cancelCurtainOrder(id) {
      this.itemId = id;
      this.content = '';
      this.showCancelStatus = true;
    },
    submitCancel: function submitCancel() {
      var _this12 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单撤销原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this12.$func.startLoading('请求中。。。');
        _this12.$api.cancelCurtainOrder({ id: _this12.itemId, content: _this12.content }).then(function (res) {
          if (res) {
            _this12.$func.endLoading();
            _this12.$func.showToast('操作成功');
            setTimeout(function () {
              _this12.showCancelStatus = false;
              _this12.list = [];
              _this12.lastId = 0;
              _this12.hasNext = 0;

              _this12.loadmore();
            }, 300);
          }
        });
      });
    },
    payStatus: function payStatus(id, index) {
      this.itemId = id;
      this.itemIndex = index;
      this.verifyOrder = '';
      this.verifyAmount = '';
      this.popBg = true;
      this.showVerifyOrder = true;
    },
    submitVerifyOrder: function submitVerifyOrder() {
      var _this13 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      var source = this.list[this.itemIndex].source;
      if (source < 3) {
        if (!this.verifyOrder) {
          this.$func.showToast('请输入核销订单号');
          return false;
        }
      } else {
        if (this.verifyAmount <= 0) {
          this.$func.showToast('请输入核销金额');
          return false;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this13.$func.startLoading('请求中。。。');
        _this13.$api.curtainPayStatus({ id: _this13.itemId, source: source, verifyOrder: _this13.verifyOrder, amount: _this13.verifyAmount }).then(function (res) {
          if (res) {
            _this13.$func.endLoading();
            _this13.$func.showToast('操作成功');
            setTimeout(function () {
              _this13.popBg = false;
              _this13.showVerifyOrder = false;
              if (source < 3) {
                _this13.list = [];
                _this13.lastId = 0;
                _this13.itemIndex = 0;
                _this13.hasNext = 0;

                _this13.loadmore();
              } else {
                _this13.list[_this13.itemIndex].pay_status = 1;
                _this13.list[_this13.itemIndex].order_amount = _this13.verifyAmount;
                _this13.list[_this13.itemIndex].verify_time = formatTime(new Date());
              }
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["openLocation"]
          });
        }
      });
    },
    openLocation: function openLocation(info) {
      weixin_js_sdk_default.a.openLocation({
        latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
        longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
        name: info.address, // 位置名
        address: info.address, // 地址详情说明
        scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: ''
      });
    },
    loadmore: function loadmore() {
      var _this14 = this;

      console.log(this.lastId, this.hasNext);
      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      setTimeout(function () {
        _this14.getList();
      }, 300);
      setTimeout(function () {
        if (_this14.blankShow) {
          _this14.busy = true;
          _this14.loadStatus = false;
          _this14.loadmoreText = '没有更多了。。。';
        } else {
          if (_this14.hasNext > 0) {
            _this14.loadStatus = false;
            _this14.busy = false;
          } else {
            _this14.busy = true;
            _this14.loadStatus = true;
            _this14.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c10cf0ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainOrder.vue
var curtainOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main",class:[_vm.popBg ? 'noscroll' : '' ]},[(_vm.isActive < 6)?_c('div',{staticClass:"search cm-w-100 cm-bg-gray shadow-gray"},[_c('div',{staticClass:"date-scroll cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"date-track"},_vm._l((_vm.dateList),function(d){return _c('div',{key:d.value,staticClass:"date-chip",class:{active: _vm.dateStr === d.value},on:{"click":function($event){return _vm.selectDate(d.value)}}},[(d.num && d.num > 0)?_c('span',{staticClass:"chip-badge"},[_vm._v(_vm._s(d.num))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"chip-label"},[_vm._v(_vm._s(d.label))]),_vm._v(" "),_c('span',{staticClass:"chip-sub"},[_vm._v(_vm._s(d.display))])])}),0)])]):_c('div',{staticClass:"search cm-w-100 cm-bg-gray shadow-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-bg-white cm-p-lr-16 cm-m-lr-8 cm-m-tb-8"},[_c('div',{staticClass:" cm-flex-middle cm-flex-between",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18",attrs:{"type":"text","placeholder":"请输入手机号查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.reset()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg",style:({top: _vm.isActive < 6 ? '65px' : '50px'})},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30","infinite-scroll-immediate-check":"true","infinite-scroll-container":"'.list-bg'"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 6)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-blue"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.status_text))]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-m-l-8 cm-p-t-12"},[(item.type == 1)?_c('span',{staticClass:"cm-color-orange cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(item.type_text))]):(item.type == 2)?_c('span',{staticClass:"cm-color-green cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(item.type_text))]):_c('span',{staticClass:"cm-color-blue cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(item.type_text))])]),_vm._v(" "),(item.source < 3)?_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[(item.status < 7 && item.pay_status < 1 && _vm.$func.checkAuth('curtainOrderPayStatus'))?_c('div',{staticClass:"cm-bg-green cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-16 cm-p-tb-4 cm-center cm-color-white",on:{"click":function($event){return _vm.payStatus(item.id,index)}}},[_vm._v("已核销")]):_vm._e()]):_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[(item.status < 7 && item.pay_status < 1 && _vm.$func.checkAuth('curtainOrderPayStatus'))?_c('div',{staticClass:"cm-bg-green cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-16 cm-p-tb-4 cm-center cm-color-white ",on:{"click":function($event){return _vm.payStatus(item.id,index)}}},[_vm._v("已付款")]):_vm._e()])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_vm._v(" "+_vm._s(item.name)+" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_c('div',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_c('a',{staticClass:"cm-color-666 cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.phone)}}},[_vm._v("复制")])]),_vm._v(" "),(item.status < 6 && _vm.$func.checkAuth('curtainEditHomeTime'))?_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.home_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-12 cm-p-tb-4 cm-center cm-color-333 cm-m-r-16",on:{"click":function($event){return _vm.editHomeTime(item.id,index)}}},[_vm._v("修改")])]):_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-orange cm-fn-16 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单类型："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.type_text))])]),_vm._v(" "),(item.source == 2)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销状态："),_c('span',{staticClass:" cm-fn-16 cm-fn-weight-default",class:{'cm-color-orange':item.pay_status < 1,'cm-color-green':item.pay_status >= 1}},[_vm._v(_vm._s(item.pay_status_text))])]):_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("支付状态："),_c('span',{staticClass:"cm-fn-16 cm-fn-weight-default",class:{'cm-color-orange':item.pay_status < 1,'cm-color-green':item.pay_status >= 1}},[_vm._v(_vm._s(item.pay_status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单商品："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.goods_title))])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"cm-fn-14 cm-m-r-24 cm-color-blue"},[_vm._v("第"),_c('span',{staticClass:"cm-fn-24 cm-fn-weight-default cm-color-orange cm-p-lr-4"},[_vm._v(_vm._s(index+1))])])])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门地址："),_c('span',{staticClass:"cm-color-orange cm-fn-16 cm-fn-weight-default",on:{"click":function($event){return _vm.openLocation(item)}}},[_c('img',{staticClass:"cm-icon-16 cm-m-r-4",attrs:{"src":"/static/images/location.png"}}),_vm._v(_vm._s(item.address))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.address)}}},[_vm._v("复制")])]),_vm._v(" "),(item.status > 5)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("回访状态："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.comment_status_text))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单来源："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.source_text))])]),_vm._v(" "),(item.content)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("客服备注："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.content))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("添加时间："+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1"},[(item.amount > 0)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单佣金："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v("￥"+_vm._s(item.amount))])]):_vm._e()]),_vm._v(" "),(item.pay_status > 0)?_c('div',{staticClass:"cm-border-bottom-1"},[(item.verify_order)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销订单："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.verify_order))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.verify_order)}}},[_vm._v("复制")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("总金额："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v("￥"+_vm._s(item.order_amount))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.verify_time))])])]):_vm._e(),_vm._v(" "),_c('div',[(item.group_id > 0)?_c('div',{staticClass:"cm-p-t-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务组长：")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14  cm-p-t-8  cm-color-666"},[_vm._v(_vm._s(item.group.name)+" "),_c('a',{staticClass:"cm-m-l-8",attrs:{"href":'tel:'+item.group.phone}},[_vm._v(_vm._s(item.group.phone))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.group.phone)}}},[_vm._v("复制")])])]):_vm._e(),_vm._v(" "),(item.worker_id != '')?_c('div',{staticClass:" cm-p-tb-8",class:{'cm-border-bottom-1':item.commented > 0}},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅：")]),_vm._v(" "),_vm._l((item.worker),function(worker,i){return _c('p',{key:i,staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(worker.name)),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+worker.phone}},[_vm._v(_vm._s(worker.phone))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(worker.phone)}}},[_vm._v("复制")])])})],2):_vm._e(),_vm._v(" "),(item.commented > 0)?_c('div',{staticClass:" cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("回访结果：")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(item.comment))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(item.comment_time))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle button cm-flex-wrap"},[(item.status == 1 && _vm.$func.checkAuth('curtainOrderStatus/2'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignGroup(item.id)}}},[_vm._v("分配组长")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainOrderStatus/2'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignGroup(item.id)}}},[_vm._v("重新分配")]):_vm._e(),_vm._v(" "),(item.status < 3 && _vm.$func.checkAuth('curtainOrderEdit'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.curtainOrderEdit(item.id)}}},[_vm._v("修改订单")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainOrderStatus/3'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignWorker(item.id,index)}}},[_vm._v("分配师傅")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('curtainOrderStatus/3'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignWorker(item.id,index)}}},[_vm._v("重新分配")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainGrabOrder'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.grabOrder(item.id)}}},[_vm._v("抢单")]):_vm._e(),_vm._v(" "),((item.status == 2 || item.status == 3) && _vm.$func.checkAuth('curtainOrderStatus/4'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('curtainOrderStatus/5'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[(item.type == 1)?_c('span',{staticClass:"cm-color-white"},[_vm._v("拆卸完毕")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("已收取")])]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('curtainOrderStatus/6'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[(item.type == 1)?_c('span',{staticClass:"cm-color-white"},[_vm._v("安装完毕")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("已送回")])]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('curtainTransferOrder'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-p-lr-16 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.transferOrder(item.id)}}},[_vm._v("转单")]):_vm._e(),_vm._v(" "),(item.status > 1 && item.status < 6 && _vm.$func.checkAuth('resetCurtainOrderStatus'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.resetCurtainOrderStatus(item.id)}}},[_vm._v("重置订单状态")]):_vm._e(),_vm._v(" "),(item.status < 6 && _vm.$func.checkAuth('cancelCurtainOrder'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.cancelCurtainOrder(item.id)}}},[_vm._v("撤销订单")]):_vm._e(),_vm._v(" "),(item.status > 2 && item.commented < 1 && _vm.$func.checkAuth('curtainOrderComment'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id,index)}}},[_vm._v("回访记录")]):_vm._e(),_vm._v(" "),(item.status < 7 && _vm.$func.checkAuth('curtainSort'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white  cm-m-r-16",on:{"click":function($event){return _vm.curtainSort(item.id)}}},[_vm._v("订单排序")]):_vm._e(),_vm._v(" "),(item.status > 2 && item.status < 7 && _vm.$func.checkAuth('curtainSetReward'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.setReward(item.id,index)}}},[(item.amount > 0)?_c('span',{staticClass:"cm-color-white"},[_vm._v("修改佣金")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("设置佣金")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center ",on:{"click":function($event){return _vm.detail(item.id)}}},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center"},[_vm._v("查看详情")])])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerGroupStatus),callback:function ($$v) {_vm.pickerGroupStatus=$$v},expression:"pickerGroupStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择拆装组","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerGroupStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,2)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.group,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onGroupChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,2)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerWorkerStatus),callback:function ($$v) {_vm.pickerWorkerStatus=$$v},expression:"pickerWorkerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择拆装师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerWorkerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,3)}}}),_vm._v(" "),_c('group',[_c('checklist',{attrs:{"required":"","options":_vm.worker},on:{"on-change":_vm.onWorkerChange},model:{value:(_vm.workerId),callback:function ($$v) {_vm.workerId=$$v},expression:"workerId"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,3)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCommentStatus),callback:function ($$v) {_vm.showCommentStatus=$$v},expression:"showCommentStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入回访结果","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitComment($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCommentStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showResetStatus),callback:function ($$v) {_vm.showResetStatus=$$v},expression:"showResetStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入订单重置原因","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitReset($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showResetStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCancelStatus),callback:function ($$v) {_vm.showCancelStatus=$$v},expression:"showCancelStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入订单撤销原因","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitCancel($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCancelStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),(_vm.showVerifyOrder)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"200px","width":"95%","left":"2%"}},[(_vm.list[_vm.itemIndex].source < 3)?_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请设置核销订单号")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verifyOrder),expression:"verifyOrder"}],staticClass:"cm-p-lr-8 cm-border cm-p-tb-8 cm-fn-16 ",staticStyle:{"width":"85%"},attrs:{"type":"text","placeholder":"请输入核销订单号"},domProps:{"value":(_vm.verifyOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.verifyOrder=$event.target.value}}})])]):_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入核销金额")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('div',{staticClass:"cm-center cm-fn-18 cm-p-lr-12 cm-p-tb-12 cm-border-radius-8"},[_c('p',{staticClass:"cm-fn-18 cm-color-222"},[_vm._v("金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verifyAmount),expression:"verifyAmount"}],staticClass:"cm-p-lr-8 cm-border cm-p-tb-8 cm-fn-16 cm-m-r-4",staticStyle:{"width":"120px"},attrs:{"type":"number","placeholder":"请输入核销金额"},domProps:{"value":(_vm.verifyAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.verifyAmount=$event.target.value}}}),_vm._v("元\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitVerifyOrder()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerSelectWorkerStatus),callback:function ($$v) {_vm.pickerSelectWorkerStatus=$$v},expression:"pickerSelectWorkerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择组员","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerSelectWorkerStatus = false},"on-click-right":function($event){_vm.pickerSelectWorkerStatus = false}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.worker,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChangeSelectWorker}})],1)],1),_vm._v(" "),_c('popup',{attrs:{"position":"left","width":"90%"},model:{value:(_vm.showQuery),callback:function ($$v) {_vm.showQuery=$$v},expression:"showQuery"}},[_c('div',{staticClass:"cm-h-100 cm-bg-white cm-p-lr-16 cm-p-tb-16"},[_c('p',{staticClass:"cm-fn-18 cm-fn-weight-bold cm-m-b-16"},[_vm._v("订单查询")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-bg-gray cm-p-lr-8 cm-p-tb-8 cm-border-radius-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-16 cm-w-100 cm-bg-gray",attrs:{"type":"text","placeholder":"手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),(_vm.grade == 23)?_c('ul',{staticClass:"cm-flex-middle cm-flex-start cm-m-t-12"},_vm._l((_vm.orderScope),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-border-radius-8 cm-border cm-p-tb-8 cm-p-lr-12 cm-m-r-12",class:[_vm.scope === item.key ? 'cm-bg-orange cm-color-white' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectScope(item.key)}}},[_vm._v(_vm._s(item.value))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("订单类型")]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-middle cm-flex-start cm-m-t-8 "},_vm._l((_vm.types),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-border-radius-8 cm-border cm-p-tb-8 cm-p-lr-12 cm-m-r-16",class:[_vm.type === item.key ? 'cm-bg-orange cm-color-white' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectType(item.key)}}},[_vm._v("\n                                  "+_vm._s(item.title)+"\n                                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("核销状态")]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-middle cm-flex-start cm-m-t-8 "},_vm._l((_vm.payStatusArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-border-radius-8 cm-border cm-p-tb-8 cm-p-lr-12 cm-m-r-16",class:[_vm.pay_status === item.key ? 'cm-bg-orange cm-color-white' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectPayStatus(item.key)}}},[_vm._v("\n                                  "+_vm._s(item.value)+"\n                                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-12"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("回访结果")]),_vm._v(" "),_c('ul',{staticClass:"cm-flex-middle cm-flex-start cm-m-t-8 "},_vm._l((_vm.commentedArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-border-radius-8 cm-border cm-p-tb-8 cm-p-lr-12 cm-m-r-16",class:[_vm.commented === item.key ? 'cm-bg-orange cm-color-white' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectCommented(item.key)}}},[_vm._v("\n                                  "+_vm._s(item.value)+"\n                              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-12"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("上门时间")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-4 cm-m-t-8 cm-flex-between cm-flex-middle cm-p-lr-12 cm-bg-white"},[_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.startHomeDate)?_c('p',{staticClass:"cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showHomeDate(0)}}},[_vm._v(_vm._s(_vm.startHomeDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4 cm-color-999",on:{"click":function($event){return _vm.showHomeDate(0)}}},[_vm._v("请选择")])]),_vm._v(" "),_c('p',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"cm-center cm-bg-white"},[(_vm.endHomeDate)?_c('p',{staticClass:" cm-p-tb-4 cm-p-lr-16",on:{"click":function($event){return _vm.showHomeDate(1)}}},[_vm._v(_vm._s(_vm.endHomeDate))]):_c('p',{staticClass:"cm-p-lr-32 cm-p-tb-4 cm-color-999",on:{"click":function($event){return _vm.showHomeDate(1)}}},[_vm._v("请选择")])])])]),_vm._v(" "),(_vm.grade == 23)?_c('div',{staticClass:"cm-m-t-12 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("组员查询")]),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-bg-gray cm-border-radius-5 cm-p-tb-8 cm-p-lr-24",class:[_vm.selectWorkerId > 0 ? 'cm-color-111 cm-fn-weight-bold' : 'cm-color-999'],on:{"click":function($event){_vm.pickerSelectWorkerStatus = true}}},[_vm._v(_vm._s(_vm.selectWorkerTitle))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-t-24 cm-m-t-12"},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.search();_vm.showQuery=false}}},[_vm._v(" 查询 ")])],1),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle "},[_c('x-button',{staticClass:"cm-m-t-12",staticStyle:{"width":"48%"},attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.reset()}}},[_vm._v(" 重置 ")]),_vm._v(" "),_c('x-button',{staticClass:"cm-m-t-12",staticStyle:{"width":"48%"},attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showQuery = false}}},[_vm._v(" 关闭 ")])],1)])])],1)],1),_vm._v(" "),_c('datetime',{staticClass:"cm-color-white",attrs:{"title":"","show":_vm.dateHomeStatus},on:{"on-change":_vm.dateHomeChange,"update:show":function($event){_vm.dateHomeStatus=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.timePop)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请确认上门时间")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('datetime',{staticClass:"cm-color-222  cm-bg-gray",attrs:{"format":"YYYY-MM-DD HH:mm","start-date":_vm.startDate,"minute-list":_vm.minuteList,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222 cm-fn-16"},[_vm._v(_vm._s(_vm.home_time))])]),_vm._v(" "),(_vm.home_time)?_c('div',{staticClass:"cm-border cm-fn-16 cm-m-l-16 cm-p-tb-8 cm-p-lr-12",on:{"click":function($event){return _vm.clearHomeTime()}}},[_vm._v("清除")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitEditHomeTime()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),(_vm.sortStatus)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"300px","width":"95%","left":"2%"}},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请选择排名")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-orange cm-m-t-8"},[_vm._v("请先确认当天所有上门订单已全部设置上门时间")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-12"},[_c('div',{staticClass:" cm-center cm-border cm-p-lr-8 cm-p-tb-12 cm-border-radius-8",class:{'cm-bg-orange cm-color-white': _vm.sortSelectType == 'top'},on:{"click":function($event){return _vm.sortSelect('top')}}},[_vm._v("排到第一名")]),_vm._v(" "),_c('div',{staticClass:" cm-center cm-border cm-p-lr-8 cm-p-tb-12 cm-border-radius-8",class:{'cm-bg-orange cm-color-white': _vm.sortSelectType == 'forward'},on:{"click":function($event){return _vm.sortSelect('forward')}}},[_vm._v("向前一名")]),_vm._v(" "),_c('div',{staticClass:" cm-center cm-border cm-p-lr-8 cm-p-tb-12 cm-border-radius-8",class:{'cm-bg-orange cm-color-white': _vm.sortSelectType == 'backward'},on:{"click":function($event){return _vm.sortSelect('backward')}}},[_vm._v("向后一名")]),_vm._v(" "),_c('div',{staticClass:" cm-center cm-border cm-p-lr-8 cm-p-tb-12 cm-border-radius-8",class:{'cm-bg-orange cm-color-white': _vm.sortSelectType == 'last'},on:{"click":function($event){return _vm.sortSelect('last')}}},[_vm._v("排最后一名")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-fn-18 cm-p-lr-12 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.sortSelect('number')}}},[_c('p',{staticClass:"cm-fn-18 cm-color-222 cm-fn-weight-default"},[_vm._v("自定义排名：")]),_vm._v("\n                  排到第"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortNum),expression:"sortNum"}],staticClass:"cm-p-lr-12 cm-border cm-p-tb-8 cm-m-l-12 cm-m-r-12",staticStyle:{"width":"50px"},attrs:{"type":"number","placeholder":"请输入排名"},domProps:{"value":(_vm.sortNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sortNum=$event.target.value}}}),_vm._v("名\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitSort()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),(_vm.rewardStatus)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"300px","width":"95%","left":"2%"}},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请设置佣金")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-orange cm-m-t-8"},[_vm._v("佣金组员平分")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('div',{staticClass:"cm-center cm-fn-18 cm-p-lr-12 cm-p-tb-12 cm-border-radius-8"},[_c('p',{staticClass:"cm-fn-18 cm-color-222"},[_vm._v("金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardAmount),expression:"rewardAmount"}],staticClass:"cm-p-lr-24 cm-border cm-p-tb-8 cm-m-l-12 cm-m-r-12 cm-m-r-4",staticStyle:{"width":"120px"},attrs:{"type":"number","placeholder":"请输入佣金"},domProps:{"value":(_vm.rewardAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rewardAmount=$event.target.value}}}),_vm._v("元\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitReward()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-border-radius cm-text-center",staticStyle:{"width":"56px","height":"56px","bottom":"125px","right":"15px","background-color":"rgba(204, 204, 204, 0.7)"},on:{"click":function($event){_vm.showQuery = true}}},[_c('p',{staticClass:"cm-fn-12 cm-color-blue cm-m-t-12 cm-fn-weight-default"},[_vm._v("订单")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-blue  cm-fn-weight-default"},[_vm._v("查询")])]),_vm._v(" "),(_vm.$func.checkAuth('curtainMap'))?_c('div',{staticClass:"cm-pf cm-img-box cm-border-radius cm-text-center",staticStyle:{"width":"56px","height":"56px","bottom":"55px","right":"15px","background-color":"rgba(204, 204, 204, 0.7)"},on:{"click":function($event){return _vm.curtainMapOrder()}}},[_c('p',{staticClass:"cm-fn-12 cm-color-orange cm-m-t-12 cm-fn-weight-default"},[_vm._v("地图")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-orange  cm-fn-weight-default"},[_vm._v("查询")])]):_vm._e()],1)}
var curtainOrder_staticRenderFns = []
var curtainOrder_esExports = { render: curtainOrder_render, staticRenderFns: curtainOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainOrder = (curtainOrder_esExports);
// CONCATENATED MODULE: ./src/pages/curtainOrder.vue
function curtainOrder_injectStyle (ssrContext) {
  __webpack_require__("TXtV")
}
var curtainOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainOrder___vue_template_functional__ = false
/* styles */
var curtainOrder___vue_styles__ = curtainOrder_injectStyle
/* scopeId */
var curtainOrder___vue_scopeId__ = "data-v-c10cf0ba"
/* moduleIdentifier (server only) */
var curtainOrder___vue_module_identifier__ = null
var curtainOrder_Component = curtainOrder_normalizeComponent(
  pages_curtainOrder,
  selectortype_template_index_0_src_pages_curtainOrder,
  curtainOrder___vue_template_functional__,
  curtainOrder___vue_styles__,
  curtainOrder___vue_scopeId__,
  curtainOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainOrder = (curtainOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainOrderInfo.vue

















/* harmony default export */ var curtainOrderInfo = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Checklist: vux_src_components_checklist, XTextarea: vux_src_components_x_textarea, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title: '订单详情',
      startDate: '',
      minHour: 6,
      maxHour: 20,
      minuteList: ['00', '30'],
      popBg: false,
      timePop: false,
      datetimeStatus: false,
      uploadStatus: false,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      showCommentStatus: false,
      showResetStatus: false,
      showCancelStatus: false,
      rewardStatus: false,
      addRemarkStatus: false,
      showVerifyOrder: false,
      showDiffVerify: false,
      verifyOrder: '',
      diffVerifyOrder: '',
      verifyAmount: '',
      rewardAmount: '',
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      id: 0,
      itemId: 0,
      list: [{
        pics_path: [],
        logs: [],
        content: '',
        create_time: ''
      }],
      pickerGroupStatus: false,
      pickerWorkerStatus: false,
      isTransferOrder: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      group: [],
      groupId: 0,
      worker: [],
      workerId: [],
      logs: [],
      filePath: [],
      pics: [],
      isAssign: 0,
      grade: 0,
      itemIndex: 0,
      content: '',
      commented: '',
      home_time: '',
      old_home_time: '',
      remark: ''
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.getList();
    this.curtainOrderLog();
    this.setDate();
  },
  mounted: function mounted() {
    this.getCurtainGroup();
    if (this.grade == 23) {
      this.getWorker();
    }
    this.config();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()

      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.home_time = val;
    },
    editHomeTime: function editHomeTime(id, index) {
      this.itemId = id;
      this.home_time = this.list[index].home_time;
      this.old_home_time = this.list[index].home_time;
      this.popBg = true;
      this.timePop = true;
    },
    submitEditHomeTime: function submitEditHomeTime() {
      var _this = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.home_time) {
        this.$func.showToast('请选择上门时间');
        return false;
      }
      if (this.home_time == this.old_home_time) {
        if (this.isAssign > 0) {
          this.datetimeStatus = false;
          this.popBg = false;
          this.timePop = false;
          this.pickerWorkerStatus = true;
          return;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$func.startLoading('请求中。。。');
        _this.$api.curtainEditHomeTime({ id: _this.itemId, home_time: _this.home_time }).then(function (res) {
          if (res) {
            _this.$func.endLoading();
            if (_this.isAssign > 0) {
              _this.datetimeStatus = false;
              _this.popBg = false;
              _this.timePop = false;
              _this.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                window.location.reload();
              }, 300);
            }
          }
        });
      });
    },
    payStatus: function payStatus(id) {
      this.itemId = id;
      this.verifyOrder = '';
      this.verifyAmount = '';
      this.popBg = true;
      this.showVerifyOrder = true;
    },
    submitVerifyOrder: function submitVerifyOrder() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      var source = this.list[this.itemIndex].source;
      if (source < 3) {
        if (!this.verifyOrder) {
          this.$func.showToast('请输入核销订单号');
          return false;
        }
      } else {
        if (this.verifyAmount <= 0) {
          this.$func.showToast('请输入核销金额');
          return false;
        }
      }

      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.curtainPayStatus({ id: _this2.itemId, source: source, verifyOrder: _this2.verifyOrder, amount: _this2.verifyAmount }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            _this2.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    curtainDiffVerify: function curtainDiffVerify(id) {
      this.itemId = id;
      this.diffVerifyOrder = '';
      this.popBg = true;
      this.showDiffVerify = true;
    },
    submitDiffVerify: function submitDiffVerify() {
      var _this3 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.diffVerifyOrder) {
        this.$func.showToast('请输入核销订单号');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.curtainDiffVerify({ id: _this3.itemId, order_no: _this3.diffVerifyOrder }).then(function (res) {
          if (res) {
            _this3.$func.endLoading();
            _this3.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.phone = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;

      this.$api.getCurtainOrder({ id: this.id }).then(function (res) {
        if (res) {

          if (!_this4.lastId) {
            _this4.blankShow = res.data.length > 0 ? false : true;
          }
          _this4.hasNext = res.hasNext;
          _this4.lastId = res.lastId;
          _this4.list = res.data;
        }
      });
    },
    curtainOrderLog: function curtainOrderLog() {
      var _this5 = this;

      this.$api.curtainOrderLog({ id: this.id }).then(function (res) {
        if (res) {
          _this5.logs = res.data;
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this6 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (status == 2 && !this.groupId) {
        this.$func.showToast('请选择拆装组');
        return false;
      }
      if (status == 3 && !this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$func.startLoading('请求中。。。');
        _this6.$api.changeCurtainStatus({ id: id, status: status, groupId: _this6.groupId, workerId: _this6.workerId, isTransferOrder: _this6.isTransferOrder ? 1 : 0 }).then(function (res) {
          if (res) {
            _this6.$func.endLoading();
            _this6.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this7 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this7.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this7.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    curtainOrderEdit: function curtainOrderEdit(id) {
      this.$router.push({ name: 'createCurtainOrder', params: { id: id } });
    },
    assignGroup: function assignGroup(id) {
      this.itemId = id;
      this.pickerGroupStatus = true;
    },
    onGroupChange: function onGroupChange(value) {
      this.groupId = value;
    },
    closePop: function closePop() {
      this.popBg = false;
      this.timePop = false;
      this.pickerWorkerStatus = false;
      this.pickerGroupStatus = false;
      this.rewardStatus = false;
      this.addRemarkStatus = false;
      this.showVerifyOrder = false;
      this.showDiffVerify = false;
      this.remark = '';
    },
    assignWorker: function assignWorker(id, index) {
      this.itemId = id;
      this.isAssign = 1;
      this.editHomeTime(id, index);
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    transferOrder: function transferOrder(id) {
      this.itemId = id;
      this.isTransferOrder = true;
      this.getWorker();
      this.popBg = true;
      this.pickerWorkerStatus = true;
    },
    setReward: function setReward(id, index) {
      this.itemId = id;
      this.rewardAmount = 0;
      this.itemIndex = index;
      this.popBg = true;
      this.rewardStatus = true;
    },
    getCurtainGroup: function getCurtainGroup() {
      var _this8 = this;

      this.$api.getCurtainGroup({}).then(function (res) {
        if (res) {
          _this8.group = res.data;
        }
      });
    },
    getWorker: function getWorker() {
      var _this9 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this9.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      this.itemId = id;
      this.showCommentStatus = true;
    },
    submitComment: function submitComment() {
      var _this10 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入回访结果');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this10.$func.startLoading('请求中。。。');
        _this10.$api.curtainComment({ id: _this10.itemId, content: _this10.content }).then(function (res) {
          if (res) {
            _this10.$func.endLoading();
            _this10.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    submitRemark: function submitRemark() {
      var _this11 = this;

      if (!this.id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.remark) {
        this.$func.showToast('请输入备注内容');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this11.$func.startLoading('请求中。。。');
        _this11.$api.curtainRemark({ id: _this11.id, remark: _this11.remark }).then(function (res) {
          if (res) {
            _this11.$func.endLoading();
            _this11.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    resetCurtainOrderStatus: function resetCurtainOrderStatus(id) {
      this.itemId = id;
      this.content = '';
      this.showResetStatus = true;
    },
    submitReset: function submitReset() {
      var _this12 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单重置原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this12.$func.startLoading('请求中。。。');
        _this12.$api.resetCurtainOrder({ id: _this12.itemId, content: _this12.content }).then(function (res) {
          if (res) {
            _this12.$func.endLoading();
            _this12.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    submitReward: function submitReward() {
      var _this13 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.rewardAmount <= 0) {
        this.$func.showToast('请输入佣金金额');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this13.$func.startLoading('请求中。。。');
        _this13.$api.curtainReward({ id: _this13.itemId, amount: _this13.rewardAmount }).then(function (res) {
          if (res) {
            _this13.$func.endLoading();
            setTimeout(function () {
              _this13.popBg = false;
              _this13.rewardStatus = false;
              _this13.list[_this13.itemIndex].amount = _this13.rewardAmount;
              _this13.rewardAmount = 0;
              _this13.itemIndex = 0;
            }, 300);
          }
        });
      });
    },
    cancelCurtainOrder: function cancelCurtainOrder(id) {
      this.itemId = id;
      this.content = '';
      this.showCancelStatus = true;
    },
    submitCancel: function submitCancel() {
      var _this14 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单撤销原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this14.$func.startLoading('请求中。。。');
        _this14.$api.cancelCurtainOrder({ id: _this14.itemId, content: _this14.content }).then(function (res) {
          if (res) {
            _this14.$func.endLoading();
            _this14.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "openLocation"]
          });
        }
      });
    },
    openLocation: function openLocation(info) {
      weixin_js_sdk_default.a.openLocation({
        latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
        longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
        name: info.address, // 位置名
        address: info.address, // 地址详情说明
        scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: ''
      });
    },
    closeUpload: function closeUpload() {
      this.uploadStatus = false;
      this.filePath = [];
      this.pics = [];
    },
    submitUpload: function submitUpload() {
      var that = this;
      that.$func.confirm('确认提交上传图片？', '提示', function () {
        that.$api.submitCurtainUpload({ id: that.id, pics: that.pics }).then(function (res) {
          if (res) {
            that.uploadStatus = false;
            that.filePath = [];
            that.pics = [];
            that.getList();
          }
        });
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'curtain' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.pathName);
              that.pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    },
    loadmore: function loadmore() {
      var _this15 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this15.blankShow) {
          _this15.busy = true;
          _this15.loadStatus = false;
          _this15.loadmoreText = '没有更多了。。。';
        } else {
          if (_this15.hasNext > 0) {
            _this15.loadStatus = false;
            _this15.busy = false;
          } else {
            _this15.busy = true;
            _this15.loadStatus = true;
            _this15.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainOrderInfo.vue

















/* harmony default export */ var pages_curtainOrderInfo = ({
  name: 'order',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, Checklist: vux_src_components_checklist, XTextarea: vux_src_components_x_textarea, Datetime: vux_src_components_datetime
  },
  data: function data() {
    return {
      title: '订单详情',
      startDate: '',
      minHour: 6,
      maxHour: 20,
      minuteList: ['00', '30'],
      popBg: false,
      timePop: false,
      datetimeStatus: false,
      uploadStatus: false,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      showCommentStatus: false,
      showResetStatus: false,
      showCancelStatus: false,
      rewardStatus: false,
      addRemarkStatus: false,
      showVerifyOrder: false,
      showDiffVerify: false,
      verifyOrder: '',
      diffVerifyOrder: '',
      verifyAmount: '',
      rewardAmount: '',
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      id: 0,
      itemId: 0,
      list: [{
        pics_path: [],
        logs: [],
        content: '',
        create_time: ''
      }],
      pickerGroupStatus: false,
      pickerWorkerStatus: false,
      isTransferOrder: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      group: [],
      groupId: 0,
      worker: [],
      workerId: [],
      logs: [],
      filePath: [],
      pics: [],
      isAssign: 0,
      grade: 0,
      itemIndex: 0,
      content: '',
      commented: '',
      home_time: '',
      old_home_time: '',
      remark: ''
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.grade = parseInt(this.$func.getLocal('grade'));
    this.getList();
    this.curtainOrderLog();
    this.setDate();
  },
  mounted: function mounted() {
    this.getCurtainGroup();
    if (this.grade == 23) {
      this.getWorker();
    }
    this.config();
  },

  methods: {
    setDate: function setDate() {
      var nowDate = new Date();
      var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate()

      };
      this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
    },
    datetimeChange: function datetimeChange(val) {
      this.home_time = val;
    },
    editHomeTime: function editHomeTime(id, index) {
      this.itemId = id;
      this.home_time = this.list[index].home_time;
      this.old_home_time = this.list[index].home_time;
      this.popBg = true;
      this.timePop = true;
    },
    submitEditHomeTime: function submitEditHomeTime() {
      var _this = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.home_time) {
        this.$func.showToast('请选择上门时间');
        return false;
      }
      if (this.home_time == this.old_home_time) {
        if (this.isAssign > 0) {
          this.datetimeStatus = false;
          this.popBg = false;
          this.timePop = false;
          this.pickerWorkerStatus = true;
          return;
        }
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this.$func.startLoading('请求中。。。');
        _this.$api.curtainEditHomeTime({ id: _this.itemId, home_time: _this.home_time }).then(function (res) {
          if (res) {
            _this.$func.endLoading();
            if (_this.isAssign > 0) {
              _this.datetimeStatus = false;
              _this.popBg = false;
              _this.timePop = false;
              _this.pickerWorkerStatus = true;
            } else {
              setTimeout(function () {
                window.location.reload();
              }, 300);
            }
          }
        });
      });
    },
    payStatus: function payStatus(id) {
      this.itemId = id;
      this.verifyOrder = '';
      this.verifyAmount = '';
      this.popBg = true;
      this.showVerifyOrder = true;
    },
    submitVerifyOrder: function submitVerifyOrder() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      var source = this.list[this.itemIndex].source;
      if (source < 3) {
        if (!this.verifyOrder) {
          this.$func.showToast('请输入核销订单号');
          return false;
        }
      } else {
        if (this.verifyAmount <= 0) {
          this.$func.showToast('请输入核销金额');
          return false;
        }
      }

      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.curtainPayStatus({ id: _this2.itemId, source: source, verifyOrder: _this2.verifyOrder, amount: _this2.verifyAmount }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            _this2.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    curtainDiffVerify: function curtainDiffVerify(id) {
      this.itemId = id;
      this.diffVerifyOrder = '';
      this.popBg = true;
      this.showDiffVerify = true;
    },
    submitDiffVerify: function submitDiffVerify() {
      var _this3 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.diffVerifyOrder) {
        this.$func.showToast('请输入核销订单号');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.curtainDiffVerify({ id: _this3.itemId, order_no: _this3.diffVerifyOrder }).then(function (res) {
          if (res) {
            _this3.$func.endLoading();
            _this3.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    reset: function reset() {
      this.phone = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;

      this.$api.getCurtainOrder({ id: this.id }).then(function (res) {
        if (res) {

          if (!_this4.lastId) {
            _this4.blankShow = res.data.length > 0 ? false : true;
          }
          _this4.hasNext = res.hasNext;
          _this4.lastId = res.lastId;
          _this4.list = res.data;
        }
      });
    },
    curtainOrderLog: function curtainOrderLog() {
      var _this5 = this;

      this.$api.curtainOrderLog({ id: this.id }).then(function (res) {
        if (res) {
          _this5.logs = res.data;
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this6 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (status == 2 && !this.groupId) {
        this.$func.showToast('请选择拆装组');
        return false;
      }
      if (status == 3 && !this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this6.$func.startLoading('请求中。。。');
        _this6.$api.changeCurtainStatus({ id: id, status: status, groupId: _this6.groupId, workerId: _this6.workerId, isTransferOrder: _this6.isTransferOrder ? 1 : 0 }).then(function (res) {
          if (res) {
            _this6.$func.endLoading();
            _this6.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this7 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this7.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this7.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    curtainOrderEdit: function curtainOrderEdit(id) {
      this.$router.push({ name: 'createCurtainOrder', params: { id: id } });
    },
    assignGroup: function assignGroup(id) {
      this.itemId = id;
      this.pickerGroupStatus = true;
    },
    onGroupChange: function onGroupChange(value) {
      this.groupId = value;
    },
    closePop: function closePop() {
      this.popBg = false;
      this.timePop = false;
      this.pickerWorkerStatus = false;
      this.pickerGroupStatus = false;
      this.rewardStatus = false;
      this.addRemarkStatus = false;
      this.showVerifyOrder = false;
      this.showDiffVerify = false;
      this.remark = '';
    },
    assignWorker: function assignWorker(id, index) {
      this.itemId = id;
      this.isAssign = 1;
      this.editHomeTime(id, index);
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    transferOrder: function transferOrder(id) {
      this.itemId = id;
      this.isTransferOrder = true;
      this.getWorker();
      this.popBg = true;
      this.pickerWorkerStatus = true;
    },
    setReward: function setReward(id, index) {
      this.itemId = id;
      this.rewardAmount = 0;
      this.itemIndex = index;
      this.popBg = true;
      this.rewardStatus = true;
    },
    getCurtainGroup: function getCurtainGroup() {
      var _this8 = this;

      this.$api.getCurtainGroup({}).then(function (res) {
        if (res) {
          _this8.group = res.data;
        }
      });
    },
    getWorker: function getWorker() {
      var _this9 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this9.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      this.itemId = id;
      this.showCommentStatus = true;
    },
    submitComment: function submitComment() {
      var _this10 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入回访结果');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this10.$func.startLoading('请求中。。。');
        _this10.$api.curtainComment({ id: _this10.itemId, content: _this10.content }).then(function (res) {
          if (res) {
            _this10.$func.endLoading();
            _this10.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    submitRemark: function submitRemark() {
      var _this11 = this;

      if (!this.id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.remark) {
        this.$func.showToast('请输入备注内容');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this11.$func.startLoading('请求中。。。');
        _this11.$api.curtainRemark({ id: _this11.id, remark: _this11.remark }).then(function (res) {
          if (res) {
            _this11.$func.endLoading();
            _this11.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    resetCurtainOrderStatus: function resetCurtainOrderStatus(id) {
      this.itemId = id;
      this.content = '';
      this.showResetStatus = true;
    },
    submitReset: function submitReset() {
      var _this12 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单重置原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this12.$func.startLoading('请求中。。。');
        _this12.$api.resetCurtainOrder({ id: _this12.itemId, content: _this12.content }).then(function (res) {
          if (res) {
            _this12.$func.endLoading();
            _this12.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    submitReward: function submitReward() {
      var _this13 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.rewardAmount <= 0) {
        this.$func.showToast('请输入佣金金额');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this13.$func.startLoading('请求中。。。');
        _this13.$api.curtainReward({ id: _this13.itemId, amount: _this13.rewardAmount }).then(function (res) {
          if (res) {
            _this13.$func.endLoading();
            setTimeout(function () {
              _this13.popBg = false;
              _this13.rewardStatus = false;
              _this13.list[_this13.itemIndex].amount = _this13.rewardAmount;
              _this13.rewardAmount = 0;
              _this13.itemIndex = 0;
            }, 300);
          }
        });
      });
    },
    cancelCurtainOrder: function cancelCurtainOrder(id) {
      this.itemId = id;
      this.content = '';
      this.showCancelStatus = true;
    },
    submitCancel: function submitCancel() {
      var _this14 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (!this.content) {
        this.$func.showToast('请输入订单撤销原因');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this14.$func.startLoading('请求中。。。');
        _this14.$api.cancelCurtainOrder({ id: _this14.itemId, content: _this14.content }).then(function (res) {
          if (res) {
            _this14.$func.endLoading();
            _this14.$func.showToast('操作成功');
            setTimeout(function () {
              window.location.reload();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false, //调试阶段建议开启
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "openLocation"]
          });
        }
      });
    },
    openLocation: function openLocation(info) {
      weixin_js_sdk_default.a.openLocation({
        latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
        longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
        name: info.address, // 位置名
        address: info.address, // 地址详情说明
        scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: ''
      });
    },
    closeUpload: function closeUpload() {
      this.uploadStatus = false;
      this.filePath = [];
      this.pics = [];
    },
    submitUpload: function submitUpload() {
      var that = this;
      that.$func.confirm('确认提交上传图片？', '提示', function () {
        that.$api.submitCurtainUpload({ id: that.id, pics: that.pics }).then(function (res) {
          if (res) {
            that.uploadStatus = false;
            that.filePath = [];
            that.pics = [];
            that.getList();
          }
        });
      });
    },
    uploadFile: function uploadFile() {
      var that = this;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var localId = localIds.pop();
      var that = this;
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'curtain' }).then(function (res) {
            if (res) {
              that.filePath.push(res.data.pathName);
              that.pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(urls, url) {
      weixin_js_sdk_default.a.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls
      });
    },
    delImg: function delImg(index) {
      this.filePath.splice(index, 1);
      this.pics.splice(index, 1);
    },
    loadmore: function loadmore() {
      var _this15 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this15.blankShow) {
          _this15.busy = true;
          _this15.loadStatus = false;
          _this15.loadmoreText = '没有更多了。。。';
        } else {
          if (_this15.hasNext > 0) {
            _this15.loadStatus = false;
            _this15.busy = false;
          } else {
            _this15.busy = true;
            _this15.loadStatus = true;
            _this15.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ef2152","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainOrderInfo.vue
var curtainOrderInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main",class:[_vm.popBg ? 'noscroll' : '' ]},[_c('div',{staticClass:"list-bg cm-p-b-20"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 6)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-blue"},[_vm._v(_vm._s(item.status_text))]),_vm._v(" "),(item.source < 3)?_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销状态："),_c('span',{staticClass:" cm-fn-16 cm-fn-weight-default",class:{'cm-color-orange':item.pay_status < 1,'cm-color-green':item.pay_status >= 1}},[_vm._v(_vm._s(item.pay_status_text))])]),_vm._v(" "),(item.status < 7 && item.pay_status < 1 && _vm.$func.checkAuth('curtainOrderPayStatus'))?_c('div',{staticClass:"cm-bg-green cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-16 cm-p-tb-4 cm-center cm-color-white",on:{"click":function($event){return _vm.payStatus(item.id)}}},[_vm._v("已核销")]):_vm._e()]):_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("支付状态："),_c('span',{staticClass:"cm-fn-16 cm-fn-weight-default",class:{'cm-color-orange':item.pay_status < 1,'cm-color-green':item.pay_status >= 1}},[_vm._v(_vm._s(item.pay_status_text))])]),_vm._v(" "),(item.status < 7 && item.pay_status < 1 && _vm.$func.checkAuth('curtainOrderPayStatus'))?_c('div',{staticClass:"cm-bg-green cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-16 cm-p-tb-4 cm-center cm-color-white ",on:{"click":function($event){return _vm.payStatus(item.id)}}},[_vm._v("已付款")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-b-12"},[_c('div',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_vm._v(" "+_vm._s(item.name)+" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_c('div',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2"},[_c('a',{staticClass:"cm-color-666 cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.phone)}}},[_vm._v("复制")])]),_vm._v(" "),(item.status < 6 && _vm.$func.checkAuth('curtainEditHomeTime'))?_c('div',{staticClass:"cm-flex-middle cm-flex-start"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.home_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-p-lr-12 cm-m-l-12 cm-p-tb-4 cm-center cm-color-333 cm-m-r-16",on:{"click":function($event){return _vm.editHomeTime(item.id,index)}}},[_vm._v("修改")])]):_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-orange cm-fn-16 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单类型："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.type_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单商品："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.goods_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门地址："),_c('span',{staticClass:"cm-color-orange cm-fn-16 cm-fn-weight-default"},[_vm._v(_vm._s(item.address))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.address)}}},[_vm._v("复制")])]),_vm._v(" "),(item.amount > 0)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单佣金："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.amount))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("订单来源："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.source_text))])]),_vm._v(" "),(item.status > 5)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("回访状态："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.comment_status_text))])]):_vm._e()]),_vm._v(" "),(item.pay_status > 0)?_c('div',{staticClass:"cm-border-bottom-1"},[(item.verify_order)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销订单："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.verify_order))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.verify_order)}}},[_vm._v("复制")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("总金额："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v("￥"+_vm._s(item.order_amount))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("核销时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.verify_time))])])]):_vm._e(),_vm._v(" "),(item.group_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务组长")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(item.group.name)+" "),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+item.group.phone}},[_vm._v(_vm._s(item.group.phone))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.group.phone)}}},[_vm._v("复制")])])]):_vm._e(),_vm._v(" "),(item.worker_id != '')?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_vm._l((item.worker),function(worker,i){return _c('p',{key:i,staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(worker.name)),_c('a',{staticClass:"cm-m-l-12",attrs:{"href":'tel:'+worker.phone}},[_vm._v(_vm._s(worker.phone))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(worker.phone)}}},[_vm._v("复制")])])})],2):_vm._e(),_vm._v(" "),(item.commented > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("回访结果")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(item.comment))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v(_vm._s(item.comment_time))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle button cm-flex-wrap"},[(item.status == 1 && _vm.$func.checkAuth('curtainOrderStatus/2'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignGroup(item.id)}}},[_vm._v("分配组长")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainOrderStatus/2'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignGroup(item.id)}}},[_vm._v("重新分配")]):_vm._e(),_vm._v(" "),(item.status < 3 && _vm.$func.checkAuth('curtainOrderEdit'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.curtainOrderEdit(item.id)}}},[_vm._v("修改订单")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainOrderStatus/3'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignWorker(item.id,index)}}},[_vm._v("分配师傅")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('curtainOrderStatus/3'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.assignWorker(item.id,index)}}},[_vm._v("重新分配")]):_vm._e(),_vm._v(" "),(item.status == 2 && _vm.$func.checkAuth('curtainGrabOrder'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.grabOrder(item.id)}}},[_vm._v("抢单")]):_vm._e(),_vm._v(" "),((item.status == 2 || item.status == 3) && _vm.$func.checkAuth('curtainOrderStatus/4'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('curtainOrderStatus/5'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[(item.type == 1)?_c('span',{staticClass:"cm-color-white"},[_vm._v("拆卸完毕")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("已收取")])]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('curtainOrderStatus/6'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[(item.type == 1)?_c('span',{staticClass:"cm-color-white"},[_vm._v("安装完毕")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("已送回")])]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('curtainTransferOrder'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-p-lr-16 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.transferOrder(item.id)}}},[_vm._v("转单")]):_vm._e(),_vm._v(" "),(item.status > 1 && item.status < 6 && _vm.$func.checkAuth('resetCurtainOrderStatus'))?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.resetCurtainOrderStatus(item.id)}}},[_vm._v("重置订单状态")]):_vm._e(),_vm._v(" "),(item.status < 6 && _vm.$func.checkAuth('cancelCurtainOrder'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.cancelCurtainOrder(item.id)}}},[_vm._v("撤销订单")]):_vm._e(),_vm._v(" "),(item.status > 2 && item.commented < 1 && _vm.$func.checkAuth('curtainOrderComment'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id)}}},[_vm._v("客户回访")]):_vm._e(),_vm._v(" "),(item.status > 2 && item.status < 7 && _vm.$func.checkAuth('curtainSetReward'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.setReward(item.id,index)}}},[(item.amount > 0)?_c('span',{staticClass:"cm-color-white"},[_vm._v("修改佣金")]):_c('span',{staticClass:"cm-color-white"},[_vm._v("设置佣金")])]):_vm._e(),_vm._v(" "),(item.status < 7 && _vm.$func.checkAuth('curtainDiffVerify'))?_c('div',{staticClass:"cm-bg-yellow cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.curtainDiffVerify(item.id)}}},[_vm._v("补差价核销")]):_vm._e(),_vm._v(" "),(_vm.$func.checkAuth('curtainUploadImg'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){_vm.uploadStatus = true}}},[_vm._v("上传图片")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){_vm.addRemarkStatus = true}}},[_vm._v("增加备注")])])])])}),0),_vm._v(" "),(_vm.list[0].diff_order)?_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("补差价核销记录")]),_vm._v(" "),_vm._l((_vm.list[0].diff_orders),function(val,i){return _c('div',{key:i,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-4"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-4 cm-p-lr-2 cm-fn-14"},[_vm._v(_vm._s(i+1)+"、"),_c('span',{staticClass:"cm-fn-weight-default "},[_vm._v(_vm._s(val.order_no))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(val.order_no)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-m-t-12 cm-fn-14 cm-m-l-8 cm-color-orange"},[_vm._v("金额：￥"+_vm._s(val.amount))])])])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("备注记录")]),_vm._v(" "),_c('div',{staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-4 cm-p-lr-8 cm-fn-14"},[_vm._v("1、"),_c('span',{staticClass:"cm-fn-weight-default "},[_vm._v(" 客服备注 ")]),_c('span',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14 cm-m-l-12"},[_vm._v(_vm._s(_vm.list[0].create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4  cm-p-lr-8 cm-fn-14"},[_c('span',{staticClass:"cm-fn-weight-default "}),_vm._v(_vm._s(_vm.list[0].content)+" ")])])]),_vm._v(" "),_vm._l((_vm.list[0].logs),function(val,i){return _c('div',{key:i,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-4 cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(i+2)+"、"),_c('span',{staticClass:"cm-fn-weight-default "},[_vm._v(_vm._s(val.operate))]),_c('span',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14 cm-m-l-12"},[_vm._v(_vm._s(val.create_time))])]),_vm._v(" "),_c('p',{staticClass:" cm-m-t-4 cm-p-lr-8 cm-fn-14"},[_c('span',{staticClass:"cm-fn-weight-default "}),_vm._v(_vm._s(val.remark)+" ")])])])})],2),_vm._v(" "),(_vm.list[0].pics_path.length > 0)?_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("图片记录")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-t-12"},_vm._l((_vm.list[0].pics_path),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-8 cm-m-b-8 cm-border-radius-10",staticStyle:{"width":"30%","height":"80px"}},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(_vm.list[0].pics_path,item)}}})])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-m-lr-8 shadow-gray cm-bg-white cm-p-tb-16 cm-m-t-12"},[_c('p',{staticClass:"cm-color-orange cm-text-left cm-p-lr-12 cm-fn-16"},[_vm._v("订单流程")]),_vm._v(" "),_vm._l((_vm.logs),function(val,i){return _c('div',{key:i,staticClass:"cm-text-left cm-m-t-12 cm-p-lr-12"},[_c('div',{staticClass:" cm-border-bottom-1 cm-p-b-8"},[_c('p',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14"},[_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(val.status_text))]),_vm._v(" "),_c('span',{staticClass:"cm-m-l-12"},[_vm._v(_vm._s(val.operate))]),_vm._v(" "),_c('span',{staticClass:"cm-m-t-12 cm-p-lr-8 cm-fn-14"},[_vm._v(_vm._s(val.create_time))])]),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-p-lr-8 cm-fn-12"},[_vm._v(_vm._s(val.remark)+" ")])])])})],2),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerGroupStatus),callback:function ($$v) {_vm.pickerGroupStatus=$$v},expression:"pickerGroupStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择拆装组","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerGroupStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,2)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.group,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onGroupChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,2)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerWorkerStatus),callback:function ($$v) {_vm.pickerWorkerStatus=$$v},expression:"pickerWorkerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择拆装师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerWorkerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,3)}}}),_vm._v(" "),_c('group',[_c('checklist',{attrs:{"required":"","options":_vm.worker},on:{"on-change":_vm.onWorkerChange},model:{value:(_vm.workerId),callback:function ($$v) {_vm.workerId=$$v},expression:"workerId"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,3)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCommentStatus),callback:function ($$v) {_vm.showCommentStatus=$$v},expression:"showCommentStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入回访结果","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitComment($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCommentStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showResetStatus),callback:function ($$v) {_vm.showResetStatus=$$v},expression:"showResetStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入订单重置原因","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitReset($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showResetStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCancelStatus),callback:function ($$v) {_vm.showCancelStatus=$$v},expression:"showCancelStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入订单撤销原因","height":200,"show-counter":true},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitCancel($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCancelStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),(_vm.showVerifyOrder)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"200px","width":"95%","left":"2%"}},[(_vm.list[_vm.itemIndex].source < 3)?_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入核销订单号")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verifyOrder),expression:"verifyOrder"}],staticClass:"cm-p-lr-8 cm-border cm-p-tb-8 cm-fn-16 ",staticStyle:{"width":"85%"},attrs:{"type":"text","placeholder":"请输入核销订单号"},domProps:{"value":(_vm.verifyOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.verifyOrder=$event.target.value}}})])]):_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入核销金额")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('div',{staticClass:"cm-center cm-fn-18 cm-p-lr-12 cm-p-tb-12 cm-border-radius-8"},[_c('p',{staticClass:"cm-fn-18 cm-color-222"},[_vm._v("金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verifyAmount),expression:"verifyAmount"}],staticClass:"cm-p-lr-8 cm-border cm-p-tb-8 cm-fn-16 cm-m-r-4",staticStyle:{"width":"120px"},attrs:{"type":"number","placeholder":"请输入核销金额"},domProps:{"value":(_vm.verifyAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.verifyAmount=$event.target.value}}}),_vm._v(" 元\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitVerifyOrder()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),(_vm.showDiffVerify)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"200px","width":"95%","left":"2%"}},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入补差价核销订单号")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diffVerifyOrder),expression:"diffVerifyOrder"}],staticClass:"cm-p-lr-8 cm-border cm-p-tb-8 cm-fn-16 ",staticStyle:{"width":"85%"},attrs:{"type":"text","placeholder":"请输入补差价核销订单号"},domProps:{"value":(_vm.diffVerifyOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.diffVerifyOrder=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitDiffVerify()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),_c('popup',{staticClass:"delivery",attrs:{"position":"bottom"},model:{value:(_vm.uploadStatus),callback:function ($$v) {_vm.uploadStatus=$$v},expression:"uploadStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16 cm-mh-100"},[_c('div',{staticClass:"cm-p-b-12 cm-text-left"},[_vm._v("请拍照记录")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list",staticStyle:{"height":"350px","overflow-y":"scroll"}},[_vm._l((_vm.filePath),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item},on:{"click":function($event){return _vm.showPic(_vm.filePath,item)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile()}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-32 cm-p-tb-16 button border-t"},[_c('div',{staticClass:"cm-border cm-p-tb-12 cm-border-radius-5 cm-center cm-p-lr-32",on:{"click":_vm.closeUpload}},[_vm._v("关闭")]),_vm._v(" "),_c('div',{staticClass:"cm-bg-red cm-p-tb-12 cm-border-radius-5 cm-m-l-16 cm-center cm-p-lr-32 cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.submitUpload()}}},[_vm._v("提交")])])])]),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.addRemarkStatus),callback:function ($$v) {_vm.addRemarkStatus=$$v},expression:"addRemarkStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('x-textarea',{attrs:{"placeholder":"请输入备注内容","height":200,"show-counter":true},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitRemark($event)}}},[_vm._v(" 提交 ")]),_vm._v(" "),_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.addRemarkStatus = false}}},[_vm._v(" 关闭 ")])],1)])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.timePop)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请确认上门时间")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('datetime',{staticClass:"cm-color-222  cm-bg-gray",attrs:{"format":"YYYY-MM-DD HH:mm","start-date":_vm.startDate,"minute-list":_vm.minuteList,"min-hour":_vm.minHour,"max-hour":_vm.maxHour,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222 cm-fn-16"},[_vm._v(_vm._s(_vm.home_time))])])],1)]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitEditHomeTime()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e(),_vm._v(" "),(_vm.rewardStatus)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10",staticStyle:{"height":"300px","width":"95%","left":"2%"}},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请设置佣金")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-orange cm-m-t-8"},[_vm._v("佣金组员平分")]),_vm._v(" "),_c('div',{staticClass:"cm-m-t-16 cm-fn-16"},[_c('div',{staticClass:"cm-center cm-fn-18 cm-p-lr-12 cm-p-tb-12 cm-border-radius-8"},[_c('p',{staticClass:"cm-fn-18 cm-color-222"},[_vm._v("金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardAmount),expression:"rewardAmount"}],staticClass:"cm-p-lr-24 cm-border cm-p-tb-8 cm-m-l-12 cm-m-r-12",staticStyle:{"width":"80px"},attrs:{"type":"number","placeholder":"请输入佣金"},domProps:{"value":(_vm.rewardAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rewardAmount=$event.target.value}}}),_vm._v("元\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-ccc cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8 cm-m-r-16",on:{"click":function($event){return _vm.closePop()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.submitReward()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认")])])])]):_vm._e()])}
var curtainOrderInfo_staticRenderFns = []
var curtainOrderInfo_esExports = { render: curtainOrderInfo_render, staticRenderFns: curtainOrderInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainOrderInfo = (curtainOrderInfo_esExports);
// CONCATENATED MODULE: ./src/pages/curtainOrderInfo.vue
function curtainOrderInfo_injectStyle (ssrContext) {
  __webpack_require__("+AI7")
}
var curtainOrderInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainOrderInfo___vue_template_functional__ = false
/* styles */
var curtainOrderInfo___vue_styles__ = curtainOrderInfo_injectStyle
/* scopeId */
var curtainOrderInfo___vue_scopeId__ = "data-v-c4ef2152"
/* moduleIdentifier (server only) */
var curtainOrderInfo___vue_module_identifier__ = null
var curtainOrderInfo_Component = curtainOrderInfo_normalizeComponent(
  pages_curtainOrderInfo,
  selectortype_template_index_0_src_pages_curtainOrderInfo,
  curtainOrderInfo___vue_template_functional__,
  curtainOrderInfo___vue_styles__,
  curtainOrderInfo___vue_scopeId__,
  curtainOrderInfo___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainOrderInfo = (curtainOrderInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainMapOrder.vue














/* harmony default export */ var curtainMapOrder = ({
  name: 'curtainMapOrder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Datetime: vux_src_components_datetime, TransferDom: transfer_dom["a" /* default */], Checklist: vux_src_components_checklist, XButton: vux_src_components_x_button, PopupHeader: vux_src_components_popup_header, Popup: node_modules_vux_src_components_popup
  },

  data: function data() {
    return {
      phone: '',
      datetimeStatus: false,
      pickerWorkerStatus: false,
      startDate: '',
      dateStr: '',
      dateValue: '',
      isActive: 0,
      map: null,
      markerLayer: null,
      infoWindow: null,
      mapReady: false,
      list: [],
      workerId: [],
      grade: 0,
      itemId: 0,
      justOpened: false,
      statusArr: [{
        key: 0,
        value: '全部'
      }, {
        key: 1,
        value: '待分配'
      }, {
        key: 2,
        value: '待分配'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }],
      worker: []
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 23) {
      this.statusArr = [{
        key: 0,
        value: '全部'
      }, {
        key: 2,
        value: '待分配'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }];
      this.getWorker();
    } else if (this.grade == 24) {
      this.statusArr = [{
        key: 0,
        value: '全部'
      }, {
        key: 2,
        value: '待抢单'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }];
    }
    this.isActive = Number(this.$route.params.status) || 0;
    var dateStr = this.$route.params.dateStr || '';
    switch (dateStr) {
      case '':
        this.dateValue = '全部';
        break;
      case 'wait':
        this.dateValue = '未设置';
        break;
      default:
        this.dateValue = dateStr;
        break;
    }
    this.dateStr = dateStr;
    this.getList();
  },
  mounted: function mounted() {
    var _this = this;

    this.loadQQMap().then(function () {
      _this.initMap();
      _this.mapReady = true;
      _this.renderMarkers();
    });
  },

  methods: {
    datetimeChange: function datetimeChange(val) {
      this.dateStr = val;
      this.dateValue = val;
      this.datetimeStatus = false;
      this.getList();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.getList();
    },
    assignWorker: function assignWorker(id) {
      this.itemId = id;
      this.workerId = [];
      this.pickerWorkerStatus = true;
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    changeStatus: function changeStatus() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }

      if (!this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.changeCurtainStatus({ id: _this2.itemId, status: 3, workerId: _this2.workerId.join(',') }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            _this2.$func.showToast('操作成功');
            setTimeout(function () {
              _this2.pickerWorkerStatus = false;
              _this2.list = [];
              _this2.getList();
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this3 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this3.$func.endLoading();
            _this3.$func.showToast('操作成功');
            setTimeout(function () {
              _this3.list = [];
              _this3.getList();
            }, 300);
          }
        });
      });
    },
    getList: function getList() {
      var _this4 = this;

      this.$api.getCurtainMapOrder({ phone: this.phone, status: this.isActive, home_date: this.dateStr }).then(function (res) {
        if (res) {
          _this4.list = Array.isArray(res.data) ? res.data : [];
          _this4.renderMarkers();
        }
      });
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    loadQQMap: function loadQQMap() {
      return new promise_default.a(function (resolve, reject) {
        if (window.TMap) {
          resolve();
          return;
        }
        var s = document.createElement('script');
        s.src = 'https://map.qq.com/api/gljs?v=1.exp&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM';
        s.onload = function () {
          return resolve();
        };
        s.onerror = function (e) {
          return reject(e);
        };
        document.head.appendChild(s);
      });
    },
    initMap: function initMap() {
      var _this6 = this;

      var center = void 0;

      center = new TMap.LatLng(34.26993, 108.94716);

      var el = document.getElementById('cm-map');
      if (el) {
        el.style.position = 'absolute';
        el.style.left = '0px';
        el.style.top = '0px';
        el.style.overflow = 'hidden';
        el.style.zIndex = '10';
        el.style.width = '100%';
        el.style.height = '100%';
      }
      this.map = new TMap.Map(el, { center: center, zoom: 12 });
      if (el) {
        el.style.zIndex = '10';
      }
      this.infoWindow = new TMap.InfoWindow({ position: center, content: '', offset: { x: 0, y: -30 } });
      this.map.on('click', function (evt) {
        if (_this6.pickerWorkerStatus) {

          return;
        }
        if (_this6.infoWindow) {
          if (!_this6.justOpened) {
            _this6.infoWindow.close();
          }
        }
      });
    },
    clearMarkers: function clearMarkers() {
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
        this.markerLayer = null;
      }
      if (this.infoWindow) {
        this.infoWindow.close();
      }
    },
    fitBounds: function fitBounds() {
      if (!this.map) return;
      var items = Array.isArray(this.list) ? this.list.filter(function (it) {
        return it && it.lat && it.lng;
      }) : [];
      if (!items.length) return;
      var bounds = new TMap.LatLngBounds();
      items.forEach(function (item) {
        bounds.extend(new TMap.LatLng(Number(item.lat), Number(item.lng)));
      });
      this.map.fitBounds(bounds, { padding: 20 });
    },
    renderMarkers: function renderMarkers() {
      var _this7 = this;

      if (!this.map) return;
      this.clearMarkers();
      var items = Array.isArray(this.list) ? this.list.filter(function (it) {
        return it && it.lat && it.lng;
      }) : [];
      var geometries = items.map(function (item, idx) {
        return {
          id: String(item.id || idx),
          styleId: 'marker',
          position: new TMap.LatLng(Number(item.lat), Number(item.lng)),
          properties: {
            name: item.name || '',
            phone: item.phone || '',
            province: item.province || '',
            city: item.city || '',
            district: item.district || '',
            address: item.address || '',
            goods_title: item.goods_title || '',
            home_time: item.home_time || '',
            status: typeof item.status === 'number' ? item.status : Number(item.status) || 0
          }
        };
      });
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({})
        },
        geometries: geometries
      });
      this.markerLayer.on('click', function (evt) {
        var g = evt.geometry;
        var p = g.position;
        var canAssign = _this7.grade == 23 && Number(g.properties.status) === 2;
        var canGrab = _this7.grade == 24 && Number(g.properties.status) === 2;
        var actions = canAssign ? '<span id="btnAssign-' + g.id + '" style="background:#FE5649;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">\u5206\u914D\u5E08\u5085</span>' : canGrab ? '<span id="btnGrab-' + g.id + '" style="background:#1AAD19;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">\u62A2\u5355</span>' : '';
        var content = '\n<div style="font-size:12px;line-height:1.6;word-break:break-all;white-space:normal;text-align:left">\n<div>' + g.properties.name + ' ' + g.properties.phone + '</div>\n<div>\u4E0A\u95E8\u65F6\u95F4\uFF1A' + g.properties.home_time + '</div>\n<div>\u670D\u52A1\u9879\u76EE\uFF1A' + g.properties.goods_title + '</div>\n<div>' + g.properties.province + g.properties.city + g.properties.district + '</div>\n<div>' + g.properties.address + '</div>\n<div style="display:flex;justify-content:flex-end;margin-top:5px;">' + actions + '</div>\n</div>\n';
        _this7.justOpened = true;
        _this7.infoWindow.setMap(_this7.map);
        _this7.infoWindow.setPosition(p);
        if (typeof _this7.infoWindow.setOffset === 'function') {
          _this7.infoWindow.setOffset({ x: 0, y: -30 });
        } else {
          var p2 = new TMap.LatLng(p.lat + 0.0006, p.lng);
          _this7.infoWindow.setPosition(p2);
        }
        _this7.infoWindow.setContent(content);
        _this7.infoWindow.open();
        _this7.map.setCenter(p);
        setTimeout(function () {
          _this7.justOpened = false;
        }, 200);
        setTimeout(function () {
          if (canAssign) {
            var btnAssign = document.getElementById('btnAssign-' + g.id);
            if (btnAssign) {
              btnAssign.addEventListener('click', function () {
                return _this7.assignWorker(g.id);
              });
            }
          } else if (canGrab) {
            var btnGrab = document.getElementById('btnGrab-' + g.id);
            if (btnGrab) {
              btnGrab.addEventListener('click', function () {
                return _this7.grabOrder(g.id);
              });
            }
          }
        }, 0);
      });
      if (items.length) {
        this.fitBounds();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainMapOrder.vue














/* harmony default export */ var pages_curtainMapOrder = ({
  name: 'curtainMapOrder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Datetime: vux_src_components_datetime, TransferDom: transfer_dom["a" /* default */], Checklist: vux_src_components_checklist, XButton: vux_src_components_x_button, PopupHeader: vux_src_components_popup_header, Popup: node_modules_vux_src_components_popup
  },

  data: function data() {
    return {
      phone: '',
      datetimeStatus: false,
      pickerWorkerStatus: false,
      startDate: '',
      dateStr: '',
      dateValue: '',
      isActive: 0,
      map: null,
      markerLayer: null,
      infoWindow: null,
      mapReady: false,
      list: [],
      workerId: [],
      grade: 0,
      itemId: 0,
      justOpened: false,
      statusArr: [{
        key: 0,
        value: '全部'
      }, {
        key: 1,
        value: '待分配'
      }, {
        key: 2,
        value: '待分配'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }],
      worker: []
    };
  },
  created: function created() {
    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.grade == 23) {
      this.statusArr = [{
        key: 0,
        value: '全部'
      }, {
        key: 2,
        value: '待分配'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }];
      this.getWorker();
    } else if (this.grade == 24) {
      this.statusArr = [{
        key: 0,
        value: '全部'
      }, {
        key: 2,
        value: '待抢单'
      }, {
        key: 3,
        value: '待上门'
      }, {
        key: 4,
        value: '拆卸中'
      }, {
        key: 5,
        value: '待安装'
      }];
    }
    this.isActive = Number(this.$route.params.status) || 0;
    var dateStr = this.$route.params.dateStr || '';
    switch (dateStr) {
      case '':
        this.dateValue = '全部';
        break;
      case 'wait':
        this.dateValue = '未设置';
        break;
      default:
        this.dateValue = dateStr;
        break;
    }
    this.dateStr = dateStr;
    this.getList();
  },
  mounted: function mounted() {
    var _this = this;

    this.loadQQMap().then(function () {
      _this.initMap();
      _this.mapReady = true;
      _this.renderMarkers();
    });
  },

  methods: {
    datetimeChange: function datetimeChange(val) {
      this.dateStr = val;
      this.dateValue = val;
      this.datetimeStatus = false;
      this.getList();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.getList();
    },
    assignWorker: function assignWorker(id) {
      this.itemId = id;
      this.workerId = [];
      this.pickerWorkerStatus = true;
    },
    onWorkerChange: function onWorkerChange(value) {
      this.workerId = value;
    },
    changeStatus: function changeStatus() {
      var _this2 = this;

      if (!this.itemId) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }

      if (!this.workerId.length) {
        this.$func.showToast('请选择拆装师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$func.startLoading('请求中。。。');
        _this2.$api.changeCurtainStatus({ id: _this2.itemId, status: 3, workerId: _this2.workerId.join(',') }).then(function (res) {
          if (res) {
            _this2.$func.endLoading();
            _this2.$func.showToast('操作成功');
            setTimeout(function () {
              _this2.pickerWorkerStatus = false;
              _this2.list = [];
              _this2.getList();
            }, 300);
          }
        });
      });
    },
    grabOrder: function grabOrder(id) {
      var _this3 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认抢单？', '提示', function () {
        _this3.$func.startLoading('请求中。。。');
        _this3.$api.curtainGrabOrder({ id: id }).then(function (res) {
          if (res) {
            _this3.$func.endLoading();
            _this3.$func.showToast('操作成功');
            setTimeout(function () {
              _this3.list = [];
              _this3.getList();
            }, 300);
          }
        });
      });
    },
    getList: function getList() {
      var _this4 = this;

      this.$api.getCurtainMapOrder({ phone: this.phone, status: this.isActive, home_date: this.dateStr }).then(function (res) {
        if (res) {
          _this4.list = Array.isArray(res.data) ? res.data : [];
          _this4.renderMarkers();
        }
      });
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getCurtainWorker({}).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    loadQQMap: function loadQQMap() {
      return new promise_default.a(function (resolve, reject) {
        if (window.TMap) {
          resolve();
          return;
        }
        var s = document.createElement('script');
        s.src = 'https://map.qq.com/api/gljs?v=1.exp&key=X4PBZ-RCUC4-36BUD-FCVYG-OWXRQ-OSBPM';
        s.onload = function () {
          return resolve();
        };
        s.onerror = function (e) {
          return reject(e);
        };
        document.head.appendChild(s);
      });
    },
    initMap: function initMap() {
      var _this6 = this;

      var center = void 0;

      center = new TMap.LatLng(34.26993, 108.94716);

      var el = document.getElementById('cm-map');
      if (el) {
        el.style.position = 'absolute';
        el.style.left = '0px';
        el.style.top = '0px';
        el.style.overflow = 'hidden';
        el.style.zIndex = '10';
        el.style.width = '100%';
        el.style.height = '100%';
      }
      this.map = new TMap.Map(el, { center: center, zoom: 12 });
      if (el) {
        el.style.zIndex = '10';
      }
      this.infoWindow = new TMap.InfoWindow({ position: center, content: '', offset: { x: 0, y: -30 } });
      this.map.on('click', function (evt) {
        if (_this6.pickerWorkerStatus) {

          return;
        }
        if (_this6.infoWindow) {
          if (!_this6.justOpened) {
            _this6.infoWindow.close();
          }
        }
      });
    },
    clearMarkers: function clearMarkers() {
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
        this.markerLayer = null;
      }
      if (this.infoWindow) {
        this.infoWindow.close();
      }
    },
    fitBounds: function fitBounds() {
      if (!this.map) return;
      var items = Array.isArray(this.list) ? this.list.filter(function (it) {
        return it && it.lat && it.lng;
      }) : [];
      if (!items.length) return;
      var bounds = new TMap.LatLngBounds();
      items.forEach(function (item) {
        bounds.extend(new TMap.LatLng(Number(item.lat), Number(item.lng)));
      });
      this.map.fitBounds(bounds, { padding: 20 });
    },
    renderMarkers: function renderMarkers() {
      var _this7 = this;

      if (!this.map) return;
      this.clearMarkers();
      var items = Array.isArray(this.list) ? this.list.filter(function (it) {
        return it && it.lat && it.lng;
      }) : [];
      var geometries = items.map(function (item, idx) {
        return {
          id: String(item.id || idx),
          styleId: 'marker',
          position: new TMap.LatLng(Number(item.lat), Number(item.lng)),
          properties: {
            name: item.name || '',
            phone: item.phone || '',
            province: item.province || '',
            city: item.city || '',
            district: item.district || '',
            address: item.address || '',
            goods_title: item.goods_title || '',
            home_time: item.home_time || '',
            status: typeof item.status === 'number' ? item.status : Number(item.status) || 0
          }
        };
      });
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({})
        },
        geometries: geometries
      });
      this.markerLayer.on('click', function (evt) {
        var g = evt.geometry;
        var p = g.position;
        var canAssign = _this7.grade == 23 && Number(g.properties.status) === 2;
        var canGrab = _this7.grade == 24 && Number(g.properties.status) === 2;
        var actions = canAssign ? '<span id="btnAssign-' + g.id + '" style="background:#FE5649;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">\u5206\u914D\u5E08\u5085</span>' : canGrab ? '<span id="btnGrab-' + g.id + '" style="background:#1AAD19;color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;cursor:pointer;">\u62A2\u5355</span>' : '';
        var content = '\n<div style="font-size:12px;line-height:1.6;word-break:break-all;white-space:normal;text-align:left">\n<div>' + g.properties.name + ' ' + g.properties.phone + '</div>\n<div>\u4E0A\u95E8\u65F6\u95F4\uFF1A' + g.properties.home_time + '</div>\n<div>\u670D\u52A1\u9879\u76EE\uFF1A' + g.properties.goods_title + '</div>\n<div>' + g.properties.province + g.properties.city + g.properties.district + '</div>\n<div>' + g.properties.address + '</div>\n<div style="display:flex;justify-content:flex-end;margin-top:5px;">' + actions + '</div>\n</div>\n';
        _this7.justOpened = true;
        _this7.infoWindow.setMap(_this7.map);
        _this7.infoWindow.setPosition(p);
        if (typeof _this7.infoWindow.setOffset === 'function') {
          _this7.infoWindow.setOffset({ x: 0, y: -30 });
        } else {
          var p2 = new TMap.LatLng(p.lat + 0.0006, p.lng);
          _this7.infoWindow.setPosition(p2);
        }
        _this7.infoWindow.setContent(content);
        _this7.infoWindow.open();
        _this7.map.setCenter(p);
        setTimeout(function () {
          _this7.justOpened = false;
        }, 200);
        setTimeout(function () {
          if (canAssign) {
            var btnAssign = document.getElementById('btnAssign-' + g.id);
            if (btnAssign) {
              btnAssign.addEventListener('click', function () {
                return _this7.assignWorker(g.id);
              });
            }
          } else if (canGrab) {
            var btnGrab = document.getElementById('btnGrab-' + g.id);
            if (btnGrab) {
              btnGrab.addEventListener('click', function () {
                return _this7.grabOrder(g.id);
              });
            }
          }
        }, 0);
      });
      if (items.length) {
        this.fitBounds();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b95af20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainMapOrder.vue
var curtainMapOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-flex-between cm-m-lr-12  cm-border-bottom-1 cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-p-tb-8"},[_vm._v("上门时间")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222",attrs:{"format":"YYYY-MM-DD","start-date":_vm.startDate,"show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[_c('span',{staticClass:"cm-color-222 cm-fn-16"},[_vm._v(_vm._s(_vm.dateValue))])])],1),_vm._v(" "),_c('div',{staticClass:"cm-bg-white cm-p-tb-4",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-12 cm-flex-middle cm-flex-between"},_vm._l((_vm.statusArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-fn-16 cm-p-tb-2 cm-p-lr-4",class:[_vm.isActive === item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectStatus(item.key)}}},[_vm._v("\n              "+_vm._s(item.value)+"\n          ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"cm-map",attrs:{"id":"cm-map"}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","hide-on-blur":true},model:{value:(_vm.pickerWorkerStatus),callback:function ($$v) {_vm.pickerWorkerStatus=$$v},expression:"pickerWorkerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择拆装师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerWorkerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,3)}}}),_vm._v(" "),_c('group',[_c('checklist',{attrs:{"required":"","options":_vm.worker},on:{"on-change":_vm.onWorkerChange},model:{value:(_vm.workerId),callback:function ($$v) {_vm.workerId=$$v},expression:"workerId"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus()}}},[_vm._v(" 确认 ")])],1)],1)],1)])}
var curtainMapOrder_staticRenderFns = []
var curtainMapOrder_esExports = { render: curtainMapOrder_render, staticRenderFns: curtainMapOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainMapOrder = (curtainMapOrder_esExports);
// CONCATENATED MODULE: ./src/pages/curtainMapOrder.vue
function curtainMapOrder_injectStyle (ssrContext) {
  __webpack_require__("7ozb")
}
var curtainMapOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainMapOrder___vue_template_functional__ = false
/* styles */
var curtainMapOrder___vue_styles__ = curtainMapOrder_injectStyle
/* scopeId */
var curtainMapOrder___vue_scopeId__ = "data-v-6b95af20"
/* moduleIdentifier (server only) */
var curtainMapOrder___vue_module_identifier__ = null
var curtainMapOrder_Component = curtainMapOrder_normalizeComponent(
  pages_curtainMapOrder,
  selectortype_template_index_0_src_pages_curtainMapOrder,
  curtainMapOrder___vue_template_functional__,
  curtainMapOrder___vue_styles__,
  curtainMapOrder___vue_scopeId__,
  curtainMapOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainMapOrder = (curtainMapOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainWorker.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var curtainWorker = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getWorkerList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        changStatus: function changStatus(id, status) {
            var _this2 = this;

            this.$func.confirm('确认操作？', '提示', function () {
                _this2.$func.startLoading('请求中。。。');
                _this2.$api.changeCurtainWorkerStatus({ id: id, status: status }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        _this2.search();
                    }
                });
            });
        },
        del: function del(id) {
            var _this3 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this3.$func.startLoading('请求中。。。');
                _this3.$api.curtainDeleteWorker({ id: id }).then(function (res) {
                    if (res) {
                        _this3.$func.endLoading();
                        _this3.$func.showToast('操作成功');
                        _this3.search();
                    }
                });
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'curtainAddWorker', params: { id: id } });
        },

        // rebate(id){
        //     this.$router.push({name:'rebate',params:{uid:0,otherId:id}})
        // },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainWorker.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_curtainWorker = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore
    },
    data: function data() {
        return {
            keyword: '',
            blankShow: false,
            loadStatus: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            list: [],
            where: [],
            hasNext: 0,
            pageFlag: 2,
            lastId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getWorkerList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        changStatus: function changStatus(id, status) {
            var _this2 = this;

            this.$func.confirm('确认操作？', '提示', function () {
                _this2.$func.startLoading('请求中。。。');
                _this2.$api.changeCurtainWorkerStatus({ id: id, status: status }).then(function (res) {
                    if (res) {
                        _this2.$func.endLoading();
                        _this2.$func.showToast('操作成功');
                        _this2.search();
                    }
                });
            });
        },
        del: function del(id) {
            var _this3 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this3.$func.startLoading('请求中。。。');
                _this3.$api.curtainDeleteWorker({ id: id }).then(function (res) {
                    if (res) {
                        _this3.$func.endLoading();
                        _this3.$func.showToast('操作成功');
                        _this3.search();
                    }
                });
            });
        },
        info: function info(id) {
            this.$router.push({ name: 'curtainAddWorker', params: { id: id } });
        },

        // rebate(id){
        //     this.$router.push({name:'rebate',params:{uid:0,otherId:id}})
        // },
        loadmore: function loadmore() {
            var _this4 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this4.blankShow) {
                    _this4.busy = true;
                    _this4.loadStatus = false;
                    _this4.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this4.hasNext > 0) {
                        _this4.loadStatus = false;
                        _this4.busy = false;
                    } else {
                        _this4.busy = true;
                        _this4.loadStatus = true;
                        _this4.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c62125f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainWorker.vue
var curtainWorker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-bg-gray"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8",staticStyle:{"width":"66%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"姓名/手机号关键字查询"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-16 cm-p-tb-8 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.info(0)}}},[_vm._v("添加")])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"cm-m-lr-8",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"shadow-gray cm-m-t-12 cm-bg-white"},[_c('div',{staticClass:"cm-p-lr-8"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-color-orange cm-fn-16 overflow-line-1"},[_vm._v(_vm._s(index+1)+"、"+_vm._s(item.name))]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(item.phone)+" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.phone)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-8"},[_c('p',{},[_vm._v("登录账号："+_vm._s(item.account)+" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.account)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('p',{staticClass:" "},[_vm._v("收益统计：")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle",staticStyle:{"width":"78%"}},[_c('p',{staticClass:"cm-color-blue"},[_vm._v("今日：￥"+_vm._s(item.day_reward))]),_vm._v(" "),_c('p',{staticClass:"cm-color-green"},[_vm._v("本月：￥"+_vm._s(item.month_reward))]),_vm._v(" "),_c('p',{staticClass:"cm-color-orange"},[_vm._v("累计：￥"+_vm._s(item.total_reward))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-p-tb-12"},[(item.status == 1)?_c('div',{staticClass:"cm-border  cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.info(item.id)}}},[_vm._v("修改")]):_vm._e(),_vm._v(" "),(item.status == 1)?_c('div',{staticClass:"cm-border  cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-bg-orange cm-color-white cm-border-radius-4 ",on:{"click":function($event){return _vm.changStatus(item.id,0)}}},[_vm._v("关闭")]):_c('div',{staticClass:"cm-border  cm-bg-blue cm-color-white cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-border-radius-4",on:{"click":function($event){return _vm.changStatus(item.id,1)}}},[_vm._v("开启")]),_vm._v(" "),_c('div',{staticClass:"cm-border  cm-p-lr-12 cm-p-tb-4 cm-m-r-12 cm-bg-red cm-color-white cm-border-radius-4",on:{"click":function($event){return _vm.del(item.id)}}},[_vm._v("删除")])])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var curtainWorker_staticRenderFns = []
var curtainWorker_esExports = { render: curtainWorker_render, staticRenderFns: curtainWorker_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainWorker = (curtainWorker_esExports);
// CONCATENATED MODULE: ./src/pages/curtainWorker.vue
function curtainWorker_injectStyle (ssrContext) {
  __webpack_require__("Ereq")
}
var curtainWorker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainWorker___vue_template_functional__ = false
/* styles */
var curtainWorker___vue_styles__ = curtainWorker_injectStyle
/* scopeId */
var curtainWorker___vue_scopeId__ = "data-v-0c62125f"
/* moduleIdentifier (server only) */
var curtainWorker___vue_module_identifier__ = null
var curtainWorker_Component = curtainWorker_normalizeComponent(
  pages_curtainWorker,
  selectortype_template_index_0_src_pages_curtainWorker,
  curtainWorker___vue_template_functional__,
  curtainWorker___vue_styles__,
  curtainWorker___vue_scopeId__,
  curtainWorker___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainWorker = (curtainWorker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainAddWorker.vue






/* harmony default export */ var pages_curtainAddWorker = ({
  name: 'curtainAddWorker',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        name: '',
        phone: '',
        account: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getWorker();
    }
  },

  methods: {
    getWorker: function getWorker() {
      var _this = this;

      this.$api.getWorkerList({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入姓名');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入电话');
        return false;
      }
      if (!this.formData.account) {
        this.$func.showToast('请输入登录账号');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$api.curtainAddWorker(_this2.formData).then(function (res) {
          if (res) {
            _this2.$func.showToast('提交成功');
            setTimeout(function () {
              _this2.$router.go(-1);
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/curtainAddWorker.vue






/* harmony default export */ var selectortype_script_index_0_src_pages_curtainAddWorker = ({
  name: 'curtainAddWorker',
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        name: '',
        phone: '',
        account: ''
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getWorker();
    }
  },

  methods: {
    getWorker: function getWorker() {
      var _this = this;

      this.$api.getWorkerList({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this.formData = res.data;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.formData.name) {
        this.$func.showToast('请输入姓名');
        return false;
      }
      if (!this.formData.phone) {
        this.$func.showToast('请输入电话');
        return false;
      }
      if (!this.formData.account) {
        this.$func.showToast('请输入登录账号');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this2.$api.curtainAddWorker(_this2.formData).then(function (res) {
          if (res) {
            _this2.$func.showToast('提交成功');
            setTimeout(function () {
              _this2.$router.go(-1);
            }, 300);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3383424a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/curtainAddWorker.vue
var curtainAddWorker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入姓名"},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","placeholder":"请输入电话"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("登录账号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.account),expression:"formData.account"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入登录账号"},domProps:{"value":(_vm.formData.account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "account", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var curtainAddWorker_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-text-left cm-p-tb-4 cm-m-t-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-orange"},[_vm._v("注：默认登录密码为：123456")])])}]
var curtainAddWorker_esExports = { render: curtainAddWorker_render, staticRenderFns: curtainAddWorker_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_curtainAddWorker = (curtainAddWorker_esExports);
// CONCATENATED MODULE: ./src/pages/curtainAddWorker.vue
function curtainAddWorker_injectStyle (ssrContext) {
  __webpack_require__("G9bI")
}
var curtainAddWorker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var curtainAddWorker___vue_template_functional__ = false
/* styles */
var curtainAddWorker___vue_styles__ = curtainAddWorker_injectStyle
/* scopeId */
var curtainAddWorker___vue_scopeId__ = "data-v-3383424a"
/* moduleIdentifier (server only) */
var curtainAddWorker___vue_module_identifier__ = null
var curtainAddWorker_Component = curtainAddWorker_normalizeComponent(
  selectortype_script_index_0_src_pages_curtainAddWorker,
  selectortype_template_index_0_src_pages_curtainAddWorker,
  curtainAddWorker___vue_template_functional__,
  curtainAddWorker___vue_styles__,
  curtainAddWorker___vue_scopeId__,
  curtainAddWorker___vue_module_identifier__
)

/* harmony default export */ var src_pages_curtainAddWorker = (curtainAddWorker_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createWashOrder.vue









/* harmony default export */ var pages_createWashOrder = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      clotheShow: false,
      rechargePop: false,
      colorShow: false,
      flawShow: false,
      clotheShowStatus: true,
      bagCode: '',
      totalAmount: 0,
      expressAmount: 0,
      order_no: '',
      type: 0,
      number: 0,
      order: {
        community: {
          name: ''
        }
      },
      froms: [],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      expressFee: [],
      info: {},
      operation: '',
      orderGoods: '',
      userOrderGoods: [],
      phone: '',
      collectOrders: []
    };
  },
  created: function created() {

    this.phone = this.$route.params.phone;
    this.orderGoods = this.$route.params.orderGoods;
    this.collectOrders = this.parseCollectOrders();
    if (this.collectOrders.length > 0) {
      this.clotheShowStatus = false;
      this.getUserCollectOrders();
    } else if (this.phone) {
      this.clotheShowStatus = false;
      this.getUserCollectOrder();
    } else {
      this.clotheShowStatus = true;
      this.createClotheShow();
    }
    this.getWashCategoryGoods();
  },
  mounted: function mounted() {
    this.config();
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    synLastUser: function synLastUser(index) {
      if (index > 0) {
        var row = this.froms[index - 1];
        this.froms[index].name = row.name;
        this.froms[index].phone = row.phone;
      }
    },
    removeModules: function removeModules(index) {
      var that = this;
      var row = this.froms[index];
      if (row.is_package > 0) {
        that.$func.confirm('确定删除套餐所有衣物吗？', '提示', function () {
          that.froms = that.froms.filter(function (val) {
            return Number(val.key) !== Number(row.key);
          });
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      } else {
        that.$func.confirm('确认删除 ”衣物' + (index + 1) + '“ 吗？', '提示', function () {
          that.froms.splice(index, 1);
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      }
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.froms[index].bag_code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getUserCollectOrder: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this2 = this;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$api.getUserCollectOrder({ phone: this.phone, orderGoods: this.orderGoods }).then(function (res) {
                  if (res) {

                    _this2.clotheShowStatus = false;
                    _this2.flawIndex = 0;
                    _this2.froms = res.data;
                    _this2.countPrice();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserCollectOrder() {
        return _ref.apply(this, arguments);
      }

      return getUserCollectOrder;
    }(),
    parseCollectOrders: function parseCollectOrders() {
      var collectOrders = this.$route.query.collectOrders || '';
      if (!collectOrders) {
        return [];
      }
      try {
        var rows = JSON.parse(collectOrders);
        return Array.isArray(rows) ? rows.filter(function (item) {
          return item.phone && item.orderGoods && item.orderGoods.length > 0;
        }) : [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    getUserCollectOrders: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, res;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$func.startLoading('请求中...');
                _context2.prev = 1;
                list = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;
                _iterator = get_iterator_default()(this.collectOrders);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 17;
                  break;
                }

                item = _step.value;
                _context2.next = 12;
                return this.$api.getUserCollectOrder({
                  phone: item.phone,
                  orderGoods: stringify_default()(item.orderGoods)
                });

              case 12:
                res = _context2.sent;

                if (res && res.data) {
                  list = list.concat(res.data);
                }

              case 14:
                _iteratorNormalCompletion = true;
                _context2.next = 8;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                this.clotheShowStatus = false;
                this.flawIndex = 0;
                this.froms = list;
                this.countPrice();

              case 35:
                _context2.prev = 35;

                this.$func.endLoading();
                return _context2.finish(35);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 35, 38], [6, 19, 23, 31], [24,, 26, 30]]);
      }));

      function getUserCollectOrders() {
        return _ref2.apply(this, arguments);
      }

      return getUserCollectOrders;
    }(),
    getWashCategoryGoods: function getWashCategoryGoods() {
      var _this3 = this;

      this.$api.getWashCategoryGoods({}).then(function (res) {
        if (res) {
          _this3.clothes = res.data.goods;

          _this3.expressFee = res.data.expressFee;
          _this3.flaws = res.data.flaw;
          if (_this3.froms.length > 0) {
            _this3.countPrice();
          }
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'edit';
    },
    createClotheShow: function createClotheShow() {
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'add';
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.clotheShow = false;
      this.flawShow = false;
      this.clotheIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    flawSelect: function flawSelect(i, title) {
      var _this4 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this4.froms[_this4.flawIndex].flaw += index == flaw.length - 1 ? _this4.flaws[item].title : _this4.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    clotheSelect: function clotheSelect(i) {
      var row = this.clothes[i];
      var key = Date.now();
      if (this.operation == 'add') {
        if (row.is_package > 0) {
          var price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: '',
              phone: '',
              bag_code: '',
              remark: '',
              clothe_id: row.id,
              price: price,
              clothe: row.title + '_' + (j + 1),
              filePath: [],
              pics: [],
              flaw_id: [],
              flaw: '选择瑕疵'
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: '',
            phone: '',
            bag_code: '',
            remark: '',
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: [],
            pics: [],
            flaw_id: [],
            flaw: '选择瑕疵'
          });
        }
      } else {
        var item = this.froms[this.clotheIndex];
        if (item.is_package > 0) {
          this.froms = this.froms.filter(function (val) {
            return Number(val.key) !== Number(item.key);
          });
        } else {
          this.froms.splice(this.clotheIndex, 1);
        }
        if (row.is_package > 0) {
          var _price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: item.name,
              phone: item.phone,
              bag_code: '',
              remark: item.remark,
              clothe_id: row.id,
              price: _price,
              clothe: row.title + '_' + (j + 1),
              filePath: item.filePath,
              pics: item.pics
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: item.name,
            phone: item.phone,
            bag_code: '',
            remark: item.remark,
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: item.filePath,
            pics: item.pics
          });
        }
      }
      this.countPrice();
      this.closePop();
    },
    countPrice: function countPrice() {
      var that = this,
          exAmount = 0,
          number1 = 0;
      number1 = this.froms.filter(function (item) {
        return item.is_package == 0;
      }).length;
      console.log('number1', number1);
      if (number1 > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.expressFee), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (item.num >= number1) {
              exAmount = item.amount;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.number = this.froms.length;
      this.expressAmount = exAmount;
      this.totalAmount = 0;
      this.froms.forEach(function (item, index) {
        that.totalAmount += Number(item.price);
      });
      this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
    },
    submit: function submit() {
      var _this5 = this;

      var that = this;
      if (!this.subStatus) {
        return false;
      }
      that.$func.confirm('确认提交？', '提示', function () {
        _this5.$func.startLoading('请求中...');
        that.$api.createWashOrder({ goods: stringify_default()(that.froms) }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            if (res.data.amount > 0) {
              WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  that.$func.showToast('支付成功');
                  that.subStatus = true;
                  setTimeout(function () {
                    if (that.clotheShowStatus) {
                      window.location.reload();
                    } else {
                      that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                    }
                  }, 300);
                } else {
                  that.$func.showToast('已取消支付');
                }
                that.closePop();
              });
            } else {
              that.$func.showToast('提交成功');
              that.subStatus = true;

              setTimeout(function () {
                if (that.clotheShowStatus) {
                  window.location.reload();
                } else {
                  that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                }
              }, 300);
            }
          }
        });
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createWashOrder.vue









/* harmony default export */ var selectortype_script_index_0_src_pages_createWashOrder = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      clotheShow: false,
      rechargePop: false,
      colorShow: false,
      flawShow: false,
      clotheShowStatus: true,
      bagCode: '',
      totalAmount: 0,
      expressAmount: 0,
      order_no: '',
      type: 0,
      number: 0,
      order: {
        community: {
          name: ''
        }
      },
      froms: [],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      expressFee: [],
      info: {},
      operation: '',
      orderGoods: '',
      userOrderGoods: [],
      phone: '',
      collectOrders: []
    };
  },
  created: function created() {

    this.phone = this.$route.params.phone;
    this.orderGoods = this.$route.params.orderGoods;
    this.collectOrders = this.parseCollectOrders();
    if (this.collectOrders.length > 0) {
      this.clotheShowStatus = false;
      this.getUserCollectOrders();
    } else if (this.phone) {
      this.clotheShowStatus = false;
      this.getUserCollectOrder();
    } else {
      this.clotheShowStatus = true;
      this.createClotheShow();
    }
    this.getWashCategoryGoods();
  },
  mounted: function mounted() {
    this.config();
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this.info = res.data;
        }
      });
    },
    synLastUser: function synLastUser(index) {
      if (index > 0) {
        var row = this.froms[index - 1];
        this.froms[index].name = row.name;
        this.froms[index].phone = row.phone;
      }
    },
    removeModules: function removeModules(index) {
      var that = this;
      var row = this.froms[index];
      if (row.is_package > 0) {
        that.$func.confirm('确定删除套餐所有衣物吗？', '提示', function () {
          that.froms = that.froms.filter(function (val) {
            return Number(val.key) !== Number(row.key);
          });
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      } else {
        that.$func.confirm('确认删除 ”衣物' + (index + 1) + '“ 吗？', '提示', function () {
          that.froms.splice(index, 1);
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      }
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.froms[index].bag_code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getUserCollectOrder: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this2 = this;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$api.getUserCollectOrder({ phone: this.phone, orderGoods: this.orderGoods }).then(function (res) {
                  if (res) {

                    _this2.clotheShowStatus = false;
                    _this2.flawIndex = 0;
                    _this2.froms = res.data;
                    _this2.countPrice();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserCollectOrder() {
        return _ref.apply(this, arguments);
      }

      return getUserCollectOrder;
    }(),
    parseCollectOrders: function parseCollectOrders() {
      var collectOrders = this.$route.query.collectOrders || '';
      if (!collectOrders) {
        return [];
      }
      try {
        var rows = JSON.parse(collectOrders);
        return Array.isArray(rows) ? rows.filter(function (item) {
          return item.phone && item.orderGoods && item.orderGoods.length > 0;
        }) : [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    getUserCollectOrders: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, res;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$func.startLoading('请求中...');
                _context2.prev = 1;
                list = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;
                _iterator = get_iterator_default()(this.collectOrders);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 17;
                  break;
                }

                item = _step.value;
                _context2.next = 12;
                return this.$api.getUserCollectOrder({
                  phone: item.phone,
                  orderGoods: stringify_default()(item.orderGoods)
                });

              case 12:
                res = _context2.sent;

                if (res && res.data) {
                  list = list.concat(res.data);
                }

              case 14:
                _iteratorNormalCompletion = true;
                _context2.next = 8;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                this.clotheShowStatus = false;
                this.flawIndex = 0;
                this.froms = list;
                this.countPrice();

              case 35:
                _context2.prev = 35;

                this.$func.endLoading();
                return _context2.finish(35);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 35, 38], [6, 19, 23, 31], [24,, 26, 30]]);
      }));

      function getUserCollectOrders() {
        return _ref2.apply(this, arguments);
      }

      return getUserCollectOrders;
    }(),
    getWashCategoryGoods: function getWashCategoryGoods() {
      var _this3 = this;

      this.$api.getWashCategoryGoods({}).then(function (res) {
        if (res) {
          _this3.clothes = res.data.goods;

          _this3.expressFee = res.data.expressFee;
          _this3.flaws = res.data.flaw;
          if (_this3.froms.length > 0) {
            _this3.countPrice();
          }
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'edit';
    },
    createClotheShow: function createClotheShow() {
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'add';
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.clotheShow = false;
      this.flawShow = false;
      this.clotheIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    flawSelect: function flawSelect(i, title) {
      var _this4 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this4.froms[_this4.flawIndex].flaw += index == flaw.length - 1 ? _this4.flaws[item].title : _this4.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    clotheSelect: function clotheSelect(i) {
      var row = this.clothes[i];
      var key = Date.now();
      if (this.operation == 'add') {
        if (row.is_package > 0) {
          var price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: '',
              phone: '',
              bag_code: '',
              remark: '',
              clothe_id: row.id,
              price: price,
              clothe: row.title + '_' + (j + 1),
              filePath: [],
              pics: [],
              flaw_id: [],
              flaw: '选择瑕疵'
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: '',
            phone: '',
            bag_code: '',
            remark: '',
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: [],
            pics: [],
            flaw_id: [],
            flaw: '选择瑕疵'
          });
        }
      } else {
        var item = this.froms[this.clotheIndex];
        if (item.is_package > 0) {
          this.froms = this.froms.filter(function (val) {
            return Number(val.key) !== Number(item.key);
          });
        } else {
          this.froms.splice(this.clotheIndex, 1);
        }
        if (row.is_package > 0) {
          var _price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: item.name,
              phone: item.phone,
              bag_code: '',
              remark: item.remark,
              clothe_id: row.id,
              price: _price,
              clothe: row.title + '_' + (j + 1),
              filePath: item.filePath,
              pics: item.pics
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: item.name,
            phone: item.phone,
            bag_code: '',
            remark: item.remark,
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: item.filePath,
            pics: item.pics
          });
        }
      }
      this.countPrice();
      this.closePop();
    },
    countPrice: function countPrice() {
      var that = this,
          exAmount = 0,
          number1 = 0;
      number1 = this.froms.filter(function (item) {
        return item.is_package == 0;
      }).length;
      console.log('number1', number1);
      if (number1 > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.expressFee), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (item.num >= number1) {
              exAmount = item.amount;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.number = this.froms.length;
      this.expressAmount = exAmount;
      this.totalAmount = 0;
      this.froms.forEach(function (item, index) {
        that.totalAmount += Number(item.price);
      });
      this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
    },
    submit: function submit() {
      var _this5 = this;

      var that = this;
      if (!this.subStatus) {
        return false;
      }
      that.$func.confirm('确认提交？', '提示', function () {
        _this5.$func.startLoading('请求中...');
        that.$api.createWashOrder({ goods: stringify_default()(that.froms) }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            if (res.data.amount > 0) {
              WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  that.$func.showToast('支付成功');
                  that.subStatus = true;
                  setTimeout(function () {
                    if (that.clotheShowStatus) {
                      window.location.reload();
                    } else {
                      that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                    }
                  }, 300);
                } else {
                  that.$func.showToast('已取消支付');
                }
                that.closePop();
              });
            } else {
              that.$func.showToast('提交成功');
              that.subStatus = true;

              setTimeout(function () {
                if (that.clotheShowStatus) {
                  window.location.reload();
                } else {
                  that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                }
              }, 300);
            }
          }
        });
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c5288e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/createWashOrder.vue
var createWashOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-p-b-32"},[_c('div',{staticClass:"cm-bg-white cm-p-b-32 cm-p-t-12 "},[(_vm.froms.length > 0)?_c('div',{staticClass:"cm-p-lr-8"},_vm._l((_vm.froms),function(item,index){return _c('div',{key:index,staticClass:" cm-p-lr-8 cm-m-t-8 shadow-gray"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12"},[_c('p',{staticClass:"cm-color-blue  cm-text-left cm-fn-16"},[_vm._v("衣物"+_vm._s(index+1))]),_vm._v(" "),(index > 0)?_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-8 cm-bg-green cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.synLastUser(index)}}},[_vm._v("同步上一件用户信息")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-8 cm-bg-orange cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.removeModules(index)}}},[_vm._v("删除")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("扎带码")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.bag_code),expression:"item.bag_code"}],staticClass:"cm-fn-16 cm-color-red cm-text-left",attrs:{"type":"text","placeholder":"请输入扎带码或扫码"},domProps:{"value":(item.bag_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "bag_code", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1,index)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("顾客姓名")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"}],staticClass:"cm-fn-16 cm-color-333 cm-fn-weight-default cm-m-r-12 cm-text-right cm-w-100 cm-p-tb-4 ",attrs:{"type":"text","placeholder":"输入姓名"},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}}),_vm._v(" "),(item.name)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){item.name = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("顾客电话")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.phone),expression:"item.phone"}],staticClass:"cm-fn-16 cm-text-right cm-m-r-12 cm-color-orange cm-p-tb-4 ",attrs:{"type":"number","placeholder":"输入电话"},domProps:{"value":(item.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "phone", $event.target.value)}}}),_vm._v(" "),(item.phone)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){item.phone = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("下单衣物")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheShow(index)}}},[_c('p',{staticClass:"cm-fn-16",class:[item.clothe_id > 0 ? 'cm-color-orange' : 'cm-color-666']},[_vm._v(_vm._s(item.clothe)+" "),(item.clothe_id > 0)?_c('span',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v("（￥"+_vm._s(item.price)+"）")]):_vm._e()]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物瑕疵")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheFlaw(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.flaw))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('p',{staticClass:"cm-fn-15 cm-m-t-12"},[_vm._v("衣物图片")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((item.filePath),function(val,i){return _c('li',{key:i,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(index,i)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index,i)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile(index)}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("备注")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":100,"placeholder":"100字以内（选填）","height":30},model:{value:(item.remark),callback:function ($$v) {_vm.$set(item, "remark", $$v)},expression:"item.remark"}})],1)],1)])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom cm-bg-white shadow-gray cm-w-100 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-lr-16"},[_c('p',{staticClass:"cm-fn-20 cm-fn-500 cm-m-l-16 cm-color-orange"},[_vm._v(_vm._s(_vm.number)+"件")]),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-m-l-16 "},[_c('p',[_vm._v("合计:"),_c('span',{staticClass:"cm-fn-20 cm-color-orange "},[_vm._v("￥"+_vm._s(_vm.totalAmount))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-10"},[_vm._v("含物流费:"),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.expressAmount))])])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-16 cm-fn-16 cm-center cm-color-white cm-bg-red",staticStyle:{"width":"35%"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交订单")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clotheShow),expression:"clotheShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.clothes),function(val,i){return _c('div',{key:i,staticClass:"cm-p-tb-4 cm-p-lr-8 cm-m-t-4 shadow-gray cm-border-radius-8 cm-m-r-12",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-bg-orange ' :'cm-bg-white',on:{"click":function($event){return _vm.clotheSelect(i)}}},[_c('div',{staticClass:"cm-center cm-img-box cm-border-radius-4"},[_c('img',{staticClass:"cm-img",attrs:{"src":val.pic_path}})]),_vm._v(" "),_c('p',{staticClass:"cm-text-center cm-m-t-4",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-color-white' :''},[_vm._v(_vm._s(val.title))]),_vm._v(" "),_c('p',{staticClass:"cm-text-center",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-color-white' :''},[_vm._v("￥"+_vm._s(val.price))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flawShow),expression:"flawShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.flaws),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:_vm.froms[_vm.flawIndex] && _vm.froms[_vm.flawIndex].flaw_id.indexOf(index) > -1 ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.flawSelect(index,item.title)}}},[_vm._v(_vm._s(item.title))])}),0),_vm._v(" "),_c('div',{staticClass:"cm-center"},[_c('div',{staticClass:"cm-p-tb-12 cm-fn-14 cm-center cm-border-radius-10 cm-color-white cm-bg-orange cm-m-t-16",staticStyle:{"width":"80%"},on:{"click":function($event){return _vm.closePop()}}},[_vm._v("确定")])])]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),(_vm.clotheShowStatus)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-blue cm-text-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"85px","right":"15px"},on:{"click":function($event){return _vm.createClotheShow()}}},[_c('p',{staticClass:"cm-fn-12 cm-m-t-8 cm-color-white"},[_vm._v("添加")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-white"},[_vm._v("衣物")])]):_vm._e()])}
var createWashOrder_staticRenderFns = []
var createWashOrder_esExports = { render: createWashOrder_render, staticRenderFns: createWashOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_createWashOrder = (createWashOrder_esExports);
// CONCATENATED MODULE: ./src/pages/createWashOrder.vue
function createWashOrder_injectStyle (ssrContext) {
  __webpack_require__("9S5I")
}
var createWashOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var createWashOrder___vue_template_functional__ = false
/* styles */
var createWashOrder___vue_styles__ = createWashOrder_injectStyle
/* scopeId */
var createWashOrder___vue_scopeId__ = "data-v-68c5288e"
/* moduleIdentifier (server only) */
var createWashOrder___vue_module_identifier__ = null
var createWashOrder_Component = createWashOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_createWashOrder,
  selectortype_template_index_0_src_pages_createWashOrder,
  createWashOrder___vue_template_functional__,
  createWashOrder___vue_styles__,
  createWashOrder___vue_scopeId__,
  createWashOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_createWashOrder = (createWashOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillOrder.vue













/* harmony default export */ var waybillOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      isActive: 0,
      statusArr: [{
        key: 0,
        num: 0,
        value: '全部'
      }, {
        key: 6,
        num: 0,
        value: '已出厂待发货'
      }, {
        key: 7,
        num: 0,
        value: '已发货待揽收'
      }]
    };
  },
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.code = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    getWaybillOrderCount: function getWaybillOrderCount() {
      var _this = this;

      this.$api.getWaybillOrderCount({ code: this.code }).then(function (res) {
        if (res) {
          _this.statusArr.forEach(function (item) {
            item.num = res.data[item.key] || 0;;
          });
          console.log(_this.statusArr);
        }
      });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getWaybillOrderList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWaybillOrder: function sendWaybillOrder(id) {
      var _this3 = this;

      this.$func.confirm('确定要物流下单送衣？', '提示', function () {
        _this3.$api.sendWaybillOrder({ id: id }).then(function (res) {
          if (res) {
            _this3.$func.showToast('物流下单成功');
            setTimeout(function () {
              _this3.search();
              _this3.getWaybillOrderCount();
            }, 300);
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              var prefix = that.code.substring(0, 4);
              if (prefix == 'JDVG') {
                that.code = that.code.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillOrder.vue













/* harmony default export */ var pages_waybillOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      isActive: 0,
      statusArr: [{
        key: 0,
        num: 0,
        value: '全部'
      }, {
        key: 6,
        num: 0,
        value: '已出厂待发货'
      }, {
        key: 7,
        num: 0,
        value: '已发货待揽收'
      }]
    };
  },
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.code = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    getWaybillOrderCount: function getWaybillOrderCount() {
      var _this = this;

      this.$api.getWaybillOrderCount({ code: this.code }).then(function (res) {
        if (res) {
          _this.statusArr.forEach(function (item) {
            item.num = res.data[item.key] || 0;;
          });
          console.log(_this.statusArr);
        }
      });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this2 = this;

      this.$api.getWaybillOrderList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
        if (res) {
          if (!_this2.lastId) {
            _this2.blankShow = res.data.length > 0 ? false : true;
          }
          _this2.hasNext = res.hasNext;
          _this2.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this2.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWaybillOrder: function sendWaybillOrder(id) {
      var _this3 = this;

      this.$func.confirm('确定要物流下单送衣？', '提示', function () {
        _this3.$api.sendWaybillOrder({ id: id }).then(function (res) {
          if (res) {
            _this3.$func.showToast('物流下单成功');
            setTimeout(function () {
              _this3.search();
              _this3.getWaybillOrderCount();
            }, 300);
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              var prefix = that.code.substring(0, 4);
              if (prefix == 'JDVG') {
                that.code = that.code.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ba17780","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waybillOrder.vue
var waybillOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-12 cm-bg-white cm-m-tb-8",staticStyle:{"width":"90%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"请输入物流单号"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("社区信息："),_c('span',{staticClass:"cm-fn-16 cm-fn-weight-default cm-m-r-8"},[_vm._v(_vm._s(item.community.name))]),_c('a',{staticClass:"cm-fn-16 cm-fn-weight-default",attrs:{"href":'tel:'+item.community.phone}},[_vm._v(_vm._s(item.community.phone))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.community.phone)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("社区地址："+_vm._s(item.community.province)+" "+_vm._s(item.community.city)+" "+_vm._s(item.community.district)+" "+_vm._s(item.community.address))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 "},[_vm._v("衣物数量："+_vm._s(item.num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 "},[_vm._v("总金额：￥"+_vm._s(item.total_amount)+"（"),_c('span',{staticClass:"cm-color-666"},[_vm._v("物流费：￥"+_vm._s(item.express_fee))]),_vm._v("）")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流单号："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.pick_waybill_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.pick_waybill_code)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-blue cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.queryExpress(item.pick_waybill_code)}}},[_vm._v("物流轨迹查询")])])]),_vm._v(" "),(item.orders.length > 0)?_c('div',{staticClass:"shadow-gray cm-p-lr-8 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default "},[_vm._v("子订单信息")]),_vm._v(" "),_vm._l((item.orders),function(order,j){return _c('div',{key:j,staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(j+1)+"、子订单号："+_vm._s(order.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(order.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("用户信息："+_vm._s(order.name)+" "),_c('a',{staticClass:"cm-fn-16 cm-fn-weight-default",attrs:{"href":'tel:'+order.phone}},[_vm._v(_vm._s(order.phone))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(order.phone)}}},[_vm._v("复制")])]),_vm._v(" "),(order.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(order.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" "},[_c('div',{staticClass:"cm-text-left cm-p-tb-8"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(order.bag_code))])]),_vm._v(" "),_vm._l((order.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-t-12"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(order.num)+"件衣物 洗涤费用￥"+_vm._s(order.amount))])],2)])})],2):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var waybillOrder_staticRenderFns = []
var waybillOrder_esExports = { render: waybillOrder_render, staticRenderFns: waybillOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waybillOrder = (waybillOrder_esExports);
// CONCATENATED MODULE: ./src/pages/waybillOrder.vue
function waybillOrder_injectStyle (ssrContext) {
  __webpack_require__("ABtU")
}
var waybillOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waybillOrder___vue_template_functional__ = false
/* styles */
var waybillOrder___vue_styles__ = waybillOrder_injectStyle
/* scopeId */
var waybillOrder___vue_scopeId__ = "data-v-8ba17780"
/* moduleIdentifier (server only) */
var waybillOrder___vue_module_identifier__ = null
var waybillOrder_Component = waybillOrder_normalizeComponent(
  pages_waybillOrder,
  selectortype_template_index_0_src_pages_waybillOrder,
  waybillOrder___vue_template_functional__,
  waybillOrder___vue_styles__,
  waybillOrder___vue_scopeId__,
  waybillOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_waybillOrder = (waybillOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/expressOrder.vue












/* harmony default export */ var expressOrder = ({
  name: 'expressOrder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  data: function data() {
    return {
      title: '全部订单',
      diffPop: false,
      popBg: false,
      grade: 0,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: '1,5',
      amount: '',
      id: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {

    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ deliveryWay: 2, type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    openDiffPop: function openDiffPop(id) {
      this.diffPop = true;
      this.popBg = true;
      this.id = id;
    },
    closePop: function closePop() {
      this.diffPop = false;
      this.popBg = false;
    },
    diffPay: function diffPay() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入补差价金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.diffPrice({ amount: this.amount, id: this.id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.id = 0;
            that.closePop();
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/expressOrder.vue












/* harmony default export */ var pages_expressOrder = ({
  name: 'expressOrder',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, PopupPicker: vux_src_components_popup_picker, Previewer: vux_src_components_previewer, Popup: node_modules_vux_src_components_popup, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header
  },
  data: function data() {
    return {
      title: '全部订单',
      diffPop: false,
      popBg: false,
      grade: 0,
      isActive: 0,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      phone: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      type: '1,5',
      amount: '',
      id: 0,
      itemId: 0,
      list: [],
      pickerStatus: false,
      worker: [],
      worker_id: 0,
      updateUid: 0,
      deliveryWay: 0,
      comment: {
        star: 0,
        star1: 0
      },
      showCommentStatus: false,
      check: '/static/images/start@2x.png',
      checked: '/static/images/started@2x.png',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },
  created: function created() {

    this.grade = parseInt(this.$func.getLocal('grade'));
    if (this.type == 2 && (this.isActive == 3 || !this.isActive) && this.grade == 8) {
      this.getWorker();
    }
  },

  methods: {
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.getList();
    },
    selectStatus: function selectStatus(key) {
      this.loadStatus = false;
      this.where = [];
      this.where['status'] = key;
      this.isActive = key;
      this.lastId = 0;
      this.list = [];
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.$api.getOrderLists({ deliveryWay: 2, type: this.type, last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone }).then(function (res) {
        if (res) {

          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    uuptOrder: function uuptOrder(id) {
      var _this2 = this;

      this.$func.confirm('确认呼叫跑腿配送？', '提示', function () {
        _this2.$api.uuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this2.list = [];
              _this2.lastId = 0;
              _this2.hasNext = 0;
              _this2.loadmore();
            }, 300);
          }
        });
      });
    },
    cancelUuptOrder: function cancelUuptOrder(id) {
      var _this3 = this;

      this.$func.confirm('确认取消跑腿配送？', '提示', function () {
        _this3.$api.cancelUuptOrder({ id: id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this4 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      if (this.type == 2 && status == 4 && !this.worker_id) {
        this.$func.showToast('请选择服务师傅');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this4.$api.changeStatus({ id: id, status: status, type: _this4.type, worker_id: _this4.worker_id }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this4.pickerStatus = false;
              _this4.list = [];
              _this4.lastId = 0;
              _this4.hasNext = 0;

              _this4.loadmore();
            }, 300);
          }
        });
      });
    },
    record: function record(orderNo) {
      this.$router.push({ name: 'bagCodeRecord', params: { type: 1, order_no: orderNo } });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    showOperater: function showOperater(id) {
      this.itemId = id;
      this.pickerStatus = true;
    },
    onChange: function onChange(value) {
      this.worker_id = value;
    },
    getWorker: function getWorker() {
      var _this5 = this;

      this.$api.getWorker({ type: this.type }).then(function (res) {
        if (res) {
          _this5.worker = res.data;
        }
      });
    },
    showComment: function showComment(id) {
      var _this6 = this;

      this.$api.getComment({ id: id }).then(function (res) {
        if (res) {
          _this6.comment = res.data;
          _this6.showCommentStatus = true;
        }
      });
    },
    updateUserInfo: function updateUserInfo(uid) {
      this.updateUid = uid;
      this.pop = true;
      console.log(111);
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    problem: function problem(id) {
      this.$router.push({ name: 'problem', params: { id: id } });
    },
    openDiffPop: function openDiffPop(id) {
      this.diffPop = true;
      this.popBg = true;
      this.id = id;
    },
    closePop: function closePop() {
      this.diffPop = false;
      this.popBg = false;
    },
    diffPay: function diffPay() {
      if (this.amount <= 0) {
        this.$func.showToast('请输入补差价金额');
        return false;
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady: function onBridgeReady() {
      var that = this;
      this.$api.diffPrice({ amount: this.amount, id: this.id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
            that.id = 0;
            that.closePop();
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this7 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';

      this.getList();
      setTimeout(function () {
        if (_this7.blankShow) {
          _this7.busy = true;
          _this7.loadStatus = false;
          _this7.loadmoreText = '没有更多了。。。';
        } else {
          if (_this7.hasNext > 0) {
            _this7.loadStatus = false;
            _this7.busy = false;
          } else {
            _this7.busy = true;
            _this7.loadStatus = true;
            _this7.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5978741e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/expressOrder.vue
var expressOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main",class:[_vm.popBg ? 'noscroll' : '' ]},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"订单号后四位|手机号|姓名|物流编码"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 cm-p-lr-12 cm-bg-white cm-p-b-12"},[(_vm.type == 2)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[(item.status < 7)?_c('p',{staticClass:"cm-fn-16 cm-p-t-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 cm-p-t-16"},[_vm._v(_vm._s(item.status_text))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-20 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "+_vm._s(item.name)),_c('span',{staticClass:"cm-fn-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("社区信息："+_vm._s(item.community_name))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("订单金额："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.amount))])]),_vm._v(" "),(item.diff_price > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("补差价："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.diff_price))])]):_vm._e()])]),_vm._v(" "),(item.worker_id > 0)?_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("服务师傅")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_c('a',{attrs:{"href":'tel:'+item.worker.phone}},[_vm._v(_vm._s(item.worker.phone))]),_vm._v(" "+_vm._s(item.worker.name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),0),_vm._v(" "),(item.phone)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 2 && _vm.$func.checkAuth('status/2'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,3)}}},[_vm._v("接单")]):_vm._e(),_vm._v(" "),(item.status == 3 && _vm.$func.checkAuth('status/3'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.showOperater(item.id)}}},[_vm._v("分配")]):_vm._e(),_vm._v(" "),(item.status == 4 && _vm.$func.checkAuth('status/4'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,5)}}},[_vm._v("已上门")]):_vm._e(),_vm._v(" "),(item.status == 5 && _vm.$func.checkAuth('status/5'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,6)}}},[_vm._v("开始服务")]):_vm._e(),_vm._v(" "),(item.status == 5 && item.problem == 0 && _vm.$func.checkAuth('problem'))?_c('div',{staticClass:"cm-bg-blue cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.problem(item.id)}}},[_vm._v("问题上报")]):_vm._e(),_vm._v(" "),(item.status == 6 && _vm.$func.checkAuth('status/6'))?_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,7)}}},[_vm._v("服务完成")]):_vm._e(),_vm._v(" "),(item.status == 9 && _vm.$func.checkAuth('status/9'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center  cm-m-r-16",on:{"click":function($event){return _vm.showComment(item.id)}}},[_vm._v("查看评价")]):_vm._e(),_vm._v(" "),(item.status < 5 && _vm.$func.checkAuth('contact'))?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()]):_vm._e()]):_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-m-t-16 cm-flex-middle"},[(item.status == 2 || item.status == 8)?_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 "},[_vm._v(_vm._s(item.status_text))])])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-p-t-8 cm-fn-weight-default cm-flex-start cm-flex-middle"},[_vm._v("  "+_vm._s(item.name)+" "),_c('a',{staticClass:"cm-m-l-4",attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-8 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.phone)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-fn-14 cm-m-l-8 cm-fn-weight-min"},[_vm._v("（"+_vm._s(item.user.nickname)+"）")])]),_vm._v(" "),(_vm.grade == 10 || _vm.grade == 2)?_c('p',{staticClass:"cm-fn-14 cm-color-222 cm-p-tb-2"},[_vm._v("站点信息："+_vm._s(item.community.name)+" "+_vm._s(item.community.head_phone))]):_vm._e(),_vm._v(" "),(item.house_number)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v("楼号门牌："+_vm._s(item.house_number))]):_vm._e(),_vm._v(" "),(item.address_id > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-p-tb-2"},[_vm._v(_vm._s(item.address.address)+" "+_vm._s(item.address.house_number))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(item.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("洗衣数量："+_vm._s(item.goods_num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("配送方式："+_vm._s(item.delivery_way_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流编码："),_c('span',{staticClass:"cm-color-orange cm-fn-weight-default"},[_vm._v(_vm._s(item.pick_waybill_code))]),(item.pick_waybill_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.pick_waybill_code)}}},[_vm._v("复制")]):_vm._e(),(item.pick_waybill_code)?_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-blue cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.queryExpress(item.pick_waybill_code)}}},[_vm._v("物流轨迹查询")]):_vm._e()]),_vm._v(" "),(item.home_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("上门时间："),_c('span',{staticClass:"cm-color-333 cm-fn-weight-default"},[_vm._v(_vm._s(item.home_time))])]):_vm._e(),_vm._v(" "),(item.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(item.remark))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.collect_time)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("收衣时间："+_vm._s(item.collect_time))]):_vm._e(),_vm._v(" "),(_vm.type == 1 && item.special_title)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("会员卡特权："+_vm._s(item.special_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border-bottom-1"},[_c('div',{staticClass:"cm-text-left cm-p-tb-12"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(item.bag_code))])]),_vm._v(" "),_vm._l((item.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-b-8 cm-m-t-16"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(item.num)+"件衣物 洗涤费用￥"+_vm._s(item.amount))])],2),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.phone)?_c('div',{staticClass:"cm-border cm-p-tb-8 cm-border-radius-5 cm-center"},[_c('a',{staticClass:"cm-color-main cm-w-100 cm-center",attrs:{"href":'tel:'+item.phone}},[_vm._v("联系客户")])]):_vm._e()])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom"},model:{value:(_vm.pickerStatus),callback:function ($$v) {_vm.pickerStatus=$$v},expression:"pickerStatus"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请选择服务师傅","show-bottom-border":false},on:{"on-click-left":function($event){_vm.pickerStatus = false},"on-click-right":function($event){return _vm.changeStatus(_vm.itemId,4)}}}),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.worker,"selected-label-style":{color: '#FE5649'}},on:{"on-change":_vm.onChange}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changeStatus(_vm.itemId,4)}}},[_vm._v(" 确认 ")])],1)],1),_vm._v(" "),_c('popup',{staticClass:"comment",attrs:{"position":"bottom"},model:{value:(_vm.showCommentStatus),callback:function ($$v) {_vm.showCommentStatus=$$v},expression:"showCommentStatus"}},[_c('div',{staticClass:"cm-bg-white cm-p-tb-16 cm-p-lr-16"},[_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap cm-p-tb-12"},_vm._l((_vm.comment.pics_path),function(item,index){return _c('li',{key:index,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.src},on:{"click":function($event){return _vm.show(index)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14 cm-m-r-16"},[_vm._v("综合评分")]),_vm._v(" "),_vm._l((Number(_vm.comment.star)),function(k,k3){return _c('img',{key:k3+'a',staticClass:"cm-icon-22 cm-m-r-8",attrs:{"src":"/static/images/started@2x.png"}})}),_vm._v(" "),_vm._l((Number(_vm.comment.star1)),function(n,k4){return _c('img',{key:k4+'b',staticClass:"cm-icon-20 cm-m-r-8",attrs:{"src":"/static/images/start@2x.png"}})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-red cm-m-l-16"},[_vm._v(_vm._s(_vm.comment.star_text))])],2),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-border-bottom-1"},[_vm._v("\n                          "+_vm._s(_vm.comment.content)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-tb-16  cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-14"},[_vm._v("评价时间")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(_vm.comment.create_time))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px"}},[_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){_vm.showCommentStatus = false}}},[_vm._v(" 关闭 ")])],1)]),_vm._v(" "),(_vm.showCommentStatus)?_c('previewer',{ref:"previewer",attrs:{"list":_vm.comment.pics_path,"options":_vm.options}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popBg),expression:"popBg"}],staticClass:"pop ",on:{"click":_vm.closePop}}),_vm._v(" "),(_vm.diffPop)?_c('div',{staticClass:"pop-bg1 cm-p-tb-24 cm-border-radius-10"},[_c('div',{staticClass:"cm-text-center cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("请输入补差价金额")]),_vm._v(" "),_c('div',{staticClass:"cm-center  cm-m-t-16 cm-fn-16"},[_c('p',{staticClass:"cm-color-orange cm-fn-22"},[_vm._v("￥")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"cm-fn-22 cm-m-lr-4 cm-p-tb-4 cm-h-100 cm-color-orange cm-bg-gray cm-text-center cm-p-lr-12 cm-border-radius-4",staticStyle:{"width":"100px","height":"40px"},attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-16"},[_c('div',{staticClass:"cm-bg-orange cm-center  cm-p-lr-32 cm-p-tb-12 cm-border-radius-8",on:{"click":function($event){return _vm.diffPay()}}},[_c('p',{staticClass:" cm-fn-16 cm-color-white cm-fn-weight-default"},[_vm._v("确认支付")])])])]):_vm._e()])}
var expressOrder_staticRenderFns = []
var expressOrder_esExports = { render: expressOrder_render, staticRenderFns: expressOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_expressOrder = (expressOrder_esExports);
// CONCATENATED MODULE: ./src/pages/expressOrder.vue
function expressOrder_injectStyle (ssrContext) {
  __webpack_require__("oE3A")
}
var expressOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var expressOrder___vue_template_functional__ = false
/* styles */
var expressOrder___vue_styles__ = expressOrder_injectStyle
/* scopeId */
var expressOrder___vue_scopeId__ = "data-v-5978741e"
/* moduleIdentifier (server only) */
var expressOrder___vue_module_identifier__ = null
var expressOrder_Component = expressOrder_normalizeComponent(
  pages_expressOrder,
  selectortype_template_index_0_src_pages_expressOrder,
  expressOrder___vue_template_functional__,
  expressOrder___vue_styles__,
  expressOrder___vue_scopeId__,
  expressOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_expressOrder = (expressOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickupOrder.vue













/* harmony default export */ var pages_pickupOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      showQuery: false,
      phone: '',
      orderCode: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      sendList: [],
      sendCode: '',
      isActive: 1,
      statusArr: [{
        key: 1,
        num: 0,
        value: '已发货待揽收'
      }, {
        key: 2,
        num: 0,
        value: '已揽收配送中'
      }]
    };
  },

  computed: {},
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.phone = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.phone = '';
      this.orderCode = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.orderCode = res.resultStr.split(',')[1];
              var prefix = that.orderCode.substring(0, 4);
              if (prefix == 'JDVG') {
                that.orderCode = that.orderCode.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this = this;

      this.$api.pickupOrder({ last_id: this.lastId, page_flag: this.pageFlag, code: this.orderCode, status: this.isActive }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pickupOrder.vue













/* harmony default export */ var selectortype_script_index_0_src_pages_pickupOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      showQuery: false,
      phone: '',
      orderCode: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      sendList: [],
      sendCode: '',
      isActive: 1,
      statusArr: [{
        key: 1,
        num: 0,
        value: '已发货待揽收'
      }, {
        key: 2,
        num: 0,
        value: '已揽收配送中'
      }]
    };
  },

  computed: {},
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.phone = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.phone = '';
      this.orderCode = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              that.orderCode = res.resultStr.split(',')[1];
              var prefix = that.orderCode.substring(0, 4);
              if (prefix == 'JDVG') {
                that.orderCode = that.orderCode.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this = this;

      this.$api.pickupOrder({ last_id: this.lastId, page_flag: this.pageFlag, code: this.orderCode, status: this.isActive }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
          _this2.loadmoreText = '没有更多了。。。';
        } else {
          if (_this2.hasNext > 0) {
            _this2.loadStatus = false;
            _this2.busy = false;
          } else {
            _this2.busy = true;
            _this2.loadStatus = true;
            _this2.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c79d99ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pickupOrder.vue
var pickupOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-l-8",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderCode),expression:"orderCode"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"请输入物流编码"},domProps:{"value":(_vm.orderCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderCode=$event.target.value}}}),_vm._v(" "),(_vm.orderCode)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("物流信息")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流单号："+_vm._s(item.order_code)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_code)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-orange cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.queryExpress(item.order_code)}}},[_vm._v("物流轨迹查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流类型："+_vm._s(item.express_type_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流状态："+_vm._s(item.status_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))])]),_vm._v(" "),(item.orderFactory.length > 0)?_c('div',{staticClass:"shadow-gray cm-p-lr-8 cm-p-tb-8"},_vm._l((item.orderFactory),function(value,i){return _c('div',{key:i},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(i+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(value.washing_code)}}},[_vm._v(_vm._s(value.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(value.washing_code)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 "},[_vm._v(_vm._s(value.name)+" "+_vm._s(value.phone))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-666 "},[_vm._v(_vm._s(value.cate_title)+"-"+_vm._s(value.clothe_title))])])])}),0):_vm._e()])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var pickupOrder_staticRenderFns = []
var pickupOrder_esExports = { render: pickupOrder_render, staticRenderFns: pickupOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pickupOrder = (pickupOrder_esExports);
// CONCATENATED MODULE: ./src/pages/pickupOrder.vue
function pickupOrder_injectStyle (ssrContext) {
  __webpack_require__("vbm8")
}
var pickupOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pickupOrder___vue_template_functional__ = false
/* styles */
var pickupOrder___vue_styles__ = pickupOrder_injectStyle
/* scopeId */
var pickupOrder___vue_scopeId__ = "data-v-c79d99ce"
/* moduleIdentifier (server only) */
var pickupOrder___vue_module_identifier__ = null
var pickupOrder_Component = pickupOrder_normalizeComponent(
  selectortype_script_index_0_src_pages_pickupOrder,
  selectortype_template_index_0_src_pages_pickupOrder,
  pickupOrder___vue_template_functional__,
  pickupOrder___vue_styles__,
  pickupOrder___vue_scopeId__,
  pickupOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_pickupOrder = (pickupOrder_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillClotheOrder.vue















/* harmony default export */ var waybillClotheOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      showQuery: false,
      phone: '',
      orderCode: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      sendList: [],
      sendCode: '',
      isActive: 0,
      statusArr: [{
        key: 0,
        num: 0,
        value: '已出厂待发货'
      }, {
        key: 1,
        num: 0,
        value: '已发货待揽收'
      }, {
        key: 2,
        num: 0,
        value: '已揽收'
      }]
    };
  },

  computed: {
    isMultipleCid: function isMultipleCid() {
      if (this.sendList.length <= 1) return false;
      var cids = new set_default.a(this.sendList.map(function (item) {
        return item.cid;
      }));
      return cids.size > 1;
    }
  },
  created: function created() {

    this.config();

    this.getWaybillCodeCount();
  },
  amount: function amount() {
    this.phone = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.phone = '';
      this.orderCode = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              if (key === 1) {
                if (!that.isActive) {
                  that.phone = res.resultStr.split(',')[1];
                } else {
                  that.orderCode = res.resultStr.split(',')[1];
                  var prefix = that.orderCode.substring(0, 4);
                  if (prefix == 'JDVG') {
                    that.orderCode = that.orderCode.substring(0, 15);
                  }
                }
                that.search();
              } else {
                that.sendCode = res.resultStr.split(',')[1];
                that.getCodeInfo();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getCodeInfo: function getCodeInfo() {
      var _this = this;

      var that = this;
      if (!this.sendCode) return;
      var isExist = this.sendList.find(function (item) {
        return item.washing_code === _this.sendCode;
      });
      if (isExist) {
        this.$func.showToast('该衣物已经在发货列表中');

        return false;
      }
      this.$api.getCodeInfo({ code: this.sendCode }).then(function (res) {
        if (res && res.data) {
          that.sendList.push(res.data);
          if (that.isMultipleCid) {
            that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
          } else {
            setTimeout(function () {
              that.scanQRCode(0);
            }, 300);
          }
        }
      });
    },
    getCidColor: function getCidColor(cid) {
      if (!cid) return '#ffffff';
      var colors = ['#f0faff', '#f6ffed', '#fff7e6', '#fff1f0', '#f9f0ff', '#feffe6'];

      var index = typeof cid === 'number' ? cid : cid.split('').reduce(function (acc, char) {
        return acc + char.charCodeAt(0);
      }, 0);
      return colors[index % colors.length];
    },
    remove: function remove(index) {
      this.sendList.splice(index, 1);
    },
    getWaybillCodeCount: function getWaybillCodeCount() {
      var _this2 = this;

      this.$api.getWaybillCodeCount({ phone: this.phone, i: 3 }).then(function (res) {
        if (res) {
          _this2.statusArr.forEach(function (item) {
            item.num = res.data[item.key] || 0;;
          });
          console.log(_this2.statusArr);
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      if (!this.isActive) {
        this.$api.waitWaybillCode({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, i: 3 }).then(function (res) {
          if (res) {
            if (!_this3.lastId) {
              _this3.blankShow = res.data.length > 0 ? false : true;
            }
            _this3.hasNext = res.hasNext;
            _this3.lastId = res.lastId;
            res.data.forEach(function (item) {
              _this3.list.push(item);
            });
          }
        });
      } else {
        this.$api.waybillCodeList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.orderCode, status: this.isActive }).then(function (res) {
          if (res) {
            if (!_this3.lastId) {
              _this3.blankShow = res.data.length > 0 ? false : true;
            }
            _this3.hasNext = res.hasNext;
            _this3.lastId = res.lastId;
            res.data.forEach(function (item) {
              _this3.list.push(item);
            });
          }
        });
      }
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWaybillCode: function sendWaybillCode() {
      var that = this;
      if (!this.sendList.length) {
        this.$func.showToast('请选择发货衣物');
        return false;
      }
      if (that.isMultipleCid) {
        that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
        return false;
      }
      var codes = [];
      this.sendList.forEach(function (item) {
        codes.push({ code: item.washing_code, cid: item.cid });
      });
      this.$func.confirm('确定物流下单送衣？', '提示', function () {
        that.$api.sendWaybillCode({ param: stringify_default()(codes) }).then(function (res) {
          if (res) {
            that.$func.showToast('物流下单成功');
            that.sendList = [];
            that.showQuery = false;
            setTimeout(function () {
              that.search();
              that.getWaybillCodeCount();
            }, 300);
          }
        });
      });
    },
    cancelWaybillOrder: function cancelWaybillOrder(id) {
      var that = this;
      this.$func.confirm('确定取消订单？', '提示', function () {
        that.$api.cancelWaybillOrder({ id: id }).then(function (res) {
          if (res) {
            that.$func.showToast('取消订单成功');
            that.sendList = [];
            that.showQuery = false;
            setTimeout(function () {
              that.search();
              that.getWaybillCodeCount();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillClotheOrder.vue















/* harmony default export */ var pages_waybillClotheOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      showQuery: false,
      phone: '',
      orderCode: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      sendList: [],
      sendCode: '',
      isActive: 0,
      statusArr: [{
        key: 0,
        num: 0,
        value: '已出厂待发货'
      }, {
        key: 1,
        num: 0,
        value: '已发货待揽收'
      }, {
        key: 2,
        num: 0,
        value: '已揽收'
      }]
    };
  },

  computed: {
    isMultipleCid: function isMultipleCid() {
      if (this.sendList.length <= 1) return false;
      var cids = new set_default.a(this.sendList.map(function (item) {
        return item.cid;
      }));
      return cids.size > 1;
    }
  },
  created: function created() {

    this.config();

    this.getWaybillCodeCount();
  },
  amount: function amount() {
    this.phone = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.phone = '';
      this.orderCode = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    searchSubmit: function searchSubmit() {
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      this.isActive = val;
      this.search();
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    scanQRCode: function scanQRCode(key) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {
              if (key === 1) {
                if (!that.isActive) {
                  that.phone = res.resultStr.split(',')[1];
                } else {
                  that.orderCode = res.resultStr.split(',')[1];
                  var prefix = that.orderCode.substring(0, 4);
                  if (prefix == 'JDVG') {
                    that.orderCode = that.orderCode.substring(0, 15);
                  }
                }
                that.search();
              } else {
                that.sendCode = res.resultStr.split(',')[1];
                that.getCodeInfo();
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getCodeInfo: function getCodeInfo() {
      var _this = this;

      var that = this;
      if (!this.sendCode) return;
      var isExist = this.sendList.find(function (item) {
        return item.washing_code === _this.sendCode;
      });
      if (isExist) {
        this.$func.showToast('该衣物已经在发货列表中');

        return false;
      }
      this.$api.getCodeInfo({ code: this.sendCode }).then(function (res) {
        if (res && res.data) {
          that.sendList.push(res.data);
          if (that.isMultipleCid) {
            that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
          } else {
            setTimeout(function () {
              that.scanQRCode(0);
            }, 300);
          }
        }
      });
    },
    getCidColor: function getCidColor(cid) {
      if (!cid) return '#ffffff';
      var colors = ['#f0faff', '#f6ffed', '#fff7e6', '#fff1f0', '#f9f0ff', '#feffe6'];

      var index = typeof cid === 'number' ? cid : cid.split('').reduce(function (acc, char) {
        return acc + char.charCodeAt(0);
      }, 0);
      return colors[index % colors.length];
    },
    remove: function remove(index) {
      this.sendList.splice(index, 1);
    },
    getWaybillCodeCount: function getWaybillCodeCount() {
      var _this2 = this;

      this.$api.getWaybillCodeCount({ phone: this.phone, i: 3 }).then(function (res) {
        if (res) {
          _this2.statusArr.forEach(function (item) {
            item.num = res.data[item.key] || 0;;
          });
          console.log(_this2.statusArr);
        }
      });
    },
    getList: function getList() {
      var _this3 = this;

      if (!this.isActive) {
        this.$api.waitWaybillCode({ last_id: this.lastId, page_flag: this.pageFlag, phone: this.phone, i: 3 }).then(function (res) {
          if (res) {
            if (!_this3.lastId) {
              _this3.blankShow = res.data.length > 0 ? false : true;
            }
            _this3.hasNext = res.hasNext;
            _this3.lastId = res.lastId;
            res.data.forEach(function (item) {
              _this3.list.push(item);
            });
          }
        });
      } else {
        this.$api.waybillCodeList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.orderCode, status: this.isActive }).then(function (res) {
          if (res) {
            if (!_this3.lastId) {
              _this3.blankShow = res.data.length > 0 ? false : true;
            }
            _this3.hasNext = res.hasNext;
            _this3.lastId = res.lastId;
            res.data.forEach(function (item) {
              _this3.list.push(item);
            });
          }
        });
      }
    },
    barOrder: function barOrder(code) {
      this.$router.push({ name: 'barOrder', params: { code: code } });
    },
    sendWaybillCode: function sendWaybillCode() {
      var that = this;
      if (!this.sendList.length) {
        this.$func.showToast('请选择发货衣物');
        return false;
      }
      if (that.isMultipleCid) {
        that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
        return false;
      }
      var codes = [];
      this.sendList.forEach(function (item) {
        codes.push({ code: item.washing_code, cid: item.cid });
      });
      this.$func.confirm('确定物流下单送衣？', '提示', function () {
        that.$api.sendWaybillCode({ param: stringify_default()(codes) }).then(function (res) {
          if (res) {
            that.$func.showToast('物流下单成功');
            that.sendList = [];
            that.showQuery = false;
            setTimeout(function () {
              that.search();
              that.getWaybillCodeCount();
            }, 300);
          }
        });
      });
    },
    cancelWaybillOrder: function cancelWaybillOrder(id) {
      var that = this;
      this.$func.confirm('确定取消订单？', '提示', function () {
        that.$api.cancelWaybillOrder({ id: id }).then(function (res) {
          if (res) {
            that.$func.showToast('取消订单成功');
            that.sendList = [];
            that.showQuery = false;
            setTimeout(function () {
              that.search();
              that.getWaybillCodeCount();
            }, 300);
          }
        });
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc591bae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waybillClotheOrder.vue
var waybillClotheOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-bg-white cm-p-b-4",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-12 cm-flex-middle cm-flex-between"},_vm._l((_vm.statusArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center  cm-fn-16 cm-p-tb-8 cm-p-lr-16 cm-pr ",class:[_vm.isActive === item.key ? 'active' : ''],staticStyle:{"overflow":"hidden"},on:{"click":function($event){return _vm.selectStatus(item.key)}}},[_vm._v("\n                      "+_vm._s(item.value)),(item.num > 0)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(item.num))]):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-l-8",staticStyle:{"width":"85%"}},[(!_vm.isActive)?_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"请输入手机号|衣物单号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]):_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderCode),expression:"orderCode"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"请输入物流单号"},domProps:{"value":(_vm.orderCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderCode=$event.target.value}}}),_vm._v(" "),(_vm.orderCode)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8"},[(!_vm.isActive)?_c('div',[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.washing_code)}}},[_vm._v("复制")])]),_vm._v(" "),(item.community_name)?_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.community_name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-text-left"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-666 cm-fn-14"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('p',{staticClass:" cm-color-666 "},[_vm._v(_vm._s(item.name)+" "),_c('a',{attrs:{"href":'tel:'+item.phone}},[_vm._v(_vm._s(item.phone))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.phone)}}},[_vm._v("复制")])])]),_vm._v(" "),(item.order_no)?_c('p',{staticClass:"cm-color-666 "},[_vm._v(_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(item.order_no)}}},[_vm._v("查询")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("录单时间："+_vm._s(item.create_time))])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-fn-12 cm-color-666 "},[_vm._v("出厂时间："+_vm._s(item.out_time))])])]):_c('div',[_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("物流信息")]),_vm._v(" "),(item.order_code)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流单号："+_vm._s(item.order_code)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_code)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-blue cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.queryExpress(item.order_code)}}},[_vm._v("物流轨迹查询")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("社区信息："),_c('span',{staticClass:"cm-fn-16 cm-fn-weight-default cm-m-r-8"},[_vm._v(_vm._s(item.community.name))]),_c('a',{staticClass:"cm-fn-16 cm-fn-weight-default",attrs:{"href":'tel:'+item.community.head_phone}},[_vm._v(_vm._s(item.community.head_phone))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.community.phone)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("社区地址："+_vm._s(item.community.province)+" "+_vm._s(item.community.city)+" "+_vm._s(item.community.district)+" "+_vm._s(item.community.address))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流类型："+_vm._s(item.express_type_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))])]),_vm._v(" "),(item.orderFactory.length > 0)?_c('div',{staticClass:"shadow-gray cm-p-lr-8 cm-p-tb-8"},_vm._l((item.orderFactory),function(value,i){return _c('div',{key:i},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(i+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(value.washing_code)}}},[_vm._v(_vm._s(value.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(value.washing_code)}}},[_vm._v("复制")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-666 "},[_vm._v(_vm._s(value.cate_title)+"-"+_vm._s(value.clothe_title))])])])}),0):_vm._e(),_vm._v(" "),(item.is_refund)?_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[_c('div',{staticClass:"cm-bg-red cm-p-tb-8 cm-border-radius-5 cm-center cm-color-white cm-fn-16",on:{"click":function($event){return _vm.cancelWaybillOrder(item.id)}}},[_vm._v("取消订单")])]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cm-pf cm-img-box cm-border-radius cm-text-center",staticStyle:{"width":"56px","height":"56px","bottom":"125px","right":"15px","background-color":"rgba(204, 204, 204, 0.8)"},on:{"click":function($event){_vm.showQuery = true}}},[_c('p',{staticClass:"cm-fn-12 cm-color-orange cm-m-t-12 cm-fn-weight-default"},[_vm._v("衣物")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-orange  cm-fn-weight-default"},[_vm._v("发货")])]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"90%"},model:{value:(_vm.showQuery),callback:function ($$v) {_vm.showQuery=$$v},expression:"showQuery"}},[_c('div',{staticClass:" cm-bg-white"},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-pr"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold"},[_vm._v("发货列表")]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-icon-12",staticStyle:{"right":"25px","top":"10px"},on:{"click":function($event){_vm.showQuery = false}}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),_c('div',{staticClass:" cm-bg-white ",staticStyle:{"height":"85%","overflow-y":"scroll"}},[(_vm.sendList.length > 0)?_c('div',[(_vm.isMultipleCid)?_c('div',{staticClass:"cm-center cm-p-tb-8 cm-color-red cm-fn-14"},[_vm._v("\n                              温馨提示：当前列表中存在多个不同社区的衣物，请注意区分！\n                          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.sendList),function(item,index){return _c('div',{key:index,staticClass:"cm-m-t-8 cm-p-tb-4 shadow-gray cm-p-lr-8",style:({backgroundColor: _vm.getCidColor(item.cid)})},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-2"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、"),_c('span',{staticClass:"cm-color-orange cm-fn-16",on:{"click":function($event){return _vm.barOrder(item.washing_code)}}},[_vm._v(_vm._s(item.washing_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.washing_code)}}},[_vm._v("复制")])]),_vm._v(" "),(item.community_name)?_c('p',{staticClass:"cm-fn-weight-default"},[_vm._v(_vm._s(item.community_name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('p',{staticClass:"cm-color-666 cm-fn-14"},[_vm._v(_vm._s(item.cate_title)+"-"+_vm._s(item.clothe_title))]),_vm._v(" "),_c('div',{staticClass:"cm-color-orange cm-p-tb-4 cm-p-lr-12 cm-border-radius-8 cm-bg-gray",on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("移除")])])])})],2):_c('div',{staticClass:"cm-center cm-h-100"},[_c('div',{staticClass:"cm-color-orange"},[_vm._v("请扫码添加发货衣物")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-around cm-flex-middle cm-pf",staticStyle:{"bottom":"5px","left":"0"}},[_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-blue cm-border-radius-8 cm-color-white cm-fn-14 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.scanQRCode(0)}}},[_vm._v("\n                          扫码添加\n                           "),_c('img',{staticClass:"cm-icon-20 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-12 cm-center cm-bg-orange cm-border-radius-8 cm-color-white cm-fn-14 cm-p-lr-32 cm-fn-weight-default",on:{"click":function($event){return _vm.sendWaybillCode()}}},[_vm._v("\n                          确认发货\n                      ")])])])])],1)])}
var waybillClotheOrder_staticRenderFns = []
var waybillClotheOrder_esExports = { render: waybillClotheOrder_render, staticRenderFns: waybillClotheOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waybillClotheOrder = (waybillClotheOrder_esExports);
// CONCATENATED MODULE: ./src/pages/waybillClotheOrder.vue
function waybillClotheOrder_injectStyle (ssrContext) {
  __webpack_require__("+jit")
}
var waybillClotheOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waybillClotheOrder___vue_template_functional__ = false
/* styles */
var waybillClotheOrder___vue_styles__ = waybillClotheOrder_injectStyle
/* scopeId */
var waybillClotheOrder___vue_scopeId__ = "data-v-dc591bae"
/* moduleIdentifier (server only) */
var waybillClotheOrder___vue_module_identifier__ = null
var waybillClotheOrder_Component = waybillClotheOrder_normalizeComponent(
  pages_waybillClotheOrder,
  selectortype_template_index_0_src_pages_waybillClotheOrder,
  waybillClotheOrder___vue_template_functional__,
  waybillClotheOrder___vue_styles__,
  waybillClotheOrder___vue_scopeId__,
  waybillClotheOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_waybillClotheOrder = (waybillClotheOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/queryExpress.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_queryExpress = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: true,
            orderCode: '',
            list: {
                expName: '',
                number: '',
                trackings: []
            }
        };
    },

    computed: {},
    created: function created() {
        this.orderCode = this.$route.params.code;
        this.config();
        if (this.orderCode) {
            this.search();
        }
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        resetSearch: function resetSearch() {
            this.orderCode = '';
            this.list = [];
            this.getList();
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.orderCode = res.resultStr.split(',')[1];
                            var prefix = that.orderCode.substring(0, 4);
                            if (prefix == 'JDVG') {
                                that.orderCode = that.orderCode.substring(0, 15);
                            }
                            that.search();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        getList: function getList() {
            var _this = this;

            this.$api.queryExpress({ code: this.orderCode }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                    _this.blankShow = res.data.trackings.length > 0 ? false : true;
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/queryExpress.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_pages_queryExpress = ({
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: true,
            orderCode: '',
            list: {
                expName: '',
                number: '',
                trackings: []
            }
        };
    },

    computed: {},
    created: function created() {
        this.orderCode = this.$route.params.code;
        this.config();
        if (this.orderCode) {
            this.search();
        }
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        search: function search() {
            this.list = [];
            this.getList();
        },
        resetSearch: function resetSearch() {
            this.orderCode = '';
            this.list = [];
            this.getList();
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            that.orderCode = res.resultStr.split(',')[1];
                            var prefix = that.orderCode.substring(0, 4);
                            if (prefix == 'JDVG') {
                                that.orderCode = that.orderCode.substring(0, 15);
                            }
                            that.search();
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        getList: function getList() {
            var _this = this;

            this.$api.queryExpress({ code: this.orderCode }).then(function (res) {
                if (res) {
                    _this.list = res.data;
                    _this.blankShow = res.data.trackings.length > 0 ? false : true;
                }
            });
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c423d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/queryExpress.vue
var queryExpress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-l-8",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"90%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderCode),expression:"orderCode"}],staticClass:"cm-fn-16 cm-h-100",attrs:{"type":"text","placeholder":"请输入物流编码"},domProps:{"value":(_vm.orderCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderCode=$event.target.value}}}),_vm._v(" "),(_vm.orderCode)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),(_vm.list && _vm.list.trackings && _vm.list.trackings.length > 0)?_c('div',{staticClass:" cm-p-16 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-flex-start cm-m-b-16"},[_c('div',{staticClass:"cm-m-l-12"},[_c('p',{staticClass:"cm-fn-16 cm-fn-500"},[_vm._v(_vm._s(_vm.list.expName || '物流信息'))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-333 cm-m-t-4"},[_vm._v("单号："+_vm._s(_vm.list.number)+" "),_c('span',{staticClass:"cm-color-blue cm-m-l-8",on:{"click":function($event){return _vm.copy(_vm.list.number)}}},[_vm._v("复制")])])])]),_vm._v(" "),_c('div',{staticClass:"timeline"},_vm._l((_vm.list.trackings),function(item,index){return _c('div',{key:index,staticClass:"timeline-item"},[(index !== _vm.list.trackings.length - 1)?_c('div',{staticClass:"timeline-line"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"timeline-dot",class:index === 0 ? 'active-dot' : ''}),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('p',{staticClass:"cm-fn-14",class:index === 0 ? 'cm-color-333 cm-fn-500' : 'cm-color-666'},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14",class:index === 0 ? 'cm-color-black cm-fn-500' : 'cm-color-666'},[_vm._v(_vm._s(item.remark))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v(_vm._s(item.time))])])])}),0)]):_vm._e()],1)])}
var queryExpress_staticRenderFns = []
var queryExpress_esExports = { render: queryExpress_render, staticRenderFns: queryExpress_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_queryExpress = (queryExpress_esExports);
// CONCATENATED MODULE: ./src/pages/queryExpress.vue
function queryExpress_injectStyle (ssrContext) {
  __webpack_require__("xfZd")
}
var queryExpress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var queryExpress___vue_template_functional__ = false
/* styles */
var queryExpress___vue_styles__ = queryExpress_injectStyle
/* scopeId */
var queryExpress___vue_scopeId__ = "data-v-69c423d6"
/* moduleIdentifier (server only) */
var queryExpress___vue_module_identifier__ = null
var queryExpress_Component = queryExpress_normalizeComponent(
  selectortype_script_index_0_src_pages_queryExpress,
  selectortype_template_index_0_src_pages_queryExpress,
  queryExpress___vue_template_functional__,
  queryExpress___vue_styles__,
  queryExpress___vue_scopeId__,
  queryExpress___vue_module_identifier__
)

/* harmony default export */ var src_pages_queryExpress = (queryExpress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillWashOrder.vue













/* harmony default export */ var waybillWashOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      isActive: 2,
      statusArr: [{
        key: 2,
        num: 0,
        value: '已支付'
      }, {
        key: 1,
        num: 0,
        value: '未支付'
      }]
    };
  },
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.code = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      if (this.isActive === val) {
        return false;
      }
      this.isActive = val;
      this.search();
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this = this;

      this.$api.getWaybillWashOrderList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code, status: this.isActive }).then(function (res) {
        if (res) {
          var list = res.data.filter(function (item) {
            return Number(item.status) !== 10;
          });
          if (!_this.lastId) {
            _this.blankShow = list.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          list.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    pay: function pay(id) {
      var _this2 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认支付？', '提示', function () {
        if (typeof WeixinJSBridge == "undefined") {
          var onBridgeReady = function onBridgeReady() {
            _this2.onBridgeReady(id);
          };
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          _this2.onBridgeReady(id);
        }
      });
    },
    onBridgeReady: function onBridgeReady(id) {
      var that = this;
      this.$api.payWaybillWashOrder({ id: id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
          });
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this3 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this3.$api.changeOrderParentStatus({ id: id, status: status, type: 5 }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.pickerStatus = false;
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              var prefix = that.code.substring(0, 4);
              if (prefix == 'JDVG') {
                that.code = that.code.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/waybillWashOrder.vue













/* harmony default export */ var pages_waybillWashOrder = ({
  components: {
    cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, Popup: node_modules_vux_src_components_popup, Group: vux_src_components_group, PopupHeader: vux_src_components_popup_header, XButton: vux_src_components_x_button, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, wx: weixin_js_sdk_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      code: '',
      pageFlag: 2,
      hasNext: 0,
      lastId: 0,
      list: [],
      isActive: 2,
      statusArr: [{
        key: 2,
        num: 0,
        value: '已支付'
      }, {
        key: 1,
        num: 0,
        value: '未支付'
      }]
    };
  },
  created: function created() {

    this.config();
  },
  amount: function amount() {
    this.code = '';
  },

  methods: {
    copy: function copy(val) {
      this.$func.copy(val, event);
    },
    searchOrder: function searchOrder(orderNo) {
      this.$router.push({ name: 'searchOrder', params: { code: orderNo } });
    },
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.code = '';
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.loadmore();
    },
    selectStatus: function selectStatus(val) {
      if (this.isActive === val) {
        return false;
      }
      this.isActive = val;
      this.search();
    },
    queryExpress: function queryExpress(code) {
      this.$router.push({ name: 'queryExpress', params: { code: code } });
    },
    getList: function getList() {
      var _this = this;

      this.$api.getWaybillWashOrderList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code, status: this.isActive }).then(function (res) {
        if (res) {
          var list = res.data.filter(function (item) {
            return Number(item.status) !== 10;
          });
          if (!_this.lastId) {
            _this.blankShow = list.length > 0 ? false : true;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          list.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    pay: function pay(id) {
      var _this2 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认支付？', '提示', function () {
        if (typeof WeixinJSBridge == "undefined") {
          var onBridgeReady = function onBridgeReady() {
            _this2.onBridgeReady(id);
          };
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          _this2.onBridgeReady(id);
        }
      });
    },
    onBridgeReady: function onBridgeReady(id) {
      var that = this;
      this.$api.payWaybillWashOrder({ id: id }).then(function (res) {
        if (res) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.$func.showToast('支付成功');
              setTimeout(function () {
                that.search();
              }, 300);
            } else {
              that.$func.showToast('已取消支付');
            }
          });
        }
      });
    },
    changeStatus: function changeStatus(id, status) {
      var _this3 = this;

      if (!id) {
        this.$func.showToast('操作失败，请稍后再试');
        return false;
      }
      this.$func.confirm('确认操作？', '提示', function () {
        _this3.$api.changeOrderParentStatus({ id: id, status: status, type: 5 }).then(function (res) {
          if (res) {
            setTimeout(function () {
              _this3.pickerStatus = false;
              _this3.list = [];
              _this3.lastId = 0;
              _this3.hasNext = 0;

              _this3.loadmore();
            }, 300);
          }
        });
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.code = res.resultStr.split(',')[1];
              var prefix = that.code.substring(0, 4);
              if (prefix == 'JDVG') {
                that.code = that.code.substring(0, 15);
              }
              that.search();
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList();
      setTimeout(function () {
        if (_this4.blankShow) {
          _this4.busy = true;
          _this4.loadStatus = false;
          _this4.loadmoreText = '没有更多了。。。';
        } else {
          if (_this4.hasNext > 0) {
            _this4.loadStatus = false;
            _this4.busy = false;
          } else {
            _this4.busy = true;
            _this4.loadStatus = true;
            _this4.loadmoreText = '没有更多了。。。';
          }
        }
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6f2f21","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/waybillWashOrder.vue
var waybillWashOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-white shadow-gray"},[_c('div',{staticClass:"cm-bg-white cm-p-b-4",staticStyle:{"border-radius":"unset"}},[_c('ul',{staticClass:"cm-m-lr-12 cm-flex-middle cm-flex-around"},_vm._l((_vm.statusArr),function(item,index){return _c('li',{key:index,staticClass:"cm-center cm-fn-16 cm-p-tb-8 cm-p-lr-16",class:[_vm.isActive === item.key ? 'active' : ''],on:{"click":function($event){return _vm.selectStatus(item.key)}}},[_vm._v("\n                      "+_vm._s(item.value)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-12 cm-bg-white cm-m-tb-8",staticStyle:{"width":"90%"}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between",staticStyle:{"width":"80%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"cm-fn-18 cm-h-100",attrs:{"type":"text","placeholder":"请输入物流单号"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.resetSearch()}}}):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"cm-icon-22 cm-m-r-16",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-20",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-8"},[_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("订单信息")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-m-t-16 cm-flex-middle"},[(item.status == 2 || item.status == 8)?_c('p',{staticClass:"cm-fn-16 cm-color-red"},[_vm._v(_vm._s(item.status_text))]):_c('p',{staticClass:"cm-fn-16 "},[_vm._v(_vm._s(item.status_text))])])]),_vm._v(" "),(item.status != 1 && item.pick_waybill_code)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("物流单号："),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(item.pick_waybill_code))]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-10 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.pick_waybill_code)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-blue cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.queryExpress(item.pick_waybill_code)}}},[_vm._v("物流轨迹查询")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("服务单号："+_vm._s(item.order_no)),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(item.order_no)}}},[_vm._v("复制")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 "},[_vm._v("物流类型："+_vm._s(item.express_type_text))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 "},[_vm._v("衣物数量："+_vm._s(item.num)+"件")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 "},[_vm._v("总金额：￥"+_vm._s(item.total_amount)+"（"),_c('span',{staticClass:"cm-color-666"},[_vm._v("物流费：￥"+_vm._s(item.express_fee))]),_vm._v("）")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("下单时间："+_vm._s(item.create_time))])]),_vm._v(" "),(item.orders.length > 0)?_c('div',{staticClass:"shadow-gray cm-p-lr-8 cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default "},[_vm._v("子订单信息")]),_vm._v(" "),_vm._l((item.orders),function(order,j){return _c('div',{key:j,staticClass:"cm-border-bottom-1 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v(_vm._s(j+1)+"、订单号："+_vm._s(order.order_no)),_c('span',{staticClass:"cm-p-lr-2 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.copy(order.order_no)}}},[_vm._v("复制")]),_c('span',{staticClass:"cm-p-lr-2 cm-fn-12 cm-color-666 cm-border cm-m-l-4 cm-border-radius-2",on:{"click":function($event){return _vm.searchOrder(order.order_no)}}},[_vm._v("查询")])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("用户信息："+_vm._s(order.name)+" "),_c('a',{staticClass:"cm-fn-16 cm-fn-weight-default",attrs:{"href":'tel:'+order.phone}},[_vm._v(_vm._s(order.phone))]),_vm._v(" "),_c('span',{staticClass:"cm-p-lr-4 cm-fn-12 cm-color-666 cm-border cm-m-l-12 cm-border-radius-2",on:{"click":function($event){return _vm.copy(order.phone)}}},[_vm._v("复制")])]),_vm._v(" "),(order.remark)?_c('p',{staticClass:"cm-fn-14 cm-p-t-8 cm-color-666"},[_vm._v("备注："+_vm._s(order.remark))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" "},[_c('div',{staticClass:"cm-text-left cm-p-tb-8"},[_c('p',{staticClass:"cm-color-666"},[_vm._v("扎带编号：")]),_vm._v(" "),_c('p',{staticClass:" cm-fn-18"},[_vm._v(_vm._s(order.bag_code))])]),_vm._v(" "),_vm._l((order.goods),function(val,i){return _c('div',{key:i,staticClass:"cm-flex-between cm-flex-middle cm-m-t-12"},[_c('div',{staticClass:"cm-img-box image"},[_c('img',{attrs:{"src":val.goods.pic}})]),_vm._v(" "),_c('div',{staticClass:"title cm-text-left"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v(_vm._s(val.goods.title))]),_vm._v(" "),_c('p',{staticClass:"cm-color-666 cm-fn-12"},[_vm._v(_vm._s(val.attr_title))])]),_vm._v(" "),_c('p',{staticClass:"cm-color-666"},[_vm._v("×"),_c('span',{staticClass:"cm-fn-18 cm-fn-weight-default"},[_vm._v(_vm._s(val.num))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-16"},[_vm._v("￥"+_vm._s(val.price))])])}),_vm._v(" "),_c('p',{staticClass:"cm-m-t-4 cm-color-666 cm-text-right cm-fn-16"},[_vm._v("共"+_vm._s(order.num)+"件衣物 洗涤费用￥"+_vm._s(order.amount))])],2)])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 button"},[(item.status == 1)?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-w-50 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,10)}}},[_vm._v("取消订单")]):_vm._e(),_vm._v(" "),(item.status == 1)?_c('div',{staticClass:"cm-bg-green cm-p-tb-8 cm-border-radius-5 cm-w-50 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.pay(item.id)}}},[_vm._v("支付")]):_vm._e(),_vm._v(" "),(item.status != 1 && item.refund > 0)?_c('div',{staticClass:"cm-bg-orange cm-p-tb-8 cm-border-radius-5 cm-w-50 cm-center cm-color-white cm-m-r-16",on:{"click":function($event){return _vm.changeStatus(item.id,10)}}},[_vm._v("申请退款")]):_vm._e()])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1)])}
var waybillWashOrder_staticRenderFns = []
var waybillWashOrder_esExports = { render: waybillWashOrder_render, staticRenderFns: waybillWashOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_waybillWashOrder = (waybillWashOrder_esExports);
// CONCATENATED MODULE: ./src/pages/waybillWashOrder.vue
function waybillWashOrder_injectStyle (ssrContext) {
  __webpack_require__("1gH4")
}
var waybillWashOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var waybillWashOrder___vue_template_functional__ = false
/* styles */
var waybillWashOrder___vue_styles__ = waybillWashOrder_injectStyle
/* scopeId */
var waybillWashOrder___vue_scopeId__ = "data-v-2b6f2f21"
/* moduleIdentifier (server only) */
var waybillWashOrder___vue_module_identifier__ = null
var waybillWashOrder_Component = waybillWashOrder_normalizeComponent(
  pages_waybillWashOrder,
  selectortype_template_index_0_src_pages_waybillWashOrder,
  waybillWashOrder___vue_template_functional__,
  waybillWashOrder___vue_styles__,
  waybillWashOrder___vue_scopeId__,
  waybillWashOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_waybillWashOrder = (waybillWashOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collectUser.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var collectUser = ({
    name: 'collectUser',
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: false,
            phone: '',
            currentPhone: '',
            list: [],
            number: 0,
            selectedGoodsMap: {}, // 按手机号记录选中的商品和数量
            selectedGoods: [],
            selectedUsers: [],
            selectedPop: false
        };
    },
    created: function created() {
        if (this.$route.params.phone) {
            this.phone = this.$route.params.phone;
            this.search();
        }
    },

    methods: {
        search: function search() {
            if (!this.phone) {
                this.$func.showToast('请输入用户手机号');
                return false;
            }
            this.saveCurrentPhoneGoods();
            var searchPhone = this.formatPhone(this.phone);
            this.phone = searchPhone;
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList(searchPhone);
        },
        getList: function getList(searchPhone) {
            var _this = this;

            this.$api.getUserWaitCollectOrderList({ phone: searchPhone }).then(function (res) {
                if (res) {
                    _this.currentPhone = searchPhone;
                    _this.list = (res.data || []).map(function (item) {
                        var selectedItem = _this.findSelectedGoods(searchPhone, item);
                        item.selectedNum = selectedItem ? selectedItem.num : Number(item.selectedNum || 0);
                        return item;
                    });
                    _this.blankShow = _this.list.length == 0;
                    _this.refreshSelectedGoods();
                }
            });
        },
        formatPhone: function formatPhone(phone) {
            return String(phone || '').trim();
        },
        getGoodsKey: function getGoodsKey(item) {
            return [item.order_id || '', item.gid || ''].join('_');
        },
        findSelectedGoods: function findSelectedGoods(phone, item) {
            var _this2 = this;

            var selectedGoods = this.selectedGoodsMap[this.formatPhone(phone)] || [];
            var goodsKey = this.getGoodsKey(item);
            return selectedGoods.find(function (val) {
                return _this2.getGoodsKey(val) === goodsKey;
            });
        },

        // 点击商品增加下单数量
        addQuantity: function addQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            if (this.number >= 6) {
                this.$func.showToast('最多添加6件');
                return false;
            }
            if (selectedNum < Number(item.num)) {
                item.selectedNum = selectedNum + 1;
                this.updateSelectedGoods();
            } else {
                this.$func.showToast('已达到数量上限');
            }
        },

        // 减少下单数量
        minusQuantity: function minusQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            if (selectedNum > 0) {
                item.selectedNum = selectedNum - 1;
                this.updateSelectedGoods();
            }
        },
        changeQuantity: function changeQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            selectedNum = selectedNum < 0 ? 0 : selectedNum;
            selectedNum = selectedNum > Number(item.num) ? Number(item.num) : selectedNum;
            var selectedItem = this.findSelectedGoods(this.currentPhone, item);
            var otherNum = this.number - Number(selectedItem ? selectedItem.num : 0);
            var maxNum = 6 - otherNum;
            if (selectedNum > maxNum) {
                selectedNum = maxNum > 0 ? maxNum : 0;
                this.$func.showToast('最多添加6件');
            }
            item.selectedNum = selectedNum;
            this.updateSelectedGoods();
        },

        // 记录选中的商品和数量
        updateSelectedGoods: function updateSelectedGoods() {
            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
        },
        saveCurrentPhoneGoods: function saveCurrentPhoneGoods() {
            var phone = this.formatPhone(this.currentPhone || this.phone);
            if (!phone) {
                return false;
            }
            var selectedGoods = this.list.filter(function (item) {
                return Number(item.selectedNum) > 0;
            }).map(function (item) {
                return {
                    gid: item.gid,
                    num: Number(item.selectedNum),
                    title: item.title,
                    order_id: item.order_id
                };
            });
            if (selectedGoods.length > 0) {
                this.$set(this.selectedGoodsMap, phone, selectedGoods);
            } else if (this.selectedGoodsMap[phone]) {
                this.$delete(this.selectedGoodsMap, phone);
            }
        },
        refreshSelectedGoods: function refreshSelectedGoods() {
            var _this3 = this;

            var selectedGoods = [];
            var selectedUsers = [];
            keys_default()(this.selectedGoodsMap).forEach(function (phone) {
                var goods = _this3.selectedGoodsMap[phone] || [];
                var num = goods.reduce(function (acc, cur) {
                    return acc + Number(cur.num);
                }, 0);
                if (num > 0) {
                    selectedUsers.push({ phone: phone, num: num });
                    goods.forEach(function (item) {
                        selectedGoods.push(assign_default()({ phone: phone }, item));
                    });
                }
            });
            this.selectedUsers = selectedUsers;
            this.selectedGoods = selectedGoods;
            this.number = this.selectedGoods.reduce(function (acc, cur) {
                return acc + Number(cur.num);
            }, 0);
            console.log('当前选中的商品及数量：', this.selectedGoods);
        },
        removeSelectedPhone: function removeSelectedPhone(phone) {
            this.$delete(this.selectedGoodsMap, phone);
            if (phone === this.currentPhone) {
                this.list.forEach(function (item) {
                    item.selectedNum = 0;
                });
            }
            this.refreshSelectedGoods();
        },
        clearSelectedGoods: function clearSelectedGoods() {
            var _this4 = this;

            this.$func.confirm('确认清空已选商品吗？', '提示', function () {
                _this4.selectedGoodsMap = {};
                _this4.selectedGoods = [];
                _this4.selectedUsers = [];
                _this4.number = 0;
                _this4.list.forEach(function (item) {
                    item.selectedNum = 0;
                });
                _this4.closeSelectedPop();
            });
        },
        openSelectedPop: function openSelectedPop() {
            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
            this.selectedPop = true;
        },
        closeSelectedPop: function closeSelectedPop() {
            this.selectedPop = false;
        },

        // 提交订单
        submitOrder: function submitOrder() {
            var _this5 = this;

            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
            if (this.selectedGoods.length == 0) {
                this.$func.showToast('请选择商品');
                return false;
            }
            var collectOrders = this.selectedUsers.map(function (item) {
                return {
                    phone: item.phone,
                    orderGoods: _this5.selectedGoodsMap[item.phone]
                };
            });
            this.$router.push({ name: 'createCollectWashOrder', params: { phone: this.phone, orderGoods: stringify_default()(this.selectedGoods) }, query: { collectOrders: stringify_default()(collectOrders) } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collectUser.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_collectUser = ({
    name: 'collectUser',
    components: {
        cmBlank: src_components_cmBlank
    },
    data: function data() {
        return {
            blankShow: false,
            phone: '',
            currentPhone: '',
            list: [],
            number: 0,
            selectedGoodsMap: {}, // 按手机号记录选中的商品和数量
            selectedGoods: [],
            selectedUsers: [],
            selectedPop: false
        };
    },
    created: function created() {
        if (this.$route.params.phone) {
            this.phone = this.$route.params.phone;
            this.search();
        }
    },

    methods: {
        search: function search() {
            if (!this.phone) {
                this.$func.showToast('请输入用户手机号');
                return false;
            }
            this.saveCurrentPhoneGoods();
            var searchPhone = this.formatPhone(this.phone);
            this.phone = searchPhone;
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList(searchPhone);
        },
        getList: function getList(searchPhone) {
            var _this = this;

            this.$api.getUserWaitCollectOrderList({ phone: searchPhone }).then(function (res) {
                if (res) {
                    _this.currentPhone = searchPhone;
                    _this.list = (res.data || []).map(function (item) {
                        var selectedItem = _this.findSelectedGoods(searchPhone, item);
                        item.selectedNum = selectedItem ? selectedItem.num : Number(item.selectedNum || 0);
                        return item;
                    });
                    _this.blankShow = _this.list.length == 0;
                    _this.refreshSelectedGoods();
                }
            });
        },
        formatPhone: function formatPhone(phone) {
            return String(phone || '').trim();
        },
        getGoodsKey: function getGoodsKey(item) {
            return [item.order_id || '', item.gid || ''].join('_');
        },
        findSelectedGoods: function findSelectedGoods(phone, item) {
            var _this2 = this;

            var selectedGoods = this.selectedGoodsMap[this.formatPhone(phone)] || [];
            var goodsKey = this.getGoodsKey(item);
            return selectedGoods.find(function (val) {
                return _this2.getGoodsKey(val) === goodsKey;
            });
        },

        // 点击商品增加下单数量
        addQuantity: function addQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            if (this.number >= 6) {
                this.$func.showToast('最多添加6件');
                return false;
            }
            if (selectedNum < Number(item.num)) {
                item.selectedNum = selectedNum + 1;
                this.updateSelectedGoods();
            } else {
                this.$func.showToast('已达到数量上限');
            }
        },

        // 减少下单数量
        minusQuantity: function minusQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            if (selectedNum > 0) {
                item.selectedNum = selectedNum - 1;
                this.updateSelectedGoods();
            }
        },
        changeQuantity: function changeQuantity(item) {
            var selectedNum = Number(item.selectedNum || 0);
            selectedNum = selectedNum < 0 ? 0 : selectedNum;
            selectedNum = selectedNum > Number(item.num) ? Number(item.num) : selectedNum;
            var selectedItem = this.findSelectedGoods(this.currentPhone, item);
            var otherNum = this.number - Number(selectedItem ? selectedItem.num : 0);
            var maxNum = 6 - otherNum;
            if (selectedNum > maxNum) {
                selectedNum = maxNum > 0 ? maxNum : 0;
                this.$func.showToast('最多添加6件');
            }
            item.selectedNum = selectedNum;
            this.updateSelectedGoods();
        },

        // 记录选中的商品和数量
        updateSelectedGoods: function updateSelectedGoods() {
            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
        },
        saveCurrentPhoneGoods: function saveCurrentPhoneGoods() {
            var phone = this.formatPhone(this.currentPhone || this.phone);
            if (!phone) {
                return false;
            }
            var selectedGoods = this.list.filter(function (item) {
                return Number(item.selectedNum) > 0;
            }).map(function (item) {
                return {
                    gid: item.gid,
                    num: Number(item.selectedNum),
                    title: item.title,
                    order_id: item.order_id
                };
            });
            if (selectedGoods.length > 0) {
                this.$set(this.selectedGoodsMap, phone, selectedGoods);
            } else if (this.selectedGoodsMap[phone]) {
                this.$delete(this.selectedGoodsMap, phone);
            }
        },
        refreshSelectedGoods: function refreshSelectedGoods() {
            var _this3 = this;

            var selectedGoods = [];
            var selectedUsers = [];
            keys_default()(this.selectedGoodsMap).forEach(function (phone) {
                var goods = _this3.selectedGoodsMap[phone] || [];
                var num = goods.reduce(function (acc, cur) {
                    return acc + Number(cur.num);
                }, 0);
                if (num > 0) {
                    selectedUsers.push({ phone: phone, num: num });
                    goods.forEach(function (item) {
                        selectedGoods.push(assign_default()({ phone: phone }, item));
                    });
                }
            });
            this.selectedUsers = selectedUsers;
            this.selectedGoods = selectedGoods;
            this.number = this.selectedGoods.reduce(function (acc, cur) {
                return acc + Number(cur.num);
            }, 0);
            console.log('当前选中的商品及数量：', this.selectedGoods);
        },
        removeSelectedPhone: function removeSelectedPhone(phone) {
            this.$delete(this.selectedGoodsMap, phone);
            if (phone === this.currentPhone) {
                this.list.forEach(function (item) {
                    item.selectedNum = 0;
                });
            }
            this.refreshSelectedGoods();
        },
        clearSelectedGoods: function clearSelectedGoods() {
            var _this4 = this;

            this.$func.confirm('确认清空已选商品吗？', '提示', function () {
                _this4.selectedGoodsMap = {};
                _this4.selectedGoods = [];
                _this4.selectedUsers = [];
                _this4.number = 0;
                _this4.list.forEach(function (item) {
                    item.selectedNum = 0;
                });
                _this4.closeSelectedPop();
            });
        },
        openSelectedPop: function openSelectedPop() {
            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
            this.selectedPop = true;
        },
        closeSelectedPop: function closeSelectedPop() {
            this.selectedPop = false;
        },

        // 提交订单
        submitOrder: function submitOrder() {
            var _this5 = this;

            this.saveCurrentPhoneGoods();
            this.refreshSelectedGoods();
            if (this.selectedGoods.length == 0) {
                this.$func.showToast('请选择商品');
                return false;
            }
            var collectOrders = this.selectedUsers.map(function (item) {
                return {
                    phone: item.phone,
                    orderGoods: _this5.selectedGoodsMap[item.phone]
                };
            });
            this.$router.push({ name: 'createCollectWashOrder', params: { phone: this.phone, orderGoods: stringify_default()(this.selectedGoods) }, query: { collectOrders: stringify_default()(collectOrders) } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5789f950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collectUser.vue
var collectUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"search cm-w-100 cm-bg-gray"},[_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-p-lr-16 cm-bg-white cm-m-tb-8 cm-m-lr-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-24 cm-h-100",attrs:{"type":"text","placeholder":"请输入用户手机号查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone)?_c('img',{staticClass:"cm-icon-24 cm-m-r-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){_vm.phone = ''}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-24",attrs:{"src":"/static/images/icon-search.png"},on:{"click":function($event){return _vm.search()}}})])]),_vm._v(" "),_c('div',{staticClass:"list-bg ",staticStyle:{"padding-bottom":"45px"}},[_c('div',{staticClass:"cm-p-lr-8 cm-p-tb-12"},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"product-item cm-bg-white cm-m-b-12 cm-p-12 cm-flex-start shadow-gray cm-border-radius-10"},[_c('div',{staticClass:"product-img cm-img-box cm-border-radius-6",staticStyle:{"width":"80px","height":"80px","overflow":"hidden"}},[_c('img',{staticClass:"cm-img",attrs:{"src":item.pic}})]),_vm._v(" "),_c('div',{staticClass:"cm-m-l-12 cm-flex-1"},[_c('div',{staticClass:"cm-text-left",staticStyle:{"width":"55%"}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold cm-color-333"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14"},[_vm._v("￥"+_vm._s(item.price))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-m-t-4"},[_vm._v("数量："),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(item.num))]),_vm._v("件")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-12"},[_c('div',{staticClass:"stepper cm-flex-middle"},[_c('div',{staticClass:"minus-btn cm-bg-orange cm-color-white cm-border-radius-circle cm-center",on:{"click":function($event){return _vm.minusQuantity(item)}}},[_c('span',{staticClass:"cm-fn-24 cm-color-white"},[_vm._v("-")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.selectedNum),expression:"item.selectedNum"}],staticClass:"selected-count cm-m-lr-12 cm-fn-18 cm-fn-weight-bold cm-bg-ccc cm-p-4 cm-border-radius-4",attrs:{"type":"number"},domProps:{"value":(item.selectedNum)},on:{"change":function($event){return _vm.changeQuantity(item)},"blur":function($event){return _vm.changeQuantity(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "selectedNum", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"add-btn cm-bg-orange cm-color-white cm-border-radius-circle cm-center",on:{"click":function($event){return _vm.addQuantity(item)}}},[_c('span',{staticClass:"cm-fn-20 cm-color-white"},[_vm._v("+")])])])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"bottom cm-bg-white shadow-gray cm-w-100 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-lr-16 selected-total",on:{"click":function($event){return _vm.openSelectedPop()}}},[_c('p',{staticClass:"cm-fn-20 cm-fn-500 cm-m-l-16 cm-color-orange"},[_vm._v(_vm._s(_vm.number)+"件")]),_vm._v(" "),(_vm.selectedUsers.length > 0)?_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-8"},[_vm._v("已选"+_vm._s(_vm.selectedUsers.length)+"人")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-16 cm-fn-16 cm-center cm-color-white cm-bg-red",staticStyle:{"width":"35%"},on:{"click":function($event){return _vm.submitOrder()}}},[_vm._v("提交订单")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPop),expression:"selectedPop"}],staticClass:"pop selected-mask",on:{"click":function($event){return _vm.closeSelectedPop()}}}),_vm._v(" "),_c('div',{staticClass:"selected-pop cm-bg-white",class:_vm.selectedPop ? 'selected-pop-show' : ''},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1"},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-bold cm-color-333"},[_vm._v("已选手机号")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle"},[(_vm.selectedUsers.length > 0)?_c('p',{staticClass:"cm-fn-14 cm-color-orange cm-m-r-16",on:{"click":function($event){return _vm.clearSelectedGoods()}}},[_vm._v("清空")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){return _vm.closeSelectedPop()}}})])]),_vm._v(" "),_c('div',{staticClass:"selected-pop-list cm-p-lr-16 cm-p-tb-12"},[(_vm.selectedUsers.length == 0)?_c('cmBlank'):_vm._e(),_vm._v(" "),_vm._l((_vm.selectedUsers),function(item,index){return _c('div',{key:index,staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 cm-border-bottom-1"},[_c('div',[_c('p',{staticClass:"cm-fn-16 cm-color-333"},[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-m-t-4"},[_vm._v(_vm._s(item.num)+"件")])]),_vm._v(" "),_c('div',{staticClass:"cm-fn-14 cm-color-red cm-p-lr-12 cm-p-tb-4 cm-border cm-border-radius-4",on:{"click":function($event){return _vm.removeSelectedPhone(item.phone)}}},[_vm._v("删除")])])})],2)])])}
var collectUser_staticRenderFns = []
var collectUser_esExports = { render: collectUser_render, staticRenderFns: collectUser_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_collectUser = (collectUser_esExports);
// CONCATENATED MODULE: ./src/pages/collectUser.vue
function collectUser_injectStyle (ssrContext) {
  __webpack_require__("EPIE")
}
var collectUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var collectUser___vue_template_functional__ = false
/* styles */
var collectUser___vue_styles__ = collectUser_injectStyle
/* scopeId */
var collectUser___vue_scopeId__ = "data-v-5789f950"
/* moduleIdentifier (server only) */
var collectUser___vue_module_identifier__ = null
var collectUser_Component = collectUser_normalizeComponent(
  pages_collectUser,
  selectortype_template_index_0_src_pages_collectUser,
  collectUser___vue_template_functional__,
  collectUser___vue_styles__,
  collectUser___vue_scopeId__,
  collectUser___vue_module_identifier__
)

/* harmony default export */ var src_pages_collectUser = (collectUser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createCollectWashOrder.vue











/* harmony default export */ var createCollectWashOrder = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      clotheShow: false,
      rechargePop: false,
      colorShow: false,
      flawShow: false,
      clotheShowStatus: true,
      bagCode: '',
      totalAmount: 0,
      expressAmount: 0,
      order_no: '',
      type: 0,
      number: 0,
      order: {
        community: {
          name: ''
        }
      },
      froms: [],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      expressFee: [],
      info: {},
      operation: '',
      orderGoods: '',
      userOrderGoods: [],
      phone: '',
      collectOrders: [],
      collectShow: false,
      collectKeyword: '',
      collectUsers: [],
      collectUser: {},
      collectGoods: [],
      collectBlank: false
    };
  },
  created: function created() {
    var _this = this;

    this.clotheShowStatus = true;
    this.getWashCategoryGoods();
    this.$nextTick(function () {
      _this.openCollectShow();
    });
  },
  mounted: function mounted() {
    this.config();
  },

  methods: {
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.info = res.data;
        }
      });
    },
    synLastUser: function synLastUser(index) {
      if (index > 0) {
        var row = this.froms[index - 1];
        this.froms[index].name = row.name;
        this.froms[index].phone = row.phone;
      }
    },
    removeModules: function removeModules(index) {
      var that = this;
      var row = this.froms[index];
      if (row.is_package > 0) {
        that.$func.confirm('确定删除套餐所有衣物吗？', '提示', function () {
          that.froms = that.froms.filter(function (val) {
            return Number(val.key) !== Number(row.key);
          });
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      } else {
        that.$func.confirm('确认删除 ”衣物' + (index + 1) + '“ 吗？', '提示', function () {
          that.froms.splice(index, 1);
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      }
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.froms[index].bag_code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getUserCollectOrder: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this3 = this;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$api.getUserCollectOrder({ phone: this.phone, orderGoods: this.orderGoods }).then(function (res) {
                  if (res) {

                    _this3.clotheShowStatus = false;
                    _this3.flawIndex = 0;
                    _this3.froms = res.data;
                    _this3.countPrice();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserCollectOrder() {
        return _ref.apply(this, arguments);
      }

      return getUserCollectOrder;
    }(),
    parseCollectOrders: function parseCollectOrders() {
      var collectOrders = this.$route.query.collectOrders || '';
      if (!collectOrders) {
        return [];
      }
      try {
        var rows = JSON.parse(collectOrders);
        return Array.isArray(rows) ? rows.filter(function (item) {
          return item.phone && item.orderGoods && item.orderGoods.length > 0;
        }) : [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    getUserCollectOrders: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, res;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$func.startLoading('请求中...');
                _context2.prev = 1;
                list = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;
                _iterator = get_iterator_default()(this.collectOrders);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 17;
                  break;
                }

                item = _step.value;
                _context2.next = 12;
                return this.$api.getUserCollectOrder({
                  phone: item.phone,
                  orderGoods: stringify_default()(item.orderGoods)
                });

              case 12:
                res = _context2.sent;

                if (res && res.data) {
                  list = list.concat(res.data);
                }

              case 14:
                _iteratorNormalCompletion = true;
                _context2.next = 8;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                this.clotheShowStatus = false;
                this.flawIndex = 0;
                this.froms = list;
                this.countPrice();

              case 35:
                _context2.prev = 35;

                this.$func.endLoading();
                return _context2.finish(35);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 35, 38], [6, 19, 23, 31], [24,, 26, 30]]);
      }));

      function getUserCollectOrders() {
        return _ref2.apply(this, arguments);
      }

      return getUserCollectOrders;
    }(),
    getWashCategoryGoods: function getWashCategoryGoods() {
      var _this4 = this;

      this.$api.getWashCategoryGoods({}).then(function (res) {
        if (res) {
          _this4.clothes = res.data.goods;

          _this4.expressFee = res.data.expressFee;
          _this4.flaws = res.data.flaw;
          if (_this4.froms.length > 0) {
            _this4.countPrice();
          }
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'edit';
    },
    createClotheShow: function createClotheShow() {
      this.openCollectShow();
    },
    openCollectShow: function openCollectShow() {
      this.popUp = true;
      this.collectShow = true;
      this.resetCollectQuantity();
    },
    closeCollectShow: function closeCollectShow() {
      this.popUp = false;
      this.collectShow = false;
      this.resetCollectQuantity();
    },
    clearCollectSearch: function clearCollectSearch() {
      this.collectKeyword = '';
      this.collectUsers = [];
      this.collectUser = {};
      this.collectGoods = [];
      this.collectBlank = false;
    },
    resetCollectQuantity: function resetCollectQuantity() {
      this.collectGoods.forEach(function (item) {
        item.selectedNum = 0;
      });
    },
    resetCollectUser: function resetCollectUser() {
      this.collectUser = {};
      this.collectGoods = [];
      this.collectBlank = false;
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.clotheShow = false;
      this.flawShow = false;
      this.collectShow = false;
      this.clotheIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    searchCollectUsers: function searchCollectUsers() {
      var _this5 = this;

      var keyword = String(this.collectKeyword || '').trim();
      if (!keyword) {
        this.$func.showToast('请输入手机号或后四位');
        return false;
      }
      this.$api.searchCollectWashUsers({ phone: keyword }).then(function (res) {
        if (res) {
          _this5.collectUsers = res.data || [];
          _this5.collectUser = {};
          _this5.collectGoods = [];
          _this5.collectBlank = _this5.collectUsers.length == 0;
          if (_this5.collectUsers.length == 1) {
            _this5.selectCollectUser(_this5.collectUsers[0]);
          }
        }
      });
    },
    selectCollectUser: function selectCollectUser(user) {
      this.collectUser = user;
      this.collectUsers = [user];
      this.getCollectGoods(user.phone, user.uid);
    },
    getCollectGoods: function getCollectGoods(phone, uid) {
      var _this6 = this;

      this.$api.getCollectWashUserGoods({ phone: phone, uid: uid }).then(function (res) {
        if (res) {
          _this6.collectGoods = (res.data || []).map(function (item) {
            item.selectedNum = 0;
            return item;
          });
          _this6.collectBlank = _this6.collectGoods.length == 0;
        }
      });
    },
    getCollectSelectedTotal: function getCollectSelectedTotal() {
      return this.collectGoods.reduce(function (acc, cur) {
        return acc + Number(cur.selectedNum || 0);
      }, 0);
    },
    getAddedCollectOrderIds: function getAddedCollectOrderIds() {
      return this.froms.filter(function (item) {
        return Number(item.is_package) === 1 && item.order_id;
      }).map(function (item) {
        return Number(item.order_id);
      });
    },
    getCollectAvailableNum: function getCollectAvailableNum(item) {
      var orderIds = String(item.order_id || '').split(',').filter(function (id) {
        return id;
      });
      var addedIds = this.getAddedCollectOrderIds();
      return orderIds.filter(function (id) {
        return addedIds.indexOf(Number(id)) < 0;
      }).length;
    },
    addCollectQuantity: function addCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      if (this.froms.length + this.getCollectSelectedTotal() >= 6) {
        this.$func.showToast('最多添加6件');
        return false;
      }
      if (selectedNum < this.getCollectAvailableNum(item)) {
        item.selectedNum = selectedNum + 1;
      } else {
        this.$func.showToast('已达到数量上限');
      }
    },
    minusCollectQuantity: function minusCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      if (selectedNum > 0) {
        item.selectedNum = selectedNum - 1;
      }
    },
    changeCollectQuantity: function changeCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      selectedNum = selectedNum < 0 ? 0 : selectedNum;
      selectedNum = selectedNum > this.getCollectAvailableNum(item) ? this.getCollectAvailableNum(item) : selectedNum;
      item.selectedNum = 0;
      var maxNum = 6 - this.froms.length - this.getCollectSelectedTotal();
      if (selectedNum > maxNum) {
        selectedNum = maxNum > 0 ? maxNum : 0;
        this.$func.showToast('最多添加6件');
      }
      item.selectedNum = selectedNum;
    },
    confirmCollectGoods: function confirmCollectGoods() {
      var _this7 = this;

      if (!this.collectUser.phone) {
        this.$func.showToast('请选择用户');
        return false;
      }
      var selectedGoods = this.collectGoods.filter(function (item) {
        return Number(item.selectedNum) > 0;
      }).map(function (item) {
        return {
          gid: item.gid,
          num: Number(item.selectedNum),
          title: item.title,
          order_id: item.order_id
        };
      });
      if (selectedGoods.length == 0) {
        this.$func.showToast('请选择商品');
        return false;
      }
      if (this.froms.length + selectedGoods.reduce(function (acc, cur) {
        return acc + Number(cur.num);
      }, 0) > 6) {
        this.$func.showToast('最多添加6件');
        return false;
      }
      this.$api.getCollectWashSelectedOrders({
        phone: this.collectUser.phone,
        uid: this.collectUser.uid,
        orderGoods: stringify_default()(selectedGoods),
        excludeOrderIds: stringify_default()(this.getAddedCollectOrderIds())
      }).then(function (res) {
        if (res) {
          var rows = res.data || [];
          var existIds = _this7.froms.map(function (item) {
            return Number(item.order_id || item.id || 0);
          });
          var addRows = rows.filter(function (item) {
            return existIds.indexOf(Number(item.order_id || item.id || 0)) < 0;
          });
          if (addRows.length == 0) {
            _this7.$func.showToast('所选衣物已添加');
            return false;
          }
          if (_this7.froms.length + addRows.length > 6) {
            addRows = addRows.slice(0, 6 - _this7.froms.length);
            _this7.$func.showToast('最多添加6件，已自动截取');
          }
          _this7.froms = _this7.froms.concat(addRows);
          _this7.countPrice();
          _this7.closeCollectShow();
        }
      });
    },
    flawSelect: function flawSelect(i, title) {
      var _this8 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this8.froms[_this8.flawIndex].flaw += index == flaw.length - 1 ? _this8.flaws[item].title : _this8.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    clotheSelect: function clotheSelect(i) {
      var row = this.clothes[i];
      var key = Date.now();
      if (this.operation == 'add') {
        if (row.is_package > 0) {
          var price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: '',
              phone: '',
              bag_code: '',
              remark: '',
              clothe_id: row.id,
              price: price,
              clothe: row.title + '_' + (j + 1),
              filePath: [],
              pics: [],
              flaw_id: [],
              flaw: '选择瑕疵'
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: '',
            phone: '',
            bag_code: '',
            remark: '',
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: [],
            pics: [],
            flaw_id: [],
            flaw: '选择瑕疵'
          });
        }
      } else {
        var item = this.froms[this.clotheIndex];
        if (item.is_package > 0) {
          this.froms = this.froms.filter(function (val) {
            return Number(val.key) !== Number(item.key);
          });
        } else {
          this.froms.splice(this.clotheIndex, 1);
        }
        if (row.is_package > 0) {
          var _price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: item.name,
              phone: item.phone,
              bag_code: '',
              remark: item.remark,
              clothe_id: row.id,
              price: _price,
              clothe: row.title + '_' + (j + 1),
              filePath: item.filePath,
              pics: item.pics
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: item.name,
            phone: item.phone,
            bag_code: '',
            remark: item.remark,
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: item.filePath,
            pics: item.pics
          });
        }
      }
      this.countPrice();
      this.closePop();
    },
    countPrice: function countPrice() {
      var that = this,
          exAmount = 0,
          number1 = 0;
      number1 = this.froms.filter(function (item) {
        return item.is_package == 0;
      }).length;
      console.log('number1', number1);
      if (number1 > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.expressFee), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (item.num >= number1) {
              exAmount = item.amount;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.number = this.froms.length;
      this.expressAmount = exAmount;
      this.totalAmount = 0;
      this.froms.forEach(function (item, index) {
        that.totalAmount += Number(item.price);
      });
      this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
    },
    submit: function submit() {
      var _this9 = this;

      var that = this;
      if (!this.subStatus) {
        return false;
      }
      that.$func.confirm('确认提交？', '提示', function () {
        _this9.$func.startLoading('请求中...');
        that.$api.createWashOrder({ goods: stringify_default()(that.froms) }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            if (res.data.amount > 0) {
              WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  that.$func.showToast('支付成功');
                  that.subStatus = true;
                  setTimeout(function () {
                    if (that.clotheShowStatus) {
                      window.location.reload();
                    } else {
                      that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                    }
                  }, 300);
                } else {
                  that.$func.showToast('已取消支付');
                }
                that.closePop();
              });
            } else {
              that.$func.showToast('提交成功');
              that.subStatus = true;

              setTimeout(function () {
                if (that.clotheShowStatus) {
                  window.location.reload();
                } else {
                  that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                }
              }, 300);
            }
          }
        });
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/createCollectWashOrder.vue











/* harmony default export */ var pages_createCollectWashOrder = ({
  components: {
    wx: weixin_js_sdk_default.a, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, cmBlank: src_components_cmBlank
  },
  data: function data() {
    return {
      subStatus: true,
      popUp: false,
      clotheShow: false,
      rechargePop: false,
      colorShow: false,
      flawShow: false,
      clotheShowStatus: true,
      bagCode: '',
      totalAmount: 0,
      expressAmount: 0,
      order_no: '',
      type: 0,
      number: 0,
      order: {
        community: {
          name: ''
        }
      },
      froms: [],
      clotheIndex: 0,
      colorIndex: 0,
      flawIndex: 0,
      picIndex: 0,
      clothes: [],
      colors: [],
      flaws: [],
      expressFee: [],
      info: {},
      operation: '',
      orderGoods: '',
      userOrderGoods: [],
      phone: '',
      collectOrders: [],
      collectShow: false,
      collectKeyword: '',
      collectUsers: [],
      collectUser: {},
      collectGoods: [],
      collectBlank: false
    };
  },
  created: function created() {
    var _this = this;

    this.clotheShowStatus = true;
    this.getWashCategoryGoods();
    this.$nextTick(function () {
      _this.openCollectShow();
    });
  },
  mounted: function mounted() {
    this.config();
  },

  methods: {
    getInfo: function getInfo() {
      var _this2 = this;

      this.$api.getInfo({}).then(function (res) {
        if (res) {
          _this2.info = res.data;
        }
      });
    },
    synLastUser: function synLastUser(index) {
      if (index > 0) {
        var row = this.froms[index - 1];
        this.froms[index].name = row.name;
        this.froms[index].phone = row.phone;
      }
    },
    removeModules: function removeModules(index) {
      var that = this;
      var row = this.froms[index];
      if (row.is_package > 0) {
        that.$func.confirm('确定删除套餐所有衣物吗？', '提示', function () {
          that.froms = that.froms.filter(function (val) {
            return Number(val.key) !== Number(row.key);
          });
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      } else {
        that.$func.confirm('确认删除 ”衣物' + (index + 1) + '“ 吗？', '提示', function () {
          that.froms.splice(index, 1);
          that.countPrice();
          that.$func.showToast('删除成功');
        });
      }
    },
    openClotheFlaw: function openClotheFlaw(index) {
      this.flawIndex = index;
      this.popUp = true;
      this.flawShow = true;
    },
    scanQRCode: function scanQRCode(key, index) {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['barCode'],
          success: function success(res) {
            setTimeout(function () {

              that.froms[index].bag_code = res.resultStr.split(',')[1];
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    getUserCollectOrder: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this3 = this;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$api.getUserCollectOrder({ phone: this.phone, orderGoods: this.orderGoods }).then(function (res) {
                  if (res) {

                    _this3.clotheShowStatus = false;
                    _this3.flawIndex = 0;
                    _this3.froms = res.data;
                    _this3.countPrice();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserCollectOrder() {
        return _ref.apply(this, arguments);
      }

      return getUserCollectOrder;
    }(),
    parseCollectOrders: function parseCollectOrders() {
      var collectOrders = this.$route.query.collectOrders || '';
      if (!collectOrders) {
        return [];
      }
      try {
        var rows = JSON.parse(collectOrders);
        return Array.isArray(rows) ? rows.filter(function (item) {
          return item.phone && item.orderGoods && item.orderGoods.length > 0;
        }) : [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    getUserCollectOrders: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, res;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$func.startLoading('请求中...');
                _context2.prev = 1;
                list = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;
                _iterator = get_iterator_default()(this.collectOrders);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 17;
                  break;
                }

                item = _step.value;
                _context2.next = 12;
                return this.$api.getUserCollectOrder({
                  phone: item.phone,
                  orderGoods: stringify_default()(item.orderGoods)
                });

              case 12:
                res = _context2.sent;

                if (res && res.data) {
                  list = list.concat(res.data);
                }

              case 14:
                _iteratorNormalCompletion = true;
                _context2.next = 8;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                this.clotheShowStatus = false;
                this.flawIndex = 0;
                this.froms = list;
                this.countPrice();

              case 35:
                _context2.prev = 35;

                this.$func.endLoading();
                return _context2.finish(35);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 35, 38], [6, 19, 23, 31], [24,, 26, 30]]);
      }));

      function getUserCollectOrders() {
        return _ref2.apply(this, arguments);
      }

      return getUserCollectOrders;
    }(),
    getWashCategoryGoods: function getWashCategoryGoods() {
      var _this4 = this;

      this.$api.getWashCategoryGoods({}).then(function (res) {
        if (res) {
          _this4.clothes = res.data.goods;

          _this4.expressFee = res.data.expressFee;
          _this4.flaws = res.data.flaw;
          if (_this4.froms.length > 0) {
            _this4.countPrice();
          }
        }
      });
    },
    openClotheShow: function openClotheShow(index) {
      this.clotheIndex = index;
      this.popUp = true;
      this.clotheShow = true;
      this.operation = 'edit';
    },
    createClotheShow: function createClotheShow() {
      this.openCollectShow();
    },
    openCollectShow: function openCollectShow() {
      this.popUp = true;
      this.collectShow = true;
      this.resetCollectQuantity();
    },
    closeCollectShow: function closeCollectShow() {
      this.popUp = false;
      this.collectShow = false;
      this.resetCollectQuantity();
    },
    clearCollectSearch: function clearCollectSearch() {
      this.collectKeyword = '';
      this.collectUsers = [];
      this.collectUser = {};
      this.collectGoods = [];
      this.collectBlank = false;
    },
    resetCollectQuantity: function resetCollectQuantity() {
      this.collectGoods.forEach(function (item) {
        item.selectedNum = 0;
      });
    },
    resetCollectUser: function resetCollectUser() {
      this.collectUser = {};
      this.collectGoods = [];
      this.collectBlank = false;
    },
    closePop: function closePop() {
      this.popUp = false;
      this.rechargePop = false;
      this.clotheShow = false;
      this.flawShow = false;
      this.collectShow = false;
      this.clotheIndex = 0;
      this.flawIndex = 0;
      this.amount = 0;
    },
    searchCollectUsers: function searchCollectUsers() {
      var _this5 = this;

      var keyword = String(this.collectKeyword || '').trim();
      if (!keyword) {
        this.$func.showToast('请输入手机号或后四位');
        return false;
      }
      this.$api.searchCollectWashUsers({ phone: keyword }).then(function (res) {
        if (res) {
          _this5.collectUsers = res.data || [];
          _this5.collectUser = {};
          _this5.collectGoods = [];
          _this5.collectBlank = _this5.collectUsers.length == 0;
          if (_this5.collectUsers.length == 1) {
            _this5.selectCollectUser(_this5.collectUsers[0]);
          }
        }
      });
    },
    selectCollectUser: function selectCollectUser(user) {
      this.collectUser = user;
      this.collectUsers = [user];
      this.getCollectGoods(user.phone, user.uid);
    },
    getCollectGoods: function getCollectGoods(phone, uid) {
      var _this6 = this;

      this.$api.getCollectWashUserGoods({ phone: phone, uid: uid }).then(function (res) {
        if (res) {
          _this6.collectGoods = (res.data || []).map(function (item) {
            item.selectedNum = 0;
            return item;
          });
          _this6.collectBlank = _this6.collectGoods.length == 0;
        }
      });
    },
    getCollectSelectedTotal: function getCollectSelectedTotal() {
      return this.collectGoods.reduce(function (acc, cur) {
        return acc + Number(cur.selectedNum || 0);
      }, 0);
    },
    getAddedCollectOrderIds: function getAddedCollectOrderIds() {
      return this.froms.filter(function (item) {
        return Number(item.is_package) === 1 && item.order_id;
      }).map(function (item) {
        return Number(item.order_id);
      });
    },
    getCollectAvailableNum: function getCollectAvailableNum(item) {
      var orderIds = String(item.order_id || '').split(',').filter(function (id) {
        return id;
      });
      var addedIds = this.getAddedCollectOrderIds();
      return orderIds.filter(function (id) {
        return addedIds.indexOf(Number(id)) < 0;
      }).length;
    },
    addCollectQuantity: function addCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      if (this.froms.length + this.getCollectSelectedTotal() >= 6) {
        this.$func.showToast('最多添加6件');
        return false;
      }
      if (selectedNum < this.getCollectAvailableNum(item)) {
        item.selectedNum = selectedNum + 1;
      } else {
        this.$func.showToast('已达到数量上限');
      }
    },
    minusCollectQuantity: function minusCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      if (selectedNum > 0) {
        item.selectedNum = selectedNum - 1;
      }
    },
    changeCollectQuantity: function changeCollectQuantity(item) {
      var selectedNum = Number(item.selectedNum || 0);
      selectedNum = selectedNum < 0 ? 0 : selectedNum;
      selectedNum = selectedNum > this.getCollectAvailableNum(item) ? this.getCollectAvailableNum(item) : selectedNum;
      item.selectedNum = 0;
      var maxNum = 6 - this.froms.length - this.getCollectSelectedTotal();
      if (selectedNum > maxNum) {
        selectedNum = maxNum > 0 ? maxNum : 0;
        this.$func.showToast('最多添加6件');
      }
      item.selectedNum = selectedNum;
    },
    confirmCollectGoods: function confirmCollectGoods() {
      var _this7 = this;

      if (!this.collectUser.phone) {
        this.$func.showToast('请选择用户');
        return false;
      }
      var selectedGoods = this.collectGoods.filter(function (item) {
        return Number(item.selectedNum) > 0;
      }).map(function (item) {
        return {
          gid: item.gid,
          num: Number(item.selectedNum),
          title: item.title,
          order_id: item.order_id
        };
      });
      if (selectedGoods.length == 0) {
        this.$func.showToast('请选择商品');
        return false;
      }
      if (this.froms.length + selectedGoods.reduce(function (acc, cur) {
        return acc + Number(cur.num);
      }, 0) > 6) {
        this.$func.showToast('最多添加6件');
        return false;
      }
      this.$api.getCollectWashSelectedOrders({
        phone: this.collectUser.phone,
        uid: this.collectUser.uid,
        orderGoods: stringify_default()(selectedGoods),
        excludeOrderIds: stringify_default()(this.getAddedCollectOrderIds())
      }).then(function (res) {
        if (res) {
          var rows = res.data || [];
          var existIds = _this7.froms.map(function (item) {
            return Number(item.order_id || item.id || 0);
          });
          var addRows = rows.filter(function (item) {
            return existIds.indexOf(Number(item.order_id || item.id || 0)) < 0;
          });
          if (addRows.length == 0) {
            _this7.$func.showToast('所选衣物已添加');
            return false;
          }
          if (_this7.froms.length + addRows.length > 6) {
            addRows = addRows.slice(0, 6 - _this7.froms.length);
            _this7.$func.showToast('最多添加6件，已自动截取');
          }
          _this7.froms = _this7.froms.concat(addRows);
          _this7.countPrice();
          _this7.closeCollectShow();
        }
      });
    },
    flawSelect: function flawSelect(i, title) {
      var _this8 = this;

      var flawId = this.froms[this.flawIndex].flaw_id;
      if (flawId) {
        if (flawId.indexOf(i) > -1) {
          flawId.splice(flawId.indexOf(i), 1);
          this.froms[this.flawIndex].flaw_id = flawId;
        } else {
          this.froms[this.flawIndex].flaw_id.push(i);
        }
      } else {
        this.froms[this.flawIndex].flaw_id.push(i);
      }
      var flaw = this.froms[this.flawIndex].flaw_id;
      this.froms[this.flawIndex].flaw = '';
      flaw.forEach(function (item, index) {
        _this8.froms[_this8.flawIndex].flaw += index == flaw.length - 1 ? _this8.flaws[item].title : _this8.flaws[item].title + ',';
      });
      if (this.froms[this.flawIndex].flaw_id.length < 1) {
        this.froms[this.flawIndex].flaw = '选择瑕疵';
      }
    },
    clotheSelect: function clotheSelect(i) {
      var row = this.clothes[i];
      var key = Date.now();
      if (this.operation == 'add') {
        if (row.is_package > 0) {
          var price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: '',
              phone: '',
              bag_code: '',
              remark: '',
              clothe_id: row.id,
              price: price,
              clothe: row.title + '_' + (j + 1),
              filePath: [],
              pics: [],
              flaw_id: [],
              flaw: '选择瑕疵'
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: '',
            phone: '',
            bag_code: '',
            remark: '',
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: [],
            pics: [],
            flaw_id: [],
            flaw: '选择瑕疵'
          });
        }
      } else {
        var item = this.froms[this.clotheIndex];
        if (item.is_package > 0) {
          this.froms = this.froms.filter(function (val) {
            return Number(val.key) !== Number(item.key);
          });
        } else {
          this.froms.splice(this.clotheIndex, 1);
        }
        if (row.is_package > 0) {
          var _price = Number(row.price / row.wash_num).toFixed(2);
          for (var j = 0; j < row.wash_num; j++) {
            this.froms.push({
              is_package: 1,
              key: key,
              name: item.name,
              phone: item.phone,
              bag_code: '',
              remark: item.remark,
              clothe_id: row.id,
              price: _price,
              clothe: row.title + '_' + (j + 1),
              filePath: item.filePath,
              pics: item.pics
            });
          }
        } else {
          this.froms.push({
            is_package: 0,
            key: key,
            name: item.name,
            phone: item.phone,
            bag_code: '',
            remark: item.remark,
            clothe_id: row.id,
            price: row.price,
            clothe: row.title,
            filePath: item.filePath,
            pics: item.pics
          });
        }
      }
      this.countPrice();
      this.closePop();
    },
    countPrice: function countPrice() {
      var that = this,
          exAmount = 0,
          number1 = 0;
      number1 = this.froms.filter(function (item) {
        return item.is_package == 0;
      }).length;
      console.log('number1', number1);
      if (number1 > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.expressFee), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (item.num >= number1) {
              exAmount = item.amount;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.number = this.froms.length;
      this.expressAmount = exAmount;
      this.totalAmount = 0;
      this.froms.forEach(function (item, index) {
        that.totalAmount += Number(item.price);
      });
      this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
    },
    submit: function submit() {
      var _this9 = this;

      var that = this;
      if (!this.subStatus) {
        return false;
      }
      that.$func.confirm('确认提交？', '提示', function () {
        _this9.$func.startLoading('请求中...');
        that.$api.createWashOrder({ goods: stringify_default()(that.froms) }).then(function (res) {
          if (res) {
            that.$func.endLoading();
            if (res.data.amount > 0) {
              WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  that.$func.showToast('支付成功');
                  that.subStatus = true;
                  setTimeout(function () {
                    if (that.clotheShowStatus) {
                      window.location.reload();
                    } else {
                      that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                    }
                  }, 300);
                } else {
                  that.$func.showToast('已取消支付');
                }
                that.closePop();
              });
            } else {
              that.$func.showToast('提交成功');
              that.subStatus = true;

              setTimeout(function () {
                if (that.clotheShowStatus) {
                  window.location.reload();
                } else {
                  that.$router.replace({ name: 'collectUser', params: { phone: that.phone } });
                }
              }, 300);
            }
          }
        });
      });
    },
    config: function config() {

      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage", "scanQRCode"]
          });
        }
      });
    },
    uploadFile: function uploadFile(index) {
      var that = this;
      this.picIndex = index;
      weixin_js_sdk_default.a.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          that.uploadImg(res.localIds);
        }
      });
    },
    uploadImg: function uploadImg(localIds) {
      var that = this;
      var localId = localIds.pop();
      weixin_js_sdk_default.a.uploadImage({
        localId: localId,
        success: function success(res) {
          that.$api.uploadsImgOss({ serverId: res.serverId, path: 'record' }).then(function (res) {
            if (res) {
              that.froms[that.picIndex].filePath.push(res.data.pathName);
              that.froms[that.picIndex].pics.push(res.data.saveName);
              if (localIds.length > 0) {
                that.uploadImg(localIds);
              }
            }
          });
        }
      });
    },
    showPic: function showPic(i, index) {
      weixin_js_sdk_default.a.previewImage({
        current: this.froms[i].filePath[index],
        urls: [this.froms[i].filePath[index]]
      });
    },
    delImg: function delImg(i, index) {
      this.froms[i].filePath.splice(index, 1);
      this.froms[i].pics.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33046f44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/createCollectWashOrder.vue
var createCollectWashOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main cm-p-b-32"},[_c('div',{staticClass:"cm-bg-white cm-p-b-32 cm-p-t-12 "},[(_vm.froms.length > 0)?_c('div',{staticClass:"cm-p-lr-8"},_vm._l((_vm.froms),function(item,index){return _c('div',{key:index,staticClass:" cm-p-lr-8 cm-m-t-8 shadow-gray"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12"},[_c('p',{staticClass:"cm-color-blue  cm-text-left cm-fn-16"},[_vm._v("衣物"+_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-4 cm-p-lr-8 cm-bg-orange cm-color-white cm-border-radius-5",on:{"click":function($event){return _vm.removeModules(index)}}},[_vm._v("删除")])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("扎带码")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.bag_code),expression:"item.bag_code"}],staticClass:"cm-fn-16 cm-color-red cm-text-left",attrs:{"type":"text","placeholder":"请输入扎带码或扫码"},domProps:{"value":(item.bag_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "bag_code", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode(1,index)}}})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("顾客姓名")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"}],staticClass:"cm-fn-16 cm-color-333 cm-fn-weight-default cm-m-r-12 cm-text-right cm-w-100 cm-p-tb-4 ",attrs:{"type":"text","placeholder":"输入姓名"},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}}),_vm._v(" "),(item.name)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){item.name = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("顾客电话")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.phone),expression:"item.phone"}],staticClass:"cm-fn-16 cm-text-right cm-m-r-12 cm-color-orange cm-p-tb-4 ",attrs:{"type":"number","placeholder":"输入电话"},domProps:{"value":(item.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "phone", $event.target.value)}}}),_vm._v(" "),(item.phone)?_c('img',{staticClass:"cm-icon-13",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":function($event){item.phone = ''}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("下单衣物")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheShow(index)}}},[_c('p',{staticClass:"cm-fn-16",class:[item.clothe_id > 0 ? 'cm-color-orange' : 'cm-color-666']},[_vm._v(_vm._s(item.clothe)+" "),(item.clothe_id > 0)?_c('span',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v("（￥"+_vm._s(item.price)+"）")]):_vm._e()]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-15"},[_vm._v("衣物瑕疵")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-end",on:{"click":function($event){return _vm.openClotheFlaw(index)}}},[_c('p',{staticClass:"cm-fn-16 cm-color-orange"},[_vm._v(_vm._s(item.flaw))]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])]),_vm._v(" "),_c('div',{staticClass:"border-b cm-p-b-12"},[_c('p',{staticClass:"cm-fn-15 cm-m-t-12"},[_vm._v("衣物图片")]),_vm._v(" "),_c('ul',{staticClass:"cm-w-100 cm-flex-start cm-flex-wrap img-list"},[_vm._l((item.filePath),function(val,i){return _c('li',{key:i,staticClass:"cm-img-box cm-m-l-4 cm-pr"},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":val},on:{"click":function($event){return _vm.showPic(index,i)}}}),_vm._v(" "),_c('div',{staticClass:"del_img cm-bg-white cm-img-box",on:{"click":function($event){return _vm.delImg(index,i)}}},[_c('img',{attrs:{"src":"/static/images/remove.png"}})])])}),_vm._v(" "),_c('li',{staticClass:"cm-img-box cm-m-l-4",on:{"click":function($event){return _vm.uploadFile(index)}}},[_c('img',{attrs:{"src":"/static/images/photo@2x.png"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"cm-p-b-12"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("备注")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":100,"placeholder":"100字以内（选填）","height":30},model:{value:(item.remark),callback:function ($$v) {_vm.$set(item, "remark", $$v)},expression:"item.remark"}})],1)],1)])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom cm-bg-white shadow-gray cm-w-100 cm-flex-between cm-flex-middle"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle cm-p-lr-16"},[_c('p',{staticClass:"cm-fn-20 cm-fn-500 cm-m-l-16 cm-color-orange"},[_vm._v(_vm._s(_vm.number)+"件")]),_vm._v(" "),_c('div',{staticClass:"cm-fn-16 cm-m-l-16 "},[_c('p',[_vm._v("合计:"),_c('span',{staticClass:"cm-fn-20 cm-color-orange "},[_vm._v("￥"+_vm._s(_vm.totalAmount))])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-10"},[_vm._v("含物流费:"),_c('span',{staticClass:"cm-color-orange"},[_vm._v(_vm._s(_vm.expressAmount))])])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-16 cm-fn-16 cm-center cm-color-white cm-bg-red",staticStyle:{"width":"35%"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交订单")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clotheShow),expression:"clotheShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.clothes),function(val,i){return _c('div',{key:i,staticClass:"cm-p-tb-4 cm-p-lr-8 cm-m-t-4 shadow-gray cm-border-radius-8 cm-m-r-12",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-bg-orange ' :'cm-bg-white',on:{"click":function($event){return _vm.clotheSelect(i)}}},[_c('div',{staticClass:"cm-center cm-img-box cm-border-radius-4"},[_c('img',{staticClass:"cm-img",attrs:{"src":val.pic_path}})]),_vm._v(" "),_c('p',{staticClass:"cm-text-center cm-m-t-4",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-color-white' :''},[_vm._v(_vm._s(val.title))]),_vm._v(" "),_c('p',{staticClass:"cm-text-center",class:_vm.froms.length > _vm.clotheIndex && val.id == _vm.froms[_vm.clotheIndex].clothe_id ? 'cm-color-white' :''},[_vm._v("￥"+_vm._s(val.price))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flawShow),expression:"flawShow"}],staticClass:"clothe-show cm-p-b-20 cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"cm-bg-white cm-m-lr-8 cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-start cm-flex-wrap "},_vm._l((_vm.flaws),function(item,index){return _c('div',{key:index,staticClass:"cm-center cm-p-tb-4 cm-p-lr-8 cm-m-t-12 cm-border-radius-2 cm-m-r-12",class:_vm.froms[_vm.flawIndex] && _vm.froms[_vm.flawIndex].flaw_id.indexOf(index) > -1 ? 'cm-bg-orange cm-color-white' :'cm-bg-gray',on:{"click":function($event){return _vm.flawSelect(index,item.title)}}},[_vm._v(_vm._s(item.title))])}),0),_vm._v(" "),_c('div',{staticClass:"cm-center"},[_c('div',{staticClass:"cm-p-tb-12 cm-fn-14 cm-center cm-border-radius-10 cm-color-white cm-bg-orange cm-m-t-16",staticStyle:{"width":"80%"},on:{"click":function($event){return _vm.closePop()}}},[_vm._v("确定")])])]),_vm._v(" "),_c('div',{staticClass:"cm-pa cm-img-box cm-icon-20",staticStyle:{"right":"5px","top":"5px"},on:{"click":_vm.closePop}},[_c('img',{attrs:{"src":"/static/images/icon-sku-close.png"}})])]),_vm._v(" "),(_vm.clotheShowStatus)?_c('div',{staticClass:"cm-pf cm-img-box cm-bg-blue cm-text-center cm-border-radius",staticStyle:{"width":"56px","height":"56px","bottom":"85px","right":"15px"},on:{"click":function($event){return _vm.createClotheShow()}}},[_c('p',{staticClass:"cm-fn-12 cm-m-t-8 cm-color-white"},[_vm._v("添加")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-white"},[_vm._v("衣物")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.collectShow),expression:"collectShow"}],staticClass:"collect-pop cm-bg-white cm-border-radius-10"},[_c('div',{staticClass:"collect-pop-header cm-flex-between cm-flex-middle cm-p-lr-16 cm-p-tb-12"},[_vm._m(0),_vm._v(" "),_c('img',{staticClass:"cm-icon-16",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.closeCollectShow}})]),_vm._v(" "),_c('div',{staticClass:"collect-pop-body cm-p-12"},[_c('div',{staticClass:"collect-search cm-flex-between cm-flex-middle cm-bg-gray cm-p-lr-12 cm-border-radius-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collectKeyword),expression:"collectKeyword"}],staticClass:"cm-fn-16 cm-h-100 collect-search-input",attrs:{"type":"text","placeholder":"输入购买人手机号或后四位"},domProps:{"value":(_vm.collectKeyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchCollectUsers()},"input":function($event){if($event.target.composing){ return; }_vm.collectKeyword=$event.target.value}}}),_vm._v(" "),(_vm.collectKeyword)?_c('img',{staticClass:"collect-search-clear cm-icon-16 cm-m-r-8",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.clearCollectSearch}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"collect-search-btn cm-center",on:{"click":function($event){return _vm.searchCollectUsers()}}},[_c('img',{staticClass:"cm-icon-24",attrs:{"src":"/static/images/icon-search.png"}})])]),_vm._v(" "),(_vm.collectUsers.length > 1)?_c('div',{staticClass:"cm-m-t-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-m-b-8"},[_vm._v("请选择用户")]),_vm._v(" "),_vm._l((_vm.collectUsers),function(item,index){return _c('div',{key:index,staticClass:"collect-user-row cm-flex-between cm-flex-middle cm-p-12 cm-m-b-8",on:{"click":function($event){return _vm.selectCollectUser(item)}}},[_c('div',[_c('p',{staticClass:"cm-fn-16 cm-color-333"},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("待收"+_vm._s(item.order_num)+"单 / "+_vm._s(item.goods_num)+"件")])]),_vm._v(" "),_c('i',{staticClass:"icon-youjiantou- cm-fn-16 iconfont cm-color-999"})])})],2):_vm._e(),_vm._v(" "),(_vm.collectUser.phone)?_c('div',{staticClass:"collect-user-panel cm-m-t-12"},[_c('div',{staticClass:"collect-current-user cm-flex-between cm-flex-middle cm-m-b-8 cm-p-12"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("当前购买人："+_vm._s(_vm.collectUser.name)+" "+_vm._s(_vm.collectUser.phone))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-blue",on:{"click":_vm.resetCollectUser}},[_vm._v("重选")])]),_vm._v(" "),_c('div',{staticClass:"collect-goods-list"},[_vm._l((_vm.collectGoods),function(item,index){return _c('div',{key:index,staticClass:"collect-product-item cm-bg-white cm-m-b-12 cm-p-12 cm-border-radius-10",class:_vm.getCollectAvailableNum(item) < 1 ? 'collect-product-disabled' : ''},[_c('div',{staticClass:"product-main cm-flex-start"},[_c('div',{staticClass:"product-img cm-img-box cm-border-radius-6"},[_c('img',{staticClass:"cm-img",attrs:{"src":item.pic}})]),_vm._v(" "),_c('div',{staticClass:"product-info cm-m-l-12"},[_c('p',{staticClass:"product-title cm-fn-16 cm-fn-weight-bold cm-color-333"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"product-meta cm-flex-between cm-flex-middle cm-m-t-8"},[_c('p',{staticClass:"cm-fn-15 cm-color-red"},[_vm._v("￥"+_vm._s(item.price))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-13 cm-color-666"},[_vm._v("可添加 "),_c('span',{staticClass:"cm-color-orange cm-fn-16"},[_vm._v(_vm._s(_vm.getCollectAvailableNum(item)))]),_vm._v(" / "+_vm._s(item.num))])])])]),_vm._v(" "),_c('div',{staticClass:"product-action cm-flex-between cm-flex-middle cm-m-t-12"},[_c('p',{staticClass:"cm-fn-13 cm-color-999"},[_vm._v("选择数量")]),_vm._v(" "),_c('div',{staticClass:"stepper cm-flex-middle"},[_c('div',{staticClass:"minus-btn cm-bg-orange cm-color-white cm-border-radius-circle cm-center",on:{"click":function($event){return _vm.minusCollectQuantity(item)}}},[_c('span',{staticClass:"cm-fn-24 cm-color-white"},[_vm._v("-")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.selectedNum),expression:"item.selectedNum"}],staticClass:"selected-count cm-m-lr-12 cm-fn-18 cm-fn-weight-bold cm-bg-ccc cm-p-4 cm-border-radius-4",attrs:{"type":"number"},domProps:{"value":(item.selectedNum)},on:{"change":function($event){return _vm.changeCollectQuantity(item)},"blur":function($event){return _vm.changeCollectQuantity(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "selectedNum", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"add-btn cm-bg-orange cm-color-white cm-border-radius-circle cm-center",on:{"click":function($event){return _vm.addCollectQuantity(item)}}},[_c('span',{staticClass:"cm-fn-20 cm-color-white"},[_vm._v("+")])])])])])}),_vm._v(" "),(_vm.collectBlank)?_c('cmBlank'):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"collect-confirm-bar cm-center"},[_c('div',{staticClass:"collect-confirm cm-p-tb-12 cm-fn-16 cm-center cm-border-radius-8 cm-color-white cm-bg-red cm-m-t-8",on:{"click":_vm.confirmCollectGoods}},[_vm._v("确认添加"),(_vm.getCollectSelectedTotal() > 0)?_c('span',[_vm._v("（"+_vm._s(_vm.getCollectSelectedTotal())+"件）")]):_vm._e()])])]):_vm._e()])])])}
var createCollectWashOrder_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"cm-fn-18 cm-fn-weight-bold cm-color-333"},[_vm._v("添加免洗衣物")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("可按购买人完整手机号或后四位查询")])])}]
var createCollectWashOrder_esExports = { render: createCollectWashOrder_render, staticRenderFns: createCollectWashOrder_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_createCollectWashOrder = (createCollectWashOrder_esExports);
// CONCATENATED MODULE: ./src/pages/createCollectWashOrder.vue
function createCollectWashOrder_injectStyle (ssrContext) {
  __webpack_require__("fXPf")
}
var createCollectWashOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var createCollectWashOrder___vue_template_functional__ = false
/* styles */
var createCollectWashOrder___vue_styles__ = createCollectWashOrder_injectStyle
/* scopeId */
var createCollectWashOrder___vue_scopeId__ = "data-v-33046f44"
/* moduleIdentifier (server only) */
var createCollectWashOrder___vue_module_identifier__ = null
var createCollectWashOrder_Component = createCollectWashOrder_normalizeComponent(
  pages_createCollectWashOrder,
  selectortype_template_index_0_src_pages_createCollectWashOrder,
  createCollectWashOrder___vue_template_functional__,
  createCollectWashOrder___vue_styles__,
  createCollectWashOrder___vue_scopeId__,
  createCollectWashOrder___vue_module_identifier__
)

/* harmony default export */ var src_pages_createCollectWashOrder = (createCollectWashOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/device.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var device = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            popUp: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            info: {},
            qrcode: '',
            qrcodeTitle: '',
            qrcodeShow: false,
            showMoreIndex: -1,
            index: '',
            lightType: '',
            number: '30',
            strip_code: ''
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        this.code = '';
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        clickType: function clickType(i) {
            this.formData.type = i;
        },
        add: function add(id) {
            this.$router.push({ name: 'deviceEdit', params: { id: id } });
        },
        setting: function setting(id) {
            this.$router.push({ name: 'deviceSetting', params: { id: id } });
        },
        airPair: function airPair(id) {
            this.$router.push({ name: 'airPair', params: { id: id } });
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getDeviceList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        operate: function operate(index, state) {
            var _this2 = this;

            this.$func.startLoading('请求中。。。');
            var id = this.list[index].id;
            var type = this.list[index].type;
            this.$api.deviceOperate({ id: id, state: state }).then(function (res) {
                if (res.code === 0) {
                    if (type == 3 || type == 4) {
                        _this2.list[index].state = state;
                    }
                    _this2.$func.showToast('操作成功');
                }
                _this2.$func.endLoading();
            });
        },
        changeStatus: function changeStatus(index, status) {
            var _this3 = this;

            var text = status ? '确认开启该设备？' : '确认关闭该设备？';
            this.$func.confirm(text, '提示', function () {
                _this3.$func.startLoading('请求中。。。');
                var id = _this3.list[index].id;
                _this3.$api.changeDeviceStatus({ id: id, status: status }).then(function (res) {
                    if (res.code === 0) {
                        _this3.list[index].status = status;
                        if (status && _this3.list[index].type == 5) {
                            _this3.list[index].on_line = 1;
                        } else if (!status) {
                            _this3.list[index].on_line = 0;
                        }
                        _this3.$func.showToast('操作成功');
                    }
                    _this3.$func.endLoading();
                });
            });
        },
        lightUp: function lightUp(index, type) {
            this.index = index;
            this.lightType = type;
            this.popUp = true;
        },
        submitLight: function submitLight() {
            var _this4 = this;

            this.$func.startLoading('请求中。。。');
            var id = this.list[this.index].id;
            this.$api.operateLightUp({ id: id, strip_code: this.strip_code, number: this.number, type: this.lightType }).then(function (res) {
                if (res.code === 0) {
                    _this4.$func.showToast('操作成功');
                }
                _this4.$func.endLoading();
            });
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            if (res.resultStr.indexOf(",") != -1) {
                                that.strip_code = res.resultStr.split(',')[1];
                            } else {
                                that.strip_code = res.resultStr;
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        delDevice: function delDevice(id) {
            var _this5 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this5.$api.delDevice({ id: id }).then(function (res) {
                    if (res) {
                        _this5.resetSearch();
                    }
                });
            });
        },
        qrcodeDevice: function qrcodeDevice(id, type) {
            var _this6 = this;

            this.$func.startLoading('请求中。。。');
            this.$api.qrcodeDevice({ id: id, type: type }).then(function (res) {
                if (res) {
                    _this6.$func.endLoading();
                    _this6.qrcode = res.data.qrcode;
                    _this6.qrcodeTitle = type ? '取衣码' : '开锁码';
                    _this6.qrcodeShow = true;
                }
            });
        },
        toggleMore: function toggleMore(index) {
            if (this.showMoreIndex == index) {
                this.showMoreIndex = -1;
            } else {
                this.showMoreIndex = index;
            }
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this7 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this7.blankShow) {
                    _this7.busy = true;
                    _this7.loadStatus = false;
                    _this7.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this7.hasNext > 0) {
                        _this7.loadStatus = false;
                        _this7.busy = false;
                    } else {
                        _this7.busy = true;
                        _this7.loadStatus = true;
                        _this7.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/device.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_device = ({
    components: {
        cmBlank: src_components_cmBlank, cmLoadmore: src_components_cmLoadmore, wx: weixin_js_sdk_default.a
    },
    data: function data() {
        return {
            blankShow: false,
            loadStatus: false,
            popUp: false,
            loadmoreText: '正在加载。。。',
            busy: false,
            pageFlag: 2,
            hasNext: 0,
            lastId: 0,
            list: [],
            info: {},
            qrcode: '',
            qrcodeTitle: '',
            qrcodeShow: false,
            showMoreIndex: -1,
            index: '',
            lightType: '',
            number: '30',
            strip_code: ''
        };
    },
    created: function created() {
        this.config();
    },
    mounted: function mounted() {
        this.code = '';
    },

    methods: {
        copy: function copy(val) {
            this.$func.copy(val, event);
        },
        clickType: function clickType(i) {
            this.formData.type = i;
        },
        add: function add(id) {
            this.$router.push({ name: 'deviceEdit', params: { id: id } });
        },
        setting: function setting(id) {
            this.$router.push({ name: 'deviceSetting', params: { id: id } });
        },
        airPair: function airPair(id) {
            this.$router.push({ name: 'airPair', params: { id: id } });
        },
        search: function search() {
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        resetSearch: function resetSearch() {
            this.code = '';
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.loadmore();
        },
        searchSubmit: function searchSubmit() {
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList: function getList() {
            var _this = this;

            this.$api.getDeviceList({ last_id: this.lastId, page_flag: this.pageFlag, code: this.code }).then(function (res) {
                if (res) {
                    if (!_this.lastId) {
                        _this.blankShow = res.data.length > 0 ? false : true;
                    }
                    _this.hasNext = res.hasNext;
                    _this.lastId = res.lastId;
                    res.data.forEach(function (item) {
                        _this.list.push(item);
                    });
                }
            });
        },
        operate: function operate(index, state) {
            var _this2 = this;

            this.$func.startLoading('请求中。。。');
            var id = this.list[index].id;
            var type = this.list[index].type;
            this.$api.deviceOperate({ id: id, state: state }).then(function (res) {
                if (res.code === 0) {
                    if (type == 3 || type == 4) {
                        _this2.list[index].state = state;
                    }
                    _this2.$func.showToast('操作成功');
                }
                _this2.$func.endLoading();
            });
        },
        changeStatus: function changeStatus(index, status) {
            var _this3 = this;

            var text = status ? '确认开启该设备？' : '确认关闭该设备？';
            this.$func.confirm(text, '提示', function () {
                _this3.$func.startLoading('请求中。。。');
                var id = _this3.list[index].id;
                _this3.$api.changeDeviceStatus({ id: id, status: status }).then(function (res) {
                    if (res.code === 0) {
                        _this3.list[index].status = status;
                        if (status && _this3.list[index].type == 5) {
                            _this3.list[index].on_line = 1;
                        } else if (!status) {
                            _this3.list[index].on_line = 0;
                        }
                        _this3.$func.showToast('操作成功');
                    }
                    _this3.$func.endLoading();
                });
            });
        },
        lightUp: function lightUp(index, type) {
            this.index = index;
            this.lightType = type;
            this.popUp = true;
        },
        submitLight: function submitLight() {
            var _this4 = this;

            this.$func.startLoading('请求中。。。');
            var id = this.list[this.index].id;
            this.$api.operateLightUp({ id: id, strip_code: this.strip_code, number: this.number, type: this.lightType }).then(function (res) {
                if (res.code === 0) {
                    _this4.$func.showToast('操作成功');
                }
                _this4.$func.endLoading();
            });
        },
        scanQRCode: function scanQRCode() {
            var that = this;
            weixin_js_sdk_default.a.ready(function () {
                weixin_js_sdk_default.a.scanQRCode({
                    needResult: 1,
                    scanType: ['barCode'],
                    success: function success(res) {
                        setTimeout(function () {
                            if (res.resultStr.indexOf(",") != -1) {
                                that.strip_code = res.resultStr.split(',')[1];
                            } else {
                                that.strip_code = res.resultStr;
                            }
                        }, 300);
                    }
                });
            });
            weixin_js_sdk_default.a.error(function (res) {
                console.log(res);
                // alert(res.errMsg);
            });
        },
        delDevice: function delDevice(id) {
            var _this5 = this;

            this.$func.confirm('确认删除？', '提示', function () {
                _this5.$api.delDevice({ id: id }).then(function (res) {
                    if (res) {
                        _this5.resetSearch();
                    }
                });
            });
        },
        qrcodeDevice: function qrcodeDevice(id, type) {
            var _this6 = this;

            this.$func.startLoading('请求中。。。');
            this.$api.qrcodeDevice({ id: id, type: type }).then(function (res) {
                if (res) {
                    _this6.$func.endLoading();
                    _this6.qrcode = res.data.qrcode;
                    _this6.qrcodeTitle = type ? '取衣码' : '开锁码';
                    _this6.qrcodeShow = true;
                }
            });
        },
        toggleMore: function toggleMore(index) {
            if (this.showMoreIndex == index) {
                this.showMoreIndex = -1;
            } else {
                this.showMoreIndex = index;
            }
        },
        config: function config() {
            var url = window.location.href.split('#');
            if (url[0].indexOf('?') != '-1') {
                url = url[0].split('?');
            }
            this.$api.wxSign({ url: url[0] }).then(function (res) {
                if (res) {
                    weixin_js_sdk_default.a.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"]
                    });
                }
            });
        },
        loadmore: function loadmore() {
            var _this7 = this;

            if (this.lastId > 0 && !this.hasNext) {
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。';
                return;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(function () {
                if (_this7.blankShow) {
                    _this7.busy = true;
                    _this7.loadStatus = false;
                    _this7.loadmoreText = '没有更多了。。。';
                } else {
                    if (_this7.hasNext > 0) {
                        _this7.loadStatus = false;
                        _this7.busy = false;
                    } else {
                        _this7.busy = true;
                        _this7.loadStatus = true;
                        _this7.loadmoreText = '没有更多了。。。';
                    }
                }
            }, 1500);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fba59de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device.vue
var device_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main",class:[_vm.popUp ? 'noscroll' : '' ],on:{"click":function($event){_vm.showMoreIndex = -1}}},[_c('div',{staticClass:"list-bg "},[(_vm.blankShow)?_c('cmBlank'):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"cm-m-t-8 shadow-gray cm-m-lr-8 cm-p-lr-12 cm-bg-white cm-p-tb-12"},[_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-4"},[_c('p',{},[_vm._v(_vm._s(index+1)+"、 "+_vm._s(item.title)+" ")]),_vm._v(" "),_c('p',{},[_vm._v("设备状态："),(item.status > 0)?_c('span',{staticClass:"cm-color-green"},[_vm._v("已开启")]):_c('span',{staticClass:"cm-color-orange"},[_vm._v("已关闭")])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-4"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle "},[_c('img',{staticClass:"cm-m-r-4",attrs:{"src":item.type_img,"alt":"","width":"24","height":"24"}}),_vm._v(_vm._s(item.type_text)),(item.device_type_text)?_c('span',[_vm._v("（"+_vm._s(item.device_type_text)+"）")]):_vm._e()]),_vm._v(" "),_c('p',{},[_vm._v("序列号："),_c('span',{staticClass:" cm-fn-weight-default"},[_vm._v(_vm._s(item.code))])])]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-4"},[_c('p',{},[_vm._v(_vm._s(item.create_time)+" ")]),_vm._v(" "),(item.status > 0)?_c('p',{},[_vm._v("在线状态："),(item.on_line > 0)?_c('span',{staticClass:"cm-color-green"},[_vm._v("在线")]):_c('span',{staticClass:"cm-color-orange"},[_vm._v("离线")])]):_c('p',{},[_vm._v("在线状态："),_c('span',{staticClass:"cm-color-orange"},[_vm._v("已停用")])])]),_vm._v(" "),(item.status > 0)?_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-p-tb-4"},[(item.type == 3)?_c('p',{},[_vm._v("上电状态："),(item.state > 0)?_c('span',{staticClass:"cm-color-green"},[_vm._v("已上电")]):_c('span',{staticClass:"cm-color-orange"},[_vm._v("未上电")])]):_vm._e(),_vm._v(" "),(item.type == 4)?_c('p',{},[_vm._v("空调状态："),(item.state > 0)?_c('span',{staticClass:"cm-color-green"},[_vm._v("已开机")]):_c('span',{staticClass:"cm-color-orange"},[_vm._v("已关机")])]):_vm._e(),_vm._v(" "),(item.type == 2)?_c('p',{},[_vm._v("位置："),(item.location > 0)?_c('span',{staticClass:"cm-color-333"},[_vm._v("店内")]):_c('span',{staticClass:"cm-color-333"},[_vm._v("店外")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-flex-end cm-flex-middle cm-m-t-8 cm-pr"},[(item.status > 0)?_c('div',{staticClass:"cm-border cm-bg-blue cm-m-r-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.add(item.id)}}},[_vm._v("\n                        编辑\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0)?_c('div',{staticClass:"cm-border cm-bg-blue cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.setting(item.id)}}},[_vm._v("\n                        设置\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0 && item.type == 1)?_c('div',{staticClass:"cm-border cm-bg-green cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.operate(index);}}},[_vm._v("\n                          开锁\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0 && item.type == 3 && item.state > 0)?_c('div',{staticClass:"cm-border cm-bg-orange cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){_vm.operate(index,0);_vm.showMoreIndex = -1}}},[_vm._v("\n                          断电\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0 && item.type == 3 && item.state <= 0)?_c('div',{staticClass:"cm-border cm-bg-green cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){_vm.operate(index,1);_vm.showMoreIndex = -1}}},[_vm._v("\n                          上电\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0 && item.type == 4 && item.state > 0)?_c('div',{staticClass:"cm-border cm-bg-orange cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){_vm.operate(index,0);_vm.showMoreIndex = -1}}},[_vm._v("\n                          关机\n                      ")]):_vm._e(),_vm._v(" "),(item.status > 0 && item.type == 4 && item.state <= 0)?_c('div',{staticClass:"cm-border cm-bg-green cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){_vm.operate(index,1);_vm.showMoreIndex = -1}}},[_vm._v("\n                          开机\n                      ")]):_vm._e(),_vm._v(" "),(item.status <= 0)?_c('div',{staticClass:"cm-border cm-bg-green cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){return _vm.changeStatus(index,1)}}},[_vm._v("\n                          开启设备\n                      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-border cm-bg-blue cm-m-l-12 cm-color-white cm-p-lr-12 cm-p-tb-4 cm-border-radius-5 cm-center",on:{"click":function($event){$event.stopPropagation();return _vm.toggleMore(index)}}},[_vm._v("\n                        更多\n                      ")]),_vm._v(" "),(_vm.showMoreIndex == index)?_c('div',{staticClass:"more-menu cm-bg-white cm-border-radius-8 cm-p-tb-4"},[(item.type == 1)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.qrcodeDevice(item.id,0);_vm.showMoreIndex = -1}}},[_vm._v("\n                              生成开锁码\n                          ")]):_vm._e(),_vm._v(" "),(item.type == 1)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.qrcodeDevice(item.id,1);_vm.showMoreIndex = -1}}},[_vm._v("\n                              生成取衣码\n                          ")]):_vm._e(),_vm._v(" "),(item.type == 2)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.operate(index);_vm.showMoreIndex = -1}}},[_vm._v("\n                              播报语音\n                          ")]):_vm._e(),_vm._v(" "),(item.type == 4)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.airPair(item.id);_vm.showMoreIndex = -1}}},[_vm._v("\n                              空调配对\n                          ")]):_vm._e(),_vm._v(" "),(item.type == 5)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.lightUp(index,0);_vm.showMoreIndex = -1}}},[_vm._v("\n                              点亮测试\n                          ")]):_vm._e(),_vm._v(" "),(item.type == 5)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.lightUp(index,1);_vm.showMoreIndex = -1}}},[_vm._v("\n                              批量点亮\n                          ")]):_vm._e(),_vm._v(" "),(item.status > 0)?_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.changeStatus(index,0);_vm.showMoreIndex = -1}}},[_vm._v("\n                              关闭设备\n                          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-item cm-p-lr-16 cm-p-tb-12 cm-border-bottom-1",on:{"click":function($event){_vm.delDevice(item.id);_vm.showMoreIndex = -1}}},[_vm._v("\n                              删除\n                          ")])]):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"add-device-btn cm-bg-green cm-color-white cm-center",on:{"click":function($event){return _vm.add()}}},[_vm._m(0)]),_vm._v(" "),(_vm.qrcodeShow)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"cm-fn-16 cm-color-333 cm-text-center"},[_vm._v(_vm._s(_vm.qrcodeTitle))]),_vm._v(" "),_c('span',{staticClass:"modal-close",on:{"click":function($event){_vm.qrcodeShow = false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.qrcode)?_c('div',{staticClass:"modal-image"},[_c('img',{attrs:{"src":_vm.qrcode,"alt":""}})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-m-t-8 cm-color-666 cm-center"},[_vm._v("长按识别小程序码")])])])])]):_vm._e(),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"pop",on:{"click":function($event){_vm.popUp = false}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popUp),expression:"popUp"}],staticClass:"popup cm-center cm-bg-white cm-border-radius-10 cm-p-tb-24"},[_c('div',{staticClass:"cm-flex-column cm-flex-middle cm-m-t-12  cm-m-lr-12"},[(_vm.lightType > 0)?_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16 "},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("点亮灯条数量：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-12 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],staticClass:"cm-fn-14 ",attrs:{"type":"number","placeholder":"最多30个"},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})])]):_c('div',{staticClass:"cm-flex-start cm-flex-middle  cm-m-t-16 "},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("灯条编码：")]),_vm._v(" "),_c('div',{staticClass:"cm-border cm-p-tb-12 cm-p-lr-8  cm-flex-between cm-flex-middle cm-border-radius-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strip_code),expression:"strip_code"}],staticClass:"cm-fn-14 ",attrs:{"type":"text","placeholder":"请输入灯条编码"},domProps:{"value":(_vm.strip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.strip_code=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}})])]),_vm._v(" "),_c('button',{staticClass:" cm-bg-red cm-p-tb-16 cm-color-white cm-border-radius-8 cm-m-t-24",staticStyle:{"width":"90%"},attrs:{"lang":"zh_CN"},on:{"click":function($event){return _vm.submitLight()}}},[_vm._v("提交")])])])])}
var device_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("添加"),_c('br'),_vm._v("设备")])}]
var device_esExports = { render: device_render, staticRenderFns: device_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_device = (device_esExports);
// CONCATENATED MODULE: ./src/pages/device.vue
function device_injectStyle (ssrContext) {
  __webpack_require__("Uz3O")
}
var device_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var device___vue_template_functional__ = false
/* styles */
var device___vue_styles__ = device_injectStyle
/* scopeId */
var device___vue_scopeId__ = "data-v-4fba59de"
/* moduleIdentifier (server only) */
var device___vue_module_identifier__ = null
var device_Component = device_normalizeComponent(
  pages_device,
  selectortype_template_index_0_src_pages_device,
  device___vue_template_functional__,
  device___vue_styles__,
  device___vue_scopeId__,
  device___vue_module_identifier__
)

/* harmony default export */ var src_pages_device = (device_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/deviceEdit.vue








/* harmony default export */ var deviceEdit = ({
  name: 'deviceEdit',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      types: [],
      type: 1,
      deviceType: 1,
      speakerTypes: [{ key: 1, value: '一代' }, { key: 2, value: '二代' }],
      lightStationTypes: [{ key: 1, value: '公网基站' }, { key: 2, value: '局域网基站' }],
      locations: [{
        key: 0,
        value: '店外（开锁成功播报）'
      }, {
        key: 1,
        value: '店内（进店后播报）'
      }],
      location: 1,
      formData: {
        id: 0,
        code: '',
        title: '',
        content: '',
        type: 1,
        device_type: 1,
        location: 1
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getDeviceInfo();
    }
    this.config();
    this.loadDeviceTypes();
  },

  computed: {},
  methods: {
    loadDeviceTypes: function loadDeviceTypes() {
      var _this = this;

      this.$api.deviceType({}).then(function (res) {
        if (res) {
          _this.types = res.data.device_type;
          _this.types.forEach(function (item) {
            item.icon = item.img;
            item.key = item.type;
            item.value = item.title;
          });
          console.log(_this.types);
        }
      });
    },
    changeType: function changeType(val) {
      this.formData.type = val;
      if (val == 2 || val == 5) {
        this.formData.device_type = this.formData.device_type || 1;
        this.deviceType = this.formData.device_type;
      } else {
        this.formData.device_type = 1;
        this.deviceType = 1;
      }
    },
    changeDeviceType: function changeDeviceType(val) {
      this.formData.device_type = val;
    },
    changeLocation: function changeLocation(val) {
      this.formData.location = val;
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this2 = this;

      this.$api.getDeviceInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = res.data;
          _this2.type = res.data.type;
          _this2.deviceType = res.data.device_type || 1;
          _this2.location = res.data.location;
          console.log('formData', _this2.formData);
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.code) {
        this.$func.showToast('请输入设备序列号');
        return false;
      }
      if (!this.formData.title) {
        this.$func.showToast('请输入设备名称');
        return false;
      }
      this.$api.bindDevice(this.formData).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 300);
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode', 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              var result = res.resultStr;
              if (result.indexOf(",") != -1) {
                result = result.split(',')[1];
              } else {
                if (result.indexOf('http') != -1 || result.indexOf('/') != -1) {
                  var parts = result.split('/').filter(function (item) {
                    return item !== "";
                  });
                  result = parts[parts.length - 1] || result;
                }
              }
              that.formData.code = result;
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/deviceEdit.vue








/* harmony default export */ var pages_deviceEdit = ({
  name: 'deviceEdit',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      types: [],
      type: 1,
      deviceType: 1,
      speakerTypes: [{ key: 1, value: '一代' }, { key: 2, value: '二代' }],
      lightStationTypes: [{ key: 1, value: '公网基站' }, { key: 2, value: '局域网基站' }],
      locations: [{
        key: 0,
        value: '店外（开锁成功播报）'
      }, {
        key: 1,
        value: '店内（进店后播报）'
      }],
      location: 1,
      formData: {
        id: 0,
        code: '',
        title: '',
        content: '',
        type: 1,
        device_type: 1,
        location: 1
      }
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    if (this.formData.id > 0) {
      this.getDeviceInfo();
    }
    this.config();
    this.loadDeviceTypes();
  },

  computed: {},
  methods: {
    loadDeviceTypes: function loadDeviceTypes() {
      var _this = this;

      this.$api.deviceType({}).then(function (res) {
        if (res) {
          _this.types = res.data.device_type;
          _this.types.forEach(function (item) {
            item.icon = item.img;
            item.key = item.type;
            item.value = item.title;
          });
          console.log(_this.types);
        }
      });
    },
    changeType: function changeType(val) {
      this.formData.type = val;
      if (val == 2 || val == 5) {
        this.formData.device_type = this.formData.device_type || 1;
        this.deviceType = this.formData.device_type;
      } else {
        this.formData.device_type = 1;
        this.deviceType = 1;
      }
    },
    changeDeviceType: function changeDeviceType(val) {
      this.formData.device_type = val;
    },
    changeLocation: function changeLocation(val) {
      this.formData.location = val;
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this2 = this;

      this.$api.getDeviceInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = res.data;
          _this2.type = res.data.type;
          _this2.deviceType = res.data.device_type || 1;
          _this2.location = res.data.location;
          console.log('formData', _this2.formData);
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.formData.code) {
        this.$func.showToast('请输入设备序列号');
        return false;
      }
      if (!this.formData.title) {
        this.$func.showToast('请输入设备名称');
        return false;
      }
      this.$api.bindDevice(this.formData).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 300);
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode', 'barCode'],
          success: function success(res) {
            setTimeout(function () {
              var result = res.resultStr;
              if (result.indexOf(",") != -1) {
                result = result.split(',')[1];
              } else {
                if (result.indexOf('http') != -1 || result.indexOf('/') != -1) {
                  var parts = result.split('/').filter(function (item) {
                    return item !== "";
                  });
                  result = parts[parts.length - 1] || result;
                }
              }
              that.formData.code = result;
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d952a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/deviceEdit.vue
var deviceEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-12"},[_c('div',{staticClass:"cm-p-tb-12 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("序列号")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.code),expression:"formData.code"}],staticClass:"cm-m-t-8 cm-p-lr-12 cm-fn-16 cm-w-100 cm-border-radius-2 ",class:_vm.formData.id > 0 ? 'cm-bg-gray cm-h-100' : '',staticStyle:{"height":"30px"},attrs:{"type":"text","placeholder":"请输入或扫码序列号","disabled":_vm.formData.id > 0 ? true : false},domProps:{"value":(_vm.formData.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "code", $event.target.value)}}}),_vm._v(" "),(!_vm.formData.id)?_c('img',{staticClass:"cm-icon-30 cm-m-l-8",attrs:{"src":_vm.$customerAsset('scanIcon', '/static/images/scanCode.png')},on:{"click":function($event){return _vm.scanQRCode()}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 border-b"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("设备名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.title),expression:"formData.title"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"请输入产品名称"},domProps:{"value":(_vm.formData.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("设备类型")]),_vm._v(" "),_c('group',[_c('radio',{attrs:{"title":"title","options":_vm.types},on:{"on-change":_vm.changeType},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)],1),_vm._v(" "),(_vm.formData.type == 2)?_c('div',{staticClass:"cm-p-tb-8 border-t"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("云喇叭类型")]),_vm._v(" "),_c('group',[_c('radio',{attrs:{"title":"title","options":_vm.speakerTypes},on:{"on-change":_vm.changeDeviceType},model:{value:(_vm.deviceType),callback:function ($$v) {_vm.deviceType=$$v},expression:"deviceType"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.formData.type == 5)?_c('div',{staticClass:"cm-p-tb-8 border-t"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("灯条基站类型")]),_vm._v(" "),_c('group',[_c('radio',{attrs:{"title":"title","options":_vm.lightStationTypes},on:{"on-change":_vm.changeDeviceType},model:{value:(_vm.deviceType),callback:function ($$v) {_vm.deviceType=$$v},expression:"deviceType"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var deviceEdit_staticRenderFns = []
var deviceEdit_esExports = { render: deviceEdit_render, staticRenderFns: deviceEdit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_deviceEdit = (deviceEdit_esExports);
// CONCATENATED MODULE: ./src/pages/deviceEdit.vue
function deviceEdit_injectStyle (ssrContext) {
  __webpack_require__("naWJ")
}
var deviceEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var deviceEdit___vue_template_functional__ = false
/* styles */
var deviceEdit___vue_styles__ = deviceEdit_injectStyle
/* scopeId */
var deviceEdit___vue_scopeId__ = "data-v-97d952a4"
/* moduleIdentifier (server only) */
var deviceEdit___vue_module_identifier__ = null
var deviceEdit_Component = deviceEdit_normalizeComponent(
  pages_deviceEdit,
  selectortype_template_index_0_src_pages_deviceEdit,
  deviceEdit___vue_template_functional__,
  deviceEdit___vue_styles__,
  deviceEdit___vue_scopeId__,
  deviceEdit___vue_module_identifier__
)

/* harmony default export */ var src_pages_deviceEdit = (deviceEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7829af00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("WZDK")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/deviceSetting.vue











/* harmony default export */ var pages_deviceSetting = ({
  name: 'deviceEdit',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      stringValue: '',
      stingTitle: '',
      locations: [{
        key: 0,
        value: '店外（开锁成功播报）'
      }, {
        key: 1,
        value: '店内（进店后播报）'
      }],
      location: 1,
      formData: {
        id: 0,
        volume: 26,
        num: 1,
        location: 1,
        content: '',
        open_state: 0,
        upload_state: 0,
        open_minute: 0,
        open_start_time: '',
        open_end_time: '',
        open_week: 127
      },
      datetimeStatus: false,
      datetimeStatus1: false,
      airTemperatureLoading: false,
      weekOptions: [{ value: 1, text: '周日' }, { value: 2, text: '周一' }, { value: 4, text: '周二' }, { value: 8, text: '周三' }, { value: 16, text: '周四' }, { value: 32, text: '周五' }, { value: 64, text: '周六' }],
      colors: [{ id: 1, name: '红', color: '#FE5448' }, { id: 2, name: '黄', color: '#FFCD35' }, { id: 3, name: '蓝', color: '#326FFA' }, { id: 4, name: '绿', color: '#2ECC71' }, { id: 5, name: '青', color: '#00FFFF' }, { id: 6, name: '白', color: '#FFFFFF' }, { id: 7, name: '紫', color: '#9B59B6' }]
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.getDeviceInfo();
    this.config();
  },

  computed: {
    speakerVolumeMin: function speakerVolumeMin() {
      return 1;
    },
    speakerVolumeMax: function speakerVolumeMax() {
      return this.formData.device_type == 2 ? 100 : 9;
    },
    speakerVolumeRange: function speakerVolumeRange() {
      return this.speakerVolumeMin + '~' + this.speakerVolumeMax;
    },
    speakerVolumeTip: function speakerVolumeTip() {
      return this.formData.device_type == 2 ? '新版云喇叭请输入1~100，默认80' : '旧版云喇叭请输入1~9，默认5';
    },
    lightColors: function lightColors() {
      if (this.formData.device_type == 2) {
        return [{ id: 1, name: '蓝', color: '#326FFA' }, { id: 2, name: '绿', color: '#2ECC71' }, { id: 3, name: '青', color: '#00FFFF' }, { id: 4, name: '红', color: '#FE5448' }, { id: 5, name: '紫', color: '#9B59B6' }, { id: 6, name: '黄', color: '#FFCD35' }, { id: 7, name: '白', color: '#FFFFFF' }];
      }
      return this.colors;
    }
  },
  methods: {
    changeOpenState: function changeOpenState(val) {
      console.log(val);
      this.stingTitle = val > 0 ? '打开' : '关闭';
    },
    isWeekSelected: function isWeekSelected(value) {
      return (parseInt(this.formData.open_week) & value) > 0;
    },
    toggleOpenWeek: function toggleOpenWeek(value) {
      var week = parseInt(this.formData.open_week) || 0;
      if ((week & value) > 0) {
        week = week & ~value;
      } else {
        week = week | value;
      }
      week = week & 127;
      if (week <= 0) {
        this.$func.showToast('至少选择一天');
        return false;
      }
      this.formData.open_week = week;
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.open_start_time = this.normalizeClockTime(val);
    },
    datetimeChange1: function datetimeChange1(val) {
      this.formData.open_end_time = this.normalizeClockTime(val);
    },
    changeLocation: function changeLocation(val) {
      this.formData.location = val;
      if (this.formData.type == 2) {
        this.formData.open_minute = parseInt(val) == 1 ? 3 : 0;
      }
    },
    changeAirTemperature: function changeAirTemperature(step) {
      var value = parseInt(this.formData.volume) || 26;
      value += step;
      if (value < 16) {
        value = 16;
      }
      if (value > 31) {
        value = 31;
      }
      this.formData.volume = value;
      this.syncAirTemperature();
    },
    syncAirTemperature: function syncAirTemperature() {
      var _this = this;

      if (this.formData.type != 4 || this.airTemperatureLoading) {
        return false;
      }
      var volume = parseInt(this.formData.volume) || 26;
      if (volume < 16) {
        volume = 16;
      }
      if (volume > 31) {
        volume = 31;
      }
      this.formData.volume = volume;
      this.airTemperatureLoading = true;
      this.$api.airSetTemperature({
        id: this.formData.id,
        temperature: volume
      }).then(function (res) {
        if (res && res.code == 0) {
          _this.formData.state = 1;
          _this.$func.showToast('空调已开启，温度' + volume + '℃');
        }
        _this.airTemperatureLoading = false;
      }).catch(function () {
        _this.airTemperatureLoading = false;
      });
    },
    goAirPair: function goAirPair() {
      this.$router.push({ name: 'airPair', params: { id: this.formData.id } });
    },
    normalizeClockTime: function normalizeClockTime(value) {
      if (value === undefined || value === null) {
        return '';
      }
      value = String(value).trim();
      if (!value || value == '开始时间' || value == '结束时间') {
        return '';
      }
      var match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
      if (!match) {
        return '';
      }
      var hour = parseInt(match[1]);
      var minute = parseInt(match[2]);
      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return '';
      }
      return (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
    },
    normalizeAirSetting: function normalizeAirSetting() {
      var volume = parseInt(this.formData.volume);
      if (!volume) {
        volume = 26;
      }
      if (volume < 16) {
        volume = 16;
      }
      if (volume > 31) {
        volume = 31;
      }
      this.formData.volume = volume;
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
    },
    normalizeLockSetting: function normalizeLockSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
    },
    normalizeSwitchSetting: function normalizeSwitchSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
      var week = parseInt(this.formData.open_week);
      if (!week || week < 1 || week > 127) {
        week = 127;
      }
      this.formData.open_week = week & 127;
    },
    normalizeSpeakerSetting: function normalizeSpeakerSetting(data) {
      this.formData.location = parseInt(this.formData.location) || 0;
      var hasDelay = data && data.open_minute !== undefined && data.open_minute !== null && data.open_minute !== '';
      if (hasDelay) {
        this.formData.open_minute = parseInt(data.open_minute) || 0;
      } else {
        this.formData.open_minute = this.formData.location == 1 ? 3 : 0;
      }
    },
    normalizeLightSetting: function normalizeLightSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.upload_state = parseInt(this.formData.upload_state) > 0 ? '1' : '0';
      this.formData.volume = parseInt(this.formData.volume) || 1;
      this.formData.open_minute = parseInt(this.formData.open_minute) || 30;
      this.formData.num = parseInt(this.formData.num) || 1;
      if (this.formData.num < 1) {
        this.formData.num = 1;
      }
      if (this.formData.num > 9) {
        this.formData.num = 9;
      }
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this2 = this;

      this.$api.getDeviceInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = assign_default()({}, _this2.formData, res.data);
          _this2.location = res.data.location;
          if (_this2.formData.type == 1) {
            _this2.normalizeLockSetting();
          }
          if (_this2.formData.type == 2) {
            _this2.normalizeSpeakerSetting(res.data);
          }
          if (_this2.formData.type == 3) {
            _this2.normalizeSwitchSetting();
          }
          if (_this2.formData.type == 4) {
            _this2.normalizeAirSetting();
          }
          if (_this2.formData.type == 5) {
            _this2.normalizeLightSetting();
          }
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (this.formData.type == 1) {
        this.normalizeLockSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择每日闭店时间');
          return false;
        }
      }
      if (this.formData.type == 2) {
        var openMinute = parseInt(this.formData.open_minute);
        if (isNaN(openMinute)) {
          openMinute = parseInt(this.formData.location) == 1 ? 3 : 0;
        }
        if (openMinute < 0) {
          openMinute = 0;
        }
        if (openMinute > 300) {
          openMinute = 300;
        }
        this.formData.open_minute = openMinute;
      }
      if (this.formData.type == 3) {
        this.normalizeSwitchSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择每日常亮时间');
          return false;
        }
        if (this.formData.open_state > 0 && !this.formData.open_week) {
          this.$func.showToast('请选择常亮星期');
          return false;
        }
      }
      if (this.formData.type == 4) {
        this.normalizeAirSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择自动开启和关闭时间');
          return false;
        }
      }
      if (this.formData.type == 5) {
        this.normalizeLightSetting();
      }
      this.$api.deviceSetting(this.formData).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 300);
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode'],
          success: function success(res) {
            setTimeout(function () {
              if (res.resultStr.indexOf(",") != -1) {
                that.formData.code = res.resultStr.split(',')[1];
              } else {
                that.formData.code = res.resultStr;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/deviceSetting.vue











/* harmony default export */ var selectortype_script_index_0_src_pages_deviceSetting = ({
  name: 'deviceEdit',
  components: {
    wx: weixin_js_sdk_default.a, PopupPicker: vux_src_components_popup_picker, CheckIcon: vux_src_components_check_icon, XTextarea: vux_src_components_x_textarea, Group: vux_src_components_group, Radio: node_modules_vux_src_components_radio, Datetime: vux_src_components_datetime, XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      stringValue: '',
      stingTitle: '',
      locations: [{
        key: 0,
        value: '店外（开锁成功播报）'
      }, {
        key: 1,
        value: '店内（进店后播报）'
      }],
      location: 1,
      formData: {
        id: 0,
        volume: 26,
        num: 1,
        location: 1,
        content: '',
        open_state: 0,
        upload_state: 0,
        open_minute: 0,
        open_start_time: '',
        open_end_time: '',
        open_week: 127
      },
      datetimeStatus: false,
      datetimeStatus1: false,
      airTemperatureLoading: false,
      weekOptions: [{ value: 1, text: '周日' }, { value: 2, text: '周一' }, { value: 4, text: '周二' }, { value: 8, text: '周三' }, { value: 16, text: '周四' }, { value: 32, text: '周五' }, { value: 64, text: '周六' }],
      colors: [{ id: 1, name: '红', color: '#FE5448' }, { id: 2, name: '黄', color: '#FFCD35' }, { id: 3, name: '蓝', color: '#326FFA' }, { id: 4, name: '绿', color: '#2ECC71' }, { id: 5, name: '青', color: '#00FFFF' }, { id: 6, name: '白', color: '#FFFFFF' }, { id: 7, name: '紫', color: '#9B59B6' }]
    };
  },
  created: function created() {
    this.formData.id = Number(this.$route.params.id);
    this.getDeviceInfo();
    this.config();
  },

  computed: {
    speakerVolumeMin: function speakerVolumeMin() {
      return 1;
    },
    speakerVolumeMax: function speakerVolumeMax() {
      return this.formData.device_type == 2 ? 100 : 9;
    },
    speakerVolumeRange: function speakerVolumeRange() {
      return this.speakerVolumeMin + '~' + this.speakerVolumeMax;
    },
    speakerVolumeTip: function speakerVolumeTip() {
      return this.formData.device_type == 2 ? '新版云喇叭请输入1~100，默认80' : '旧版云喇叭请输入1~9，默认5';
    },
    lightColors: function lightColors() {
      if (this.formData.device_type == 2) {
        return [{ id: 1, name: '蓝', color: '#326FFA' }, { id: 2, name: '绿', color: '#2ECC71' }, { id: 3, name: '青', color: '#00FFFF' }, { id: 4, name: '红', color: '#FE5448' }, { id: 5, name: '紫', color: '#9B59B6' }, { id: 6, name: '黄', color: '#FFCD35' }, { id: 7, name: '白', color: '#FFFFFF' }];
      }
      return this.colors;
    }
  },
  methods: {
    changeOpenState: function changeOpenState(val) {
      console.log(val);
      this.stingTitle = val > 0 ? '打开' : '关闭';
    },
    isWeekSelected: function isWeekSelected(value) {
      return (parseInt(this.formData.open_week) & value) > 0;
    },
    toggleOpenWeek: function toggleOpenWeek(value) {
      var week = parseInt(this.formData.open_week) || 0;
      if ((week & value) > 0) {
        week = week & ~value;
      } else {
        week = week | value;
      }
      week = week & 127;
      if (week <= 0) {
        this.$func.showToast('至少选择一天');
        return false;
      }
      this.formData.open_week = week;
    },
    datetimeChange: function datetimeChange(val) {
      this.formData.open_start_time = this.normalizeClockTime(val);
    },
    datetimeChange1: function datetimeChange1(val) {
      this.formData.open_end_time = this.normalizeClockTime(val);
    },
    changeLocation: function changeLocation(val) {
      this.formData.location = val;
      if (this.formData.type == 2) {
        this.formData.open_minute = parseInt(val) == 1 ? 3 : 0;
      }
    },
    changeAirTemperature: function changeAirTemperature(step) {
      var value = parseInt(this.formData.volume) || 26;
      value += step;
      if (value < 16) {
        value = 16;
      }
      if (value > 31) {
        value = 31;
      }
      this.formData.volume = value;
      this.syncAirTemperature();
    },
    syncAirTemperature: function syncAirTemperature() {
      var _this = this;

      if (this.formData.type != 4 || this.airTemperatureLoading) {
        return false;
      }
      var volume = parseInt(this.formData.volume) || 26;
      if (volume < 16) {
        volume = 16;
      }
      if (volume > 31) {
        volume = 31;
      }
      this.formData.volume = volume;
      this.airTemperatureLoading = true;
      this.$api.airSetTemperature({
        id: this.formData.id,
        temperature: volume
      }).then(function (res) {
        if (res && res.code == 0) {
          _this.formData.state = 1;
          _this.$func.showToast('空调已开启，温度' + volume + '℃');
        }
        _this.airTemperatureLoading = false;
      }).catch(function () {
        _this.airTemperatureLoading = false;
      });
    },
    goAirPair: function goAirPair() {
      this.$router.push({ name: 'airPair', params: { id: this.formData.id } });
    },
    normalizeClockTime: function normalizeClockTime(value) {
      if (value === undefined || value === null) {
        return '';
      }
      value = String(value).trim();
      if (!value || value == '开始时间' || value == '结束时间') {
        return '';
      }
      var match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
      if (!match) {
        return '';
      }
      var hour = parseInt(match[1]);
      var minute = parseInt(match[2]);
      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return '';
      }
      return (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
    },
    normalizeAirSetting: function normalizeAirSetting() {
      var volume = parseInt(this.formData.volume);
      if (!volume) {
        volume = 26;
      }
      if (volume < 16) {
        volume = 16;
      }
      if (volume > 31) {
        volume = 31;
      }
      this.formData.volume = volume;
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
    },
    normalizeLockSetting: function normalizeLockSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
    },
    normalizeSwitchSetting: function normalizeSwitchSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
      this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
      var week = parseInt(this.formData.open_week);
      if (!week || week < 1 || week > 127) {
        week = 127;
      }
      this.formData.open_week = week & 127;
    },
    normalizeSpeakerSetting: function normalizeSpeakerSetting(data) {
      this.formData.location = parseInt(this.formData.location) || 0;
      var hasDelay = data && data.open_minute !== undefined && data.open_minute !== null && data.open_minute !== '';
      if (hasDelay) {
        this.formData.open_minute = parseInt(data.open_minute) || 0;
      } else {
        this.formData.open_minute = this.formData.location == 1 ? 3 : 0;
      }
    },
    normalizeLightSetting: function normalizeLightSetting() {
      this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
      this.formData.upload_state = parseInt(this.formData.upload_state) > 0 ? '1' : '0';
      this.formData.volume = parseInt(this.formData.volume) || 1;
      this.formData.open_minute = parseInt(this.formData.open_minute) || 30;
      this.formData.num = parseInt(this.formData.num) || 1;
      if (this.formData.num < 1) {
        this.formData.num = 1;
      }
      if (this.formData.num > 9) {
        this.formData.num = 9;
      }
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this2 = this;

      this.$api.getDeviceInfo({ id: this.formData.id }).then(function (res) {
        if (res) {
          _this2.formData = assign_default()({}, _this2.formData, res.data);
          _this2.location = res.data.location;
          if (_this2.formData.type == 1) {
            _this2.normalizeLockSetting();
          }
          if (_this2.formData.type == 2) {
            _this2.normalizeSpeakerSetting(res.data);
          }
          if (_this2.formData.type == 3) {
            _this2.normalizeSwitchSetting();
          }
          if (_this2.formData.type == 4) {
            _this2.normalizeAirSetting();
          }
          if (_this2.formData.type == 5) {
            _this2.normalizeLightSetting();
          }
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (this.formData.type == 1) {
        this.normalizeLockSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择每日闭店时间');
          return false;
        }
      }
      if (this.formData.type == 2) {
        var openMinute = parseInt(this.formData.open_minute);
        if (isNaN(openMinute)) {
          openMinute = parseInt(this.formData.location) == 1 ? 3 : 0;
        }
        if (openMinute < 0) {
          openMinute = 0;
        }
        if (openMinute > 300) {
          openMinute = 300;
        }
        this.formData.open_minute = openMinute;
      }
      if (this.formData.type == 3) {
        this.normalizeSwitchSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择每日常亮时间');
          return false;
        }
        if (this.formData.open_state > 0 && !this.formData.open_week) {
          this.$func.showToast('请选择常亮星期');
          return false;
        }
      }
      if (this.formData.type == 4) {
        this.normalizeAirSetting();
        if (this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)) {
          this.$func.showToast('请选择自动开启和关闭时间');
          return false;
        }
      }
      if (this.formData.type == 5) {
        this.normalizeLightSetting();
      }
      this.$api.deviceSetting(this.formData).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('提交成功');
          setTimeout(function () {
            _this3.$router.go(-1);
          }, 300);
        }
      });
    },
    scanQRCode: function scanQRCode() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1,
          scanType: ['qrCode'],
          success: function success(res) {
            setTimeout(function () {
              if (res.resultStr.indexOf(",") != -1) {
                that.formData.code = res.resultStr.split(',')[1];
              } else {
                that.formData.code = res.resultStr;
              }
            }, 300);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        console.log(res);
      });
    },
    config: function config() {
      var url = window.location.href.split('#');
      if (url[0].indexOf('?') != '-1') {
        url = url[0].split('?');
      }
      this.$api.wxSign({ url: url[0] }).then(function (res) {
        if (res) {
          weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["scanQRCode"]
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-990f9858","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/deviceSetting.vue
var deviceSetting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main"},[_c('div',{staticClass:"cm-bg-white cm-p-b-16 cm-p-lr-8"},[(_vm.formData.type == 1)?_c('div',[_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("延时上锁时间（秒）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.open_minute),expression:"formData.open_minute"}],staticClass:" cm-fn-16 cm-p-tb-4 cm-w-100",attrs:{"type":"number","min":"1","max":"300","placeholder":"请输入"},domProps:{"value":(_vm.formData.open_minute)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "open_minute", $event.target.value)}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 border-b shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("开锁距离（米）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.num),expression:"formData.num"}],staticClass:" cm-fn-16 cm-w-100 cm-p-tb-4",attrs:{"type":"number","min":"1","placeholder":"请输入"},domProps:{"value":(_vm.formData.num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "num", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("每日闭店状态")]),_vm._v(" "),_c('x-switch',{attrs:{"title":"","value-map":['0', '1']},on:{"on-change":_vm.changeOpenState},model:{value:(_vm.formData.open_state),callback:function ($$v) {_vm.$set(_vm.formData, "open_state", $$v)},expression:"formData.open_state"}})],1),_vm._v(" "),(_vm.formData.open_state > 0)?_c('div',{staticClass:"cm-p-tb-8 border-b shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("每日闭店时间")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8"},[_c('datetime',{staticClass:"cm-color-222  cm-bg-white  cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[(_vm.formData.open_start_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100  cm-center"},[_vm._v(_vm._s(_vm.formData.open_start_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16  cm-w-100  cm-center"},[_vm._v("开始时间")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16  cm-center",staticStyle:{"width":"50px"}},[_vm._v("至")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222  cm-bg-white cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus1},on:{"update:show":function($event){_vm.datetimeStatus1=$event},"on-change":_vm.datetimeChange1}},[(_vm.formData.open_end_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100  cm-center"},[_vm._v(_vm._s(_vm.formData.open_end_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16 cm-w-100  cm-center"},[_vm._v("结束时间")])])],1),_vm._v(" "),_vm._m(2)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.formData.type == 2)?_c('div',[_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("安装位置")]),_vm._v(" "),_c('group',[_c('radio',{attrs:{"title":"title","options":_vm.locations},on:{"on-change":_vm.changeLocation},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16 cm-p-t-12"},[_vm._v("播报内容")]),_vm._v(" "),_c('group',[_c('x-textarea',{staticClass:"cm-border cm-fn-16",attrs:{"max":150,"placeholder":"150字以内","height":120},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("播放音量（数字"+_vm._s(_vm.speakerVolumeRange)+"）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.volume),expression:"formData.volume"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":_vm.speakerVolumeMin,"max":_vm.speakerVolumeMax,"minlength":"1","maxlength":"3","placeholder":"请输入"},domProps:{"value":(_vm.formData.volume)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "volume", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v(_vm._s(_vm.speakerVolumeTip))])])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("循环播放次数")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.num),expression:"formData.num"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"1","minlength":"1","maxlength":"1","placeholder":"请输入"},domProps:{"value":(_vm.formData.num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "num", $event.target.value)}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("延时播放时间（秒）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.open_minute),expression:"formData.open_minute"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"0","max":"300","placeholder":"请输入"},domProps:{"value":(_vm.formData.open_minute)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "open_minute", $event.target.value)}}}),_vm._v(" "),_vm._m(4)])]):_vm._e(),_vm._v(" "),(_vm.formData.type == 3)?_c('div',[_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("单次上电时长（分钟）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.open_minute),expression:"formData.open_minute"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"1","placeholder":"请输入"},domProps:{"value":(_vm.formData.open_minute)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "open_minute", $event.target.value)}}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("每日常亮状态")]),_vm._v(" "),_c('x-switch',{attrs:{"title":"","value-map":['0', '1']},on:{"on-change":_vm.changeOpenState},model:{value:(_vm.formData.open_state),callback:function ($$v) {_vm.$set(_vm.formData, "open_state", $$v)},expression:"formData.open_state"}})],1),_vm._v(" "),(_vm.formData.open_state > 0)?_c('div',{staticClass:"cm-p-tb-8 border-b shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("每日常亮时间")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8"},[_c('datetime',{staticClass:"cm-color-222  cm-bg-white  cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[(_vm.formData.open_start_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100  cm-center"},[_vm._v(_vm._s(_vm.formData.open_start_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16  cm-w-100  cm-center"},[_vm._v("开始时间")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16  cm-center",staticStyle:{"width":"50px"}},[_vm._v("至")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222  cm-bg-white cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus1},on:{"update:show":function($event){_vm.datetimeStatus1=$event},"on-change":_vm.datetimeChange1}},[(_vm.formData.open_end_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100  cm-center"},[_vm._v(_vm._s(_vm.formData.open_end_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16 cm-w-100  cm-center"},[_vm._v("结束时间")])])],1),_vm._v(" "),_c('p',{staticClass:"cm-fn-16 cm-m-t-8"},[_vm._v("重复星期")]),_vm._v(" "),_c('div',{staticClass:"week-options cm-flex-start cm-flex-wrap cm-m-t-8"},_vm._l((_vm.weekOptions),function(item){return _c('div',{key:item.value,staticClass:"week-option cm-center cm-m-r-8 cm-m-b-8",class:{'active': _vm.isWeekSelected(item.value)},on:{"click":function($event){return _vm.toggleOpenWeek(item.value)}}},[_vm._v("\n                        "+_vm._s(item.text)+"\n                    ")])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.formData.type == 4)?_c('div',[_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8"},[_c('div',[_c('p',{staticClass:"cm-fn-16"},[_vm._v("空调配对")]),_vm._v(" "),(_vm.formData.air_brand)?_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("空调品牌："+_vm._s(_vm.formData.air_brand))]):_vm._e(),_vm._v(" "),(_vm.formData.content)?_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("当前型号码："+_vm._s(_vm.formData.content))]):_vm._e(),_vm._v(" "),(!_vm.formData.air_brand && !_vm.formData.content)?_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("选择品牌并按提示确认")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cm-bg-blue cm-color-white cm-p-lr-12 cm-p-tb-8 cm-border-radius-5",on:{"click":_vm.goAirPair}},[_vm._v("去配对")])]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("温度设置（℃）")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-between cm-flex-middle cm-m-t-8"},[_c('div',{staticClass:"temp-stepper cm-center",on:{"click":function($event){return _vm.changeAirTemperature(-1)}}},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"temp-value cm-fn-20 cm-center"},[_vm._v(_vm._s(_vm.formData.volume || 26))]),_vm._v(" "),_c('div',{staticClass:"temp-stepper cm-center",on:{"click":function($event){return _vm.changeAirTemperature(1)}}},[_vm._v("+")])]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("自动开启开关")]),_vm._v(" "),_c('x-switch',{attrs:{"title":"","value-map":['0', '1']},on:{"on-change":_vm.changeOpenState},model:{value:(_vm.formData.open_state),callback:function ($$v) {_vm.$set(_vm.formData, "open_state", $$v)},expression:"formData.open_state"}})],1),_vm._v(" "),(_vm.formData.open_state > 0)?_c('div',{staticClass:"cm-p-tb-8 border-b shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("自动开启和关闭时间")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-start cm-p-tb-8"},[_c('datetime',{staticClass:"cm-color-222 cm-bg-white cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus},on:{"update:show":function($event){_vm.datetimeStatus=$event},"on-change":_vm.datetimeChange}},[(_vm.formData.open_start_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100 cm-center"},[_vm._v(_vm._s(_vm.formData.open_start_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16 cm-w-100 cm-center"},[_vm._v("开始时间")])]),_vm._v(" "),_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-center",staticStyle:{"width":"50px"}},[_vm._v("至")]),_vm._v(" "),_c('datetime',{staticClass:"cm-color-222 cm-bg-white cm-center",staticStyle:{"width":"100px"},attrs:{"format":"HH:mm","show":_vm.datetimeStatus1},on:{"update:show":function($event){_vm.datetimeStatus1=$event},"on-change":_vm.datetimeChange1}},[(_vm.formData.open_end_time)?_c('p',{staticClass:"cm-color-222 cm-fn-16 cm-w-100 cm-center"},[_vm._v(_vm._s(_vm.formData.open_end_time))]):_c('p',{staticClass:"cm-color-666 cm-fn-16 cm-w-100 cm-center"},[_vm._v("结束时间")])])],1),_vm._v(" "),_vm._m(7)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.formData.type == 5)?_c('div',[_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("灯条亮灯时长（秒）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.open_minute),expression:"formData.open_minute"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"1","max":"300","placeholder":"请输入"},domProps:{"value":(_vm.formData.open_minute)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "open_minute", $event.target.value)}}}),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("亮灯次数")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.num),expression:"formData.num"}],staticClass:"cm-m-t-8 cm-fn-16 cm-w-100",attrs:{"type":"number","min":"1","max":"9","placeholder":"请输入"},domProps:{"value":(_vm.formData.num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "num", $event.target.value)}}}),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-p-lr-8 cm-m-t-4"},[_c('p',{staticClass:"cm-fn-16"},[_vm._v("亮灯颜色")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-start cm-flex-wrap cm-m-t-12"},_vm._l((_vm.lightColors),function(item){return _c('div',{key:item.id,staticClass:"color-box cm-center cm-m-r-8 cm-m-b-8 cm-pr",class:{'active': _vm.formData.volume == item.id},on:{"click":function($event){_vm.formData.volume = item.id}}},[_c('div',{staticClass:"color-dot",style:({backgroundColor: item.color})}),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-m-t-4"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(_vm.formData.volume == item.id)?_c('img',{staticClass:"selected-icon",attrs:{"src":"/static/images/checkbox-checked.png"}}):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-4"},[_vm._m(10),_vm._v(" "),_c('x-switch',{attrs:{"title":"","value-map":['0', '1']},on:{"on-change":_vm.changeOpenState},model:{value:(_vm.formData.open_state),callback:function ($$v) {_vm.$set(_vm.formData, "open_state", $$v)},expression:"formData.open_state"}})],1),_vm._v(" "),_c('div',{staticClass:"cm-p-tb-8 cm-border shadow-gray cm-flex-between cm-flex-middle cm-p-lr-8 cm-m-t-4"},[_vm._m(11),_vm._v(" "),_c('x-switch',{attrs:{"title":"","value-map":['0', '1']},model:{value:(_vm.formData.upload_state),callback:function ($$v) {_vm.$set(_vm.formData, "upload_state", $$v)},expression:"formData.upload_state"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cm-w-100 cm-center cm-m-t-40",staticStyle:{"height":"44px"}},[_c('div',{staticClass:"cm-bg-red cm-border-radius-8 cm-center",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticClass:"cm-fn-16 cm-fn-weight-default cm-color-white"},[_vm._v("提交")])])])])])}
var deviceSetting_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("开锁后延时上锁时间；默认3秒")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("开锁有效距离；0为不限制")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4 cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("闭店时间内顾客扫码不能开锁，可设置跨天时间，如21:00至09:00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("语音循环播放次数")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("开锁后延时播放；店内默认3秒，店外默认0秒，0为不延时")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("顾客扫码开门上电后每次上电时长（分钟）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4 cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("空调开启时使用该温度，范围16~31℃")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4 cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("时间格式与智能开关一致，如09:00至21:00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("请输入灯条亮灯时长（秒）;默认30秒")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-m-t-4  cm-flex-middle cm-flex-start"},[_c('img',{staticClass:"cm-icon-12",attrs:{"src":"/static/images/callout.png"}}),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-l-2"},[_vm._v("灯条每次触发亮灯次数；默认1次")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"cm-fn-16"},[_vm._v("循环颜色")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("关闭后使用上方固定颜色，打开后按颜色顺序循环亮灯")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"cm-fn-16"},[_vm._v("灯条上报")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-12 cm-color-666 cm-m-t-4"},[_vm._v("开启后按灯条上报判断点亮结果，10秒未上报时自动重发")])])}]
var deviceSetting_esExports = { render: deviceSetting_render, staticRenderFns: deviceSetting_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_deviceSetting = (deviceSetting_esExports);
// CONCATENATED MODULE: ./src/pages/deviceSetting.vue
function deviceSetting_injectStyle (ssrContext) {
  __webpack_require__("Ddy5")
}
var deviceSetting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var deviceSetting___vue_template_functional__ = false
/* styles */
var deviceSetting___vue_styles__ = deviceSetting_injectStyle
/* scopeId */
var deviceSetting___vue_scopeId__ = "data-v-990f9858"
/* moduleIdentifier (server only) */
var deviceSetting___vue_module_identifier__ = null
var deviceSetting_Component = deviceSetting_normalizeComponent(
  selectortype_script_index_0_src_pages_deviceSetting,
  selectortype_template_index_0_src_pages_deviceSetting,
  deviceSetting___vue_template_functional__,
  deviceSetting___vue_styles__,
  deviceSetting___vue_scopeId__,
  deviceSetting___vue_module_identifier__
)

/* harmony default export */ var src_pages_deviceSetting = (deviceSetting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/airPair.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var airPair = ({
  name: 'airPair',
  data: function data() {
    return {
      id: 0,
      keyword: '',
      brands: [],
      currentBrand: null,
      currentCode: '',
      activeLetter: '',
      step: 'brand',
      temperature: 25,
      currentPower: 1
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.loadBrands();
  },

  computed: {
    letters: function letters() {
      return this.groupedBrands.map(function (item) {
        return item.letter;
      });
    },
    groupedBrands: function groupedBrands() {
      var _this = this;

      var groups = {};
      this.brands.forEach(function (item) {
        var letter = _this.brandLetter(item);
        if (!groups[letter]) {
          groups[letter] = [];
        }
        groups[letter].push(item);
      });
      return keys_default()(groups).sort().map(function (letter) {
        return { letter: letter, items: groups[letter] };
      });
    },
    codes: function codes() {
      return this.currentBrand && this.currentBrand.codes ? this.currentBrand.codes : [];
    },
    currentIndex: function currentIndex() {
      return this.codes.indexOf(Number(this.currentCode));
    },
    remainingCount: function remainingCount() {
      if (this.currentIndex < 0) {
        return this.codes.length;
      }
      return Math.max(this.codes.length - this.currentIndex - 1, 0);
    },
    pairTitle: function pairTitle() {
      return this.currentBrand ? '转换器（' + this.currentBrand.name + '）' : '空调配对';
    }
  },
  methods: {
    loadBrands: function loadBrands() {
      var _this2 = this;

      this.$api.airConditionerModels({ keyword: this.keyword }).then(function (res) {
        if (res) {
          _this2.brands = res.data || [];
          _this2.activeLetter = _this2.groupedBrands.length ? _this2.groupedBrands[0].letter : '';
        }
      });
    },
    brandLetter: function brandLetter(item) {
      var letterMap = {
        '奥克斯': 'A',
        '澳柯玛': 'A',
        '宝立创': 'B',
        '春兰': 'C',
        '长虹': 'C',
        '创维': 'C',
        '东芝': 'D',
        '东宝': 'D',
        '大金': 'D',
        '富士通': 'F',
        '格力': 'G',
        '高路华': 'G',
        '格兰仕': 'G',
        '高美': 'G',
        '国美': 'G',
        '海尔': 'H',
        '海信': 'H',
        '华凌': 'H',
        '惠而浦': 'H',
        '海林': 'H',
        '海普': 'H',
        '华蒜': 'H',
        '和山': 'H',
        '科龙': 'K',
        '开利': 'K',
        '康佳': 'K',
        '酷风': 'K',
        '蓝波': 'L',
        '乐华': 'L',
        '乐京': 'L',
        '美的': 'M',
        '麦克维尔': 'M',
        '米家': 'M',
        '内田': 'N',
        '欧科': 'O',
        '日立': 'R',
        '三星': 'S',
        '三洋': 'S',
        '三菱重工': 'S',
        '三菱电机': 'S',
        '松下': 'S',
        '上凌': 'S',
        '三垦': 'S',
        '三菱': 'S',
        '上菱': 'S',
        '绅宝': 'S',
        '深松': 'S',
        '深宝': 'S',
        '三菱重工海尔': 'S',
        '山水': 'S',
        '苏宁极物': 'S',
        '天元': 'T',
        '泰阳': 'T',
        '汤姆森': 'T',
        '万宝': 'W',
        '新科': 'X',
        '熊猫': 'X',
        '夏普': 'X',
        '新迎燕': 'X',
        '夏洋': 'X',
        '西冷': 'X',
        '小米': 'X',
        '夏宝': 'X',
        '乐声': 'Y',
        '玉兔': 'Y',
        '扬子': 'Y',
        '伊莱克斯': 'Y',
        '约克': 'Y',
        '樱花': 'Y',
        '月兔': 'Y',
        '银燕': 'Y',
        '志高': 'Z',
        '镇堡': 'Z',
        '中广欧特斯': 'Z'
      };
      if (letterMap[item.name]) {
        return letterMap[item.name];
      }
      var en = (item.en || item.name || '').trim();
      var letter = en ? en.substr(0, 1).toUpperCase() : '#';
      return (/^[A-Z]$/.test(letter) ? letter : '#'
      );
    },
    scrollToLetter: function scrollToLetter(letter) {
      this.activeLetter = letter;
      var el = document.getElementById('brand-' + letter);
      if (el) {
        el.scrollIntoView();
      }
    },
    selectBrand: function selectBrand(item) {
      this.currentBrand = item;
      this.currentCode = item.codes && item.codes.length ? item.codes[0] : '';
      this.currentPower = 1;
      this.step = 'control';
    },
    sendPairCommand: function sendPairCommand(power) {
      var _this3 = this;

      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码');
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.airPairControl({
        id: this.id,
        ac_code: this.currentCode,
        power: power,
        temperature: this.temperature,
        mode: 0,
        fan: 1
      }).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('发送成功');
        }
        _this3.$func.endLoading();
      });
    },
    nextCode: function nextCode() {
      if (this.codes.length <= 0) {
        return false;
      }
      var index = this.currentIndex;
      if (index < 0) {
        this.currentCode = this.codes[0];
        return false;
      }
      if (index >= this.codes.length - 1) {
        this.$func.showToast('当前品牌已到最后一组');
        return false;
      }
      this.currentCode = this.codes[index + 1];
      this.currentPower = 1;
    },
    saveCode: function saveCode() {
      var _this4 = this;

      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码');
        return false;
      }
      if (this.currentPower) {
        this.currentPower = 0;
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.airSaveModelCode({
        id: this.id,
        ac_code: this.currentCode,
        brand: this.currentBrand ? this.currentBrand.name : ''
      }).then(function (res) {
        if (res.code == 0) {
          _this4.$func.showToast('保存成功');
          setTimeout(function () {
            _this4.$router.go(-1);
          }, 300);
        }
        _this4.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/airPair.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_airPair = ({
  name: 'airPair',
  data: function data() {
    return {
      id: 0,
      keyword: '',
      brands: [],
      currentBrand: null,
      currentCode: '',
      activeLetter: '',
      step: 'brand',
      temperature: 25,
      currentPower: 1
    };
  },
  created: function created() {
    this.id = Number(this.$route.params.id);
    this.loadBrands();
  },

  computed: {
    letters: function letters() {
      return this.groupedBrands.map(function (item) {
        return item.letter;
      });
    },
    groupedBrands: function groupedBrands() {
      var _this = this;

      var groups = {};
      this.brands.forEach(function (item) {
        var letter = _this.brandLetter(item);
        if (!groups[letter]) {
          groups[letter] = [];
        }
        groups[letter].push(item);
      });
      return keys_default()(groups).sort().map(function (letter) {
        return { letter: letter, items: groups[letter] };
      });
    },
    codes: function codes() {
      return this.currentBrand && this.currentBrand.codes ? this.currentBrand.codes : [];
    },
    currentIndex: function currentIndex() {
      return this.codes.indexOf(Number(this.currentCode));
    },
    remainingCount: function remainingCount() {
      if (this.currentIndex < 0) {
        return this.codes.length;
      }
      return Math.max(this.codes.length - this.currentIndex - 1, 0);
    },
    pairTitle: function pairTitle() {
      return this.currentBrand ? '转换器（' + this.currentBrand.name + '）' : '空调配对';
    }
  },
  methods: {
    loadBrands: function loadBrands() {
      var _this2 = this;

      this.$api.airConditionerModels({ keyword: this.keyword }).then(function (res) {
        if (res) {
          _this2.brands = res.data || [];
          _this2.activeLetter = _this2.groupedBrands.length ? _this2.groupedBrands[0].letter : '';
        }
      });
    },
    brandLetter: function brandLetter(item) {
      var letterMap = {
        '奥克斯': 'A',
        '澳柯玛': 'A',
        '宝立创': 'B',
        '春兰': 'C',
        '长虹': 'C',
        '创维': 'C',
        '东芝': 'D',
        '东宝': 'D',
        '大金': 'D',
        '富士通': 'F',
        '格力': 'G',
        '高路华': 'G',
        '格兰仕': 'G',
        '高美': 'G',
        '国美': 'G',
        '海尔': 'H',
        '海信': 'H',
        '华凌': 'H',
        '惠而浦': 'H',
        '海林': 'H',
        '海普': 'H',
        '华蒜': 'H',
        '和山': 'H',
        '科龙': 'K',
        '开利': 'K',
        '康佳': 'K',
        '酷风': 'K',
        '蓝波': 'L',
        '乐华': 'L',
        '乐京': 'L',
        '美的': 'M',
        '麦克维尔': 'M',
        '米家': 'M',
        '内田': 'N',
        '欧科': 'O',
        '日立': 'R',
        '三星': 'S',
        '三洋': 'S',
        '三菱重工': 'S',
        '三菱电机': 'S',
        '松下': 'S',
        '上凌': 'S',
        '三垦': 'S',
        '三菱': 'S',
        '上菱': 'S',
        '绅宝': 'S',
        '深松': 'S',
        '深宝': 'S',
        '三菱重工海尔': 'S',
        '山水': 'S',
        '苏宁极物': 'S',
        '天元': 'T',
        '泰阳': 'T',
        '汤姆森': 'T',
        '万宝': 'W',
        '新科': 'X',
        '熊猫': 'X',
        '夏普': 'X',
        '新迎燕': 'X',
        '夏洋': 'X',
        '西冷': 'X',
        '小米': 'X',
        '夏宝': 'X',
        '乐声': 'Y',
        '玉兔': 'Y',
        '扬子': 'Y',
        '伊莱克斯': 'Y',
        '约克': 'Y',
        '樱花': 'Y',
        '月兔': 'Y',
        '银燕': 'Y',
        '志高': 'Z',
        '镇堡': 'Z',
        '中广欧特斯': 'Z'
      };
      if (letterMap[item.name]) {
        return letterMap[item.name];
      }
      var en = (item.en || item.name || '').trim();
      var letter = en ? en.substr(0, 1).toUpperCase() : '#';
      return (/^[A-Z]$/.test(letter) ? letter : '#'
      );
    },
    scrollToLetter: function scrollToLetter(letter) {
      this.activeLetter = letter;
      var el = document.getElementById('brand-' + letter);
      if (el) {
        el.scrollIntoView();
      }
    },
    selectBrand: function selectBrand(item) {
      this.currentBrand = item;
      this.currentCode = item.codes && item.codes.length ? item.codes[0] : '';
      this.currentPower = 1;
      this.step = 'control';
    },
    sendPairCommand: function sendPairCommand(power) {
      var _this3 = this;

      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码');
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.airPairControl({
        id: this.id,
        ac_code: this.currentCode,
        power: power,
        temperature: this.temperature,
        mode: 0,
        fan: 1
      }).then(function (res) {
        if (res.code == 0) {
          _this3.$func.showToast('发送成功');
        }
        _this3.$func.endLoading();
      });
    },
    nextCode: function nextCode() {
      if (this.codes.length <= 0) {
        return false;
      }
      var index = this.currentIndex;
      if (index < 0) {
        this.currentCode = this.codes[0];
        return false;
      }
      if (index >= this.codes.length - 1) {
        this.$func.showToast('当前品牌已到最后一组');
        return false;
      }
      this.currentCode = this.codes[index + 1];
      this.currentPower = 1;
    },
    saveCode: function saveCode() {
      var _this4 = this;

      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码');
        return false;
      }
      if (this.currentPower) {
        this.currentPower = 0;
        return false;
      }
      this.$func.startLoading('请求中。。。');
      this.$api.airSaveModelCode({
        id: this.id,
        ac_code: this.currentCode,
        brand: this.currentBrand ? this.currentBrand.name : ''
      }).then(function (res) {
        if (res.code == 0) {
          _this4.$func.showToast('保存成功');
          setTimeout(function () {
            _this4.$router.go(-1);
          }, 300);
        }
        _this4.$func.endLoading();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0de054a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/airPair.vue
var airPair_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main air-pair-page"},[(_vm.step == 'brand')?_c('div',{staticClass:"brand-page cm-bg-white"},[_c('div',{staticClass:"brand-search cm-p-lr-12 cm-p-tb-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"cm-fn-16 cm-w-100",attrs:{"type":"text","placeholder":"搜索空调品牌"},domProps:{"value":(_vm.keyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadBrands($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"brand-search-btn cm-bg-blue cm-color-white cm-border-radius-5 cm-m-l-8",on:{"click":_vm.loadBrands}},[_vm._v("搜索")])]),_vm._v(" "),_c('div',{staticClass:"brand-list"},_vm._l((_vm.groupedBrands),function(group){return _c('div',{key:group.letter,attrs:{"id":'brand-' + group.letter}},[_c('div',{staticClass:"letter-title"},[_vm._v(_vm._s(group.letter))]),_vm._v(" "),_vm._l((group.items),function(item){return _c('div',{key:item.name,staticClass:"brand-item",on:{"click":function($event){return _vm.selectBrand(item)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"letter-index"},_vm._l((_vm.letters),function(letter){return _c('div',{key:letter,class:{'active': _vm.activeLetter == letter},on:{"click":function($event){return _vm.scrollToLetter(letter)}}},[_vm._v(_vm._s(letter))])}),0)]):_c('div',{staticClass:"control-page cm-bg-white"},[_c('div',{staticClass:"pair-title cm-center"},[_c('p',{staticClass:"cm-fn-18"},[_vm._v(_vm._s(_vm.pairTitle)+" 剩余组数："+_vm._s(_vm.remainingCount)+"个")])]),_vm._v(" "),_c('div',{staticClass:"pair-orb cm-center"},[(_vm.currentPower)?_c('div',{staticClass:"pair-status"},[_c('span',[_vm._v(_vm._s(_vm.temperature))]),_c('span',{staticClass:"degree"},[_vm._v("℃")]),_vm._v(" "),_c('span',{staticClass:"split"},[_vm._v("|")]),_c('span',[_vm._v("自动")]),_c('span',{staticClass:"split"},[_vm._v("|")]),_c('span',[_vm._v("低速")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"power-btn",on:{"click":function($event){return _vm.sendPairCommand(_vm.currentPower)}}},[_vm._v(_vm._s(_vm.currentPower ? '开机' : '关机'))])]),_vm._v(" "),_c('div',{staticClass:"pair-guide"},[_c('p',[_vm._v("1、请点击以上"+_vm._s(_vm.currentPower ? '开机' : '关机')+"按钮（可多次尝试）")]),_vm._v(" "),_c('p',[_vm._v("2、空调正常"+_vm._s(_vm.currentPower ? '开机' : '关机')+"选“是”")]),_vm._v(" "),_c('p',[_vm._v("3、其他选“否”")]),_vm._v(" "),_c('p',[_vm._v("4、重复以上操作直到正常"+_vm._s(_vm.currentPower ? '开机' : '关机'))])]),_vm._v(" "),_c('div',{staticClass:"pair-actions"},[_c('div',{staticClass:"pair-action",on:{"click":_vm.nextCode}},[_vm._v("否")]),_vm._v(" "),_c('div',{staticClass:"pair-action",on:{"click":_vm.saveCode}},[_vm._v("是")])])])])}
var airPair_staticRenderFns = []
var airPair_esExports = { render: airPair_render, staticRenderFns: airPair_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_airPair = (airPair_esExports);
// CONCATENATED MODULE: ./src/pages/airPair.vue
function airPair_injectStyle (ssrContext) {
  __webpack_require__("XHWC")
}
var airPair_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var airPair___vue_template_functional__ = false
/* styles */
var airPair___vue_styles__ = airPair_injectStyle
/* scopeId */
var airPair___vue_scopeId__ = "data-v-b0de054a"
/* moduleIdentifier (server only) */
var airPair___vue_module_identifier__ = null
var airPair_Component = airPair_normalizeComponent(
  pages_airPair,
  selectortype_template_index_0_src_pages_airPair,
  airPair___vue_template_functional__,
  airPair___vue_styles__,
  airPair___vue_scopeId__,
  airPair___vue_module_identifier__
)

/* harmony default export */ var src_pages_airPair = (airPair_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scanUnlock.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var scanUnlock = ({
  name: 'scanUnlock',
  data: function data() {
    return {
      cid: 0,
      mid: 0,
      token: '',
      status: 'loading',
      message: '开锁中...',
      storeTitle: src_customer.name
    };
  },

  computed: {
    tokenKey: function tokenKey() {
      return 'scan_token_' + src_customer.key;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.parseScene();
      if (!this.cid) {
        this.status = 'error';
        this.message = '二维码异常，缺少门店信息';
        return;
      }
      this.openLock();
    },
    retry: function retry() {
      this.status = 'loading';
      this.message = '开锁中...';
      this.openLock();
    },
    parseScene: function parseScene() {
      var query = assign_default()({}, this.$route.query);
      var scene = query.scene ? decodeURIComponent(query.scene) : '';
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach(function (item) {
          var arr = item.split('=');
          if (arr[0]) {
            query[arr[0]] = arr[1];
          }
        });
      }
      this.cid = parseInt(query.cid || 0);
      this.mid = parseInt(query.mid || query.id || 0);
    },
    openLock: function openLock() {
      var _this = this;

      this.status = 'loading';
      this.message = '开锁中...';
      var data = { cid: this.cid };
      if (this.mid) {
        data.id = this.mid;
      }
      this.$api.scanOpenLock(data, this.token).then(function (res) {
        if (!res) {
          _this.status = 'error';
          _this.message = '开锁失败，请稍后再试';
          return;
        }
        if (res.code === 0) {
          _this.status = 'success';
          _this.message = res.msg || '已开锁';
          if (res.data && res.data.src) {
            var audio = new Audio(res.data.src);
            audio.play();
          }
          _this.$api.scanOpenLockCallback({ cid: _this.cid }, _this.token);
          return;
        }
        _this.status = 'error';
        _this.message = res.msg || '开锁失败';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scanUnlock.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_scanUnlock = ({
  name: 'scanUnlock',
  data: function data() {
    return {
      cid: 0,
      mid: 0,
      token: '',
      status: 'loading',
      message: '开锁中...',
      storeTitle: src_customer.name
    };
  },

  computed: {
    tokenKey: function tokenKey() {
      return 'scan_token_' + src_customer.key;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.parseScene();
      if (!this.cid) {
        this.status = 'error';
        this.message = '二维码异常，缺少门店信息';
        return;
      }
      this.openLock();
    },
    retry: function retry() {
      this.status = 'loading';
      this.message = '开锁中...';
      this.openLock();
    },
    parseScene: function parseScene() {
      var query = assign_default()({}, this.$route.query);
      var scene = query.scene ? decodeURIComponent(query.scene) : '';
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach(function (item) {
          var arr = item.split('=');
          if (arr[0]) {
            query[arr[0]] = arr[1];
          }
        });
      }
      this.cid = parseInt(query.cid || 0);
      this.mid = parseInt(query.mid || query.id || 0);
    },
    openLock: function openLock() {
      var _this = this;

      this.status = 'loading';
      this.message = '开锁中...';
      var data = { cid: this.cid };
      if (this.mid) {
        data.id = this.mid;
      }
      this.$api.scanOpenLock(data, this.token).then(function (res) {
        if (!res) {
          _this.status = 'error';
          _this.message = '开锁失败，请稍后再试';
          return;
        }
        if (res.code === 0) {
          _this.status = 'success';
          _this.message = res.msg || '已开锁';
          if (res.data && res.data.src) {
            var audio = new Audio(res.data.src);
            audio.play();
          }
          _this.$api.scanOpenLockCallback({ cid: _this.cid }, _this.token);
          return;
        }
        _this.status = 'error';
        _this.message = res.msg || '开锁失败';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394d1a37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/scanUnlock.vue
var scanUnlock_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scan-page cm-main cm-bg-gray"},[_c('div',{staticClass:"scan-card cm-bg-white cm-border-radius-10 cm-p-lr-20 cm-p-tb-28 cm-text-center"},[_c('img',{staticClass:"scan-logo",attrs:{"src":_vm.$customer.assets.logo}}),_vm._v(" "),_c('p',{staticClass:"cm-fn-22 cm-color-block cm-m-t-16 cm-fn-weight-default"},[_vm._v("用户开锁")]),_vm._v(" "),_c('p',{staticClass:"cm-fn-14 cm-color-666 cm-m-t-8"},[_vm._v(_vm._s(_vm.storeTitle))]),_vm._v(" "),_c('div',{staticClass:"scan-state cm-m-t-28",class:'is-' + _vm.status},[_c('span')]),_vm._v(" "),_c('p',{staticClass:"cm-fn-18 cm-color-block cm-m-t-18"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.status === 'error')?_c('button',{staticClass:"cm-bg-blue cm-color-white cm-fn-16 cm-border-radius-8 cm-p-tb-12 cm-p-lr-40 cm-m-t-24",on:{"click":_vm.retry}},[_vm._v("重新开锁")]):_vm._e()])])}
var scanUnlock_staticRenderFns = []
var scanUnlock_esExports = { render: scanUnlock_render, staticRenderFns: scanUnlock_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_scanUnlock = (scanUnlock_esExports);
// CONCATENATED MODULE: ./src/pages/scanUnlock.vue
function scanUnlock_injectStyle (ssrContext) {
  __webpack_require__("EHUm")
}
var scanUnlock_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scanUnlock___vue_template_functional__ = false
/* styles */
var scanUnlock___vue_styles__ = scanUnlock_injectStyle
/* scopeId */
var scanUnlock___vue_scopeId__ = "data-v-394d1a37"
/* moduleIdentifier (server only) */
var scanUnlock___vue_module_identifier__ = null
var scanUnlock_Component = scanUnlock_normalizeComponent(
  pages_scanUnlock,
  selectortype_template_index_0_src_pages_scanUnlock,
  scanUnlock___vue_template_functional__,
  scanUnlock___vue_styles__,
  scanUnlock___vue_scopeId__,
  scanUnlock___vue_module_identifier__
)

/* harmony default export */ var src_pages_scanUnlock = (scanUnlock_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scanPickClothes.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var scanPickClothes = ({
  name: 'scanPickClothes',
  data: function data() {
    return {
      cid: 0,
      token: '',
      user: {},
      phone: '',
      banner: [],
      type: 0,
      list: [],
      number: 0,
      lastId: 0,
      pageFlag: 1,
      hasNext: 0,
      checkAllStatus: false,
      blankShow: false,
      blankText: '请输入手机号查询待取衣物',
      loading: false,
      tabs: [{ key: 0, value: '待取衣物' }, { key: 1, value: '全部衣物' }]
    };
  },

  computed: {
    tokenKey: function tokenKey() {
      return 'scan_token_' + src_customer.key;
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    init: function init() {
      this.parseScene();
      if (!this.cid) {
        this.blankShow = true;
        this.blankText = '二维码异常，缺少门店信息';
        return;
      }
      this.getBanner();
    },
    parseScene: function parseScene() {
      var query = assign_default()({}, this.$route.query);
      var scene = query.scene ? decodeURIComponent(query.scene) : '';
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach(function (item) {
          var arr = item.split('=');
          if (arr[0]) {
            query[arr[0]] = arr[1];
          }
        });
      }
      this.cid = parseInt(query.cid || 0);
    },
    getBanner: function getBanner() {
      var _this = this;

      this.$api.scanBanner({ cid: this.cid, position: 2 }, this.token).then(function (res) {
        if (res && res.data && res.data.list) {
          _this.banner = res.data.list;
        }
      });
    },
    selectType: function selectType(type) {
      this.type = type;
      this.search();
    },
    search: function search() {
      if (!this.phone) {
        this.$func.showToast('请输入手机号查询');
        return;
      }
      this.pageFlag = 1;
      this.lastId = 0;
      this.list = [];
      this.number = 0;
      this.checkAllStatus = false;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      if (this.loading || !this.phone) {
        return;
      }
      this.loading = true;
      this.$api.scanWaitPick({
        cid: this.cid,
        type: this.type,
        last_id: this.lastId,
        page_flag: this.pageFlag,
        phone: this.phone
      }, this.token).then(function (res) {
        _this2.loading = false;
        if (!res) {
          return;
        }
        var data = res.data || [];
        if (!_this2.lastId) {
          _this2.blankShow = data.length <= 0;
          _this2.blankText = '暂无待取衣物';
        }
        _this2.hasNext = res.hasNext;
        _this2.lastId = res.lastId;
        data.forEach(function (item) {
          item.checked = 0;
          _this2.list.push(item);
        });
      }).catch(function () {
        _this2.loading = false;
      });
    },
    checkAll: function checkAll() {
      var _this3 = this;

      this.checkAllStatus = !this.checkAllStatus;
      this.list.forEach(function (item) {
        item.checked = _this3.checkAllStatus ? 1 : 0;
      });
      this.countNum();
    },
    check: function check(index) {
      this.list[index].checked = this.list[index].checked ? 0 : 1;
      this.checkAllStatus = this.list.length > 0 && this.list.every(function (item) {
        return item.checked;
      });
      this.countNum();
    },
    countNum: function countNum() {
      this.number = this.list.filter(function (item) {
        return item.checked;
      }).length;
    },
    submit: function submit() {
      var _this4 = this;

      var ids = this.list.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.id;
      });
      if (!ids.length) {
        this.$func.showToast('请选择衣物');
        return;
      }
      this.$func.confirm('确认取衣？', '提示', function () {
        _this4.$api.scanPick({ ids: ids.join(','), cid: _this4.cid, phone: _this4.phone }, _this4.token).then(function (res) {
          if (res) {
            _this4.$func.showToast(res.msg || '取衣成功');
            _this4.search();
          }
        });
      });
    },
    onScroll: function onScroll() {
      if (!this.hasNext || this.loading) {
        return;
      }
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + clientHeight + 80 >= scrollHeight) {
        this.pageFlag = 2;
        this.getList();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scanPickClothes.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_scanPickClothes = ({
  name: 'scanPickClothes',
  data: function data() {
    return {
      cid: 0,
      token: '',
      user: {},
      phone: '',
      banner: [],
      type: 0,
      list: [],
      number: 0,
      lastId: 0,
      pageFlag: 1,
      hasNext: 0,
      checkAllStatus: false,
      blankShow: false,
      blankText: '请输入手机号查询待取衣物',
      loading: false,
      tabs: [{ key: 0, value: '待取衣物' }, { key: 1, value: '全部衣物' }]
    };
  },

  computed: {
    tokenKey: function tokenKey() {
      return 'scan_token_' + src_customer.key;
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    init: function init() {
      this.parseScene();
      if (!this.cid) {
        this.blankShow = true;
        this.blankText = '二维码异常，缺少门店信息';
        return;
      }
      this.getBanner();
    },
    parseScene: function parseScene() {
      var query = assign_default()({}, this.$route.query);
      var scene = query.scene ? decodeURIComponent(query.scene) : '';
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach(function (item) {
          var arr = item.split('=');
          if (arr[0]) {
            query[arr[0]] = arr[1];
          }
        });
      }
      this.cid = parseInt(query.cid || 0);
    },
    getBanner: function getBanner() {
      var _this = this;

      this.$api.scanBanner({ cid: this.cid, position: 2 }, this.token).then(function (res) {
        if (res && res.data && res.data.list) {
          _this.banner = res.data.list;
        }
      });
    },
    selectType: function selectType(type) {
      this.type = type;
      this.search();
    },
    search: function search() {
      if (!this.phone) {
        this.$func.showToast('请输入手机号查询');
        return;
      }
      this.pageFlag = 1;
      this.lastId = 0;
      this.list = [];
      this.number = 0;
      this.checkAllStatus = false;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      if (this.loading || !this.phone) {
        return;
      }
      this.loading = true;
      this.$api.scanWaitPick({
        cid: this.cid,
        type: this.type,
        last_id: this.lastId,
        page_flag: this.pageFlag,
        phone: this.phone
      }, this.token).then(function (res) {
        _this2.loading = false;
        if (!res) {
          return;
        }
        var data = res.data || [];
        if (!_this2.lastId) {
          _this2.blankShow = data.length <= 0;
          _this2.blankText = '暂无待取衣物';
        }
        _this2.hasNext = res.hasNext;
        _this2.lastId = res.lastId;
        data.forEach(function (item) {
          item.checked = 0;
          _this2.list.push(item);
        });
      }).catch(function () {
        _this2.loading = false;
      });
    },
    checkAll: function checkAll() {
      var _this3 = this;

      this.checkAllStatus = !this.checkAllStatus;
      this.list.forEach(function (item) {
        item.checked = _this3.checkAllStatus ? 1 : 0;
      });
      this.countNum();
    },
    check: function check(index) {
      this.list[index].checked = this.list[index].checked ? 0 : 1;
      this.checkAllStatus = this.list.length > 0 && this.list.every(function (item) {
        return item.checked;
      });
      this.countNum();
    },
    countNum: function countNum() {
      this.number = this.list.filter(function (item) {
        return item.checked;
      }).length;
    },
    submit: function submit() {
      var _this4 = this;

      var ids = this.list.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.id;
      });
      if (!ids.length) {
        this.$func.showToast('请选择衣物');
        return;
      }
      this.$func.confirm('确认取衣？', '提示', function () {
        _this4.$api.scanPick({ ids: ids.join(','), cid: _this4.cid, phone: _this4.phone }, _this4.token).then(function (res) {
          if (res) {
            _this4.$func.showToast(res.msg || '取衣成功');
            _this4.search();
          }
        });
      });
    },
    onScroll: function onScroll() {
      if (!this.hasNext || this.loading) {
        return;
      }
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + clientHeight + 80 >= scrollHeight) {
        this.pageFlag = 2;
        this.getList();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f12336f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/scanPickClothes.vue
var scanPickClothes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scan-pick cm-main cm-bg-gray"},[(_vm.banner.length)?_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.banner[0].pic}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search cm-bg-white cm-p-lr-12 cm-p-tb-12"},[_c('p',{staticClass:"cm-fn-20 cm-color-block cm-fn-weight-default"},[_vm._v("自助取衣")]),_vm._v(" "),_c('div',{staticClass:"cm-flex-middle cm-flex-between cm-m-t-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"cm-fn-16 cm-bg-gray cm-border-radius-6 cm-p-lr-12",attrs:{"type":"tel","maxlength":"11","placeholder":"请输入手机号查询"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"cm-bg-blue cm-color-white cm-fn-15 cm-border-radius-6 cm-m-l-8",on:{"click":_vm.search}},[_vm._v("查询")])])]),_vm._v(" "),_c('div',{staticClass:"tabs cm-bg-white cm-flex-middle cm-m-t-8"},_vm._l((_vm.tabs),function(item){return _c('div',{key:item.key,staticClass:"tab cm-center cm-fn-15",class:{active: _vm.type === item.key},on:{"click":function($event){return _vm.selectType(item.key)}}},[_vm._v(_vm._s(item.value))])}),0),_vm._v(" "),(_vm.list.length)?_c('div',{staticClass:"toolbar cm-bg-white cm-flex-between cm-flex-middle cm-p-lr-12 cm-p-tb-10"},[_c('p',{staticClass:"cm-fn-14 cm-color-666"},[_vm._v("已选 "+_vm._s(_vm.number)+" 件")]),_vm._v(" "),_c('button',{staticClass:"cm-fn-14 cm-color-blue",on:{"click":_vm.checkAll}},[_vm._v(_vm._s(_vm.checkAllStatus ? '取消全选' : '全选'))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,staticClass:"item cm-bg-white cm-m-t-8 cm-p-lr-12 cm-p-tb-12",on:{"click":function($event){return _vm.check(index)}}},[_c('div',{staticClass:"cm-flex-middle cm-flex-between"},[_c('div',{staticClass:"cm-flex-start cm-flex-middle"},[_c('span',{staticClass:"checkbox",class:{checked: item.checked}}),_vm._v(" "),_c('img',{staticClass:"pic cm-m-l-8",attrs:{"src":item.pic || _vm.$customer.assets.logo}}),_vm._v(" "),_c('div',{staticClass:"cm-m-l-10"},[_c('p',{staticClass:"cm-fn-16 cm-color-block"},[_vm._v(_vm._s(item.clothe_title || item.name || '衣物'))]),_vm._v(" "),_c('p',{staticClass:"cm-fn-13 cm-color-666 cm-m-t-4"},[_vm._v(_vm._s(item.washing_code))]),_vm._v(" "),(item.strip_code)?_c('p',{staticClass:"cm-fn-13 cm-color-666 cm-m-t-4"},[_vm._v("灯条："+_vm._s(item.strip_code))]):_vm._e()])]),_vm._v(" "),_c('p',{staticClass:"cm-fn-13 cm-color-blue"},[_vm._v(_vm._s(item.state_text))])])])}),0),_vm._v(" "),(_vm.blankShow)?_c('div',{staticClass:"blank cm-text-center cm-color-999 cm-fn-15"},[_vm._v(_vm._s(_vm.blankText))]):_vm._e(),_vm._v(" "),(_vm.list.length)?_c('div',{staticClass:"footer cm-bg-white cm-flex-between cm-flex-middle cm-p-lr-12"},[_c('p',{staticClass:"cm-fn-15 cm-color-block"},[_vm._v("共 "+_vm._s(_vm.list.length)+" 件")]),_vm._v(" "),_c('button',{staticClass:"cm-bg-blue cm-color-white cm-fn-16 cm-border-radius-6",on:{"click":_vm.submit}},[_vm._v("确认取衣")])]):_vm._e()])}
var scanPickClothes_staticRenderFns = []
var scanPickClothes_esExports = { render: scanPickClothes_render, staticRenderFns: scanPickClothes_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_scanPickClothes = (scanPickClothes_esExports);
// CONCATENATED MODULE: ./src/pages/scanPickClothes.vue
function scanPickClothes_injectStyle (ssrContext) {
  __webpack_require__("p8Zg")
}
var scanPickClothes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scanPickClothes___vue_template_functional__ = false
/* styles */
var scanPickClothes___vue_styles__ = scanPickClothes_injectStyle
/* scopeId */
var scanPickClothes___vue_scopeId__ = "data-v-f12336f8"
/* moduleIdentifier (server only) */
var scanPickClothes___vue_module_identifier__ = null
var scanPickClothes_Component = scanPickClothes_normalizeComponent(
  pages_scanPickClothes,
  selectortype_template_index_0_src_pages_scanPickClothes,
  scanPickClothes___vue_template_functional__,
  scanPickClothes___vue_styles__,
  scanPickClothes___vue_scopeId__,
  scanPickClothes___vue_module_identifier__
)

/* harmony default export */ var src_pages_scanPickClothes = (scanPickClothes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/miniUserManage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var miniUserManage = ({
  name: 'miniUserManage',
  components: {
    cmBlank: src_components_cmBlank,
    cmLoadmore: src_components_cmLoadmore
  },
  data: function data() {
    return {
      keyword: '',
      list: [],
      tagOptions: [],
      currentUser: {},
      checkedTagIds: [],
      selectedTagId: 0,
      tagPop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      saving: false
    };
  },
  created: function created() {
    this.getTagOptions();
    this.loadmore();
  },

  methods: {
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.blankShow = false;
      this.busy = false;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.keyword = '';
      this.search();
    },
    getList: function getList() {
      var _this = this;

      return this.$api.miniUserList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, tag_id: this.selectedTagId }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length == 0;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList().finally(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
        } else if (_this2.hasNext > 0) {
          _this2.busy = false;
          _this2.loadStatus = false;
        } else {
          _this2.busy = true;
          _this2.loadStatus = true;
          _this2.loadmoreText = '没有更多了。。。';
        }
      });
    },
    getTagOptions: function getTagOptions() {
      var _this3 = this;

      this.$api.miniUserTagOptions({}).then(function (res) {
        if (res) {
          _this3.tagOptions = res.data || [];
        }
      });
    },
    selectTagFilter: function selectTagFilter(id) {
      id = Number(id);
      if (this.selectedTagId === id) {
        return false;
      }
      this.selectedTagId = id;
      this.search();
    },
    openTagPop: function openTagPop(user) {
      this.currentUser = user;
      this.checkedTagIds = (user.tag_list || []).map(function (item) {
        return Number(item.id);
      });
      this.tagPop = true;
    },
    closeTagPop: function closeTagPop() {
      this.tagPop = false;
    },
    isChecked: function isChecked(id) {
      return this.checkedTagIds.indexOf(Number(id)) > -1;
    },
    toggleTag: function toggleTag(id) {
      id = Number(id);
      var index = this.checkedTagIds.indexOf(id);
      if (index > -1) {
        this.checkedTagIds.splice(index, 1);
      } else {
        this.checkedTagIds.push(id);
      }
    },
    viewUserOrders: function viewUserOrders(user) {
      if (!user.phone) {
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({ name: 'order', params: { type: 1, i: 0 }, query: { phone: user.phone } });
    },
    viewWashRecords: function viewWashRecords(user) {
      if (!user.phone) {
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({ name: 'recordPhoneList', query: { phone: user.phone } });
    },
    copyPhone: function copyPhone(phone, event) {
      if (!phone) {
        return false;
      }
      this.$func.copy(phone, event);
    },
    removeUserTag: function removeUserTag(user, tag) {
      var _this4 = this;

      if (this.saving) {
        return false;
      }
      var tagId = Number(tag.id);
      var nextTags = (user.tag_list || []).filter(function (item) {
        return Number(item.id) !== tagId;
      });
      this.saving = true;
      this.$api.saveMiniUserTags({ uid: user.uid, tag_ids: nextTags.map(function (item) {
          return item.id;
        }).join(',') }).then(function (res) {
        if (res) {
          _this4.$set(user, 'tag_list', nextTags);
          _this4.$set(user, 'tag_text', nextTags.map(function (item) {
            return item.name;
          }).join('，'));
          if (_this4.currentUser.uid === user.uid) {
            _this4.checkedTagIds = nextTags.map(function (item) {
              return Number(item.id);
            });
          }
          _this4.$func.showToast('删除成功');
        }
      }).finally(function () {
        _this4.saving = false;
      });
    },
    tagStyle: function tagStyle(tag) {
      var checked = this.isChecked(tag.id);
      return {
        color: checked ? '#ffffff' : '#333333',
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    filterTagStyle: function filterTagStyle(tag) {
      var checked = this.selectedTagId === Number(tag.id);
      return {
        color: checked ? '#ffffff' : tag.color,
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    tagBgColor: function tagBgColor(color) {
      if (!color || color.indexOf('#') !== 0) {
        return '#f7f8fa';
      }
      var hex = color.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(function (item) {
          return item + item;
        }).join('');
      }
      if (hex.length !== 6) {
        return '#f7f8fa';
      }
      var r = parseInt(hex.slice(0, 2), 16);
      var g = parseInt(hex.slice(2, 4), 16);
      var b = parseInt(hex.slice(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',0.08)';
    },
    hasTagEffect: function hasTagEffect(tag) {
      return this.tagEffectText(tag) !== '';
    },
    tagEffectText: function tagEffectText(tag) {
      if (!tag) {
        return '';
      }
      if (tag.effect_text) {
        return tag.effect_text;
      }
      var code = tag.effect_code || '';
      if (!code || code === 'none') {
        return '';
      }
      var map = {
        store_no_call: '扫码免打电话',
        store_deny_open: '扫码禁止开门'
      };
      return map[code] || code;
    },
    showTagEffectTip: function showTagEffectTip(tag) {
      var text = this.tagEffectText(tag);
      if (text) {
        this.$func.showToast(text);
      }
    },
    submitTags: function submitTags() {
      var _this5 = this;

      if (this.saving) {
        return false;
      }
      this.saving = true;
      this.$api.saveMiniUserTags({ uid: this.currentUser.uid, tag_ids: this.checkedTagIds.join(',') }).then(function (res) {
        if (res) {
          var selected = _this5.tagOptions.filter(function (item) {
            return _this5.checkedTagIds.indexOf(Number(item.id)) > -1;
          });
          _this5.$set(_this5.currentUser, 'tag_list', selected);
          _this5.$set(_this5.currentUser, 'tag_text', selected.map(function (item) {
            return item.name;
          }).join('，'));
          _this5.closeTagPop();
        }
      }).finally(function () {
        _this5.saving = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/miniUserManage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_miniUserManage = ({
  name: 'miniUserManage',
  components: {
    cmBlank: src_components_cmBlank,
    cmLoadmore: src_components_cmLoadmore
  },
  data: function data() {
    return {
      keyword: '',
      list: [],
      tagOptions: [],
      currentUser: {},
      checkedTagIds: [],
      selectedTagId: 0,
      tagPop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      saving: false
    };
  },
  created: function created() {
    this.getTagOptions();
    this.loadmore();
  },

  methods: {
    search: function search() {
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.blankShow = false;
      this.busy = false;
      this.loadmore();
    },
    resetSearch: function resetSearch() {
      this.keyword = '';
      this.search();
    },
    getList: function getList() {
      var _this = this;

      return this.$api.miniUserList({ last_id: this.lastId, page_flag: this.pageFlag, keyword: this.keyword, tag_id: this.selectedTagId }).then(function (res) {
        if (res) {
          if (!_this.lastId) {
            _this.blankShow = res.data.length == 0;
          }
          _this.hasNext = res.hasNext;
          _this.lastId = res.lastId;
          res.data.forEach(function (item) {
            _this.list.push(item);
          });
        }
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.lastId > 0 && !this.hasNext) {
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList().finally(function () {
        if (_this2.blankShow) {
          _this2.busy = true;
          _this2.loadStatus = false;
        } else if (_this2.hasNext > 0) {
          _this2.busy = false;
          _this2.loadStatus = false;
        } else {
          _this2.busy = true;
          _this2.loadStatus = true;
          _this2.loadmoreText = '没有更多了。。。';
        }
      });
    },
    getTagOptions: function getTagOptions() {
      var _this3 = this;

      this.$api.miniUserTagOptions({}).then(function (res) {
        if (res) {
          _this3.tagOptions = res.data || [];
        }
      });
    },
    selectTagFilter: function selectTagFilter(id) {
      id = Number(id);
      if (this.selectedTagId === id) {
        return false;
      }
      this.selectedTagId = id;
      this.search();
    },
    openTagPop: function openTagPop(user) {
      this.currentUser = user;
      this.checkedTagIds = (user.tag_list || []).map(function (item) {
        return Number(item.id);
      });
      this.tagPop = true;
    },
    closeTagPop: function closeTagPop() {
      this.tagPop = false;
    },
    isChecked: function isChecked(id) {
      return this.checkedTagIds.indexOf(Number(id)) > -1;
    },
    toggleTag: function toggleTag(id) {
      id = Number(id);
      var index = this.checkedTagIds.indexOf(id);
      if (index > -1) {
        this.checkedTagIds.splice(index, 1);
      } else {
        this.checkedTagIds.push(id);
      }
    },
    viewUserOrders: function viewUserOrders(user) {
      if (!user.phone) {
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({ name: 'order', params: { type: 1, i: 0 }, query: { phone: user.phone } });
    },
    viewWashRecords: function viewWashRecords(user) {
      if (!user.phone) {
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({ name: 'recordPhoneList', query: { phone: user.phone } });
    },
    copyPhone: function copyPhone(phone, event) {
      if (!phone) {
        return false;
      }
      this.$func.copy(phone, event);
    },
    removeUserTag: function removeUserTag(user, tag) {
      var _this4 = this;

      if (this.saving) {
        return false;
      }
      var tagId = Number(tag.id);
      var nextTags = (user.tag_list || []).filter(function (item) {
        return Number(item.id) !== tagId;
      });
      this.saving = true;
      this.$api.saveMiniUserTags({ uid: user.uid, tag_ids: nextTags.map(function (item) {
          return item.id;
        }).join(',') }).then(function (res) {
        if (res) {
          _this4.$set(user, 'tag_list', nextTags);
          _this4.$set(user, 'tag_text', nextTags.map(function (item) {
            return item.name;
          }).join('，'));
          if (_this4.currentUser.uid === user.uid) {
            _this4.checkedTagIds = nextTags.map(function (item) {
              return Number(item.id);
            });
          }
          _this4.$func.showToast('删除成功');
        }
      }).finally(function () {
        _this4.saving = false;
      });
    },
    tagStyle: function tagStyle(tag) {
      var checked = this.isChecked(tag.id);
      return {
        color: checked ? '#ffffff' : '#333333',
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    filterTagStyle: function filterTagStyle(tag) {
      var checked = this.selectedTagId === Number(tag.id);
      return {
        color: checked ? '#ffffff' : tag.color,
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    tagBgColor: function tagBgColor(color) {
      if (!color || color.indexOf('#') !== 0) {
        return '#f7f8fa';
      }
      var hex = color.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(function (item) {
          return item + item;
        }).join('');
      }
      if (hex.length !== 6) {
        return '#f7f8fa';
      }
      var r = parseInt(hex.slice(0, 2), 16);
      var g = parseInt(hex.slice(2, 4), 16);
      var b = parseInt(hex.slice(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',0.08)';
    },
    hasTagEffect: function hasTagEffect(tag) {
      return this.tagEffectText(tag) !== '';
    },
    tagEffectText: function tagEffectText(tag) {
      if (!tag) {
        return '';
      }
      if (tag.effect_text) {
        return tag.effect_text;
      }
      var code = tag.effect_code || '';
      if (!code || code === 'none') {
        return '';
      }
      var map = {
        store_no_call: '扫码免打电话',
        store_deny_open: '扫码禁止开门'
      };
      return map[code] || code;
    },
    showTagEffectTip: function showTagEffectTip(tag) {
      var text = this.tagEffectText(tag);
      if (text) {
        this.$func.showToast(text);
      }
    },
    submitTags: function submitTags() {
      var _this5 = this;

      if (this.saving) {
        return false;
      }
      this.saving = true;
      this.$api.saveMiniUserTags({ uid: this.currentUser.uid, tag_ids: this.checkedTagIds.join(',') }).then(function (res) {
        if (res) {
          var selected = _this5.tagOptions.filter(function (item) {
            return _this5.checkedTagIds.indexOf(Number(item.id)) > -1;
          });
          _this5.$set(_this5.currentUser, 'tag_list', selected);
          _this5.$set(_this5.currentUser, 'tag_text', selected.map(function (item) {
            return item.name;
          }).join('，'));
          _this5.closeTagPop();
        }
      }).finally(function () {
        _this5.saving = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a71b0fd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/miniUserManage.vue
var miniUserManage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-main mini-user-page"},[_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-inner"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],attrs:{"type":"text","placeholder":"昵称/姓名/手机号查询"},domProps:{"value":(_vm.keyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),(_vm.keyword)?_c('img',{staticClass:"search-clear",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.resetSearch}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"search-icon",attrs:{"src":"/static/images/icon-search.png"},on:{"click":_vm.search}})]),_vm._v(" "),_c('div',{staticClass:"tag-filter"},[_c('span',{staticClass:"filter-tag",class:_vm.selectedTagId === 0 ? 'filter-tag-active' : '',on:{"click":function($event){return _vm.selectTagFilter(0)}}},[_vm._v("全部")]),_vm._v(" "),_vm._l((_vm.tagOptions),function(tag){return _c('span',{key:tag.id,staticClass:"filter-tag",class:_vm.selectedTagId === Number(tag.id) ? 'filter-tag-active' : '',style:(_vm.filterTagStyle(tag)),on:{"click":function($event){return _vm.selectTagFilter(tag.id)}}},[_vm._v(_vm._s(tag.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"list-bg"},[(_vm.blankShow)?_c('cmBlank',{attrs:{"blankStyle":"70vh"}}):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"user-list",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},_vm._l((_vm.list),function(item){return _c('li',{key:item.uid,staticClass:"user-card"},[_c('div',{staticClass:"user-row"},[_c('div',{staticClass:"user-main"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.head || '/static/images/me.png'}})]),_vm._v(" "),_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-title"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(item.name || item.nickname || '微信用户'))]),_vm._v(" "),_c('span',{staticClass:"user-uid"},[_vm._v("UID："+_vm._s(item.uid))])]),_vm._v(" "),_c('div',{staticClass:"user-phone"},[_c('span',{staticClass:"phone-text"},[_vm._v(_vm._s(item.phone || '未绑定手机号'))]),_vm._v(" "),(item.phone)?_c('span',{staticClass:"phone-copy",on:{"click":function($event){$event.stopPropagation();return _vm.copyPhone(item.phone, $event)}}},[_vm._v("复制")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"user-stats"},[_c('span',[_vm._v("订单 "),_c('em',{staticClass:"order-count"},[_vm._v(_vm._s(item.order_count || 0))])]),_vm._v(" "),_c('span',[_vm._v("洗衣 "),_c('em',{staticClass:"wash-count"},[_vm._v(_vm._s(item.wash_count || 0))])])]),_vm._v(" "),(item.tag_list && item.tag_list.length)?_c('div',{staticClass:"tag-list"},_vm._l((item.tag_list),function(tag){return _c('span',{key:tag.id,staticClass:"tag-item",style:({color: tag.color, borderColor: tag.color, backgroundColor: _vm.tagBgColor(tag.color)})},[_c('span',{staticClass:"tag-name"},[_vm._v(_vm._s(tag.name))]),_vm._v(" "),(_vm.hasTagEffect(tag))?_c('span',{staticClass:"tag-help",on:{"click":function($event){$event.stopPropagation();return _vm.showTagEffectTip(tag)}}},[_vm._v("?")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tag-remove",on:{"click":function($event){$event.stopPropagation();return _vm.removeUserTag(item, tag)}}},[_vm._v("×")])])}),0):_c('p',{staticClass:"empty-tags"},[_vm._v("暂无标签")])])])]),_vm._v(" "),_c('div',{staticClass:"user-actions"},[_c('button',{staticClass:"record-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewWashRecords(item)}}},[_vm._v("洗衣记录")]),_vm._v(" "),_c('button',{staticClass:"order-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewUserOrders(item)}}},[_vm._v("查看订单")]),_vm._v(" "),_c('button',{staticClass:"tag-edit-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openTagPop(item)}}},[_vm._v("设置标签")])])])}),0),_vm._v(" "),(_vm.loadStatus)?_c('cmLoadmore',{attrs:{"text":_vm.loadmoreText}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagPop),expression:"tagPop"}],staticClass:"pop tag-mask",on:{"click":_vm.closeTagPop}}),_vm._v(" "),_c('div',{staticClass:"tag-pop",class:_vm.tagPop ? 'tag-pop-show' : ''},[_c('div',{staticClass:"tag-pop-header"},[_c('div',[_c('p',{staticClass:"tag-pop-title"},[_vm._v("设置标签")]),_vm._v(" "),(_vm.currentUser.uid)?_c('p',{staticClass:"tag-pop-sub"},[_vm._v(_vm._s(_vm.currentUser.name || _vm.currentUser.nickname || '微信用户')+" "+_vm._s(_vm.currentUser.phone || ''))]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"tag-pop-close",attrs:{"src":"/static/images/icon-sku-close.png"},on:{"click":_vm.closeTagPop}})]),_vm._v(" "),_c('div',{staticClass:"tag-options"},[(_vm.tagOptions.length == 0)?_c('cmBlank',{attrs:{"blankStyle":"160px","text":"暂无可用标签"}}):_c('div',{staticClass:"tag-option-list"},_vm._l((_vm.tagOptions),function(tag){return _c('div',{key:tag.id,staticClass:"tag-option",class:_vm.isChecked(tag.id) ? 'tag-option-active' : '',style:(_vm.tagStyle(tag)),on:{"click":function($event){return _vm.toggleTag(tag.id)}}},[_c('span',{staticClass:"tag-dot",style:({backgroundColor: tag.color})}),_vm._v(" "),_c('span',{staticClass:"tag-option-name"},[_vm._v(_vm._s(tag.name))]),_vm._v(" "),(_vm.hasTagEffect(tag))?_c('span',{staticClass:"tag-help",on:{"click":function($event){$event.stopPropagation();return _vm.showTagEffectTip(tag)}}},[_vm._v("?")]):_vm._e()])}),0)],1),_vm._v(" "),_c('div',{staticClass:"tag-pop-footer"},[_c('button',{staticClass:"clear-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.checkedTagIds = []}}},[_vm._v("清空")]),_vm._v(" "),_c('button',{staticClass:"save-btn",class:_vm.saving ? 'save-btn-disabled' : '',attrs:{"type":"button"},on:{"click":_vm.submitTags}},[_vm._v(_vm._s(_vm.saving ? '保存中' : '保存'))])])])])}
var miniUserManage_staticRenderFns = []
var miniUserManage_esExports = { render: miniUserManage_render, staticRenderFns: miniUserManage_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_miniUserManage = (miniUserManage_esExports);
// CONCATENATED MODULE: ./src/pages/miniUserManage.vue
function miniUserManage_injectStyle (ssrContext) {
  __webpack_require__("oDQS")
}
var miniUserManage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var miniUserManage___vue_template_functional__ = false
/* styles */
var miniUserManage___vue_styles__ = miniUserManage_injectStyle
/* scopeId */
var miniUserManage___vue_scopeId__ = "data-v-a71b0fd0"
/* moduleIdentifier (server only) */
var miniUserManage___vue_module_identifier__ = null
var miniUserManage_Component = miniUserManage_normalizeComponent(
  pages_miniUserManage,
  selectortype_template_index_0_src_pages_miniUserManage,
  miniUserManage___vue_template_functional__,
  miniUserManage___vue_styles__,
  miniUserManage___vue_scopeId__,
  miniUserManage___vue_module_identifier__
)

/* harmony default export */ var src_pages_miniUserManage = (miniUserManage_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js














































































































































vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    alias: '/home',
    name: 'home',
    component: src_pages_home,
    meta: { title: "首页" }
  }, {
    path: '/scanUnlock',
    name: 'scanUnlock',
    component: src_pages_scanUnlock,
    meta: { title: "用户开锁" }
  }, {
    path: '/scanPickClothes',
    name: 'scanPickClothes',
    component: src_pages_scanPickClothes,
    meta: { title: "自助取衣" }
  }, {
    path: '/createWashOrder/:phone?/:orderGoods?',
    name: 'createWashOrder',
    component: src_pages_createWashOrder,
    meta: { title: "衣物下单" }
  }, {
    path: '/waybillClotheOrder',
    name: 'waybillClotheOrder',
    component: src_pages_waybillClotheOrder,
    meta: { title: "衣物发货" }
  }, {
    path: '/expressOrder',
    name: 'expressOrder',
    component: src_pages_expressOrder,
    meta: { title: "送洗订单" }
  }, {
    path: '/pickupOrder',
    name: 'pickupOrder',
    component: src_pages_pickupOrder,
    meta: { title: "送回订单" }
  }, {
    path: '/waybillWashOrder',
    name: 'waybillWashOrder',
    component: src_pages_waybillWashOrder,
    meta: { title: "物流订单" }
  }, {
    path: '/queryExpress/:code?',
    name: 'queryExpress',
    component: src_pages_queryExpress,
    meta: { title: "物流轨迹查询" }
  }, {
    path: '/createCollectWashOrder',
    name: 'createCollectWashOrder',
    component: src_pages_createCollectWashOrder,
    meta: { title: "订单核销" }
  }, {
    path: '/waybillOrder',
    name: 'waybillOrder',
    component: src_pages_waybillOrder,
    meta: { title: "物流发货" }
  }, {
    path: '/collectUser/:phone?',
    name: 'collectUser',
    component: src_pages_collectUser,
    meta: { title: "用户订单" }
  }, {
    path: '/miniUserManage',
    name: 'miniUserManage',
    component: src_pages_miniUserManage,
    meta: { title: "用户管理" }
  }, {
    path: '/curtain',
    name: 'curtain',
    component: src_pages_curtain,
    meta: { title: "窗帘调度" }
  }, {
    path: '/curtainGoods',
    name: 'curtainGoods',
    component: src_pages_curtainGoods,
    meta: { title: "产品管理" }
  }, {
    path: '/createCurtainOrder/:id?',
    name: 'createCurtainOrder',
    component: src_pages_createCurtainOrder,
    meta: {
      title: "创建上门订单",
      keepAlive: true
    }
  }, {
    path: '/curtainOrder/:i?/:commented?',
    name: 'curtainOrder',
    component: src_pages_curtainOrder,
    meta: {
      title: "订单管理"
      // keepAlive: true
    }
  }, {
    path: '/curtainOrderInfo/:id',
    name: 'curtainOrderInfo',
    component: src_pages_curtainOrderInfo,
    meta: {
      title: "订单详情"
      // keepAlive: true
    }
  }, {
    path: '/curtainAddGoods',
    name: 'curtainAddGoods',
    component: src_pages_curtainAddGoods,
    meta: { title: "添加产品" }
  }, {
    path: '/curtainWorker',
    name: 'curtainWorker',
    component: src_pages_curtainWorker,
    meta: { title: "组员管理" }
  }, {
    path: '/curtainAddWorker/:id?',
    name: 'curtainAddWorker',
    component: src_pages_curtainAddWorker,
    meta: { title: "组员编辑" }
  }, {
    path: '/curtainMapOrder/:status?/:dateStr?',
    name: 'curtainMapOrder',
    component: src_pages_curtainMapOrder,
    meta: { title: "地图订单" }
  }, {
    path: '/work',
    name: 'work',
    component: src_pages_work,
    meta: { title: "工单" }
  }, {
    path: '/douYinVerify',
    name: 'douYinVerify',
    component: src_pages_douYinVerify,
    meta: { title: "抖音团购核销" }
  }, {
    path: '/douyinOrder',
    name: 'douyinOrder',
    component: src_pages_douyinOrder,
    meta: { title: "抖音团购订单" }
  }, {
    path: '/pickList',
    name: 'pickList',
    component: src_pages_pickList,
    meta: { title: "取衣记录" }
  }, {
    path: '/device',
    name: 'device',
    component: src_pages_device,
    meta: { title: "门店设备" }
  }, {
    path: '/deviceEdit/:id?',
    name: 'deviceEdit',
    component: src_pages_deviceEdit,
    meta: { title: "编辑门店设备" }
  }, {
    path: '/deviceSetting/:id?',
    name: 'deviceSetting',
    component: src_pages_deviceSetting,
    meta: { title: "设备设置" }
  }, {
    path: '/airPair/:id?',
    name: 'airPair',
    component: src_pages_airPair,
    meta: { title: "空调配对" }
  }, {
    path: '/upList',
    name: 'upList',
    component: src_pages_upList,
    meta: { title: "上挂列表" }
  }, {
    path: '/washBagCode',
    name: 'washBagCode',
    component: src_pages_washBagCode,
    meta: { title: "送洗码" }
  }, {
    path: '/washHome',
    name: 'washHome',
    component: src_pages_washHome,
    meta: { title: "上门收衣" }
  }, {
    path: '/clotheWash',
    name: 'clotheWash',
    component: src_pages_clotheWash,
    meta: { title: "洗涤中" }
  }, {
    path: '/timeOutClotheWash',
    name: 'timeOutClotheWash',
    component: src_pages_timeOutClotheWash,
    meta: { title: "超时衣物" }
  }, {
    path: '/card',
    name: 'card',
    component: src_pages_card,
    meta: { title: "会员卡" }
  }, {
    path: '/countInOutFactory',
    name: 'countInOutFactory',
    component: src_pages_countInOutFactory,
    meta: { title: "进出厂数据" }
  }, {
    path: '/clothesConfirm',
    name: 'clothesConfirm',
    component: src_pages_clothesConfirm,
    meta: {
      title: "衣物确认",
      keepAlive: true
    }
  }, {
    path: '/clothesConfirmInfo/:id?',
    name: 'clothesConfirmInfo',
    component: src_pages_clothesConfirmInfo,
    meta: { title: "衣物确认" }
  }, {
    path: '/user',
    name: 'user',
    component: src_pages_user,
    meta: { title: "我的" }
  }, {
    path: '/active',
    name: 'active',
    component: src_pages_active,
    meta: { title: "免洗活动赠送" }
  }, {
    path: '/withdrawCleanRecord',
    name: 'withdrawCleanRecord',
    component: src_pages_withdrawCleanRecord,
    meta: { title: "家政提现" }
  }, {
    path: '/clean',
    name: 'clean',
    component: src_pages_clean,
    meta: { title: "家政" }
  }, {
    path: '/wash',
    name: 'wash',
    component: src_pages_wash,
    meta: { title: "洗衣" }
  }, {
    path: '/boxList',
    name: 'boxList',
    component: src_pages_boxList,
    meta: { title: "盒子列表" }
  }, {
    path: '/recordOrder',
    name: 'recordOrder',
    component: src_pages_recordOrder,
    meta: { title: "洗衣录单" }
  }, {
    path: '/clothePhoto',
    name: 'clothePhoto',
    component: src_pages_clothePhoto,
    meta: { title: "衣物图片" }
  }, {
    path: '/pickClothe',
    name: 'pickClothe',
    component: src_pages_pickClothe,
    meta: { title: "顾客取衣" }
  }, {
    path: '/yizhuanjia/pickClothe',
    name: 'pickClotheYizhuanjia',
    component: src_pages_pickClotheYizhuanjia,
    meta: { title: "顾客取衣" }
  }, {
    path: '/upClothe',
    name: 'upClothe',
    component: src_pages_upClothe,
    meta: { title: "衣物上挂" }
  }, {
    path: '/upCustomClothe',
    name: 'upCustomClothe',
    component: src_pages_upCustomClothe,
    meta: { title: "其他衣物上挂" }
  }, {
    path: '/yizhuanjia/upClothe',
    name: 'upClotheYizhuanjia',
    component: src_pages_upClotheYizhuanjia,
    meta: { title: "衣物上挂" }
  }, {
    path: '/coupon/:type?',
    name: 'coupon',
    component: src_pages_coupon,
    meta: { title: "平台优惠券" }
  }, {
    path: '/annex',
    name: 'annex',
    component: src_pages_annex,
    meta: { title: "附件补录" }
  }, {
    path: '/abnormal',
    name: 'abnormal',
    component: src_pages_abnormal,
    meta: { title: "异常报备" }
  }, {
    path: '/cancelRecord',
    name: 'cancelRecord',
    component: src_pages_cancelRecord,
    meta: { title: "撤单" }
  }, {
    path: '/todayRecordList',
    name: 'todayRecordList',
    component: src_pages_todayRecordList,
    meta: {
      title: "今日送洗",
      keepAlive: true
    }
  }, {
    path: '/recordList',
    name: 'recordList',
    component: src_pages_recordList,
    meta: {
      title: "综合查询",
      keepAlive: true
    }
  }, {
    path: '/recordPhoneList',
    name: 'recordPhoneList',
    component: src_pages_recordPhoneList,
    meta: {
      title: "手机号查询",
      keepAlive: true
    }
  }, {
    path: '/cardMember/:i?',
    name: 'cardMember',
    component: src_pages_cardMember,
    meta: { title: "会员用户" }
  }, {
    path: '/bagCodeRecord/:type/:order_no?',
    name: 'bagCodeRecord',
    component: src_pages_bagCodeRecord,
    meta: { title: "衣物录单" }
  }, {
    path: '/backStore',
    name: 'backStore',
    component: src_pages_backStore,
    meta: { title: "回店记录" }
  }, {
    path: '/goodsCount',
    name: 'goodsCount',
    component: src_pages_goodsCount,
    meta: { title: "洗衣店普通商品统计" }
  }, {
    path: '/goodsAmountCount',
    name: 'goodsAmountCount',
    component: src_pages_goodsAmountCount,
    meta: { title: "洗衣店各项收入统计" }
  }, {
    path: '/goodsGroupCount',
    name: 'goodsGroupCount',
    component: src_pages_goodsGroupCount,
    meta: { title: "洗衣店团购商品统计" }
  }, {
    path: '/dataCount',
    name: 'dataCount',
    component: src_pages_dataCount,
    meta: { title: "数据统计" }
  }, {
    path: '/giveCoupon/:id',
    name: 'giveCoupon',
    component: src_pages_giveCoupon,
    meta: { title: "优惠券赠送" }
  }, {
    path: '/qrCoupon/:id',
    name: 'qrCoupon',
    component: src_pages_qrCoupon,
    meta: { title: "优惠券领取码" }
  }, {
    path: '/driver',
    name: 'driver',
    component: src_pages_driver,
    meta: { title: "物流" }
  }, {
    path: '/factory',
    name: 'factory',
    component: src_pages_factory,
    meta: { title: "工厂" }
  }, {
    path: '/express',
    name: 'express',
    component: src_pages_express,
    meta: { title: "快递下单" }
  }, {
    path: '/barOrder/:code?',
    name: 'barOrder',
    component: src_pages_barOrder,
    meta: { title: "条码查询" }
  }, {
    path: '/productVerify',
    name: 'productVerify',
    component: src_pages_productVerify,
    meta: { title: "订单核销" }
  }, {
    path: '/inFactory/:i',
    name: 'inFactory',
    component: src_pages_inFactory,
    meta: { title: "入厂" }
  }, {
    path: '/backwash/:i',
    name: 'backwash',
    component: src_pages_backwash,
    meta: { title: "回进厂" }
  }, {
    path: '/waitInFactory/:i/:type',
    name: 'waitInFactory',
    component: src_pages_waitInFactory,
    meta: { title: "待入厂" }
  }, {
    path: '/product',
    name: 'product',
    component: src_pages_product,
    meta: { title: "商品" }
  }, {
    path: '/myProduct',
    name: 'myProduct',
    component: src_pages_myProduct,
    meta: { title: "本店商品" }
  }, {
    path: '/submitWork',
    name: 'submitWork',
    component: src_pages_submitWork,
    meta: { title: "发起工单" }
  }, {
    path: '/clotheStatus',
    name: 'clotheStatus',
    component: src_pages_clotheStatus,
    meta: { title: "衣物状态" }
  }, {
    path: '/workorder/:i',
    name: 'workorder',
    component: src_pages_workorder,
    // meta:{title:"工单列表"}
    meta: {
      title: "工单列表",
      keepAlive: true
    }
  }, {
    path: '/workOrderInfo/:id',
    name: 'workOrderInfo',
    component: src_pages_workOrderInfo,
    meta: { title: "工单详情" }
  }, {
    path: '/workOrderSolution/:id',
    name: 'workOrderSolution',
    component: src_pages_workOrderSolution,
    meta: { title: "工单处理办法" }
  }, {
    path: '/addProduct/:id?',
    name: 'addProduct',
    component: src_pages_addProduct,
    meta: { title: "添加商品" }
  }, {
    path: '/password',
    name: 'password',
    component: src_pages_password,
    meta: { title: "修改密码" }
  }, {
    path: '/editUser',
    name: 'editUser',
    component: src_pages_editUser,
    meta: { title: "站点信息" }
  }, {
    path: '/myInvite',
    name: 'myInvite',
    component: src_pages_myInvite,
    meta: { title: "我的下级" }
  }, {
    path: '/secondCommunityOrder',
    name: 'secondCommunityOrder',
    component: src_pages_secondCommunityOrder,
    meta: { title: "下级团长订单" }
  }, {
    path: '/secondCommunityFactoryPrice/:cid?',
    name: 'secondCommunityFactoryPrice',
    component: src_pages_secondCommunityFactoryPrice,
    meta: { title: "下级门店加工价格" }
  }, {
    path: '/inviteUser',
    name: 'inviteUser',
    component: src_pages_inviteUser,
    meta: { title: "我的推广" }
  }, {
    path: '/secondBd',
    name: 'secondBd',
    component: src_pages_secondBd,
    meta: { title: "下级BD" }
  }, {
    path: '/maps/:latitude?/:longitude?',
    name: 'maps',
    component: src_pages_maps,
    meta: { title: "位置选择" }
  }, {
    path: '/secondBdEdit/:id?',
    name: 'secondBdEdit',
    component: src_pages_secondBdEdit,
    meta: { title: "BD编辑" }
  }, {
    path: '/secondCommunityEdit/:id?',
    name: 'secondCommunityEdit',
    component: src_pages_secondCommunityEdit,
    // meta:{title:"团长编辑"}
    meta: {
      title: "编辑",
      keepAlive: true
    }
  }, {
    path: '/secondCommunity',
    name: 'secondCommunity',
    component: src_pages_secondCommunity,
    meta: { title: "下级门店" }
  }, {
    path: '/groupInvite',
    name: 'groupInvite',
    component: src_pages_groupInvite,
    meta: { title: "组员推广" }
  }, {
    path: '/collectData',
    name: 'collectData',
    component: src_pages_collectData,
    meta: { title: "楼管收衣数据" }
  }, {
    path: '/communityData',
    name: 'communityData',
    component: src_pages_communityData,
    meta: { title: "小区收衣数据" }
  }, {
    path: '/myData',
    name: 'myData',
    component: src_pages_myData,
    meta: { title: "我的收衣数据" }
  }, {
    path: '/login',
    name: 'login',
    component: src_pages_login,
    meta: { title: "登录" }
  }, {
    path: '/selectStore',
    name: 'selectStore',
    component: src_pages_selectStore,
    meta: { title: "选择门店" }
  }, {
    path: '/outTimeOrder',
    name: 'outTimeOrder',
    component: src_pages_outTimeOrder,
    meta: { title: "超时订单" }
  }, {
    path: '/suboutTimeOrder',
    name: 'suboutTimeOrder',
    component: src_pages_suboutTimeOrder,
    meta: { title: "下级团长超时订单" }
  }, {
    path: '/addVisit/:cid/:title/:id?',
    name: 'addVisit',
    component: src_pages_addVisit,
    meta: { title: "新增拜访记录" }
  }, {
    path: '/visit/:cid/:title',
    name: 'visit',
    component: src_pages_visit,
    meta: { title: "拜访记录" }
  },
  // {
  //   path: '/order/:type/:i',
  //   name: 'order',
  //   component: order,
  //   meta:{title:"订单"}
  // },
  {
    path: '/order/:type/:i/:deliveryWay?',
    name: 'order',
    component: src_pages_order,
    meta: { title: "订单" }
  }, {
    path: '/suborder/:type/:i',
    name: 'suborder',
    component: src_pages_suborder,
    meta: { title: "下级团长订单" }
  }, {
    path: '/orderDetail/:id',
    name: 'orderDetail',
    component: src_pages_orderDetail,
    meta: { title: "订单详情" }
  }, {
    path: '/problem/:id',
    name: 'problem',
    component: src_pages_problem,
    meta: { title: "问题上报" }
  }, {
    path: '/waitCollect',
    name: 'waitCollect',
    component: src_pages_waitCollect,
    meta: { title: "待送洗" }
  }, {
    path: '/yizhuanjia/waitCollect',
    name: 'waitCollectYizhuanjia',
    component: src_pages_waitCollectYizhuanjia,
    meta: { title: "待送洗" }
  }, {
    path: '/collect/:id',
    name: 'collect',
    component: src_pages_collect,
    meta: { title: "收衣物" }
  }, {
    path: '/wareHouse',
    name: 'wareHouse',
    component: src_pages_wareHouse,
    meta: { title: "洗衣入库" }

  }, {
    path: '/outHouse',
    name: 'outHouse',
    component: src_pages_outHouse,
    meta: { title: "衣物出库" }

  }, {
    path: '/outHouseCode',
    name: 'outHouseCode',
    component: src_pages_outHouseCode,
    meta: { title: "扫码出库" }

  }, {
    path: '/withdraw',
    name: 'withdraw',
    component: src_pages_withdraw,
    meta: { title: "提现" }
  }, {
    path: '/balance',
    name: 'balance',
    component: src_pages_balance,
    meta: { title: "平台账户" }
  }, {
    path: '/rebate/:uid?/:otherId?',
    name: 'rebate',
    component: src_pages_rebate,
    meta: { title: "收益记录" }
  }, {
    path: '/withdrawComplete',
    name: 'withdrawComplete',
    component: src_pages_withdrawComplete,
    meta: { title: "提现完成" }
  }, {
    path: '/withdrawRecord',
    name: 'withdrawRecord',
    component: src_pages_withdrawRecord,
    meta: { title: "提现记录" }
  }, {
    path: '/group',
    name: 'group',
    component: src_pages_group,
    meta: { title: "渠道中心" }
  }, {
    path: '/groupRebate',
    name: 'groupRebate',
    component: src_pages_groupRebate,
    meta: { title: "渠道收益" }
  }, {
    path: '/groupOrder',
    name: 'groupOrder',
    component: src_pages_groupOrder,
    meta: { title: "全部订单" }
  }, {
    path: '/clearSession',
    name: 'clearSession',
    component: src_pages_clearSession,
    meta: { title: "缓存清理" }
  }, {
    path: '/storeApply',
    name: 'storeApply',
    component: src_pages_storeApply,
    meta: { title: "合伙人招募" }
  }, {
    path: '/countReward',
    name: 'countReward',
    component: src_pages_countReward,
    meta: { title: "收入统计" }
  }, {
    path: '/driverList',
    name: 'driverList',
    component: src_pages_driverList,
    meta: {
      title: "物流司机",
      keepAlive: true
    }
  }, {
    path: '/driverEdit/:id',
    name: 'driverEdit',
    component: src_pages_driverEdit,
    meta: { title: "编辑" }
  }, {
    path: '/waitPickup/:i',
    name: 'waitPickup',
    component: src_pages_waitPickup,
    meta: { title: "待取件" }
  }, {
    path: '/pickup',
    name: 'pickup',
    component: src_pages_pickup,
    meta: { title: "取件" }
  }, {
    path: '/outFactory',
    name: 'outFactory',
    component: src_pages_outFactory,
    meta: { title: "出厂" }
  }, {
    path: '/arrival',
    name: 'arrival',
    component: src_pages_arrival,
    meta: { title: "到站" }
  }, {
    path: '/editBag',
    name: 'editBag',
    component: src_pages_editBag,
    meta: { title: "修改扎带码" }
  }, {
    path: '/factoryBack',
    name: 'factoryBack',
    component: src_pages_factoryBack,
    meta: { title: "不洗退回" }
  }, {
    path: '/searchOrder/:code?',
    name: 'searchOrder',
    component: src_pages_searchOrder,
    meta: { title: "查询订单" }
  }, {
    path: '/openMap/:id',
    name: 'openMap',
    component: src_pages_openMap,
    meta: { title: "查看地图" }
  }, {
    path: '/pickuped',
    name: 'pickuped',
    component: src_pages_pickuped,
    meta: { title: "已取件" }
  }, {
    path: '/arrivaled',
    name: 'arrivaled',
    component: src_pages_arrivaled,
    meta: { title: "已到站" }
  }, {
    path: '/waitPickupInfo/:cid/:i/:type',
    name: 'waitPickupInfo',
    component: src_pages_waitPickupInfo,
    meta: { title: "配送详情" }
  }]
}));
// EXTERNAL MODULE: ./static/iconfont/iconfont.css
var iconfont = __webpack_require__("NWtE");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./src/css/app.css
var app = __webpack_require__("VXnA");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: ./src/css/public.css
var css_public = __webpack_require__("fNnY");
var public_default = /*#__PURE__*/__webpack_require__.n(css_public);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/clipboard/dist/clipboard.js
var dist_clipboard = __webpack_require__("TQvf");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(dist_clipboard);

// EXTERNAL MODULE: ./node_modules/qrious/dist/qrious.js
var qrious = __webpack_require__("+n64");
var qrious_default = /*#__PURE__*/__webpack_require__.n(qrious);

// CONCATENATED MODULE: ./src/utils/func.js











vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);

var func_func = {
  setSession: function setSession(key, value) {
    return window.sessionStorage.setItem(key, value);
  },
  getSession: function getSession(key) {
    return window.sessionStorage.getItem(key);
  },
  setLocal: function setLocal(key, value) {
    return window.localStorage.setItem(key, value);
  },
  getLocal: function getLocal(key) {
    return window.localStorage.getItem(key);
  },
  getBrandId: function getBrandId() {
    return src_customer.brandId;
  },
  getApiBaseURL: function getApiBaseURL() {
    return src_customer.apiBaseURL || 'https://fcbrand.uunbiot.com/';
  },
  showToast: function showToast(msg) {
    vue_esm["a" /* default */].$vux.loading.hide();
    vue_esm["a" /* default */].$vux.toast.text(msg ? msg : '服务器跑丢了', 'middle');
  },
  startLoading: function startLoading(title) {
    vue_esm["a" /* default */].$vux.loading.show({
      text: title ? title : '加载中。。。'
    });
  },
  endLoading: function endLoading() {
    vue_esm["a" /* default */].$vux.loading.hide();
  },
  createQrCode: function createQrCode(text, elementId) {
    if (!text || !elementId) {
      return promise_default.a.reject(new Error('Text and elementId are required'));
    }
    return new promise_default.a(function (resolve) {
      new qrious_default.a({
        element: elementId,
        value: text,
        size: 200
      });
      resolve();
    });
  },
  downloadFile: function downloadFile(url, filename) {
    var link = document.createElement('a');
    link.href = url;
    link.download = filename || 'download';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  alert: function alert(content, title) {
    vue_esm["a" /* default */].$vux.alert.show({
      title: title ? title : '温馨提示',
      content: content,
      onShow: function onShow() {
        console.log('Plugin: I\'m showing');
      },
      onHide: function onHide() {
        console.log('Plugin: I\'m hiding');
      }
    });
  },
  confirm: function confirm(content, title, callfun) {
    vue_esm["a" /* default */].$vux.confirm.show({
      title: title ? title : '温馨提示',
      content: content,
      onCancel: function onCancel() {
        console.log('Plugin: I\'m onCancel');
      },
      onConfirm: function onConfirm() {
        callfun ? callfun() : '';
        console.log('Plugin: I\'m onConfirm');
      }
    });
  },
  copy: function copy(_text, event, onSuccess, onError) {
    event = event || {};
    var clipboard = new clipboard_default.a(event.target, {
      text: function text() {
        return _text;
      }
    });
    clipboard.on('success', function () {
      onSuccess ? onSuccess() : vue_esm["a" /* default */].$vux.toast.text('已复制');
      clipboard.off('error');
      clipboard.off('success');
      clipboard.destroy();
    });
    clipboard.on('error', function () {
      onError ? onError() : vue_esm["a" /* default */].$vux.toast.text('复制失败');
      clipboard.off('error');
      clipboard.off('success');
      clipboard.destroy();
    });
    clipboard.onClick(event);
  },
  checkAuth: function checkAuth(val) {

    var publicAuth = ['upList', 'upCustomClothe'];
    if (publicAuth.indexOf(val) > -1) {
      return true;
    }
    if (src_customer.forceAuth && src_customer.forceAuth.indexOf(val) > -1) {
      return true;
    }
    if (this.getLocal('node_v1')) {
      var node = JSON.parse(this.getLocal('node_v1'));

      return node[val] ? true : false;
    }
  }
};
/* harmony default export */ var utils_func = (func_func);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/utils/request.js





/**
 * 封装axios，实现发送/响应接口的拦截，来实现统一提示等效果
 */

var service = axios_default.a.create({
  // baseURL: 'http://fcbrand.local.com/',
  baseURL: utils_func.getApiBaseURL(),
  timeout: 30000, // 请求超时时间限制
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', brand: utils_func.getBrandId(), token: utils_func.getLocal('token') },
  transformRequest: [function (data) {
    var ret = '';
    for (var it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    }
    return ret;
  }]
});

// 请求拦截器
service.interceptors.request.use(function (config) {
  // func.startLoading()
  config.headers.brand = utils_func.getBrandId();
  if (Object.prototype.hasOwnProperty.call(config.headers, 'scanToken')) {
    config.headers.token = '' + (config.headers.scanToken || '');
    delete config.headers.scanToken;
  } else {
    config.headers.token = '' + (utils_func.getLocal('token') || '');
  }
  if (!config.headers.sign) {
    var data = config.data || config.params;
    var params = {
      timestamp: Date.now(),
      nonce: generateNonce()
    };
    if (typeof data !== 'undefined') {
      for (var key in data) {
        params[key] = data[key];
      }
    }
    config.headers.timestamp = params.timestamp;
    config.headers.nonce = params.nonce;
    config.headers.sign = generateSHA256Sign(params);
  }
  return config;
}, function (err) {
  // func.endLoading()
  utils_func.showToast();
  promise_default.a.reject(err);
});

// 响应拦截器
service.interceptors.response.use(function (response) {
  // func.endLoading()
  console.log(response);
  if (response.status == 200) {
    if (!response.data.code || response.data.code == 2) {
      return response.data;
    } else {
      // func.endLoading();
      utils_func.showToast(response.data.msg);
      return false;
    }
  } else {
    utils_func.showToast('服务器跑丢了');
  }
}, function (err) {
  utils_func.showToast();
  return promise_default.a.reject(err);
});

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/utils/api.js


var api = {
  //openid登录
  login: function login(data) {
    return request({
      url: 'group/Account/login',
      method: 'post',
      data: data
    });
  },

  //退出
  out: function out(data) {
    return request({
      url: 'group/User/out',
      method: 'post',
      data: data
    });
  },

  //用户信息
  getInfo: function getInfo() {
    return request({
      url: 'group/User/info',
      method: 'get'
    });
  },

  //社区信息
  submitCommunity: function submitCommunity(data) {
    return request({
      url: 'group/User/submitCommunity',
      method: 'post',
      data: data
    });
  },

  //充值
  recharge: function recharge(data) {
    return request({
      url: 'group/User/recharge',
      method: 'post',
      data: data
    });
  },

  //充值
  submitStoreGoodsPrice: function submitStoreGoodsPrice(data) {
    return request({
      url: 'group/User/submitStoreGoodsPrice',
      method: 'post',
      data: data
    });
  },

  //下级门店加工价格
  storeGoodsPrice: function storeGoodsPrice(data) {
    return request({
      url: 'group/User/storeGoodsPrice',
      method: 'get',
      params: data
    });
  },

  //检测是否绑定社区
  checkCid: function checkCid() {
    return request({
      url: 'group/User/checkCid',
      method: 'get'
    });
  },

  //获取账号密码
  account: function account() {
    return request({
      url: 'group/User/account',
      method: 'get'
    });
  },

  //修改密码
  password: function password(data) {
    return request({
      url: 'group/User/password',
      method: 'post',
      data: data
    });
  },

  //获取权限配置
  getAccess: function getAccess() {
    return request({
      url: 'group/User/getAccess',
      method: 'post'
    });
  },
  miniUserList: function miniUserList(data) {
    return request({
      url: 'group/User/miniUserList',
      method: 'get',
      params: data
    });
  },
  miniUserTagOptions: function miniUserTagOptions(data) {
    return request({
      url: 'group/User/miniUserTagOptions',
      method: 'get',
      params: data
    });
  },
  saveMiniUserTags: function saveMiniUserTags(data) {
    return request({
      url: 'group/User/saveMiniUserTags',
      method: 'post',
      data: data
    });
  },

  //登录小区
  loginCommunity: function loginCommunity(data) {
    return request({
      url: 'group/Account/loginCommunity',
      method: 'post',
      data: data
    });
  },

  //切换门店
  selectCommunityStore: function selectCommunityStore(data) {
    return request({
      url: 'group/Account/selectCommunityStore',
      method: 'post',
      data: data
    });
  },

  //订单数量
  getOrderCount: function getOrderCount(data) {
    return request({
      url: 'group/User/getOrderCount',
      method: 'get',
      params: data
    });
  },

  //下级订单数量
  getSubOrderCount: function getSubOrderCount(data) {
    return request({
      url: 'group/User/getSubOrderCount',
      method: 'get',
      params: data
    });
  },

  //订单列表
  getOrderLists: function getOrderLists(data) {
    return request({
      url: 'group/User/getOrderLists',
      method: 'get',
      params: data
    });
  },

  //下级订单列表
  getSubOrderLists: function getSubOrderLists(data) {
    return request({
      url: 'group/User/getSubOrderLists',
      method: 'get',
      params: data
    });
  },

  //订单列表
  orderDetial: function orderDetial(data) {
    return request({
      url: 'group/User/orderDetial',
      method: 'get',
      params: data
    });
  },

  //修改上门时间
  editHomeTime: function editHomeTime(data) {
    return request({
      url: 'group/User/editHomeTime',
      method: 'post',
      data: data
    });
  },

  //扫码签名
  wxSign: function wxSign(data) {
    return request({
      url: 'group/User/wxSign',
      method: 'get',
      params: data
    });
  },

  //确认收衣
  collect: function collect(data) {
    return request({
      url: 'group/User/collect',
      method: 'post',
      data: data
    });
  },

  //获取入库订单
  getOrder: function getOrder(data) {
    return request({
      url: 'group/User/getOrder',
      method: 'get',
      params: data
    });
  },

  //商品入库
  factoryHouse: function factoryHouse(data) {
    return request({
      url: 'group/User/factoryHouse',
      method: 'post',
      data: data
    });
  },

  //订单入库
  wareHouse: function wareHouse(data) {
    return request({
      url: 'group/User/wareHouse',
      method: 'post',
      data: data
    });
  },

  //出库订单
  getOutOrder: function getOutOrder(data) {
    return request({
      url: 'group/User/getOutOrder',
      method: 'get',
      params: data
    });
  },

  //出库
  outHouse: function outHouse(data) {
    return request({
      url: 'group/User/outHouse',
      method: 'post',
      data: data
    });
  },

  //状态改变
  changeStatus: function changeStatus(data) {
    return request({
      url: 'group/User/changeStatus',
      method: 'post',
      data: data
    });
  },

  //获取师傅
  getWorker: function getWorker(data) {
    return request({
      url: 'group/User/getWorker',
      method: 'get',
      params: data
    });
  },

  //查看评价
  getComment: function getComment(data) {
    return request({
      url: 'group/User/getComment',
      method: 'get',
      params: data
    });
  },

  //收益明细
  orderRebate: function orderRebate(data) {
    return request({
      url: 'group/User/orderRebate',
      method: 'get',
      params: data
    });
  },

  //提现金额
  withdrawMoney: function withdrawMoney(data) {
    return request({
      url: 'group/User/withdrawMoney',
      method: 'post',
      data: data
    });
  },

  //可提现记录
  withdrawList: function withdrawList(data) {
    return request({
      url: 'group/User/withdrawList',
      method: 'get',
      params: data
    });
  },

  //中转仓可提现
  warehouseWithdrawList: function warehouseWithdrawList(data) {
    return request({
      url: 'group/User/warehouseWithdrawList',
      method: 'get',
      params: data
    });
  },

  //提现记录
  withdrawRecord: function withdrawRecord(data) {
    return request({
      url: 'group/User/withdrawRecord',
      method: 'get',
      params: data
    });
  },

  //提现申请
  submitWithdraw: function submitWithdraw(data) {
    return request({
      url: 'group/User/submitWithdraw',
      method: 'post',
      data: data
    });
  },

  //余额变动记录
  balanceList: function balanceList(data) {
    return request({
      url: 'group/User/balanceList',
      method: 'get',
      params: data
    });
  },

  //团长收益
  groupRebate: function groupRebate(data) {
    return request({
      url: 'group/User/groupRebate',
      method: 'get',
      params: data || {}
    });
  },

  //获取小区
  getCommunity: function getCommunity(data) {
    return request({
      url: 'group/User/getCommunity',
      params: data
    });
  },
  getCityShopInfo: function getCityShopInfo(data) {
    return request({
      url: 'group/User/getInfo',
      params: data
    });
  },
  cityShopMap: function cityShopMap(data) {
    return request({
      url: 'group/User/cityShopMap',
      params: data
    });
  },
  shopList: function shopList(data) {
    return request({
      url: 'group/User/shopList',
      params: data
    });
  },
  factoryOrder: function factoryOrder(data) {
    return request({
      url: 'group/User/factoryOrder',
      params: data
    });
  },
  diffPrice: function diffPrice(data) {
    return request({
      url: 'group/User/diffPrice',
      method: 'post',
      data: data
    });
  },

  //社区所有操作员
  communityOperater: function communityOperater() {
    return request({
      url: 'group/User/communityOperater'
    });
  },

  //小区收衣数据
  communityData: function communityData(data) {
    return request({
      url: 'group/User/communityData',
      params: data
    });
  },

  //呼叫跑腿配送
  uuptOrder: function uuptOrder(data) {
    return request({
      url: 'group/User/uuptOrder',
      method: 'post',
      data: data
    });
  },

  //取消跑腿配送
  cancelUuptOrder: function cancelUuptOrder(data) {
    return request({
      url: 'group/User/cancelUuptOrder',
      method: 'post',
      data: data
    });
  },
  storeApply: function storeApply(data) {
    return request({
      url: 'group/Account/storeApply',
      method: 'post',
      data: data
    });
  },
  problem: function problem(data) {
    return request({
      url: 'group/User/problem',
      method: 'post',
      data: data
    });
  },

  // wxSign1(data){
  //   return request({
  //     url: 'group/User/wxSign1',
  //     method: 'get',
  //     params:data
  //   })
  // },
  uploadsImg: function uploadsImg(data) {
    return request({
      url: 'group/User/uploadsImg',
      method: 'post',
      data: data
    });
  },

  //我的下级
  myInvite: function myInvite(data) {
    return request({
      url: 'group/User/myInvite',
      method: 'get',
      params: data
    });
  },

  //我的推广
  inviteUser: function inviteUser(data) {
    return request({
      url: 'group/User/inviteUser',
      method: 'get',
      params: data
    });
  },

  //二级BD
  getSecondBd: function getSecondBd(data) {
    return request({
      url: 'group/User/getSecondBd',
      method: 'get',
      params: data
    });
  },

  //编辑二级BD
  submitSecondBd: function submitSecondBd(data) {
    return request({
      url: 'group/User/submitSecondBd',
      method: 'post',
      data: data
    });
  },

  //组员推广
  groupInvite: function groupInvite(data) {
    return request({
      url: 'group/User/groupInvite',
      method: 'get',
      params: data
    });
  },

  //下级团长添加
  submitSecondCommunity: function submitSecondCommunity(data) {
    return request({
      url: 'group/User/submitSecondCommunity',
      method: 'post',
      data: data
    });
  },

  //下级团长
  getSecondCommunity: function getSecondCommunity(data) {
    return request({
      url: 'group/User/getSecondCommunity',
      method: 'get',
      params: data
    });
  },

  //下级团长收益
  secondCommunityReward: function secondCommunityReward(data) {
    return request({
      url: 'group/User/secondCommunityReward',
      method: 'get',
      params: data
    });
  },

  //拜访记录
  visit: function visit(data) {
    return request({
      url: 'group/User/visit',
      method: 'get',
      params: data
    });
  },

  //新增拜访记录
  submitVisit: function submitVisit(data) {
    return request({
      url: 'group/User/submitVisit',
      method: 'post',
      data: data
    });
  },

  //拜访标签
  visitLabels: function visitLabels(data) {
    return request({
      url: 'group/User/visitLabels',
      method: 'get',
      params: data
    });
  },

  //收入统计
  countReward: function countReward(data) {
    return request({
      url: 'group/User/countReward',
      method: 'get',
      params: data
    });
  },

  //获取小程序码
  qrcode: function qrcode() {
    return request({
      url: 'group/User/qrcode',
      method: 'get'
    });
  },

  //超时订单
  outTimeOrder: function outTimeOrder(data) {
    return request({
      url: 'group/User/outTimeOrder',
      method: 'get',
      params: data
    });
  },

  //下级超时订单
  suboutTimeOrder: function suboutTimeOrder(data) {
    return request({
      url: 'group/User/suboutTimeOrder',
      method: 'get',
      params: data
    });
  },


  //商品搜索
  searchProduct: function searchProduct(data) {
    return request({
      url: 'group/Product/searchProduct',
      method: 'get',
      params: data
    });
  },

  //分类
  category: function category() {
    return request({
      url: 'group/Product/category',
      method: 'get'
    });
  },

  //添加商品
  submitProduct: function submitProduct(data) {
    return request({
      url: 'group/Product/submitProduct',
      method: 'post',
      data: data
    });
  },

  //修改扎代码
  editBag: function editBag(data) {
    return request({
      url: 'group/User/editBag',
      method: 'post',
      data: data
    });
  },

  //商品列表
  productList: function productList(data) {
    return request({
      url: 'group/Product/productList',
      method: 'get',
      params: data
    });
  },

  //商品详情
  productDetial: function productDetial(data) {
    return request({
      url: 'group/Product/productDetial',
      method: 'get',
      params: data
    });
  },

  //商品详情
  changeProductStatus: function changeProductStatus(data) {
    return request({
      url: 'group/Product/changeProductStatus',
      method: 'post',
      data: data
    });
  },

  //工单分类
  workCategory: function workCategory(data) {
    return request({
      url: 'group/Work/category',
      method: 'get',
      params: data
    });
  },

  //提交工单
  submitWork: function submitWork(data) {
    return request({
      url: 'group/Work/submitWork',
      method: 'post',
      data: data
    });
  },

  //工单统计
  workCount: function workCount(data) {
    return request({
      url: 'group/Work/workCount',
      method: 'get',
      params: data
    });
  },

  //工单列表
  workOrder: function workOrder(data) {
    return request({
      url: 'group/Work/workOrder',
      method: 'get',
      params: data
    });
  },

  //工单详情
  workOrderInfo: function workOrderInfo(data) {
    return request({
      url: 'group/Work/workOrderInfo',
      method: 'get',
      params: data
    });
  },

  //工单处理办法
  submitSolution: function submitSolution(data) {
    return request({
      url: 'group/Work/submitSolution',
      method: 'post',
      data: data
    });
  },

  //工单处理标签
  workLabels: function workLabels(data) {
    return request({
      url: 'group/Work/labels',
      method: 'get',
      params: data
    });
  },

  //工单回复
  submitWorkReply: function submitWorkReply(data) {
    return request({
      url: 'group/Work/submitWorkReply',
      method: 'post',
      data: data
    });
  },

  //获取工单回复
  workOrderReply: function workOrderReply(data) {
    return request({
      url: 'group/Work/workOrderReply',
      method: 'get',
      params: data
    });
  },

  //客服接收快捷回复
  quickReply: function quickReply() {
    return request({
      url: 'group/Work/quickReply',
      method: 'get'
    });
  },

  //工单状态
  changeWorkStatus: function changeWorkStatus(data) {
    return request({
      url: 'group/Work/changeWorkStatus',
      method: 'post',
      data: data
    });
  },

  //衣物状态
  clotheStatus: function clotheStatus(data) {
    return request({
      url: 'group/Work/clotheStatus',
      method: 'get',
      params: data
    });
  },

  //门店列表
  store: function store() {
    return request({
      url: 'group/Work/store',
      method: 'get'
    });
  },

  //客服列表
  getService: function getService() {
    return request({
      url: 'group/Work/service',
      method: 'get'
    });
  },

  //分配客服
  assignService: function assignService(data) {
    return request({
      url: 'group/Work/assignService',
      method: 'post',
      data: data
    });
  },

  //司机
  driverList: function driverList(data) {
    return request({
      url: 'group/driver/driverList',
      method: 'get',
      params: data
    });
  },

  //编辑司机
  submitDriver: function submitDriver(data) {
    return request({
      url: 'group/driver/submitDriver',
      method: 'post',
      data: data
    });
  },

  //待取件
  waitPickup: function waitPickup(data) {
    return request({
      url: 'group/driver/waitPickup',
      method: 'get',
      params: data
    });
  },

  //取件
  pickup: function pickup(data) {
    return request({
      url: 'group/driver/pickup',
      method: 'post',
      data: data
    });
  },

  //出厂订单
  getFactoryOrder: function getFactoryOrder(data) {
    return request({
      url: 'group/driver/getFactoryOrder',
      method: 'get',
      params: data
    });
  },
  getExpressOrder: function getExpressOrder(data) {
    return request({
      url: 'group/driver/getExpressOrder',
      method: 'get',
      params: data
    });
  },

  //快递下单
  submitExpress: function submitExpress(data) {
    return request({
      url: 'group/driver/submitExpress',
      method: 'post',
      data: data
    });
  },
  submitFactory: function submitFactory(data) {
    return request({
      url: 'group/driver/submitFactory',
      method: 'post',
      data: data
    });
  },

  //商品配送提交
  submitDelivery: function submitDelivery(data) {
    return request({
      url: 'group/driver/submitDelivery',
      method: 'post',
      data: data
    });
  },

  //物流统计
  driverData: function driverData(data) {
    return request({
      url: 'group/driver/driverData',
      method: 'get',
      params: data
    });
  },

  //物流统计2
  driverData2: function driverData2(data) {
    return request({
      url: 'group/driver/driverData2',
      method: 'get',
      params: data
    });
  },

  //已取件
  pickuped: function pickuped(data) {
    return request({
      url: 'group/driver/pickuped',
      method: 'get',
      params: data
    });
  },

  //已到站
  arrivaled: function arrivaled(data) {
    return request({
      url: 'group/driver/arrivaled',
      method: 'get',
      params: data
    });
  },

  //上挂
  up: function up(data) {
    return request({
      url: 'group/Record/up',
      method: 'post',
      data: data
    });
  },
  lightUpStrip: function lightUpStrip(data) {
    return request({
      url: 'group/Record/lightUpStrip',
      method: 'post',
      data: data
    });
  },

  //待取详情
  waitPickupInfo: function waitPickupInfo(data) {
    return request({
      url: 'group/driver/waitPickupInfo',
      method: 'get',
      params: data
    });
  },

  //待入厂
  waitInFactory: function waitInFactory(data) {
    return request({
      url: 'group/factorys/waitInFactory',
      method: 'get',
      params: data
    });
  },
  backwash: function backwash(data) {
    return request({
      url: 'group/factorys/backwash',
      method: 'get',
      params: data
    });
  },
  inFactory: function inFactory(data) {
    return request({
      url: 'group/factorys/inFactory',
      method: 'post',
      data: data
    });
  },
  factoryData: function factoryData(data) {
    return request({
      url: 'group/factorys/factoryData',
      method: 'get',
      params: data
    });
  },
  barOrder: function barOrder(data) {
    return request({
      url: 'group/factorys/barOrder',
      method: 'get',
      params: data
    });
  },
  searchOrder: function searchOrder(data) {
    return request({
      url: 'group/factorys/searchOrder',
      method: 'get',
      params: data
    });
  },
  alliInFactory: function alliInFactory(data) {
    return request({
      url: 'group/factorys/alliInFactory',
      method: 'post',
      data: data
    });
  },

  //不洗退回
  factoryBack: function factoryBack(data) {
    return request({
      url: 'group/factorys/factoryBack',
      method: 'post',
      data: data
    });
  },
  getProductOrder: function getProductOrder(data) {
    return request({
      url: 'group/user/getProductOrder',
      method: 'get',
      params: data
    });
  },
  submitProductQrcode: function submitProductQrcode(data) {
    return request({
      url: 'group/user/submitProductQrcode',
      method: 'post',
      data: data
    });
  },
  getUser: function getUser(data) {
    return request({
      url: 'group/user/getUser',
      method: 'get',
      params: data
    });
  },
  submitActive: function submitActive(data) {
    return request({
      url: 'group/user/submitActive',
      method: 'post',
      data: data
    });
  },

  //昨天出厂
  yesterdayOutFactory: function yesterdayOutFactory(data) {
    return request({
      url: 'group/user/yesterdayOutFactory',
      method: 'get',
      params: data
    });
  },

  //历史出厂未到店
  outFactoryList: function outFactoryList(data) {
    return request({
      url: 'group/user/outFactoryList',
      method: 'get',
      params: data
    });
  },

  //历史已回店
  historyBackStore: function historyBackStore(data) {
    return request({
      url: 'group/user/historyBackStore',
      method: 'get',
      params: data
    });
  },

  //扫回店
  backStore: function backStore(data) {
    return request({
      url: 'group/user/backStore',
      method: 'post',
      data: data
    });
  },

  //录单查代码查询
  getRecordOrder: function getRecordOrder(data) {
    return request({
      url: 'group/Record/getOrder',
      method: 'get',
      params: data
    });
  },

  //录单扎代码查询
  submitRecord: function submitRecord(data) {
    return request({
      url: 'group/Record/submitRecord',
      method: 'post',
      data: data
    });
  },

  //录单记录
  washCode: function washCode(data) {
    return request({
      url: 'group/Record/washCode',
      method: 'get',
      params: data
    });
  },

  //上挂列表
  upList: function upList(data) {
    return request({
      url: 'group/Record/upList',
      method: 'get',
      params: data
    });
  },

  //录单查代码查询
  uploadsImgOss: function uploadsImgOss(data) {
    return request({
      url: 'group/User/uploadsImgOss',
      method: 'post',
      data: data
    });
  },

  //送洗
  sendFactory: function sendFactory(data) {
    return request({
      url: 'group/Record/submitFactory',
      method: 'post',
      data: data
    });
  },

  //送洗工厂
  getFactory: function getFactory(data) {
    return request({
      url: 'group/Record/getFactory',
      method: 'get',
      params: data
    });
  },

  //顾客取衣
  waitPick: function waitPick(data) {
    return request({
      url: 'group/Record/waitPick',
      method: 'get',
      params: data
    });
  },

  //顾客取衣
  pickClothe: function pickClothe(data) {
    return request({
      url: 'group/Record/pick',
      method: 'post',
      data: data
    });
  },

  //附件补录
  getAnnex: function getAnnex(data) {
    return request({
      url: 'group/Record/annex',
      method: 'get',
      params: data
    });
  },


  //附件补录
  submitAnnex: function submitAnnex(data) {
    return request({
      url: 'group/Record/submitAnnex',
      method: 'post',
      data: data
    });
  },


  //获取同订单录单数据
  getWashCode: function getWashCode(data) {
    return request({
      url: 'group/Record/getWashCode',
      method: 'get',
      params: data
    });
  },

  //撤单
  cancelRecord: function cancelRecord(data) {
    return request({
      url: 'group/Record/cancelOrder',
      method: 'post',
      data: data
    });
  },


  //获取进出厂数据
  getInOutFactoryData: function getInOutFactoryData(data) {
    return request({
      url: 'group/Home/getInOutFactoryData',
      method: 'get',
      params: data
    });
  },

  //获取进出厂门店数据
  getInOutFactoryCommunity: function getInOutFactoryCommunity(data) {
    return request({
      url: 'group/Home/community',
      method: 'get',
      params: data
    });
  },

  //异常衣物类型
  abnormal: function abnormal(data) {
    return request({
      url: 'group/Home/abnormal',
      method: 'get',
      params: data
    });
  },

  //异常衣物报备
  submitAbnormal: function submitAbnormal(data) {
    return request({
      url: 'group/factorys/submitAbnormal',
      method: 'post',
      data: data
    });
  },

  //优惠券
  communityCoupon: function communityCoupon(data) {
    return request({
      url: 'group/user/communityCoupon',
      method: 'get',
      params: data
    });
  },

  //社区用户
  getCommunityUser: function getCommunityUser(data) {
    return request({
      url: 'group/user/getCommunityUser',
      method: 'get',
      params: data
    });
  },

  //社区用户
  giveCoupon: function giveCoupon(data) {
    return request({
      url: 'group/user/giveCoupon',
      method: 'post',
      data: data
    });
  },

  //社区用户
  subQrCoupon: function subQrCoupon(data) {
    return request({
      url: 'group/user/subQrCoupon',
      method: 'post',
      data: data
    });
  },

  //社区用户
  goodsCount: function goodsCount(data) {
    return request({
      url: 'group/user/goodsCount',
      method: 'get',
      params: data
    });
  },

  //社区用户
  goodsAmountCount: function goodsAmountCount(data) {
    return request({
      url: 'group/user/goodsAmountCount',
      method: 'get',
      params: data
    });
  },

  //社区用户
  goodsGroupCount: function goodsGroupCount(data) {
    return request({
      url: 'group/user/goodsGroupCount',
      method: 'get',
      params: data
    });
  },

  //社区用户
  goodsCountExport: function goodsCountExport(data) {
    return request({
      url: 'group/user/goodsCountExport',
      method: 'get',
      params: data
    });
  },

  //社区用户
  goodsAmountCountExport: function goodsAmountCountExport(data) {
    return request({
      url: 'group/user/goodsAmountCountExport',
      method: 'get',
      params: data
    });
  },

  //社区用户
  goodsGroupCountExport: function goodsGroupCountExport(data) {
    return request({
      url: 'group/user/goodsGroupCountExport',
      method: 'get',
      params: data
    });
  },

  //会员统计
  getCountMember: function getCountMember(data) {
    return request({
      url: 'group/user/getCountMember',
      method: 'get',
      params: data
    });
  },

  //会员统计
  cardMember: function cardMember(data) {
    return request({
      url: 'group/user/cardMember',
      method: 'get',
      params: data
    });
  },
  clothesConfirmList: function clothesConfirmList(data) {
    return request({
      url: 'group/user/clothesConfirmList',
      method: 'get',
      params: data
    });
  },
  clothesConfirmInfo: function clothesConfirmInfo(data) {
    return request({
      url: 'group/user/clothesConfirmInfo',
      method: 'get',
      params: data
    });
  },
  submitClothesConfirm: function submitClothesConfirm(data) {
    return request({
      url: 'group/user/submitClothesConfirm',
      method: 'post',
      data: data
    });
  },
  submitClothesConfirmPush: function submitClothesConfirmPush(data) {
    return request({
      url: 'group/user/submitClothesConfirmPush',
      method: 'post',
      data: data
    });
  },
  submitClothesConfirmContent: function submitClothesConfirmContent(data) {
    return request({
      url: 'group/user/submitClothesConfirmContent',
      method: 'post',
      data: data
    });
  },
  getDouYinOrder: function getDouYinOrder(data) {
    return request({
      url: 'group/user/getDouYinOrder',
      method: 'get',
      params: data
    });
  },
  getDouYinOrderNew: function getDouYinOrderNew(data) {
    return request({
      url: 'group/user/getDouYinOrderNew',
      method: 'get',
      params: data
    });
  },
  douYinVerify: function douYinVerify(data) {
    return request({
      url: 'group/user/douYinVerify',
      method: 'post',
      data: data
    });
  },
  douYinVerifyNew: function douYinVerifyNew(data) {
    return request({
      url: 'group/user/douYinVerifyNew',
      method: 'post',
      data: data
    });
  },
  exportWashCode: function exportWashCode(data) {
    return request({
      url: 'group/user/exportWashCode',
      method: 'post',
      data: data
    });
  },
  editWashCode: function editWashCode(data) {
    return request({
      url: 'group/user/editWashCode',
      method: 'post',
      data: data
    });
  },

  //获取上一条用户信息
  getLastUserInfo: function getLastUserInfo(data) {
    return request({
      url: 'group/Record/getLastUserInfo',
      method: 'get',
      params: data
    });
  },
  searchFactoryUsers: function searchFactoryUsers(data) {
    return request({
      url: 'group/Record/searchFactoryUsers',
      method: 'get',
      params: data
    });
  },
  getClotheCount: function getClotheCount(data) {
    return request({
      url: 'group/Record/getClotheCount',
      method: 'get',
      params: data
    });
  },
  operatePhoto: function operatePhoto(data) {
    return request({
      url: 'group/Record/operatePhoto',
      method: 'post',
      data: data
    });
  },
  bindBox: function bindBox(data) {
    return request({
      url: 'group/user/bindBox',
      method: 'post',
      data: data
    });
  },
  unbindBox: function unbindBox(data) {
    return request({
      url: 'group/user/unbindBox',
      method: 'post',
      data: data
    });
  },
  getBoxList: function getBoxList(data) {
    return request({
      url: 'group/user/getBoxList',
      method: 'get',
      params: data
    });
  },
  qrcodeBox: function qrcodeBox(data) {
    return request({
      url: 'group/user/qrcodeBox',
      method: 'get',
      params: data
    });
  },
  getCurtainGoods: function getCurtainGoods(data) {
    return request({
      url: 'group/curtain/getCurtainGoods',
      method: 'get',
      params: data
    });
  },
  submitCurtainGoods: function submitCurtainGoods(data) {
    return request({
      url: 'group/curtain/submitCurtainGoods',
      method: 'post',
      data: data
    });
  },
  changeCurtainGoodsStatus: function changeCurtainGoodsStatus(data) {
    return request({
      url: 'group/curtain/changeCurtainGoodsStatus',
      method: 'post',
      data: data
    });
  },
  submitCurtainOrder: function submitCurtainOrder(data) {
    return request({
      url: 'group/curtain/submitCurtainOrder',
      method: 'post',
      data: data
    });
  },
  curtainDiffVerify: function curtainDiffVerify(data) {
    return request({
      url: 'group/curtain/curtainDiffVerify',
      method: 'post',
      data: data
    });
  },
  getCurtainOrder: function getCurtainOrder(data) {
    return request({
      url: 'group/curtain/getCurtainOrder',
      method: 'get',
      params: data
    });
  },
  getCurtainOrderInfo: function getCurtainOrderInfo(data) {
    return request({
      url: 'group/curtain/getCurtainOrderInfo',
      method: 'get',
      params: data
    });
  },
  getCurtainGroup: function getCurtainGroup(data) {
    return request({
      url: 'group/curtain/getCurtainGroup',
      method: 'get',
      params: data
    });
  },
  getCurtainWorker: function getCurtainWorker(data) {
    return request({
      url: 'group/curtain/getCurtainWorker',
      method: 'get',
      params: data
    });
  },
  changeCurtainStatus: function changeCurtainStatus(data) {
    return request({
      url: 'group/curtain/changeCurtainStatus',
      method: 'post',
      data: data
    });
  },
  curtainGrabOrder: function curtainGrabOrder(data) {
    return request({
      url: 'group/curtain/curtainGrabOrder',
      method: 'post',
      data: data
    });
  },
  curtainComment: function curtainComment(data) {
    return request({
      url: 'group/curtain/curtainComment',
      method: 'post',
      data: data
    });
  },
  curtainEditHomeTime: function curtainEditHomeTime(data) {
    return request({
      url: 'group/curtain/curtainEditHomeTime',
      method: 'post',
      data: data
    });
  },
  curtainPayStatus: function curtainPayStatus(data) {
    return request({
      url: 'group/curtain/curtainPayStatus',
      method: 'post',
      data: data
    });
  },
  getCurtainOrderCount: function getCurtainOrderCount(data) {
    return request({
      url: 'group/curtain/getCurtainOrderCount',
      method: 'get',
      params: data
    });
  },
  curtainOrderLog: function curtainOrderLog(data) {
    return request({
      url: 'group/curtain/curtainOrderLog',
      method: 'get',
      params: data
    });
  },
  resetCurtainOrder: function resetCurtainOrder(data) {
    return request({
      url: 'group/curtain/resetCurtainOrder',
      method: 'post',
      data: data
    });
  },
  cancelCurtainOrder: function cancelCurtainOrder(data) {
    return request({
      url: 'group/curtain/cancelCurtainOrder',
      method: 'post',
      data: data
    });
  },
  submitCurtainUpload: function submitCurtainUpload(data) {
    return request({
      url: 'group/curtain/submitCurtainUpload',
      method: 'post',
      data: data
    });
  },
  curtainSort: function curtainSort(data) {
    return request({
      url: 'group/curtain/curtainSort',
      method: 'post',
      data: data
    });
  },
  getCurtainOrderDateCount: function getCurtainOrderDateCount(data) {
    return request({
      url: 'group/curtain/getCurtainOrderDateCount',
      method: 'get',
      params: data
    });
  },
  getCurtainOrderPayCount: function getCurtainOrderPayCount(data) {
    return request({
      url: 'group/curtain/getCurtainOrderPayCount',
      method: 'get',
      params: data
    });
  },
  getWorkerList: function getWorkerList(data) {
    return request({
      url: 'group/curtain/getWorkerList',
      method: 'get',
      params: data
    });
  },
  getCurtainMapOrder: function getCurtainMapOrder(data) {
    return request({
      url: 'group/curtain/getCurtainMapOrder',
      method: 'get',
      params: data
    });
  },
  changeCurtainWorkerStatus: function changeCurtainWorkerStatus(data) {
    return request({
      url: 'group/curtain/changeWorkerStatus',
      method: 'post',
      data: data
    });
  },
  curtainAddWorker: function curtainAddWorker(data) {
    return request({
      url: 'group/curtain/curtainAddWorker',
      method: 'post',
      data: data
    });
  },
  curtainDeleteWorker: function curtainDeleteWorker(data) {
    return request({
      url: 'group/curtain/curtainDeleteWorker',
      method: 'post',
      data: data
    });
  },
  curtainReward: function curtainReward(data) {
    return request({
      url: 'group/curtain/curtainReward',
      method: 'post',
      data: data
    });
  },
  curtainRemark: function curtainRemark(data) {
    return request({
      url: 'group/curtain/curtainRemark',
      method: 'post',
      data: data
    });
  },

  //其他衣物上挂
  upCustomClothe: function upCustomClothe(data) {
    return request({
      url: 'group/record/upCustomClothe',
      method: 'post',
      data: data
    });
  },
  deviceType: function deviceType(data) {
    return request({
      url: 'group/device/deviceType',
      method: 'get',
      params: data
    });
  },
  bindDevice: function bindDevice(data) {
    return request({
      url: 'group/device/bindDevice',
      method: 'post',
      data: data
    });
  },
  delDevice: function delDevice(data) {
    return request({
      url: 'group/device/delDevice',
      method: 'post',
      data: data
    });
  },
  getDeviceList: function getDeviceList(data) {
    return request({
      url: 'group/device/getDeviceList',
      method: 'get',
      params: data
    });
  },
  getDeviceInfo: function getDeviceInfo(data) {
    return request({
      url: 'group/device/getDeviceInfo',
      method: 'get',
      params: data
    });
  },
  qrcodeDevice: function qrcodeDevice(data) {
    return request({
      url: 'group/device/qrcodeDevice',
      method: 'post',
      data: data
    });
  },
  deviceSetting: function deviceSetting(data) {
    return request({
      url: 'group/device/deviceSetting',
      method: 'post',
      data: data
    });
  },
  deviceOperate: function deviceOperate(data) {
    return request({
      url: 'group/device/deviceOperate',
      method: 'post',
      data: data
    });
  },
  operateLightUp: function operateLightUp(data) {
    return request({
      url: 'group/device/operateLightUp',
      method: 'post',
      data: data
    });
  },
  pickList: function pickList(data) {
    return request({
      url: 'group/record/pickList',
      method: 'get',
      params: data
    });
  },
  airConditionerModels: function airConditionerModels(data) {
    return request({
      url: 'group/device/airConditionerModels',
      method: 'get',
      params: data
    });
  },
  airSetTemperature: function airSetTemperature(data) {
    return request({
      url: 'group/device/airSetTemperature',
      method: 'post',
      data: data
    });
  },
  airPairControl: function airPairControl(data) {
    return request({
      url: 'group/device/airPairControl',
      method: 'post',
      data: data
    });
  },
  airSaveModelCode: function airSaveModelCode(data) {
    return request({
      url: 'group/device/airSaveModelCode',
      method: 'post',
      data: data
    });
  },
  changeDeviceStatus: function changeDeviceStatus(data) {
    return request({
      url: 'group/device/changeDeviceStatus',
      method: 'post',
      data: data
    });
  },
  withdrawAuthorization: function withdrawAuthorization(data) {
    return request({
      url: 'group/User/withdrawAuthorization',
      method: 'post',
      data: data
    });
  },
  bindWithdrawAuthorization: function bindWithdrawAuthorization(data) {
    return request({
      url: 'group/User/bindWithdrawAuthorization',
      method: 'post',
      data: data
    });
  },
  pickupOrder: function pickupOrder(data) {
    return request({
      url: 'group/User/pickupOrder',
      method: 'get',
      params: data
    });
  },
  getWaybillWashOrderList: function getWaybillWashOrderList(data) {
    return request({
      url: 'group/User/getWaybillWashOrderList',
      method: 'get',
      params: data
    });
  },
  getUserWaitCollectOrderList: function getUserWaitCollectOrderList(data) {
    return request({
      url: 'group/User/getUserWaitCollectOrderList',
      method: 'get',
      params: data
    });
  },
  getUserCollectOrder: function getUserCollectOrder(data) {
    return request({
      url: 'group/User/getUserCollectOrder',
      method: 'post',
      data: data
    });
  },
  searchCollectWashUsers: function searchCollectWashUsers(data) {
    return request({
      url: 'group/User/searchCollectWashUsers',
      method: 'get',
      params: data
    });
  },
  getCollectWashUserGoods: function getCollectWashUserGoods(data) {
    return request({
      url: 'group/User/getCollectWashUserGoods',
      method: 'get',
      params: data
    });
  },
  getCollectWashSelectedOrders: function getCollectWashSelectedOrders(data) {
    return request({
      url: 'group/User/getCollectWashSelectedOrders',
      method: 'post',
      data: data
    });
  },
  queryExpress: function queryExpress(data) {
    return request({
      url: 'group/User/queryExpress',
      method: 'get',
      params: data
    });
  },
  communityUp: function communityUp(data) {
    return request({
      url: 'group/User/communityUp',
      method: 'post',
      data: data
    });
  },
  getWaybillOrderList: function getWaybillOrderList(data) {
    return request({
      url: 'group/factorys/getWaybillOrderList',
      method: 'get',
      params: data
    });
  },
  getWaybillOrderCount: function getWaybillOrderCount(data) {
    return request({
      url: 'group/factorys/getWaybillOrderCount',
      method: 'get',
      params: data
    });
  },
  sendWaybillOrder: function sendWaybillOrder(data) {
    return request({
      url: 'group/factorys/sendWaybillOrder',
      method: 'post',
      data: data
    });
  },
  waitWaybillCode: function waitWaybillCode(data) {
    return request({
      url: 'group/factorys/waitWaybillCode',
      method: 'get',
      params: data
    });
  },
  sendWaybillCode: function sendWaybillCode(data) {
    return request({
      url: 'group/factorys/sendWaybillCode',
      method: 'post',
      data: data
    });
  },
  getWaybillCodeCount: function getWaybillCodeCount(data) {
    return request({
      url: 'group/factorys/getWaybillCodeCount',
      method: 'get',
      params: data
    });
  },
  getCodeInfo: function getCodeInfo(data) {
    return request({
      url: 'group/factorys/getCodeInfo',
      method: 'get',
      params: data
    });
  },
  waybillCodeList: function waybillCodeList(data) {
    return request({
      url: 'group/factorys/waybillCodeList',
      method: 'get',
      params: data
    });
  },
  cancelWaybillOrder: function cancelWaybillOrder(data) {
    return request({
      url: 'group/factorys/cancelWaybillOrder',
      method: 'post',
      data: data
    });
  },
  getWashCategoryGoods: function getWashCategoryGoods(data) {
    return request({
      url: 'group/User/getWashCategoryGoods',
      method: 'get',
      params: data
    });
  },
  createWashOrder: function createWashOrder(data) {
    return request({
      url: 'group/User/createWashOrder',
      method: 'post',
      data: data
    });
  },
  payWaybillWashOrder: function payWaybillWashOrder(data) {
    return request({
      url: 'group/User/payWaybillWashOrder',
      method: 'post',
      data: data
    });
  },
  changeOrderParentStatus: function changeOrderParentStatus(data) {
    return request({
      url: 'group/User/changeOrderParentStatus',
      method: 'post',
      data: data
    });
  },
  scanLogin: function scanLogin(data) {
    return request({
      url: 'group/Account/login',
      method: 'post',
      data: data
    });
  },
  scanInfo: function scanInfo(token) {
    return request({
      url: 'group/Scan/info',
      method: 'get',
      headers: { scanToken: token }
    });
  },
  scanBanner: function scanBanner(data, token) {
    return request({
      url: 'group/Scan/getBanner',
      method: 'get',
      params: data,
      headers: { scanToken: token }
    });
  },
  scanOpenLock: function scanOpenLock(data, token) {
    return request({
      url: 'group/Scan/openLock',
      method: 'get',
      params: data,
      headers: { scanToken: token }
    });
  },
  scanOpenLockCallback: function scanOpenLockCallback(data, token) {
    return request({
      url: 'group/Scan/openLockCallback',
      method: 'get',
      params: data,
      headers: { scanToken: token }
    });
  },
  scanWaitPick: function scanWaitPick(data, token) {
    return request({
      url: 'group/Scan/waitPick',
      method: 'get',
      params: data,
      headers: { scanToken: token }
    });
  },
  scanPick: function scanPick(data, token) {
    return request({
      url: 'group/Scan/pick',
      method: 'post',
      data: data,
      headers: { scanToken: token }
    });
  }
};
/* harmony default export */ var utils_api = (api);
// EXTERNAL MODULE: ./node_modules/vue-infinite-scroll/vue-infinite-scroll.js
var vue_infinite_scroll = __webpack_require__("bqTm");
var vue_infinite_scroll_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_scroll);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import VueRouter from 'vue-router'


// import less from 'less'



// import './css/public.less';




// Vue.use(less);
vue_esm["a" /* default */].use(vue_infinite_scroll_default.a);
vue_esm["a" /* default */].prototype.$api = utils_api;
vue_esm["a" /* default */].prototype.$func = utils_func;
vue_esm["a" /* default */].prototype.$customer = src_customer;
vue_esm["a" /* default */].prototype.$customerAsset = function (name, fallback) {
  return src_customer.assets && src_customer.assets[name] || fallback || '';
};
fastclick_default.a.attach(document.body);
document.body.className = (document.body.className ? document.body.className + ' ' : '') + 'theme-' + src_customer.theme + ' customer-' + src_customer.key;
if (false) {
  var devCustomerKey = 'dev_customer';
  var devTokenKey = 'dev_token_' + customer.key;
  var savedCustomer = func.getLocal(devCustomerKey);
  var testToken = process.env.TEST_TOKEN;
  var localToken = func.getLocal('token');

  if (savedCustomer && savedCustomer !== customer.key) {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('grade');
    window.localStorage.removeItem('cid');
    window.localStorage.removeItem('store_list');
    window.localStorage.removeItem('node_v1');
  }

  if (testToken) {
    if (localToken !== testToken) {
      window.localStorage.removeItem('grade');
      window.localStorage.removeItem('cid');
      window.localStorage.removeItem('store_list');
      window.localStorage.removeItem('node_v1');
    }
    func.setLocal(devTokenKey, testToken);
    func.setLocal('token', testToken);
  } else if (!func.getLocal('token') && func.getLocal(devTokenKey)) {
    func.setLocal('token', func.getLocal(devTokenKey));
    window.localStorage.removeItem('grade');
    window.localStorage.removeItem('cid');
    window.localStorage.removeItem('store_list');
    window.localStorage.removeItem('node_v1');
  }

  func.setLocal(devCustomerKey, customer.key);
}
src_router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
vue_esm["a" /* default */].config.productionTip = true;

new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NWtE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NcMn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nz4j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OOHY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P+90":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PT8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PdTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q/l8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q44f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q7uw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QGo0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R1fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R4rr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RDzS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RS7C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RUse":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S+BX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5Li":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5Ll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5PC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5Vs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TXtV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TdPp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tl4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TxjS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UUfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ur7f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uvid":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uz3O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VXnA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WGM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJ6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XHWC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XsBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YSb3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YqSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZYdI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aE5D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIO9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atlD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "by66":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9F2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cu/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dEb7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "emCF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fB+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fJrc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNnY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fXPf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gIZc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMNk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gf3k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hWTM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hon+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i8+u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iYUD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ijf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "izsC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9Kl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jnan":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kN7D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "km7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksP8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kznd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l76H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lm63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mkCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("TuEr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "naWJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oDQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oE3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8Zg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p9i6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qMU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+28":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r36t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rZq6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s3fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sFso":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sR1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sVG7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYDS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjPP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ubv/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v9cA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOuF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vTcT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXwO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vbm8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x0oP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xfZd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xhby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y15j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yIJl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yvPf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z1dc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z6pM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3dedacefe13dafed8cd6.1785252079033.js